webpackJsonp([1],{

/***/ "+2ZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sildePopup_vue__ = __webpack_require__("f/Ek");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d08d8244_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sildePopup_vue__ = __webpack_require__("Kj3v");
function injectStyle (ssrContext) {
  __webpack_require__("H452")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d08d8244"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sildePopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d08d8244_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sildePopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+9Lz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultShopImg.e407cad.png";

/***/ }),

/***/ "+B/h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Jgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      type: this.options.type
    };
  },

  computed: {
    src: function src() {
      return 'https://imsdk.tuhu.cn/static/wap.html?' + this.toQueryString(this.type);
    }
  },
  created: function created() {
    if (!this.type) {
      this.type = JSON.parse(localStorage.getItem('wapsdk'));
    }
  },

  methods: {
    toQueryPair: function toQueryPair(key, value) {
      if (typeof value === 'undefined') {
        return key;
      }
      return key + '=' + encodeURIComponent(value === null ? '' : String(value));
    },
    toQueryString: function toQueryString(obj) {
      var ret = [];
      for (var key in obj) {
        key = encodeURIComponent(key);
        var values = obj[key];

        if (values && values.constructor === Array) {
          // 数组
          var queryValues = [];
          for (var i = 0, len = values.length, value; i < len; i++) {
            value = values[i];
            queryValues.push(this.toQueryPair(key, value));
          }
          ret = ret.concat(queryValues);
        } else {
          ret.push(this.toQueryPair(key, values));
        }
      }
      return ret.join('&');
    }
  }
});

/***/ }),

/***/ "+T4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slideTip_vue__ = __webpack_require__("/MPX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4139f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slideTip_vue__ = __webpack_require__("E2wV");
function injectStyle (ssrContext) {
  __webpack_require__("gSgL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f4139f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slideTip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4139f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slideTip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Ypz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+bc7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopAllComments_vue__ = __webpack_require__("3qKe");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_657dc41f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopAllComments_vue__ = __webpack_require__("38rr");
function injectStyle (ssrContext) {
  __webpack_require__("FY18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-657dc41f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopAllComments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_657dc41f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopAllComments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+c27":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { localStorage } from '@/utils/storage'

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            // 基本信息
            StoreInfo_val1: '',
            StoreInfo_val2: '',
            StoreInfo_val3: '',
            StoreInfo_val4: '',
            StoreInfo_val5: '',
            StoreInfo_val6: '',
            StoreInfo_val7: '',
            StoreInfo_Picker1: false,
            StoreInfo_Picker2: false,
            // 负责人类型
            StoreInfo_columns1: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 区域
            StoreInfo_columns2: [{
                text: '浙江',
                children: [{
                    text: '杭州',
                    children: [{ text: '西湖区' }, { text: '余杭区' }]
                }, {
                    text: '温州',
                    children: [{ text: '鹿城区' }, { text: '瓯海区' }]
                }]
            }, {
                text: '福建',
                children: [{
                    text: '福州',
                    children: [{ text: '鼓楼区' }, { text: '台江区' }]
                }, {
                    text: '厦门',
                    children: [{ text: '思明区' }, { text: '海沧区' }]
                }]
            }],

            // 店铺信息
            Shopinfo_val1: '',
            Shopinfo_val2: '',
            Shopinfo_val3: '',
            Shopinfo_val4: '',
            Shopinfo_val5: '',
            Shopinfo_val6: '',
            Shopinfo_val7: '',
            Shopinfo_Picker1: false,
            Shopinfo_Picker2: false,
            Shopinfo_Picker3: false,
            Shopinfo_Picker4: false,
            Shopinfo_Picker5: false,
            Shopinfo_Picker6: false,
            Shopinfo_Picker7: false,
            Shopinfo_checked1: false,
            result: [],
            // 门店类型
            Shopinfo_columns1: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 主营服务
            Shopinfo_columns2: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 营业面积
            Shopinfo_columns3: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 洗车工位
            Shopinfo_columns4: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 美容工位
            Shopinfo_columns5: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 维保工位
            Shopinfo_columns6: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 烤漆房数
            Shopinfo_columns7: [
            // 类型第一列
            {
                values: ['老板', '店长', '店员'],
                defaultIndex: 0
            }],
            // 独立休息去
            Shopinfo_radio: '0',
            // 企业信息
            CompanyInfo_radio: '1',
            CompanyInfo_val1: '',
            CompanyInfo_val2: '',
            CompanyInfo_val3: '',
            // 证照店照
            StoreImg_fileList1: [
                // { url: '' }
                // Uploader 根据文件后缀来判断是否为图片文件
                // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
                // { url: 'https://cloud-image', isImage: true }
            ],
            StoreImg_fileList2: [],
            StoreImg_fileList3: [],
            StoreImg_fileList4: [],
            StoreImg_fileList5: [],
            StoreImg_fileList6: [],
            // 默认tab页
            active: 0,
            title: '1',
            tabList1: [{
                name: '修改门店信息',
                url: '/pages/shopInfo/index'
            }]
        };
    },
    created: function created() {
        this.ShowTab();
    },
    mounted: function mounted() {},

    methods: {
        // ShowTab() {
        //     if (localStorage.get('shopinfo_showtab')) {
        //         this.active = localStorage.get('shopinfo_showtab')
        //         localStorage.remove('shopinfo_showtab')
        //     }
        // },
        handleClick1: function handleClick1(item) {
            // localStorage.set('shopinfo_showtab', this.active)
            // tuhu.navigateTo({
            //     url: item.url
            // })
            tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.CHANGE_SHOP_DETAIL, {
                method: 'post',
                body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    'merchantShopDetailInfo': {
                        'cityId': 'string',
                        'cityName': '城市',
                        'districtId': 'string',
                        'districtName': '区',
                        'provinceId': 'string',
                        'provinceName': '省',
                        'shopAddress': this.StoreInfo_val7,
                        'shopLatitude': 0,
                        'shopLongitude': 0,
                        'shopName': this.StoreInfo_val1,
                        'shopPhone': this.StoreInfo_val5,
                        'shopPrincipal': this.StoreInfo_val2,
                        'shopPrincipalPhone': this.StoreInfo_val4,
                        'shopPrincipalType': 0 // this.StoreInfo_val3
                    }
                })
            });
        },
        handleClick2: function handleClick2(item) {
            // localStorage.set('shopinfo_showtab', this.active)
            // tuhu.navigateTo({
            //     url: item.url
            // })
            // 营业项目
            if (this.result.indexOf('全选') !== -1) {
                this.result.splice(0, 1);
            } else {
                this.result = this.result;
            }
            tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.CHANGE_SHOP_DETAIL, {
                method: 'post',
                body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    'shopId': 0,
                    'shopStoreInfo': {
                        'businessItems': this.result.join(','), // 营业项目
                        'haveRestArea': parseInt(this.Shopinfo_radio), // 有无休息区
                        'mainService': this.Shopinfo_val2, // 主营项目
                        'merchantArea': this.Shopinfo_val3, // 门店面积
                        'shopBank': 'string',
                        'shopType': this.Shopinfo_val1, // 门店类型
                        'stationCondition': 'string'
                    }
                })
            });
        },
        handleClick3: function handleClick3(item) {
            // localStorage.set('shopinfo_showtab', this.active)
            // tuhu.navigateTo({
            //     url: item.url
            // })
            tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.CHANGE_SHOP_COMPANYINFO, {
                method: 'post',
                body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    'shopCompanyInfo': {
                        'businessLicense': parseInt(this.CompanyInfo_radio),
                        'enterprisePrincipal': this.CompanyInfo_val1,
                        'enterprisePrincipalPhone': this.CompanyInfo_val2,
                        'staffNum': parseInt(this.CompanyInfo_val3)
                    },
                    'shopId': 0
                })
            });
        },
        handleClick4: function handleClick4(item) {
            // localStorage.set('shopinfo_showtab', this.active)
            tuhu.navigateTo({
                url: item.url
            });
        },

        // 复选框全选
        checkAll: function checkAll() {
            var checked = this.Shopinfo_checked1;
            if (checked) {
                this.$refs.checkboxGroup.toggleAll(false);
            } else {
                this.$refs.checkboxGroup.toggleAll(true);
            }
            this.Shopinfo_checked1 = !checked;
        },

        // // 反选
        // toggleAll() {
        //     this.$refs.checkboxGroup.toggleAll()
        //     this.Shopinfo_checked1 = !this.Shopinfo_checked1
        // },
        StoreInfo_onConfirm1: function StoreInfo_onConfirm1(value) {
            this.StoreInfo_val3 = value.toString();
            this.StoreInfo_Picker1 = false;
        },
        StoreInfo_onConfirm2: function StoreInfo_onConfirm2(value) {
            this.StoreInfo_val6 = value.toString().replace(/,/g, '-');
            this.StoreInfo_Picker2 = false;
        },
        Shopinfo_onConfirm1: function Shopinfo_onConfirm1(value) {
            this.Shopinfo_val1 = value.toString();
            this.Shopinfo_Picker1 = false;
        },
        Shopinfo_onConfirm2: function Shopinfo_onConfirm2(value) {
            this.Shopinfo_val2 = value.toString();
            this.Shopinfo_Picker2 = false;
        },
        Shopinfo_onConfirm3: function Shopinfo_onConfirm3(value) {
            this.Shopinfo_val3 = value.toString();
            this.Shopinfo_Picker3 = false;
        },
        Shopinfo_onConfirm4: function Shopinfo_onConfirm4(value) {
            this.Shopinfo_val4 = value.toString();
            this.Shopinfo_Picker4 = false;
        },
        Shopinfo_onConfirm5: function Shopinfo_onConfirm5(value) {
            this.Shopinfo_val5 = value.toString();
            this.Shopinfo_Picker5 = false;
        },
        Shopinfo_onConfirm6: function Shopinfo_onConfirm6(value) {
            this.Shopinfo_val6 = value.toString();
            this.Shopinfo_Picker6 = false;
        },
        Shopinfo_onConfirm7: function Shopinfo_onConfirm7(value) {
            this.Shopinfo_val7 = value.toString();
            this.Shopinfo_Picker7 = false;
        },

        // 店证店照 文件上传完毕后会触发after-read回调函数，获取到对应的file对象
        afterRead1: function afterRead1(file) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // 此时可以自行将文件上传至服务器
                                console.log(file);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        afterRead2: function afterRead2(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
        },
        afterRead3: function afterRead3(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
        },
        afterRead4: function afterRead4(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
        },
        afterRead5: function afterRead5(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
        },
        afterRead6: function afterRead6(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
        }
    }
});

/***/ }),

/***/ "/DoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isShow: { type: Boolean, default: false },
    url: { type: String, default: '' }
  },
  methods: {
    handleClose: function handleClose() {
      // 向父组件发送关闭事件
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "/FvA":
/***/ (function(module, exports) {

/*!
 * =====================================================
 * SUI Mobile - http://m.sui.taobao.org/
 *
 * =====================================================
 */
;$.smVersion = "0.6.2";+function ($) {
    "use strict";

    //全局配置
    var defaults = {
        autoInit: false, //自动初始化页面
        showPageLoadingIndicator: true, //push.js加载页面的时候显示一个加载提示
        router: true, //默认使用router
        swipePanel: "left", //滑动打开侧栏
        swipePanelOnlyClose: true  //只允许滑动关闭，不允许滑动打开侧栏
    };

    $.smConfig = $.extend(defaults, $.config);

}(Zepto);

+ function($) {
    "use strict";

    //比较一个字符串版本号
    //a > b === 1
    //a = b === 0
    //a < b === -1
    $.compareVersion = function(a, b) {
        var as = a.split('.');
        var bs = b.split('.');
        if (a === b) return 0;

        for (var i = 0; i < as.length; i++) {
            var x = parseInt(as[i]);
            if (!bs[i]) return 1;
            var y = parseInt(bs[i]);
            if (x < y) return -1;
            if (x > y) return 1;
        }
        return -1;
    };

    $.getCurrentPage = function() {
        return $(".page-current")[0] || $(".page")[0] || document.body;
    };

}(Zepto);

/* global WebKitCSSMatrix:true */

(function($) {
    "use strict";
    ['width', 'height'].forEach(function(dimension) {
        var  Dimension = dimension.replace(/./, function(m) {
            return m[0].toUpperCase();
        });
        $.fn['outer' + Dimension] = function(margin) {
            var elem = this;
            if (elem) {
                var size = elem[dimension]();
                var sides = {
                    'width': ['left', 'right'],
                    'height': ['top', 'bottom']
                };
                sides[dimension].forEach(function(side) {
                    if (margin) size += parseInt(elem.css('margin-' + side), 10);
                });
                return size;
            } else {
                return null;
            }
        };
    });

    //support
    $.support = (function() {
        var support = {
            touch: !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch)
        };
        return support;
    })();

    $.touchEvents = {
        start: $.support.touch ? 'touchstart' : 'mousedown',
        move: $.support.touch ? 'touchmove' : 'mousemove',
        end: $.support.touch ? 'touchend' : 'mouseup'
    };

    $.getTranslate = function (el, axis) {
        var matrix, curTransform, curStyle, transformMatrix;

        // automatic axis detection
        if (typeof axis === 'undefined') {
            axis = 'x';
        }

        curStyle = window.getComputedStyle(el, null);
        if (window.WebKitCSSMatrix) {
            // Some old versions of Webkit choke when 'none' is passed; pass
            // empty string instead in this case
            transformMatrix = new WebKitCSSMatrix(curStyle.webkitTransform === 'none' ? '' : curStyle.webkitTransform);
        }
        else {
            transformMatrix = curStyle.MozTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
            matrix = transformMatrix.toString().split(',');
        }

        if (axis === 'x') {
            //Latest Chrome and webkits Fix
            if (window.WebKitCSSMatrix)
                curTransform = transformMatrix.m41;
            //Crazy IE10 Matrix
            else if (matrix.length === 16)
                curTransform = parseFloat(matrix[12]);
            //Normal Browsers
            else
                curTransform = parseFloat(matrix[4]);
        }
        if (axis === 'y') {
            //Latest Chrome and webkits Fix
            if (window.WebKitCSSMatrix)
                curTransform = transformMatrix.m42;
            //Crazy IE10 Matrix
            else if (matrix.length === 16)
                curTransform = parseFloat(matrix[13]);
            //Normal Browsers
            else
                curTransform = parseFloat(matrix[5]);
        }

        return curTransform || 0;
    };
    /* jshint ignore:start */
    $.requestAnimationFrame = function (callback) {
        if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
        else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
        else if (window.mozRequestAnimationFrame) return window.mozRequestAnimationFrame(callback);
        else {
            return window.setTimeout(callback, 1000 / 60);
        }
    };
    $.cancelAnimationFrame = function (id) {
        if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
        else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
        else if (window.mozCancelAnimationFrame) return window.mozCancelAnimationFrame(id);
        else {
            return window.clearTimeout(id);
        }
    };
    /* jshint ignore:end */

    $.fn.dataset = function() {
        var dataset = {},
            ds = this[0].dataset;
        for (var key in ds) { // jshint ignore:line
            var item = (dataset[key] = ds[key]);
            if (item === 'false') dataset[key] = false;
            else if (item === 'true') dataset[key] = true;
            else if (parseFloat(item) === item * 1) dataset[key] = item * 1;
        }
        // mixin dataset and __eleData
        return $.extend({}, dataset, this[0].__eleData);
    };
    $.fn.data = function(key, value) {
        var tmpData = $(this).dataset();
        if (!key) {
            return tmpData;
        }
        // value may be 0, false, null
        if (typeof value === 'undefined') {
            // Get value
            var dataVal = tmpData[key],
                __eD = this[0].__eleData;

            //if (dataVal !== undefined) {
            if (__eD && (key in __eD)) {
                return __eD[key];
            } else {
                return dataVal;
            }

        } else {
            // Set value,uniformly set in extra ```__eleData```
            for (var i = 0; i < this.length; i++) {
                var el = this[i];
                // delete multiple data in dataset
                if (key in tmpData) delete el.dataset[key];

                if (!el.__eleData) el.__eleData = {};
                el.__eleData[key] = value;
            }
            return this;
        }
    };
    function __dealCssEvent(eventNameArr, callback) {
        var events = eventNameArr,
            i, dom = this;// jshint ignore:line

        function fireCallBack(e) {
            /*jshint validthis:true */
            if (e.target !== this) return;
            callback.call(this, e);
            for (i = 0; i < events.length; i++) {
                dom.off(events[i], fireCallBack);
            }
        }
        if (callback) {
            for (i = 0; i < events.length; i++) {
                dom.on(events[i], fireCallBack);
            }
        }
    }
    $.fn.animationEnd = function(callback) {
        __dealCssEvent.call(this, ['webkitAnimationEnd', 'animationend'], callback);
        return this;
    };
    $.fn.transitionEnd = function(callback) {
        __dealCssEvent.call(this, ['webkitTransitionEnd', 'transitionend'], callback);
        return this;
    };
    $.fn.transition = function(duration) {
        if (typeof duration !== 'string') {
            duration = duration + 'ms';
        }
        for (var i = 0; i < this.length; i++) {
            var elStyle = this[i].style;
            elStyle.webkitTransitionDuration = elStyle.MozTransitionDuration = elStyle.transitionDuration = duration;
        }
        return this;
    };
    $.fn.transform = function(transform) {
        for (var i = 0; i < this.length; i++) {
            var elStyle = this[i].style;
            elStyle.webkitTransform = elStyle.MozTransform = elStyle.transform = transform;
        }
        return this;
    };
    $.fn.prevAll = function (selector) {
        var prevEls = [];
        var el = this[0];
        if (!el) return $([]);
        while (el.previousElementSibling) {
            var prev = el.previousElementSibling;
            if (selector) {
                if($(prev).is(selector)) prevEls.push(prev);
            }
            else prevEls.push(prev);
            el = prev;
        }
        return $(prevEls);
    };
    $.fn.nextAll = function (selector) {
        var nextEls = [];
        var el = this[0];
        if (!el) return $([]);
        while (el.nextElementSibling) {
            var next = el.nextElementSibling;
            if (selector) {
                if($(next).is(selector)) nextEls.push(next);
            }
            else nextEls.push(next);
            el = next;
        }
        return $(nextEls);
    };

    //重置zepto的show方法，防止有些人引用的版本中 show 方法操作 opacity 属性影响动画执行
    $.fn.show = function(){
        var elementDisplay = {};
        function defaultDisplay(nodeName) {
            var element, display;
            if (!elementDisplay[nodeName]) {
                element = document.createElement(nodeName);
                document.body.appendChild(element);
                display = getComputedStyle(element, '').getPropertyValue("display");
                element.parentNode.removeChild(element);
                display === "none" && (display = "block");
                elementDisplay[nodeName] = display;
            }
            return elementDisplay[nodeName];
        }

        return this.each(function(){
            this.style.display === "none" && (this.style.display = '');
            if (getComputedStyle(this, '').getPropertyValue("display") === "none");
            this.style.display = defaultDisplay(this.nodeName);
        });
    };
})(Zepto);

/*===========================
Device/OS Detection
===========================*/
;(function ($) {
    "use strict";
    var device = {};
    var ua = navigator.userAgent;

    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);

    device.ios = device.android = device.iphone = device.ipad = device.androidChrome = false;

    // Android
    if (android) {
        device.os = 'android';
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, '.');
        device.iphone = true;
    }
    if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, '.');
        device.ipad = true;
    }
    if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
        device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
        if (device.osVersion.split('.')[0] === '10') {
            device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
        }
    }

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
        var osVersionArr = device.osVersion.split('.');
        device.minimalUi = !device.webView &&
            (ipod || iphone) &&
            (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
            $('meta[name="viewport"]').length > 0 && $('meta[name="viewport"]').attr('content').indexOf('minimal-ui') >= 0;
    }

    // Check for status bar and fullscreen app mode
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    device.statusBar = false;
    if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
        device.statusBar = true;
    }
    else {
        device.statusBar = false;
    }

    // Classes
    var classNames = [];

    // Pixel Ratio
    device.pixelRatio = window.devicePixelRatio || 1;
    classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio));
    if (device.pixelRatio >= 2) {
        classNames.push('retina');
    }

    // OS classes
    if (device.os) {
        classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'));
        if (device.os === 'ios') {
            var major = parseInt(device.osVersion.split('.')[0], 10);
            for (var i = major - 1; i >= 6; i--) {
                classNames.push('ios-gt-' + i);
            }
        }

    }
    // Status bar classes
    if (device.statusBar) {
        classNames.push('with-statusbar-overlay');
    }
    else {
        $('html').removeClass('with-statusbar-overlay');
    }

    // Add html classes
    if (classNames.length > 0) $('html').addClass(classNames.join(' '));

    // keng..
    device.isWeixin = /MicroMessenger/i.test(ua);

    $.device = device;
})(Zepto);

;(function () {
    'use strict';

    /**
     * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
     *
     * @codingstandard ftlabs-jsv2
     * @copyright The Financial Times Limited [All Rights Reserved]
     * @license MIT License (see LICENSE.txt)
     */

    /*jslint browser:true, node:true, elision:true*/
    /*global Event, Node*/


    /**
     * Instantiate fast-clicking listeners on the specified layer.
     *
     * @constructor
     * @param {Element} layer The layer to listen on
     * @param {Object} [options={}] The options to override the defaults
     */
    function FastClick(layer, options) {
        var oldOnClick;

        options = options || {};

        /**
         * Whether a click is currently being tracked.
         *
         * @type boolean
         */
        this.trackingClick = false;


        /**
         * Timestamp for when click tracking started.
         *
         * @type number
         */
        this.trackingClickStart = 0;


        /**
         * The element being tracked for a click.
         *
         * @type EventTarget
         */
        this.targetElement = null;


        /**
         * X-coordinate of touch start event.
         *
         * @type number
         */
        this.touchStartX = 0;


        /**
         * Y-coordinate of touch start event.
         *
         * @type number
         */
        this.touchStartY = 0;


        /**
         * ID of the last touch, retrieved from Touch.identifier.
         *
         * @type number
         */
        this.lastTouchIdentifier = 0;


        /**
         * Touchmove boundary, beyond which a click will be cancelled.
         *
         * @type number
         */
        this.touchBoundary = options.touchBoundary || 10;


        /**
         * The FastClick layer.
         *
         * @type Element
         */
        this.layer = layer;

        /**
         * The minimum time between tap(touchstart and touchend) events
         *
         * @type number
         */
        this.tapDelay = options.tapDelay || 200;

        /**
         * The maximum time for a tap
         *
         * @type number
         */
        this.tapTimeout = options.tapTimeout || 700;

        if (FastClick.notNeeded(layer)) {
            return;
        }

        // Some old versions of Android don't have Function.prototype.bind
        function bind(method, context) {
            return function() { return method.apply(context, arguments); };
        }


        var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
        var context = this;
        for (var i = 0, l = methods.length; i < l; i++) {
            context[methods[i]] = bind(context[methods[i]], context);
        }

        // Set up event handlers as required
        if (deviceIsAndroid) {
            layer.addEventListener('mouseover', this.onMouse, true);
            layer.addEventListener('mousedown', this.onMouse, true);
            layer.addEventListener('mouseup', this.onMouse, true);
        }

        layer.addEventListener('click', this.onClick, true);
        layer.addEventListener('touchstart', this.onTouchStart, false);
        layer.addEventListener('touchmove', this.onTouchMove, false);
        layer.addEventListener('touchend', this.onTouchEnd, false);
        layer.addEventListener('touchcancel', this.onTouchCancel, false);

        // Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
        // which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
        // layer when they are cancelled.
        if (!Event.prototype.stopImmediatePropagation) {
            layer.removeEventListener = function(type, callback, capture) {
                var rmv = Node.prototype.removeEventListener;
                if (type === 'click') {
                    rmv.call(layer, type, callback.hijacked || callback, capture);
                } else {
                    rmv.call(layer, type, callback, capture);
                }
            };

            layer.addEventListener = function(type, callback, capture) {
                var adv = Node.prototype.addEventListener;
                if (type === 'click') {
                    adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
                        if (!event.propagationStopped) {
                            callback(event);
                        }
                    }), capture);
                } else {
                    adv.call(layer, type, callback, capture);
                }
            };
        }

        // If a handler is already declared in the element's onclick attribute, it will be fired before
        // FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
        // adding it as listener.
        if (typeof layer.onclick === 'function') {

            // Android browser on at least 3.2 requires a new reference to the function in layer.onclick
            // - the old one won't work if passed to addEventListener directly.
            oldOnClick = layer.onclick;
            layer.addEventListener('click', function(event) {
                oldOnClick(event);
            }, false);
            layer.onclick = null;
        }
    }

    /**
     * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
     *
     * @type boolean
     */
    var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

    /**
     * Android requires exceptions.
     *
     * @type boolean
     */
    var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


    /**
     * iOS requires exceptions.
     *
     * @type boolean
     */
    var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


    /**
     * iOS 4 requires an exception for select elements.
     *
     * @type boolean
     */
    var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


    /**
     * iOS 6.0-7.* requires the target element to be manually derived
     *
     * @type boolean
     */
    var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

    /**
     * BlackBerry requires exceptions.
     *
     * @type boolean
     */
    var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

    /**
     * 判断是否组合型label
     * @type {Boolean}
     */
    var isCompositeLabel = false;

    /**
     * Determine whether a given element requires a native click.
     *
     * @param {EventTarget|Element} target Target DOM element
     * @returns {boolean} Returns true if the element needs a native click
     */
    FastClick.prototype.needsClick = function(target) {

        // 修复bug: 如果父元素中有 label
        // 如果label上有needsclick这个类，则用原生的点击，否则，用模拟点击
        var parent = target;
        while(parent && (parent.tagName.toUpperCase() !== "BODY")) {
            if (parent.tagName.toUpperCase() === "LABEL") {
                isCompositeLabel = true;
                if ((/\bneedsclick\b/).test(parent.className)) return true;
            }
            parent = parent.parentNode;
        }

        switch (target.nodeName.toLowerCase()) {

            // Don't send a synthetic click to disabled inputs (issue #62)
            case 'button':
            case 'select':
            case 'textarea':
                if (target.disabled) {
                    return true;
                }

                break;
            case 'input':

                // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
                if ((deviceIsIOS && target.type === 'file') || target.disabled) {
                    return true;
                }

                break;
            case 'label':
            case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
            case 'video':
                return true;
        }

        return (/\bneedsclick\b/).test(target.className);
    };


    /**
     * Determine whether a given element requires a call to focus to simulate click into element.
     *
     * @param {EventTarget|Element} target Target DOM element
     * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
     */
    FastClick.prototype.needsFocus = function(target) {
        switch (target.nodeName.toLowerCase()) {
            case 'textarea':
                return true;
            case 'select':
                return !deviceIsAndroid;
            case 'input':
                switch (target.type) {
                    case 'button':
                    case 'checkbox':
                    case 'file':
                    case 'image':
                    case 'radio':
                    case 'submit':
                        return false;
                }

                // No point in attempting to focus disabled inputs
                return !target.disabled && !target.readOnly;
            default:
                return (/\bneedsfocus\b/).test(target.className);
        }
    };


    /**
     * Send a click event to the specified element.
     *
     * @param {EventTarget|Element} targetElement
     * @param {Event} event
     */
    FastClick.prototype.sendClick = function(targetElement, event) {
        var clickEvent, touch;

        // On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
        if (document.activeElement && document.activeElement !== targetElement) {
            document.activeElement.blur();
        }

        touch = event.changedTouches[0];

        // Synthesise a click event, with an extra attribute so it can be tracked
        clickEvent = document.createEvent('MouseEvents');
        clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
        clickEvent.forwardedTouchEvent = true;
        targetElement.dispatchEvent(clickEvent);
    };

    FastClick.prototype.determineEventType = function(targetElement) {

        //Issue #159: Android Chrome Select Box does not open with a synthetic click event
        if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
            return 'mousedown';
        }

        return 'click';
    };


    /**
     * @param {EventTarget|Element} targetElement
     */
    FastClick.prototype.focus = function(targetElement) {
        var length;

        // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
        var unsupportedType = ['date', 'time', 'month', 'number', 'email'];
        if (deviceIsIOS && targetElement.setSelectionRange && unsupportedType.indexOf(targetElement.type) === -1) {
            length = targetElement.value.length;
            targetElement.setSelectionRange(length, length);
        } else {
            targetElement.focus();
        }
    };


    /**
     * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
     *
     * @param {EventTarget|Element} targetElement
     */
    FastClick.prototype.updateScrollParent = function(targetElement) {
        var scrollParent, parentElement;

        scrollParent = targetElement.fastClickScrollParent;

        // Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
        // target element was moved to another parent.
        if (!scrollParent || !scrollParent.contains(targetElement)) {
            parentElement = targetElement;
            do {
                if (parentElement.scrollHeight > parentElement.offsetHeight) {
                    scrollParent = parentElement;
                    targetElement.fastClickScrollParent = parentElement;
                    break;
                }

                parentElement = parentElement.parentElement;
            } while (parentElement);
        }

        // Always update the scroll top tracker if possible.
        if (scrollParent) {
            scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
        }
    };


    /**
     * @param {EventTarget} targetElement
     * @returns {Element|EventTarget}
     */
    FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

        // On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
        if (eventTarget.nodeType === Node.TEXT_NODE) {
            return eventTarget.parentNode;
        }

        return eventTarget;
    };


    /**
     * On touch start, record the position and scroll offset.
     *
     * @param {Event} event
     * @returns {boolean}
     */
    FastClick.prototype.onTouchStart = function(event) {
        var targetElement, touch, selection;

        // Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
        if (event.targetTouches.length > 1) {
            return true;
        }

        targetElement = this.getTargetElementFromEventTarget(event.target);
        touch = event.targetTouches[0];

        if (deviceIsIOS) {

            // Only trusted events will deselect text on iOS (issue #49)
            selection = window.getSelection();
            if (selection.rangeCount && !selection.isCollapsed) {
                return true;
            }

            if (!deviceIsIOS4) {

                // Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
                // when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
                // with the same identifier as the touch event that previously triggered the click that triggered the alert.
                // Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
                // immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
                // Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
                // which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
                // random integers, it's safe to to continue if the identifier is 0 here.
                if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
                    event.preventDefault();
                    return false;
                }

                this.lastTouchIdentifier = touch.identifier;

                // If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
                // 1) the user does a fling scroll on the scrollable layer
                // 2) the user stops the fling scroll with another tap
                // then the event.target of the last 'touchend' event will be the element that was under the user's finger
                // when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
                // is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
                this.updateScrollParent(targetElement);
            }
        }

        this.trackingClick = true;
        this.trackingClickStart = event.timeStamp;
        this.targetElement = targetElement;

        this.touchStartX = touch.pageX;
        this.touchStartY = touch.pageY;

        // Prevent phantom clicks on fast double-tap (issue #36)
        if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
            event.preventDefault();
        }

        return true;
    };


    /**
     * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
     *
     * @param {Event} event
     * @returns {boolean}
     */
    FastClick.prototype.touchHasMoved = function(event) {
        var touch = event.changedTouches[0], boundary = this.touchBoundary;

        if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
            return true;
        }

        return false;
    };


    /**
     * Update the last position.
     *
     * @param {Event} event
     * @returns {boolean}
     */
    FastClick.prototype.onTouchMove = function(event) {
        if (!this.trackingClick) {
            return true;
        }

        // If the touch has moved, cancel the click tracking
        if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
            this.trackingClick = false;
            this.targetElement = null;
        }

        return true;
    };


    /**
     * Attempt to find the labelled control for the given label element.
     *
     * @param {EventTarget|HTMLLabelElement} labelElement
     * @returns {Element|null}
     */
    FastClick.prototype.findControl = function(labelElement) {

        // Fast path for newer browsers supporting the HTML5 control attribute
        if (labelElement.control !== undefined) {
            return labelElement.control;
        }

        // All browsers under test that support touch events also support the HTML5 htmlFor attribute
        if (labelElement.htmlFor) {
            return document.getElementById(labelElement.htmlFor);
        }

        // If no for attribute exists, attempt to retrieve the first labellable descendant element
        // the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
        return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
    };


    /**
     * On touch end, determine whether to send a click event at once.
     *
     * @param {Event} event
     * @returns {boolean}
     */
    FastClick.prototype.onTouchEnd = function(event) {
        var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

        if (!this.trackingClick) {
            return true;
        }

        // Prevent phantom clicks on fast double-tap (issue #36)
        if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
            this.cancelNextClick = true;
            return true;
        }

        if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
            return true;
        }
        //修复安卓微信下，input type="date" 的bug，经测试date,time,month已没问题
        var unsupportedType = ['date', 'time', 'month'];
        if(unsupportedType.indexOf(event.target.type) !== -1){
            　　　　return false;
            　　}
        // Reset to prevent wrong click cancel on input (issue #156).
        this.cancelNextClick = false;

        this.lastClickTime = event.timeStamp;

        trackingClickStart = this.trackingClickStart;
        this.trackingClick = false;
        this.trackingClickStart = 0;

        // On some iOS devices, the targetElement supplied with the event is invalid if the layer
        // is performing a transition or scroll, and has to be re-detected manually. Note that
        // for this to function correctly, it must be called *after* the event target is checked!
        // See issue #57; also filed as rdar://13048589 .
        if (deviceIsIOSWithBadTarget) {
            touch = event.changedTouches[0];

            // In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
            targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
            targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
        }

        targetTagName = targetElement.tagName.toLowerCase();
        if (targetTagName === 'label') {
            forElement = this.findControl(targetElement);
            if (forElement) {
                this.focus(targetElement);
                if (deviceIsAndroid) {
                    return false;
                }

                targetElement = forElement;
            }
        } else if (this.needsFocus(targetElement)) {

            // Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
            // Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
            if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
                this.targetElement = null;
                return false;
            }

            this.focus(targetElement);
            this.sendClick(targetElement, event);

            // Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
            // Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
            if (!deviceIsIOS || targetTagName !== 'select') {
                this.targetElement = null;
                event.preventDefault();
            }

            return false;
        }

        if (deviceIsIOS && !deviceIsIOS4) {

            // Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
            // and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
            scrollParent = targetElement.fastClickScrollParent;
            if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
                return true;
            }
        }

        // Prevent the actual click from going though - unless the target node is marked as requiring
        // real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
        if (!this.needsClick(targetElement)) {
            event.preventDefault();
            this.sendClick(targetElement, event);
        }

        return false;
    };


    /**
     * On touch cancel, stop tracking the click.
     *
     * @returns {void}
     */
    FastClick.prototype.onTouchCancel = function() {
        this.trackingClick = false;
        this.targetElement = null;
    };


    /**
     * Determine mouse events which should be permitted.
     *
     * @param {Event} event
     * @returns {boolean}
     */
    FastClick.prototype.onMouse = function(event) {

        // If a target element was never set (because a touch event was never fired) allow the event
        if (!this.targetElement) {
            return true;
        }

        if (event.forwardedTouchEvent) {
            return true;
        }

        // Programmatically generated events targeting a specific element should be permitted
        if (!event.cancelable) {
            return true;
        }

        // Derive and check the target element to see whether the mouse event needs to be permitted;
        // unless explicitly enabled, prevent non-touch click events from triggering actions,
        // to prevent ghost/doubleclicks.
        if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

            // Prevent any user-added listeners declared on FastClick element from being fired.
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {

                // Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
                event.propagationStopped = true;
            }

            // Cancel the event
            event.stopPropagation();
            // 允许组合型label冒泡
            if (!isCompositeLabel) {
                event.preventDefault();
            }
            // 允许组合型label冒泡
            return false;
        }

        // If the mouse event is permitted, return true for the action to go through.
        return true;
    };


    /**
     * On actual clicks, determine whether this is a touch-generated click, a click action occurring
     * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
     * an actual click which should be permitted.
     *
     * @param {Event} event
     * @returns {boolean}
     */
    FastClick.prototype.onClick = function(event) {
        var permitted;

        // It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
        if (this.trackingClick) {
            this.targetElement = null;
            this.trackingClick = false;
            return true;
        }

        // Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
        if (event.target.type === 'submit' && event.detail === 0) {
            return true;
        }

        permitted = this.onMouse(event);

        // Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
        if (!permitted) {
            this.targetElement = null;
        }

        // If clicks are permitted, return true for the action to go through.
        return permitted;
    };


    /**
     * Remove all FastClick's event listeners.
     *
     * @returns {void}
     */
    FastClick.prototype.destroy = function() {
        var layer = this.layer;

        if (deviceIsAndroid) {
            layer.removeEventListener('mouseover', this.onMouse, true);
            layer.removeEventListener('mousedown', this.onMouse, true);
            layer.removeEventListener('mouseup', this.onMouse, true);
        }

        layer.removeEventListener('click', this.onClick, true);
        layer.removeEventListener('touchstart', this.onTouchStart, false);
        layer.removeEventListener('touchmove', this.onTouchMove, false);
        layer.removeEventListener('touchend', this.onTouchEnd, false);
        layer.removeEventListener('touchcancel', this.onTouchCancel, false);
    };


    /**
     * Check whether FastClick is needed.
     *
     * @param {Element} layer The layer to listen on
     */
    FastClick.notNeeded = function(layer) {
        var metaViewport;
        var chromeVersion;
        var blackberryVersion;
        var firefoxVersion;

        // Devices that don't support touch don't need FastClick
        if (typeof window.ontouchstart === 'undefined') {
            return true;
        }

        // Chrome version - zero for other browsers
        chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

        if (chromeVersion) {

            if (deviceIsAndroid) {
                metaViewport = document.querySelector('meta[name=viewport]');

                if (metaViewport) {
                    // Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
                    if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
                        return true;
                    }
                    // Chrome 32 and above with width=device-width or less don't need FastClick
                    if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
                        return true;
                    }
                }

                // Chrome desktop doesn't need FastClick (issue #15)
            } else {
                return true;
            }
        }

        if (deviceIsBlackBerry10) {
            blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

            // BlackBerry 10.3+ does not require Fastclick library.
            // https://github.com/ftlabs/fastclick/issues/251
            if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
                metaViewport = document.querySelector('meta[name=viewport]');

                if (metaViewport) {
                    // user-scalable=no eliminates click delay.
                    if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
                        return true;
                    }
                    // width=device-width (or less than device-width) eliminates click delay.
                    if (document.documentElement.scrollWidth <= window.outerWidth) {
                        return true;
                    }
                }
            }
        }

        // IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
        if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
            return true;
        }

        // Firefox version - zero for other browsers
        firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

        if (firefoxVersion >= 27) {
            // Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

            metaViewport = document.querySelector('meta[name=viewport]');
            if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
                return true;
            }
        }

        // IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
        // http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
        if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
            return true;
        }

        return false;
    };


    /**
     * Factory method for creating a FastClick object
     *
     * @param {Element} layer The layer to listen on
     * @param {Object} [options={}] The options to override the defaults
     */
    FastClick.attach = function(layer, options) {
        return new FastClick(layer, options);
    };

    window.FastClick = FastClick;
}());

/*======================================================
************   Modals   ************
======================================================*/
/*jshint unused: false*/
+function ($) {
    "use strict";
    var _modalTemplateTempDiv = document.createElement('div');

    $.modalStack = [];

    $.modalStackClearQueue = function () {
        if ($.modalStack.length) {
            ($.modalStack.shift())();
        }
    };
    $.modal = function (params) {
        params = params || {};
        var modalHTML = '';
        var buttonsHTML = '';
        if (params.buttons && params.buttons.length > 0) {
            for (var i = 0; i < params.buttons.length; i++) {
                if(params.buttons[i].text==='取消'){
                    buttonsHTML += '<span class="modal-button cancel' + (params.buttons[i].bold ? ' modal-button-bold' : '') + '">' + params.buttons[i].text + '</span>';
                }else{
                    buttonsHTML += '<span class="modal-button' + (params.buttons[i].bold ? ' modal-button-bold' : '') + '">' + params.buttons[i].text + '</span>';
                }
            }
        }
        var extraClass = params.extraClass || '';
        var titleHTML = params.title ? '<div class="modal-title colorred">' + params.title + '</div>' : '';
        var textHTML = params.text ? '<div class="modal-text">' + params.text + '</div>' : '';
        var afterTextHTML = params.afterText ? params.afterText : '';
        var noButtons = !params.buttons || params.buttons.length === 0 ? 'modal-no-buttons' : '';
        var verticalButtons = params.verticalButtons ? 'modal-buttons-vertical' : '';
        modalHTML = '<div class="modal ' + extraClass + ' ' + noButtons + '"><div class="modal-inner">' + (titleHTML + textHTML + afterTextHTML) + '</div><div class="modal-buttons ' + verticalButtons + '">' + buttonsHTML + '</div></div>';

        _modalTemplateTempDiv.innerHTML = modalHTML;

        var modal = $(_modalTemplateTempDiv).children();

        $(defaults.modalContainer).append(modal[0]);

        // Add events on buttons
        modal.find('.modal-button').each(function (index, el) {
            $(el).on('click', function (e) {
                if (params.buttons[index].close !== false) $.closeModal(modal);
                if (params.buttons[index].onClick) params.buttons[index].onClick(modal, e);
                if (params.onClick) params.onClick(modal, index);
            });
        });
        $.openModal(modal);
        return modal[0];
    };
    $.alert = function (text, title, callbackOk) {
        if (typeof title === 'function') {
            callbackOk = arguments[1];
            title = undefined;
        }
        return $.modal({
            text: text || '',
            title: typeof title === 'undefined' ? defaults.modalTitle : title,
            buttons: [ {text: defaults.modalButtonOk, bold: true, onClick: callbackOk} ]
        });
    };
    $.confirm = function (text, title, callbackOk, callbackCancel) {
        if (typeof title === 'function') {
            callbackCancel = arguments[2];
            callbackOk = arguments[1];
            title = undefined;
        }
        return $.modal({
            text: text || '',
            title: typeof title === 'undefined' ? defaults.modalTitle : title,
            buttons: [
                {text: defaults.modalButtonCancel, onClick: callbackCancel},
                {text: defaults.modalButtonOk, bold: true, onClick: callbackOk}
            ]
        });
    };
    $.prompt = function (text, title, callbackOk, callbackCancel) {
        if (typeof title === 'function') {
            callbackCancel = arguments[2];
            callbackOk = arguments[1];
            title = undefined;
        }
        return $.modal({
            text: text || '',
            title: typeof title === 'undefined' ? defaults.modalTitle : title,
            afterText: '<input type="text" class="modal-text-input">',
            buttons: [
                {
                    text: defaults.modalButtonCancel
                },
                {
                    text: defaults.modalButtonOk,
                    bold: true
                }
            ],
            onClick: function (modal, index) {
                if (index === 0 && callbackCancel) callbackCancel($(modal).find('.modal-text-input').val());
                if (index === 1 && callbackOk) callbackOk($(modal).find('.modal-text-input').val());
            }
        });
    };
    $.modalLogin = function (text, title, callbackOk, callbackCancel) {
        if (typeof title === 'function') {
            callbackCancel = arguments[2];
            callbackOk = arguments[1];
            title = undefined;
        }
        return $.modal({
            text: text || '',
            title: typeof title === 'undefined' ? defaults.modalTitle : title,
            afterText: '<input type="text" name="modal-username" placeholder="' + defaults.modalUsernamePlaceholder + '" class="modal-text-input modal-text-input-double"><input type="password" name="modal-password" placeholder="' + defaults.modalPasswordPlaceholder + '" class="modal-text-input modal-text-input-double">',
            buttons: [
                {
                    text: defaults.modalButtonCancel
                },
                {
                    text: defaults.modalButtonOk,
                    bold: true
                }
            ],
            onClick: function (modal, index) {
                var username = $(modal).find('.modal-text-input[name="modal-username"]').val();
                var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
                if (index === 0 && callbackCancel) callbackCancel(username, password);
                if (index === 1 && callbackOk) callbackOk(username, password);
            }
        });
    };
    $.modalPassword = function (text, title, callbackOk, callbackCancel) {
        if (typeof title === 'function') {
            callbackCancel = arguments[2];
            callbackOk = arguments[1];
            title = undefined;
        }
        return $.modal({
            text: text || '',
            title: typeof title === 'undefined' ? defaults.modalTitle : title,
            afterText: '<input type="password" name="modal-password" placeholder="' + defaults.modalPasswordPlaceholder + '" class="modal-text-input">',
            buttons: [
                {
                    text: defaults.modalButtonCancel
                },
                {
                    text: defaults.modalButtonOk,
                    bold: true
                }
            ],
            onClick: function (modal, index) {
                var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
                if (index === 0 && callbackCancel) callbackCancel(password);
                if (index === 1 && callbackOk) callbackOk(password);
            }
        });
    };
    $.showPreloader = function (title) {
        $.hidePreloader();
        $.showPreloader.preloaderModal = $.modal({
            title: title || defaults.modalPreloaderTitle,
            text: '<div class="preloader"></div>'
        });

        return $.showPreloader.preloaderModal;
    };
    $.hidePreloader = function () {
        $.showPreloader.preloaderModal && $.closeModal($.showPreloader.preloaderModal);
    };
    $.showIndicator = function () {
        if ($('.preloader-indicator-modal')[0]) return;
        $(defaults.modalContainer).append('<div class="preloader-indicator-overlay"></div><div class="preloader-indicator-modal"><span class="preloader preloader-white"></span></div>');
    };
    $.hideIndicator = function () {
        $('.preloader-indicator-overlay, .preloader-indicator-modal').remove();
    };
    // Action Sheet
    $.actions = function (params) {
        var modal, groupSelector, buttonSelector;
        params = params || [];

        if (params.length > 0 && !$.isArray(params[0])) {
            params = [params];
        }
        var modalHTML;
        var buttonsHTML = '';
        for (var i = 0; i < params.length; i++) {
            for (var j = 0; j < params[i].length; j++) {
                if (j === 0) buttonsHTML += '<div class="actions-modal-group">';
                var button = params[i][j];
                var buttonClass = button.label ? 'actions-modal-label' : 'actions-modal-button';
                if (button.bold) buttonClass += ' actions-modal-button-bold';
                if (button.color) buttonClass += ' color-' + button.color;
                if (button.bg) buttonClass += ' bg-' + button.bg;
                if (button.disabled) buttonClass += ' disabled';
                buttonsHTML += '<span class="' + buttonClass + '">' + button.text + '</span>';
                if (j === params[i].length - 1) buttonsHTML += '</div>';
            }
        }
        modalHTML = '<div class="actions-modal">' + buttonsHTML + '</div>';
        _modalTemplateTempDiv.innerHTML = modalHTML;
        modal = $(_modalTemplateTempDiv).children();
        $(defaults.modalContainer).append(modal[0]);
        groupSelector = '.actions-modal-group';
        buttonSelector = '.actions-modal-button';

        var groups = modal.find(groupSelector);
        groups.each(function (index, el) {
            var groupIndex = index;
            $(el).children().each(function (index, el) {
                var buttonIndex = index;
                var buttonParams = params[groupIndex][buttonIndex];
                var clickTarget;
                if ($(el).is(buttonSelector)) clickTarget = $(el);
                // if (toPopover && $(el).find(buttonSelector).length > 0) clickTarget = $(el).find(buttonSelector);

                if (clickTarget) {
                    clickTarget.on('click', function (e) {
                        if (buttonParams.close !== false) $.closeModal(modal);
                        if (buttonParams.onClick) buttonParams.onClick(modal, e);
                    });
                }
            });
        });
        $.openModal(modal);
        return modal[0];
    };
    $.popup = function (modal, removeOnClose) {
        if (typeof removeOnClose === 'undefined') removeOnClose = true;
        if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
            var _modal = document.createElement('div');
            _modal.innerHTML = modal.trim();
            if (_modal.childNodes.length > 0) {
                modal = _modal.childNodes[0];
                if (removeOnClose) modal.classList.add('remove-on-close');
                $(defaults.modalContainer).append(modal);
            }
            else return false; //nothing found
        }
        modal = $(modal);
        if (modal.length === 0) return false;
        modal.show();
        modal.find(".content").scroller("refresh");
        if (modal.find('.' + defaults.viewClass).length > 0) {
            $.sizeNavbars(modal.find('.' + defaults.viewClass)[0]);
        }
        $.openModal(modal);

        return modal[0];
    };
    $.pickerModal = function (pickerModal, removeOnClose) {
        if (typeof removeOnClose === 'undefined') removeOnClose = true;
        if (typeof pickerModal === 'string' && pickerModal.indexOf('<') >= 0) {
            pickerModal = $(pickerModal);
            if (pickerModal.length > 0) {
                if (removeOnClose) pickerModal.addClass('remove-on-close');
                $(defaults.modalContainer).append(pickerModal[0]);
            }
            else return false; //nothing found
        }
        pickerModal = $(pickerModal);
        if (pickerModal.length === 0) return false;
        pickerModal.show();
        $.openModal(pickerModal);
        return pickerModal[0];
    };
    $.loginScreen = function (modal) {
        if (!modal) modal = '.login-screen';
        modal = $(modal);
        if (modal.length === 0) return false;
        modal.show();
        if (modal.find('.' + defaults.viewClass).length > 0) {
            $.sizeNavbars(modal.find('.' + defaults.viewClass)[0]);
        }
        $.openModal(modal);
        return modal[0];
    };
    //显示一个消息，会在2秒钟后自动消失
    $.toast = function(msg, duration, extraclass) {
        var $toast = $('<div class="modal toast ' + (extraclass || '') + '">' + msg + '</div>').appendTo(document.body);
        $.openModal($toast, function(){
            setTimeout(function() {
                $.closeModal($toast);
            }, duration || 2000);
        });
    };
    $.openModal = function (modal, cb) {
        modal = $(modal);
        var isModal = modal.hasClass('modal'),
            isNotToast = !modal.hasClass('toast');
        if ($('.modal.modal-in:not(.modal-out)').length && defaults.modalStack && isModal && isNotToast) {
            $.modalStack.push(function () {
                $.openModal(modal, cb);
            });
            return;
        }
        var isPopup = modal.hasClass('popup');
        var isLoginScreen = modal.hasClass('login-screen');
        var isPickerModal = modal.hasClass('picker-modal');
        var isToast = modal.hasClass('toast');
        if (isModal) {
            modal.show();
            modal.css({
                marginTop: - Math.round(modal.outerHeight() / 2) + 'px'
            });
        }
        if (isToast) {
            modal.css({
                marginLeft: - Math.round(modal.outerWidth() / 2 / 1.185) + 'px' //1.185 是初始化时候的放大效果
            });
        }

        var overlay;
        if (!isLoginScreen && !isPickerModal && !isToast) {
            if ($('.modal-overlay').length === 0 && !isPopup) {
                $(defaults.modalContainer).append('<div class="modal-overlay"></div>');
            }
            if ($('.popup-overlay').length === 0 && isPopup) {
                $(defaults.modalContainer).append('<div class="popup-overlay"></div>');
            }
            overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
        }

        //Make sure that styles are applied, trigger relayout;
        var clientLeft = modal[0].clientLeft;

        // Trugger open event
        modal.trigger('open');

        // Picker modal body class
        if (isPickerModal) {
            $(defaults.modalContainer).addClass('with-picker-modal');
        }

        // Classes for transition in
        if (!isLoginScreen && !isPickerModal && !isToast) overlay.addClass('modal-overlay-visible');
        modal.removeClass('modal-out').addClass('modal-in').transitionEnd(function (e) {
            if (modal.hasClass('modal-out')) modal.trigger('closed');
            else modal.trigger('opened');
        });
        // excute callback
        if (typeof cb === 'function') {
          cb.call(this);
        }
        return true;
    };
    $.closeModal = function (modal) {
        modal = $(modal || '.modal-in');
        if (typeof modal !== 'undefined' && modal.length === 0) {
            return;
        }
        var isModal = modal.hasClass('modal'),
            isPopup = modal.hasClass('popup'),
            isToast = modal.hasClass('toast'),
            isLoginScreen = modal.hasClass('login-screen'),
            isPickerModal = modal.hasClass('picker-modal'),
            removeOnClose = modal.hasClass('remove-on-close'),
            overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
        if (isPopup){
            if (modal.length === $('.popup.modal-in').length) {
                overlay.removeClass('modal-overlay-visible');
            }
        }
        else if (!(isPickerModal || isToast)) {
            overlay.removeClass('modal-overlay-visible');
        }

        modal.trigger('close');

        // Picker modal body class
        if (isPickerModal) {
            $(defaults.modalContainer).removeClass('with-picker-modal');
            $(defaults.modalContainer).addClass('picker-modal-closing');
        }

        modal.removeClass('modal-in').addClass('modal-out').transitionEnd(function (e) {
            if (modal.hasClass('modal-out')) modal.trigger('closed');
            else modal.trigger('opened');

            if (isPickerModal) {
                $(defaults.modalContainer).removeClass('picker-modal-closing');
            }
            if (isPopup || isLoginScreen || isPickerModal) {
                modal.removeClass('modal-out').hide();
                if (removeOnClose && modal.length > 0) {
                    modal.remove();
                }
            }
            else {
                modal.remove();
            }
        });
        if (isModal &&  defaults.modalStack ) {
            $.modalStackClearQueue();
        }

        return true;
    };
    function handleClicks(e) {
        /*jshint validthis:true */
        var clicked = $(this);
        var url = clicked.attr('href');


        //Collect Clicked data- attributes
        var clickedData = clicked.dataset();

        // Popup
        var popup;
        if (clicked.hasClass('open-popup')) {
            if (clickedData.popup) {
                popup = clickedData.popup;
            }
            else popup = '.popup';
            $.popup(popup);
        }
        if (clicked.hasClass('close-popup')) {
            if (clickedData.popup) {
                popup = clickedData.popup;
            }
            else popup = '.popup.modal-in';
            $.closeModal(popup);
        }

        // Close Modal
        if (clicked.hasClass('modal-overlay')) {
            if ($('.modal.modal-in').length > 0 && defaults.modalCloseByOutside)
                $.closeModal('.modal.modal-in');
            if ($('.actions-modal.modal-in').length > 0 && defaults.actionsCloseByOutside)
                $.closeModal('.actions-modal.modal-in');

        }
        if (clicked.hasClass('popup-overlay')) {
            if ($('.popup.modal-in').length > 0 && defaults.popupCloseByOutside)
                $.closeModal('.popup.modal-in');
        }




    }
    $(document).on('click', ' .modal-overlay, .popup-overlay, .close-popup, .open-popup, .close-picker', handleClicks);
    var defaults =  $.modal.prototype.defaults  = {
        modalStack: true,
        modalButtonOk: '确认',
        modalButtonCancel: '取消',
        modalPreloaderTitle: '加载中',
        modalContainer : document.body ? document.body : 'body'
    };
}(Zepto);

/*======================================================
************   Calendar   ************
======================================================*/
/*jshint unused: false*/
+function ($) {
    "use strict";
    var rtl = false;
    var Calendar = function (params) {
        var p = this;
        var defaults = {
            monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月' , '九月' , '十月', '十一月', '十二月'],
            monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月' , '九月' , '十月', '十一月', '十二月'],
            dayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            firstDay: 1, // First day of the week, Monday
            weekendDays: [0, 6], // Sunday and Saturday
            multiple: false,
            dateFormat: 'yyyy-mm-dd',
            direction: 'horizontal', // or 'vertical'
            minDate: null,
            maxDate: null,
            touchMove: true,
            animate: true,
            closeOnSelect: true,
            monthPicker: true,
            monthPickerTemplate:
                '<div class="picker-calendar-month-picker">' +
                '<a href="#" class="link icon-only picker-calendar-prev-month"><i class="icon icon-prev"></i></a>' +
                '<div class="current-month-value"></div>' +
                '<a href="#" class="link icon-only picker-calendar-next-month"><i class="icon icon-next"></i></a>' +
                '</div>',
            yearPicker: true,
            yearPickerTemplate:
                '<div class="picker-calendar-year-picker">' +
                '<a href="#" class="link icon-only picker-calendar-prev-year"><i class="icon icon-prev"></i></a>' +
                '<span class="current-year-value"></span>' +
                '<a href="#" class="link icon-only picker-calendar-next-year"><i class="icon icon-next"></i></a>' +
                '</div>',
            weekHeader: true,
            // Common settings
            scrollToInput: true,
            inputReadOnly: true,
            toolbar: true,
            toolbarCloseText: 'Done',
            toolbarTemplate:
                '<div class="toolbar">' +
                '<div class="toolbar-inner">' +
                '{{monthPicker}}' +
                '{{yearPicker}}' +
                // '<a href="#" class="link close-picker">{{closeText}}</a>' +
                '</div>' +
                '</div>',
            /* Callbacks
               onMonthAdd
               onChange
               onOpen
               onClose
               onDayClick
               onMonthYearChangeStart
               onMonthYearChangeEnd
               */
        };
        params = params || {};
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
        }
        p.params = params;
        p.initialized = false;

        // Inline flag
        p.inline = p.params.container ? true : false;

        // Is horizontal
        p.isH = p.params.direction === 'horizontal';

        // RTL inverter
        var inverter = p.isH ? (rtl ? -1 : 1) : 1;

        // Animating flag
        p.animating = false;

        // Format date
        function formatDate(date) {
            date = new Date(date);
            var year = date.getFullYear();
            var month = date.getMonth();
            var month1 = month + 1;
            var day = date.getDate();
            var weekDay = date.getDay();
            return p.params.dateFormat
                .replace(/yyyy/g, year)
                .replace(/yy/g, (year + '').substring(2))
                .replace(/mm/g, month1 < 10 ? '0' + month1 : month1)
                .replace(/m/g, month1)
                .replace(/MM/g, p.params.monthNames[month])
                .replace(/M/g, p.params.monthNamesShort[month])
                .replace(/dd/g, day < 10 ? '0' + day : day)
                .replace(/d/g, day)
                .replace(/DD/g, p.params.dayNames[weekDay])
                .replace(/D/g, p.params.dayNamesShort[weekDay]);
        }


        // Value
        p.addValue = function (value) {
            if (p.params.multiple) {
                if (!p.value) p.value = [];
                var inValuesIndex;
                for (var i = 0; i < p.value.length; i++) {
                    if (new Date(value).getTime() === new Date(p.value[i]).getTime()) {
                        inValuesIndex = i;
                    }
                }
                if (typeof inValuesIndex === 'undefined') {
                    p.value.push(value);
                }
                else {
                    p.value.splice(inValuesIndex, 1);
                }
                p.updateValue();
            }
            else {
                p.value = [value];
                p.updateValue();
            }
        };
        p.setValue = function (arrValues) {
            p.value = arrValues;
            p.updateValue();
        };
        p.updateValue = function () {
            p.wrapper.find('.picker-calendar-day-selected').removeClass('picker-calendar-day-selected');
            var i, inputValue;
            for (i = 0; i < p.value.length; i++) {
                var valueDate = new Date(p.value[i]);
                p.wrapper.find('.picker-calendar-day[data-date="' + valueDate.getFullYear() + '-' + valueDate.getMonth() + '-' + valueDate.getDate() + '"]').addClass('picker-calendar-day-selected');
            }
            if (p.params.onChange) {
                p.params.onChange(p, p.value, p.value.map(formatDate));
            }
            if (p.input && p.input.length > 0) {
                if (p.params.formatValue) inputValue = p.params.formatValue(p, p.value);
                else {
                    inputValue = [];
                    for (i = 0; i < p.value.length; i++) {
                        inputValue.push(formatDate(p.value[i]));
                    }
                    inputValue = inputValue.join(', ');
                }
                $(p.input).val(inputValue);
                $(p.input).trigger('change');
            }
        };

        // Columns Handlers
        p.initCalendarEvents = function () {
            var col;
            var allowItemClick = true;
            var isTouched, isMoved, touchStartX, touchStartY, touchCurrentX, touchCurrentY, touchStartTime, touchEndTime, startTranslate, currentTranslate, wrapperWidth, wrapperHeight, percentage, touchesDiff, isScrolling;
            function handleTouchStart (e) {
                if (isMoved || isTouched) return;
                // e.preventDefault();
                isTouched = true;
                touchStartX = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
                touchStartTime = (new Date()).getTime();
                percentage = 0;
                allowItemClick = true;
                isScrolling = undefined;
                startTranslate = currentTranslate = p.monthsTranslate;
            }
            function handleTouchMove (e) {
                if (!isTouched) return;

                touchCurrentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                if (typeof isScrolling === 'undefined') {
                    isScrolling = !!(isScrolling || Math.abs(touchCurrentY - touchStartY) > Math.abs(touchCurrentX - touchStartX));
                }
                if (p.isH && isScrolling) {
                    isTouched = false;
                    return;
                }
                e.preventDefault();
                if (p.animating) {
                    isTouched = false;
                    return;
                }
                allowItemClick = false;
                if (!isMoved) {
                    // First move
                    isMoved = true;
                    wrapperWidth = p.wrapper[0].offsetWidth;
                    wrapperHeight = p.wrapper[0].offsetHeight;
                    p.wrapper.transition(0);
                }
                e.preventDefault();

                touchesDiff = p.isH ? touchCurrentX - touchStartX : touchCurrentY - touchStartY;
                percentage = touchesDiff/(p.isH ? wrapperWidth : wrapperHeight);
                currentTranslate = (p.monthsTranslate * inverter + percentage) * 100;

                // Transform wrapper
                p.wrapper.transform('translate3d(' + (p.isH ? currentTranslate : 0) + '%, ' + (p.isH ? 0 : currentTranslate) + '%, 0)');

            }
            function handleTouchEnd (e) {
                if (!isTouched || !isMoved) {
                    isTouched = isMoved = false;
                    return;
                }
                isTouched = isMoved = false;

                touchEndTime = new Date().getTime();
                if (touchEndTime - touchStartTime < 300) {
                    if (Math.abs(touchesDiff) < 10) {
                        p.resetMonth();
                    }
                    else if (touchesDiff >= 10) {
                        if (rtl) p.nextMonth();
                        else p.prevMonth();
                    }
                    else {
                        if (rtl) p.prevMonth();
                        else p.nextMonth();
                    }
                }
                else {
                    if (percentage <= -0.5) {
                        if (rtl) p.prevMonth();
                        else p.nextMonth();
                    }
                    else if (percentage >= 0.5) {
                        if (rtl) p.nextMonth();
                        else p.prevMonth();
                    }
                    else {
                        p.resetMonth();
                    }
                }

                // Allow click
                setTimeout(function () {
                    allowItemClick = true;
                }, 100);
            }

            function handleDayClick(e) {
                if (!allowItemClick) return;
                var day = $(e.target).parents('.picker-calendar-day');
                if (day.length === 0 && $(e.target).hasClass('picker-calendar-day')) {
                    day = $(e.target);
                }
                if (day.length === 0) return;
                if (day.hasClass('picker-calendar-day-selected') && !p.params.multiple) return;
                if (day.hasClass('picker-calendar-day-disabled')) return;
                if (day.hasClass('picker-calendar-day-next')) p.nextMonth();
                if (day.hasClass('picker-calendar-day-prev')) p.prevMonth();
                var dateYear = day.attr('data-year');
                var dateMonth = day.attr('data-month');
                var dateDay = day.attr('data-day');
                if (p.params.onDayClick) {
                    p.params.onDayClick(p, day[0], dateYear, dateMonth, dateDay);
                }
                p.addValue(new Date(dateYear, dateMonth, dateDay).getTime());
                if (p.params.closeOnSelect) p.close();
            }

            p.container.find('.picker-calendar-prev-month').on('click', p.prevMonth);
            p.container.find('.picker-calendar-next-month').on('click', p.nextMonth);
            p.container.find('.picker-calendar-prev-year').on('click', p.prevYear);
            p.container.find('.picker-calendar-next-year').on('click', p.nextYear);

            /**
             * 处理选择年份时的手势操作事件
             *
             * Start - edit by JSoon
             */
            function handleYearTouchStart (e) {
                if (isMoved || isTouched) return;
                // e.preventDefault();
                isTouched = true;
                touchStartX = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
                touchStartTime = (new Date()).getTime();
                percentage = 0;
                allowItemClick = true;
                isScrolling = undefined;
                startTranslate = currentTranslate = p.yearsTranslate;
            }

            function handleYearTouchMove (e) {
                if (!isTouched) return;

                touchCurrentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                if (typeof isScrolling === 'undefined') {
                    isScrolling = !!(isScrolling || Math.abs(touchCurrentY - touchStartY) > Math.abs(touchCurrentX - touchStartX));
                }
                if (p.isH && isScrolling) {
                    isTouched = false;
                    return;
                }
                e.preventDefault();
                if (p.animating) {
                    isTouched = false;
                    return;
                }
                allowItemClick = false;
                if (!isMoved) {
                    // First move
                    isMoved = true;
                    wrapperWidth = p.yearsPickerWrapper[0].offsetWidth;
                    wrapperHeight = p.yearsPickerWrapper[0].offsetHeight;
                    p.yearsPickerWrapper.transition(0);
                }
                e.preventDefault();

                touchesDiff = p.isH ? touchCurrentX - touchStartX : touchCurrentY - touchStartY;
                percentage = touchesDiff/(p.isH ? wrapperWidth : wrapperHeight);
                currentTranslate = (p.yearsTranslate * inverter + percentage) * 100;

                // Transform wrapper
                p.yearsPickerWrapper.transform('translate3d(' + (p.isH ? currentTranslate : 0) + '%, ' + (p.isH ? 0 : currentTranslate) + '%, 0)');

            }

            function handleYearTouchEnd (e) {
                if (!isTouched || !isMoved) {
                    isTouched = isMoved = false;
                    return;
                }
                isTouched = isMoved = false;

                touchEndTime = new Date().getTime();
                if (touchEndTime - touchStartTime < 300) {
                    if (Math.abs(touchesDiff) < 10) {
                        p.resetYearsGroup();
                    }
                    else if (touchesDiff >= 10) {
                        if (rtl) p.nextYearsGroup();
                        else p.prevYearsGroup();
                    }
                    else {
                        if (rtl) p.prevYearsGroup();
                        else p.nextYearsGroup();
                    }
                }
                else {
                    if (percentage <= -0.5) {
                        if (rtl) p.prevYearsGroup();
                        else p.nextYearsGroup();
                    }
                    else if (percentage >= 0.5) {
                        if (rtl) p.nextYearsGroup();
                        else p.prevYearsGroup();
                    }
                    else {
                        p.resetYearsGroup();
                    }
                }

                // Allow click
                setTimeout(function () {
                    allowItemClick = true;
                }, 100);
            }

            function handleYearSelector() {
                var curYear = $(this).text(),
                    yearsPicker = p.container.find('.picker-calendar-years-picker');
                yearsPicker.show().transform('translate3d(0, 0, 0)');
                p.updateSelectedInPickers();
                yearsPicker.on('click', '.picker-calendar-year-unit', p.pickYear);
            }

            function handleMonthSelector() {
                var monthsPicker = p.container.find('.picker-calendar-months-picker');
                monthsPicker.show().transform('translate3d(0, 0, 0)');
                p.updateSelectedInPickers();
                monthsPicker.on('click', '.picker-calendar-month-unit', p.pickMonth);
            }

            // 选择年份
            p.container.find('.current-year-value').on('click', handleYearSelector);

            // 选择月份
            p.container.find('.current-month-value').on('click', handleMonthSelector);
            /**
             * End - edit by JSoon
             */

            p.wrapper.on('click', handleDayClick);
            if (p.params.touchMove) {
                /**
                 * 给年份选择器绑定手势操作事件
                 *
                 * Start - edit by JSoon
                 */
                p.yearsPickerWrapper.on($.touchEvents.start, handleYearTouchStart);
                p.yearsPickerWrapper.on($.touchEvents.move, handleYearTouchMove);
                p.yearsPickerWrapper.on($.touchEvents.end, handleYearTouchEnd);
                /**
                 * Start - edit by JSoon
                 */

                p.wrapper.on($.touchEvents.start, handleTouchStart);
                p.wrapper.on($.touchEvents.move, handleTouchMove);
                p.wrapper.on($.touchEvents.end, handleTouchEnd);
            }

            p.container[0].f7DestroyCalendarEvents = function () {
                p.container.find('.picker-calendar-prev-month').off('click', p.prevMonth);
                p.container.find('.picker-calendar-next-month').off('click', p.nextMonth);
                p.container.find('.picker-calendar-prev-year').off('click', p.prevYear);
                p.container.find('.picker-calendar-next-year').off('click', p.nextYear);
                p.wrapper.off('click', handleDayClick);
                if (p.params.touchMove) {
                    p.wrapper.off($.touchEvents.start, handleTouchStart);
                    p.wrapper.off($.touchEvents.move, handleTouchMove);
                    p.wrapper.off($.touchEvents.end, handleTouchEnd);
                }
            };


        };
        p.destroyCalendarEvents = function (colContainer) {
            if ('f7DestroyCalendarEvents' in p.container[0]) p.container[0].f7DestroyCalendarEvents();
        };

        // Calendar Methods

        /**
         * 1. 生成年份和月份选择器DOM结构
         * 2. 年份选择和月份选择的pick事件函数
         * 3. 年份选择手势操作结束后，更新年分组DOM结构
         *
         * Start - edit by JSoon
         */
        p.yearsGroupHTML = function(date, offset) {
            date = new Date(date);
            var curYear = date.getFullYear(), // 日历上的当前年份
                trueYear = new Date().getFullYear(), // 当前真实年份
                yearNum = 25, // 年份面板年份总数量
                firstYear = curYear - Math.floor(yearNum/2), // 年份面板第一格年份
                yearsHTML = '';
            if (offset === 'next') {
                firstYear = firstYear + yearNum;
            }
            if (offset === 'prev') {
                firstYear = firstYear - yearNum;
            }
            for (var i = 0; i < 5; i += 1) {
                var rowHTML = '';
                var row = i;
                rowHTML += '<div class="picker-calendar-row">';
                for (var j = 0; j < 5; j += 1) {
                    if (firstYear === trueYear) {
                        rowHTML += '<div class="picker-calendar-year-unit current-calendar-year-unit" data-year="'+ firstYear +'"><span>' + firstYear + '</span></div>';
                    } else if (firstYear === curYear) {
                        rowHTML += '<div class="picker-calendar-year-unit picker-calendar-year-unit-selected" data-year="'+ firstYear +'"><span>' + firstYear + '</span></div>';
                    } else {
                        rowHTML += '<div class="picker-calendar-year-unit" data-year="'+ firstYear +'"><span>' + firstYear + '</span></div>';
                    }
                    firstYear += 1;
                }
                rowHTML += '</div>';
                yearsHTML += rowHTML;
            }
            yearsHTML = '<div class="picker-calendar-years-group">' + yearsHTML + '</div>';
            return yearsHTML;
        };

        p.pickYear = function() {
            var year = $(this).text(),
                curYear = p.wrapper.find('.picker-calendar-month-current').attr('data-year');
            p.yearsPickerWrapper.find('.picker-calendar-year-unit').removeClass('picker-calendar-year-unit-selected');
            $(this).addClass('picker-calendar-year-unit-selected');
            if (curYear !== year) {
                p.setYearMonth(year);
                p.container.find('.picker-calendar-years-picker').hide().transform('translate3d(0, 100%, 0)');
            } else {
                p.container.find('.picker-calendar-years-picker').transform('translate3d(0, 100%, 0)');
            }
        };

        p.onYearsChangeEnd = function (dir) {
            p.animating = false;
            var nextYearsHTML, prevYearsHTML, newCurFirstYear;
            var yearNum = p.yearsPickerWrapper.children('.picker-calendar-years-next').find('.picker-calendar-year-unit').length;
            if (dir === 'next') {
                var newCurFirstYear = parseInt(p.yearsPickerWrapper.children('.picker-calendar-years-next').find('.picker-calendar-year-unit').eq(Math.floor(yearNum/2)).text());
                nextYearsHTML = p.yearsGroupHTML(new Date(newCurFirstYear, p.currentMonth), 'next');
                p.yearsPickerWrapper.append(nextYearsHTML);
                p.yearsPickerWrapper.children().first().remove();
                p.yearsGroups = p.container.find('.picker-calendar-years-group');
            }
            if (dir === 'prev') {
                var newCurFirstYear = parseInt(p.yearsPickerWrapper.children('.picker-calendar-years-prev').find('.picker-calendar-year-unit').eq(Math.floor(yearNum/2)).text());
                prevYearsHTML = p.yearsGroupHTML(new Date(newCurFirstYear, p.currentMonth), 'prev');
                p.yearsPickerWrapper.prepend(prevYearsHTML);
                p.yearsPickerWrapper.children().last().remove();
                p.yearsGroups = p.container.find('.picker-calendar-years-group');
            }
            p.setYearsTranslate(p.yearsTranslate);
        };

        p.monthsGroupHTML = function(date) {
            date = new Date(date);
            var curMonth = date.getMonth() + 1, // 日历上的当前月份
                trueMonth = new Date().getMonth() + 1, // 当前真实月份
                monthNum = 12, // 月份面板月份总数量
                firstMonth = 1,
                monthsHTML = '';
            for (var i = 0; i < 3; i += 1) {
                var rowHTML = '';
                var row = i;
                rowHTML += '<div class="picker-calendar-row">';
                for (var j = 0; j < 4; j += 1) {
                    if (firstMonth === trueMonth) {
                        rowHTML += '<div class="picker-calendar-month-unit current-calendar-month-unit" data-month="'+ (firstMonth-1) +'"><span>' + p.params.monthNames[firstMonth-1] + '</span></div>';
                    } else if (firstMonth === curMonth) {
                        rowHTML += '<div class="picker-calendar-month-unit picker-calendar-month-selected" data-month="'+ (firstMonth-1) +'"><span>' + p.params.monthNames[firstMonth-1] + '</span></div>';
                    } else {
                        rowHTML += '<div class="picker-calendar-month-unit" data-month="'+ (firstMonth-1) +'"><span>' + p.params.monthNames[firstMonth-1] + '</span></div>';
                    }
                    firstMonth += 1;
                }
                rowHTML += '</div>';
                monthsHTML += rowHTML;
            }
            monthsHTML = '<div class="picker-calendar-months-group">' + monthsHTML + '</div>';
            return monthsHTML;
        };

        p.pickMonth = function() {
            var month = $(this).attr('data-month'),
                curYear = p.wrapper.find('.picker-calendar-month-current').attr('data-year'),
                curMonth = p.wrapper.find('.picker-calendar-month-current').attr('data-month');
            p.monthsPickerWrapper.find('.picker-calendar-month-unit').removeClass('picker-calendar-month-unit-selected');
            $(this).addClass('picker-calendar-month-unit-selected');
            if (curMonth !== month) {
                p.setYearMonth(curYear, month);
                p.container.find('.picker-calendar-months-picker').hide().transform('translate3d(0, 100%, 0)');
            } else {
                p.container.find('.picker-calendar-months-picker').transform('translate3d(0, 100%, 0)');
            }
        };
        /**
         * End - edit by JSoon
         */

        p.daysInMonth = function (date) {
            var d = new Date(date);
            return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
        };
        p.monthHTML = function (date, offset) {
            date = new Date(date);
            var year = date.getFullYear(),
                month = date.getMonth(),
                day = date.getDate();
            if (offset === 'next') {
                if (month === 11) date = new Date(year + 1, 0);
                else date = new Date(year, month + 1, 1);
            }
            if (offset === 'prev') {
                if (month === 0) date = new Date(year - 1, 11);
                else date = new Date(year, month - 1, 1);
            }
            if (offset === 'next' || offset === 'prev') {
                month = date.getMonth();
                year = date.getFullYear();
            }
            var daysInPrevMonth = p.daysInMonth(new Date(date.getFullYear(), date.getMonth()).getTime() - 10 * 24 * 60 * 60 * 1000),
                daysInMonth = p.daysInMonth(date),
                firstDayOfMonthIndex = new Date(date.getFullYear(), date.getMonth()).getDay();
            if (firstDayOfMonthIndex === 0) firstDayOfMonthIndex = 7;

            var dayDate, currentValues = [], i, j,
                rows = 6, cols = 7,
                monthHTML = '',
                dayIndex = 0 + (p.params.firstDay - 1),
                today = new Date().setHours(0,0,0,0),
                minDate = p.params.minDate ? new Date(p.params.minDate).getTime() : null,
                maxDate = p.params.maxDate ? new Date(p.params.maxDate).getTime() : null;

            if (p.value && p.value.length) {
                for (i = 0; i < p.value.length; i++) {
                    currentValues.push(new Date(p.value[i]).setHours(0,0,0,0));
                }
            }

            for (i = 1; i <= rows; i++) {
                var rowHTML = '';
                var row = i;
                for (j = 1; j <= cols; j++) {
                    var col = j;
                    dayIndex ++;
                    var dayNumber = dayIndex - firstDayOfMonthIndex;
                    var addClass = '';
                    if (dayNumber < 0) {
                        dayNumber = daysInPrevMonth + dayNumber + 1;
                        addClass += ' picker-calendar-day-prev';
                        dayDate = new Date(month - 1 < 0 ? year - 1 : year, month - 1 < 0 ? 11 : month - 1, dayNumber).getTime();
                    }
                    else {
                        dayNumber = dayNumber + 1;
                        if (dayNumber > daysInMonth) {
                            dayNumber = dayNumber - daysInMonth;
                            addClass += ' picker-calendar-day-next';
                            dayDate = new Date(month + 1 > 11 ? year + 1 : year, month + 1 > 11 ? 0 : month + 1, dayNumber).getTime();
                        }
                        else {
                            dayDate = new Date(year, month, dayNumber).getTime();
                        }
                    }
                    // Today
                    if (dayDate === today) addClass += ' picker-calendar-day-today';
                    // Selected
                    if (currentValues.indexOf(dayDate) >= 0) addClass += ' picker-calendar-day-selected';
                    // Weekend
                    if (p.params.weekendDays.indexOf(col - 1) >= 0) {
                        addClass += ' picker-calendar-day-weekend';
                    }
                    // Disabled
                    if ((minDate && dayDate < minDate) || (maxDate && dayDate > maxDate)) {
                        addClass += ' picker-calendar-day-disabled';
                    }

                    dayDate = new Date(dayDate);
                    var dayYear = dayDate.getFullYear();
                    var dayMonth = dayDate.getMonth();
                    rowHTML += '<div data-year="' + dayYear + '" data-month="' + dayMonth + '" data-day="' + dayNumber + '" class="picker-calendar-day' + (addClass) + '" data-date="' + (dayYear + '-' + dayMonth + '-' + dayNumber) + '"><span>'+dayNumber+'</span></div>';
                }
                monthHTML += '<div class="picker-calendar-row">' + rowHTML + '</div>';
            }
            monthHTML = '<div class="picker-calendar-month" data-year="' + year + '" data-month="' + month + '">' + monthHTML + '</div>';
            return monthHTML;
        };
        p.animating = false;
        p.updateCurrentMonthYear = function (dir) {
            if (typeof dir === 'undefined') {
                p.currentMonth = parseInt(p.months.eq(1).attr('data-month'), 10);
                p.currentYear = parseInt(p.months.eq(1).attr('data-year'), 10);
            }
            else {
                p.currentMonth = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-month'), 10);
                p.currentYear = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-year'), 10);
            }
            p.container.find('.current-month-value').text(p.params.monthNames[p.currentMonth]);
            p.container.find('.current-year-value').text(p.currentYear);

        };
        p.onMonthChangeStart = function (dir) {
            p.updateCurrentMonthYear(dir);
            p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
            var currentIndex = dir === 'next' ? p.months.length - 1 : 0;

            p.months.eq(currentIndex).addClass('picker-calendar-month-current');
            p.months.eq(dir === 'next' ? currentIndex - 1 : currentIndex + 1).addClass(dir === 'next' ? 'picker-calendar-month-prev' : 'picker-calendar-month-next');

            if (p.params.onMonthYearChangeStart) {
                p.params.onMonthYearChangeStart(p, p.currentYear, p.currentMonth);
            }
        };
        p.onMonthChangeEnd = function (dir, rebuildBoth) {
            p.animating = false;
            var nextMonthHTML, prevMonthHTML, newMonthHTML;
            p.wrapper.find('.picker-calendar-month:not(.picker-calendar-month-prev):not(.picker-calendar-month-current):not(.picker-calendar-month-next)').remove();

            if (typeof dir === 'undefined') {
                dir = 'next';
                rebuildBoth = true;
            }
            if (!rebuildBoth) {
                newMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), dir);
            }
            else {
                p.wrapper.find('.picker-calendar-month-next, .picker-calendar-month-prev').remove();
                prevMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'prev');
                nextMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'next');
            }
            if (dir === 'next' || rebuildBoth) {
                p.wrapper.append(newMonthHTML || nextMonthHTML);
            }
            if (dir === 'prev' || rebuildBoth) {
                p.wrapper.prepend(newMonthHTML || prevMonthHTML);
            }
            p.months = p.wrapper.find('.picker-calendar-month');
            p.setMonthsTranslate(p.monthsTranslate);
            if (p.params.onMonthAdd) {
                p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
            }
            if (p.params.onMonthYearChangeEnd) {
                p.params.onMonthYearChangeEnd(p, p.currentYear, p.currentMonth);
            }
            /**
             * 月历面板结束手势操作后，更新年份/月份选择器中的选中高亮状态
             *
             * Start - edit by JSoon
             */
            p.updateSelectedInPickers();
            /**
             * End - edit by JSoon
             */
        };

        /**
         * 1. 更新年份/月份选择器中的选中高亮状态函数
         * 2. 年份选择器过渡动画函数
         * 3. 下一个/上一个/当前年分组手势操作函数
         *
         * Start - edit by JSoon
         */
        p.updateSelectedInPickers = function() {
            var curYear = parseInt(p.wrapper.find('.picker-calendar-month-current').attr('data-year'), 10),
                trueYear = new Date().getFullYear(),
                curMonth = parseInt(p.wrapper.find('.picker-calendar-month-current').attr('data-month'), 10),
                trueMonth = new Date().getMonth(),
                selectedYear = parseInt(p.yearsPickerWrapper.find('.picker-calendar-year-unit-selected').attr('data-year'), 10),
                selectedMonth = parseInt(p.monthsPickerWrapper.find('.picker-calendar-month-unit-selected').attr('data-month'), 10);
            if (selectedYear !== curYear) {
                p.yearsPickerWrapper.find('.picker-calendar-year-unit').removeClass('picker-calendar-year-unit-selected');
                p.yearsPickerWrapper.find('.picker-calendar-year-unit[data-year="' + curYear + '"]').addClass('picker-calendar-year-unit-selected');
            }
            if (selectedMonth !== curMonth) {
                p.monthsPickerWrapper.find('.picker-calendar-month-unit').removeClass('picker-calendar-month-unit-selected');
                p.monthsPickerWrapper.find('.picker-calendar-month-unit[data-month="' + curMonth + '"]').addClass('picker-calendar-month-unit-selected');
            }
            if (trueYear !== curYear) {
                p.monthsPickerWrapper.find('.picker-calendar-month-unit').removeClass('current-calendar-month-unit');
            } else {
                p.monthsPickerWrapper.find('.picker-calendar-month-unit[data-month="' + trueMonth + '"]').addClass('current-calendar-month-unit');
            }
        };

        p.setYearsTranslate = function (translate) {
            translate = translate || p.yearsTranslate || 0;
            if (typeof p.yearsTranslate === 'undefined') p.yearsTranslate = translate;
            p.yearsGroups.removeClass('picker-calendar-years-current picker-calendar-years-prev picker-calendar-years-next');
            var prevYearTranslate = -(translate + 1) * 100 * inverter;
            var currentYearTranslate = -translate * 100 * inverter;
            var nextYearTranslate = -(translate - 1) * 100 * inverter;
            p.yearsGroups.eq(0).transform('translate3d(' + (p.isH ? prevYearTranslate : 0) + '%, ' + (p.isH ? 0 : prevYearTranslate) + '%, 0)').addClass('picker-calendar-years-prev');
            p.yearsGroups.eq(1).transform('translate3d(' + (p.isH ? currentYearTranslate : 0) + '%, ' + (p.isH ? 0 : currentYearTranslate) + '%, 0)').addClass('picker-calendar-years-current');
            p.yearsGroups.eq(2).transform('translate3d(' + (p.isH ? nextYearTranslate : 0) + '%, ' + (p.isH ? 0 : nextYearTranslate) + '%, 0)').addClass('picker-calendar-years-next');
        };

        p.nextYearsGroup = function (transition) {
            if (typeof transition === 'undefined' || typeof transition === 'object') {
                transition = '';
                if (!p.params.animate) transition = 0;
            }
            var transitionEndCallback = p.animating ? false : true;
            p.yearsTranslate --;
            p.animating = true;
            var translate = (p.yearsTranslate * 100) * inverter;
            p.yearsPickerWrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
            if (transitionEndCallback) {
                p.yearsPickerWrapper.transitionEnd(function () {
                    p.onYearsChangeEnd('next');
                });
            }
            if (!p.params.animate) {
                p.onYearsChangeEnd('next');
            }
        };

        p.prevYearsGroup = function (transition) {
            if (typeof transition === 'undefined' || typeof transition === 'object') {
                transition = '';
                if (!p.params.animate) transition = 0;
            }
            var transitionEndCallback = p.animating ? false : true;
            p.yearsTranslate ++;
            p.animating = true;
            var translate = (p.yearsTranslate * 100) * inverter;
            p.yearsPickerWrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
            if (transitionEndCallback) {
                p.yearsPickerWrapper.transitionEnd(function () {
                    p.onYearsChangeEnd('prev');
                });
            }
            if (!p.params.animate) {
                p.onYearsChangeEnd('prev');
            }
        };

        p.resetYearsGroup = function (transition) {
            if (typeof transition === 'undefined') transition = '';
            var translate = (p.yearsTranslate * 100) * inverter;
            p.yearsPickerWrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
        };
        /**
         * End - edit by JSoon
         */

        p.setMonthsTranslate = function (translate) {
            translate = translate || p.monthsTranslate || 0;
            if (typeof p.monthsTranslate === 'undefined') p.monthsTranslate = translate;
            p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
            var prevMonthTranslate = -(translate + 1) * 100 * inverter;
            var currentMonthTranslate = -translate * 100 * inverter;
            var nextMonthTranslate = -(translate - 1) * 100 * inverter;
            p.months.eq(0).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
            p.months.eq(1).transform('translate3d(' + (p.isH ? currentMonthTranslate : 0) + '%, ' + (p.isH ? 0 : currentMonthTranslate) + '%, 0)').addClass('picker-calendar-month-current');
            p.months.eq(2).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
        };
        p.nextMonth = function (transition) {
            if (typeof transition === 'undefined' || typeof transition === 'object') {
                transition = '';
                if (!p.params.animate) transition = 0;
            }
            var nextMonth = parseInt(p.months.eq(p.months.length - 1).attr('data-month'), 10);
            var nextYear = parseInt(p.months.eq(p.months.length - 1).attr('data-year'), 10);
            var nextDate = new Date(nextYear, nextMonth);
            var nextDateTime = nextDate.getTime();
            var transitionEndCallback = p.animating ? false : true;
            if (p.params.maxDate) {
                if (nextDateTime > new Date(p.params.maxDate).getTime()) {
                    return p.resetMonth();
                }
            }
            p.monthsTranslate --;
            if (nextMonth === p.currentMonth) {
                var nextMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
                var nextMonthHTML = $(p.monthHTML(nextDateTime, 'next')).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
                p.wrapper.append(nextMonthHTML[0]);
                p.months = p.wrapper.find('.picker-calendar-month');
                if (p.params.onMonthAdd) {
                    p.params.onMonthAdd(p, p.months.eq(p.months.length - 1)[0]);
                }
            }
            p.animating = true;
            p.onMonthChangeStart('next');
            var translate = (p.monthsTranslate * 100) * inverter;

            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
            if (transitionEndCallback) {
                p.wrapper.transitionEnd(function () {
                    p.onMonthChangeEnd('next');
                });
            }
            if (!p.params.animate) {
                p.onMonthChangeEnd('next');
            }
        };
        p.prevMonth = function (transition) {
            if (typeof transition === 'undefined' || typeof transition === 'object') {
                transition = '';
                if (!p.params.animate) transition = 0;
            }
            var prevMonth = parseInt(p.months.eq(0).attr('data-month'), 10);
            var prevYear = parseInt(p.months.eq(0).attr('data-year'), 10);
            var prevDate = new Date(prevYear, prevMonth + 1, -1);
            var prevDateTime = prevDate.getTime();
            var transitionEndCallback = p.animating ? false : true;
            if (p.params.minDate) {
                if (prevDateTime < new Date(p.params.minDate).getTime()) {
                    return p.resetMonth();
                }
            }
            p.monthsTranslate ++;
            if (prevMonth === p.currentMonth) {
                var prevMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
                var prevMonthHTML = $(p.monthHTML(prevDateTime, 'prev')).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
                p.wrapper.prepend(prevMonthHTML[0]);
                p.months = p.wrapper.find('.picker-calendar-month');
                if (p.params.onMonthAdd) {
                    p.params.onMonthAdd(p, p.months.eq(0)[0]);
                }
            }
            p.animating = true;
            p.onMonthChangeStart('prev');
            var translate = (p.monthsTranslate * 100) * inverter;
            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
            if (transitionEndCallback) {
                p.wrapper.transitionEnd(function () {
                    p.onMonthChangeEnd('prev');
                });
            }
            if (!p.params.animate) {
                p.onMonthChangeEnd('prev');
            }
        };
        p.resetMonth = function (transition) {
            if (typeof transition === 'undefined') transition = '';
            var translate = (p.monthsTranslate * 100) * inverter;
            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
        };
        p.setYearMonth = function (year, month, transition) {
            if (typeof year === 'undefined') year = p.currentYear;
            if (typeof month === 'undefined') month = p.currentMonth;
            if (typeof transition === 'undefined' || typeof transition === 'object') {
                transition = '';
                if (!p.params.animate) transition = 0;
            }
            var targetDate;
            if (year < p.currentYear) {
                targetDate = new Date(year, month + 1, -1).getTime();
            } else {
                targetDate = new Date(year, month).getTime();
            }
            if (p.params.maxDate && targetDate > new Date(p.params.maxDate).getTime()) {
                return false;
            }
            if (p.params.minDate && targetDate < new Date(p.params.minDate).getTime()) {
                return false;
            }
            var currentDate = new Date(p.currentYear, p.currentMonth).getTime();
            var dir = targetDate > currentDate ? 'next' : 'prev';
            var newMonthHTML = p.monthHTML(new Date(year, month));
            p.monthsTranslate = p.monthsTranslate || 0;
            var prevTranslate = p.monthsTranslate;
            var monthTranslate, wrapperTranslate;
            var transitionEndCallback = p.animating ? false : true;
            if (targetDate > currentDate) {
                // To next
                p.monthsTranslate --;
                if (!p.animating) p.months.eq(p.months.length - 1).remove();
                p.wrapper.append(newMonthHTML);
                p.months = p.wrapper.find('.picker-calendar-month');
                monthTranslate = -(prevTranslate - 1) * 100 * inverter;
                p.months.eq(p.months.length - 1).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
            }
            else {
                // To prev
                p.monthsTranslate ++;
                if (!p.animating) p.months.eq(0).remove();
                p.wrapper.prepend(newMonthHTML);
                p.months = p.wrapper.find('.picker-calendar-month');
                monthTranslate = -(prevTranslate + 1) * 100 * inverter;
                p.months.eq(0).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
            }
            if (p.params.onMonthAdd) {
                p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
            }
            p.animating = true;
            p.onMonthChangeStart(dir);
            wrapperTranslate = (p.monthsTranslate * 100) * inverter;
            p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? wrapperTranslate : 0) + '%, ' + (p.isH ? 0 : wrapperTranslate) + '%, 0)');
            if (transitionEndCallback) {
                p.wrapper.transitionEnd(function () {
                    p.onMonthChangeEnd(dir, true);
                });
            }
            if (!p.params.animate) {
                p.onMonthChangeEnd(dir);
            }
        };
        p.nextYear = function () {
            p.setYearMonth(p.currentYear + 1);
        };
        p.prevYear = function () {
            p.setYearMonth(p.currentYear - 1);
        };


        // HTML Layout
        p.layout = function () {
            var pickerHTML = '';
            var pickerClass = '';
            var i;

            var layoutDate = p.value && p.value.length ? p.value[0] : new Date().setHours(0,0,0,0);
            /**
             * 生成年份组和月份组DOM
             *
             * Start - edit by JSoon
             */
            var prevYearsHTML = p.yearsGroupHTML(layoutDate, 'prev');
            var currentYearsHTML = p.yearsGroupHTML(layoutDate);
            var nextYearsHTML = p.yearsGroupHTML(layoutDate, 'next');
            var yearsGroupHTML = '<div class="picker-calendar-years-picker"><div class="picker-calendar-years-picker-wrapper">' + (prevYearsHTML + currentYearsHTML + nextYearsHTML) + '</div></div>';

            var monthsGroupHTML = '<div class="picker-calendar-months-picker"><div class="picker-calendar-months-picker-wrapper">' + p.monthsGroupHTML(layoutDate) + '</div></div>';
            /**
             * End - edit by JSoon
             */
            var prevMonthHTML = p.monthHTML(layoutDate, 'prev');
            var currentMonthHTML = p.monthHTML(layoutDate);
            var nextMonthHTML = p.monthHTML(layoutDate, 'next');
            var monthsHTML = '<div class="picker-calendar-months"><div class="picker-calendar-months-wrapper">' + (prevMonthHTML + currentMonthHTML + nextMonthHTML) + '</div></div>';
            // Week days header
            var weekHeaderHTML = '';
            if (p.params.weekHeader) {
                for (i = 0; i < 7; i++) {
                    var weekDayIndex = (i + p.params.firstDay > 6) ? (i - 7 + p.params.firstDay) : (i + p.params.firstDay);
                    var dayName = p.params.dayNamesShort[weekDayIndex];
                    weekHeaderHTML += '<div class="picker-calendar-week-day ' + ((p.params.weekendDays.indexOf(weekDayIndex) >= 0) ? 'picker-calendar-week-day-weekend' : '') + '"> ' + dayName + '</div>';

                }
                weekHeaderHTML = '<div class="picker-calendar-week-days">' + weekHeaderHTML + '</div>';
            }
            pickerClass = 'picker-modal picker-calendar ' + (p.params.cssClass || '');
            var toolbarHTML = p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '';
            if (p.params.toolbar) {
                toolbarHTML = p.params.toolbarTemplate
                    .replace(/{{closeText}}/g, p.params.toolbarCloseText)
                    .replace(/{{monthPicker}}/g, (p.params.monthPicker ? p.params.monthPickerTemplate : ''))
                    .replace(/{{yearPicker}}/g, (p.params.yearPicker ? p.params.yearPickerTemplate : ''));
            }

            /**
             * 将年份组/月份组DOM添加document中
             *
             * Start - edit by JSoon
             */
            pickerHTML =
                '<div class="' + (pickerClass) + '">' +
                toolbarHTML +
                '<div class="picker-modal-inner">' +
                weekHeaderHTML +
                monthsHTML +
                '</div>' +
                monthsGroupHTML +
                yearsGroupHTML +
                '</div>';
            /**
             * End - edit by JSoon
             */

            p.pickerHTML = pickerHTML;
        };

        // Input Events
        function openOnInput(e) {
            e.preventDefault();
            // 安卓微信webviewreadonly的input依然弹出软键盘问题修复
            if ($.device.isWeixin && $.device.android && p.params.inputReadOnly) {
                /*jshint validthis:true */
                this.focus();
                this.blur();
            }
            if (p.opened) return;
            p.open();
            if (p.params.scrollToInput) {
                var pageContent = p.input.parents('.content');
                if (pageContent.length === 0) return;

                var paddingTop = parseInt(pageContent.css('padding-top'), 10),
                    paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
                    pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
                    pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
                    newPaddingBottom;

                var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
                if (inputTop > pageHeight) {
                    var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
                    if (scrollTop + pageHeight > pageScrollHeight) {
                        newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
                        if (pageHeight === pageScrollHeight) {
                            newPaddingBottom = p.container.height();
                        }
                        pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
                    }
                    pageContent.scrollTop(scrollTop, 300);
                }
            }
        }
        function closeOnHTMLClick(e) {
            if (p.input && p.input.length > 0) {
                if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
            }
            else {
                if ($(e.target).parents('.picker-modal').length === 0) p.close();
            }
        }

        if (p.params.input) {
            p.input = $(p.params.input);
            if (p.input.length > 0) {
                if (p.params.inputReadOnly) p.input.prop('readOnly', true);
                if (!p.inline) {
                    p.input.on('click', openOnInput);
                }
                /**
                 * 修复[#308](https://github.com/sdc-alibaba/SUI-Mobile/issues/308)
                 * 场景：内联页面中存在日历控件的input
                 * 问题：因未在关闭时unbind click openOnInput事件导致多次调用p.open()而生成多个日历
                 *
                 * Start - edit by JSoon
                 */
                $(document).on('beforePageSwitch', function() {
                    p.input.off('click', openOnInput);
                    $(document).off('beforePageSwitch');
                });
                /**
                 * End - edit by JSoon
                 */
            }

        }

        if (!p.inline) $('html').on('click', closeOnHTMLClick);

        // Open
        function onPickerClose() {
            p.opened = false;
            if (p.input && p.input.length > 0) p.input.parents('.content').css({'padding-bottom': ''});
            if (p.params.onClose) p.params.onClose(p);

            // Destroy events
            p.destroyCalendarEvents();
        }

        p.opened = false;
        p.open = function () {
            var updateValue = false;
            if (!p.opened) {
                // Set date value
                if (!p.value) {
                    if (p.params.value) {
                        p.value = p.params.value;
                        updateValue = true;
                    }
                }

                // Layout
                p.layout();

                // Append
                if (p.inline) {
                    p.container = $(p.pickerHTML);
                    p.container.addClass('picker-modal-inline');
                    $(p.params.container).append(p.container);
                }
                else {
                    p.container = $($.pickerModal(p.pickerHTML));
                    $(p.container)
                        .on('close', function () {
                            onPickerClose();
                        });
                }

                // Store calendar instance
                p.container[0].f7Calendar = p;
                p.wrapper = p.container.find('.picker-calendar-months-wrapper');

                /**
                 * 获取全局年份组及其wrapper的zepto对象
                 * 获取全局月份组wrapper的zepto对象
                 *
                 * Start - edit by JSoon
                 */
                p.yearsPickerWrapper = p.container.find('.picker-calendar-years-picker-wrapper');
                p.yearsGroups = p.yearsPickerWrapper.find('.picker-calendar-years-group');

                p.monthsPickerWrapper = p.container.find('.picker-calendar-months-picker-wrapper');
                /**
                 * End - edit by JSoon
                 */

                // Months
                p.months = p.wrapper.find('.picker-calendar-month');

                // Update current month and year
                p.updateCurrentMonthYear();

                // Set initial translate
                /**
                 * 初始化年份组过渡动画位置
                 *
                 * Start - edit by JSoon
                 */
                p.yearsTranslate = 0;
                p.setYearsTranslate();
                /**
                 * End - edit by JSoon
                 */
                p.monthsTranslate = 0;
                p.setMonthsTranslate();

                // Init events
                p.initCalendarEvents();

                // Update input value
                if (updateValue) p.updateValue();

            }

            // Set flag
            p.opened = true;
            p.initialized = true;
            if (p.params.onMonthAdd) {
                p.months.each(function () {
                    p.params.onMonthAdd(p, this);
                });
            }
            if (p.params.onOpen) p.params.onOpen(p);
        };

        // Close
        p.close = function () {
            if (!p.opened || p.inline) return;
            $.closeModal(p.container);
            return;
        };

        // Destroy
        p.destroy = function () {
            p.close();
            if (p.params.input && p.input.length > 0) {
                p.input.off('click', openOnInput);
            }
            $('html').off('click', closeOnHTMLClick);
        };

        if (p.inline) {
            p.open();
        }

        return p;
    };
    $.fn.calendar = function (params) {
        return this.each(function() {
            var $this = $(this);
            if(!$this[0]) return;
            var p = {};
            if($this[0].tagName.toUpperCase() === "INPUT") {
                p.input = $this;
            } else {
                p.container = $this;
            }
            new Calendar($.extend(p, params));
        });
    };

    $.initCalendar = function(content) {
        var $content = content ? $(content) : $(document.body);
        $content.find("[data-toggle='date']").each(function() {
            $(this).calendar();
        });
    };
}(Zepto);

/*======================================================
************   Picker   ************
======================================================*/
/* jshint unused:false */
/* jshint multistr:true */
+ function($) {
    "use strict";
    var Picker = function (params) {
        var p = this;
        var defaults = {
            updateValuesOnMomentum: false,
            updateValuesOnTouchmove: true,
            rotateEffect: false,
            momentumRatio: 7,
            freeMode: false,
            // Common settings
            scrollToInput: true,
            inputReadOnly: true,
            toolbar: true,
            toolbarCloseText: '确定',
            toolbarTemplate: '<header class="bar bar-nav">\
                <button class="button button-link pull-right close-picker">确定</button>\
                <h1 class="title">请选择</h1>\
                </header>',
        };
        params = params || {};
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
        }
        p.params = params;
        p.cols = [];
        p.initialized = false;

        // Inline flag
        p.inline = p.params.container ? true : false;

        // 3D Transforms origin bug, only on safari
        var originBug = $.device.ios || (navigator.userAgent.toLowerCase().indexOf('safari') >= 0 && navigator.userAgent.toLowerCase().indexOf('chrome') < 0) && !$.device.android;

        // Value
        p.setValue = function (arrValues, transition) {
            var valueIndex = 0;
            for (var i = 0; i < p.cols.length; i++) {
                if (p.cols[i] && !p.cols[i].divider) {
                    p.cols[i].setValue(arrValues[valueIndex], transition);
                    valueIndex++;
                }
            }
        };
        p.updateValue = function () {
            var newValue = [];
            var newDisplayValue = [];
            for (var i = 0; i < p.cols.length; i++) {
                if (!p.cols[i].divider) {
                    newValue.push(p.cols[i].value);
                    newDisplayValue.push(p.cols[i].displayValue);
                }
            }
            if (newValue.indexOf(undefined) >= 0) {
                return;
            }
            p.value = newValue;
            p.displayValue = newDisplayValue;
            if (p.params.onChange) {
                p.params.onChange(p, p.value, p.displayValue);
            }
            if (p.input && p.input.length > 0) {
                $(p.input).val(p.params.formatValue ? p.params.formatValue(p, p.value, p.displayValue) : p.value.join(' '));
                $(p.input).trigger('change');
            }
        };

        // Columns Handlers
        p.initPickerCol = function (colElement, updateItems) {
            var colContainer = $(colElement);
            var colIndex = colContainer.index();
            var col = p.cols[colIndex];
            if (col.divider) return;
            col.container = colContainer;
            col.wrapper = col.container.find('.picker-items-col-wrapper');
            col.items = col.wrapper.find('.picker-item');

            var i, j;
            var wrapperHeight, itemHeight, itemsHeight, minTranslate, maxTranslate;
            col.replaceValues = function (values, displayValues) {
                col.destroyEvents();
                col.values = values;
                col.displayValues = displayValues;
                var newItemsHTML = p.columnHTML(col, true);
                col.wrapper.html(newItemsHTML);
                col.items = col.wrapper.find('.picker-item');
                col.calcSize();
                col.setValue(col.values[0], 0, true);
                col.initEvents();
            };
            col.calcSize = function () {
                if (p.params.rotateEffect) {
                    col.container.removeClass('picker-items-col-absolute');
                    if (!col.width) col.container.css({width:''});
                }
                var colWidth, colHeight;
                colWidth = 0;
                colHeight = col.container[0].offsetHeight;
                wrapperHeight = col.wrapper[0].offsetHeight;
                itemHeight = col.items[0].offsetHeight;
                itemsHeight = itemHeight * col.items.length;
                minTranslate = colHeight / 2 - itemsHeight + itemHeight / 2;
                maxTranslate = colHeight / 2 - itemHeight / 2;
                if (col.width) {
                    colWidth = col.width;
                    if (parseInt(colWidth, 10) === colWidth) colWidth = colWidth + 'px';
                    col.container.css({width: colWidth});
                }
                if (p.params.rotateEffect) {
                    if (!col.width) {
                        col.items.each(function () {
                            var item = $(this);
                            item.css({width:'auto'});
                            colWidth = Math.max(colWidth, item[0].offsetWidth);
                            item.css({width:''});
                        });
                        col.container.css({width: (colWidth + 2) + 'px'});
                    }
                    col.container.addClass('picker-items-col-absolute');
                }
            };
            col.calcSize();

            col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)').transition(0);


            var activeIndex = 0;
            var animationFrameId;

            // Set Value Function
            col.setValue = function (newValue, transition, valueCallbacks) {
                if (typeof transition === 'undefined') transition = '';
                var newActiveIndex = col.wrapper.find('.picker-item[data-picker-value="' + newValue + '"]').index();
                if(typeof newActiveIndex === 'undefined' || newActiveIndex === -1) {
                    return;
                }
                var newTranslate = -newActiveIndex * itemHeight + maxTranslate;
                // Update wrapper
                col.wrapper.transition(transition);
                col.wrapper.transform('translate3d(0,' + (newTranslate) + 'px,0)');

                // Watch items
                if (p.params.updateValuesOnMomentum && col.activeIndex && col.activeIndex !== newActiveIndex ) {
                    $.cancelAnimationFrame(animationFrameId);
                    col.wrapper.transitionEnd(function(){
                        $.cancelAnimationFrame(animationFrameId);
                    });
                    updateDuringScroll();
                }

                // Update items
                col.updateItems(newActiveIndex, newTranslate, transition, valueCallbacks);
            };

            col.updateItems = function (activeIndex, translate, transition, valueCallbacks) {
                if (typeof translate === 'undefined') {
                    translate = $.getTranslate(col.wrapper[0], 'y');
                }
                if(typeof activeIndex === 'undefined') activeIndex = -Math.round((translate - maxTranslate)/itemHeight);
                if (activeIndex < 0) activeIndex = 0;
                if (activeIndex >= col.items.length) activeIndex = col.items.length - 1;
                var previousActiveIndex = col.activeIndex;
                col.activeIndex = activeIndex;
                /*
                   col.wrapper.find('.picker-selected, .picker-after-selected, .picker-before-selected').removeClass('picker-selected picker-after-selected picker-before-selected');

                   col.items.transition(transition);
                   var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');
                   var prevItems = selectedItem.prevAll().addClass('picker-before-selected');
                   var nextItems = selectedItem.nextAll().addClass('picker-after-selected');
                   */
                //去掉 .picker-after-selected, .picker-before-selected 以提高性能
                col.wrapper.find('.picker-selected').removeClass('picker-selected');
                if (p.params.rotateEffect) {
                    col.items.transition(transition);
                }
                var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');

                if (valueCallbacks || typeof valueCallbacks === 'undefined') {
                    // Update values
                    col.value = selectedItem.attr('data-picker-value');
                    col.displayValue = col.displayValues ? col.displayValues[activeIndex] : col.value;
                    // On change callback
                    if (previousActiveIndex !== activeIndex) {
                        if (col.onChange) {
                            col.onChange(p, col.value, col.displayValue);
                        }
                        p.updateValue();
                    }
                }

                // Set 3D rotate effect
                if (!p.params.rotateEffect) {
                    return;
                }
                var percentage = (translate - (Math.floor((translate - maxTranslate)/itemHeight) * itemHeight + maxTranslate)) / itemHeight;

                col.items.each(function () {
                    var item = $(this);
                    var itemOffsetTop = item.index() * itemHeight;
                    var translateOffset = maxTranslate - translate;
                    var itemOffset = itemOffsetTop - translateOffset;
                    var percentage = itemOffset / itemHeight;

                    var itemsFit = Math.ceil(col.height / itemHeight / 2) + 1;

                    var angle = (-18*percentage);
                    if (angle > 180) angle = 180;
                    if (angle < -180) angle = -180;
                    // Far class
                    if (Math.abs(percentage) > itemsFit) item.addClass('picker-item-far');
                    else item.removeClass('picker-item-far');
                    // Set transform
                    item.transform('translate3d(0, ' + (-translate + maxTranslate) + 'px, ' + (originBug ? -110 : 0) + 'px) rotateX(' + angle + 'deg)');
                });
            };

            function updateDuringScroll() {
                animationFrameId = $.requestAnimationFrame(function () {
                    col.updateItems(undefined, undefined, 0);
                    updateDuringScroll();
                });
            }

            // Update items on init
            if (updateItems) col.updateItems(0, maxTranslate, 0);

            var allowItemClick = true;
            var isTouched, isMoved, touchStartY, touchCurrentY, touchStartTime, touchEndTime, startTranslate, returnTo, currentTranslate, prevTranslate, velocityTranslate, velocityTime;
            function handleTouchStart (e) {
                if (isMoved || isTouched) return;
                e.preventDefault();
                isTouched = true;
                touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
                touchStartTime = (new Date()).getTime();

                allowItemClick = true;
                startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
            }
            function handleTouchMove (e) {
                if (!isTouched) return;
                e.preventDefault();
                allowItemClick = false;
                touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                if (!isMoved) {
                    // First move
                    $.cancelAnimationFrame(animationFrameId);
                    isMoved = true;
                    startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
                    col.wrapper.transition(0);
                }
                e.preventDefault();

                var diff = touchCurrentY - touchStartY;
                currentTranslate = startTranslate + diff;
                returnTo = undefined;

                // Normalize translate
                if (currentTranslate < minTranslate) {
                    currentTranslate = minTranslate - Math.pow(minTranslate - currentTranslate, 0.8);
                    returnTo = 'min';
                }
                if (currentTranslate > maxTranslate) {
                    currentTranslate = maxTranslate + Math.pow(currentTranslate - maxTranslate, 0.8);
                    returnTo = 'max';
                }
                // Transform wrapper
                col.wrapper.transform('translate3d(0,' + currentTranslate + 'px,0)');

                // Update items
                col.updateItems(undefined, currentTranslate, 0, p.params.updateValuesOnTouchmove);

                // Calc velocity
                velocityTranslate = currentTranslate - prevTranslate || currentTranslate;
                velocityTime = (new Date()).getTime();
                prevTranslate = currentTranslate;
            }
            function handleTouchEnd (e) {
                if (!isTouched || !isMoved) {
                    isTouched = isMoved = false;
                    return;
                }
                isTouched = isMoved = false;
                col.wrapper.transition('');
                if (returnTo) {
                    if (returnTo === 'min') {
                        col.wrapper.transform('translate3d(0,' + minTranslate + 'px,0)');
                    }
                    else col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)');
                }
                touchEndTime = new Date().getTime();
                var velocity, newTranslate;
                if (touchEndTime - touchStartTime > 300) {
                    newTranslate = currentTranslate;
                }
                else {
                    velocity = Math.abs(velocityTranslate / (touchEndTime - velocityTime));
                    newTranslate = currentTranslate + velocityTranslate * p.params.momentumRatio;
                }

                newTranslate = Math.max(Math.min(newTranslate, maxTranslate), minTranslate);

                // Active Index
                var activeIndex = -Math.floor((newTranslate - maxTranslate)/itemHeight);

                // Normalize translate
                if (!p.params.freeMode) newTranslate = -activeIndex * itemHeight + maxTranslate;

                // Transform wrapper
                col.wrapper.transform('translate3d(0,' + (parseInt(newTranslate,10)) + 'px,0)');

                // Update items
                col.updateItems(activeIndex, newTranslate, '', true);

                // Watch items
                if (p.params.updateValuesOnMomentum) {
                    updateDuringScroll();
                    col.wrapper.transitionEnd(function(){
                        $.cancelAnimationFrame(animationFrameId);
                    });
                }

                // Allow click
                setTimeout(function () {
                    allowItemClick = true;
                }, 100);
            }

            function handleClick(e) {
                if (!allowItemClick) return;
                $.cancelAnimationFrame(animationFrameId);
                /*jshint validthis:true */
                var value = $(this).attr('data-picker-value');
                col.setValue(value);
            }

            col.initEvents = function (detach) {
                var method = detach ? 'off' : 'on';
                col.container[method]($.touchEvents.start, handleTouchStart);
                col.container[method]($.touchEvents.move, handleTouchMove);
                col.container[method]($.touchEvents.end, handleTouchEnd);
                col.items[method]('click', handleClick);
            };
            col.destroyEvents = function () {
                col.initEvents(true);
            };

            col.container[0].f7DestroyPickerCol = function () {
                col.destroyEvents();
            };

            col.initEvents();

        };
        p.destroyPickerCol = function (colContainer) {
            colContainer = $(colContainer);
            if ('f7DestroyPickerCol' in colContainer[0]) colContainer[0].f7DestroyPickerCol();
        };
        // Resize cols
        function resizeCols() {
            if (!p.opened) return;
            for (var i = 0; i < p.cols.length; i++) {
                if (!p.cols[i].divider) {
                    p.cols[i].calcSize();
                    p.cols[i].setValue(p.cols[i].value, 0, false);
                }
            }
        }
        $(window).on('resize', resizeCols);

        // HTML Layout
        p.columnHTML = function (col, onlyItems) {
            var columnItemsHTML = '';
            var columnHTML = '';
            if (col.divider) {
                columnHTML += '<div class="picker-items-col picker-items-col-divider ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '">' + col.content + '</div>';
            }
            else {
                for (var j = 0; j < col.values.length; j++) {
                    columnItemsHTML += '<div class="picker-item" data-picker-value="' + col.values[j] + '">' + (col.displayValues ? col.displayValues[j] : col.values[j]) + '</div>';
                }

                columnHTML += '<div class="picker-items-col ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '"><div class="picker-items-col-wrapper">' + columnItemsHTML + '</div></div>';
            }
            return onlyItems ? columnItemsHTML : columnHTML;
        };
        p.layout = function () {
            var pickerHTML = '';
            var pickerClass = '';
            var i;
            p.cols = [];
            var colsHTML = '';
            for (i = 0; i < p.params.cols.length; i++) {
                var col = p.params.cols[i];
                colsHTML += p.columnHTML(p.params.cols[i]);
                p.cols.push(col);
            }
            pickerClass = 'picker-modal picker-columns ' + (p.params.cssClass || '') + (p.params.rotateEffect ? ' picker-3d' : '');
            pickerHTML =
                '<div class="' + (pickerClass) + '">' +
                (p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '') +
                '<div class="picker-modal-inner picker-items">' +
                colsHTML +
                '<div class="picker-center-highlight"></div>' +
                '</div>' +
                '</div>';

            p.pickerHTML = pickerHTML;
        };

        // Input Events
        function openOnInput(e) {
            e.preventDefault();
            // 安卓微信webviewreadonly的input依然弹出软键盘问题修复
            if ($.device.isWeixin && $.device.android && p.params.inputReadOnly) {
                /*jshint validthis:true */
                this.focus();
                this.blur();
            }
            if (p.opened) return;
            //关闭其他picker
            $.closeModal($('.picker-modal'));
            p.open();
            if (p.params.scrollToInput) {
                var pageContent = p.input.parents('.content');
                if (pageContent.length === 0) return;

                var paddingTop = parseInt(pageContent.css('padding-top'), 10),
                    paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
                    pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
                    pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
                    newPaddingBottom;
                var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
                if (inputTop > pageHeight) {
                    var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
                    if (scrollTop + pageHeight > pageScrollHeight) {
                        newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
                        if (pageHeight === pageScrollHeight) {
                            newPaddingBottom = p.container.height();
                        }
                        pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
                    }
                    pageContent.scrollTop(scrollTop, 300);
                }
            }
            //停止事件冒泡，主动处理
            e.stopPropagation();
        }
        function closeOnHTMLClick(e) {
            if (!p.opened) return;
            if (p.input && p.input.length > 0) {
                if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
            }
            else {
                if ($(e.target).parents('.picker-modal').length === 0) p.close();
            }
        }

        if (p.params.input) {
            p.input = $(p.params.input);
            if (p.input.length > 0) {
                if (p.params.inputReadOnly) p.input.prop('readOnly', true);
                if (!p.inline) {
                    p.input.on('click', openOnInput);
                }
            }
        }

        if (!p.inline) $('html').on('click', closeOnHTMLClick);

        // Open
        function onPickerClose() {
            p.opened = false;
            if (p.input && p.input.length > 0) p.input.parents('.content').css({'padding-bottom': ''});
            if (p.params.onClose) p.params.onClose(p);

            // Destroy events
            p.container.find('.picker-items-col').each(function () {
                p.destroyPickerCol(this);
            });
        }

        p.opened = false;
        p.open = function () {

            if (!p.opened) {

                // Layout
                p.layout();
                p.opened = true;
                // Append
                if (p.inline) {
                    p.container = $(p.pickerHTML);
                    p.container.addClass('picker-modal-inline');
                    $(p.params.container).append(p.container);

                }
                else {

                    p.container = $($.pickerModal(p.pickerHTML));

                    $(p.container)
                        .on('close', function () {
                            onPickerClose();
                        });
                }

                // Store picker instance
                p.container[0].f7Picker = p;

                // Init Events
                p.container.find('.picker-items-col').each(function () {
                    var updateItems = true;
                    if ((!p.initialized && p.params.value) || (p.initialized && p.value)) updateItems = false;
                    p.initPickerCol(this, updateItems);
                });

                // Set value
                if (!p.initialized) {
                    if (p.params.value) {
                        p.setValue(p.params.value, 0);
                    }
                }
                else {
                    if (p.value) p.setValue(p.value, 0);
                }
            }

            // Set flag
            p.initialized = true;

            if (p.params.onOpen) p.params.onOpen(p);
        };

        // Close
        p.close = function () {
            if (!p.opened || p.inline) return;
            $.closeModal(p.container);
            return;
        };

        // Destroy
        p.destroy = function () {
            p.close();
            if (p.params.input && p.input.length > 0) {
                p.input.off('click', openOnInput);
            }
            $('html').off('click', closeOnHTMLClick);
            $(window).off('resize', resizeCols);
        };

        if (p.inline) {
            p.open();
        }

        return p;
    };

    $(document).on("click", ".close-picker", function() {
        var pickerToClose = $('.picker-modal.modal-in');
        $.closeModal(pickerToClose);
    });

    $.fn.picker = function(params) {
        var args = arguments;
        return this.each(function() {
            if(!this) return;
            var $this = $(this);

            var picker = $this.data("picker");
            if(!picker) {
                var p = $.extend({
                    input: this,
                    value: $this.val() ? $this.val().split(' ') : ''
                }, params);
                picker = new Picker(p);
                $this.data("picker", picker);
            }
            if(typeof params === typeof "a") {
                picker[params].apply(picker, Array.prototype.slice.call(args, 1));
            }
        });
    };
}(Zepto);

/* jshint unused:false*/

+ function($) {
    "use strict";

    var today = new Date();

    var getDays = function(max) {
        var days = [];
        for(var i=1; i<= (max||31);i++) {
            days.push(i < 10 ? "0"+i : i);
        }
        return days;
    };

    var getDaysByMonthAndYear = function(month, year) {
        var int_d = new Date(year, parseInt(month)+1-1, 1);
        var d = new Date(int_d - 1);
        return getDays(d.getDate());
    };

    var formatNumber = function (n) {
        return n < 10 ? "0" + n : n;
    };

    var initMonthes = ('01 02 03 04 05 06 07 08 09 10 11 12').split(' ');

    var initYears = (function () {
        var arr = [];
        for (var i = 1950; i <= 2030; i++) { arr.push(i); }
        return arr;
    })();


    var defaults = {

        rotateEffect: false,  //为了性能

        value: [today.getFullYear(), formatNumber(today.getMonth()+1), formatNumber(today.getDate()), today.getHours(), formatNumber(today.getMinutes())],

        onChange: function (picker, values, displayValues) {
            var days = getDaysByMonthAndYear(picker.cols[1].value, picker.cols[0].value);
            var currentValue = picker.cols[2].value;
            if(currentValue > days.length) currentValue = days.length;
            picker.cols[2].setValue(currentValue);
        },

        formatValue: function (p, values, displayValues) {
            return displayValues[0] + '-' + values[1] + '-' + values[2] + ' ' + values[3] + ':' + values[4];
        },

        cols: [
            // Years
        {
            values: initYears
        },
        // Months
        {
            values: initMonthes
        },
        // Days
        {
            values: getDays()
        },

        // Space divider
        {
            divider: true,
            content: '  '
        },
        // Hours
        {
            values: (function () {
                var arr = [];
                for (var i = 0; i <= 23; i++) { arr.push(i); }
                return arr;
            })(),
        },
        // Divider
        {
            divider: true,
            content: ':'
        },
        // Minutes
        {
            values: (function () {
                var arr = [];
                for (var i = 0; i <= 59; i++) { arr.push(i < 10 ? '0' + i : i); }
                return arr;
            })(),
        }
        ]
    };

    $.fn.datetimePicker = function(params) {
        return this.each(function() {
            if(!this) return;
            var p = $.extend(defaults, params);
            $(this).picker(p);
            if (params.value) $(this).val(p.formatValue(p, p.value, p.value));
        });
    };

}(Zepto);

+ function(window) {

    "use strict";

    var rAF = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function(callback) {
            window.setTimeout(callback, 1000 / 60);
        };
    /*var cRAF = window.cancelRequestAnimationFrame ||
        window.webkitCancelRequestAnimationFrame ||
        window.mozCancelRequestAnimationFrame ||
        window.oCancelRequestAnimationFrame ||
        window.msCancelRequestAnimationFrame;*/

    var utils = (function() {
        var me = {};

        var _elementStyle = document.createElement('div').style;
        var _vendor = (function() {
            var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                transform,
                i = 0,
                l = vendors.length;

            for (; i < l; i++) {
                transform = vendors[i] + 'ransform';
                if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
            }

            return false;
        })();

        function _prefixStyle(style) {
            if (_vendor === false) return false;
            if (_vendor === '') return style;
            return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
        }

        me.getTime = Date.now || function getTime() {
            return new Date().getTime();
        };

        me.extend = function(target, obj) {
            for (var i in obj) {  // jshint ignore:line
                    target[i] = obj[i];
            }
        };

        me.addEvent = function(el, type, fn, capture) {
            el.addEventListener(type, fn, !!capture);
        };

        me.removeEvent = function(el, type, fn, capture) {
            el.removeEventListener(type, fn, !!capture);
        };

        me.prefixPointerEvent = function(pointerEvent) {
            return window.MSPointerEvent ?
                'MSPointer' + pointerEvent.charAt(9).toUpperCase() + pointerEvent.substr(10) :
                pointerEvent;
        };

        me.momentum = function(current, start, time, lowerMargin, wrapperSize, deceleration, self) {
            var distance = current - start,
                speed = Math.abs(distance) / time,
                destination,
                duration;

            // var absDistance = Math.abs(distance);
            speed = speed / 2; //slowdown
            speed = speed > 1.5 ? 1.5 : speed; //set max speed to 1
            deceleration = deceleration === undefined ? 0.0006 : deceleration;

            destination = current + (speed * speed) / (2 * deceleration) * (distance < 0 ? -1 : 1);
            duration = speed / deceleration;

            if (destination < lowerMargin) {
                destination = wrapperSize ? lowerMargin - (wrapperSize / 2.5 * (speed / 8)) : lowerMargin;
                distance = Math.abs(destination - current);
                duration = distance / speed;
            } else if (destination > 0) {
                destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
                distance = Math.abs(current) + destination;
                duration = distance / speed;
            }

            //simple trigger, every 50ms
            var t = +new Date();
            var l = t;

            function eventTrigger() {
                if (+new Date() - l > 50) {
                    self._execEvent('scroll');
                    l = +new Date();
                }
                if (+new Date() - t < duration) {
                    rAF(eventTrigger);
                }
            }
            rAF(eventTrigger);

            return {
                destination: Math.round(destination),
                duration: duration
            };
        };

        var _transform = _prefixStyle('transform');

        me.extend(me, {
            hasTransform: _transform !== false,
            hasPerspective: _prefixStyle('perspective') in _elementStyle,
            hasTouch: 'ontouchstart' in window,
            hasPointer: window.PointerEvent || window.MSPointerEvent, // IE10 is prefixed
            hasTransition: _prefixStyle('transition') in _elementStyle
        });

        // This should find all Android browsers lower than build 535.19 (both stock browser and webview)
        me.isBadAndroid = /Android /.test(window.navigator.appVersion) && !(/Chrome\/\d/.test(window.navigator.appVersion)) && false; //this will cause many android device scroll flash; so set it to false!

        me.extend(me.style = {}, {
            transform: _transform,
            transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
            transitionDuration: _prefixStyle('transitionDuration'),
            transitionDelay: _prefixStyle('transitionDelay'),
            transformOrigin: _prefixStyle('transformOrigin')
        });

        me.hasClass = function(e, c) {
            var re = new RegExp('(^|\\s)' + c + '(\\s|$)');
            return re.test(e.className);
        };

        me.addClass = function(e, c) {
            if (me.hasClass(e, c)) {
                return;
            }

            var newclass = e.className.split(' ');
            newclass.push(c);
            e.className = newclass.join(' ');
        };

        me.removeClass = function(e, c) {
            if (!me.hasClass(e, c)) {
                return;
            }

            var re = new RegExp('(^|\\s)' + c + '(\\s|$)', 'g');
            e.className = e.className.replace(re, ' ');
        };

        me.offset = function(el) {
            var left = -el.offsetLeft,
                top = -el.offsetTop;

            // jshint -W084
            while (el = el.offsetParent) {
                left -= el.offsetLeft;
                top -= el.offsetTop;
            }
            // jshint +W084

            return {
                left: left,
                top: top
            };
        };

        me.preventDefaultException = function(el, exceptions) {
            for (var i in exceptions) {
                if (exceptions[i].test(el[i])) {
                    return true;
                }
            }

            return false;
        };

        me.extend(me.eventType = {}, {
            touchstart: 1,
            touchmove: 1,
            touchend: 1,

            mousedown: 2,
            mousemove: 2,
            mouseup: 2,

            pointerdown: 3,
            pointermove: 3,
            pointerup: 3,

            MSPointerDown: 3,
            MSPointerMove: 3,
            MSPointerUp: 3
        });

        me.extend(me.ease = {}, {
            quadratic: {
                style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                fn: function(k) {
                    return k * (2 - k);
                }
            },
            circular: {
                style: 'cubic-bezier(0.1, 0.57, 0.1, 1)', // Not properly 'circular' but this looks better, it should be (0.075, 0.82, 0.165, 1)
                fn: function(k) {
                    return Math.sqrt(1 - (--k * k));
                }
            },
            back: {
                style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                fn: function(k) {
                    var b = 4;
                    return (k = k - 1) * k * ((b + 1) * k + b) + 1;
                }
            },
            bounce: {
                style: '',
                fn: function(k) {
                    if ((k /= 1) < (1 / 2.75)) {
                        return 7.5625 * k * k;
                    } else if (k < (2 / 2.75)) {
                        return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
                    } else if (k < (2.5 / 2.75)) {
                        return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
                    } else {
                        return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
                    }
                }
            },
            elastic: {
                style: '',
                fn: function(k) {
                    var f = 0.22,
                        e = 0.4;

                    if (k === 0) {
                        return 0;
                    }
                    if (k === 1) {
                        return 1;
                    }

                    return (e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1);
                }
            }
        });

        me.tap = function(e, eventName) {
            var ev = document.createEvent('Event');
            ev.initEvent(eventName, true, true);
            ev.pageX = e.pageX;
            ev.pageY = e.pageY;
            e.target.dispatchEvent(ev);
        };

        me.click = function(e) {
            var target = e.target,
                ev;

            if (!(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName)) {
                ev = document.createEvent('MouseEvents');
                ev.initMouseEvent('click', true, true, e.view, 1,
                    target.screenX, target.screenY, target.clientX, target.clientY,
                    e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
                    0, null);

                ev._constructed = true;
                target.dispatchEvent(ev);
            }
        };

        return me;
    })();

    function IScroll(el, options) {
        this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
        this.scroller = $(this.wrapper).find('.content-inner')[0]; // jshint ignore:line


        this.scrollerStyle = this.scroller&&this.scroller.style; // cache style for better performance

        this.options = {

            resizeScrollbars: true,

            mouseWheelSpeed: 20,

            snapThreshold: 0.334,

            // INSERT POINT: OPTIONS

            startX: 0,
            startY: 0,
            scrollY: true,
            directionLockThreshold: 5,
            momentum: true,

            bounce: true,
            bounceTime: 600,
            bounceEasing: '',

            preventDefault: true,
            preventDefaultException: {
                tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/
            },

            HWCompositing: true,
            useTransition: true,
            useTransform: true,

            //other options
            eventPassthrough: undefined, //if you  want to use native scroll, you can set to: true or horizontal
        };

        for (var i in options) {
                this.options[i] = options[i];
        }

        // Normalize options
        this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

        this.options.useTransition = utils.hasTransition && this.options.useTransition;
        this.options.useTransform = utils.hasTransform && this.options.useTransform;

        this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
        this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

        // If you want eventPassthrough I have to lock one of the axes
        this.options.scrollY = this.options.eventPassthrough === 'vertical' ? false : this.options.scrollY;
        this.options.scrollX = this.options.eventPassthrough === 'horizontal' ? false : this.options.scrollX;

        // With eventPassthrough we also need lockDirection mechanism
        this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
        this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

        this.options.bounceEasing = typeof this.options.bounceEasing === 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

        this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

        if (this.options.tap === true) {
            this.options.tap = 'tap';
        }

        if (this.options.shrinkScrollbars === 'scale') {
            this.options.useTransition = false;
        }

        this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

        if (this.options.probeType === 3) {
            this.options.useTransition = false;
        }

        // INSERT POINT: NORMALIZATION

        // Some defaults
        this.x = 0;
        this.y = 0;
        this.directionX = 0;
        this.directionY = 0;
        this._events = {};

        // INSERT POINT: DEFAULTS

        this._init();
        this.refresh();

        this.scrollTo(this.options.startX, this.options.startY);
        this.enable();
    }

    IScroll.prototype = {
        version: '5.1.3',

        _init: function() {
            this._initEvents();

            if (this.options.scrollbars || this.options.indicators) {
                this._initIndicators();
            }

            if (this.options.mouseWheel) {
                this._initWheel();
            }

            if (this.options.snap) {
                this._initSnap();
            }

            if (this.options.keyBindings) {
                this._initKeys();
            }

            // INSERT POINT: _init

        },

        destroy: function() {
            this._initEvents(true);

            this._execEvent('destroy');
        },

        _transitionEnd: function(e) {
            if (e.target !== this.scroller || !this.isInTransition) {
                return;
            }

            this._transitionTime();
            if (!this.resetPosition(this.options.bounceTime)) {
                this.isInTransition = false;
                this._execEvent('scrollEnd');
            }
        },

        _start: function(e) {
            // React to left mouse button only
            if (utils.eventType[e.type] !== 1) {
                if (e.button !== 0) {
                    return;
                }
            }

            if (!this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated)) {
                return;
            }

            if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
                e.preventDefault();
            }

            var point = e.touches ? e.touches[0] : e,
                pos;

            this.initiated = utils.eventType[e.type];
            this.moved = false;
            this.distX = 0;
            this.distY = 0;
            this.directionX = 0;
            this.directionY = 0;
            this.directionLocked = 0;

            this._transitionTime();

            this.startTime = utils.getTime();

            if (this.options.useTransition && this.isInTransition) {
                this.isInTransition = false;
                pos = this.getComputedPosition();
                this._translate(Math.round(pos.x), Math.round(pos.y));
                this._execEvent('scrollEnd');
            } else if (!this.options.useTransition && this.isAnimating) {
                this.isAnimating = false;
                this._execEvent('scrollEnd');
            }

            this.startX = this.x;
            this.startY = this.y;
            this.absStartX = this.x;
            this.absStartY = this.y;
            this.pointX = point.pageX;
            this.pointY = point.pageY;

            this._execEvent('beforeScrollStart');
        },

        _move: function(e) {
            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault) { // increases performance on Android? TODO: check!
                e.preventDefault();
            }

            var point = e.touches ? e.touches[0] : e,
                deltaX = point.pageX - this.pointX,
                deltaY = point.pageY - this.pointY,
                timestamp = utils.getTime(),
                newX, newY,
                absDistX, absDistY;

            this.pointX = point.pageX;
            this.pointY = point.pageY;

            this.distX += deltaX;
            this.distY += deltaY;
            absDistX = Math.abs(this.distX);
            absDistY = Math.abs(this.distY);

            // We need to move at least 10 pixels for the scrolling to initiate
            if (timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10)) {
                return;
            }

            // If you are scrolling in one direction lock the other
            if (!this.directionLocked && !this.options.freeScroll) {
                if (absDistX > absDistY + this.options.directionLockThreshold) {
                    this.directionLocked = 'h'; // lock horizontally
                } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
                    this.directionLocked = 'v'; // lock vertically
                } else {
                    this.directionLocked = 'n'; // no lock
                }
            }

            if (this.directionLocked === 'h') {
                if (this.options.eventPassthrough === 'vertical') {
                    e.preventDefault();
                } else if (this.options.eventPassthrough === 'horizontal') {
                    this.initiated = false;
                    return;
                }

                deltaY = 0;
            } else if (this.directionLocked === 'v') {
                if (this.options.eventPassthrough === 'horizontal') {
                    e.preventDefault();
                } else if (this.options.eventPassthrough === 'vertical') {
                    this.initiated = false;
                    return;
                }

                deltaX = 0;
            }

            deltaX = this.hasHorizontalScroll ? deltaX : 0;
            deltaY = this.hasVerticalScroll ? deltaY : 0;

            newX = this.x + deltaX;
            newY = this.y + deltaY;

            // Slow down if outside of the boundaries
            if (newX > 0 || newX < this.maxScrollX) {
                newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
            }
            if (newY > 0 || newY < this.maxScrollY) {
                newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
            }

            this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
            this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

            if (!this.moved) {
                this._execEvent('scrollStart');
            }

            this.moved = true;

            this._translate(newX, newY);

            /* REPLACE START: _move */
            if (timestamp - this.startTime > 300) {
                this.startTime = timestamp;
                this.startX = this.x;
                this.startY = this.y;

                if (this.options.probeType === 1) {
                    this._execEvent('scroll');
                }
            }

            if (this.options.probeType > 1) {
                this._execEvent('scroll');
            }
            /* REPLACE END: _move */

        },

        _end: function(e) {
            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
                e.preventDefault();
            }

            var /*point = e.changedTouches ? e.changedTouches[0] : e,*/
                momentumX,
                momentumY,
                duration = utils.getTime() - this.startTime,
                newX = Math.round(this.x),
                newY = Math.round(this.y),
                distanceX = Math.abs(newX - this.startX),
                distanceY = Math.abs(newY - this.startY),
                time = 0,
                easing = '';

            this.isInTransition = 0;
            this.initiated = 0;
            this.endTime = utils.getTime();

            // reset if we are outside of the boundaries
            if (this.resetPosition(this.options.bounceTime)) {
                return;
            }

            this.scrollTo(newX, newY); // ensures that the last position is rounded

            // we scrolled less than 10 pixels
            if (!this.moved) {
                if (this.options.tap) {
                    utils.tap(e, this.options.tap);
                }

                if (this.options.click) {
                    utils.click(e);
                }

                this._execEvent('scrollCancel');
                return;
            }

            if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
                this._execEvent('flick');
                return;
            }

            // start momentum animation if needed
            if (this.options.momentum && duration < 300) {
                momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration, this) : {
                    destination: newX,
                    duration: 0
                };
                momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration, this) : {
                    destination: newY,
                    duration: 0
                };
                newX = momentumX.destination;
                newY = momentumY.destination;
                time = Math.max(momentumX.duration, momentumY.duration);
                this.isInTransition = 1;
            }


            if (this.options.snap) {
                var snap = this._nearestSnap(newX, newY);
                this.currentPage = snap;
                time = this.options.snapSpeed || Math.max(
                    Math.max(
                        Math.min(Math.abs(newX - snap.x), 1000),
                        Math.min(Math.abs(newY - snap.y), 1000)
                    ), 300);
                newX = snap.x;
                newY = snap.y;

                this.directionX = 0;
                this.directionY = 0;
                easing = this.options.bounceEasing;
            }

            // INSERT POINT: _end

            if (newX !== this.x || newY !== this.y) {
                // change easing function when scroller goes out of the boundaries
                if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
                    easing = utils.ease.quadratic;
                }

                this.scrollTo(newX, newY, time, easing);
                return;
            }

            this._execEvent('scrollEnd');
        },

        _resize: function() {
            var that = this;

            clearTimeout(this.resizeTimeout);

            this.resizeTimeout = setTimeout(function() {
                that.refresh();
            }, this.options.resizePolling);
        },

        resetPosition: function(time) {
            var x = this.x,
                y = this.y;

            time = time || 0;

            if (!this.hasHorizontalScroll || this.x > 0) {
                x = 0;
            } else if (this.x < this.maxScrollX) {
                x = this.maxScrollX;
            }

            if (!this.hasVerticalScroll || this.y > 0) {
                y = 0;
            } else if (this.y < this.maxScrollY) {
                y = this.maxScrollY;
            }

            if (x === this.x && y === this.y) {
                return false;
            }

            if (this.options.ptr && this.y > 44 && this.startY * -1 < $(window).height() && !this.ptrLock) {// jshint ignore:line
                // not trigger ptr when user want to scroll to top
                y = this.options.ptrOffset || 44;
                this._execEvent('ptr');
                // 防止返回的过程中再次触发了 ptr ，导致被定位到 44px（因为可能done事件触发很快，在返回到44px以前就触发done
                this.ptrLock = true;
                var self = this;
                setTimeout(function() {
                    self.ptrLock = false;
                }, 500);
            }

            this.scrollTo(x, y, time, this.options.bounceEasing);

            return true;
        },

        disable: function() {
            this.enabled = false;
        },

        enable: function() {
            this.enabled = true;
        },

        refresh: function() {
            // var rf = this.wrapper.offsetHeight; // Force reflow

            this.wrapperWidth = this.wrapper.clientWidth;
            this.wrapperHeight = this.wrapper.clientHeight;

            /* REPLACE START: refresh */

            this.scrollerWidth = this.scroller.offsetWidth;
            this.scrollerHeight = this.scroller.offsetHeight;

            this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
            this.maxScrollY = this.wrapperHeight - this.scrollerHeight;

            /* REPLACE END: refresh */

            this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
            this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;

            if (!this.hasHorizontalScroll) {
                this.maxScrollX = 0;
                this.scrollerWidth = this.wrapperWidth;
            }

            if (!this.hasVerticalScroll) {
                this.maxScrollY = 0;
                this.scrollerHeight = this.wrapperHeight;
            }

            this.endTime = 0;
            this.directionX = 0;
            this.directionY = 0;

            this.wrapperOffset = utils.offset(this.wrapper);

            this._execEvent('refresh');

            this.resetPosition();

            // INSERT POINT: _refresh

        },

        on: function(type, fn) {
            if (!this._events[type]) {
                this._events[type] = [];
            }

            this._events[type].push(fn);
        },

        off: function(type, fn) {
            if (!this._events[type]) {
                return;
            }

            var index = this._events[type].indexOf(fn);

            if (index > -1) {
                this._events[type].splice(index, 1);
            }
        },

        _execEvent: function(type) {
            if (!this._events[type]) {
                return;
            }

            var i = 0,
                l = this._events[type].length;

            if (!l) {
                return;
            }

            for (; i < l; i++) {
                this._events[type][i].apply(this, [].slice.call(arguments, 1));
            }
        },

        scrollBy: function(x, y, time, easing) {
            x = this.x + x;
            y = this.y + y;
            time = time || 0;

            this.scrollTo(x, y, time, easing);
        },

        scrollTo: function(x, y, time, easing) {
            easing = easing || utils.ease.circular;

            this.isInTransition = this.options.useTransition && time > 0;

            if (!time || (this.options.useTransition && easing.style)) {
                this._transitionTimingFunction(easing.style);
                this._transitionTime(time);
                this._translate(x, y);
            } else {
                this._animate(x, y, time, easing.fn);
            }
        },

        scrollToElement: function(el, time, offsetX, offsetY, easing) {
            el = el.nodeType ? el : this.scroller.querySelector(el);

            if (!el) {
                return;
            }

            var pos = utils.offset(el);

            pos.left -= this.wrapperOffset.left;
            pos.top -= this.wrapperOffset.top;

            // if offsetX/Y are true we center the element to the screen
            if (offsetX === true) {
                offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
            }
            if (offsetY === true) {
                offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
            }

            pos.left -= offsetX || 0;
            pos.top -= offsetY || 0;

            pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
            pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

            time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;

            this.scrollTo(pos.left, pos.top, time, easing);
        },

        _transitionTime: function(time) {
            time = time || 0;

            this.scrollerStyle[utils.style.transitionDuration] = time + 'ms';

            if (!time && utils.isBadAndroid) {
                this.scrollerStyle[utils.style.transitionDuration] = '0.001s';
            }


            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].transitionTime(time);
                }
            }


            // INSERT POINT: _transitionTime

        },

        _transitionTimingFunction: function(easing) {
            this.scrollerStyle[utils.style.transitionTimingFunction] = easing;


            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].transitionTimingFunction(easing);
                }
            }


            // INSERT POINT: _transitionTimingFunction

        },

        _translate: function(x, y) {
            if (this.options.useTransform) {

                /* REPLACE START: _translate */

                this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

                /* REPLACE END: _translate */

            } else {
                x = Math.round(x);
                y = Math.round(y);
                this.scrollerStyle.left = x + 'px';
                this.scrollerStyle.top = y + 'px';
            }

            this.x = x;
            this.y = y;


            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].updatePosition();
                }
            }


            // INSERT POINT: _translate

        },

        _initEvents: function(remove) {
            var eventType = remove ? utils.removeEvent : utils.addEvent,
                target = this.options.bindToWrapper ? this.wrapper : window;

            eventType(window, 'orientationchange', this);
            eventType(window, 'resize', this);

            if (this.options.click) {
                eventType(this.wrapper, 'click', this, true);
            }

            if (!this.options.disableMouse) {
                eventType(this.wrapper, 'mousedown', this);
                eventType(target, 'mousemove', this);
                eventType(target, 'mousecancel', this);
                eventType(target, 'mouseup', this);
            }

            if (utils.hasPointer && !this.options.disablePointer) {
                eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
                eventType(target, utils.prefixPointerEvent('pointermove'), this);
                eventType(target, utils.prefixPointerEvent('pointercancel'), this);
                eventType(target, utils.prefixPointerEvent('pointerup'), this);
            }

            if (utils.hasTouch && !this.options.disableTouch) {
                eventType(this.wrapper, 'touchstart', this);
                eventType(target, 'touchmove', this);
                eventType(target, 'touchcancel', this);
                eventType(target, 'touchend', this);
            }

            eventType(this.scroller, 'transitionend', this);
            eventType(this.scroller, 'webkitTransitionEnd', this);
            eventType(this.scroller, 'oTransitionEnd', this);
            eventType(this.scroller, 'MSTransitionEnd', this);
        },

        getComputedPosition: function() {
            var matrix = window.getComputedStyle(this.scroller, null),
                x, y;

            if (this.options.useTransform) {
                matrix = matrix[utils.style.transform].split(')')[0].split(', ');
                x = +(matrix[12] || matrix[4]);
                y = +(matrix[13] || matrix[5]);
            } else {
                x = +matrix.left.replace(/[^-\d.]/g, '');
                y = +matrix.top.replace(/[^-\d.]/g, '');
            }

            return {
                x: x,
                y: y
            };
        },

        _initIndicators: function() {
            var interactive = this.options.interactiveScrollbars,
                customStyle = typeof this.options.scrollbars !== 'string',
                indicators = [],
                indicator;

            var that = this;

            this.indicators = [];

            if (this.options.scrollbars) {
                // Vertical scrollbar
                if (this.options.scrollY) {
                    indicator = {
                        el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenX: false
                    };

                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }

                // Horizontal scrollbar
                if (this.options.scrollX) {
                    indicator = {
                        el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenY: false
                    };

                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }
            }

            if (this.options.indicators) {
                // TODO: check concat compatibility
                indicators = indicators.concat(this.options.indicators);
            }

            for (var i = indicators.length; i--;) {
                this.indicators.push(new Indicator(this, indicators[i]));
            }

            // TODO: check if we can use array.map (wide compatibility and performance issues)
            function _indicatorsMap(fn) {
                for (var i = that.indicators.length; i--;) {
                    fn.call(that.indicators[i]);
                }
            }

            if (this.options.fadeScrollbars) {
                this.on('scrollEnd', function() {
                    _indicatorsMap(function() {
                        this.fade();
                    });
                });

                this.on('scrollCancel', function() {
                    _indicatorsMap(function() {
                        this.fade();
                    });
                });

                this.on('scrollStart', function() {
                    _indicatorsMap(function() {
                        this.fade(1);
                    });
                });

                this.on('beforeScrollStart', function() {
                    _indicatorsMap(function() {
                        this.fade(1, true);
                    });
                });
            }


            this.on('refresh', function() {
                _indicatorsMap(function() {
                    this.refresh();
                });
            });

            this.on('destroy', function() {
                _indicatorsMap(function() {
                    this.destroy();
                });

                delete this.indicators;
            });
        },

        _initWheel: function() {
            utils.addEvent(this.wrapper, 'wheel', this);
            utils.addEvent(this.wrapper, 'mousewheel', this);
            utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

            this.on('destroy', function() {
                utils.removeEvent(this.wrapper, 'wheel', this);
                utils.removeEvent(this.wrapper, 'mousewheel', this);
                utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
            });
        },

        _wheel: function(e) {
            if (!this.enabled) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            var wheelDeltaX, wheelDeltaY,
                newX, newY,
                that = this;

            if (this.wheelTimeout === undefined) {
                that._execEvent('scrollStart');
            }

            // Execute the scrollEnd event after 400ms the wheel stopped scrolling
            clearTimeout(this.wheelTimeout);
            this.wheelTimeout = setTimeout(function() {
                that._execEvent('scrollEnd');
                that.wheelTimeout = undefined;
            }, 400);

            if ('deltaX' in e) {
                if (e.deltaMode === 1) {
                    wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
                    wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
                } else {
                    wheelDeltaX = -e.deltaX;
                    wheelDeltaY = -e.deltaY;
                }
            } else if ('wheelDeltaX' in e) {
                wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
                wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
            } else if ('wheelDelta' in e) {
                wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
            } else if ('detail' in e) {
                wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
            } else {
                return;
            }

            wheelDeltaX *= this.options.invertWheelDirection;
            wheelDeltaY *= this.options.invertWheelDirection;

            if (!this.hasVerticalScroll) {
                wheelDeltaX = wheelDeltaY;
                wheelDeltaY = 0;
            }

            if (this.options.snap) {
                newX = this.currentPage.pageX;
                newY = this.currentPage.pageY;

                if (wheelDeltaX > 0) {
                    newX--;
                } else if (wheelDeltaX < 0) {
                    newX++;
                }

                if (wheelDeltaY > 0) {
                    newY--;
                } else if (wheelDeltaY < 0) {
                    newY++;
                }

                this.goToPage(newX, newY);

                return;
            }

            newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
            newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

            if (newX > 0) {
                newX = 0;
            } else if (newX < this.maxScrollX) {
                newX = this.maxScrollX;
            }

            if (newY > 0) {
                newY = 0;
            } else if (newY < this.maxScrollY) {
                newY = this.maxScrollY;
            }

            this.scrollTo(newX, newY, 0);

            this._execEvent('scroll');

            // INSERT POINT: _wheel
        },

        _initSnap: function() {
            this.currentPage = {};

            if (typeof this.options.snap === 'string') {
                this.options.snap = this.scroller.querySelectorAll(this.options.snap);
            }

            this.on('refresh', function() {
                var i = 0,
                    l,
                    m = 0,
                    n,
                    cx, cy,
                    x = 0,
                    y,
                    stepX = this.options.snapStepX || this.wrapperWidth,
                    stepY = this.options.snapStepY || this.wrapperHeight,
                    el;

                this.pages = [];

                if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
                    return;
                }

                if (this.options.snap === true) {
                    cx = Math.round(stepX / 2);
                    cy = Math.round(stepY / 2);

                    while (x > -this.scrollerWidth) {
                        this.pages[i] = [];
                        l = 0;
                        y = 0;

                        while (y > -this.scrollerHeight) {
                            this.pages[i][l] = {
                                x: Math.max(x, this.maxScrollX),
                                y: Math.max(y, this.maxScrollY),
                                width: stepX,
                                height: stepY,
                                cx: x - cx,
                                cy: y - cy
                            };

                            y -= stepY;
                            l++;
                        }

                        x -= stepX;
                        i++;
                    }
                } else {
                    el = this.options.snap;
                    l = el.length;
                    n = -1;

                    for (; i < l; i++) {
                        if (i === 0 || el[i].offsetLeft <= el[i - 1].offsetLeft) {
                            m = 0;
                            n++;
                        }

                        if (!this.pages[m]) {
                            this.pages[m] = [];
                        }

                        x = Math.max(-el[i].offsetLeft, this.maxScrollX);
                        y = Math.max(-el[i].offsetTop, this.maxScrollY);
                        cx = x - Math.round(el[i].offsetWidth / 2);
                        cy = y - Math.round(el[i].offsetHeight / 2);

                        this.pages[m][n] = {
                            x: x,
                            y: y,
                            width: el[i].offsetWidth,
                            height: el[i].offsetHeight,
                            cx: cx,
                            cy: cy
                        };

                        if (x > this.maxScrollX) {
                            m++;
                        }
                    }
                }

                this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

                // Update snap threshold if needed
                if (this.options.snapThreshold % 1 === 0) {
                    this.snapThresholdX = this.options.snapThreshold;
                    this.snapThresholdY = this.options.snapThreshold;
                } else {
                    this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
                    this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
                }
            });

            this.on('flick', function() {
                var time = this.options.snapSpeed || Math.max(
                    Math.max(
                        Math.min(Math.abs(this.x - this.startX), 1000),
                        Math.min(Math.abs(this.y - this.startY), 1000)
                    ), 300);

                this.goToPage(
                    this.currentPage.pageX + this.directionX,
                    this.currentPage.pageY + this.directionY,
                    time
                );
            });
        },

        _nearestSnap: function(x, y) {
            if (!this.pages.length) {
                return {
                    x: 0,
                    y: 0,
                    pageX: 0,
                    pageY: 0
                };
            }

            var i = 0,
                l = this.pages.length,
                m = 0;

            // Check if we exceeded the snap threshold
            if (Math.abs(x - this.absStartX) < this.snapThresholdX &&
                Math.abs(y - this.absStartY) < this.snapThresholdY) {
                return this.currentPage;
            }

            if (x > 0) {
                x = 0;
            } else if (x < this.maxScrollX) {
                x = this.maxScrollX;
            }

            if (y > 0) {
                y = 0;
            } else if (y < this.maxScrollY) {
                y = this.maxScrollY;
            }

            for (; i < l; i++) {
                if (x >= this.pages[i][0].cx) {
                    x = this.pages[i][0].x;
                    break;
                }
            }

            l = this.pages[i].length;

            for (; m < l; m++) {
                if (y >= this.pages[0][m].cy) {
                    y = this.pages[0][m].y;
                    break;
                }
            }

            if (i === this.currentPage.pageX) {
                i += this.directionX;

                if (i < 0) {
                    i = 0;
                } else if (i >= this.pages.length) {
                    i = this.pages.length - 1;
                }

                x = this.pages[i][0].x;
            }

            if (m === this.currentPage.pageY) {
                m += this.directionY;

                if (m < 0) {
                    m = 0;
                } else if (m >= this.pages[0].length) {
                    m = this.pages[0].length - 1;
                }

                y = this.pages[0][m].y;
            }

            return {
                x: x,
                y: y,
                pageX: i,
                pageY: m
            };
        },

        goToPage: function(x, y, time, easing) {
            easing = easing || this.options.bounceEasing;

            if (x >= this.pages.length) {
                x = this.pages.length - 1;
            } else if (x < 0) {
                x = 0;
            }

            if (y >= this.pages[x].length) {
                y = this.pages[x].length - 1;
            } else if (y < 0) {
                y = 0;
            }

            var posX = this.pages[x][y].x,
                posY = this.pages[x][y].y;

            time = time === undefined ? this.options.snapSpeed || Math.max(
                Math.max(
                    Math.min(Math.abs(posX - this.x), 1000),
                    Math.min(Math.abs(posY - this.y), 1000)
                ), 300) : time;

            this.currentPage = {
                x: posX,
                y: posY,
                pageX: x,
                pageY: y
            };

            this.scrollTo(posX, posY, time, easing);
        },

        next: function(time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;

            x++;

            if (x >= this.pages.length && this.hasVerticalScroll) {
                x = 0;
                y++;
            }

            this.goToPage(x, y, time, easing);
        },

        prev: function(time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;

            x--;

            if (x < 0 && this.hasVerticalScroll) {
                x = 0;
                y--;
            }

            this.goToPage(x, y, time, easing);
        },

        _initKeys: function() {
            // default key bindings
            var keys = {
                pageUp: 33,
                pageDown: 34,
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40
            };
            var i;

            // if you give me characters I give you keycode
            if (typeof this.options.keyBindings === 'object') {
                for (i in this.options.keyBindings) {
                    if (typeof this.options.keyBindings[i] === 'string') {
                        this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
                    }
                }
            } else {
                this.options.keyBindings = {};
            }

            for (i in keys) { // jshint ignore:line
                    this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
            }

            utils.addEvent(window, 'keydown', this);

            this.on('destroy', function() {
                utils.removeEvent(window, 'keydown', this);
            });
        },

        _key: function(e) {
            if (!this.enabled) {
                return;
            }

            var snap = this.options.snap, // we are using this alot, better to cache it
                newX = snap ? this.currentPage.pageX : this.x,
                newY = snap ? this.currentPage.pageY : this.y,
                now = utils.getTime(),
                prevTime = this.keyTime || 0,
                acceleration = 0.250,
                pos;

            if (this.options.useTransition && this.isInTransition) {
                pos = this.getComputedPosition();

                this._translate(Math.round(pos.x), Math.round(pos.y));
                this.isInTransition = false;
            }

            this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

            switch (e.keyCode) {
                case this.options.keyBindings.pageUp:
                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
                        newX += snap ? 1 : this.wrapperWidth;
                    } else {
                        newY += snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.pageDown:
                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
                        newX -= snap ? 1 : this.wrapperWidth;
                    } else {
                        newY -= snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.end:
                    newX = snap ? this.pages.length - 1 : this.maxScrollX;
                    newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
                    break;
                case this.options.keyBindings.home:
                    newX = 0;
                    newY = 0;
                    break;
                case this.options.keyBindings.left:
                    newX += snap ? -1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
                    break;
                case this.options.keyBindings.up:
                    newY += snap ? 1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
                    break;
                case this.options.keyBindings.right:
                    newX -= snap ? -1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
                    break;
                case this.options.keyBindings.down:
                    newY -= snap ? 1 : 5 + this.keyAcceleration >> 0; // jshint ignore:line
                    break;
                default:
                    return;
            }

            if (snap) {
                this.goToPage(newX, newY);
                return;
            }

            if (newX > 0) {
                newX = 0;
                this.keyAcceleration = 0;
            } else if (newX < this.maxScrollX) {
                newX = this.maxScrollX;
                this.keyAcceleration = 0;
            }

            if (newY > 0) {
                newY = 0;
                this.keyAcceleration = 0;
            } else if (newY < this.maxScrollY) {
                newY = this.maxScrollY;
                this.keyAcceleration = 0;
            }

            this.scrollTo(newX, newY, 0);

            this.keyTime = now;
        },

        _animate: function(destX, destY, duration, easingFn) {
            var that = this,
                startX = this.x,
                startY = this.y,
                startTime = utils.getTime(),
                destTime = startTime + duration;

            function step() {
                var now = utils.getTime(),
                    newX, newY,
                    easing;

                if (now >= destTime) {
                    that.isAnimating = false;
                    that._translate(destX, destY);

                    if (!that.resetPosition(that.options.bounceTime)) {
                        that._execEvent('scrollEnd');
                    }

                    return;
                }

                now = (now - startTime) / duration;
                easing = easingFn(now);
                newX = (destX - startX) * easing + startX;
                newY = (destY - startY) * easing + startY;
                that._translate(newX, newY);

                if (that.isAnimating) {
                    rAF(step);
                }

                if (that.options.probeType === 3) {
                    that._execEvent('scroll');
                }
            }

            this.isAnimating = true;
            step();
        },

        handleEvent: function(e) {
            switch (e.type) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
                case 'orientationchange':
                case 'resize':
                    this._resize();
                    break;
                case 'transitionend':
                case 'webkitTransitionEnd':
                case 'oTransitionEnd':
                case 'MSTransitionEnd':
                    this._transitionEnd(e);
                    break;
                case 'wheel':
                case 'DOMMouseScroll':
                case 'mousewheel':
                    this._wheel(e);
                    break;
                case 'keydown':
                    this._key(e);
                    break;
                case 'click':
                    if (!e._constructed) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    break;
            }
        }
    };

    function createDefaultScrollbar(direction, interactive, type) {
        var scrollbar = document.createElement('div'),
            indicator = document.createElement('div');

        if (type === true) {
            scrollbar.style.cssText = 'position:absolute;z-index:9999';
            indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
        }

        indicator.className = 'iScrollIndicator';

        if (direction === 'h') {
            if (type === true) {
                scrollbar.style.cssText += ';height:5px;left:2px;right:2px;bottom:0';
                indicator.style.height = '100%';
            }
            scrollbar.className = 'iScrollHorizontalScrollbar';
        } else {
            if (type === true) {
                scrollbar.style.cssText += ';width:5px;bottom:2px;top:2px;right:1px';
                indicator.style.width = '100%';
            }
            scrollbar.className = 'iScrollVerticalScrollbar';
        }

        scrollbar.style.cssText += ';overflow:hidden';

        if (!interactive) {
            scrollbar.style.pointerEvents = 'none';
        }

        scrollbar.appendChild(indicator);

        return scrollbar;
    }

    function Indicator(scroller, options) {
        this.wrapper = typeof options.el === 'string' ? document.querySelector(options.el) : options.el;
        this.wrapperStyle = this.wrapper.style;
        this.indicator = this.wrapper.children[0];
        this.indicatorStyle = this.indicator.style;
        this.scroller = scroller;

        this.options = {
            listenX: true,
            listenY: true,
            interactive: false,
            resize: true,
            defaultScrollbars: false,
            shrink: false,
            fade: false,
            speedRatioX: 0,
            speedRatioY: 0
        };

        for (var i in options) { // jshint ignore:line
                this.options[i] = options[i];

        }

        this.sizeRatioX = 1;
        this.sizeRatioY = 1;
        this.maxPosX = 0;
        this.maxPosY = 0;

        if (this.options.interactive) {
            if (!this.options.disableTouch) {
                utils.addEvent(this.indicator, 'touchstart', this);
                utils.addEvent(window, 'touchend', this);
            }
            if (!this.options.disablePointer) {
                utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
            }
            if (!this.options.disableMouse) {
                utils.addEvent(this.indicator, 'mousedown', this);
                utils.addEvent(window, 'mouseup', this);
            }
        }

        if (this.options.fade) {
            this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
            this.wrapperStyle[utils.style.transitionDuration] = utils.isBadAndroid ? '0.001s' : '0ms';
            this.wrapperStyle.opacity = '0';
        }
    }

    Indicator.prototype = {
        handleEvent: function(e) {
            switch (e.type) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
            }
        },

        destroy: function() {
            if (this.options.interactive) {
                utils.removeEvent(this.indicator, 'touchstart', this);
                utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.removeEvent(this.indicator, 'mousedown', this);

                utils.removeEvent(window, 'touchmove', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
                utils.removeEvent(window, 'mousemove', this);

                utils.removeEvent(window, 'touchend', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
                utils.removeEvent(window, 'mouseup', this);
            }

            if (this.options.defaultScrollbars) {
                this.wrapper.parentNode.removeChild(this.wrapper);
            }
        },

        _start: function(e) {
            var point = e.touches ? e.touches[0] : e;

            e.preventDefault();
            e.stopPropagation();

            this.transitionTime();

            this.initiated = true;
            this.moved = false;
            this.lastPointX = point.pageX;
            this.lastPointY = point.pageY;

            this.startTime = utils.getTime();

            if (!this.options.disableTouch) {
                utils.addEvent(window, 'touchmove', this);
            }
            if (!this.options.disablePointer) {
                utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
            }
            if (!this.options.disableMouse) {
                utils.addEvent(window, 'mousemove', this);
            }

            this.scroller._execEvent('beforeScrollStart');
        },

        _move: function(e) {
            var point = e.touches ? e.touches[0] : e,
                deltaX, deltaY,
                newX, newY,
                timestamp = utils.getTime();

            if (!this.moved) {
                this.scroller._execEvent('scrollStart');
            }

            this.moved = true;

            deltaX = point.pageX - this.lastPointX;
            this.lastPointX = point.pageX;

            deltaY = point.pageY - this.lastPointY;
            this.lastPointY = point.pageY;

            newX = this.x + deltaX;
            newY = this.y + deltaY;

            this._pos(newX, newY);


            if (this.scroller.options.probeType === 1 && timestamp - this.startTime > 300) {
                this.startTime = timestamp;
                this.scroller._execEvent('scroll');
            } else if (this.scroller.options.probeType > 1) {
                this.scroller._execEvent('scroll');
            }


            // INSERT POINT: indicator._move

            e.preventDefault();
            e.stopPropagation();
        },

        _end: function(e) {
            if (!this.initiated) {
                return;
            }

            this.initiated = false;

            e.preventDefault();
            e.stopPropagation();

            utils.removeEvent(window, 'touchmove', this);
            utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
            utils.removeEvent(window, 'mousemove', this);

            if (this.scroller.options.snap) {
                var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

                var time = this.options.snapSpeed || Math.max(
                    Math.max(
                        Math.min(Math.abs(this.scroller.x - snap.x), 1000),
                        Math.min(Math.abs(this.scroller.y - snap.y), 1000)
                    ), 300);

                if (this.scroller.x !== snap.x || this.scroller.y !== snap.y) {
                    this.scroller.directionX = 0;
                    this.scroller.directionY = 0;
                    this.scroller.currentPage = snap;
                    this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
                }
            }

            if (this.moved) {
                this.scroller._execEvent('scrollEnd');
            }
        },

        transitionTime: function(time) {
            time = time || 0;
            this.indicatorStyle[utils.style.transitionDuration] = time + 'ms';

            if (!time && utils.isBadAndroid) {
                this.indicatorStyle[utils.style.transitionDuration] = '0.001s';
            }
        },

        transitionTimingFunction: function(easing) {
            this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
        },

        refresh: function() {
            this.transitionTime();

            if (this.options.listenX && !this.options.listenY) {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
            } else if (this.options.listenY && !this.options.listenX) {
                this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
            } else {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
            }

            if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
                utils.addClass(this.wrapper, 'iScrollBothScrollbars');
                utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

                if (this.options.defaultScrollbars && this.options.customStyle) {
                    if (this.options.listenX) {
                        this.wrapper.style.right = '8px';
                    } else {
                        this.wrapper.style.bottom = '8px';
                    }
                }
            } else {
                utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
                utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

                if (this.options.defaultScrollbars && this.options.customStyle) {
                    if (this.options.listenX) {
                        this.wrapper.style.right = '2px';
                    } else {
                        this.wrapper.style.bottom = '2px';
                    }
                }
            }

            // var r = this.wrapper.offsetHeight; // force refresh

            if (this.options.listenX) {
                this.wrapperWidth = this.wrapper.clientWidth;
                if (this.options.resize) {
                    this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
                    this.indicatorStyle.width = this.indicatorWidth + 'px';
                } else {
                    this.indicatorWidth = this.indicator.clientWidth;
                }

                this.maxPosX = this.wrapperWidth - this.indicatorWidth;

                if (this.options.shrink === 'clip') {
                    this.minBoundaryX = -this.indicatorWidth + 8;
                    this.maxBoundaryX = this.wrapperWidth - 8;
                } else {
                    this.minBoundaryX = 0;
                    this.maxBoundaryX = this.maxPosX;
                }

                this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
            }

            if (this.options.listenY) {
                this.wrapperHeight = this.wrapper.clientHeight;
                if (this.options.resize) {
                    this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
                    this.indicatorStyle.height = this.indicatorHeight + 'px';
                } else {
                    this.indicatorHeight = this.indicator.clientHeight;
                }

                this.maxPosY = this.wrapperHeight - this.indicatorHeight;

                if (this.options.shrink === 'clip') {
                    this.minBoundaryY = -this.indicatorHeight + 8;
                    this.maxBoundaryY = this.wrapperHeight - 8;
                } else {
                    this.minBoundaryY = 0;
                    this.maxBoundaryY = this.maxPosY;
                }

                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
                this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
            }

            this.updatePosition();
        },

        updatePosition: function() {
            var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
                y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

            if (!this.options.ignoreBoundaries) {
                if (x < this.minBoundaryX) {
                    if (this.options.shrink === 'scale') {
                        this.width = Math.max(this.indicatorWidth + x, 8);
                        this.indicatorStyle.width = this.width + 'px';
                    }
                    x = this.minBoundaryX;
                } else if (x > this.maxBoundaryX) {
                    if (this.options.shrink === 'scale') {
                        this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
                        this.indicatorStyle.width = this.width + 'px';
                        x = this.maxPosX + this.indicatorWidth - this.width;
                    } else {
                        x = this.maxBoundaryX;
                    }
                } else if (this.options.shrink === 'scale' && this.width !== this.indicatorWidth) {
                    this.width = this.indicatorWidth;
                    this.indicatorStyle.width = this.width + 'px';
                }

                if (y < this.minBoundaryY) {
                    if (this.options.shrink === 'scale') {
                        this.height = Math.max(this.indicatorHeight + y * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                    }
                    y = this.minBoundaryY;
                } else if (y > this.maxBoundaryY) {
                    if (this.options.shrink === 'scale') {
                        this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                        y = this.maxPosY + this.indicatorHeight - this.height;
                    } else {
                        y = this.maxBoundaryY;
                    }
                } else if (this.options.shrink === 'scale' && this.height !== this.indicatorHeight) {
                    this.height = this.indicatorHeight;
                    this.indicatorStyle.height = this.height + 'px';
                }
            }

            this.x = x;
            this.y = y;

            if (this.scroller.options.useTransform) {
                this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
            } else {
                this.indicatorStyle.left = x + 'px';
                this.indicatorStyle.top = y + 'px';
            }
        },

        _pos: function(x, y) {
            if (x < 0) {
                x = 0;
            } else if (x > this.maxPosX) {
                x = this.maxPosX;
            }

            if (y < 0) {
                y = 0;
            } else if (y > this.maxPosY) {
                y = this.maxPosY;
            }

            x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
            y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

            this.scroller.scrollTo(x, y);
        },

        fade: function(val, hold) {
            if (hold && !this.visible) {
                return;
            }

            clearTimeout(this.fadeTimeout);
            this.fadeTimeout = null;

            var time = val ? 250 : 500,
                delay = val ? 0 : 300;

            val = val ? '1' : '0';

            this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

            this.fadeTimeout = setTimeout((function(val) {
                this.wrapperStyle.opacity = val;
                this.visible = +val;
            }).bind(this, val), delay);
        }
    };

    IScroll.utils = utils;

    window.IScroll = IScroll;
}(window);

/* ===============================================================================
************   scroller   ************
=============================================================================== */
+ function($) {
    "use strict";
    //重置zepto自带的滚动条
    var _zeptoMethodCache = {
        "scrollTop": $.fn.scrollTop,
        "scrollLeft": $.fn.scrollLeft
    };
    //重置scrollLeft和scrollRight
    (function() {
        $.extend($.fn, {
            scrollTop: function(top, dur) {
                if (!this.length) return;
                var scroller = this.data('scroller');
                if (scroller && scroller.scroller) { //js滚动
                    return scroller.scrollTop(top, dur);
                } else {
                    return _zeptoMethodCache.scrollTop.apply(this, arguments);
                }
            }
        });
        $.extend($.fn, {
            scrollLeft: function(left, dur) {
                if (!this.length) return;
                var scroller = this.data('scroller');
                if (scroller && scroller.scroller) { //js滚动
                    return scroller.scrollLeft(left, dur);
                } else {
                    return _zeptoMethodCache.scrollLeft.apply(this, arguments);
                }
            }
        });
    })();



    //自定义的滚动条
    var Scroller = function(pageContent, _options) {
        var $pageContent = this.$pageContent = $(pageContent);

        this.options = $.extend({}, this._defaults, _options);

        var type = this.options.type;
        //auto的type,系统版本的小于4.4.0的安卓设备和系统版本小于6.0.0的ios设备，启用js版的iscoll
        var useJSScroller = (type === 'js') || (type === 'auto' && ($.device.android && $.compareVersion('4.4.0', $.device.osVersion) > -1) || (type === 'auto' && ($.device.ios && $.compareVersion('6.0.0', $.device.osVersion) > -1)));

        if (useJSScroller) {

            var $pageContentInner = $pageContent.find('.content-inner');
            //如果滚动内容没有被包裹，自动添加wrap
            if (!$pageContentInner[0]) {
                // $pageContent.html('<div class="content-inner">' + $pageContent.html() + '</div>');
                var children = $pageContent.children();
                if (children.length < 1) {
                    $pageContent.children().wrapAll('<div class="content-inner"></div>');
                } else {
                    $pageContent.html('<div class="content-inner">' + $pageContent.html() + '</div>');
                }
            }

            if ($pageContent.hasClass('pull-to-refresh-content')) {
                //因为iscroll 当页面高度不足 100% 时无法滑动，所以无法触发下拉动作，这里改动一下高度
                //区分是否有.bar容器，如有，则content的top:0，无则content的top:-2.2rem,这里取2.2rem的最大值，近60
                var minHeight = $(window).height() + ($pageContent.prev().hasClass(".bar") ? 1 : 61);
                $pageContent.find('.content-inner').css('min-height', minHeight + 'px');
            }

            var ptr = $(pageContent).hasClass('pull-to-refresh-content');
            //js滚动模式，用transform移动内容区位置，会导致fixed失效，表现类似absolute。因此禁用transform模式
            var useTransform = $pageContent.find('.fixed-tab').length === 0;
            var options = {
                probeType: 1,
                mouseWheel: true,
                //解决安卓js模式下，刷新滚动条后绑定的事件不响应，对chrome内核浏览器设置click:true
                click: $.device.androidChrome,
                useTransform: useTransform,
                //js模式下允许滚动条横向滚动，但是需要注意，滚动容易宽度必须大于屏幕宽度滚动才生效
                scrollX: true
            };
            if (ptr) {
                options.ptr = true;
                options.ptrOffset = 44;
            }
            //如果用js滚动条，用transform计算内容区位置，position：fixed将实效。若有.fixed-tab，强制使用native滚动条；备选方案，略粗暴
            // if($(pageContent).find('.fixed-tab').length>0){
            //     $pageContent.addClass('native-scroll');
            //     return;
            // }
            this.scroller = new IScroll(pageContent, options); // jshint ignore:line
            //和native滚动统一起来
            this._bindEventToDomWhenJs();
            $.initPullToRefresh = $._pullToRefreshJSScroll.initPullToRefresh;
            $.pullToRefreshDone = $._pullToRefreshJSScroll.pullToRefreshDone;
            $.pullToRefreshTrigger = $._pullToRefreshJSScroll.pullToRefreshTrigger;
            $.destroyToRefresh = $._pullToRefreshJSScroll.destroyToRefresh;
            $pageContent.addClass('javascript-scroll');
            if (!useTransform) {
                $pageContent.find('.content-inner').css({
                    width: '100%',
                    position: 'absolute'
                });
            }

            //如果页面本身已经进行了原生滚动，那么把这个滚动换成JS的滚动
            var nativeScrollTop = this.$pageContent[0].scrollTop;
            if(nativeScrollTop) {
                this.$pageContent[0].scrollTop = 0;
                this.scrollTop(nativeScrollTop);
            }
        } else {
            $pageContent.addClass('native-scroll');
        }
    };
    Scroller.prototype = {
        _defaults: {
            type: 'native',
        },
        _bindEventToDomWhenJs: function() {
            //"scrollStart", //the scroll started.
            //"scroll", //the content is scrolling. Available only in scroll-probe.js edition. See onScroll event.
            //"scrollEnd", //content stopped scrolling.
            if (this.scroller) {
                var self = this;
                this.scroller.on('scrollStart', function() {
                    self.$pageContent.trigger('scrollstart');
                });
                this.scroller.on('scroll', function() {
                    self.$pageContent.trigger('scroll');
                });
                this.scroller.on('scrollEnd', function() {
                    self.$pageContent.trigger('scrollend');
                });
            } else {
                //TODO: 实现native的scrollStart和scrollEnd
            }
        },
        scrollTop: function(top, dur) {
            if (this.scroller) {
                if (top !== undefined) {
                    this.scroller.scrollTo(0, -1 * top, dur);
                } else {
                    return this.scroller.getComputedPosition().y * -1;
                }
            } else {
                return this.$pageContent.scrollTop(top, dur);
            }
            return this;
        },
        scrollLeft: function(left, dur) {
            if (this.scroller) {
                if (left !== undefined) {
                    this.scroller.scrollTo(-1 * left, 0);
                } else {
                    return this.scroller.getComputedPosition().x * -1;
                }
            } else {
                return this.$pageContent.scrollTop(left, dur);
            }
            return this;
        },
        on: function(event, callback) {
            if (this.scroller) {
                this.scroller.on(event, function() {
                    callback.call(this.wrapper);
                });
            } else {
                this.$pageContent.on(event, callback);
            }
            return this;
        },
        off: function(event, callback) {
            if (this.scroller) {
                this.scroller.off(event, callback);
            } else {
                this.$pageContent.off(event, callback);
            }
            return this;
        },
        refresh: function() {
            if (this.scroller) this.scroller.refresh();
            return this;
        },
        scrollHeight: function() {
            if (this.scroller) {
                return this.scroller.scrollerHeight;
            } else {
                return this.$pageContent[0].scrollHeight;
            }
        }

    };

    //Scroller PLUGIN DEFINITION
    // =======================

    function Plugin(option) {
        var args = Array.apply(null, arguments);
        args.shift();
        var internal_return;

        this.each(function() {

            var $this = $(this);

            var options = $.extend({}, $this.dataset(), typeof option === 'object' && option);

            var data = $this.data('scroller');
            //如果 scroller 没有被初始化，对scroller 进行初始化r
            if (!data) {
                //获取data-api的
                $this.data('scroller', (data = new Scroller(this, options)));

            }
            if (typeof option === 'string' && typeof data[option] === 'function') {
                internal_return = data[option].apply(data, args);
                if (internal_return !== undefined)
            return false;
            }

        });

        if (internal_return !== undefined)
            return internal_return;
        else
            return this;

    }

    var old = $.fn.scroller;

    $.fn.scroller = Plugin;
    $.fn.scroller.Constructor = Scroller;


    // Scroll NO CONFLICT
    // =================

    $.fn.scroller.noConflict = function() {
        $.fn.scroller = old;
        return this;
    };
    //添加data-api
    $(function() {
        $('[data-toggle="scroller"]').scroller();
    });

    //统一的接口,带有 .javascript-scroll 的content 进行刷新
    $.refreshScroller = function(content) {
        if (content) {
            $(content).scroller('refresh');
        } else {
            $('.javascript-scroll').each(function() {
                $(this).scroller('refresh');
            });
        }

    };
    //全局初始化方法，会对页面上的 [data-toggle="scroller"]，.content. 进行滚动条初始化
    $.initScroller = function(option) {
        this.options = $.extend({}, typeof option === 'object' && option);
        $('[data-toggle="scroller"],.content').scroller(option);
    };
    //获取scroller对象
    $.getScroller = function(content) {
        //以前默认只能有一个无限滚动，因此infinitescroll都是加在content上，现在允许里面有多个，因此要判断父元素是否有content
        content = content.hasClass('content') ? content : content.parents('.content');
        if (content) {
            return $(content).data('scroller');
        } else {
            return $('.content.javascript-scroll').data('scroller');
        }
    };
    //检测滚动类型,
    //‘js’: javascript 滚动条
    //‘native’: 原生滚动条
    $.detectScrollerType = function(content) {
        if (content) {
            if ($(content).data('scroller') && $(content).data('scroller').scroller) {
                return 'js';
            } else {
                return 'native';
            }
        }
    };

}(Zepto);

/* ===============================================================================
************   Tabs   ************
=============================================================================== */
+function ($) {
    "use strict";

    var showTab = function (tab, tabLink, force) {
        var newTab = $(tab);
        if (arguments.length === 2) {
            if (typeof tabLink === 'boolean') {
                force = tabLink;
            }
        }
        if (newTab.length === 0) return false;
        if (newTab.hasClass('active')) {
            if (force) newTab.trigger('show');
            return false;
        }
        var tabs = newTab.parent('.tabs');
        if (tabs.length === 0) return false;

        // Animated tabs
        /*var isAnimatedTabs = tabs.parent().hasClass('tabs-animated-wrap');
          if (isAnimatedTabs) {
          tabs.transform('translate3d(' + -newTab.index() * 100 + '%,0,0)');
          }*/

        // Remove active class from old tabs
        var oldTab = tabs.children('.tab.active').removeClass('active');
        // Add active class to new tab
        newTab.addClass('active');
        // Trigger 'show' event on new tab
        newTab.trigger('show');

        // Update navbars in new tab
        /*if (!isAnimatedTabs && newTab.find('.navbar').length > 0) {
        // Find tab's view
        var viewContainer;
        if (newTab.hasClass(app.params.viewClass)) viewContainer = newTab[0];
        else viewContainer = newTab.parents('.' + app.params.viewClass)[0];
        app.sizeNavbars(viewContainer);
        }*/

        // Find related link for new tab
        if (tabLink) tabLink = $(tabLink);
        else {
            // Search by id
            if (typeof tab === 'string') tabLink = $('.tab-link[href="' + tab + '"]');
            else tabLink = $('.tab-link[href="#' + newTab.attr('id') + '"]');
            // Search by data-tab
            if (!tabLink || tabLink && tabLink.length === 0) {
                $('[data-tab]').each(function () {
                    if (newTab.is($(this).attr('data-tab'))) tabLink = $(this);
                });
            }
        }
        if (tabLink.length === 0) return;

        // Find related link for old tab
        var oldTabLink;
        if (oldTab && oldTab.length > 0) {
            // Search by id
            var oldTabId = oldTab.attr('id');
            if (oldTabId) oldTabLink = $('.tab-link[href="#' + oldTabId + '"]');
            // Search by data-tab
            if (!oldTabLink || oldTabLink && oldTabLink.length === 0) {
                $('[data-tab]').each(function () {
                    if (oldTab.is($(this).attr('data-tab'))) oldTabLink = $(this);
                });
            }
        }

        // Update links' classes
        if (tabLink && tabLink.length > 0) tabLink.addClass('active');
        if (oldTabLink && oldTabLink.length > 0) oldTabLink.removeClass('active');
        tabLink.trigger('active');

        //app.refreshScroller();

        return true;
    };

    var old = $.showTab;
    $.showTab = showTab;

    $.showTab.noConflict = function () {
        $.showTab = old;
        return this;
    };
    //a标签上的click事件，在iscroll下响应有问题
    $(document).on("click", ".tab-link", function(e) {
        e.preventDefault();
        var clicked = $(this);
        showTab(clicked.data("tab") || clicked.attr('href'), clicked);
    });


}(Zepto);

/* ===============================================================================
************   Tabs   ************
=============================================================================== */
+function ($) {
    "use strict";
    $.initFixedTab = function(){
        var $fixedTab = $('.fixed-tab');
        if ($fixedTab.length === 0) return;
        $('.fixed-tab').fixedTab();//默认{offset: 0}
    };
    var FixedTab = function(pageContent, _options) {
        var $pageContent = this.$pageContent = $(pageContent);
        var shadow = $pageContent.clone();
        var fixedTop = $pageContent[0].getBoundingClientRect().top;

        shadow.css('visibility', 'hidden');
        this.options = $.extend({}, this._defaults, {
            fixedTop: fixedTop,
            shadow: shadow,
            offset: 0
        }, _options);

        this._bindEvents();
    };

    FixedTab.prototype = {
        _defaults: {
            offset: 0,
        },
        _bindEvents: function() {
            this.$pageContent.parents('.content').on('scroll', this._scrollHandler.bind(this));
            this.$pageContent.on('active', '.tab-link', this._tabLinkHandler.bind(this));
        },
        _tabLinkHandler: function(ev) {
            var isFixed = $(ev.target).parents('.buttons-fixed').length > 0;
            var fixedTop = this.options.fixedTop;
            var offset = this.options.offset;
            $.refreshScroller();
            if (!isFixed) return;
            this.$pageContent.parents('.content').scrollTop(fixedTop - offset);
        },
        // 滚动核心代码
        _scrollHandler: function(ev) {
            var $scroller = $(ev.target);
            var $pageContent = this.$pageContent;
            var shadow = this.options.shadow;
            var offset = this.options.offset;
            var fixedTop = this.options.fixedTop;
            var scrollTop = $scroller.scrollTop();
            var isFixed = scrollTop >= fixedTop - offset;
            if (isFixed) {
                shadow.insertAfter($pageContent);
                $pageContent.addClass('buttons-fixed').css('top', offset);
            } else {
                shadow.remove();
                $pageContent.removeClass('buttons-fixed').css('top', 0);
            }
        }
    };

    //FixedTab PLUGIN DEFINITION
    // =======================

    function Plugin(option) {
        var args = Array.apply(null, arguments);
        args.shift();
        this.each(function() {
            var $this = $(this);
            var options = $.extend({}, $this.dataset(), typeof option === 'object' && option);
            var data = $this.data('fixedtab');
            if (!data) {
                //获取data-api的
                $this.data('fixedtab', (data = new FixedTab(this, options)));
            }
        });

    }
    $.fn.fixedTab = Plugin;
    $.fn.fixedTab.Constructor = FixedTab;
    $(document).on('pageInit',function(){
        $.initFixedTab();
    });



}(Zepto);

+ function($) {
    "use strict";
    //这里实在js滚动时使用的下拉刷新代码。

    var refreshTime = 0;
    var initPullToRefreshJS = function(pageContainer) {
        var eventsTarget = $(pageContainer);
        if (!eventsTarget.hasClass('pull-to-refresh-content')) {
            eventsTarget = eventsTarget.find('.pull-to-refresh-content');
        }
        if (!eventsTarget || eventsTarget.length === 0) return;

        var page = eventsTarget.hasClass('content') ? eventsTarget : eventsTarget.parents('.content');
        var scroller = $.getScroller(page[0]);
        if(!scroller) return;


        var container = eventsTarget;

        function handleScroll() {
            if (container.hasClass('refreshing')) return;
            if (scroller.scrollTop() * -1 >= 44) {
                container.removeClass('pull-down').addClass('pull-up');
            } else {
                container.removeClass('pull-up').addClass('pull-down');
            }
        }

        function handleRefresh() {
            if (container.hasClass('refreshing')) return;
            container.removeClass('pull-down pull-up');
            container.addClass('refreshing transitioning');
            container.trigger('refresh');
            refreshTime = +new Date();
        }
        scroller.on('scroll', handleScroll);
        scroller.scroller.on('ptr', handleRefresh);

        // Detach Events on page remove
        function destroyPullToRefresh() {
            scroller.off('scroll', handleScroll);
            scroller.scroller.off('ptr', handleRefresh);
        }
        eventsTarget[0].destroyPullToRefresh = destroyPullToRefresh;

    };

    var pullToRefreshDoneJS = function(container) {
        container = $(container);
        if (container.length === 0) container = $('.pull-to-refresh-content.refreshing');
        if (container.length === 0) return;
        var interval = (+new Date()) - refreshTime;
        var timeOut = interval > 1000 ? 0 : 1000 - interval; //long than bounce time
        var scroller = $.getScroller(container);
        setTimeout(function() {
            scroller.refresh();
            container.removeClass('refreshing');
            container.transitionEnd(function() {
                container.removeClass("transitioning");
            });
        }, timeOut);
    };
    var pullToRefreshTriggerJS = function(container) {
        container = $(container);
        if (container.length === 0) container = $('.pull-to-refresh-content');
        if (container.hasClass('refreshing')) return;
        container.addClass('refreshing');
        var scroller = $.getScroller(container);
        scroller.scrollTop(44 + 1, 200);
        container.trigger('refresh');
    };

    var destroyPullToRefreshJS = function(pageContainer) {
        pageContainer = $(pageContainer);
        var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
        if (pullToRefreshContent.length === 0) return;
        if (pullToRefreshContent[0].destroyPullToRefresh) pullToRefreshContent[0].destroyPullToRefresh();
    };

    $._pullToRefreshJSScroll = {
        "initPullToRefresh": initPullToRefreshJS,
        "pullToRefreshDone": pullToRefreshDoneJS,
        "pullToRefreshTrigger": pullToRefreshTriggerJS,
        "destroyPullToRefresh": destroyPullToRefreshJS,
    };
}(Zepto); // jshint ignore:line

+ function($) {
    'use strict';
    $.initPullToRefresh = function(pageContainer) {
        var eventsTarget = $(pageContainer);
        if (!eventsTarget.hasClass('pull-to-refresh-content')) {
            eventsTarget = eventsTarget.find('.pull-to-refresh-content');
        }
        if (!eventsTarget || eventsTarget.length === 0) return;

        var isTouched, isMoved, touchesStart = {},
            isScrolling, touchesDiff, touchStartTime, container, refresh = false,
            useTranslate = false,
            startTranslate = 0,
            translate, scrollTop, wasScrolled, triggerDistance, dynamicTriggerDistance;

        container = eventsTarget;

        // Define trigger distance
        if (container.attr('data-ptr-distance')) {
            dynamicTriggerDistance = true;
        } else {
            triggerDistance = 44;
        }

        function handleTouchStart(e) {
            if (isTouched) {
                if ($.device.android) {
                    if ('targetTouches' in e && e.targetTouches.length > 1) return;
                } else return;
            }
            isMoved = false;
            isTouched = true;
            isScrolling = undefined;
            wasScrolled = undefined;
            touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            touchStartTime = (new Date()).getTime();
            /*jshint validthis:true */
            container = $(this);
        }

        function handleTouchMove(e) {
            if (!isTouched) return;
            var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
            if (typeof isScrolling === 'undefined') {
                isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
            }
            if (!isScrolling) {
                isTouched = false;
                return;
            }

            scrollTop = container[0].scrollTop;
            if (typeof wasScrolled === 'undefined' && scrollTop !== 0) wasScrolled = true;

            if (!isMoved) {
                /*jshint validthis:true */
                container.removeClass('transitioning');
                if (scrollTop > container[0].offsetHeight) {
                    isTouched = false;
                    return;
                }
                if (dynamicTriggerDistance) {
                    triggerDistance = container.attr('data-ptr-distance');
                    if (triggerDistance.indexOf('%') >= 0) triggerDistance = container[0].offsetHeight * parseInt(triggerDistance, 10) / 100;
                }
                startTranslate = container.hasClass('refreshing') ? triggerDistance : 0;
                if (container[0].scrollHeight === container[0].offsetHeight || !$.device.ios) {
                    useTranslate = true;
                } else {
                    useTranslate = false;
                }
                useTranslate = true;
            }
            isMoved = true;
            touchesDiff = pageY - touchesStart.y;

            if (touchesDiff > 0 && scrollTop <= 0 || scrollTop < 0) {
                // iOS 8 fix
                if ($.device.ios && parseInt($.device.osVersion.split('.')[0], 10) > 7 && scrollTop === 0 && !wasScrolled) useTranslate = true;

                if (useTranslate) {
                    e.preventDefault();
                    translate = (Math.pow(touchesDiff, 0.85) + startTranslate);
                    container.transform('translate3d(0,' + translate + 'px,0)');
                } else {}
                if ((useTranslate && Math.pow(touchesDiff, 0.85) > triggerDistance) || (!useTranslate && touchesDiff >= triggerDistance * 2)) {
                    refresh = true;
                    container.addClass('pull-up').removeClass('pull-down');
                } else {
                    refresh = false;
                    container.removeClass('pull-up').addClass('pull-down');
                }
            } else {

                container.removeClass('pull-up pull-down');
                refresh = false;
                return;
            }
        }

        function handleTouchEnd() {
            if (!isTouched || !isMoved) {
                isTouched = false;
                isMoved = false;
                return;
            }
            if (translate) {
                container.addClass('transitioning');
                translate = 0;
            }
            container.transform('');
            if (refresh) {
                //防止二次触发
                if(container.hasClass('refreshing')) return;
                container.addClass('refreshing');
                container.trigger('refresh');
            } else {
                container.removeClass('pull-down');
            }
            isTouched = false;
            isMoved = false;
        }

        // Attach Events
        eventsTarget.on($.touchEvents.start, handleTouchStart);
        eventsTarget.on($.touchEvents.move, handleTouchMove);
        eventsTarget.on($.touchEvents.end, handleTouchEnd);


        function destroyPullToRefresh() {
            eventsTarget.off($.touchEvents.start, handleTouchStart);
            eventsTarget.off($.touchEvents.move, handleTouchMove);
            eventsTarget.off($.touchEvents.end, handleTouchEnd);
        }
        eventsTarget[0].destroyPullToRefresh = destroyPullToRefresh;

    };
    $.pullToRefreshDone = function(container) {
        $(window).scrollTop(0);//解决微信下拉刷新顶部消失的问题
        container = $(container);
        if (container.length === 0) container = $('.pull-to-refresh-content.refreshing');
        container.removeClass('refreshing').addClass('transitioning');
        container.transitionEnd(function() {
            container.removeClass('transitioning pull-up pull-down');
        });
    };
    $.pullToRefreshTrigger = function(container) {
        container = $(container);
        if (container.length === 0) container = $('.pull-to-refresh-content');
        if (container.hasClass('refreshing')) return;
        container.addClass('transitioning refreshing');
        container.trigger('refresh');
    };

    $.destroyPullToRefresh = function(pageContainer) {
        pageContainer = $(pageContainer);
        var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
        if (pullToRefreshContent.length === 0) return;
        if (pullToRefreshContent[0].destroyPullToRefresh) pullToRefreshContent[0].destroyPullToRefresh();
    };

    //这里是否需要写到 scroller 中去？
/*    $.initPullToRefresh = function(pageContainer) {
        var $pageContainer = $(pageContainer);
        $pageContainer.each(function(index, item) {
            if ($.detectScrollerType(item) === 'js') {
                $._pullToRefreshJSScroll.initPullToRefresh(item);
            } else {
                initPullToRefresh(item);
            }
        });
    };


    $.pullToRefreshDone = function(pageContainer) {
        var $pageContainer = $(pageContainer);
        $pageContainer.each(function(index, item) {
            if ($.detectScrollerType(item) === 'js') {
                $._pullToRefreshJSScroll.pullToRefreshDone(item);
            } else {
                pullToRefreshDone(item);
            }
        });
    };


    $.pullToRefreshTrigger = function(pageContainer) {
       var $pageContainer = $(pageContainer);
        $pageContainer.each(function(index, item) {
            if ($.detectScrollerType(item) === 'js') {
                $._pullToRefreshJSScroll.pullToRefreshTrigger(item);
            } else {
                pullToRefreshTrigger(item);
            }
        });
    };

    $.destroyPullToRefresh = function(pageContainer) {
        var $pageContainer = $(pageContainer);
        $pageContainer.each(function(index, item) {
            if ($.detectScrollerType(item) === 'js') {
                $._pullToRefreshJSScroll.destroyPullToRefresh(item);
            } else {
                destroyPullToRefresh(item);
            }
        });
    };
*/

}(Zepto); //jshint ignore:line

+ function($) {
    'use strict';

    function handleInfiniteScroll() {
        /*jshint validthis:true */
        var inf = $(this);
        var scroller = $.getScroller(inf);
        var scrollTop = scroller.scrollTop();
        var scrollHeight = scroller.scrollHeight();
        var height = inf[0].offsetHeight;
        var distance = inf[0].getAttribute('data-distance');
        var virtualListContainer = inf.find('.virtual-list');
        var virtualList;
        var onTop = inf.hasClass('infinite-scroll-top');
        if (!distance) distance = 50;
        if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
            distance = parseInt(distance, 10) / 100 * height;
        }
        if (distance > height) distance = height;
        if (onTop) {
            if (scrollTop < distance) {
                inf.trigger('infinite');
            }
        } else {
            if (scrollTop + height >= scrollHeight - distance) {
                if (virtualListContainer.length > 0) {
                    virtualList = virtualListContainer[0].f7VirtualList;
                    if (virtualList && !virtualList.reachEnd) return;
                }
                inf.trigger('infinite');
            }
        }

    }
    $.attachInfiniteScroll = function(infiniteContent) {
        $.getScroller(infiniteContent).on('scroll', handleInfiniteScroll);
    };
    $.detachInfiniteScroll = function(infiniteContent) {
        $.getScroller(infiniteContent).off('scroll', handleInfiniteScroll);
    };

    $.initInfiniteScroll = function(pageContainer) {
        pageContainer = $(pageContainer);
        var infiniteContent = pageContainer.hasClass('infinite-scroll')?pageContainer:pageContainer.find('.infinite-scroll');
        if (infiniteContent.length === 0) return;
        $.attachInfiniteScroll(infiniteContent);
        //如果是顶部无限刷新，要将滚动条初始化于最下端
        pageContainer.forEach(function(v){
            if($(v).hasClass('infinite-scroll-top')){
                var height = v.scrollHeight - v.clientHeight;
                $(v).scrollTop(height);
            }
        });
        function detachEvents() {
            $.detachInfiniteScroll(infiniteContent);
            pageContainer.off('pageBeforeRemove', detachEvents);
        }
        pageContainer.on('pageBeforeRemove', detachEvents);
    };
}(Zepto);

+function ($) {
    "use strict";
    $(function() {
        $(document).on("focus", ".searchbar input", function(e) {
            var $input = $(e.target);
            $input.parents(".searchbar").addClass("searchbar-active");
        });
        $(document).on("click", ".searchbar-cancel", function(e) {
            var $btn = $(e.target);
            $btn.parents(".searchbar").removeClass("searchbar-active");
        });
        $(document).on("blur", ".searchbar input", function(e) {
            var $input = $(e.target);
            $input.parents(".searchbar").removeClass("searchbar-active");
        });
    });
}(Zepto);

/*======================================================
************   Panels   ************
======================================================*/
/*jshint unused: false*/
+function ($) {
    "use strict";
    $.allowPanelOpen = true;
    $.openPanel = function (panel) {
        if (!$.allowPanelOpen) return false;
        if(panel === 'left' || panel === 'right') panel = ".panel-" + panel;  //可以传入一个方向
        panel = panel ? $('.page.page-current').find(panel) : $('.page.page-current').find(".panel").eq(0);
        var direction = panel.hasClass("panel-right") ? "right" : "left";
        if (panel.length === 0 || panel.hasClass('active')) return false;
        $.closePanel(); // Close if some panel is opened
        $.allowPanelOpen = false;
        var effect = panel.hasClass('panel-reveal') ? 'reveal' : 'cover';
        panel.css({display: 'block'}).addClass('active');
        panel.trigger('open');

        // Trigger reLayout
        var clientLeft = panel[0].clientLeft;

        // Transition End;
        var transitionEndTarget = effect === 'reveal' ? $($.getCurrentPage()) : panel;
        var openedTriggered = false;

        function panelTransitionEnd() {
            transitionEndTarget.transitionEnd(function (e) {
                if (e.target === transitionEndTarget[0]) {
                    if (panel.hasClass('active')) {
                        panel.trigger('opened');
                    }
                    else {
                        panel.trigger('closed');
                    }
            $.allowPanelOpen = true;
                }
                else panelTransitionEnd();
            });
        }
        panelTransitionEnd();

        $(document.body).addClass('with-panel-' + direction + '-' + effect);
        return true;
    };
    $.closePanel = function () {
        var activePanel = $('.panel.active');
        if (activePanel.length === 0) return false;
        var effect = activePanel.hasClass('panel-reveal') ? 'reveal' : 'cover';
        var panelPosition = activePanel.hasClass('panel-left') ? 'left' : 'right';
        activePanel.removeClass('active');
        var transitionEndTarget = effect === 'reveal' ? $('.page') : activePanel;
        activePanel.trigger('close');
        $.allowPanelOpen = false;

        transitionEndTarget.transitionEnd(function () {
            if (activePanel.hasClass('active')) return;
            activePanel.css({display: ''});
            activePanel.trigger('closed');
            $('body').removeClass('panel-closing');
            $.allowPanelOpen = true;
        });

        $('body').addClass('panel-closing').removeClass('with-panel-' + panelPosition + '-' + effect);
    };

    $(document).on("click", ".open-panel", function(e) {
        var panel = $(e.target).data('panel');
        $.openPanel(panel);
    });
    $(document).on("click", ".close-panel, .panel-overlay", function(e) {
        $.closePanel();
    });
    /*======================================================
     ************   Swipe panels   ************
     ======================================================*/
    $.initSwipePanels = function () {
        var panel, side;
        var swipePanel = $.smConfig.swipePanel;
        var swipePanelOnlyClose = $.smConfig.swipePanelOnlyClose;
        var swipePanelCloseOpposite = true;
        var swipePanelActiveArea = false;
        var swipePanelThreshold = 2;
        var swipePanelNoFollow = false;

        if(!(swipePanel || swipePanelOnlyClose)) return;

        var panelOverlay = $('.panel-overlay');
        var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, translate, opened, panelWidth, effect, direction;
        var views = $('.page');

        function handleTouchStart(e) {
            if (!$.allowPanelOpen || (!swipePanel && !swipePanelOnlyClose) || isTouched) return;
            if ($('.modal-in, .photo-browser-in').length > 0) return;
            if (!(swipePanelCloseOpposite || swipePanelOnlyClose)) {
                if ($('.panel.active').length > 0 && !panel.hasClass('active')) return;
            }
            touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            if (swipePanelCloseOpposite || swipePanelOnlyClose) {
                if ($('.panel.active').length > 0) {
                    side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
                }
                else {
                    if (swipePanelOnlyClose) return;
                    side = swipePanel;
                }
                if (!side) return;
            }
            panel = $('.page.page-current').find('.panel.panel-' + side);
            if(!panel[0]) return;
            opened = panel.hasClass('active');
            if (swipePanelActiveArea && !opened) {
                if (side === 'left') {
                    if (touchesStart.x > swipePanelActiveArea) return;
                }
                if (side === 'right') {
                    if (touchesStart.x < window.innerWidth - swipePanelActiveArea) return;
                }
            }
            isMoved = false;
            isTouched = true;
            isScrolling = undefined;

            touchStartTime = (new Date()).getTime();
            direction = undefined;
        }
        function handleTouchMove(e) {
            if (!isTouched) return;
            if(!panel[0]) return;
            if (e.f7PreventPanelSwipe) return;
            var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
            if (typeof isScrolling === 'undefined') {
                isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
            }
            if (isScrolling) {
                isTouched = false;
                return;
            }
            if (!direction) {
                if (pageX > touchesStart.x) {
                    direction = 'to-right';
                }
                else {
                    direction = 'to-left';
                }

                if (
                        side === 'left' &&
                        (
                         direction === 'to-left' && !panel.hasClass('active')
                        ) ||
                        side === 'right' &&
                        (
                         direction === 'to-right' && !panel.hasClass('active')
                        )
                   )
                {
                    isTouched = false;
                    return;
                }
            }

            if (swipePanelNoFollow) {
                var timeDiff = (new Date()).getTime() - touchStartTime;
                if (timeDiff < 300) {
                    if (direction === 'to-left') {
                        if (side === 'right') $.openPanel(side);
                        if (side === 'left' && panel.hasClass('active')) $.closePanel();
                    }
                    if (direction === 'to-right') {
                        if (side === 'left') $.openPanel(side);
                        if (side === 'right' && panel.hasClass('active')) $.closePanel();
                    }
                }
                isTouched = false;
                console.log(3);
                isMoved = false;
                return;
            }

            if (!isMoved) {
                effect = panel.hasClass('panel-cover') ? 'cover' : 'reveal';
                if (!opened) {
                    panel.show();
                    panelOverlay.show();
                }
                panelWidth = panel[0].offsetWidth;
                panel.transition(0);
                /*
                   if (panel.find('.' + app.params.viewClass).length > 0) {
                   if (app.sizeNavbars) app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
                   }
                   */
            }

            isMoved = true;

            e.preventDefault();
            var threshold = opened ? 0 : -swipePanelThreshold;
            if (side === 'right') threshold = -threshold;

            touchesDiff = pageX - touchesStart.x + threshold;

            if (side === 'right') {
                translate = touchesDiff  - (opened ? panelWidth : 0);
                if (translate > 0) translate = 0;
                if (translate < -panelWidth) {
                    translate = -panelWidth;
                }
            }
            else {
                translate = touchesDiff  + (opened ? panelWidth : 0);
                if (translate < 0) translate = 0;
                if (translate > panelWidth) {
                    translate = panelWidth;
                }
            }
            if (effect === 'reveal') {
                views.transform('translate3d(' + translate + 'px,0,0)').transition(0);
                panelOverlay.transform('translate3d(' + translate + 'px,0,0)');
                //app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
            }
            else {
                panel.transform('translate3d(' + translate + 'px,0,0)').transition(0);
                //app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
            }
        }
        function handleTouchEnd(e) {
            if (!isTouched || !isMoved) {
                isTouched = false;
                isMoved = false;
                return;
            }
            isTouched = false;
            isMoved = false;
            var timeDiff = (new Date()).getTime() - touchStartTime;
            var action;
            var edge = (translate === 0 || Math.abs(translate) === panelWidth);

            if (!opened) {
                if (translate === 0) {
                    action = 'reset';
                }
                else if (
                        timeDiff < 300 && Math.abs(translate) > 0 ||
                        timeDiff >= 300 && (Math.abs(translate) >= panelWidth / 2)
                        ) {
                            action = 'swap';
                        }
                else {
                    action = 'reset';
                }
            }
            else {
                if (translate === -panelWidth) {
                    action = 'reset';
                }
                else if (
                        timeDiff < 300 && Math.abs(translate) >= 0 ||
                        timeDiff >= 300 && (Math.abs(translate) <= panelWidth / 2)
                        ) {
                            if (side === 'left' && translate === panelWidth) action = 'reset';
                            else action = 'swap';
                        }
                else {
                    action = 'reset';
                }
            }
            if (action === 'swap') {
                $.allowPanelOpen = true;
                if (opened) {
                    $.closePanel();
                    if (edge) {
                        panel.css({display: ''});
                        $('body').removeClass('panel-closing');
                    }
                }
                else {
                    $.openPanel(side);
                }
                if (edge) $.allowPanelOpen = true;
            }
            if (action === 'reset') {
                if (opened) {
                    $.allowPanelOpen = true;
                    $.openPanel(side);
                }
                else {
                    $.closePanel();
                    if (edge) {
                        $.allowPanelOpen = true;
                        panel.css({display: ''});
                    }
                    else {
                        var target = effect === 'reveal' ? views : panel;
                        $('body').addClass('panel-closing');
                        target.transitionEnd(function () {
                            $.allowPanelOpen = true;
                            panel.css({display: ''});
                            $('body').removeClass('panel-closing');
                        });
                    }
                }
            }
            if (effect === 'reveal') {
                views.transition('');
                views.transform('');
            }
            panel.transition('').transform('');
            panelOverlay.css({display: ''}).transform('');
        }
        $(document).on($.touchEvents.start, handleTouchStart);
        $(document).on($.touchEvents.move, handleTouchMove);
        $(document).on($.touchEvents.end, handleTouchEnd);
    };

    $.initSwipePanels();
}(Zepto);

/**
 * @typedef {Object} State
 * @property {Number} id
 * @property {String} url
 * @property {String} pageId
 */

/**
 * @typedef {Object} UrlObject 字符串 url 转为的对象
 * @property {String} base url 的基本路径
 * @property {String} full url 的完整绝对路径
 * @property {String} origin 转换前的 url
 * @property {String} fragment url 的 fragment
 */

/**
 * @typedef {Object} DocumentCache
 * @property {*|HTMLElement} $doc 看做是 $(document)
 * @property {*|HTMLElement} $content $doc 里的 routerConfig.innerViewClass 元素
 */

/*======================================================
************   Modals   ************
======================================================*/
/*jshint unused: false*/
+function ($) {
  "use strict";
  $.lastPosition =function(options) {
    if ( !sessionStorage) {
        return;
    }
    // 需要记忆模块的className
    var needMemoryClass = options.needMemoryClass || [];

    $(window).off('beforePageSwitch').on('beforePageSwitch', function(event,id,arg) {
      updateMemory(id,arg);
    });
    $(window).off('pageAnimationStart').on('pageAnimationStart', function(event,id,arg) {
      getMemory(id,arg);
    });
    //让后退页面回到之前的高度
    function getMemory(id,arg){
      needMemoryClass.forEach(function(item, index) {
          if ($(item).length === 0) {
              return;
          }
          var positionName = id ;
          // 遍历对应节点设置存储的高度
          var memoryHeight = sessionStorage.getItem(positionName);
          arg.find(item).scrollTop(parseInt(memoryHeight));

      });
    }
    //记住即将离开的页面的高度
    function updateMemory(id,arg) {
        var positionName = id ;
        // 存储需要记忆模块的高度
        needMemoryClass.forEach(function(item, index) {
            if ($(item).length === 0) {
                return;
            }
            sessionStorage.setItem(
                positionName,
                arg.find(item).scrollTop()
            );

        });
    }
  };
}(Zepto);

/*jshint unused: false*/
+function($) {
    'use strict';

    var getPage = function() {
        var $page = $(".page-current");
        if (!$page[0]) $page = $(".page").addClass('page-current');
        return $page;
    };

    //初始化页面中的JS组件
    $.initPage = function(page) {
        var $page = getPage();
        if (!$page[0]) $page = $(document.body);
        var $content = $page.hasClass('content') ?
                       $page :
                       $page.find('.content');
        $content.scroller();  //注意滚动条一定要最先初始化

        $.initPullToRefresh($content);
        $.initInfiniteScroll($content);
        $.initCalendar($content);

        //extend
        if ($.initSwiper) $.initSwiper($content);
    };

    if ($.smConfig.showPageLoadingIndicator) {
        //这里的 以 push 开头的是私有事件，不要用
        $(window).on('pageLoadStart', function() {
            $.showIndicator();

        });
        $(window).on('pageAnimationStart', function() {
            $.hideIndicator();
        });
        $(window).on('pageLoadCancel', function() {
            $.hideIndicator();
        });
        $(window).on('pageLoadComplete', function() {
            $.hideIndicator();
        });
        $(window).on('pageLoadError', function() {
            $.hideIndicator();
            $.toast('加载失败');
        });
    }

    $(window).on('pageAnimationStart', function(event,id,page) {
        // 在路由切换页面动画开始前,为了把位于 .page 之外的 popup 等隐藏,此处做些处理
        $.closeModal();
        $.closePanel();
        // 如果 panel 的 effect 是 reveal 时,似乎是 page 的动画或别的样式原因导致了 transitionEnd 时间不会触发
        // 这里暂且处理一下
        $('body').removeClass('panel-closing');
        $.allowPanelOpen = true;
    });

    $(window).on('pageInit', function() {
        $.hideIndicator();
        $.lastPosition({
            needMemoryClass: [
                '.content'
            ]
        });
    });
    // safari 在后退的时候会使用缓存技术，但实现上似乎存在些问题，
    // 导致路由中绑定的点击事件不会正常如期的运行（log 和 debugger 都没法调试），
    // 从而后续的跳转等完全乱了套。
    // 所以，这里检测到是 safari 的 cache 的情况下，做一次 reload
    // 测试路径(后缀 D 表示是 document，E 表示 external，不使用路由跳转）：
    // 1. aD -> bDE
    // 2. back
    // 3. aD -> bD
    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            location.reload();
        }
    });

    $.init = function() {
        var $page = getPage();
        var id = $page[0].id;
        $.initPage();
        $page.trigger('pageInit', [id, $page]);
    };

    //DOM READY
    $(function() {
        //直接绑定
        FastClick.attach(document.body);

        if ($.smConfig.autoInit) {
            $.init();
        }

        $(document).on('pageInitInternal', function(e, id, page) {
            $.init();
        });
    });

}(Zepto);

/**
 * ScrollFix v0.1
 * http://www.joelambert.co.uk
 *
 * Copyright 2011, Joe Lambert.
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 */
/* ===============================================================================
************   ScrollFix   ************
=============================================================================== */

+ function($) {
    "use strict";
    //安卓微信中使用scrollfix会有问题，因此只在ios中使用，安卓机器按照原来的逻辑

    if($.device.ios){
        var ScrollFix = function(elem) {

            // Variables to track inputs
            var startY;
            var startTopScroll;

            elem = elem || document.querySelector(elem);

            // If there is no element, then do nothing
            if(!elem)
                return;

            // Handle the start of interactions
            elem.addEventListener('touchstart', function(event){
                startY = event.touches[0].pageY;
                startTopScroll = elem.scrollTop;

                if(startTopScroll <= 0)
                elem.scrollTop = 1;

            if(startTopScroll + elem.offsetHeight >= elem.scrollHeight)
                elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1;
            }, false);
        };

        var initScrollFix = function(){
            var prefix = $('.page-current').length > 0 ? '.page-current ' : '';
            var scrollable = $(prefix + ".content");
            new ScrollFix(scrollable[0]);
        };

        $(document).on($.touchEvents.move, ".page-current .bar",function(){
            event.preventDefault();
        });
        //监听ajax页面跳转
        $(document).on("pageLoadComplete", function(){
             initScrollFix();
        });
        //监听内联页面跳转
        $(document).on("pageAnimationEnd", function(){
             initScrollFix();
        });
        initScrollFix();
    }

}(Zepto);


/***/ }),

/***/ "/Hz0":
/***/ (function(module, exports) {

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/11/28
 * desc: 去搜索页面
 * eg:<a href="#" v-search>去搜索页面</a>
 */

Vue.directive('search', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, options) {
    $(el).on('click', function () {
      if (options.value === undefined) {
        tuhu.navigateTo({ url: '/pages/_search/index' });
      } else {
        tuhu.navigateTo({ url: '/pages/_search/list', query: options.value });
      }
    });
  }
});

/***/ }),

/***/ "/Lae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ase__ = __webpack_require__("sfZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_util__ = __webpack_require__("xMCk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase, eqeqeq, no-redeclare */


/**
 * VerifySlide
 * @description 滑块
 * */



//  "captchaType":"blockPuzzle",
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VerifySlide',
  props: {
    captchaType: {
      type: String
    },
    type: {
      type: String,
      default: '1'
    },
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: 'fixed'
    },
    vSpace: {
      type: Number,
      default: 5
    },
    explain: {
      type: String,
      default: '向右滑动完成验证'
    },
    imgSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '155px'
        };
      }
    },
    blockSize: {
      type: Object,
      default: function _default() {
        return {
          width: '50px',
          height: '50px'
        };
      }
    },
    barSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '40px'
        };
      }
    },
    defaultImg: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      secretKey: '', // 后端返回的加密秘钥 字段
      passFlag: '', // 是否通过的标识
      backImgBase: '', // 验证码背景图片
      blockBackImgBase: '', // 验证滑块的背景图片
      backToken: '', // 后端返回的唯一token值
      startMoveTime: '', // 移动开始的时间
      endMovetime: '', // 移动结束的时间
      tipsBackColor: '', // 提示词的背景颜色
      tipWords: '',
      text: '',
      finishText: '',
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0
      },
      top: 0,
      left: 0,
      moveBlockLeft: undefined,
      leftBarWidth: undefined,
      // 移动中样式
      moveBlockBackgroundColor: undefined,
      leftBarBorderColor: '#ddd',
      iconColor: undefined,
      iconClass: 'icon-right',
      status: false, // 鼠标状态
      isEnd: false, // 是够验证完成
      showRefresh: true,
      transitionLeft: '',
      transitionWidth: ''
    };
  },

  computed: {
    barArea: function barArea() {
      return this.$el.querySelector('.verify-bar-area');
    },
    resetSize: function resetSize() {
      return __WEBPACK_IMPORTED_MODULE_3__utils_util__["a" /* resetSize */];
    }
  },
  watch: {
    // type变化则全面刷新
    type: {
      immediate: true,
      handler: function handler() {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    // 禁止拖拽
    this.$el.onselectstart = function () {
      return false;
    };
  },

  methods: {
    init: function init() {
      var _this2 = this;

      this.text = this.explain;
      this.getPictrue();
      this.$nextTick(function () {
        var setSize = _this2.resetSize(_this2); // 重新设置宽度高度
        for (var key in setSize) {
          _this2.$set(_this2.setSize, key, setSize[key]);
        }
        _this2.$parent.$emit('ready', _this2);
      });

      var _this = this;

      window.removeEventListener('touchmove', function (e) {
        _this.move(e);
      });
      window.removeEventListener('mousemove', function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.removeEventListener('touchend', function () {
        _this.end();
      });
      window.removeEventListener('mouseup', function () {
        _this.end();
      });

      window.addEventListener('touchmove', function (e) {
        _this.move(e);
      });
      window.addEventListener('mousemove', function (e) {
        _this.move(e);
      });

      // 鼠标松开
      window.addEventListener('touchend', function () {
        _this.end();
      });
      window.addEventListener('mouseup', function () {
        _this.end();
      });
    },


    // 鼠标按下
    start: function start(e) {
      e = e || window.event;
      if (!e.touches) {
        // 兼容PC端
        var x = e.clientX;
      } else {
        // 兼容移动端
        var x = e.touches[0].pageX;
      }
      this.startLeft = Math.floor(x - this.barArea.getBoundingClientRect().left);
      this.startMoveTime = +new Date(); // 开始滑动的时间
      if (this.isEnd == false) {
        this.text = '';
        this.moveBlockBackgroundColor = '#337ab7';
        this.leftBarBorderColor = '#337AB7';
        this.iconColor = '#fff';
        e.stopPropagation();
        this.status = true;
      }
    },
    // 鼠标移动
    move: function move(e) {
      e = e || window.event;
      if (this.status && this.isEnd == false) {
        if (!e.touches) {
          // 兼容PC端
          var x = e.clientX;
        } else {
          // 兼容移动端
          var x = e.touches[0].pageX;
        }
        var bar_area_left = this.barArea.getBoundingClientRect().left;
        var move_block_left = x - bar_area_left; // 小方块相对于父元素的left值
        if (move_block_left >= this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2) {
          move_block_left = this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2;
        }
        if (move_block_left <= 0) {
          move_block_left = parseInt(parseInt(this.blockSize.width) / 2);
        }
        // 拖动后小方块的left值
        this.moveBlockLeft = move_block_left - this.startLeft + 'px';
        this.leftBarWidth = move_block_left - this.startLeft + 'px';
      }
    },

    // 鼠标松开
    end: function end() {
      var _this3 = this;

      this.endMovetime = +new Date();
      var _this = this;
      // 判断是否重合
      if (this.status && this.isEnd == false) {
        var moveLeftDistance = parseInt((this.moveBlockLeft || '').replace('px', ''));
        moveLeftDistance = moveLeftDistance * 310 / parseInt(this.setSize.imgWidth);
        var data = {
          captchaType: this.captchaType,
          pointJson: this.secretKey ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_ase__["a" /* aesEncrypt */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ x: moveLeftDistance, y: 5.0 }), this.secretKey) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ x: moveLeftDistance, y: 5.0 }),
          token: this.backToken,
          source: 1,
          phone: this.phone
        };
        tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_1__configs_config__["a" /* default */].apis.captchaCheck, {
          method: 'post',
          body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
        }).then(function (data) {
          if (data && data.code === '200') {
            _this3.moveBlockBackgroundColor = '#5cb85c';
            _this3.leftBarBorderColor = '#5cb85c';
            _this3.iconColor = '#fff';
            _this3.iconClass = 'icon-check';
            _this3.showRefresh = false;
            _this3.isEnd = true;
            if (_this3.mode == 'pop') {
              setTimeout(function () {
                _this3.$parent.clickShow = false;
                _this3.refresh();
              }, 1500);
            }
            _this3.passFlag = true;
            _this3.tipWords = ((_this3.endMovetime - _this3.startMoveTime) / 1000).toFixed(2) + 's\u9A8C\u8BC1\u6210\u529F';
            var captchaVerification = _this3.secretKey ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_ase__["a" /* aesEncrypt */])(_this3.backToken + '---' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ x: moveLeftDistance, y: 5.0 }), _this3.secretKey) : _this3.backToken + '---' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ x: moveLeftDistance, y: 5.0 });
            setTimeout(function () {
              _this3.tipWords = '';
              _this3.$parent.closeBox();
              _this3.$parent.$emit('success', { captchaVerification: captchaVerification });
            }, 1000);
          } else {
            _this3.moveBlockBackgroundColor = '#d9534f';
            _this3.leftBarBorderColor = '#d9534f';
            _this3.iconColor = '#fff';
            _this3.iconClass = 'icon-close';
            _this3.passFlag = false;
            setTimeout(function () {
              _this.refresh();
            }, 1000);
            _this3.$parent.$emit('error', _this3);
            _this3.tipWords = data.message || '验证失败';
            setTimeout(function () {
              _this3.tipWords = '';
            }, 1000);
          }
        }).catch(function (e) {
          _this3.moveBlockBackgroundColor = '#d9534f';
          _this3.leftBarBorderColor = '#d9534f';
          _this3.iconColor = '#fff';
          _this3.iconClass = 'icon-close';
          _this3.passFlag = false;
          setTimeout(function () {
            _this.refresh();
          }, 1000);
          _this3.$parent.$emit('error', _this3);
          _this3.tipWords = e.message || '验证失败';
          setTimeout(function () {
            _this3.tipWords = '';
          }, 1000);
        });
        this.status = false;
      }
    },

    refresh: function refresh() {
      var _this4 = this;

      this.showRefresh = true;
      this.finishText = '';

      this.transitionLeft = 'left .3s';
      this.moveBlockLeft = 0;

      this.leftBarWidth = undefined;
      this.transitionWidth = 'width .3s';

      this.leftBarBorderColor = '#ddd';
      this.moveBlockBackgroundColor = '#fff';
      this.iconColor = '#000';
      this.iconClass = 'icon-right';
      this.isEnd = false;

      this.getPictrue();
      setTimeout(function () {
        _this4.transitionWidth = '';
        _this4.transitionLeft = '';
        _this4.text = _this4.explain;
      }, 300);
    },

    // 请求背景图片和验证图片
    getPictrue: function getPictrue() {
      var _this5 = this;

      var data = {
        captchaType: this.captchaType,
        clientUid: localStorage.getItem('slider'),
        ts: Date.now() // 现在的时间戳
      };
      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_1__configs_config__["a" /* default */].apis.captchaGet, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
      }).then(function (data) {
        if (data && data.code === '200') {
          console.log(data);
          _this5.backImgBase = data.data.originalImageBase64;
          _this5.blockBackImgBase = data.data.jigsawImageBase64;
          _this5.backToken = data.data.token;
          _this5.secretKey = data.data.secretKey;
        } else {
          tuhu.toast(data.message || '网络错误');
        }
      }).catch(function (e) {
        console.log(e, 'error');

        // 判断接口请求次数是否失效
        if (e.code == '6201') {
          _this5.backImgBase = null;
          _this5.blockBackImgBase = null;
        }
        _this5.tipWords = e.message || '请求错误';
      });
    }
  }
});

/***/ }),

/***/ "/MPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    billFlag: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      left: __webpack_require__("qm4d"),
      tips: __webpack_require__("um+J"),
      items: [{ title: "小鲲车服订单结算流程说明", type: "text" }, { title: "重点税务公告", type: "toxic" }, { title: "重要打款公告", type: "new" }, { title: "小鲲车服订单结算流程说明", type: "text" }],
      currentIndex: 0,
      interval: null,
      offset: 0,
      itemHeight: 0,
      isDragging: false,
      touchStartY: 0,
      isTransitioning: false,
      visibleItems: [],
      notrans: false
    };
  },
  mounted: function mounted() {
    this.calculateItemHeight();
    this.initCarousel();
    this.startAutoPlay();
    window.addEventListener("resize", this.calculateItemHeight);
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAutoPlay();
    window.removeEventListener("resize", this.calculateItemHeight);
  },

  methods: {
    initCarousel: function initCarousel() {
      // 创建三倍数据缓冲实现无缝循环
      this.visibleItems = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items));
      this.currentIndex = this.items.length; // 初始位置在中间段
      this.$nextTick(this.calculateOffset);
    },
    handleView: function handleView(type) {
      if (type === "text") {
        if (this.billFlag === 0) {
          tuhu.navigateTo({
            url: "/pages/home/text"
          });
        } else if (this.billFlag === 1) {
          tuhu.navigateTo({
            url: "/pages/home/textInvoice"
          });
        }
      } else if (type === "toxic") {
        // 重点税务公告：对应 noticeDialogs[1]（id=1）
        this.$emit("showSlide", 1);
      } else if (type === "new") {
        // 重要打款公告：对应 noticeDialogs[2]（id=2）
        this.$emit("showSlide", 2);
      }
    },
    calculateItemHeight: function calculateItemHeight() {
      var _this = this;

      this.$nextTick(function () {
        var tipEl = document.querySelector(".carousel-container");
        _this.itemHeight = tipEl.offsetHeight || 72;
        _this.calculateOffset();
      });
    },
    calculateOffset: function calculateOffset() {
      this.offset = -this.currentIndex * this.itemHeight;
    },
    next: function next() {
      this.isTransitioning = true;
      this.currentIndex++;
      this.handleBoundaryCheck();
      this.calculateOffset();
    },
    prev: function prev() {
      this.isTransitioning = true;
      this.currentIndex--;
      this.handleBoundaryCheck();
      this.calculateOffset();
    },
    handleBoundaryCheck: function handleBoundaryCheck() {
      var _this2 = this;

      var total = this.items.length;
      // 向后滚动到缓冲区末尾时重置
      if (this.currentIndex >= total * 2) {
        this.isTransitioning = false;
        this.currentIndex = total;
        this.$nextTick(function () {
          _this2.calculateOffset();
        });
      }
      // 向前滚动到缓冲区起始时重置
      if (this.currentIndex < total) {
        this.isTransitioning = false;
        this.currentIndex = total * 2 - 1;
        this.$nextTick(function () {
          _this2.isTransitioning = true;
          _this2.calculateOffset();
        });
      }
    },
    goTo: function goTo(index) {
      this.currentIndex = index % this.items.length;
      this.calculateOffset();
    },
    onTouchStart: function onTouchStart(e) {
      this.touchStartY = e.touches[0].clientY;
      this.isDragging = true;
      this.stopAutoPlay();
    },
    onTouchMove: function onTouchMove(e) {
      if (!this.isDragging) return;
      var touchCurrentY = e.touches[0].clientY;
      var diffY = touchCurrentY - this.touchStartY;
      this.offset = -this.currentIndex * this.itemHeight;
    },
    onTouchEnd: function onTouchEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      var touchEndY = e.changedTouches[0].clientY;
      var diffY = touchEndY - this.touchStartY;
      var threshold = 0;
      if (Math.abs(diffY) > threshold) {
        if (diffY < 0) this.next();
      } else {
        this.calculateOffset();
      }
      // 修正边界检查逻辑
      if (this.currentIndex >= this.items.length * 2) {
        this.goTo(0);
      } else if (this.currentIndex < 0) {
        this.goTo(this.items.length - 1);
      }
      this.startAutoPlay();
    },
    startAutoPlay: function startAutoPlay() {
      var _this3 = this;

      this.stopAutoPlay();
      this.interval = setInterval(function () {
        if (_this3.currentIndex === 6) _this3.next();
        _this3.next();
        _this3.handleBoundaryCheck(); // 每次轮播后检查边界
      }, 2000);
    },
    stopAutoPlay: function stopAutoPlay() {
      clearInterval(this.interval);
    }
  }
});

/***/ }),

/***/ "/ThF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"accountAccessPic"},[_c('img',{attrs:{"src":__webpack_require__("Zdwm"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/iEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commentCard_vue__ = __webpack_require__("dSEq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414c2851_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_commentCard_vue__ = __webpack_require__("7YbI");
function injectStyle (ssrContext) {
  __webpack_require__("IzBW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-414c2851"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commentCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_414c2851_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_commentCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/lqb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"c-box"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"price"},[_vm._v("￥"+_vm._s(_vm.orderInfo.settlementPrice))]),_vm._v(" "),_c('p',[_vm._v("申请结款金额")])]),_vm._v(" "),_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"bottom-line"},[_c('div',{staticClass:"key"},[_vm._v("收款账户")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.orderInfo.bankAccountSecret))])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"key"},[_vm._v("账期")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v(_vm._s(_vm.orderInfo.billPeriod))])])]),_vm._v(" "),_c('div',{staticClass:"item-upload"},[_c('div',{staticClass:"t"},[_vm._v("上传发票 "),(!_vm.orderInfo.billFlag)?_c('span',[_vm._v("（非必传）")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({onUpload: _vm.upload , vin:false, index:0, refresh:true}),expression:"{onUpload: upload , vin:false, index:0, refresh:true}"}],staticClass:"upload"},[(!_vm.invoiceImg)?_c('img',{attrs:{"src":__webpack_require__("4TQe"),"alt":""}}):_c('img',{attrs:{"src":_vm.invoiceImg,"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoiceImg),expression:"invoiceImg"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.invoiceImg=''}}})])])]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.submit()}}},[(_vm.orderInfo.billFlag)?_c('div',[_vm._v("提示：喷漆服务不上传发票可能导致结款不通过")]):_vm._e(),_vm._v(" "),_c('tt-button',{attrs:{"text":"立即申请"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/voH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tt-btn', _vm.type]},[_c('div',{staticClass:"btn-name"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_vm._t("icon")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productComponents_tab1__ = __webpack_require__("ZGyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productComponents_tab2__ = __webpack_require__("xW3h");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    tab1: __WEBPACK_IMPORTED_MODULE_0__productComponents_tab1__["a" /* default */], // 评论 infinite
    tab2: __WEBPACK_IMPORTED_MODULE_1__productComponents_tab2__["a" /* default */] // 图片 infinite
  },
  data: function data() {
    return {
      tabData: {
        productId: this.options.productId
      },
      titles: [] // tab初始化
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    // 获取tab信息
    this.GetCommentStatistic();
  },

  methods: {
    GetCommentStatistic: function GetCommentStatistic() {
      var _this = this;

      tuhu.fetch('https://item.tuhu.cn/Comment/GetCommentStatistic.html', {}, {
        query: { productId: this.tabData.productId }
      }).then(function (res) {
        _this.titles = [{
          name: '全部',
          number: res.AllNum
        }, {
          name: '晒图',
          number: res.ImageNum
        }];
      });
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0+DV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0/Pl":
/***/ (function(module, exports, __webpack_require__) {

/**
 * author: caominjie@tuhu.cn
 * date: 2017/12/13
 * docs:
 * wdith: 宽度
 * value: String
 * eg:
    <img v-qrcode="{width: 180, value:'13671802215TH19957321'}">
 */
var qrCode = __webpack_require__("71e1");

Vue.directive('qrcode', {
  inserted: function inserted(el, arg) {
    var scale = Math.ceil(arg.value.width / 29 || 6);
    qrCode.toDataURL(arg.value.value || '', { margin: 2, scale: scale }, function (e, url) {
      if (e) {
        console.error(e);
      } else {
        el.src = url;
        el.width = arg.value.width;
      }
    });
  }
});

/***/ }),

/***/ "000B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city-picker"},[_c('van-picker',{attrs:{"show-toolbar":"","title":_vm.title,"columns":_vm.columns},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "02pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0EE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);








var _this2 = this;

/**
 * author: liuhaojun@tuhu.cn
 * date: 2018/09/20
 * describe:
 *  指令接受一个对象或number值或false, 对象包括num, productId, orderId三个属性,num:客服分组, productId:商品Id, orderId:订单Id 如果值为false则不跳转
 *  num表示客服分组对应的客服ID请参考下面newCustomerCareDictory对象
 *  点击使用了该指令的元素会自动跳转到相应客服页面
 * demo:
    <div v-new-customer-care="0">点我</div>
    <div v-new-customer-care="{num: 0, productId: 'ss'}">点我</div>
    <div v-new-customer-care="{num: 0, orderId: 'ss'}">点我</div>
    <div v-new-customer-care="{num: 0}">点我</div>
 */
var newCustomerCareDictory = {
  0: { // 轮胎和默认 未传值或者传值类型不是number的情况下默认为0
    app: 'tuhu_app_lt',
    h5: 'tuhu_h5_lt'
  },
  1: { // 保养
    app: 'tuhu_app_by',
    h5: 'tuhu_h5_by'
  },
  2: { // 汽车美容
    app: 'tuhu_app_mr',
    h5: 'tuhu_h5_mr'
  },
  3: { // 车品
    app: 'tuhu_app_cp',
    h5: 'tuhu_h5_cp'
  },
  4: { // 汽车改装
    app: 'tuhu_app_gz',
    h5: 'tuhu_h5_gz'
  },
  5: { // 蓄电池
    app: 'tuhu_app_xdc',
    h5: 'tuhu_h5_xdc'
  },
  6: { // 轮毂
    app: 'tuhu_app_lg',
    h5: 'tuhu_h5_lg'
  },
  7: { // 加油充值
    app: 'tuhu_app_jycz',
    h5: 'tuhu_h5_jycz'
  },
  8: { // 违章代缴
    app: 'tuhu_app_wzdj',
    h5: 'tuhu_h5_wzdj'
  },
  9: { // 钣金喷漆
    app: 'tuhu_app_bjpq',
    h5: 'tuhu_h5_bjpq'
  },
  10: { // 车险
    app: 'tuhu_app_cx',
    h5: 'tuhu_h5_cx'
  },
  11: { // 镭射眼
    app: 'tuhu_app_lsy',
    h5: 'tuhu_h5_lsy'
  },
  12: { // 售后
    app: 'tuhu_app_shouhou',
    h5: 'tuhu_h5_shouhou'
  }
};

var NewCustomerCare = function () {
  function NewCustomerCare(type) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, NewCustomerCare);

    var num = void 0;
    var productId = void 0;
    var orderId = void 0;

    if ((typeof type === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(type)) === 'object') {
      num = type.num;
      productId = type.productId;
      orderId = type.orderId;
    } else {
      num = type;
    }

    if (typeof +num !== 'number') {
      num = 0;
    }

    return this.init(num, productId, orderId);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(NewCustomerCare, [{
    key: 'init',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(num, productId, orderId) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var userinfo, uname, uid, receptionId, pcid, sdkkey, chatInfoType, chatInfoId, type;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return tuhu.getUserInfo();

                          case 2:
                            userinfo = _context.sent;
                            uname = userinfo.name || '';
                            uid = userinfo.userid || '';
                            receptionId = _this.getDictory(num);
                            pcid = _this.getGuid();
                            sdkkey = '4f1b5898f498a048ab2686fb68e6afa7';
                            chatInfoType = _this.getChatInfoType(productId, orderId);
                            chatInfoId = orderId || productId || '';
                            type = {
                              skillGroupNo: receptionId || 'tuhu_h5_lt', // 接待组ID
                              customerName: receptionId || 'tuhu_h5_lt', // 接待组ID 老版本兼容效果同skillGroupNo
                              containerId: '#app', // 必填
                              sdkkey: sdkkey, // 必填
                              pcid: pcid || '',
                              uid: uid || '',
                              uname: uname || '',
                              isvip: '',
                              userlevel: '',
                              isShow: false,
                              chatInfoType: chatInfoType,
                              chatInfoId: chatInfoId
                            };

                            resolve(type);

                          case 12:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x4, _x5) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'getChatInfoType',
    value: function getChatInfoType(productId, orderId) {
      if (orderId) {
        return 'order';
      } else if (productId) {
        return 'product';
      } else {
        return '';
      }
    }
  }, {
    key: 'getGuid',
    value: function getGuid() {
      var item = localStorage.getItem('guid');
      if (!item) {
        localStorage.setItem('guid', tuhu.util.uuid());
        return localStorage.getItem('guid');
      }
      return item;
    }
  }, {
    key: 'getDictory',
    value: function getDictory(num) {
      num = Number(num);

      if (typeof num === 'number') {
        // 对传值进行校验
        num = Math.floor(num);

        if (num < 0 || isNaN(num)) {
          num = 0;
        }
      } else {
        num = 0;
      }

      if (tuhu.device.isApp) {
        return newCustomerCareDictory[num].app;
      } else {
        return newCustomerCareDictory[num].h5;
      }
    }
  }]);

  return NewCustomerCare;
}();

Vue.directive('new-customer-care', {
  inserted: function inserted(el, arg) {
    $(el).on('click', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(arg.value === false)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt('return');

            case 2:
              new NewCustomerCare(arg.value).then(function (type) {
                localStorage.setItem('wapsdk', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(type)); // localStorage的名字为wapsdk，勿改，因为涉及到第三方拿数据
                tuhu.navigateTo({
                  url: '/pages/_newcustomer/index',
                  query: {
                    type: type
                  }
                });
              });

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    })));
  }
});

/***/ }),

/***/ "0KwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);







// 去保养页面
var toMaintenance = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var isApp, isAndroid, useMessage, androidParams, iosParams;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isApp = tuhu.device.isApp;
            isAndroid = tuhu.device.tuhuAndroid;
            _context.next = 4;
            return tuhu.getDefaultCar(5, false);

          case 4:
            useMessage = _context.sent;
            androidParams = {
              'baoyangType': '',
              'activityID': '',
              'isTuHuRecommend': 0,
              'baoyangcar': {
                'Brand': useMessage.Brand,
                'LIYANGID': useMessage.LiYangID,
                'Nian': useMessage.Nian,
                'Pailiang': useMessage.Pailiang,
                'TID': useMessage.TID,
                'TireSize': useMessage.TireSize,
                'Vehicle': useMessage.Vehicle,
                'ProductID': useMessage.ProductID,
                'ImageUrl': useMessage.ImageUrl,
                'PropertyList': useMessage.PropertyList
              }
            };
            iosParams = {
              'carID': useMessage.carID,
              'productID': useMessage.vehicleID,
              'brandImage': useMessage.brandImg,
              'brand': useMessage.brand,
              'vehicle': useMessage.vehicle,
              'displacement': useMessage.pailiang,
              'year': useMessage.nian,
              'engineType': useMessage.salesname,
              'TID': useMessage.tid,
              'carNewProprtyArray': useMessage.property
            };

            if (isApp) {
              if (isAndroid) {
                actionWidthAndroid('toBaoYang', androidParams);
              } else {
                location.href = 'tuhuaction://segue#Tuhu.THCarMaintainVC#' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(iosParams));
                // Utils.link(Config.SEND_TO_IOS + 'Tuhu.THCarMaintainVC#' + Utils.encodeParams(iosParams))
              }
            }

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function toMaintenance() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * author: 582196894@qq.com
 * date: 2017/10/26
 * desc: 所有和原生交互相关
 */
// const TWICE_SEND_TIME = 1000
var REQUEST_SEP = 300;

var getCallBackName = function () {
  var id = 0;

  return function () {
    return '_native_callback_' + id++;
  };
}();

var allResults = {};

function encodeParams(params) {
  return encodeURIComponent(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(params));
}

function actionWithIos(type) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (args.callback) {
    var callBackName = getCallBackName();
    window[callBackName] = args.callback;
    args.callback = callBackName;
  }
  try {
    if (window.webkit) {
      window.webkit.messageHandlers[type].postMessage(args);
    }
  } catch (error) {
    console.log(error);
  }
}

var device = function () {
  var appVersion = navigator.userAgent.match(/tuhu.+?(\d+\.\d+\.\d+)/);
  var browserVersion = navigator.userAgent.match(/version\/(.+?)\s/i);

  var tuhuIos = navigator.userAgent.indexOf('tuhuIOS') > -1;

  var tuhuAndroid = navigator.userAgent.indexOf('tuhuAndroid') > -1;

  return $.extend({}, $.device, {
    tuhuIos: tuhuIos,
    tuhuAndroid: tuhuAndroid,
    appVersion: appVersion ? appVersion[1] : '',
    browserVersion: browserVersion ? browserVersion[1] - 0 : '',
    isApp: tuhuIos || tuhuAndroid
  });
}();

function actionWidthAndroid(type) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var callback = args.callback;
  if (callback) {
    delete args.callback;
  }

  /** if ($.isEmptyObject(args)) {
    return window.WebViewJavascriptBridge.callHandler(type, {
      param: ''
    }, callback)
  } */

  return window.WebViewJavascriptBridge.callHandler(type, encodeURIComponent(encodeParams(args)), callback);
}

function deviceDetail() {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      return actionWidthAndroid('getDeviceID', {
        callback: function callback(data) {
          try {
            var main = JSON.parse(data);
            var detail = JSON.parse(main.track);
            delete main.track;

            return resolve(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, detail, main));
          } catch (e) {}

          resolve({});
        }
      });
    } else {
      return actionWithIos('getDeviceInfo', {
        callback: function callback(data) {
          resolve(data);
        }
      });
    }
  }).then(function (data) {
    /**
     * ios: {\"district\":\"\",\"city\":\"上海市\",\"is_gps_enabled\":true,\"screen_resolution\":\"375*667\",\"is_notify_enabled\":true,\"blackBox\":\"eyJ0b2tlbklkIjoiQmUxTDVjSVZyNGxXXC9lZlVheHpjUmY0RU9wTEtoV29GTXRSR0JPcFNTaUN4QjExTjgxdk4rSUoxdFZkT1FyUTFKNnJEcE9tSlBzdlBHNWxcL2N0cW8xUT09Iiwib3MiOiJpT1MiLCJwcm9maWxlVGltZSI6MzEwLCJ2ZXJzaW9uIjoiMy4wLjYifQ==\",\"os_name\":\"iOS\",\"lang\":\"zh\",\"network_status\":\"wifi\",\"model\":\"iPhone 6s\",\"province\":\"上海市\",\"device_model\":\"iPhone\",\"latitude\":31.1359252929688,\"device_type\":\"桂宇轩滴6s\",\"location\":\"31.1359252929688,121.402191162109\",\"device_carrier\":\"中国电信\",\"os_version\":\"10.3.3\",\"version\":\"5.1.0\",\"UDID\":\"D740AEED-7C44-45F9-BBA6-1E16FAB9E1A7\",\"longitude\":121.402191162109,\"country\":\"US\"}
     * android: {"blackBox":"eyJvcyI6ImFuZHJvaWQiLCJ2ZXJzaW9uIjoiMy4xLjEiLCJwYWNrYWdlcyI6ImNuLlR1SHUuYW5kcm9pZF81LjEuMCIsInByb2ZpbGVfdGltZSI6MTAyNjMsImludGVydmFsX3RpbWUiOjg0NzA1OTUsInRva2VuX2lkIjoic2hhYkd3YVJvYXFpZXdtWk5kUXFwNmlJZkNrS09GM1pHcHRYbmpCVTBzd242YzBodVNqOEZiSU9rRWVMbldzNFFabmRLWDRcL1p3OGp2bkl2R0xmWVNBPT0ifQ==","deviceId":"35e46291-7bab-3005-9954-f24103d106dc","deviceModel":"_huawei","deviceType":"HWVIE","deviceCarrier":"中国移动","isGpsEnabled":true,"isNotifyEnabled":"","lang":"zh","model":"VIE-AL10","osName":"HUAWEI","osVersion":"7.0","version":"5.1.0","netWork":"wifi","raw":{"device_type":"HWVIE","is_notify_enabled":false,"city":"上海市","client_time":1509003111,"event_type":"get_info","app_id":"android_app","screen_resolution":"1794x1080","app_name":"小鲲车服","network":"wifi","is_gps_enabled":true,"device_carrier":"中国移动","app_version":"5.1.0","country":"CN","event_action":"get_info","device_id":"35e46291-7bab-3005-9954-f24103d106dc","imei":"482eeb98e36e800252e45fa498747f17","location":"31.138903,121.409357","lang":"zh","device_model":"VIE-AL10","os_version":"7.0","metadata":"{\"Source\":\"_huawei\"}","level":"info","user_id":"{92acaaaf-07be-54d4-c741-4d6b306a4a3b}","os_name":"HUAWEI","deviceid":"35e46291-7bab-3005-9954-f24103d106dc","blackbox":"eyJvcyI6ImFuZHJvaWQiLCJ2ZXJzaW9uIjoiMy4xLjEiLCJwYWNrYWdlcyI6ImNuLlR1SHUuYW5kcm9pZF81LjEuMCIsInByb2ZpbGVfdGltZSI6MTAyNjMsImludGVydmFsX3RpbWUiOjg0NzA1OTUsInRva2VuX2lkIjoic2hhYkd3YVJvYXFpZXdtWk5kUXFwNmlJZkNrS09GM1pHcHRYbmpCVTBzd242YzBodVNqOEZiSU9rRWVMbldzNFFabmRLWDRcL1p3OGp2bkl2R0xmWVNBPT0ifQ==","channel":"_huawei"}}
     */
    var result = {};

    result.blackBox = data.blackBox || data.blackbox || '';
    result.deviceId = data.deviceid || data.UDID || '';
    result.deviceModel = data.channel || data.device_model || '';
    result.deviceType = data.device_type || '';
    result.deviceCarrier = data.device_carrier || '';
    result.isGpsEnabled = data.is_gps_enabled || '';
    result.isNotifyEnabled = data.is_notify_enabled || '';
    result.lang = data.lang || '';
    result.province = data.province || '';
    result.city = data.city || '';
    /** result.country = data.country || ''
    result.province = data.province || ''
    result.city = data.city || ''
    result.district = data.district || ''
    result.latitude = data.latitude || ''
    result.longitude = data.longitude || '' */
    result.model = data.model || data.device_model || '';
    result.osName = data.os_name || '';
    result.osVersion = data.os_version || '';
    result.version = data.version || data.app_version || '';
    result.netWork = data.network || data.network_status || '';
    result.raw = data;

    return result;
  });
}

function validatelogin(param) {
  if (device.tuhuAndroid) {
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      actionWidthAndroid('validateLogin', {
        callback: function callback() {
          resolve('success');
        },
        onlyLogout: !param.presentLogin // false 自动跳登陆 true 不跳
      });
    });
  }
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    actionWithIos('validateLogin', {
      callback: function callback() {
        resolve('success');
      },
      presentLogin: param.presentLogin // true 不跳 false 跳
    });
  });
}
function getUserInfo() {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      actionWidthAndroid('loginBridge', {
        callback: function callback(res) {
          var data = null;

          try {
            data = JSON.parse(res);
          } catch (e) {}
          resolve(data);
        }
      });
    } else {
      actionWithIos('getUserInfo', {
        callback: function callback(data) {
          resolve(data);
        }
      });
    }
  });
}

function forceLogin() {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      window.androidLoginSuccessFuc = function (data) {
        if (!data) {
          resolve(data);
        } else {
          return getUserInfo().then(function (data) {
            resolve(data);
          });
        }
      };
      actionWidthAndroid('actityBridgeNotRefresh');
    } else {
      actionWithIos('getUserInfo', {
        'callback': function callback(data) {
          window.webview_reactive = function () {};
          resolve(data);
        },
        'force': true
      });
      window.webview_reactive = function (data) {
        setTimeout(function () {
          resolve({});
        }, 200);
      };
    }
  });
}

function locate() {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      window.onLocationOK = function (locationInfo) {
        try {
          var data = JSON.parse(locationInfo);
          if (data.code === 1) {
            delete data.code;
            resolve(data);
          } else {
            resolve(null);
          }
        } catch (e) {
          resolve(null);
        }
      };

      return actionWidthAndroid('Location');
    } else {
      if (tuhu.compareVersion(tuhu.device.appVersion, '5.0.21') >= 0) {
        // 5.0.21以上版本，用新的webkit交互方式
        window.refreshLocationCallback = function (locationInfo) {
          try {
            resolve(locationInfo);
          } catch (e) {
            resolve(null);
          }
        };

        window.webkit.messageHandlers.refreshLocation.postMessage({ 'callback': 'refreshLocationCallback' });
      } else {
        return actionWithIos('refreshLocation', {
          callback: function callback(data) {
            resolve(data || null);
          }
        });
      }
    }
  });
}

function selectCar(args) {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      return actionWidthAndroid('ChangeCarFromH5', args);
    }
    // args.callback = function(data) {
    //   resolve(data)
    // }
    return actionWithIos('selectCar', {
      callback: function callback(data) {
        resolve(data);
      }
    });
  });
}

function carChange(item) {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      var params = {
        Brand: item.Brand,
        CarBrand: item.BrandType,
        CarName: item.CarName,
        SalesName: item.SalesName || '',
        Nian: item.Nian || '',
        PKID: item.CarID || '',
        PaiLiang: item.Pailiang || '',
        PropertyList: item.PropertyList && item.PropertyList.length > 0 && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(item.PropertyList) || '',
        TID: item.TID || '',
        TireSize: item.TireSize || '',
        TireSizeForSingle: item.TireSizeForSingle || '',
        VehicleID: item.ProductID || '',
        VehicleLogin: item.ImageUrl || '',
        VehicleName: item.Vehicle || '',
        IsDefaultCar: true,
        IsDelete: false,
        CarNumber: item.CarNumber || '',
        Registrationtime: item.Registrationtime || ''
      };
      params.callback = function (data) {
        resolve(data);
      };
      return tuhu.car.getCarList().then(function (data) {
        if (data && data.CarHistory && data.CarHistory.length > 0) {
          return actionWidthAndroid('carToNative', data.CarHistory[0]);
        }
        return actionWidthAndroid('carToNative', params);
      });
      // return actionWidthAndroid('carToNative', params)
    } else {
      // Brand: data.Brand,
      // BrandType: data.BrandType || data.CarBrand,
      // CarID: data.CarID || data.PKID || '',
      // CarName: data.CarName,
      // ImageUrl: data.ImageUrl || data.VehicleLogin,
      // IsDefaultCar: data.IsDefaultCar || true,
      // Nian: data.Nian || '',
      // Pailiang: data.Pailiang || data.PaiLiang,
      // ProductID: data.ProductID || data.VehicleID,
      // PropertyList: propertyList,
      // SalesName: data.SalesName || data.LiYangName || '',
      // TID: data.TID || '',
      // SpecialTireSize: data.SpecialTireSize || data.TireSizeForSingle || '',
      // TireSize: data.TireSize || data.Tires || '',
      // Vehicle: data.Vehicle || data.VehicleName || '',
      // raw: data
      var _params = {
        car: {
          Brand: item.Brand,
          BrandType: item.BrandType,
          CarName: item.CarName,
          ProductID: item.ProductID,
          CarID: item.CarID,
          ImageUrl: item.ImageUrl,
          IsDefaultCar: item.IsDefaultCar,
          PropertyList: item.PropertyList || [],
          Nian: item.Nian || '',
          Pailiang: item.Pailiang || '',
          SalesName: item.SalesName || '',
          TID: item.TID || '',
          TireSize: item.TireSize || '',
          TireSizeForSingle: item.TireSizeForSingle || '',
          Vehicle: item.Vehicle,
          CarNumber: item.CarNumber || '',
          Registrationtime: item.Registrationtime || ''
        },
        callback: function callback(data) {}
      };

      return actionWithIos('saveCar', _params);
    }
  });
}

function share(params) {
  if (device.tuhuAndroid) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(actionWidthAndroid('initH5Sharedata', params));
  }

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(actionWithIos('setShare', params));
}
// 分享埋点信息
function handleTaShareChannel(value) {
  if (tuhu.device.tuhuIos) {
    switch (value) {
      case 1:
        return {
          eventID: 'ClickWXHY',
          platform: '微信好友'
        };

      case 2:
        return {
          eventID: 'ClickPYQ',
          platform: '微信朋友圈'
        };

      case 4:
        return {
          eventID: 'ClickWEIBO',
          platform: '新浪微博'
        };

      case 8:
        return {
          eventID: 'ClickQQ',
          platform: 'QQ'
        };

      case 16:
        return {
          eventID: 'ClickQQKJ',
          platform: 'QQ空间'
        };

      case 64:
        return {
          eventID: 'ClickMSM',
          platform: '短信'
        };
    }
  } else if (tuhu.device.tuhuAndroid) {
    switch (JSON.parse(value).platform) {
      case 'WEIXIN_CIRCLE':
        return {
          eventID: 'ClickPYQ',
          platform: '微信朋友圈'
        };

      case 'WEIXIN':
        return {
          eventID: 'ClickWXHY',
          platform: '微信好友'
        };

      case 'QQ':
        return {
          eventID: 'ClickQQ',
          platform: 'QQ'
        };

      case 'QZONE':
        return {
          eventID: 'ClickQQKJ',
          platform: 'QQ空间'
        };

      case 'SINA':
        return {
          eventID: 'ClickWEIBO',
          platform: '新浪微博'
        };
    }
  }
}
function sharePanel(params) {
  // 唤起分享 埋点
  Ta.ta('event', 'home_click_share', {
    'channel': tuhu.device.tuhuAndroid ? 'Android' : 'IOS'
  });
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    params.callback = function (data) {
      // 分享回调埋点
      Ta.ta('event', 'home_click_' + handleTaShareChannel(data).eventID, {
        'platform': handleTaShareChannel(data).platform
      });
      resolve({
        'success': true,
        'platform': handleTaShareChannel(data).platform,
        'channel': tuhu.device.tuhuAndroid ? 'Android' : 'IOS'
      });
    };

    if (tuhu.device.tuhuAndroid) {
      return actionWidthAndroid('toShareMediaNew', params);
    }

    return actionWithIos('newShare', params);
  });
}

function getCar() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      params.callback = function (data) {
        resolve(data);
      };

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(params, {
        carLevel: 0,
        isNeedCar: 0
      });
      return actionWidthAndroid('getCar', params);
    }

    window.getCar = function (data) {
      resolve(data);
    };

    return actionWithIos('getDefaultCar');
  });
}

function checkThirdApp() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (device.tuhuAndroid) {
      params.callback = function (data) {
        resolve(data);
      };

      return actionWidthAndroid('checkThirdApp', params);
    } else {
      window.checkAppInstallCallback = function (data) {
        resolve(data);
      };

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(params, { callback: window.checkAppInstallCallback });
      return actionWithIos('tryOpenUrl', params);
    }
  });
}

function toWeiZhang() {
  // if (tuhu.device.tuhuAndroid) {
  //   location.href = 'tuhu:///carProfile/trafficViolation/edit'
  // } else {
  //   location.href = 'tuhu:/carProfile/trafficViolation/result'
  // }

  location.href = 'tuhu:/carProfile/trafficViolation/result';

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(null);
}

function openBank(res) {
  if (tuhu.device.tuhuAndroid) {
    // Utils.link(BaseConfig.SEND_TO_IOS + "THOrderCashiersVC#" + encodeURIComponent(JSON.stringify({
    //   casgiersData: res,
    //   orderNumber: res.PayInfo.OrderNO
    // })))
    actionWidthAndroid('toActityBridge', {
      'FunctionID': 'cn.TuHu.Activity.OrderSubmit.PayOrderConfirm',
      // 'SerialNumbers': res.PayInfo.SerialNumbers || '',
      // 'PayAmount': res.PayInfo.Price || '',
      // 'subject': res.PayInfo.Title || '',
      // 'body': res.PayInfo.Body || '',
      'OrderNO': res.PayInfo.OrderNO,
      'CallBackUrl': res.PayInfo.CallBackUrl || ''
    });
  } else {
    location.href = 'tuhuaction://segue#THOrderCashiersVC#' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()({
      casgiersData: res,
      orderNumber: res.PayInfo.OrderNO,
      CallBackUrl: res.PayInfo.CallBackUrl || ''
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(null);
}

function closeWebview() {
  if (device.tuhuAndroid) {
    actionWidthAndroid('Close', {
      callback: function callback() {}
    });
  } else {
    actionWithIos('close');
  }
}

function toCoupons() {
  location.href = 'tuhu:/coupons';

  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(null);
}

function toShopDetail(args) {
  // 跳原生门店详情页
  var shopId = args.shopId,
      pid = args.pid,
      type = args.type; // 0-全部，1-轮胎，2-保养，3-7-美容团购(3不用了)，4-安装，5 喷漆 6-改装

  var url = 'tuhu:///shop?shopID=' + shopId + '&positionShopType=' + type + '&positionCategoryId=' + pid;

  location.href = url;
}

function toChepinDetail(args) {
  // 跳原生车品详情页
  var _args$ProductID$split = args.ProductID.split('|'),
      _args$ProductID$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_args$ProductID$split, 2),
      productID = _args$ProductID$split2[0],
      vID = _args$ProductID$split2[1];

  var url = 'tuhu:/accessory/item?pid=' + productID + '&vid=' + vID;

  location.href = url;
}

// 去订单成功页面
function toOrderResult(args) {
  var OrderId = args.OrderId;

  tuhu.router.goPayRouter(true);

  if (tuhu.device.tuhuAndroid) {
    var param = {
      'FunctionID': 'cn.TuHu.Activity.OrderSubmit.OrderInfoSuccess',
      'OrderNO': OrderId,
      'OrderTypeIndex': 2
    };
    actionWidthAndroid('toActityBridge', param);
  } else if (tuhu.device.tuhuIos) {
    var _param = {
      finishOrderID: OrderId + '',
      orderType: 2,
      segueType: 1
    };
    location.href = 'tuhuaction://segue#Tuhu.THFinishOrderVC#' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(_param));
  }
}
// 去选择门店列表
function toShop(args) {
  var pids = args.pids;

  if (tuhu.device.tuhuAndroid) {
    var param = {
      'androidKey': 'tuhu:///placeOrder/selectShop?ShowType=1&serviceType=2&pids=' + pids + '&ShowType=1',
      'androidValue': '',
      'callback': window.shopCallBack
    };
    actionWidthAndroid('toGetOrderShopNew', param);
  } else if (tuhu.device.tuhuIos) {
    window.currentObj = {
      shopCallBack: window.shopCallBack
    };

    location.href = 'tuhuaction://selectShop#' + pids + '##window.shopCallBack';
  }
}
// 跳文章评论
function toArticleComment(args) {
  var id = args.id;

  if (tuhu.device.tuhuIos) {
    window.location.href = 'tuhu:/explore/article/comment?pkid=' + id;
  } else if (tuhu.device.tuhuAndroid) {
    window.location.href = 'tuhu:/explore/article/comment?id=' + id;
  }
}
// 跳转商品详情
function toProduct(args) {
  var pid = args.pid;

  var flag = pid.substring(0, 2);
  var arr = pid.split('|');
  if (flag === 'TR') {
    location.href = 'tuhu:/tire/item?pid=' + arr[0] + '&vid=' + arr[1];
  } else if (flag === 'LG') {
    location.href = 'tuhu:/wheelRim/item?pid=' + arr[0] + '&vid=' + arr[1];
  } else {
    location.href = 'tuhu:/accessory/item?pid=' + arr[0] + '&vid=' + arr[1];
  }
}
function actionWithNative(name) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!tuhu.device.isApp || location.href.indexOf('resource.html') > -1) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(null);
  }

  // let count = 0
  var key = name + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(args);
  if (allResults[key]) {
    if (+new Date() - allResults[key].time < REQUEST_SEP) {
      return allResults[key].result;
    }

    delete allResults[key];
  }

  return function _actionWithNative() {
    var result = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(null);
    switch (name) {
      case 'getUserInfo':
        result = getUserInfo();
        break;
      case 'forceLogin':
        result = forceLogin();
        break;
      case 'deviceDetail':
        result = deviceDetail();
        break;
      case 'locate':
        result = locate();
        break;
      case 'selectCar':
        result = selectCar(args);
        break;
      case 'carChange':
        result = carChange(args);
        break;
      case 'getCar':
        result = getCar(args);
        break;
      case 'share':
        result = share(args);
        break;
      case 'sharePanel':
        result = sharePanel(args);
        break;
      case 'toWeiZhang':
        result = toWeiZhang();
        break;
      case 'openBank':
        result = openBank(args);
        break;
      case 'closeWebview':
        result = closeWebview();
        break;
      case 'toCoupons':
        result = toCoupons();
        break;
      case 'toMaintenance':
        result = toMaintenance();
        break;
      case 'toOrderResult':
        result = toOrderResult(args);
        break;
      case 'toShop':
        result = toShop(args);
        break;
      case 'toArticleComment':
        result = toArticleComment(args);
        break;
      case 'toProduct':
        result = toProduct(args);
        break;
      case 'toShopDetail':
        result = toShopDetail(args);
        break;
      case 'toChepinDetail':
        result = toChepinDetail(args);
        break;
      case 'validatelogin':
        result = validatelogin(args);
        break;
      case 'checkThirdApp':
        result = checkThirdApp(args);
        break;
    }

    // const timeout = setTimeout(function () {
    //   /* if (['selectCar', 'forceLogin', 'getCar', 'carChange', 'sharePanel', 'toWeiZhang', 'openBank', 'closeWebview'].indexOf(name) < 0 && count++ < 1) {
    //     _actionWithNative()
    //   } */
    //   if (['getUserInfo', 'deviceDetail', 'locate'].indexOf(name) > -1 && count++ < 1) {
    //     _actionWithNative()
    //   }
    // }, TWICE_SEND_TIME)

    var ret = result.then(function (data) {
      // clearTimeout(timeout)

      return data;
    });

    allResults[key] = {
      result: ret,
      time: +new Date()
    };

    return ret;
  }();
}

function actionWithAll(name) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!tuhu.device.isApp || location.href.indexOf('resource.html') > -1) {
    // h5 环境下
    if (name === 'toMaintenance') {
      tuhu.navigateTo({
        url: '/pages/maintenance/index'
      });
    } else if (name === 'toOrderResult') {
      tuhu.router.goPayRouter(true);

      tuhu.navigateTo({
        url: '/pages/order/orderResult',
        query: {
          i: args.OrderId,
          orderType: 1
        }
      });
    } else if (name === 'toShop') {
      return tuhu.changeShop({
        serviceType: args.serviceType, // 门店类型 1 轮胎 2 保养 4 服务
        pids: args.pids, // pids
        activityId: '', // 活动id
        shopId: args.shopId // 默认门店id
      });
    } else if (name === 'toShopDetail') {
      tuhu.navigateTo({
        url: '/pages/shops/detail',
        data: args,
        query: {
          shopId: args.shopId,
          ProductID: args.pid,
          serviceType: args.type || 0 // 0-全部，1-轮胎，2-保养，3-7-美容团购(3不用了)，4-安装，5 喷漆 6-改装
        }
      });
    } else if (name === 'toChepinDetail') {
      tuhu.navigateTo({
        url: '/pages/chepin/detail',
        query: {
          pid: args.ProductID,
          actid: ''
        }
      });
    }
    // if (name === 'openBank') {
    //   let url = 'https://wx.tuhu.cn/order/PayWay?i=' + args.OrderNO.replace(/^TH/, '')
    //   location.replace(url)
    // }
  } else {
    // 在原生环境下
    try {
      actionWithNative(name, args);
    } catch (error) {
      console.log(error);
    }
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  actionWithNative: actionWithNative,
  device: device,
  actionWithAll: actionWithAll,
  getDeviceDetail: function getDeviceDetail() {
    return actionWithNative('deviceDetail');
  },
  newWebView: function newWebView(url) {
    if (this.device.tuhuIos) {
      location.href = 'tuhu:/webView?url=' + encodeURIComponent(url);
    } else if (this.device.tuhuAndroid) {
      location.href = 'tuhu:/webView?url=' + encodeURIComponent(encodeURIComponent(url));
    }
  }
});

/***/ }),

/***/ "0NVO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0jmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('section',{staticClass:"year-record"},[_c('img',{staticClass:"bg",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/e41a13db2d4b41f181bff1e5aa73a44e.png","alt":"","srcset":""}}),_vm._v(" "),_c('section',{staticClass:"page-content"},[_c('RecordList',{attrs:{"dataList":_vm.dataList,"tabList":_vm.tabList},on:{"goPage":_vm.goPage},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('section',{staticClass:"check-block"},[_c('span',[_vm._v(_vm._s(_vm.queryYear)+"年")]),_vm._v(" "),(_vm.yearList.length)?_c('div',{staticClass:"img",on:{"click":_vm.change}},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/3b171fa3213d4eb79958069853792c0e.png","alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"year-list",style:({ display: _vm.isOpen ? 'block' : 'none' })},_vm._l((_vm.yearList),function(item){return _c('div',{key:item,style:({ background: _vm.queryYear === item ? '#f5f5f5' : '' }),on:{"click":function($event){return _vm.oncheck(item)}}},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}),0)])]},proxy:true}])})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0lA4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0q08":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_2.ee6a91a.png";

/***/ }),

/***/ "1H7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1HAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"result"},[_c('img',{staticClass:"icon1",attrs:{"src":_vm.isSucess ? _vm.icon1 : _vm.icon2,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.isSucess ? '券码核销成功' : '券码核销失败'))]),_vm._v(" "),(_vm.isSucess)?_c('p',{staticClass:"text"},[_vm._v("核销券数"),_c('span',[_vm._v(_vm._s(_vm.dataInfo.verifyNum))]),_vm._v("张，核销收入"),_c('span',[_vm._v("￥"+_vm._s(_vm.dataInfo.verifyIncome))])]):_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.tips||'请联系您的商户专员或小鲲车服客服处理！'))])]),_vm._v(" "),(_vm.isSucess)?_c('div',{staticClass:"goods"},[_c('div',{staticClass:"cell-goods"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.dataInfo.goodsImg,"alt":"暂无图片"}}),_vm._v(" "),_c('div',{staticClass:"cell-flex"},[_c('p',{staticClass:"one-limit cell-name"},[_vm._v(_vm._s(_vm.dataInfo.title))]),_vm._v(" "),_c('p',{staticClass:"cell-price"},[_vm._v("结算单价"),_c('span',[_vm._v("￥"+_vm._s(_vm.dataInfo.settlementPrice))])])])]),_vm._v(" "),_vm._l((_vm.dataInfo.detail),function(item,index){return _c('div',{key:index,staticClass:"cell-code"},[_c('div',{staticClass:"code code-num"},[_c('p',{staticClass:"code-code"},[_vm._v("券码："+_vm._s(item.certificateId))]),_vm._v(" "),(item.status == 'ORDER_FINISH')?_c('p',{staticClass:"code-status"},[_vm._v("已核销")]):(item.status == 'CANCEL')?_c('p',{staticClass:"code-status code-status-grey"},[_vm._v("已撤销核销")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"code code-desc"},[_c('p',{staticClass:"code-text"},[_vm._v("核销1小时内可以撤销核销")]),_vm._v(" "),(item.status == 'ORDER_FINISH')?_c('p',{staticClass:"code-btn",on:{"click":function($event){_vm.currentItem = item; _vm.isShow = true}}},[_vm._v("\n                            撤销核销")]):_vm._e()])])})],2):_c('div',{staticClass:"err-btn"},[_c('p',{directives:[{name:"call",rawName:"v-call"}]},[_vm._v("联系客服")]),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.toHome()}}},[_vm._v("返回首页")])])]),_vm._v(" "),(_vm.isSucess)?_c('div',{staticClass:"footer"},[_c('p',{on:{"click":function($event){return _vm.toView()}}},[_vm._v("查看核销明细")]),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.toHome()}}},[_vm._v("返回首页")])]):_vm._e()]),_vm._v(" "),_c('van-dialog',{staticClass:"dialog-result",attrs:{"title":"撤销当前核销？","showCancelButton":"","confirmButtonText":"确认撤销","cancelButtonText":"暂不撤销","get-container":".day-record"},on:{"confirm":_vm.sureRevoke},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"text"},[_vm._v("\n            请和消费者确认后再进行撤销操作，撤销后该订单将不计入核销订单和核销收入。\n        ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1How":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_storage__ = __webpack_require__("lqPF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shopInfo__ = __webpack_require__("Cntp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_image_defaultShopImg_png__ = __webpack_require__("+9Lz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_image_defaultShopImg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgs_image_defaultShopImg_png__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var urlTypes = [{
  urlType: "business_license",
  imgUrl: "",
  name: "营业执照"
}, {
  urlType: "working_area",
  imgUrl: "",
  name: "工位图"
}, {
  urlType: "rest_area",
  imgUrl: "",
  name: "休息区"
}, {
  urlType: "other",
  imgUrl: "",
  name: "其他形象图"
}];

function getRange(all) {
  var arr = [];
  var c = all === 24 ? "时" : "分";
  for (var i = 0; i < all; i++) {
    if (i < 10) {
      arr.push("0" + i + c);
    } else {
      arr.push(i + c);
    }
  }
  return arr;
}
var hours = getRange(24);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    shopInfo: __WEBPACK_IMPORTED_MODULE_5__components_shopInfo__["a" /* default */]
  },
  data: function data() {
    return {
      visibleShop: false,
      defaultImg: __WEBPACK_IMPORTED_MODULE_6__imgs_image_defaultShopImg_png___default.a,
      shopHeadImg: "",
      shopStatusData: {}, // 营业状态
      shopBasicData: {}, // 基本信息
      shopMerchantData: {}, // 店铺信息
      shopCompanyData: {}, // 企业信息
      CertificatePhotoData: urlTypes, // 证照店照
      checked: true,
      workTime: "", // 营业时间
      workStartTime: "", // 营业开始时间
      workEndTime: "", // 营业结束时间
      showPicker: false,
      showPicker2: false,
      columns: [
      // 第一列
      {
        values: hours,
        defaultIndex: 2
      },
      // 第二列
      {
        values: ["00分", "30分"],
        defaultIndex: 1
      },
      // 第三列
      {
        values: ["-"],
        defaultIndex: 1
      },
      // 第4列
      {
        values: hours,
        defaultIndex: 1
      },
      // 第5列
      {
        values: ["00分", "30分"],
        defaultIndex: 1
      }],
      active: 0, // 当前第几个tab
      showEdit: false,
      title: "",
      tabList1: [{
        name: "员工权限",
        url: "/pages/changeShopInfo/index"
      }]
    };
  },
  created: function created() {
    this.getShopInfo();
    this.getShopBasicInfo();
    this.getMerchantInfo();
    this.getCompanyInfo();
    this.getCertificatePhoto();
    this.ShowTab();
  },

  // mounted() {
  // 	if (window.history && window.history.pushState) {
  //     // 向历史记录中插入了当前页
  //     // history.pushState(null, null, document.URL)
  //     window.addEventListener('popstate', this.goBack, false)
  // 	}
  // },
  // destroyed () {
  // 	window.removeEventListener('popstate', this.goBack, false)
  // },
  computed: {
    shopInfo: function shopInfo() {
      return tuhu.store.state.currentShopInfo;
    },
    shopId: function shopId() {
      return this.shopInfo ? this.shopInfo.shopId : tuhu.getParam("shopId");
    }
  },
  methods: {
    // goBack () {
    // 	console.log('点击了浏览器的返回按钮')
    // 	window.location.href = '/pages/home/index'
    // },
    ShowTab: function ShowTab() {
      if (__WEBPACK_IMPORTED_MODULE_4__commons_storage__["a" /* localStorage */].get("shopinfo_showtab")) {
        this.active = __WEBPACK_IMPORTED_MODULE_4__commons_storage__["a" /* localStorage */].get("shopinfo_showtab");
      }
    },

    // 修改按钮
    showTabs: function showTabs() {
      var _this = this;

      this.showEdit = true;
      this.active = this.active + 1;
      setTimeout(function () {
        _this.active = _this.active - 1;
      }, 0);
    },

    // 子元素当前tab数
    changeTabInfo: function changeTabInfo(i) {
      this.active = i;
    },
    upload: function upload(val) {
      if (val && val.code === '200' && val.data) {
        this.shopHeadImg = val.data;
        this.changeShopDoorImg(val.data);
      }
    },
    changeShopDoorImg: function changeShopDoorImg(url) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_DOOR_URL, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this2.shopId,
                    url: url
                  })
                });

              case 3:
                data = _context.sent;

                if (data && data.code === '200') {
                  tuhu.toast("门头照片更换成功");
                } else {
                  tuhu.toast(data.message || "网络错误");
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    getShopInfo: function getShopInfo() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_OPEN_INFO, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this3.shopId
                  })
                });

              case 2:
                data = _context2.sent;

                if (data && data.code === '200') {
                  _this3.shopStatusData = data.data;
                  _this3.shopHeadImg = data.data.doorPhoto || __WEBPACK_IMPORTED_MODULE_6__imgs_image_defaultShopImg_png___default.a;
                  // 门店状态
                  if (data.data.shopStatus === 1) {
                    _this3.checked = true;
                  } else {
                    _this3.checked = false;
                  }
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getShopBasicInfo: function getShopBasicInfo() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_BASIC_INFO, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this4.shopId
                  })
                });

              case 2:
                data = _context3.sent;

                if (data && data.code === '200') {
                  _this4.shopBasicData = data.data;
                  // console.log('this.shopBasicData', this.shopBasicData)
                  _this4.$nextTick(function () {
                    _this4.renderShopMap(data.data);
                  });
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    renderShopMap: function renderShopMap(info) {
      var data = {
        lat: info.shopLatitude || 31.1364283468,
        lng: info.shopLongitude || 121.3640087132,
        name: info.shopName || "小鲲车服测试门店",
        address: info.shopAddress || "上海市徐汇区罗秀路105号（近平福路路口）"
      };
      this.$refs.shopInfoRef.initMap(data);
      // window._locateToData = data;
      // let src = "/static/locateline.html?isLocate=1";
      // if (location.host.indexOf("47.99.172.20") > -1) {
      //   // src = 'https://www.xiaokunkeji.cn/user/vue/locateline.html?isLocate=1'
      //   src = `${config.apis.RENDER_MAP}`;
      // }
      // const iframe = $(
      //   `<iframe width="100%" height="100%" frameborder="0" src="${src}"></iframe>`
      // );
      // $("#shop-map").empty();
      // $("#shop-map").append(iframe);
    },
    getMerchantInfo: function getMerchantInfo() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_MERCHANT_INFO, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this5.shopId
                  })
                });

              case 2:
                data = _context4.sent;

                if (data && data.code === '200') {
                  _this5.shopMerchantData = data.data;
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getCompanyInfo: function getCompanyInfo() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_COMPANY_INFO, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this6.shopId
                  })
                });

              case 2:
                data = _context5.sent;

                if (data && data.code === '200') {
                  _this6.shopCompanyData = data.data;
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    getCertificatePhoto: function getCertificatePhoto() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data, arr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_CERTIFICATE_PHOTO, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this7.shopId
                  })
                });

              case 2:
                data = _context6.sent;

                if (data && data.code === '200') {
                  arr = data.data || [];

                  arr.forEach(function (item) {
                    item["name"] = item.urlType === urlTypes[0].urlType ? urlTypes[0].name : item.urlType === urlTypes[1].urlType ? urlTypes[1].name : item.urlType === urlTypes[2].urlType ? urlTypes[2].name : item.urlType === urlTypes[3].urlType ? urlTypes[3].name : "";
                  });
                  _this7.CertificatePhotoData = arr;
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    onConfirm: function onConfirm(value) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var Time, shopId, workStartTime, workEndTime, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.workTime = value.toString().replace(/,/g, "").replace("时", ":").replace("时", ":").replace("分", "").replace("分", "");
                _this8.showPicker = false;
                _this8.showPicker2 = true;
                Time = _this8.workTime.split("-");

                _this8.workStartTime = Time[0];
                _this8.workEndTime = Time[1];
                shopId = _this8.shopId, workStartTime = _this8.workStartTime, workEndTime = _this8.workEndTime;
                _context7.next = 9;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_BUSINESS_HOURS + "?shopId=" + shopId + "&openingTime=" + workStartTime + "&closingTime=" + workEndTime);

              case 9:
                data = _context7.sent;

                if (data && data.code === '200') {
                  tuhu.toast("设置成功");
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    onInput1: function onInput1() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.visibleShop = true;
                // let checked = this.checked;
                // if (checked) {
                //   this.visibleShop = true;
                // } else {
                //   const data = await tuhu.fetch(
                //     `${config.apis.GET_SHOP_STATUS}?shopId=${this.shopId}&shopStatus=${
                //       this.checked ? 0 : 1
                //     }`
                //   );
                //   if (data && data.code === '200') {
                //     tuhu.toast("修改门店营业状态成功");
                //     console.log("原本3", this.checked);
                //     console.log("原本4", checked);
                //     // tuhu.store.commit('setCurrentShopInfo', Object.assign(this.shopInfo, { shopStatus: this.checked ? 0 : 0 }))
                //     // window.pagesHomeVUe.setShopStatus(this.checked ? 1 : 0)
                //     this.checked = !checked;
                //   }
                // }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    }
  }
});

/***/ }),

/***/ "1SyJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_order.65d24cd.png";

/***/ }),

/***/ "1bfi":
/***/ (function(module, exports) {

/**
 * author: caominjie@tuhu.cn
 * date: 2017/11/16
 * docs:
 * tel: 电话号码 (不必填) 默认值为 400-176-8848
 * eg: <a href="#" v-call>客服电话</a>
 */
/**
 * 获取当前电话号码
 * @param {Object} arg - 指令参数
 * @returns {string} 电话号码
 */
function getTel(arg) {
  // 支持 v-call="'13800000000'" 和 v-call="{tel: '13800000000'}" 两种写法
  if (typeof arg.value === 'string') return arg.value;
  return arg.value && arg.value.tel || '400-176-8848';
}

Vue.directive('call', {
  /**
   * 元素插入时绑定点击事件
   * @param {HTMLElement} el - 绑定的元素
   * @param {Object} arg - 指令参数
   */
  inserted: function inserted(el, arg) {
    el._callTel = getTel(arg);
    el._callLock = tuhu.util.lockFn();

    /**
     * 执行拨号操作
     * @param {string} tel - 电话号码
     */
    var doCall = function doCall(tel) {
      if (tuhu.isLightApp) {
        window.location.href = 'tel:' + tel;
      } else {
        var deviceInfo = tuhu.device;
        if (deviceInfo && deviceInfo.iphone) {
          window.location.href = 'tel://' + tel;
        } else {
          window.location.href = 'tel:' + tel;
        }
      }
    };

    // 点击事件处理函数，便于后续解绑
    el._callHandler = function () {
      el._callLock(function () {
        return doCall(el._callTel);
      });
    };

    el.addEventListener('click', el._callHandler);
  },
  /**
   * 组件更新时同步最新的电话号码
   * @param {HTMLElement} el - 绑定的元素
   * @param {Object} arg - 指令参数
   */
  componentUpdated: function componentUpdated(el, arg) {
    el._callTel = getTel(arg);
  },
  /**
   * 指令解绑时清理事件监听，防止内存泄漏
   * @param {HTMLElement} el - 绑定的元素
   */
  unbind: function unbind(el) {
    if (el._callHandler) {
      el.removeEventListener('click', el._callHandler);
      el._callHandler = null;
    }
    el._callTel = null;
    el._callLock = null;
  }
});

/***/ }),

/***/ "1g47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"shopWrap"},[_c('div',{staticClass:"tabsList"},[_c('div',{staticClass:"tabsItem area",class:_vm.tabsSelectedType === 'area' ? 'selected':'',on:{"click":function($event){$event.stopPropagation();return _vm.handleClickTabsItem("area")}}},[_c('div',{staticClass:"tabTitle"},[_c('span',{},[_vm._v(_vm._s(_vm._f("fliterLocateNull")(_vm.cityTabTitle)))]),_c('i')]),_vm._v(" "),_c('div',{staticClass:"arealist",class:_vm.tabsSelectedType === 'area' ? 'block':'none'},[_c('div',{staticClass:"areaExpanded"},[_c('div',{staticClass:"otherCity",on:{"click":function($event){$event.stopPropagation();}}},[_c('span',{on:{"click":_vm.switchCity}},[_vm._v("选择其他城市")])]),_vm._v(" "),_c('ul',_vm._l((_vm.areas),function(item,index){return _c('li',{key:index,class:{'selected': _vm.isCitySelected(item)},on:{"click":function($event){$event.stopPropagation();return _vm.handleClickCity(item.Region)}}},[_c('i',{domProps:{"textContent":_vm._s(item.Region)}}),_c('span',{domProps:{"textContent":_vm._s(item.Count)}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tabsItem sort",class:_vm.tabsSelectedType === 'sort' ? 'selected':'',on:{"click":function($event){$event.stopPropagation();return _vm.handleClickTabsItem("sort")}}},[_c('div',{staticClass:"tabTitle"},[_c('span',[_vm._v(_vm._s(_vm.sortTabTitle))]),_c('i')]),_vm._v(" "),_c('div',{staticClass:"shopsortlist",class:_vm.tabsSelectedType === 'sort' ? 'block':'none'},[_c('div',{staticClass:"shopsortExpanded"},[_c('ul',_vm._l((_vm.sort),function(item,index){return _c('li',{key:index,class:item.select?'selected':'',on:{"click":function($event){$event.stopPropagation();return _vm.handleClickSort(item.sort)}}},[_c('i',{domProps:{"textContent":_vm._s(item.text)}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"tabsItem type",class:_vm.tabsSelectedType === 'type' ? 'selected':'',on:{"click":function($event){$event.stopPropagation();return _vm.handleClickTabsItem("type")}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"Typelist",class:_vm.tabsSelectedType === 'type' ? 'block':'none',on:{"click":function($event){$event.stopPropagation();return _vm.handelClickCover($event)}}},[_c('div',{staticClass:"TypeExpanded"},[_c('div',{staticClass:"shopType"},[_vm._v("门店种类")]),_vm._v(" "),_c('ul',_vm._l((_vm.ShopClassifications),function(item,index){return _c('li',{key:index,class:_vm.selectedShopTypes.indexOf(item) !== -1?'selected':'',domProps:{"textContent":_vm._s(item)},on:{"click":function($event){$event.stopPropagation();return _vm.handleClickType(item)}}})}),0),_vm._v(" "),_c('div',{staticClass:"typeButton"},[_c('div',{staticClass:"reset",on:{"click":function($event){$event.stopPropagation();return _vm.resetTypeButton($event)}}},[_vm._v("重置")]),_vm._v(" "),_c('div',{staticClass:"submit",on:{"click":function($event){$event.stopPropagation();return _vm.submitTypeButton($event)}}},[_vm._v("确定")])])])])])]),_vm._v(" "),_c('div',{staticClass:"locateAdd"},[_c('div',{staticClass:"locate"},[_vm._v(_vm._s(_vm._f("fliterLocateNull")(_vm.locateName)))])]),_vm._v(" "),_c('div',{staticClass:"scrollContent"},[_c('tuhu-infinite',{attrs:{"nodata":_vm.nodata,"endmsg":"到底了哦","distance":100,"end":_vm.end,"id":_vm.scrollId},on:{"oninfinite":_vm.oninfinite}},[_c('div',{staticClass:"shopList",attrs:{"slot":"content"},slot:"content"},[_c('ul',_vm._l((_vm.shopList),function(item,index){return _c('li',{key:item.ShopId,on:{"click":function($event){return _vm.autoNavigate(item)}}},[_c('div',{staticClass:"shopItem"},[(item.IsSuspend)?_c('div',{staticClass:"leftImg zanting"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item.Images[0],width:'3.2'}),expression:"{src:item.Images[0],width:'3.2'}"}]})]):(item.Summary  === '1' )?_c('div',{staticClass:"leftImg kaiye"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item.Images[0],width:'3.2'}),expression:"{src:item.Images[0],width:'3.2'}"}]})]):_c('div',{staticClass:"leftImg"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item.Images[0],width:'3.2'}),expression:"{src:item.Images[0],width:'3.2'}"}]})]),_vm._v(" "),_c('div',{staticClass:"rightText"},[_c('div',{staticClass:"shopTitle"},[_c('span',{staticClass:"name",domProps:{"textContent":_vm._s(item.CarparName)}}),_vm._v(" "),_c('span',{staticClass:"distance"},[_vm._v(_vm._s(_vm._f("filterDistance")(item.Distance)))])]),_vm._v(" "),_c('div',{staticClass:"address"},[_c('span',{staticClass:"addInfo",domProps:{"textContent":_vm._s(item.Address)}})]),_vm._v(" "),_c('div',{staticClass:"tags"},[((item.ShopType & 512)  === 512)?_c('span',{staticClass:"gcd"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.gcd}),expression:"{src:gcd}"}]})]):_vm._e(),_vm._v(" "),(((item.ShopType & 512)  !== 512) && item.ShopClassification === '维修厂')?_c('span',{staticClass:"wxc"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.wxc}),expression:"{src:wxc}"}]})]):_vm._e(),_vm._v(" "),(((item.ShopType & 512)  !== 512 ) &&  item.ShopClassification === '快修店')?_c('span',{staticClass:"kxd"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.kxd}),expression:"{src:kxd}"}]})]):_vm._e(),_vm._v(" "),((item.ShopCertification & 8 )=== 8)?_c('span',{staticClass:"mfjc"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.mfjc}),expression:"{src:mfjc}"}]})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"crd"},[(!item.InstallNow && item.NextDayArrival)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.crd}),expression:"{src:crd}"}]}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"msz"},[(item.InstallNow)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.msz}),expression:"{src:msz}"}]}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"itemInfo"},[_c('div',{staticClass:"allPingjia"},[_vm._v("评分"),_c('span',{domProps:{"textContent":_vm._s(item.CommentRate)}})]),_vm._v(" "),_c('div',{staticClass:"allOrder"},[_vm._v("单数"),_c('span',{domProps:{"textContent":_vm._s(item.InstallQuantity)}})])]),_vm._v(" "),(index === 0 &&  _vm.hasDefalutShop)?_c('div',{staticClass:"redselect selected",on:{"click":function($event){$event.stopPropagation();return _vm.changeShop(item)}}},[_vm._v("\n                    已选择\n                  ")]):_c('div',{staticClass:"redselect",on:{"click":function($event){$event.stopPropagation();return _vm.changeShop(item)}}},[_vm._v("选择")])])])])}),0)])])],1)]),_vm._v(" "),_c('tuhu-gotop',{attrs:{"scrollid":_vm.scrollId}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabTitle"},[_c('span',[_vm._v("筛选")]),_c('i')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1j7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"content"},[_c('div',{staticClass:"recruit-canvas"},[_c('div',{staticClass:"canvas-out-box"},[_c('div',{ref:"canvasRef",staticClass:"canvas-box"},[_c('canvas',{ref:"canvasMapRef",attrs:{"id":"canvas-map","width":"100","height":"100"}})])]),_vm._v(" "),_c('div',{staticClass:"btn-box flex-row"},[_c('van-button',{staticClass:"no-use",on:{"click":_vm.clearHandle}},[_vm._v("重绘")]),_vm._v(" "),_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.confirmHandle}},[_vm._v("确认")])],1),_vm._v(" "),_vm._t("default",null,{"signatrue":_vm.canvasNode})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1qOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_writeResult_vue__ = __webpack_require__("emv/");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce2473be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_writeResult_vue__ = __webpack_require__("1HAG");
function injectStyle (ssrContext) {
  __webpack_require__("Q/Tj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce2473be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_writeResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce2473be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_writeResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "23Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"holiday-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleClose($event)}}},[_c('div',{staticClass:"holiday-wrap"},[_c('div',{staticClass:"holiday-sheet"},[_c('div',{staticClass:"holiday-head"},[_c('div',{staticClass:"holiday-title"},[_vm._v(_vm._s(_vm.popupTitle))]),_vm._v(" "),_c('div',{staticClass:"holiday-desc"},[_vm._v("为保障消费者体验，请确认您门店在"+_vm._s(_vm.descText)+"的营业安排")])]),_vm._v(" "),_c('div',{staticClass:"holiday-body"},[(_vm.showMidAutumn)?_c('div',{staticClass:"holiday-block"},[_c('div',{staticClass:"block-label"},[_c('strong',[_vm._v("中秋节")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.holidayConfig.midAutumn.dateRange))])]),_vm._v(" "),_c('div',{staticClass:"radio-row"},[_c('label',{staticClass:"radio-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.midStatus),expression:"midStatus"}],attrs:{"type":"radio","value":"open"},domProps:{"checked":_vm._q(_vm.midStatus,"open")},on:{"change":function($event){_vm.midStatus="open"}}}),_vm._v(" 正常营业\n            ")]),_vm._v(" "),_c('label',{staticClass:"radio-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.midStatus),expression:"midStatus"}],attrs:{"type":"radio","value":"partial"},domProps:{"checked":_vm._q(_vm.midStatus,"partial")},on:{"change":function($event){_vm.midStatus="partial"}}}),_vm._v(" 部分日期休息\n            ")]),_vm._v(" "),_c('label',{staticClass:"radio-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.midStatus),expression:"midStatus"}],attrs:{"type":"radio","value":"full"},domProps:{"checked":_vm._q(_vm.midStatus,"full")},on:{"change":function($event){_vm.midStatus="full"}}}),_vm._v(" 全程休息（"+_vm._s(_vm.holidayConfig.midAutumn.fullLabel)+"）\n            ")])]),_vm._v(" "),(_vm.midStatus === 'partial' || _vm.midStatus === 'full')?_c('div',{staticClass:"date-panel"},[_c('div',{staticClass:"date-grid"},_vm._l((_vm.holidayConfig.midAutumn.dates),function(item){return _c('div',{key:item.date,class:[
                  'date-chip',
                  { 'is-selected': _vm.isDateSelected('mid', item.date) },
                  { 'is-disabled': _vm.midStatus === 'full' }
                ],on:{"click":function($event){return _vm.toggleDate('mid', item.date)}}},[_vm._v("\n                "+_vm._s(item.label)),_c('small',[_vm._v(_vm._s(item.weekday))])])}),0),_vm._v(" "),_c('div',{class:['selected-summary', { 'is-warn': _vm.midStatus === 'partial' && _vm.selectedMidDates.length === 0 }]},[_vm._v("\n              "+_vm._s(_vm.midSummaryText)+"\n            ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"holiday-block"},[_c('div',{staticClass:"block-label"},[_c('strong',[_vm._v("国庆节")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.holidayConfig.national.dateRange))])]),_vm._v(" "),_c('div',{staticClass:"radio-row"},[_c('label',{staticClass:"radio-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nationalStatus),expression:"nationalStatus"}],attrs:{"type":"radio","value":"open"},domProps:{"checked":_vm._q(_vm.nationalStatus,"open")},on:{"change":function($event){_vm.nationalStatus="open"}}}),_vm._v(" 正常营业\n            ")]),_vm._v(" "),_c('label',{staticClass:"radio-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nationalStatus),expression:"nationalStatus"}],attrs:{"type":"radio","value":"partial"},domProps:{"checked":_vm._q(_vm.nationalStatus,"partial")},on:{"change":function($event){_vm.nationalStatus="partial"}}}),_vm._v(" 部分日期休息\n            ")]),_vm._v(" "),_c('label',{staticClass:"radio-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nationalStatus),expression:"nationalStatus"}],attrs:{"type":"radio","value":"full"},domProps:{"checked":_vm._q(_vm.nationalStatus,"full")},on:{"change":function($event){_vm.nationalStatus="full"}}}),_vm._v(" 全程休息（"+_vm._s(_vm.holidayConfig.national.fullLabel)+"）\n            ")])]),_vm._v(" "),(_vm.nationalStatus === 'partial' || _vm.nationalStatus === 'full')?_c('div',{staticClass:"date-panel"},[_c('div',{staticClass:"date-grid"},_vm._l((_vm.holidayConfig.national.dates),function(item){return _c('div',{key:item.date,class:[
                  'date-chip',
                  { 'is-selected': _vm.isDateSelected('national', item.date) },
                  { 'is-disabled': _vm.nationalStatus === 'full' }
                ],on:{"click":function($event){return _vm.toggleDate('national', item.date)}}},[_vm._v("\n                "+_vm._s(item.label)),_c('small',[_vm._v(_vm._s(item.weekday))])])}),0),_vm._v(" "),_c('div',{class:['selected-summary', { 'is-warn': _vm.nationalStatus === 'partial' && _vm.selectedNationalDates.length === 0 }]},[_vm._v("\n              "+_vm._s(_vm.nationalSummaryText)+"\n            ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"holiday-foot"},[_c('van-button',{staticClass:"btn-primary",attrs:{"round":"","type":"info"},on:{"click":_vm.handleSubmit}},[_vm._v("确认提交")])],1)]),_vm._v(" "),_c('button',{staticClass:"holiday-close",attrs:{"type":"button"},on:{"click":_vm.handleClose}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M6 6l12 12M18 6L6 18","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round"}})])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "23rr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("cSKZ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4477ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WcOf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4477ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "297+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gcd.9ca40cd.png";

/***/ }),

/***/ "2LI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("iemT");



var config = [];

var uuid = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* default */].getParam('_uuid');

function setSave() {
  if (uuid) {
    var formData = new FormData();
    var params = [];
    config.forEach(function (item) {
      params.push({
        url: item.url,
        istab: item.istab,
        tab: item.tab
      });
    });

    formData.append('uuid', uuid);
    formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
    // alert(JSON.stringify(params))
    tuhu.fetch('https://wx.tuhu.cn/activity/setpagestack', {
      method: 'post',
      body: formData
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  _setCurrentPage: function _setCurrentPage(id, path, tab, pageId, istab, instance, url) {
    config.push({
      _id: config.length,
      id: id,
      path: path,
      pageId: pageId,
      tab: tab,
      istab: istab,
      instance: instance,
      url: url
    });

    setSave();
  },
  _popPage: function _popPage() {
    config.pop();
  },
  delPage: function delPage(index) {
    config.splice(index, 1);

    setSave();
  },
  getCurrentPages: function getCurrentPages() {
    return config;
  },
  getCurrentPage: function getCurrentPage() {
    return config[config.length - 1];
  }
});

/***/ }),

/***/ "2QzO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            userRole: '', // 权限
            currentPage: 1,
            activeMonth: false,
            activeDay: false,
            activeServe: false,
            // 订单列表
            AllOrderData: {},
            AllOrderListPage: {},
            AllOrderListPageRecords: {},
            // 2级服务列表
            SndServiceData: {},
            // 订单详情列表
            orderDetailList: {},
            // 服务的点击状态
            tagFlagData: [],
            // 筛选发送的2级服务列表
            tagSecondClassId: [],
            tagFlagAll: true,
            // 月
            monthStartTime: '',
            monthEndTime: '',
            // 日
            dayStartTime: '',
            dayEndTime: '',
            // 月
            startTimePicker: true,
            endTimePicker: false,
            // 日
            dayStartTimePicker: true,
            dayEndTimePicker: false,
            // 月 日 时间
            minDate: new Date(2019, 0, 1),
            maxDate: new Date(2050, 10, 1),
            // 月
            currentStartTime: [],
            currentEndTime: [],
            // 日
            dayCurrentStartTime: [],
            dayCurrentEndTime: [],
            // 默认展开栏
            activeName: '',
            // 请求用数据
            shopId: '',
            selectType: true,
            selectStartTime: null,
            selectEndTime: null,
            secondClassId: null,
            // 跳转详情
            tabList: [{
                name: '订单列表详情',
                url: '/pages/orderDetail/index'
            }],
            dataCode: null
        };
    },
    created: function created() {
        this.getAllOrderData();
        this.getSndServiceData();
    },

    methods: {
        getAllOrderData: function getAllOrderData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                if (roleData && roleData.code === '200') {
                                    _this.shopId = roleData.data.shopId;
                                    _this.userRole = roleData.data.role;
                                } else {
                                    tuhu.toast(roleData.message || '获取权限信息失败');
                                }
                                _context.next = 6;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_ALLORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        endTime: null,
                                        pageNum: 1,
                                        pageSize: 6,
                                        secondClassId: null,
                                        selectType: true,
                                        shopId: _this.shopId,
                                        startingTime: null
                                    })
                                });

                            case 6:
                                data = _context.sent;

                                if (data && data.code === '200') {
                                    _this.AllOrderData = data.data;
                                    _this.AllOrderListPage = data.data.listPage;
                                    _this.AllOrderListPageRecords = data.data.listPage.list;
                                    console.log('全部订单', data.data);
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 二级菜单列表
        getSndServiceData: function getSndServiceData() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data, length, i;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_SECOND_CLASS + '?level=1');

                            case 2:
                                data = _context2.sent;


                                if (data && data.code === '200') {

                                    _this2.SndServiceData = data.data;

                                    length = data.data.length;


                                    for (i = 0; i < length; i++) {

                                        _this2.tagFlagData.push(false);
                                    }
                                } else {

                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        serviceFlag: function serviceFlag(i) {
            return this.tagFlagData[i];
        },

        // 月 点击起始时间
        clickStartTime: function clickStartTime() {
            this.startTimePicker = true;
            this.endTimePicker = false;
        },

        // 月 点击结束时间
        clickEndTime: function clickEndTime() {
            this.endTimePicker = true;
            this.startTimePicker = false;
            this.monthEndTime = this.currentEndTime[0] + '-' + this.currentEndTime[1];
        },

        // 日 点击起始时间
        dayClickStartTime: function dayClickStartTime() {
            this.dayStartTimePicker = true;
            this.dayEndTimePicker = false;
        },

        // 日 点击结束时间
        dayClickEndTime: function dayClickEndTime() {
            this.dayEndTimePicker = true;
            this.dayStartTimePicker = false;
            this.dayEndTime = this.dayCurrentEndTime[0] + '-' + this.dayCurrentEndTime[1] + '-' + this.dayCurrentEndTime[2];
        },

        // 按月查询 确认取消 4个按钮
        cancelStartPicker: function cancelStartPicker() {
            this.$refs.item1.toggle();
        },
        confirmStartPicker: function confirmStartPicker() {
            this.monthStartTime = this.currentStartTime[0] + '-' + this.currentStartTime[1];
            this.startTimePicker = false;
            this.endTimePicker = true;
        },
        cancelEndPicker: function cancelEndPicker() {
            this.$refs.item1.toggle();
        },

        // 最后一个选择时间结束 发起请求
        confirmEndPicker: function confirmEndPicker() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                // 初始
                                _this3.selectStartTime = null;
                                _this3.selectEndTime = null;
                                _this3.monthEndTime = _this3.currentEndTime[0] + '-' + _this3.currentEndTime[1];
                                _this3.$refs.item1.toggle();
                                // 发送
                                _this3.selectType = true;
                                _this3.selectStartTime = _this3.monthStartTime;
                                _this3.selectEndTime = _this3.monthEndTime;

                                if (!(_this3.selectStartTime !== '' && _this3.selectEndTime !== null)) {
                                    _context3.next = 14;
                                    break;
                                }

                                _context3.next = 10;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_ALLORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'startingTime': _this3.selectStartTime,
                                        'endTime': _this3.selectEndTime,
                                        'selectType': _this3.selectType,
                                        'shopId': _this3.shopId,
                                        'pageNum': 1,
                                        'pageSize': 6,
                                        'secondClassId': _this3.secondClassId
                                    })
                                });

                            case 10:
                                data = _context3.sent;

                                if (data && data.code === '200') {
                                    _this3.AllOrderData = data.data;
                                    _this3.AllOrderListPage = data.data.listPage;
                                    _this3.AllOrderListPageRecords = data.data.listPage.list;
                                    // 展开全收起
                                    _this3.activeName = '';
                                    // 分页跳第一页
                                    _this3.currentPage = 1;
                                    // 按月查询文本亮
                                    _this3.activeMonth = true;
                                    // 按日查询文本不亮
                                    _this3.activeDay = false;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }
                                _context3.next = 16;
                                break;

                            case 14:
                                tuhu.toast('未选择开始时间');
                                _this3.activeMonth = false;

                            case 16:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },

        // 按日查询 确认取消 4个按钮
        dayCancelStartPicker: function dayCancelStartPicker() {
            this.$refs.item2.toggle();
        },
        dayConfirmStartPicker: function dayConfirmStartPicker() {
            this.dayStartTime = this.dayCurrentStartTime[0] + '-' + this.dayCurrentStartTime[1] + '-' + this.dayCurrentStartTime[2];
            this.dayStartTimePicker = false;
            this.dayEndTimePicker = true;
        },
        dayCancelEndPicker: function dayCancelEndPicker() {
            this.$refs.item2.toggle();
        },

        // 最后一个选择时间结束 发起请求
        dayConfirmEndPicker: function dayConfirmEndPicker() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                // 初始
                                _this4.selectStartTime = null;
                                _this4.selectEndTime = null;
                                _this4.dayEndTime = _this4.dayCurrentEndTime[0] + '-' + _this4.dayCurrentEndTime[1] + '-' + _this4.dayCurrentEndTime[2];
                                _this4.$refs.item2.toggle();
                                // 发送
                                _this4.selectType = false;
                                _this4.selectStartTime = _this4.dayStartTime;
                                _this4.selectEndTime = _this4.dayEndTime;
                                // 请求

                                if (!(_this4.selectStartTime !== '' && _this4.selectEndTime !== null)) {
                                    _context4.next = 14;
                                    break;
                                }

                                _context4.next = 10;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_ALLORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'startingTime': _this4.selectStartTime,
                                        'endTime': _this4.selectEndTime,
                                        'selectType': _this4.selectType,
                                        'shopId': _this4.shopId,
                                        'pageNum': 1,
                                        'pageSize': 6,
                                        'secondClassId': _this4.secondClassId
                                    })
                                });

                            case 10:
                                data = _context4.sent;

                                if (data && data.code === '200') {
                                    _this4.AllOrderData = data.data;
                                    _this4.AllOrderListPage = data.data.listPage;
                                    _this4.AllOrderListPageRecords = data.data.listPage.list;
                                    // 展开全收起
                                    _this4.activeName = '';
                                    // 分页跳第一页
                                    _this4.currentPage = 1;
                                    // 按月查询文本不亮
                                    _this4.activeMonth = false;
                                    // 按日查询文本亮
                                    _this4.activeDay = true;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }
                                _context4.next = 16;
                                break;

                            case 14:
                                tuhu.toast('未选择开始时间');
                                _this4.activeDay = false;

                            case 16:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },

        // 格式化时间显示
        // 按月 开始时间
        formatter1: function formatter1(type, val) {
            if (type === 'year') {
                this.currentStartTime[0] = '' + val;
                return val + '\u5E74';
            } else if (type === 'month') {
                this.currentStartTime[1] = '' + val;
                return val + '\u6708';
            }
            return val;
        },

        // 按月 结束时间
        formatter2: function formatter2(type, val) {
            if (type === 'year') {
                this.currentEndTime[0] = '' + val;
                return val + '\u5E74';
            } else if (type === 'month') {
                this.currentEndTime[1] = '' + val;
                return val + '\u6708';
            }
            return val;
        },

        // 按日 开始时间
        formatter3: function formatter3(type, val) {
            if (type === 'year') {
                this.dayCurrentStartTime[0] = '' + val;
                return val + '\u5E74';
            } else if (type === 'month') {
                this.dayCurrentStartTime[1] = '' + val;
                return val + '\u6708';
            } else if (type === 'day') {
                this.dayCurrentStartTime[2] = '' + val;
                return val + '\u65E5';
            }
            return val;
        },

        // 按日 结束时间
        formatter4: function formatter4(type, val) {
            if (type === 'year') {
                this.dayCurrentEndTime[0] = '' + val;
                return val + '\u5E74';
            } else if (type === 'month') {
                this.dayCurrentEndTime[1] = '' + val;
                return val + '\u6708';
            } else if (type === 'day') {
                this.dayCurrentEndTime[2] = '' + val;
                return val + '\u65E5';
            }
            return val;
        },

        // 按服务筛选 发送第二服务id
        confirmSndService: function confirmSndService() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var len, i, a, b, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                // 勾选服务
                                if (_this5.tagFlagAll) {
                                    _this5.tagSecondClassId = [];
                                    len = _this5.tagFlagData.length;

                                    for (i = 0; i < len; i++) {
                                        a = _this5.$refs.serviceTagList[i].attributes.secondclassid.value;
                                        b = parseInt(a);

                                        _this5.tagSecondClassId.push(b);
                                    }
                                    _this5.$refs.item3.toggle();
                                } else {
                                    _this5.tagSecondClassId = [];
                                    _this5.tagFlagData.forEach(function (val, i) {
                                        if (val) {
                                            _this5.tagSecondClassId.push(_this5.$refs.serviceTagList[i].attributes.secondclassid.value);
                                        }
                                    });
                                    _this5.$refs.item3.toggle();
                                }
                                // 初始
                                _this5.secondClassId = _this5.tagSecondClassId;
                                // 请求

                                if (!(_this5.secondClassId.length !== 0)) {
                                    _context5.next = 9;
                                    break;
                                }

                                _context5.next = 5;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_ALLORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'startingTime': _this5.selectStartTime,
                                        'endTime': _this5.selectEndTime,
                                        'selectType': _this5.selectType,
                                        'shopId': _this5.shopId,
                                        'pageNum': 1,
                                        'pageSize': 6,
                                        'secondClassId': _this5.secondClassId
                                    })
                                });

                            case 5:
                                data = _context5.sent;

                                if (data && data.code === '200') {
                                    _this5.AllOrderData = data.data;
                                    _this5.AllOrderListPage = data.data.listPage;
                                    _this5.AllOrderListPageRecords = data.data.listPage.list;
                                    // 展开全收起
                                    _this5.activeName = '';
                                    // 分页跳第一页
                                    _this5.currentPage = 1;
                                    // 按服务查询文本亮
                                    _this5.activeServe = true;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }
                                _context5.next = 12;
                                break;

                            case 9:
                                tuhu.toast('未选择服务');
                                _this5.secondClassId = null;
                                _this5.activeServe = false;

                            case 12:
                                console.log('b', _this5.secondClassId);

                            case 13:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },

        // 2级服务点击
        clickService: function clickService(i) {
            this.$set(this.tagFlagData, i, !this.tagFlagData[i]);
            this.tagFlagAll = false;
        },

        // 全部服务
        clickServiceAll: function clickServiceAll() {
            this.tagFlagAll = !this.tagFlagAll;
            var len = this.tagFlagData.length;
            if (this.tagFlagAll) {
                for (var i = 0; i < len; i++) {
                    this.tagFlagData[i] = false;
                }
            }
        },

        // 清空
        cancelSndService: function cancelSndService() {
            this.tagFlagAll = false;
            var len = this.tagFlagData.length;
            for (var i = 0; i < len; i++) {
                this.$set(this.tagFlagData, i, false);
            }
        },

        // 分页事件
        changePage: function changePage(index) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var pageNum, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                pageNum = index;
                                _context6.next = 3;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_ALLORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'startingTime': _this6.selectStartTime,
                                        'endTime': _this6.selectEndTime,
                                        'selectType': _this6.selectType,
                                        'shopId': _this6.shopId,
                                        'pageNum': pageNum,
                                        'pageSize': 6,
                                        'secondClassId': _this6.secondClassId
                                    })
                                });

                            case 3:
                                data = _context6.sent;

                                if (data && data.code === '200') {
                                    _this6.AllOrderData = data.data;
                                    _this6.AllOrderListPage = data.data.listPage;
                                    _this6.AllOrderListPageRecords = data.data.listPage.list;
                                    _this6.activeName = '';
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },

        // 详情列表查询
        getOrderDetailList: function getOrderDetailList(e, i) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var selectTime, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                // 当前查询列表时间
                                selectTime = _this7.AllOrderData.listPage.list[i].billDate;

                                if (!(_this7.activeName !== '')) {
                                    _context7.next = 8;
                                    break;
                                }

                                _context7.next = 4;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_ALLORDER_DETAILLIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'pageNum': 1,
                                        'pageSize': 100000,
                                        'secondClassId': _this7.secondClassId,
                                        'selectTime': selectTime,
                                        'selectType': _this7.selectType,
                                        // 'selectTime': '2020-06',
                                        // 'selectType': true,
                                        'shopId': _this7.shopId
                                    })
                                });

                            case 4:
                                data = _context7.sent;

                                if (data && data.code === '200') {
                                    _this7.orderDetailList = data.data.list;
                                    _this7.dataCode = 200;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                    // 展开全收起
                                    _this7.activeName = '';
                                }
                                _context7.next = 8;
                                break;

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },

        // 跳转
        handleClick: function handleClick(item, index) {
            tuhu.sessionStorage.setItem('shopOrderDetail', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.orderDetailList[index]));
            var i = index;
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ListInfo: this.orderDetailList[i] || {}
                },
                query: {
                    scsShow: 1
                }
            });
        }
    }
});

/***/ }),

/***/ "2g6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"item-box3"},[_vm._v("\n            "+_vm._s(_vm.uploadDetail.serviceDetailName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"_content1"},[(_vm.showAllProv)?_c('div',{ref:"provinces",staticClass:"provinces"},[_c('div',{staticClass:"prolist"},_vm._l((_vm.provinces),function(item,index){return _c('div',{key:index,class:_vm.province===item ? 'selected' : '',on:{"click":function($event){return _vm.chooseProvince(item)}}},[_vm._v(_vm._s(item))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-box2"},[_c('div',{staticClass:"box-cont"},[_c('div',{staticClass:"title bottom-line"},[_c('div',[_vm._v("图片资料")]),_vm._v(" "),_c('div',{staticClass:"title-right",on:{"click":function($event){_vm.showPupup = !_vm.showPupup}}},[_vm._v("\n              查看范例\n                        "),_c('img',{attrs:{"src":__webpack_require__("OzHQ"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"cont"},_vm._l((_vm.filteredCarWashList),function(item,index){return _c('div',{key:index,staticClass:"li"},[(_vm.photoMap[item.isShow])?_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({onUpload: _vm.upload , vin:false, index:item.imgType, refresh:true}),expression:"{onUpload: upload , vin:false, index:item.imgType, refresh:true}"}],staticClass:"upload-img"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photoList[item.imgType]),expression:"!photoList[item.imgType]"}],staticClass:"car",attrs:{"src":__webpack_require__("gKLg"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photoList[item.imgType]),expression:"!photoList[item.imgType]"}],staticClass:"camera",attrs:{"src":__webpack_require__("eAMs"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoList[item.imgType]),expression:"photoList[item.imgType]"}],staticClass:"upload-img",attrs:{"src":_vm.photoList[item.imgType],"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoList[item.imgType]),expression:"photoList[item.imgType]"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.photoList[item.imgType]=''}}})]):_vm._e(),_vm._v(" "),(_vm.photoMap[item.isShow])?_c('div',{staticClass:"tips"},[_vm._v(_vm._s(item.text)),(item.required)?_c('span',{staticClass:"themeColor"},[_vm._v(" *")]):_vm._e()]):_vm._e()])}),0)]),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.safeCheckReport)?_c('div',[_c('div',{staticClass:"box-cont2"},[_c('div',{staticClass:"title"},[_c('div',{staticStyle:{"font-size":"0.75rem","font-weight":"550"}},[_vm._v("安全检测结果建议")]),_vm._v(" "),_c('div',{staticClass:"title-right"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}],staticClass:"van-checkbox__icon van-checkbox__icon--square van-checkbox__icon--checked",staticStyle:{"font-size":"12px"},on:{"click":_vm.handleCheckAll}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}],staticClass:"van-checkbox__icon van-checkbox__icon--square",staticStyle:{"font-size":"12px"},on:{"click":_vm.handleCheckAll}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"3px"}},[_vm._v("全部已通过")])])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('van-cell-group',{attrs:{"inset":""}},[_c('van-field',{attrs:{"rows":"3","autosize":"","type":"textarea","maxlength":"300","placeholder":"请输入留言","show-word-limit":""},model:{value:(_vm.safeCheckResultAdvise),callback:function ($$v) {_vm.safeCheckResultAdvise=$$v},expression:"safeCheckResultAdvise"}})],1)],1)]),_vm._v(" "),_vm._l((_vm.filteredSafeCheckContent),function(item,index){return _c('div',{key:index,staticClass:"box-cont3"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-label"},[_vm._v(_vm._s(item.checkId)+" 、 "+_vm._s(item.checkName))]),_vm._v(" "),_c('div',{staticClass:"title-right"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.pass === 1),expression:"item.pass === 1"}],staticClass:"van-checkbox__icon van-checkbox__icon--square van-checkbox__icon--checked",staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.handleCheck(item)}}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.pass === 0),expression:"item.pass === 0"}],staticClass:"van-checkbox__icon van-checkbox__icon--square",staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.handleCheck(item)}}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"3px"}},[_vm._v(_vm._s(item.pass === 1 ? '已通过' : '未通过'))])])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"li"},[_c('p',[_vm._v(_vm._s(item.checkContent))])])])])}),_vm._v(" "),_c('div',{staticClass:"box-cont4",on:{"click":function($event){_vm.showALL = !_vm.showALL}}},[_vm._v("\n                    "+_vm._s(_vm.showALL? '收起': '展开剩余7条')+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"box-cont"},[_c('div',{staticClass:"title bottom-line"},[_c('div',[_vm._v("客户签名")]),_vm._v(" "),_c('div',{staticClass:"title-right"},[_c('van-radio-group',{attrs:{"direction":"horizontal","icon-size":"12"},model:{value:(_vm.signatureType),callback:function ($$v) {_vm.signatureType=$$v},expression:"signatureType"}},[_c('van-radio',{attrs:{"name":1}},[_vm._v("在线签名")]),_vm._v(" "),_c('van-radio',{attrs:{"name":2}},[_vm._v("签名图片")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"li"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signatureType === 1),expression:"signatureType === 1"}],staticClass:"upload-img2",on:{"click":_vm.toOnlineSign}},[(_vm.signatureUrl)?_c('img',{staticClass:"upload-img",attrs:{"src":_vm.signatureUrl,"alt":""}}):_c('img',{staticClass:"camera",attrs:{"src":__webpack_require__("Iy2a"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signatureType === 2),expression:"signatureType === 2"},{name:"upload",rawName:"v-upload",value:({onUpload: _vm.uploadSignature , vin:false, refresh:true}),expression:"{onUpload: uploadSignature , vin:false, refresh:true}"}],staticClass:"upload-img2"},[(_vm.signatureUrl)?_c('img',{staticClass:"upload-img",attrs:{"src":_vm.signatureUrl,"alt":""}}):_c('img',{staticClass:"camera",attrs:{"src":__webpack_require__("QHWF"),"alt":""}})])])])])],2):_vm._e()]),_vm._v(" "),_c('van-popup',{staticClass:"popup-about",attrs:{"round":"","closeable":"","position":"bottom"},model:{value:(_vm.showPupup),callback:function ($$v) {_vm.showPupup=$$v},expression:"showPupup"}},[_c('div',{staticClass:"content-block"},[_c('p',{staticClass:"tt"},[_vm._v("图片资料范例")]),_vm._v(" "),_c('p',{staticClass:"tip marginTop marginBottom"},[_vm._v("请按照示例上传完整清晰图片")]),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.isVehicleWorkingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("8jTK"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                能清晰显露车牌及车店的作业中照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.isWorkingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("DhIS"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                作业中照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.isVehicleOilPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("0q08"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                使用的机油与车辆合影照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.isWorkOrderPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("wOE/"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                工单照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.carLiftPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("USF0"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                车辆在起升架上的照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap&&_vm.photoMap.hoodOpenPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("gB3B"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                引擎盖打开的照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.puttyingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2025/12/22/78bb17d304294a51a4d49cd660f428db.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                刮腻子照片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.isVinPhoto || _vm.photoMap.isVehicleWorkingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2026/01/13/db02a6572ec54e498122c9e66b473976.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                车架号图片\n              ")]),_vm._v("\n              示意图\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showPupup = false}}},[_c('tt-button',{attrs:{"text":"知道了"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"btn verify-btn",on:{"click":function($event){return _vm.sureToOff()}}},[_c('tt-button',{attrs:{"text":"确认修改"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ify":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "38rr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"coWrap comments-all"},[_c('div',{staticClass:"scrollContent"},[_c('tuhu-infinite',{key:0,attrs:{"endmsg":"到底了哦","distance":100,"nodata":_vm.commentsNoData,"end":_vm.commentsEnd},on:{"oninfinite":_vm.oninfinite}},[_c('div',{staticClass:"productComment",attrs:{"slot":"content"},slot:"content"},[_c('ul',{staticClass:"commentList"},_vm._l((_vm.commentsList),function(item,index){return _c('li',{key:item.CommentID,staticClass:"mrItem"},[_c('div',{staticClass:"itemTop"},[_c('div',{staticClass:"pic"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item.HeadImage?item.HeadImage: 'https://res.tuhu.org/Image/UserCenter/headimg_d.png', width: '1.3'}),expression:"{src:item.HeadImage?item.HeadImage: 'https://res.tuhu.org/Image/UserCenter/headimg_d.png', width: '1.3'}"}],staticClass:"img"}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.level[item.UserLevel]}),expression:"{src:level[item.UserLevel]}"}],staticClass:"grade"})]),_vm._v(" "),_c('div',{staticClass:"rightText"},[_c('div',{staticClass:"user"},[_c('span',{staticClass:"name",domProps:{"textContent":_vm._s(item.UserName)}}),_vm._v(" "),_c('span',{staticClass:"date",domProps:{"textContent":_vm._s(item.CommentTime)}})]),_vm._v(" "),_c('tuhu-rater',{attrs:{"point":item.CommentR1}})],1)]),_vm._v(" "),_c('div',{staticClass:"commentDetail"},[_c('div',{class:_vm.flags[index] === true ? 'commentTxt expanded' : 'commentTxt',domProps:{"textContent":_vm._s(item.CommentContent)}}),_vm._v(" "),(item.CommentContent.length>65)?_c('div',{staticClass:"open",on:{"click":function($event){return _vm.changeState(index)}}},[_vm._v(_vm._s(_vm.flags[index] === true ? '收起' : '全文'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"commentImg"},_vm._l((item.CommentImages),function(item2,index2){return (index2 < 4)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item2, width:3.5, height:3.5, group: index + _vm.group1}),expression:"{src:item2, width:3.5, height:3.5, group: index + group1}"}],key:index2,staticClass:"img"}):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"carInfo"},[_c('span',{staticClass:"carName",domProps:{"textContent":_vm._s(item.CarTypeDes)}}),_vm._v(" "),_c('span',{staticClass:"carService",domProps:{"textContent":_vm._s(item.InstallShop)}})])])])}),0)])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3IMD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3OQM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3R1Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/v2.df6560d.png";

/***/ }),

/***/ "3Y5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * 中秋国庆营业确认弹窗组件
 * 用于收集商户在双节期间的营业安排
 */
/** 中秋节模块过期截止时间：2026-09-24 23:59:59 */
var MID_AUTUMN_DEADLINE = new Date('2026-09-24T23:59:59').getTime();
/** 整体下线截止时间：2026-09-30 23:59:59 */
var OVERALL_DEADLINE = new Date('2026-09-30T23:59:59').getTime();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'holidayConfirm',
  props: {
    /** 是否显示弹窗 */
    visible: {
      type: Boolean,
      default: false
    },
    /** 当前门店ID */
    shopId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      /** 中秋节营业状态：''-未选择 open-正常营业 partial-部分休息 full-全程休息，默认不选 */
      midStatus: '',
      /** 国庆节营业状态，默认不选 */
      nationalStatus: '',
      /** 中秋节已选休息日期 */
      selectedMidDates: [],
      /** 国庆节已选休息日期 */
      selectedNationalDates: [],
      /** 节假日配置数据 */
      holidayConfig: {
        midAutumn: {
          dateRange: '9月25日 — 9月27日',
          fullLabel: '9/25—9/27',
          dates: [{ date: '2026-09-25', label: '9/25', weekday: '周五' }, { date: '2026-09-26', label: '9/26', weekday: '周六' }, { date: '2026-09-27', label: '9/27', weekday: '周日' }]
        },
        national: {
          dateRange: '10月1日 — 10月7日',
          fullLabel: '10/1—10/7',
          dates: [{ date: '2026-10-01', label: '10/1', weekday: '周四' }, { date: '2026-10-02', label: '10/2', weekday: '周五' }, { date: '2026-10-03', label: '10/3', weekday: '周六' }, { date: '2026-10-04', label: '10/4', weekday: '周日' }, { date: '2026-10-05', label: '10/5', weekday: '周一' }, { date: '2026-10-06', label: '10/6', weekday: '周二' }, { date: '2026-10-07', label: '10/7', weekday: '周三' }]
        }
      }
    };
  },

  computed: {
    /**
     * 是否展示中秋节模块
     * 9月24日23:59:59后隐藏中秋部分
     * @returns {boolean}
     */
    showMidAutumn: function showMidAutumn() {
      return Date.now() <= MID_AUTUMN_DEADLINE;
    },

    /**
     * 弹窗标题（根据中秋模块是否过期动态变化）
     * @returns {string}
     */
    popupTitle: function popupTitle() {
      return this.showMidAutumn ? '中秋 · 国庆营业确认' : '国庆营业确认';
    },

    /**
     * 弹窗描述文案（根据中秋模块是否过期动态变化）
     * @returns {string}
     */
    descText: function descText() {
      return this.showMidAutumn ? '中秋国庆期间' : '国庆期间';
    },

    /**
     * 中秋节摘要文本
     * @returns {string} 已选日期或提示文案
     */
    midSummaryText: function midSummaryText() {
      if (this.midStatus === 'full') {
        return '全程休息：9/25 — 9/27';
      }
      if (this.selectedMidDates.length === 0) {
        return '请至少选择 1 个休息日期';
      }
      var labels = this.getLabelsByDates('mid', this.selectedMidDates);
      return '已选休息：' + labels.join('、');
    },

    /**
     * 国庆节摘要文本
     * @returns {string} 已选日期或提示文案
     */
    nationalSummaryText: function nationalSummaryText() {
      if (this.nationalStatus === 'full') {
        return '全程休息：10/1 — 10/7';
      }
      if (this.selectedNationalDates.length === 0) {
        return '请至少选择 1 个休息日期';
      }
      var labels = this.getLabelsByDates('national', this.selectedNationalDates);
      return '已选休息：' + labels.join('、');
    }
  },
  watch: {
    /**
     * 监听中秋节状态变化
     * 切换到全程休息时自动选中所有日期
     * 切换到正常营业或部分休息时清空已选日期
     */
    midStatus: function midStatus(val) {
      if (val === 'full') {
        this.selectedMidDates = this.holidayConfig.midAutumn.dates.map(function (d) {
          return d.date;
        });
      } else {
        this.selectedMidDates = [];
      }
    },

    /**
     * 监听国庆节状态变化
     * 切换到全程休息时自动选中所有日期
     * 切换到正常营业或部分休息时清空已选日期
     */
    nationalStatus: function nationalStatus(val) {
      if (val === 'full') {
        this.selectedNationalDates = this.holidayConfig.national.dates.map(function (d) {
          return d.date;
        });
      } else {
        this.selectedNationalDates = [];
      }
    }
  },
  methods: {
    /**
     * 判断日期是否被选中
     * @param {string} type - 节日类型：mid 或 national
     * @param {string} date - 日期字符串，如 2026-09-25
     * @returns {boolean} 是否选中
     */
    isDateSelected: function isDateSelected(type, date) {
      if (type === 'mid') {
        return this.selectedMidDates.includes(date);
      }
      return this.selectedNationalDates.includes(date);
    },


    /**
     * 切换日期选中状态
     * 全程休息模式下不可操作
     * @param {string} type - 节日类型：mid 或 national
     * @param {string} date - 日期字符串
     */
    toggleDate: function toggleDate(type, date) {
      // 全程休息模式下禁止手动切换
      if (type === 'mid' && this.midStatus === 'full') return;
      if (type === 'national' && this.nationalStatus === 'full') return;

      if (type === 'mid') {
        var idx = this.selectedMidDates.indexOf(date);
        if (idx > -1) {
          this.selectedMidDates.splice(idx, 1);
        } else {
          this.selectedMidDates.push(date);
        }
      } else {
        var _idx = this.selectedNationalDates.indexOf(date);
        if (_idx > -1) {
          this.selectedNationalDates.splice(_idx, 1);
        } else {
          this.selectedNationalDates.push(date);
        }
      }
    },


    /**
     * 根据日期数组获取对应的显示标签
     * @param {string} type - 节日类型
     * @param {Array} dates - 日期数组
     * @returns {Array} 标签数组，如 ['9/25', '9/26']
     */
    getLabelsByDates: function getLabelsByDates(type, dates) {
      var config = type === 'mid' ? this.holidayConfig.midAutumn : this.holidayConfig.national;
      return config.dates.filter(function (d) {
        return dates.includes(d.date);
      }).map(function (d) {
        return d.label;
      });
    },


    /**
     * 判断弹窗是否应该展示（供父组件调用）
     * 整体下线时间：2026-09-30 23:59:59
     * @returns {boolean} 是否应展示
     */
    isWithinDeadline: function isWithinDeadline() {
      return Date.now() <= OVERALL_DEADLINE;
    },


    /**
     * 确认提交
     * 将中秋和国庆选中的休息日期转换为接口所需格式，提交到 /shop/restTime/save
     */
    handleSubmit: function handleSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var restTimeList, params, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.showMidAutumn && !_this.midStatus)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', tuhu.toast('请完善营业信息'));

              case 2:
                if (_this.nationalStatus) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', tuhu.toast('请完善营业信息'));

              case 4:
                if (!(_this.showMidAutumn && _this.midStatus === 'partial' && _this.selectedMidDates.length === 0)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', tuhu.toast('请完善营业信息'));

              case 6:
                if (!(_this.nationalStatus === 'partial' && _this.selectedNationalDates.length === 0)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', tuhu.toast('请完善营业信息'));

              case 8:

                // 构建 restTimeList：每个选中日期转换为 { restRemark, restStartTime, restEndTime }
                restTimeList = [];
                // 中秋日期（未过期时才添加）

                if (_this.showMidAutumn) {
                  _this.selectedMidDates.forEach(function (date) {
                    restTimeList.push({
                      restRemark: '中秋',
                      restStartTime: date,
                      restEndTime: date
                    });
                  });
                }
                // 国庆日期
                _this.selectedNationalDates.forEach(function (date) {
                  restTimeList.push({
                    restRemark: '国庆',
                    restStartTime: date,
                    restEndTime: date
                  });
                });

                // 构建请求参数
                params = {
                  shopId: _this.shopId,
                  type: 4,
                  restTimeList: restTimeList
                };
                _context.prev = 12;
                _context.next = 15;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SAVE_REST_TIME, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params),
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 15:
                data = _context.sent;

                if (data.code === '200') {
                  tuhu.toast('提交成功，感谢您的配合');
                } else {
                  tuhu.toast(data.message || '提交失败');
                }
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](12);

                console.log('saveRestTime err', _context.t0);
                tuhu.toast('网络开小差了，请重试');

              case 23:
                // 无论接口成功与否都通知父组件关闭弹窗，触发下一个
                // 延时 500ms 让用户看到 toast 提示后再关闭
                setTimeout(function () {
                  _this.$emit('close');
                }, 500);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 19]]);
      }))();
    },


    /**
     * 关闭弹窗
     * 不做提交，仅关闭，由父组件的 noticeIds 机制控制下次是否再弹
     */
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ph9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopInfoCom"},[_c('div',{staticClass:"tabs"},[_c('van-tabs',{attrs:{"color":"rgb(25,137,250)"},on:{"click":_vm.TabsIndex},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":"基本信息"}},[_c('van-field',{attrs:{"label":"店招名称","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopBasicData.shopName),callback:function ($$v) {_vm.$set(_vm.shopBasicData, "shopName", $$v)},expression:"shopBasicData.shopName"}}),_vm._v(" "),_c('van-field',{attrs:{"label":"门店负责人","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopBasicData.shopPrincipal),callback:function ($$v) {_vm.$set(_vm.shopBasicData, "shopPrincipal", $$v)},expression:"shopBasicData.shopPrincipal"}}),_vm._v(" "),_c('van-field',{attrs:{"label":"门店电话","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopBasicData.shopPhone),callback:function ($$v) {_vm.$set(_vm.shopBasicData, "shopPhone", $$v)},expression:"shopBasicData.shopPhone"}}),_vm._v(" "),(_vm.isEdit)?[_c('van-field',{attrs:{"readonly":"","label":"负责人类型","value":_vm.shopBasicData.shopPrincipalType === 2 ? '店长' : _vm.shopBasicData.shopPrincipalType === 1 ? '老板' : '其他',"placeholder":"请输入","input-align":"right"},on:{"click":function($event){_vm.shopBossPickerFlag = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.shopBossPickerFlag),callback:function ($$v) {_vm.shopBossPickerFlag=$$v},expression:"shopBossPickerFlag"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":['老板', '店长', '其他']},on:{"cancel":function($event){_vm.shopBossPickerFlag = false},"confirm":_vm.onShopBossConfirm}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"负责人电话","placeholder":"请输入","input-align":"right"},model:{value:(_vm.shopBasicData.shopPrincipalPhone),callback:function ($$v) {_vm.$set(_vm.shopBasicData, "shopPrincipalPhone", $$v)},expression:"shopBasicData.shopPrincipalPhone"}}),_vm._v(" "),_c('van-field',{attrs:{"readonly":"","label":"所在区域","placeholder":"请输入","input-align":"right"},on:{"click":function($event){_vm.showCityTypePicker = true}},model:{value:(_vm.shopBasicData.city),callback:function ($$v) {_vm.$set(_vm.shopBasicData, "city", $$v)},expression:"shopBasicData.city"}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.showCityTypePicker),callback:function ($$v) {_vm.showCityTypePicker=$$v},expression:"showCityTypePicker"}},[_c('city-picker',{ref:"cPicker",attrs:{"title":'选择所在区域',"confirm":_vm.cityConfirm,"cancel":function () {
                  _vm.showCityTypePicker = false
                }}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"门店地址","placeholder":"请输入","input-align":"right"},model:{value:(_vm.shopBasicData.shopAddress),callback:function ($$v) {_vm.$set(_vm.shopBasicData, "shopAddress", $$v)},expression:"shopBasicData.shopAddress"}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"shop-map"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEdit),expression:"!isEdit"}],staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"shop-map"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isEdit),expression:"!isEdit"}],staticClass:"addressInfo"},[_c('div',{staticClass:"leftDesc"},[_c('p',{staticClass:"title",attrs:{"id":"shop-title"}}),_vm._v(" "),_c('p',{staticClass:"subtitle",attrs:{"id":"shop-subtitle"}})])])])],2),_vm._v(" "),_c('div',{staticClass:"shop-item-cont"},[_c('van-tab',{attrs:{"title":"店铺信息"}},[(!_vm.isEdit)?_c('van-field',{attrs:{"readonly":"","label":"门店类型","value":_vm.shopMerchantData.shopType,"placeholder":"请输入","input-align":"right"}}):_c('van-field',{attrs:{"readonly":"","label":"门店类型","value":_vm.shopMerchantData.shopType,"placeholder":"请输入","input-align":"right","right-icon":"arrow"},on:{"click":function($event){_vm.shopTypePickerFlag = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.shopTypePickerFlag),callback:function ($$v) {_vm.shopTypePickerFlag=$$v},expression:"shopTypePickerFlag"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":['加盟连锁店', '品牌自营连锁店', '私营门店']},on:{"cancel":function($event){_vm.shopTypePickerFlag = false},"confirm":_vm.onShopTypeConfirm}})],1),_vm._v(" "),(!_vm.isEdit)?_c('van-field',{attrs:{"readonly":"","label":"主营服务","value":_vm.shopMerchantData.mainService,"placeholder":"请输入","input-align":"right"}}):_c('van-field',{attrs:{"readonly":"","label":"主营服务","value":_vm.shopMerchantData.mainService,"placeholder":"请输入","input-align":"right","right-icon":"arrow"},on:{"click":function($event){_vm.showMainPickerFlag = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showMainPickerFlag),callback:function ($$v) {_vm.showMainPickerFlag=$$v},expression:"showMainPickerFlag"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":['洗车', '美容装潢', '维修保养', '综合服务', '轮胎']},on:{"cancel":function($event){_vm.showMainPickerFlag = false},"confirm":_vm.onShowMainConfirm}})],1),_vm._v(" "),(!_vm.isEdit)?_c('van-field',{attrs:{"label":"营业项目","value":_vm.shopMerchantData.businessItems,"placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit}}):_c('van-collapse',{staticStyle:{"text-align":"left"},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('van-collapse-item',{attrs:{"title":"营业项目","name":"2"}},[_c('van-checkbox-group',{attrs:{"direction":"horizontal"},model:{value:(_vm.businessItemsSelected),callback:function ($$v) {_vm.businessItemsSelected=$$v},expression:"businessItemsSelected"}},_vm._l((_vm.allServices),function(item){return _c('van-checkbox',{key:item,staticStyle:{"margin-bottom":"5px","margin-right":"5px","width":"30%"},attrs:{"name":item}},[_vm._v(_vm._s(item))])}),1)],1)],1),_vm._v(" "),(!_vm.isEdit)?_c('van-field',{attrs:{"readonly":"","label":"营业面积","value":_vm.shopMerchantData.merchantArea,"placeholder":"请输入","input-align":"right"}}):_c('van-field',{attrs:{"readonly":"","label":"营业面积","value":_vm.shopMerchantData.merchantArea,"placeholder":"请输入","input-align":"right","right-icon":"arrow"},on:{"click":function($event){_vm.showAreaPickerFlag = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAreaPickerFlag),callback:function ($$v) {_vm.showAreaPickerFlag=$$v},expression:"showAreaPickerFlag"}},[_c('van-picker',{attrs:{"show-toolbar":"","columns":[
                '100平米以下',
                '100-200平米',
                '200-300平米',
                '300-400平米',
                '400-500平米',
                '500-600平米',
                '600-700平米'
              ]},on:{"cancel":function($event){_vm.showAreaPickerFlag = false},"confirm":_vm.onShowAreaConfirm}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"洗车工位","maxlength":"2","value":_vm.washCount1 === undefined ? _vm.shopMerchantData.washCount : _vm.washCount1,"placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},on:{"input":_vm.washCountInput}}),_vm._v(" "),_c('van-field',{attrs:{"label":"美容工位","maxlength":"2","value":_vm.beautyCount1 === undefined ? _vm.shopMerchantData.beautyCount : _vm.beautyCount1,"placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},on:{"input":_vm.beautyCountInput}}),_vm._v(" "),_c('van-field',{attrs:{"label":"维保工位","maxlength":"2","value":_vm.repairCount1 === undefined ? _vm.shopMerchantData.repairCount : _vm.repairCount1,"placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},on:{"input":_vm.repairCountInput}}),_vm._v(" "),_c('van-field',{attrs:{"label":"烤漆房数","maxlength":"2","value":_vm.copyCount1 === undefined ? _vm.shopMerchantData.copyCount : _vm.copyCount1,"copyCount1":"","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},on:{"input":_vm.copyCountInput}}),_vm._v(" "),(!_vm.isEdit)?_c('van-field',{attrs:{"label":"独立休息区","value":_vm.shopMerchantData.haveRestArea === 0 ? '无' : '有',"placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit}}):_c('van-cell',{staticStyle:{"text-align":"left"},attrs:{"title":"独立休息区"}},[_c('template',{slot:"default"},[_c('van-radio-group',{attrs:{"direction":"horizontal"},model:{value:(_vm.restArea),callback:function ($$v) {_vm.restArea=$$v},expression:"restArea"}},[_c('van-radio',{attrs:{"name":1}},[_vm._v("有")]),_vm._v(" "),_c('van-radio',{attrs:{"name":0}},[_vm._v("无")])],1)],1)],2)],1)],1),_vm._v(" "),_c('van-tab',{attrs:{"title":"企业信息"}},[(!_vm.isEdit)?_c('van-field',{attrs:{"label":"营业执照","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopCompanyData.businessLicense === 0 ? '无' : '有'),callback:function ($$v) {_vm.$set(_vm.shopCompanyData, "businessLicense === 0 ? '无' : '有'", $$v)},expression:"shopCompanyData.businessLicense === 0 ? '无' : '有'"}}):_c('van-cell',{staticStyle:{"text-align":"left"},attrs:{"title":"营业执照"}},[_c('template',{slot:"default"},[_c('van-radio-group',{attrs:{"direction":"horizontal"},model:{value:(_vm.businessLicense),callback:function ($$v) {_vm.businessLicense=$$v},expression:"businessLicense"}},[_c('van-radio',{attrs:{"name":1}},[_vm._v("有")]),_vm._v(" "),_c('van-radio',{attrs:{"name":0}},[_vm._v("无")])],1)],1)],2),_vm._v(" "),(_vm.businessLicense == 1)?_c('van-field',{attrs:{"label":"企业主体","maxlength":"18","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopCompanyData.businessEntity),callback:function ($$v) {_vm.$set(_vm.shopCompanyData, "businessEntity", $$v)},expression:"shopCompanyData.businessEntity"}}):_vm._e(),_vm._v(" "),(_vm.businessLicense == 1)?_c('van-field',{attrs:{"label":"企业信用代码","maxlength":"18","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopCompanyData.shopCreditCode),callback:function ($$v) {_vm.$set(_vm.shopCompanyData, "shopCreditCode", $$v)},expression:"shopCompanyData.shopCreditCode"}}):_vm._e(),_vm._v(" "),_c('van-field',{attrs:{"label":"企业法人","maxlength":"6","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopCompanyData.enterprisePrincipal),callback:function ($$v) {_vm.$set(_vm.shopCompanyData, "enterprisePrincipal", $$v)},expression:"shopCompanyData.enterprisePrincipal"}}),_vm._v(" "),_c('van-field',{attrs:{"label":"法人手机","type":"number","maxlength":"11","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopCompanyData.enterprisePrincipalPhone),callback:function ($$v) {_vm.$set(_vm.shopCompanyData, "enterprisePrincipalPhone", $$v)},expression:"shopCompanyData.enterprisePrincipalPhone"}}),_vm._v(" "),_c('van-field',{attrs:{"label":"员工人数","maxlength":"10","placeholder":"请输入","input-align":"right","readonly":!_vm.isEdit},model:{value:(_vm.shopCompanyData.staffNum),callback:function ($$v) {_vm.$set(_vm.shopCompanyData, "staffNum", $$v)},expression:"shopCompanyData.staffNum"}})],1),_vm._v(" "),_c('van-tab',{staticClass:"shop_img",attrs:{"title":"证照店照"}},[(_vm.isEdit)?_vm._l((_vm.CertificatePhotoData),function(item,index){return _c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload2, index: index, refresh: true }),expression:"{ onUpload: upload2, index: index, refresh: true }"}],key:index,staticClass:"certificate_photo"},[_c('div',{staticClass:"img-cont"},[(item.imgUrl)?_c('img',{attrs:{"src":item.imgUrl}}):_c('img',{staticClass:"add-icon",attrs:{"src":_vm.addIcon}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])}):_vm._l((_vm.CertificatePhotoData),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.imgUrl !== null),expression:"item.imgUrl !== null"}],key:index,staticClass:"certificate_photo"},[_c('div',{staticClass:"img-cont"},[_c('img',{attrs:{"src":item.imgUrl}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])})],2)],1),_vm._v(" "),(_vm.isEdit)?_c('van-button',{staticClass:"shop_info_btn",attrs:{"size":"large","color":"rgb(25,137,250)","plain":"","type":"info","hairline":true},on:{"click":_vm.handleSave}},[_vm._v("保存")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3qKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imgs_v0_png__ = __webpack_require__("7AV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imgs_v0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__imgs_v0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_v1_png__ = __webpack_require__("xgxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_v1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__imgs_v1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_v2_png__ = __webpack_require__("3R1Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_v2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__imgs_v2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_v3_png__ = __webpack_require__("sv6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_v3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgs_v3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imgs_v4_png__ = __webpack_require__("rHuL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imgs_v4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__imgs_v4_png__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // options: {
      //   productId: 'TR-YK-A349'
      // },
      titles: [{
        name: '全部',
        number: ''
      }, {
        name: '晒图',
        number: ''
      }],
      fetchCommentsParams: {
        'UserId': '',
        'shopId': '',
        'type': '',
        'pageIndex': 1,
        'pageSize': 10
      },
      commentsList: [], // 评论列表
      commentsNoData: false, // 评论是否没有内容
      commentsEnd: false, // 评论是否到底
      commentsTotalPage: 1, // 评论总页数
      resolve: function resolve() {},
      reject: function reject() {},
      flags: [],
      level: {
        V0: __WEBPACK_IMPORTED_MODULE_3__imgs_v0_png___default.a,
        V1: __WEBPACK_IMPORTED_MODULE_4__imgs_v1_png___default.a,
        V2: __WEBPACK_IMPORTED_MODULE_5__imgs_v2_png___default.a,
        V3: __WEBPACK_IMPORTED_MODULE_6__imgs_v3_png___default.a,
        V4: __WEBPACK_IMPORTED_MODULE_7__imgs_v4_png___default.a
      }
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    tuhu.getUserInfo({
      force: false
    }).then(function (user) {
      _this.fetchCommentsParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.fetchCommentsParams, {
        shopId: _this.options.shopId,
        type: _this.options.type,
        UserId: user.userid
      });
    });
  },

  computed: {
    group1: function group1() {
      return tuhu.util.getGroup();
    }
    // allImages: function() {
    //   let allImages = []
    //   this.imagesList.forEach(element => {
    //     allImages = allImages.concat(element.CommentImages)
    //   })
    //   return allImages
    // }
    // flags: function() {
    //   let a = new Array(this.commentsList.length)
    //   a.fill(false)
    //   return a
    // }

  },
  watch: {
    fetchCommentsParams: {
      handler: function handler(value, oldValue) {
        var isRefersh = true;
        if (value.pageIndex !== oldValue.pageIndex) {
          isRefersh = false;
        }
        if (isRefersh) {
          this.commentsEnd = false;
        }
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value) !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(oldValue)) {
          this.getComments(isRefersh);
        }
      },

      deep: true
    },
    commentsList: {
      handler: function handler(value) {
        var a = new Array(value.length);
        a.fill(false);
        this.flags = a;
      }
    }
  },
  methods: {
    openPhotoBrowser: function openPhotoBrowser(photos) {
      tuhu.photoBrowser({
        photos: photos
      });
    },
    oninfinite: function oninfinite(ev, resolve, reject) {
      this.fetchCommentsParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.fetchCommentsParams, {
        pageIndex: this.fetchCommentsParams.pageIndex + 1
      });
      this.resolve = resolve;
      this.reject = reject;
    },

    // 获取评价信息
    getComments: function getComments(isRefersh) {
      var _this2 = this;

      var canFetch = false;
      // 评论
      if (this.commentsTotalPage >= this.fetchCommentsParams.pageIndex && !this.commentsEnd) {
        canFetch = true;
      }
      if (canFetch) {
        tuhu.fetch('https://api.tuhu.cn/Comment/SelectShopComments', {
          methods: 'POST'
        }, {
          query: this.fetchCommentsParams,
          status: false
        }).then(function (res) {
          if (isRefersh) {
            _this2.commentsList = res.Comments;
          } else {
            var _commentsList;

            (_commentsList = _this2.commentsList).push.apply(_commentsList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.Comments));
          }
          if (res.Comments.length === 0 || res.TotalPage === 0) {
            _this2.commentsNoData = true;
          }
          _this2.commentsTotalPage = res.TotalPage;
          if (res.TotalPage === 1 || _this2.fetchCommentsParams.pageIndex + '' === _this2.commentsTotalPage + '') {
            _this2.commentsEnd = true;
            _this2.reject();
          }
          _this2.resolve();
        });
      }
    },
    changeState: function changeState(k) {
      // this.flags[k] = !this.flags[k]
      this.$set(this.flags, k, !this.flags[k]);
    }
  }
});

/***/ }),

/***/ "3wdF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4TQe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/upload-bg.5218016.png";

/***/ }),

/***/ "4XSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platenum",attrs:{"id":"insert_Plate"}},[_c('div',{staticClass:"maskbg",style:({display:(this.showmask && this.showPlate !== 3)? 'block':'none'}),on:{"click":_vm.hidePlate}}),_vm._v(" "),_c('div',{staticClass:"cityPlate",style:({display:this.showPlate===1?'block':'none'})},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"confirmBtn",on:{"click":_vm.hidePlate}},[_vm._v("确定")])]),_vm._v(" "),_vm._l((this.cityList),function(citys,index){return _c('div',{key:index,staticClass:"lineList"},_vm._l((citys),function(item,idx){return _c('div',{key:idx,class:{'gray': item === '' ? true : false, 'item': true, 'selected already': item === _vm.citySelected},on:{"touchend":function($event){return _vm.cityremove(item)},"touchstart":function($event){return _vm.citychooseHandler(item)}}},[_vm._v("\n        "+_vm._s(item)+"\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item !== ''),expression:"item !== ''"}],staticClass:"itemPop"},[_vm._v(_vm._s(item))])])}),0)})],2),_vm._v(" "),_c('div',{staticClass:"cityPlate EnglishPlate",style:({display:this.showPlate===2?'block':'none'})},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"confirmBtn",on:{"click":_vm.hidePlate}},[_vm._v("确定")])]),_vm._v(" "),_vm._l((this.EnglishList),function(english,index){return _c('div',{key:index,staticClass:"lineList"},_vm._l((english),function(item,idx){return _c('div',{key:idx,class:{'item': true, 'delete': item === 'delete' ? true :false, 'selected already': item === _vm.citySelected},on:{"touchend":function($event){$event.stopPropagation();return _vm.cityremove($event)},"touchstart":function($event){$event.stopPropagation();return _vm.citychooseHandler(item)}}},[_vm._v("\n        "+_vm._s(item === 'delete' ? '' : item)+"\n        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item !== 'delete'),expression:"item !== 'delete'"}],staticClass:"itemPop"},[_vm._v(_vm._s(item))]),_vm._v(" "),(item === 'delete')?_c('img',{attrs:{"src":__webpack_require__("gNyG")}}):_vm._e()])}),0)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4f+T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4idc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4jlU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tpCode_vue__ = __webpack_require__("UeWu");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7cf262_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tpCode_vue__ = __webpack_require__("W/LA");
function injectStyle (ssrContext) {
  __webpack_require__("xF0d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d7cf262"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tpCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d7cf262_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tpCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4rJS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4trQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_dialog_style__ = __webpack_require__("XmAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_dialog__ = __webpack_require__("il3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_loading_style__ = __webpack_require__("nOaS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_loading__ = __webpack_require__("pIDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_commons_wxconfig__ = __webpack_require__("Z+yf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_commons_xkPay_js__ = __webpack_require__("HHv+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configs_config__ = __webpack_require__("65XL");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
Vue.use(__WEBPACK_IMPORTED_MODULE_6_vant_es_loading__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      radio: '',
      show: false,
      sec: 20,
      serd: false,
      payTypeList: [{
        img: __webpack_require__("S/7D"),
        type: 'sd',
        name: '杉德'
      }, {
        img: __webpack_require__("HfTo"),
        type: 'rx',
        name: '瑞祥'
      }],
      now: true,
      dialogs: true,
      dialogs2: true,
      durations: 1000,
      duration1: 2000,
      time: 500,
      totalPrice: '',
      shopBill: {},
      orderIds: '',
      authCode: '',
      title: '',
      payModelId: '',
      orderIdN: '',
      payTitle: '',
      payPlatformId: ''

    };
  },
  created: function created() {
    this.init();
    // this.dialog()
  },
  mounted: function mounted() {
    // 调试工具
    // let vConsole = new VConsole()
  },

  computed: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.path !== location.pathname) {
      location.assign(to.fullPath);
    } else {
      next();
    }
  },

  methods: {
    // 初始化获取数据
    init: function init() {
      var queryList = JSON.parse(tuhu.sessionStorage.getItem('queryList'));

      this.totalPrice = queryList.goodsPriceTotal;
      this.orderIds = queryList.goodsOrderId;
      this.authCode = queryList.channelCode;
      this.title = queryList.shopName;

      this.shopBill = JSON.parse(tuhu.sessionStorage.getItem('shopBill'));
      this.radio = this.shopBill.payModels[0].payModelId;
      this.payModelId = this.shopBill.payModels[0].payModelId;
      this.payPlatformId = this.shopBill.payModels[0].payPlatformId;
      if (this.radio === 'WXPAY') {
        this.payTitle = '立即支付';
      } else {
        this.payTitle = '立即收款';
      }
    },

    // 支付方式改变 payModelId 改变
    radioChange: function radioChange(payPlatformId) {
      this.payPlatformId = payPlatformId;
      console.log(this.radio);
      if (this.radio === 'WXPAY') {
        this.payTitle = '立即支付';
      } else {
        this.payTitle = '立即收款';
      }
    },

    // 支付按钮
    nowPay: function nowPay() {
      if (this.radio === 'WXPAY') {
        this.payment();
      } else {
        this.coll();
      }
    },

    // 调用微信扫一扫
    coll: function coll() {
      var that = this; // 微信扫一扫关键字
      if (tuhu.device.isWeixin) {
        __WEBPACK_IMPORTED_MODULE_7__lib_commons_wxconfig__["a" /* default */].share(['scanQRCode']).then(function (status) {
          // console.log('配置是否成功', status)
          __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk___default.a.scanQRCode({
            desc: 'scanQRCode desc',
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success: function success(res) {
              // Toast.loading({
              //   message: '正在发起收款...',
              //   forbidClick: true,
              //   duration: that.duration1
              //   }) // 收款加载2s
              setTimeout(function () {
                if (that.time === 500) {
                  that.setOut();
                }
              }, that.time); // 2s后倒计时10秒
              var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              console.log(result, '121212');
              tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_10__configs_config__["a" /* default */].apis.PAY_UNIFIED, {
                method: 'post',
                body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
                  authCode: result,
                  orderId: that.orderIds,
                  jumpUrl: '',
                  openid: '',
                  payModelId: that.radio,
                  payPlatformId: that.payPlatformId,
                  payPriceTotal: that.totalPrice,
                  title: that.title
                })
              }).then(function (data) {
                if (data && data.code === '200') {
                  // that.setOut()
                  // that.show = false
                  // that.dialogs = false
                  // Toast.loading({
                  //     message: '收款中，请勿关闭页面！',
                  //     forbidClick: true,
                  //     duration: that.durations
                  //       }) // 查询支付状态
                  if (that.sec <= 20 && that.sec > 1) {
                    that.checkBill(data.data.orderId, data.data.outTradeNo);
                    // const interval = setInterval(() => {
                    //     that.checkBill(data.data.orderId, data.data.outTradeNo)
                    //     if (that.sec === 0) {
                    //       clearInterval(interval)
                    //     }
                    //   }, 3000)
                    //  that.checkBill(data.data.orderId, data.data.outTradeNo)
                  }
                  // that.checkBill(data.data.orderId, data.data.outTradeNo)
                  that.orderIdN = data.data.orderId;
                } else {
                  that.time = 1;
                  that.duration1 = 1;
                  that.show = false;
                  that.dialogs = false;
                  tuhu.toast(data.message || '网络错误');
                }
              }).catch(function () {
                that.show = false;
                that.dialogs = false;
                that.time = 1;
                that.duration1 = 1;
                setTimeout(function () {
                  tuhu.toast('支付出错');
                }, 2100);
              });
            },
            fail: function fail(err) {
              that.show = false;
              that.dialogs = false;
              tuhu.toast(err || '网络错误');
            }
          });
        });
      } else {
        tuhu.toast('请在微信客户端打开');
      }
    },

    // 唤起微信支付
    payment: function payment() {
      var _this2 = this;

      if (tuhu.device.isWeixin) {
        var _this = this;
        tuhu.wxsdk.ready().then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    __WEBPACK_IMPORTED_MODULE_9__lib_commons_xkPay_js__["a" /* default */].openBank({
                      // userId: '238283928',
                      signUrl: '' + __WEBPACK_IMPORTED_MODULE_10__configs_config__["a" /* default */].apis.PAY_UNIFIED,
                      orderId: _this.orderIds,
                      jumpUrl: '',
                      openid: '',
                      payModelId: _this.radio,
                      payPlatformId: _this.payPlatformId,
                      payPriceTotal: _this.totalPrice,
                      title: _this.title
                    }, true);

                  case 1:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (e) {
          console.log('支付错误1111', e);
        });
      } else {
        tuhu.toast('请于微信公众号中发起支付！');
      }
    },

    // 查询订单
    checkBill: function checkBill(orderId, outTradeNo) {
      var _this3 = this;

      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_10__configs_config__["a" /* default */].apis.PAY_QUERY, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
          reqNo: orderId,
          outTradeNo: outTradeNo
        })
      }).then(function (data) {
        if (data.data && data.code === '200') {
          _this3.show = false;
          _this3.dialogs = false;
          // this.durations = 100
          _this3.serd = true;
          _this3.checkSerBills();
        } else {
          // this.checkBill(orderId, outTradeNo)
          var interval = setInterval(function () {
            _this3.checkBill(orderId, outTradeNo);
            if (_this3.sec === 0) {
              clearInterval(interval);
            }
          }, 3000);
          // tuhu.toast('顾客支付失败，请重新进行收款!')
        }
      }).catch(function () {
        tuhu.toast('账单支付状态查询出错', 500);
      });
    },

    // 创建服务单
    checkSerBills: function checkSerBills() {
      var _this4 = this;

      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_10__configs_config__["a" /* default */].apis.SHOP_DISTR, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
          goodsOrderId: this.orderIds
        })
      }).then(function (data) {
        if (data && data.code === '200') {
          _this4.now = false;
          setTimeout(function () {
            _this4.navigateToBill();
          }, 200); // 跳转订单详情
        } else {
          _this4.dialog2();
          _this4.serd = false;
          // tuhu.toast(data.message || '网络错误')
        }
      }).catch(function () {
        tuhu.toast('创建服务单失败');
        _this4.serd = false;
      });
    },


    // 跳转链接
    navigateToBill: function navigateToBill() {
      tuhu.navigateTo({
        url: '/pages/cashiers/billDetail',
        query: {
          orderId: this.orderIds
        }
      });
    },

    // 客户收款倒计时
    setOut: function setOut() {
      var _this5 = this;

      // this.dialog()
      this.show = true;
      this.sec = 20;
      var interval = setInterval(function () {
        if (_this5.show === true) {
          _this5.sec--;
          if (_this5.sec === 0) {
            _this5.show = false;
            clearInterval(interval);
            _this5.dialog();
            // this.sec = 10
          }
        }
      }, 1000);
    },

    // 关闭支付单
    cancelPay: function cancelPay() {
      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_10__configs_config__["a" /* default */].apis.PAY_CLOSE, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
          goodsOrderId: this.orderIds
        })
      }).then(function (data) {
        if (data && data.code === '200') {
          tuhu.toast('当前支付单已关闭，请重新进行收款!');
        } else {
          tuhu.toast(data.message || '网络错误');
        }
      }).catch(function () {
        tuhu.toast('关闭支付单失败');
      });
    },

    // 支付确认弹框
    dialog: function dialog() {
      var _this6 = this;

      if (this.dialogs === true) {
        __WEBPACK_IMPORTED_MODULE_1_vant_es_dialog__["a" /* default */].confirm({
          title: '支付确认',
          message: '请与顾客确认支付状态：' + '\n1. 如顾客已放弃支付，请点击 [客户已放弃支付]' + '\n2. 如顾客正在支付，请点击 [等待顾客继续支付]',
          cancelButtonText: '客户已放弃支付',
          confirmButtonText: '等待顾客继续支付',
          messageAlign: 'left',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonColor: '#1989fa'
        }).then(function () {
          // on confirm
          _this6.setOut();
        }).catch(function () {
          // on cancel
          _this6.cancelPay();
          // tuhu.toast('顾客支付失败，请重新进行收款!')
        });
      }
    },

    // 创建服务单失败提示弹框
    dialog2: function dialog2() {
      __WEBPACK_IMPORTED_MODULE_1_vant_es_dialog__["a" /* default */].confirm({
        title: '服务单创建失败',
        message: '服务单创建失败，已支付款项将退回客户支付账户，请提醒客户查看！',
        cancelButtonText: '联系客服',
        confirmButtonText: '重新下单',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#1989fa'
      }).then(function () {
        // on confirm
      }).catch(function () {
        // on cancel
        var deviceInfo = tuhu.device;
        if (deviceInfo.iphone) {
          window.location.href = 'tel://400-176-8848';
        } else {
          window.location.href = 'tel:400-176-8848';
        }
      });
    }
  }
});

/***/ }),

/***/ "4uTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_coupons_vue__ = __webpack_require__("k1KU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19c21cc7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coupons_vue__ = __webpack_require__("MnV8");
function injectStyle (ssrContext) {
  __webpack_require__("XLZH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19c21cc7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_coupons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19c21cc7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coupons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "56pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7D6f");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0853740a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("E63A");
function injectStyle (ssrContext) {
  __webpack_require__("7Rgr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0853740a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0853740a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5FTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mwtemplate__ = __webpack_require__("s2wQ");
//
//
//
//
//
//

// import base64 from 'base-64'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mlink: '',
      showDownloadBtnStatus: false,
      downloadAppImg: tuhu.downloadAppImg,
      mlinkid: tuhu.util.getGroup()
    };
  },

  props: {
    nativeurl: {
      type: String,
      default: '/home?v=1'
    },
    forceredirect: {
      type: Number,
      default: 0
    },
    eventaction: {
      type: String,
      detault: 'downloadapp_click'
    },
    callbackfun: {
      type: Function
    }
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      // this.downloadinit()
      setTimeout(function () {
        _this.downloadappinit();
        _this.$emit('callbackfun', _this.showDownloadBtnStatus);
      }, 500);

      var ua = navigator.userAgent || '';
      var myAppUrl = 'tuhu://explore';
      if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
        myAppUrl = 'tuhu:';
      }

      if (this.nativeurl.indexOf('http') === 0) {
        myAppUrl = 'tuhu://explore/webView?url=';
      }

      var link = tuhu.getParam('nativeurl') || '' + myAppUrl + this.nativeurl;
      var redirect = tuhu.getParam('forceredirect') || this.forceredirect;
      this.mlink = decodeURIComponent('' + link);
      if (redirect && parseInt(redirect)) {
        location.href = this.mlink;
      }
    },
    downloadappinit: function downloadappinit() {
      var channelInfo = tuhu.channelInfo;
      var status = false;
      if (channelInfo) {
        status = channelInfo.isShowDownLoadBtn;
      }
      if (tuhu.getParam('hidedownload')) {
        status = false;
      }
      if (tuhu.isLightApp) {
        status = false;
      }
      this.showDownloadBtnStatus = status;
    },
    downloadinit: function downloadinit() {
      tuhu.script('https://static.mlinks.cc/scripts/dist/mlink.min.js');
    },
    openApp: function openApp() {
      Ta.ta('event', 'mw_openapp_img_click', {
        channel: tuhu.orderChannel || 'kH5'
      });
      tuhu.tPopup.popupData(__WEBPACK_IMPORTED_MODULE_0__mwtemplate__["a" /* default */], {
        wrapCla: 'mw_centerMiddle', // 最外层追加的Class名
        isShowCloseBtn: false,
        alignCla: 'centerMiddle', // ''|'bottom'|'top'|'fullScreen'|'centerMiddle',
        transitionCls: 't_scale', // ''|'t_toUp'|'t_scale'|'t_toBottom'|'t_toLeft';
        props: {
          mlink: this.mlink
        }
      }).then(function (data) {
        if (data && data.type === 'close') {
          Ta.ta('event', 'mw_close_click', {
            channel: tuhu.orderChannel || 'kH5'
          });
        }
      });
      // if (tuhu.orderChannel === 'zhidemai') {
      //   // 值得买特殊处理 CPSZDMParameters
      //   const feedback = tuhu.util.getCookie('CPSZDMParameters')
      //   this.mlink = `${this.mlink}&feedback=${feedback}`

      //   location.href = this.mlink
      // }

      // try {
      //   const data = base64.encode(JSON.stringify({
      //     url: this.mlink
      //   }))
      //   const id = this.mlinkid

      //   new window.Mlink({
      //     mlink: 'AakR',
      //     button: document.querySelector('a#' + id),
      //     params: {data: data}
      //   })
      // } catch (e) {
      //   tuhu.toast('网络异常')
      // }

      // setTimeout(() => {
      //   try {
      //     const id = this.mlinkid
      //     const aDom = document.querySelector('#' + id)

      //     aDom && aDom.dispatchEvent(new MouseEvent('click'))
      //   } catch (e) {
      //     try {
      //       this.$refs.mlinkref.click()
      //     } catch (e) {
      //       tuhu.toast('系统异常')
      //     }
      //   }
      // }, 2000)
    }
  }
});

/***/ }),

/***/ "5Hoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5b9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("6x3Y");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16320fde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("L5f8");
function injectStyle (ssrContext) {
  __webpack_require__("yXvx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16320fde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16320fde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5uA8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "65XL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ORIGIN = 'https://api.hzqmtech.com'; // 正式接口地址
// const ORIGIN = 'http://test-api.hzqmtech.com' // 测试接口地址

/* harmony default export */ __webpack_exports__["a"] = ({
  // 处理url
  apiFilter: function apiFilter(url) {
    var origin = location.origin;

    if (origin === 'http://test-m.hzqmtech.com') {
      //测试
      return url.replace(
      // /http:\/\/47.99.172.20:4041/, //正式ip
      /https:\/\/api.hzqmtech.com/, //正式
      'http://test-api.hzqmtech.com' //测试接口地址
      );
    }
    return url;
  },

  // 添加接口后记得在dev.env.js中的proxyTarget中也加入，不然会出现本地代理拦截的情况
  apis: {
    LOGIN: ORIGIN + '/shop/auth/login', // 登录
    captchaGet: ORIGIN + '/shop/auth/captcha/get', // 获取验证图片  以及token
    captchaCheck: ORIGIN + '/shop/auth/captcha/verification/code', // 滑动或者点选验证
    GET_CODE: ORIGIN + '/shop/auth/getVerificationCode', // 获取验证码
    LOG_OUT: ORIGIN + '/shop/auth/logout', // 退登
    PROVINCE: ORIGIN + '/admin/common/areaTree', // 获取省市区
    GET_BANK_LIST: ORIGIN + '/admin/common/getOrganizationDetailListByType', // 银行列表
    // GET_HOME_DATA: `${ORIGIN}/shop/merchant/merchantHomeInfo`, // 获取商户端首页信息
    WX_SILENT: ORIGIN + '/shop/wechat/silentAuthorization', // wx静默授权登陆 逻辑：前端请求接口 => 后端判断是否存此用户 => 有用户存token跳首页,无用户跳登陆页返回openId登陆时传给后端
    // GET_SHOP_ACCOUNTS: `${ORIGIN}/shop/user/select/`, // 查门店所有账号
    GET_SHOPLIST_BYID: ORIGIN + '/shop/merchant/getShopListByTraderId', // 获取商户绑定的门店列表
    // GET_ACCOUNT_PERMISSION: `${ORIGIN}/shop/user/selectAccountPermission`, // 查商户账号权限
    SWITCH_SHOP: ORIGIN + '/shop/merchant/switchShop', // 切换门店
    SWITCH_USER_COUNT: ORIGIN + '/shop/user/switchUserShop', // 切换账号
    GET_USERINFO: ORIGIN + '/shop/user/selectUserInfo', // 获取商户信息
    CHECK_CODE_COUPON: ORIGIN + '/shop/merchant/merchantCheckCode', // 校验核销券码
    GET_CODE_COUPON: ORIGIN + '/shop/merchant/merchantWriteOffCode', // 核销券码
    GET_VERIFICATION_CONFIG: ORIGIN + '/shop/merchant/getVerificationConfig', //获取核销配置信息

    GET_SAFE_MESSAGE: ORIGIN + '/shop/merchant/getSafeCheckMessage', // 获取安全检测信息
    UPDATE_SAFE_MESSAGE: ORIGIN + '/shop/merchant/updateSafeCheckMessage', //更新安全检测信息
    // 订单
    GET_TODAYORDER_LIST: ORIGIN + '/shop/merchant/merchantTodayOrderList', // 商户今日订单列表
    GET_ALLORDER_LIST: ORIGIN + '/shop/merchant/merchantAllOrderList', // 全部订单
    // UPDATAE_WRITEOFF_PIC: `${ORIGIN}/shopBillBackStage/updateShopWriteOffPic`, // 订单修改核销图片,不用了，在修改核销信息里边统一修改
    GET_ALLORDER_DETAILLIST: ORIGIN + '/shop/merchant/merchantAllOrderDetailList', // 全部订单详细列表
    GET_SECOND_CLASS: ORIGIN + '/admin/common/getServiceClassList', // 全部二级服务名
    // 门店信息
    SHOP_OPEN_INFO: ORIGIN + '/shop/merchant/merchantShopBasicInfo', // 商户门店营业信息
    SHOP_BASIC_INFO: ORIGIN + '/shop/merchant/merchantShopDetailInfo', // 商户端门店基本信息
    SHOP_MERCHANT_INFO: ORIGIN + '/shop/merchant/merchantShopStoreInfo', // 商户门店店铺信息
    SHOP_COMPANY_INFO: ORIGIN + '/shop/merchant/merchantShopCompanyInfo', // 商户门店企业信息
    SHOP_CERTIFICATE_PHOTO: ORIGIN + '/shop/merchant/merchantUrlInfoList', // 商户端证照店照
    // 修改门店信息页
    GET_DOOR_URL: ORIGIN + '/shop/merchant/merchantChangeShopDoorUtl', // 商户更换门头照
    GET_SHOP_STATUS: ORIGIN + '/shop/merchant/merchantChangeShopStatus', // 商户更改门店状态
    GET_BUSINESS_HOURS: ORIGIN + '/shop/merchant/merchantChangeBusinessHours', // 商户修改营业时间
    CHANGE_SHOP_DETAIL: ORIGIN + '/shop/merchant/merchantChangeShopDetail', // 商户端修改门店基本信息
    CHANGE_SHOP_STOREINFO: ORIGIN + '/shop/merchant/merchantChangeShopStoreInfo', // 商户端修改门店店铺信息
    CHANGE_SHOP_COMPANYINFO: ORIGIN + '/shop/merchant/merchantChangeShopCompanyInfo', // 商户端修改门店企业信息
    CHANGE_SHOP_URLINFO: ORIGIN + '/shop/merchant/merchantChangeUrlInfo', // 商户端修改证照店照
    // 门店服务
    SERVICE_LIST: ORIGIN + '/shop/merchant/merchantServiceList', // 商户获取门店服务列表
    // 关闭服务页
    CLOSE_SERVICE: ORIGIN + '/shop/merchant/merchantCloseServiceSign', // 商户端关闭服务

    // 员工管理
    SELECT_USER_INFO: ORIGIN + '/shop/user/select', // 查询当前商户信息
    // 添加账号页
    ADD_USER_ACCOUNT: ORIGIN + '/shop/user/addUserAccount', // 新增账号
    SHOP_USER_UPDATE: ORIGIN + '/shop/user/update', // 商户员工编辑和删除

    // 结款管理
    SETTLEMENT_LIST: ORIGIN + '/shop/merchant/merchantSettlementList', // 商户结款记录
    // SETTLEMENT_ORDER_LIST: `${ORIGIN}/shop/merchant/matchMerchantSettlement`, // 商户出账订单
    SETTLEMENT_ORDER_INFO: ORIGIN + '/shop/merchant/applyMerchantSettlementDetail', // 商户出账详情
    SETTLEMENT_ORDER_SUBMIT: ORIGIN + '/shop/merchant/applyMerchantSettlement', // 申请出账

    // 收款账户
    PROCEEDS_BANKCAR_INFO: ORIGIN + '/shop/merchant/merchantBankCarInfo', // 商户端银行卡信息
    PROCEEDS_CHANGE_BANKCAR_INFO: ORIGIN + '/shop/merchant/merchantChangeBankCardInfo', // 商户端修改银行卡信息
    // 公共
    RENDER_MAP: 'https://www.xiaokunkeji.cn/user/vue/locateline.html?isLocate=1', // 渲染地图 不要调User的了，重新画地图吧
    XK_MAP: 'https://www.xiaokunkeji.cn/user/vue/locateline.html', // 地图地址 不要调User的了，重新画地图吧
    // 加盟
    SHOP_VERIFY_LOGIN: ORIGIN + '/admin/shop-check/checkShopUser', // 登陆校验-查看门店详情
    SHOP_ADDSHOP: ORIGIN + '/admin/shop-check/add', // 新增门店签约
    SHOP_EDITSHOP: ORIGIN + '/shop/merchant/editShopSignStatus', // 查看已有门店签约
    ADD_SHOP_DETAIL: ORIGIN + '/shop/merchant/getShopDetail', // 门店详情
    PAY_UNIFIED: ORIGIN + '/pay/unified', // 扫码支付
    PAY_QUERY: ORIGIN + '/pay/query', // 支付结果查询
    INDEX_CONFIG: ORIGIN + '/distribution', // 渠道下单首页配置接口
    GOOD_LISTS: ORIGIN + '/goods/distribution', // 商品列表
    GOOD_SUBMIT: ORIGIN + '/goods/order/submit', // 商品下单
    SHOP_DISTR: ORIGIN + '/shopdistr/order/submit', // 创建服务单
    GOODS_DETAIL: ORIGIN + '/goods/order/detail', // 购买商品详情查询
    PAY_CLOSE: ORIGIN + '/pay/close', // 关闭支付定单接口
    // GET_SHOP_URL_PROVIDE: `${ORIGIN}/distribution/whether/access`,
    GET_QUERY_TP: ORIGIN + '/shop/wax/waxShop', // 太平财险
    GET_VERUFUCATION_CODE: ORIGIN + '/shop/wax/getVerification', // 太平券码验证
    TO_VALIDATE: ORIGIN + '/shop/wax/waxOrder', // 太平核销
    GET_MERCHANT_YEAR: ORIGIN + '/shop/merchant/listYearMonth', //商户查询x年的月订单统计
    GET_MERCHANT_MONTH: ORIGIN + '/shop/merchant/month', //商户查询x年x月的订单统计
    GET_MERCHANT_NUM: ORIGIN + '/shop/merchant/chargeCount', //商户查询本月出账次数
    TO_SHOP_ACCOUNT: ORIGIN + '/shop/merchant/beforehandSettlement', //商户出账
    GET_AGREEMERT_INFO: ORIGIN + '/shop/merchant/agreement', //小鲲协议
    // 抖音
    GET_TIKTOY_MERCHANT_PREPARE: ORIGIN + '/tiktok/merchant/prepare', //抖音核销确认
    GET_TIKTOK_VERIFY: ORIGIN + '/tiktok/merchant/verify', //抖音核销
    GET_TIKTOK_ORDER_YEAR_RECORD: ORIGIN + '/tiktok/merchant/order/year', //抖音核销年记录
    GET_TIKTOK_ORDER_DAY_RECORD: ORIGIN + '/tiktok/merchant/order/day', //抖音核销日记录
    QUERY_TIKTOK_CANCEL: ORIGIN + '/tiktok/merchant/cancel', //抖音撤销核销
    GET_TIKTOK_MERCHANT_LIST: ORIGIN + '/tiktok/merchant/list', //核销列表
    GET_TIKTOK_MAINTAIM_MERCHANT_PERPARE: ORIGIN + '/tiktok/merchant/maintain/verify', // 抖音保养核销
    //
    GET_MERCHANT_VERIFY_FIRST_TIME: ORIGIN + '/shop/merchant/verifyFirstTime', // 验证用户是否第一次登录
    UploadBase64File: ORIGIN + '/admin/common/uploadBaseFile', //base64流上传
    GetSignature: ORIGIN + '/shop/merchant/getSignature', //生成电子签名
    UPLOAD_INVOICE: ORIGIN + '/admin/shopInvoiceBill/upload', //用户上传发票
    UPLOAD_URL: ORIGIN + '/admin/common/upload', //上传
    INVOICE_INFO: ORIGIN + '/admin/shopInvoiceBill/getInvoiceInfo', //查看发票信息
    //
    ADD_USER_NOTICE: ORIGIN + '/shop/user/addUserNotice', //用户看过某个公告
    ADD_AGREEMENT: ORIGIN + '/shop/merchant/addAgreement', //商户签订协议

    UPLOAD_URL_TO_PDF: ORIGIN + '/admin/common/imageListToPdf', //图片列表转pdf

    SAVE_REST_TIME: ORIGIN + '/shop/restTime/save' //保存节假日休息时间
  },
  pages: {
    // home
    '/pages/home/index': {
      title: '商户管理首页',
      vue: __webpack_require__("FP3a"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/orderAll/index': {
      title: '全部订单',
      vue: __webpack_require__("zG/U"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/orderToday/index': {
      title: '今日订单',
      vue: __webpack_require__("gXbw"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/orderDetail/index': {
      title: '订单详情',
      vue: __webpack_require__("J1i8"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 门店信息
    '/pages/shopInfo/index': {
      title: '门店信息',
      vue: __webpack_require__("P3LE"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/changeShopInfo/index': {
      title: '修改门店信息',
      vue: __webpack_require__("L1w5"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 门店服务
    '/pages/shopService/index': {
      title: '门店服务',
      vue: __webpack_require__("73KK"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 关闭门店服务
    '/pages/shopServeClose/index': {
      title: '门店服务',
      vue: __webpack_require__("6jrD"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 员工管理
    '/pages/userManagement/index': {
      title: '员工管理',
      vue: __webpack_require__("eApe"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/accountAccessPic/index': {
      title: '权限管理',
      vue: __webpack_require__("ZVHc"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/addAccessUser/index': {
      title: '增加账号',
      vue: __webpack_require__("DrzV"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },

    // 结款管理
    '/pages/settlementRecords/index': {
      title: '结算管理',
      vue: __webpack_require__("6iwZ"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 确认信息
    '/pages/confirmInfo/index': {
      title: '确认信息',
      vue: __webpack_require__("I8BA"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },

    // 收款账户
    '/pages/accounts/index': {
      title: '添加收款账户',
      vue: __webpack_require__("56pz"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销券页面
    '/pages/verifyCode/index': {
      title: '券码核销',
      vue: __webpack_require__("6l62"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销信息 上传图片
    '/pages/verifyUploadImg/index': {
      title: '核销信息',
      vue: __webpack_require__("Ax1q"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 修改核销信息
    '/pages/editVerifyImg/index': {
      title: '修改核销信息',
      vue: __webpack_require__("pjao"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销信息 上传图片
    '/pages/orderDetail/onlineSign': {
      title: '在线签名',
      vue: __webpack_require__("KPJK"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 商户加盟页
    '/pages/cooperation/index': {
      title: '小鲲车服',
      vue: __webpack_require__("tqxU"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 填写加盟信息
    '/pages/cooperationShopInfo/index': {
      title: '填写信息',
      vue: __webpack_require__("ZLWk"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 通用页面bankList
    '/pages/bankList/index': {
      title: '填写信息',
      vue: __webpack_require__("MZKj"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/agreement/index': {
      title: '小鲲车服入驻协议',
      vue: __webpack_require__("Ia83"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/cashiers/index': {
      title: '小鲲收银台',
      vue: __webpack_require__("Et+B"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/shopBill/index': {
      title: '',
      vue: __webpack_require__("wPkz"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/cashiers/billDetail': {
      title: '订单详情',
      vue: __webpack_require__("sONz"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 太平核销信息
    '/pages/verify/code': {
      title: '核销信息',
      vue: __webpack_require__("4jlU"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    '/pages/home/text': {
      title: '结算流程通知',
      vue: __webpack_require__("KUrA"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    '/pages/home/textInvoice': {
      //有发票的
      title: '结算流程通知',
      vue: __webpack_require__("Yc9d"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 核销记录（年）
    '/pages/yearRecord/index': {
      title: '',
      vue: __webpack_require__("dQAN"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销记录（月）
    '/pages/monthRecord/index': {
      title: '',
      vue: __webpack_require__("AfIi"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 核销记录（日）
    '/pages/dayRecord/index': {
      title: '',
      vue: __webpack_require__("zS2x"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 抖音验券核销
    '/pages/tiktok/verify': {
      title: '验券核销',
      vue: __webpack_require__("uY7Y"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 抖音验券核销结果
    '/pages/tiktok/result': {
      title: '核销结果',
      vue: __webpack_require__("1qOG"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 发票管理
    '/pages/invoice/index': {
      title: '发票管理',
      vue: __webpack_require__("b9Th"),
      forceLocate: false,
      forceLogin: true,
      forceCar: false
    },
    // 服务协议
    '/pages/assignMent/index': {
      title: '服务协议',
      vue: __webpack_require__("5b9E"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    },
    // 服务协议
    '/pages/common/review': {
      title: 'PDF预览',
      vue: __webpack_require__("TK4F"),
      forceLocate: false,
      forceLogin: false,
      forceCar: false
    }
  }
});

/***/ }),

/***/ "6KQ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6XpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"main-bg"},[_c('div',{staticClass:"main-bg-name"},[_c('p',{staticClass:"main-switch"},[_c('img',{staticClass:"main-logo",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/04638af030304facb5768e9720cf974f.png","alt":""}}),_vm._v(" "),_c('span',{staticClass:"main-shop-name"},[_vm._v(_vm._s(_vm.currentShopData.shopName))])]),_vm._v(" "),(_vm.shopList.length > 1)?_c('p',{staticClass:"main-switch-ed",on:{"click":function($event){_vm.showAllShop = true}}},[_vm._v("\n          切换\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"entry-order-num"},[_c('div',{staticClass:"order-content",on:{"click":function($event){return _vm.handleClick2(_vm.tabList1[0])}}},[_c('span',[_vm._v(_vm._s(_vm.currentShopData.orderCount || 0)+" ")]),_vm._v(" "),_c('span',[_vm._v("总订单")])]),_vm._v(" "),_c('div',{staticClass:"order-content",on:{"click":function($event){return _vm.handleClick2(_vm.tabList2[0])}}},[_c('span',[_vm._v(_vm._s(_vm.currentShopData.todayOrderCount || 0))]),_vm._v(" "),_c('span',[_vm._v("今日订单")])])]),_vm._v(" "),_c('slideTip',{attrs:{"billFlag":_vm.userInfo.billFlag},on:{"showSlide":_vm.handleShowSlide}}),_vm._v(" "),(_vm.veryCoupon)?_c('div',{staticClass:"entry-content"},[(_vm.shopStatus == 1)?_c('div',{staticClass:"entry-item",on:{"click":_vm.scanQrcode}},[_c('img',{staticClass:"enter-img",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/a05ff421a59b4acbb37f775abfbf02b2.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("扫一扫")])]):_c('div',{staticClass:"entry-item",on:{"click":_vm.handleOpenTips}},[_c('img',{staticClass:"enter-img",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/a05ff421a59b4acbb37f775abfbf02b2.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("扫一扫")])]),_vm._v(" "),(_vm.shopStatus == 1)?_c('div',{staticClass:"entry-item",on:{"click":_vm.handleVerify}},[_c('img',{staticClass:"enter-img",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/e65bc35ae1734dd4a57eeec7ccfd2292.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("消费码")])]):_c('div',{staticClass:"entry-item",on:{"click":_vm.handleOpenTips}},[_c('img',{staticClass:"enter-img",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/e65bc35ae1734dd4a57eeec7ccfd2292.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v("消费码")])])]):_vm._e(),_vm._v(" "),(_vm.tpVisible)?_c('div',{staticClass:"entry-content"},[_c('div',{staticClass:"tp-entry-item"},[_vm._m(0),_vm._v(" "),_c('img',{staticClass:"tp-enter-code",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/b019730365cd4e62b3412570c43c1a61.png","alt":""},on:{"click":_vm.handleGoToTP}})])]):_vm._e(),_vm._v(" "),(_vm.currentShopData.tiktokShop)?_c('div',{staticClass:"entry-dy-zone"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dy-zone-record"},[_c('div',{staticClass:"flex-row",on:{"click":function($event){return _vm.handleDyZone('/pages/dayRecord/index')}}},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.tiktokOrder.verifyOrderSum || 0))]),_vm._v(" "),_c('p',[_vm._v("今日订单")])]),_vm._v(" "),_c('div',{staticClass:"flex-row",on:{"click":function($event){return _vm.handleDySRcode()}}},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/658afb910bb94d5d852131b52717eda4.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("扫码核销")])]),_vm._v(" "),_c('div',{staticClass:"flex-row",on:{"click":function($event){return _vm.handleDyZone('/pages/yearRecord/index')}}},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/149eff069f034ec2b50a3381eabb9392.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("核销记录")])]),_vm._v(" "),_c('div',{staticClass:"flex-row",on:{"click":function($event){_vm.tiktokVisible = true}}},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/07/7cfaafe997024455b2007f420df8a744.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("结算说明")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-entry-ed"},[_c('p',{staticClass:"main-entry-name"},[_vm._v("服务功能")]),_vm._v(" "),_c('div',{staticClass:"main-entry"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,staticClass:"entry-item entry-item-ed",on:{"click":function($event){return _vm.handleClick(item)}}},[_c('div',{staticClass:"item-img"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.badge),expression:"item.badge"}],staticClass:"entry-badge"},[_vm._v(_vm._s(item.badge))]),_vm._v(" "),_c('img',{staticClass:"item-img",attrs:{"src":item.icon,"alt":""}})]),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(item.name)}})])}),0)]),_vm._v(" "),(_vm.marketManage)?_c('div',{directives:[{name:"call",rawName:"v-call",value:({
          tel: _vm.currentShopInfo && _vm.currentShopInfo.managerPhone ? _vm.currentShopInfo.managerPhone : '400-176-8848'
        }),expression:"{\n          tel: currentShopInfo && currentShopInfo.managerPhone ? currentShopInfo.managerPhone : '400-176-8848'\n        }"}],staticClass:"concat"},[_c('van-icon',{attrs:{"name":"phone","color":"#8AB2FB"}}),_vm._v(" "),_c('span',[_vm._v("直接拨打门店专员电话")])],1):_vm._e()],1),_vm._v(" "),_c('van-popup',{style:({ height: '30%' }),attrs:{"position":"bottom"},model:{value:(_vm.showAllShop),callback:function ($$v) {_vm.showAllShop=$$v},expression:"showAllShop"}},[_c('van-radio-group',{staticClass:"shoplist-popup",model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},_vm._l((_vm.shopList),function(item,index){return _c('van-cell',{key:index,class:{
            'shop-item': true,
            selected: _vm.currentShopData.id === item.id
          },attrs:{"clickable":true},on:{"click":function($event){return _vm.handleSelect(item)}}},[_c('van-radio',{attrs:{"name":index}},[_vm._v(_vm._s(item.shopName))])],1)}),1)],1),_vm._v(" "),_c('van-dialog',{staticClass:"custormTips",attrs:{"showConfirmButton":false},model:{value:(_vm.tipsVisible),callback:function ($$v) {_vm.tipsVisible=$$v},expression:"tipsVisible"}},[_c('p',{staticClass:"title"},[_vm._v("小鲲车服结算流程调整通知")]),_vm._v(" "),_c('p',{staticClass:"tips"},[_c('img',{attrs:{"src":_vm.icon1,"alt":""}}),_vm._v("非常重要，请务必仔细阅读！")]),_vm._v(" "),_c('div',{staticClass:"t-content"},[_c('p',{staticClass:"name"},[_vm._v("尊敬的小鲲车服合作商户：")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n              您好！感谢一直以来对小鲲车服的支持。为更灵活、更方便的向各位商户结算服务费用，同时避免出现打款错误的情况发生（如：门店收款信息变更），小鲲车服对结算流程进行了优化调整：\n          "),_c('span',[_vm._v("由系统每月自动生成结算单，调整为由您在商户端进入【结算管理】栏目自行申请结算！")]),_vm._v("具体流程说明请查看详情。\n        ")]),_vm._v(" "),_c('p',{staticClass:"t-btn",on:{"click":_vm.closeTipsVisible}},[_vm._v("查看详情")]),_vm._v(" "),_c('p',{staticClass:"close",on:{"click":_vm.closeTipsVisible2}},[_vm._v("我已知晓该通知内容")])])]),_vm._v(" "),_c('van-dialog',{staticClass:"custormTips1",attrs:{"showConfirmButton":false},model:{value:(_vm.tiktokVisible),callback:function ($$v) {_vm.tiktokVisible=$$v},expression:"tiktokVisible"}},[_c('p',{staticClass:"title"},[_vm._v("抖音订单结算说明")]),_vm._v(" "),_c('p',{staticClass:"tips1"},[_c('img',{attrs:{"src":_vm.icon1,"alt":""}}),_vm._v("非常重要，请务必仔细阅读！")]),_vm._v(" "),_c('div',{staticClass:"t-content"},[_c('p',{staticClass:"name"},[_vm._v("尊敬的小鲲车服合作商户：")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n              您好！感谢一直以来对小鲲车服的支持。我司在抖音的业务是以"),_c('span',[_vm._v("鲲鲲养车")]),_vm._v("品牌进行的推广，您的门店在抖音推广的店名均带有"),_c('span',[_vm._v("鲲鲲养车")]),_vm._v("字样，凡是用户在"),_c('span',[_vm._v("鲲鲲养车")]),_vm._v("字样门店购买的服务请务必使用小鲲商户端抖音专区进行扫码核销，核销成功后服务结算款项将由抖音在次日（T+1）打款至您的银行账户，如对结算有疑问，可致电小鲲车服商户专员或客服!\n        ")]),_vm._v(" "),_c('div',{staticClass:"t-btn",on:{"click":function () {
              _vm.tiktokVisible = false
            }}},[_vm._v("\n          我知道了\n        ")])])]),_vm._v(" "),_c('van-dialog',{staticClass:"custormTips3",attrs:{"showConfirmButton":false},model:{value:(_vm.visiblePopup),callback:function ($$v) {_vm.visiblePopup=$$v},expression:"visiblePopup"}},[_c('p',{staticClass:"title"},[_vm._v("温馨提示")]),_vm._v(" "),_c('div',{staticClass:"t-content"},[_c('p',{staticClass:"name"},[_vm._v("尊敬的小鲲合作商户：")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.commonText)}}),_vm._v(" "),_c('p',{staticClass:"service-provider"},[_vm._v("小鲲车服商户管理中心")]),_vm._v(" "),_c('img',{staticClass:"t-btns",attrs:{"src":_vm.btn,"alt":""},on:{"click":function($event){_vm.visiblePopup = false}}})])]),_vm._v(" "),_c('van-dialog',{staticClass:"custormTips4",attrs:{"showConfirmButton":true,"showCancelButton":true,"confirmButtonText":"去签署","title":"提示"},on:{"confirm":_vm.toAssignMent},model:{value:(_vm.visibleAssign),callback:function ($$v) {_vm.visibleAssign=$$v},expression:"visibleAssign"}},[_c('p',{staticClass:"t-content4"},[_vm._v("您好,合作协议已更新需重新签署")])]),_vm._v(" "),_vm._l((_vm.noticeDialogs),function(item){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.show),expression:"item.show"}],key:item.id},[(_vm.currentIndex === 0 && item.show)?_c('holiday-confirm',{attrs:{"visible":item.show,"shopId":_vm.currentShopData.shopId},on:{"close":function($event){return _vm.handleClose(item.id)}}}):_vm._e(),_vm._v(" "),(_vm.currentIndex === 1 && item.show)?_c('sildePopup',{attrs:{"visible":item.show,"slideId":item.containSlideId},on:{"close":function($event){return _vm.handleClose(item.id)}}}):_vm._e(),_vm._v(" "),(_vm.currentIndex === 2 && item.show)?_c('sildePopup2',{attrs:{"visible":item.show,"slideId":item.containSlideId},on:{"close":function($event){return _vm.handleClose(item.id)}}}):_vm._e(),_vm._v(" "),(_vm.currentIndex === 3 && item.show && _vm.userInfo.role === '老板')?_c('sildePopup3',{attrs:{"visible":item.show},on:{"close":function($event){return _vm.handleClose(item.id)}}}):_vm._e()],1)})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tp-flex"},[_c('span',{staticClass:"tp-name"},[_vm._v("太平财险核销")]),_vm._v(" "),_c('img',{staticClass:"tp-logo",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/06cf60bc65ab48cd90fc031e49cbbb53.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dy-zone-name"},[_c('p',{staticClass:"name"},[_vm._v("抖音核销专区")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("鲲鲲养车")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6iwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Xj3y");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a296ee62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("TSLh");
function injectStyle (ssrContext) {
  __webpack_require__("0NVO")
  __webpack_require__("V0e4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a296ee62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a296ee62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6jrD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("EttA");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa62010_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nYer");
function injectStyle (ssrContext) {
  __webpack_require__("z4ei")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7aa62010"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aa62010_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6l62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JCFv");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3351e9cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("RyDP");
function injectStyle (ssrContext) {
  __webpack_require__("V51g")
  __webpack_require__("LOZ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3351e9cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3351e9cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6seA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QHvU");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd10560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ypDU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd10560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6x3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_image_preview_style__ = __webpack_require__("WJbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_image_preview__ = __webpack_require__("OhwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_loading_style__ = __webpack_require__("nOaS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_es_loading__ = __webpack_require__("pIDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_signPad_vue__ = __webpack_require__("Zmio");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_agreement_vue__ = __webpack_require__("Ia83");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__imgs_image_success_png__ = __webpack_require__("kfX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__imgs_image_success_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__imgs_image_success_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commons_util__ = __webpack_require__("sEZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commons_imageCompress__ = __webpack_require__("N6PM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);









 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
Vue.use(__WEBPACK_IMPORTED_MODULE_9_vant_es_loading__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shouldStorageShopForm: '0',
      assignSignPdfUrl: null, //pdf
      fileUrl1: 'https://res.xiaokunkeji.cn/image/2025/11/27/4a9c97f85a69488da988cb3ee22bbc44.jpg',
      fileUrl2: 'https://res.xiaokunkeji.cn/image/2025/11/27/330e4f9ac61a4088859b4bd1e8c5e62b.jpg',
      fileUrl3: 'https://res.xiaokunkeji.cn/image/2025/11/27/061bf0dd5f4d41c1bb57b8ad94da1fc9.jpg',
      fileUrl5: 'https://res.xiaokunkeji.cn/image/2025/11/27/4ba0fdd2433d47388cf7286c7da9331b.jpg',
      file1: null,
      file2: null,
      file3: null,
      file5: null,
      shopInfo: {},
      isAssign: true,
      assignSignUrlOrginal: 'https://res.xiaokunkeji.cn/image/2025/11/27/52a0c161d2e045b3b498c52043380c95.jpg',
      assignSignUrl: 'https://res.xiaokunkeji.cn/image/2025/11/27/52a0c161d2e045b3b498c52043380c95.jpg',
      assignSignUrl2: 'https://res.xiaokunkeji.cn/image/2025/11/27/52a0c161d2e045b3b498c52043380c95.jpg',
      form: {},
      signatureUrl: '',
      signatureUrl2: '',
      isShowSignPad: false,
      merchantCode: tuhu.getParam('merchantCode'),
      shopId: tuhu.getParam('shopId'),
      cryptoId: tuhu.getParam('cryptoId')
    };
  },

  components: {
    agreement: __WEBPACK_IMPORTED_MODULE_11__common_agreement_vue__["default"],
    signPad: __WEBPACK_IMPORTED_MODULE_10__components_signPad_vue__["a" /* default */]
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_14__commons_util__["a" /* default */].getFile('https://res.xiaokunkeji.cn/image/2025/11/27/4a9c97f85a69488da988cb3ee22bbc44.jpg').then(function (file) {
      _this.file1 = file;
    });
    __WEBPACK_IMPORTED_MODULE_14__commons_util__["a" /* default */].getFile('https://res.xiaokunkeji.cn/image/2025/11/27/330e4f9ac61a4088859b4bd1e8c5e62b.jpg').then(function (file) {
      return _this.file2 = file;
    });
    __WEBPACK_IMPORTED_MODULE_14__commons_util__["a" /* default */].getFile('https://res.xiaokunkeji.cn/image/2025/11/27/061bf0dd5f4d41c1bb57b8ad94da1fc9.jpg').then(function (file) {
      return _this.file3 = file;
    });
    __WEBPACK_IMPORTED_MODULE_14__commons_util__["a" /* default */].getFile('https://res.xiaokunkeji.cn/image/2025/11/27/4ba0fdd2433d47388cf7286c7da9331b.jpg').then(function (file) {
      return _this.file5 = file;
    });
    this.getAgreementInfo();
    // let vConsole = new VConsole()
  },


  computed: {
    btnStyle: function btnStyle() {
      return {
        background: this.signatureUrl ? 'linear-gradient(355deg, #0061FE 0%, #42BEF5 100%)' : '#d8d8d8'
      };
    }
  },

  methods: {
    showImagePreview: function showImagePreview(key) {
      Object(__WEBPACK_IMPORTED_MODULE_7_vant_es_image_preview__["a" /* default */])({
        images: [this.fileUrl1, this.fileUrl2, this.fileUrl3, this.assignSignUrl], // 要预览的图片数组（支持多张）
        closeable: true, // 显示关闭按钮
        closeOnPopstate: true, // 浏览器后退时关闭预览
        startPosition: key
      });
    },
    getAgreementInfo: function getAgreementInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!tuhu.getParam('cryptoId')) {
                  _context.next = 8;
                  break;
                }

                params = {
                  shopId: tuhu.getParam('cryptoId')
                };
                _context.next = 4;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_12__configs_config__["a" /* default */].apis.GET_AGREEMERT_INFO, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(params || '')
                });

              case 4:
                res = _context.sent;

                if (res.code === '200') {
                  _this2.shopInfo = res.data.shopInfo;
                } else {
                  tuhu.toast(res.message || '网络错误');
                }
                _context.next = 12;
                break;

              case 8:
                _this2.shouldStorageShopForm = tuhu.sessionStorage.getItem('shouldStorageShopForm');
                _this2.form = JSON.parse(tuhu.sessionStorage.getItem('shopForm'));
                console.log(_this2.form);
                _this2.shopInfo = {
                  name: _this2.form && _this2.form.shopName || ''
                };

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    close: function close(url) {
      tuhu.showIndicator();
      this.isShowSignPad = false;
      this.signatureUrl = url;
      this.exportImage();
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, form, data, msg;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.signatureUrl) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', tuhu.toast('请滑动到页面下方签署姓名'));

              case 2:
                if (_this3.isAssign) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', tuhu.toast('图片上传失败，需重新上传'));

              case 4:
                if (_this3.assignSignPdfUrl) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', tuhu.toast('协议生成失败，请重新签字'));

              case 6:
                // return
                url = _this3.shouldStorageShopForm === '1' ? __WEBPACK_IMPORTED_MODULE_12__configs_config__["a" /* default */].apis.SHOP_ADDSHOP : __WEBPACK_IMPORTED_MODULE_12__configs_config__["a" /* default */].apis.ADD_AGREEMENT;
                // !this.eventFlag ? url = config.apis.SHOP_ADDSHOP : url = config.apis.SHOP_EDITSHOP

                form = _this3.shouldStorageShopForm === '1' ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this3.form, {
                  shopId: _this3.cryptoId || '',
                  merchantCode: _this3.merchantCode || 'XKKJ',
                  shopSignUrl: _this3.assignSignPdfUrl
                }) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
                  shopId: _this3.shopId,
                  shopSignUrl: _this3.assignSignPdfUrl
                });
                _context2.prev = 8;
                _context2.next = 11;
                return tuhu.fetch('' + url, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(form)
                });

              case 11:
                data = _context2.sent;

                if (data && data.code === '200') {
                  msg = '提交成功，请耐心等待审核！';

                  tuhu.sessionStorage.setItem('shopForm', null);
                  tuhu.modal({
                    title: '',
                    text: '<img src="' + __WEBPACK_IMPORTED_MODULE_13__imgs_image_success_png___default.a + '" style="width:3.3rem; margin:0 auto">\n                                    <div style="font-size:16px;font-weight:600;padding:.2rem 0">\u63D0\u4EA4\u6210\u529F</div>\n                                <div style="text-align:left">' + msg + '</div>',
                    buttons: [{
                      text: '知道了',
                      bold: true,
                      onClick: function onClick() {
                        if (_this3.form && _this3.form.shopName) {
                          setTimeout(function () {
                            tuhu.redirectTo({ url: '/pages/_login/index' });
                          }, 200);
                        } else {
                          setTimeout(function () {
                            tuhu.redirectTo({ url: '/pages/home/index' });
                          }, 200);
                        }
                      }
                    }]
                  });
                } else {
                  tuhu.toast(data.message || '网络异常');
                }
                _context2.next = 17;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](8);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[8, 15]]);
      }))();
    },
    loadImages: function loadImages() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var loadImage, _ref, _ref2, baseImg, overlayImg;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loadImage = function loadImage(url) {
                  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (res, rej) {
                    var img = new Image();
                    img.crossOrigin = 'Anonymous';
                    img.onload = function () {
                      return res(img);
                    };
                    img.onerror = rej;
                    img.src = url;
                  });
                };

                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([loadImage(_this4.assignSignUrlOrginal), loadImage(_this4.signatureUrl)]);

              case 4:
                _ref = _context3.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                baseImg = _ref2[0];
                overlayImg = _ref2[1];

                _this4.assignSignUrl2 = baseImg;
                _this4.signatureUrl2 = overlayImg;
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](1);

                console.error('图片加载失败:', _context3.t0);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 12]]);
      }))();
    },
    getFormattedDate: function getFormattedDate() {
      var today = new Date();
      return today.getFullYear() + '\u5E74' + (today.getMonth() + 1) + '\u6708' + today.getDate() + '\u65E5';
    },
    drawWatermark: function drawWatermark(ctx, canvas, x, y, fillText) {
      var fontSize = Math.max(12, canvas.width * 0.015);
      ctx.font = 'bold ' + fontSize + 'px Arial';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'left';

      var textX = canvas.width / x;
      var textY = canvas.height * y;

      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
      ctx.shadowBlur = 2;
      ctx.fillText(fillText, textX, textY);
      ctx.shadowColor = 'transparent';
    },
    exportImage: function exportImage() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var exportCanvas, exportCtx, overlayHeight, overlayWidth, posX, posY, time, base64ImgtoFile, _signImg, imgFile, mess;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.loadImages();

              case 2:
                if (!(!_this5.assignSignUrl2 || !_this5.signatureUrl2)) {
                  _context5.next = 5;
                  break;
                }

                alert('请先加载图片');
                return _context5.abrupt('return');

              case 5:
                exportCanvas = document.createElement('canvas');
                exportCtx = exportCanvas.getContext('2d');

                // 设置导出尺寸为背景图原始尺寸

                exportCanvas.width = _this5.assignSignUrl2.width;
                exportCanvas.height = _this5.assignSignUrl2.height;

                // 绘制背景图
                exportCtx.drawImage(_this5.assignSignUrl2, 0, 0);

                // 计算叠加图位置和尺寸
                overlayHeight = Math.max(12, exportCanvas.width * 0.04); // 固定高度（单位px）

                overlayWidth = overlayHeight * _this5.signatureUrl2.width / _this5.signatureUrl2.height;
                posX = _this5.assignSignUrl2.width * 0.28 - overlayWidth / 2;
                posY = _this5.assignSignUrl2.height * 0.333 - overlayHeight / 2;

                8;
                // 绘制叠加图
                exportCtx.drawImage(_this5.signatureUrl2, posX, posY, overlayWidth, overlayHeight);

                _this5.drawWatermark(exportCtx, exportCanvas, 5, 0.317, _this5.shopInfo.name || '');
                time = _this5.getFormattedDate();
                // 添加动态水印

                _this5.drawWatermark(exportCtx, exportCanvas, 5, 0.357, time || '');
                _this5.drawWatermark(exportCtx, exportCanvas, 1.55, 0.357, time || '');
                // 导出图片

                base64ImgtoFile = function base64ImgtoFile(dataurl) {
                  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';

                  var arr = dataurl.split(',');
                  var mime = arr[0].match(/:(.*?);/)[1];
                  var suffix = mime.split('/')[1];
                  var bstr = atob(arr[1]);
                  var n = bstr.length;
                  var u8arr = new Uint8Array(n);
                  while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                  }
                  return new File([u8arr], filename + '.' + suffix, {
                    type: mime
                  });
                };

                _signImg = exportCanvas.toDataURL('image/png');
                imgFile = base64ImgtoFile(_signImg);
                // 上传前先压缩：等比缩放到最大边长后重新编码（压缩失败或体积未变小时返回原文件）

                _context5.next = 25;
                return Object(__WEBPACK_IMPORTED_MODULE_15__commons_imageCompress__["a" /* compressImage */])(imgFile);

              case 25:
                imgFile = _context5.sent;

                if (imgFile) {
                  _context5.next = 29;
                  break;
                }

                // 处理超时已提示"处理失败"，终止本次上传
                tuhu.hideIndicator();
                return _context5.abrupt('return');

              case 29:
                mess = new FormData();

                mess.append('multipartFile', imgFile);
                _context5.next = 33;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_12__configs_config__["a" /* default */].apis.UPLOAD_URL, {
                  method: 'post',
                  body: mess
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(res) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!(res.code === '200')) {
                              _context4.next = 7;
                              break;
                            }

                            _this5.assignSignUrl = res.data;
                            _context4.next = 4;
                            return _this5.getPdf(imgFile);

                          case 4:
                            _this5.isAssign = true;
                            // this.$nextTick(() => {
                            //   this.handleScroll()
                            // })
                            _context4.next = 10;
                            break;

                          case 7:
                            _this5.isAssign = false;
                            tuhu.hideIndicator();
                            tuhu.toast(res.message || '网络错误');

                          case 10:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this5);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 33:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    imgBase64ToUrl: function imgBase64ToUrl(data) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var params, res;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // 原有上传逻辑保持不变
                params = { baseFile: data, fileName: '签名.png' };
                _context6.prev = 1;
                _context6.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_12__configs_config__["a" /* default */].apis.UploadBase64File, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(params)
                });

              case 4:
                res = _context6.sent;


                if (res.code === '200') {
                  _this6.assignSignUrl = res.data;
                } else {
                  tuhu.toast(res.message || '上传失败');
                }
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](1);

                console.error('上传错误', _context6.t0);
                tuhu.toast('请求异常');

              case 12:
                _context6.prev = 12;
                return _context6.finish(12);

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[1, 8, 12, 14]]);
      }))();
    },
    getPdf: function getPdf(imgFile) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var files, mess;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                files = [_this7.file1, _this7.file2, _this7.file3, imgFile, _this7.file5];
                mess = new FormData();

                files.forEach(function (file) {
                  mess.append('multipartFile', file);
                });

                _context7.next = 5;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_12__configs_config__["a" /* default */].apis.UPLOAD_URL_TO_PDF, {
                  method: 'post',
                  body: mess
                }).then(function (res) {
                  if (res.code === '200') {
                    _this7.assignSignPdfUrl = res.data;
                  } else {
                    tuhu.toast(res.message || '网络错误');
                  }
                });

              case 5:
                tuhu.hideIndicator();

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    }
  }
});

/***/ }),

/***/ "6xC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ttButton_vue__ = __webpack_require__("bPVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cityPicker_vue__ = __webpack_require__("kQ4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imgs_image_success_png__ = __webpack_require__("kfX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imgs_image_success_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__imgs_image_success_png__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ttButton: __WEBPACK_IMPORTED_MODULE_4__components_ttButton_vue__["a" /* default */], cityPicker: __WEBPACK_IMPORTED_MODULE_5__components_cityPicker_vue__["a" /* default */] },
  data: function data() {
    return {
      lock: false,
      agreementFlag: false,
      showCityFlag: false,
      eventFlag: true,
      imgType: '',
      shopId: '',
      phone: '',
      shopNo: '', // 门店id加密字符串
      merchantCode: '',
      merchantSignFlag: null,
      signFlag: null,
      form: {
        shopName: '',
        shopPrincipal: '', // 门店负责人
        shopPhone: '',
        city: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        districtId: '',
        districtName: '',
        shopAddress: '',
        businessLicense: '', // 营业执照
        doorPhoto: '', // 门头照
        restArea: '', // 休息区
        workingArea: '', // 工位
        other: '', // 其他
        bankName: '',
        bankBranchName: '',
        bankAccountName: '', // 银行账户名
        bankAccount: '' // 银行卡号
      }
    };
  },
  created: function created() {
    this.init();
  },

  computed: {
    bankInfo: function bankInfo() {
      var info = JSON.parse(tuhu.store.state.bankInfo);
      return info;
    }
  },
  watch: {
    bankInfo: function bankInfo(val) {
      if (val) {
        this.form.bankName = val.text;
      }
    }
  },
  methods: {
    init: function init() {
      this.shopId = tuhu.getParam('shopId');
      this.phone = tuhu.getParam('phone');
      this.shopNo = tuhu.getParam('shopNo');
      this.merchantSignFlag = tuhu.getParam('merchantSignFlag');
      this.signFlag = tuhu.getParam('signFlag');
      this.merchantCode = tuhu.getParam('merchantCode');
      if (this.shopId && this.phone) {
        this.eventFlag = true;
        this.getShopInfo();
      } else {
        this.eventFlag = false;
      }
    },
    getShopInfo: function getShopInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  shopId: _this.shopId,
                  sign: true
                };
                _context.prev = 1;
                _context.next = 4;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.ADD_SHOP_DETAIL, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params)
                });

              case 4:
                res = _context.sent;

                if (res && res.code === '200') {
                  if (res && res.data) {
                    data = res.data;
                    // 门店信息

                    _this.form.shopName = data.shopDetailInfo.shopName;
                    _this.form.shopPrincipal = data.shopDetailInfo.shopPrincipal;
                    _this.form.shopPhone = data.shopDetailInfo.shopPrincipalPhone;

                    _this.form.city = data.shopDetailInfo.provinceName + '-' + data.shopDetailInfo.cityName + '-' + data.shopDetailInfo.districtName;
                    _this.form.provinceId = data.shopDetailInfo.provinceId;
                    _this.form.provinceName = data.shopDetailInfo.provinceName;
                    _this.form.cityId = data.shopDetailInfo.cityId;
                    _this.form.cityName = data.shopDetailInfo.cityName;
                    _this.form.districtId = data.shopDetailInfo.districtId;
                    _this.form.districtName = data.shopDetailInfo.districtName;
                    _this.form.shopAddress = data.shopDetailInfo.shopName;

                    // 图片信息
                    if (data.urlInfoList) {
                      data.urlInfoList.map(function (li) {
                        if (li.urlType === 'door_photo') {
                          _this.form.doorPhoto = li.imgUrl;
                        } else if (li.urlType === 'business_license') {
                          _this.form.businessLicense = li.imgUrl;
                        } else if (li.urlType === 'rest_area') {
                          _this.form.restArea = li.imgUrl;
                        } else if (li.urlType === 'working_area') {
                          _this.form.workingArea = li.imgUrl;
                        } else if (li.urlType === 'other') {
                          _this.form.other = li.imgUrl;
                        }
                      });
                    }

                    // 银行信息
                    _this.form.bankName = data.bankCardInfo.bankName;
                    _this.form.bankBranchName = data.bankCardInfo.bankBranchName;
                    _this.form.bankAccount = data.bankCardInfo.bankAccount;
                    _this.form.bankAccountName = data.bankCardInfo.bankAccountName;
                  }
                } else {
                  tuhu.toast(res.message || '网络错误');
                  console.log('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.GET_CODE, res);
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.log('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.GET_CODE, _context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    toAssignMent: function toAssignMent() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.lock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', false);

              case 2:
                _this2.lock = true;
                setTimeout(function () {
                  _this2.lock = false;
                }, 2000);
                res = _this2.verify();

                if (res) {
                  if (!_this2.shopId) tuhu.sessionStorage.setItem('shouldStorageShopForm', '1');
                  tuhu.sessionStorage.setItem('shopForm', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.form));
                  tuhu.navigateTo({
                    url: '/pages/assignMent/index',
                    query: {
                      merchantCode: _this2.merchantCode,
                      shopId: _this2.shopId
                    }
                  });
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res, url, form, data, msg;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.lock) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', false);

              case 2:
                _this3.lock = true;
                setTimeout(function () {
                  _this3.lock = false;
                }, 2000);
                res = _this3.verify();

                if (!res) {
                  _context3.next = 18;
                  break;
                }

                url = __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.SHOP_ADDSHOP;
                // !this.eventFlag ? url = config.apis.SHOP_ADDSHOP : url = config.apis.SHOP_EDITSHOP

                form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.form, { shopId: _this3.shopId, merchantCode: _this3.merchantCode || 'XKKJ' });
                _context3.prev = 8;
                _context3.next = 11;
                return tuhu.fetch('' + url, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(form)
                });

              case 11:
                data = _context3.sent;

                if (data && data.code === '200') {
                  msg = '提交成功，请耐心等待审核！';

                  tuhu.modal({
                    title: '',
                    text: '<img src="' + __WEBPACK_IMPORTED_MODULE_7__imgs_image_success_png___default.a + '" style="width:3.3rem; margin:0 auto">\n                                    <div style="font-size:16px;font-weight:600;padding:.2rem 0">\u63D0\u4EA4\u6210\u529F</div>\n                                <div style="text-align:left">' + msg + '</div>',
                    buttons: [{
                      text: '知道了',
                      bold: true,
                      onClick: function onClick() {
                        setTimeout(function () {
                          tuhu.redirectTo({ url: '/pages/_login/index' });
                        }, 200);
                      }
                    }]
                  });
                } else {
                  tuhu.toast(data.message || '网络异常');
                  console.log('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.SHOP_ADDSHOP, data.message);
                }
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](8);

                console.log('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.SHOP_ADDSHOP, _context3.t0);

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[8, 15]]);
      }))();
    },
    cityConfirm: function cityConfirm(val, i) {
      var res = this.$refs.cPicker.cityData(i);

      this.form.city = val.join().replace(/,/g, '-');
      this.form.provinceName = val[0];
      this.form.cityName = val[1];
      this.form.districtName = val[2];
      this.form.provinceId = res.provinceId;
      this.form.cityId = res.cityId;
      this.form.districtId = res.districtId;
      this.showCityFlag = false;
    },
    upload: function upload(val) {
      if (val && val.code === '200' && val.data) {
        this.form[this.imgType] = val.data;
      } else {
        tuhu.toast(val.message || '网络错误');
      }
    },
    uploadClear: function uploadClear(type) {
      this.form[type] = '';
    },
    toBankList: function toBankList() {
      tuhu.navigateTo({
        url: '/pages/bankList/index'
      });
    },
    verify: function verify() {
      if (!this.form.shopName) return tuhu.toast('请填写店铺招牌名称');
      if (!this.form.shopPrincipal) return tuhu.toast('请填写门店负责人名称');
      if (!this.form.shopPhone) return tuhu.toast('请填写手机号');
      if (!this.form.city) return tuhu.toast('请选择门店所在区域');
      if (!this.form.shopAddress) return tuhu.toast('请填写门店地址');

      if (!this.form.doorPhoto) return tuhu.toast('请上传门头照');
      if (!this.form.businessLicense) return tuhu.toast('请上传营业执照');

      if (!this.form.bankName) return tuhu.toast('请选择开户银行');
      if (!this.form.bankBranchName) return tuhu.toast('请填写开户支行');
      if (!this.form.bankAccountName) return tuhu.toast('请填写账户名称');
      if (!this.form.bankAccount) return tuhu.toast('请填写银行卡号');

      //   if (!this.agreementFlag) return tuhu.toast('请勾选入驻协议')

      return true;
    },
    toAgreement: function toAgreement() {
      tuhu.navigateTo({
        url: '/pages/agreement/index',
        query: {
          shopNo: this.shopNo || ''
        }
      });
    }
  }
});

/***/ }),

/***/ "73KK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ylj4");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2993042_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("XZgI");
function injectStyle (ssrContext) {
  __webpack_require__("Ehs9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2993042"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2993042_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "75xz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("店招名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.shopName),expression:"form.shopName"}],staticClass:"val",attrs:{"type":"text","placeholder":" 请填写店铺招牌名称","maxlength":"40","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.shopName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "shopName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("门店负责人")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.shopPrincipal),expression:"form.shopPrincipal"}],staticClass:"val",attrs:{"type":"text","placeholder":" 请填写姓名","maxlength":"40","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.shopPrincipal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "shopPrincipal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("门店电话")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.shopPhone),expression:"form.shopPhone"}],staticClass:"val",attrs:{"type":"number","placeholder":"请填写","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.shopPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "shopPhone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("所在区域")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.city),expression:"form.city"}],staticClass:"val",attrs:{"placeholder":"请选择","readonly":""},domProps:{"value":(_vm.form.city)},on:{"click":function($event){!_vm.eventFlag ? (_vm.showCityFlag = true) : ''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "city", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"arrow-right",attrs:{"src":__webpack_require__("mnUN"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("门店地址")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.shopAddress),expression:"form.shopAddress"}],staticClass:"val",attrs:{"type":"text","placeholder":" 请填写详细地址","maxlength":"60","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.shopAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "shopAddress", $event.target.value)}}})])]),_vm._v(" "),(!_vm.eventFlag)?_c('div',{staticClass:"item1 marginTop"},[_c('div',{staticClass:"padding75 fontSize75 bottom-line"},[_vm._v("证照及门店照片")]),_vm._v(" "),_c('div',{staticClass:"item-row"},[_c('div',{staticClass:"upload-box"},[_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, vin: false, index: 0, refresh: true, readonly: _vm.eventFlag }),expression:"{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"}],staticClass:"upload",on:{"click":function($event){_vm.imgType = 'doorPhoto'}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.doorPhoto),expression:"!form.doorPhoto"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.doorPhoto),expression:"form.doorPhoto"}],staticClass:"uploadImg",attrs:{"src":_vm.form.doorPhoto,"alt":""}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.doorPhoto && !_vm.eventFlag),expression:"form.doorPhoto && !eventFlag"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.uploadClear('doorPhoto')}}})]),_vm._v(" "),_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, vin: false, index: 0, refresh: true, readonly: _vm.eventFlag }),expression:"{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"}],staticClass:"upload",on:{"click":function($event){_vm.imgType = 'businessLicense'}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.businessLicense),expression:"!form.businessLicense"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.businessLicense),expression:"form.businessLicense"}],staticClass:"uploadImg",attrs:{"src":_vm.form.businessLicense,"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.businessLicense && !_vm.eventFlag),expression:"form.businessLicense && !eventFlag"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.uploadClear('businessLicense')}}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"item-row"},[_c('div',{staticClass:"upload-box"},[_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, vin: false, index: 0, refresh: true, readonly: _vm.eventFlag }),expression:"{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"}],staticClass:"upload",on:{"click":function($event){_vm.imgType = 'workingArea'}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.workingArea),expression:"!form.workingArea"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.workingArea),expression:"form.workingArea"}],staticClass:"uploadImg",attrs:{"src":_vm.form.workingArea,"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.workingArea && !_vm.eventFlag),expression:"form.workingArea && !eventFlag"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.uploadClear('workingArea')}}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("工位图")])]),_vm._v(" "),_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, vin: false, index: 0, refresh: true, readonly: _vm.eventFlag }),expression:"{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"}],staticClass:"upload",on:{"click":function($event){_vm.imgType = 'restArea'}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.restArea),expression:"!form.restArea"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.restArea),expression:"form.restArea"}],staticClass:"uploadImg",attrs:{"src":_vm.form.restArea,"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.restArea && !_vm.eventFlag),expression:"form.restArea && !eventFlag"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.uploadClear('restArea')}}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("休息区")])])])]),_vm._v(" "),_c('div',{staticClass:"item-row"},[_c('div',{staticClass:"upload-box"},[_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, vin: false, index: 0, refresh: true, readonly: _vm.eventFlag }),expression:"{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"}],staticClass:"upload",on:{"click":function($event){_vm.imgType = 'other'}}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.other),expression:"!form.other"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.other),expression:"form.other"}],staticClass:"uploadImg",attrs:{"src":_vm.form.other,"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.other && !_vm.eventFlag),expression:"form.other && !eventFlag"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.uploadClear('other')}}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("其他")])])])])]):_vm._e(),_vm._v(" "),(_vm.eventFlag)?_c('div',{staticClass:"item1 marginTop"},[_c('div',{staticClass:"padding75 fontSize75 bottom-line"},[_vm._v("证照及门店照片")]),_vm._v(" "),_c('div',{staticClass:"item-row"},[_c('div',{staticClass:"upload-box"},[_c('div',{staticClass:"upload"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.doorPhoto),expression:"!form.doorPhoto"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.doorPhoto),expression:"form.doorPhoto"}],staticClass:"uploadImg",attrs:{"src":_vm.form.doorPhoto,"alt":""}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"upload"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.businessLicense),expression:"!form.businessLicense"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.businessLicense),expression:"form.businessLicense"}],staticClass:"uploadImg",attrs:{"src":_vm.form.businessLicense,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("营业执照")])])])]),_vm._v(" "),_c('div',{staticClass:"item-row"},[_c('div',{staticClass:"upload-box"},[_c('div',{staticClass:"upload"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.workingArea),expression:"!form.workingArea"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.workingArea),expression:"form.workingArea"}],staticClass:"uploadImg",attrs:{"src":_vm.form.workingArea,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("工位图")])]),_vm._v(" "),_c('div',{staticClass:"upload"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.restArea),expression:"!form.restArea"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.restArea),expression:"form.restArea"}],staticClass:"uploadImg",attrs:{"src":_vm.form.restArea,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("休息区")])])])]),_vm._v(" "),_c('div',{staticClass:"item-row"},[_c('div',{staticClass:"upload-box"},[_c('div',{staticClass:"upload"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.form.other),expression:"!form.other"}],staticClass:"uploadImg",attrs:{"src":__webpack_require__("4TQe"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.other),expression:"form.other"}],staticClass:"uploadImg",attrs:{"src":_vm.form.other,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"marginTop"},[_vm._v("其他")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item marginTop"},[_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("开户银行")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.bankName),expression:"form.bankName"}],staticClass:"val",attrs:{"type":"text","readonly":"","placeholder":"请选择"},domProps:{"value":(_vm.form.bankName)},on:{"click":function($event){!_vm.eventFlag ? _vm.toBankList() : ''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "bankName", $event.target.value)}}}),_vm._v(" "),_c('img',{staticClass:"arrow-right",attrs:{"src":__webpack_require__("mnUN"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("开户支行")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.bankBranchName),expression:"form.bankBranchName"}],staticClass:"val",attrs:{"type":"text","placeholder":"请填写","maxlength":"40","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.bankBranchName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "bankBranchName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("账户名称")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.bankAccountName),expression:"form.bankAccountName"}],staticClass:"val",attrs:{"type":"text","placeholder":"请填写","maxlength":"40","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.bankAccountName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "bankAccountName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-row bottom-line"},[_c('div',{staticClass:"title"},[_vm._v("银行账号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.bankAccount),expression:"form.bankAccount"}],staticClass:"val",attrs:{"maxlength":"25","placeholder":"请填写","readonly":_vm.eventFlag},domProps:{"value":(_vm.form.bankAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "bankAccount", $event.target.value)}}})])]),_vm._v(" "),(_vm.merchantSignFlag === 0 || _vm.merchantSignFlag === '0' || _vm.signFlag === 0||  _vm.signFlag === '0')?_c('div',{staticClass:"marginTop",on:{"click":_vm.submit}},[_c('tt-button',{attrs:{"text":"提交"}})],1):_c('div',{staticClass:"marginTop",on:{"click":_vm.toAssignMent}},[_c('tt-button',{attrs:{"text":"去签署协议"}})],1),_vm._v(" "),_c('div',{directives:[{name:"call",rawName:"v-call"}],staticClass:"kefu"},[_vm._v("如有疑问请咨询小鲲车服"),_c('span',[_vm._v("400-176-8848")])]),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.showCityFlag),callback:function ($$v) {_vm.showCityFlag=$$v},expression:"showCityFlag"}},[_c('city-picker',{ref:"cPicker",attrs:{"title":'选择所在区域',"confirm":_vm.cityConfirm,"cancel":function () {
          _vm.showCityFlag = false
        }}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"marginTop"},[_vm._v("门头照片 "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"marginTop"},[_vm._v("营业执照"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"marginTop"},[_vm._v("门头照片 "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7AV6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/v0.abfacb0.png";

/***/ }),

/***/ "7Cty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productAllComments_vue__ = __webpack_require__("/yn/");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62fd4bb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productAllComments_vue__ = __webpack_require__("XhlL");
function injectStyle (ssrContext) {
  __webpack_require__("CrBw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62fd4bb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productAllComments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62fd4bb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productAllComments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7D6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_util__ = __webpack_require__("sEZZ");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            bankInfoData: {},
            checked: true,
            proceeds_val1: '',
            proceeds_val2: '',
            proceeds_val3: '',
            proceeds_val4: '',
            proceeds_val5: '',
            proceeds_val6: '',
            proceeds_val7: '',
            proceeds_Picker1: false,
            proceeds_columns1: ['中国银行', '中国工商银行', '中国农业银行', '中国建设银行', '交通银行', '中国邮政储蓄银行'],
            active: 2,
            title: '',
            tabList1: [{
                name: '收款账户',
                url: '/pages/accounts/index'
            }],
            code: null,
            userRole: '',
            shopId: '',
            isDisabled: true
        };
    },
    created: function created() {
        this.getBankInfo();
    },

    methods: {
        proceeds_onConfirm1: function proceeds_onConfirm1(value) {
            this.proceeds_val1 = value.toString();
            this.proceeds_Picker1 = false;
        },
        getBankInfo: function getBankInfo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData, data, bankList, bankArr, i, bankName;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                if (roleData && roleData.code === '200') {
                                    _this.userRole = roleData.data.role;
                                    _this.shopId = roleData.data.shopId;
                                } else {
                                    tuhu.toast(roleData.message || '获取权限失败');
                                }
                                // 银行卡信息
                                _context.next = 6;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.PROCEEDS_BANKCAR_INFO, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        shopId: _this.shopId
                                    })
                                });

                            case 6:
                                data = _context.sent;

                                if (data && data.code === '200') {
                                    // 0 是有数据页
                                    // if (data.data === null) {
                                    //     this.code = 1
                                    // } else {
                                    //     this.bankInfoData = data.data
                                    //     this.code = 0
                                    // }
                                    _this.code = data.data.isCheck;
                                    _this.bankInfoData = data.data;
                                    _this.proceeds_val1 = _this.bankInfoData.bankName;
                                    _this.proceeds_val2 = _this.bankInfoData.bankBranchName;
                                    _this.proceeds_val3 = _this.bankInfoData.bankAccountName;
                                    _this.proceeds_val4 = _this.bankInfoData.bankAccount;
                                    _this.proceeds_val5 = _this.bankInfoData.bankAccountNumber;
                                    _this.proceeds_val6 = _this.bankInfoData.bankAccountIdCard;
                                    _this.proceeds_val7 = _this.bankInfoData.phone;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }
                                // 银行列表

                                if (_this.code) {
                                    _context.next = 13;
                                    break;
                                }

                                _context.next = 11;
                                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_BANK_LIST + '?level=1&type=3');

                            case 11:
                                bankList = _context.sent;

                                if (bankList && bankList.code === '200') {
                                    bankArr = [];

                                    for (i = 0; i < bankList.data.length; i++) {
                                        bankName = bankList.data[i].text.replace(/股份/g, '').replace(/有限/g, '').replace(/公司/g, '');

                                        bankArr.push(bankName);
                                    }
                                    _this.proceeds_columns1 = bankArr;
                                } else {
                                    tuhu.toast(bankList.message || '网络错误');
                                }

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleClick: function handleClick(item) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var nameReg, reg, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.proceeds_val4 = String(_this2.proceeds_val4).replace(/\s+/g, ''); //除去空格

                                if (_this2.proceeds_val1) {
                                    _context2.next = 3;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请选择开户银行'));

                            case 3:
                                if (_this2.proceeds_val2) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请输入开户支行'));

                            case 5:
                                if (_this2.proceeds_val3) {
                                    _context2.next = 7;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请输入收款人姓名'));

                            case 7:
                                nameReg = /^[\u4e00-\u9fa5·（）]+$/;

                                if (nameReg.test(_this2.proceeds_val3)) {
                                    _context2.next = 10;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('收款人姓名仅支持中文、括号和点'));

                            case 10:
                                if (_this2.proceeds_val4) {
                                    _context2.next = 12;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请输入银行账号'));

                            case 12:
                                reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

                                if (!(_this2.proceeds_val6 && !reg.test(_this2.proceeds_val6))) {
                                    _context2.next = 15;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请输入有效的身份证号码'));

                            case 15:
                                if (__WEBPACK_IMPORTED_MODULE_5__commons_util__["a" /* default */].isPhone(_this2.proceeds_val7)) {
                                    _context2.next = 17;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请输入正确的手机号'));

                            case 17:
                                if (_this2.isDisabled) {
                                    _context2.next = 19;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 19:
                                _this2.isDisabled = false;
                                _context2.next = 22;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.PROCEEDS_CHANGE_BANKCAR_INFO, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'bankCardInfo': {
                                            'bankName': _this2.proceeds_val1, // 银行名
                                            'bankBranchName': _this2.proceeds_val2, // 支行名
                                            'bankAccountName': _this2.proceeds_val3, // 账户名
                                            'bankAccount': _this2.proceeds_val4, // 银行账户号
                                            'bankAccountNumber': _this2.proceeds_val5, //联行号
                                            bankAccountIdCard: _this2.proceeds_val6,
                                            phone: _this2.proceeds_val7
                                        },
                                        'shopId': _this2.shopId
                                    })
                                });

                            case 22:
                                data = _context2.sent;

                                _this2.isDisabled = true;
                                if (data && data.code === '200') {
                                    // this.isDisabled = false
                                    // tuhu.navigateTo({
                                    //     url: item.url
                                    // })
                                    if (_this2.proceeds_val1 && _this2.proceeds_val2 && _this2.proceeds_val3 && _this2.proceeds_val4 && _this2.proceeds_val5) {
                                        _this2.code = null;
                                        _this2.getBankInfo();
                                    }
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 25:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        formatter1: function formatter1(value) {
            return value.replace(/\W/ig, '');
        },
        formatterAccountName: function formatterAccountName(value) {
            return value.replace(/[^\u4e00-\u9fa5·（）]/g, '');
        },
        formatter2: function formatter2(value) {
            return value.replace(/\W/ig, '');
        }
    }
});

/***/ }),

/***/ "7HPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.commentsList.length>0)?_c('tuhu-infinite',{attrs:{"endmsg":"没有更多评价","distance":100,"nodata":_vm.nodata,"end":_vm.end},on:{"oninfinite":_vm.oninfinite}},[_c('div',{staticClass:"productComment",attrs:{"slot":"content"},slot:"content"},[_c('ul',{staticClass:"commentList"},_vm._l((_vm.commentsList),function(item){return _c('comment',{key:item.CommentID,attrs:{"commentData":item}})}),1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Rgr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7RoH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nodata.328c411.png";

/***/ }),

/***/ "7YbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"mrItem"},[_c('div',{staticClass:"itemTop"},[_c('div',{staticClass:"pic"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.commentData.HeadImage? _vm.commentData.HeadImage :'https://res.tuhu.org/Image/UserCenter/headimg_d.png' , width:'1.3'}),expression:"{src:commentData.HeadImage? commentData.HeadImage :'https://res.tuhu.org/Image/UserCenter/headimg_d.png' , width:'1.3'}"}],staticClass:"img"}),_vm._v(" "),_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.level[_vm.commentData.UserGrade]}),expression:"{src:level[commentData.UserGrade]}"}],staticClass:"grade"})]),_vm._v(" "),_c('div',{staticClass:"rightText"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"name"},[_c('span',{staticClass:"username"},[_vm._v("\n            "+_vm._s(_vm.commentData.UserName)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"carName"},[_vm._v("\n            "+_vm._s(_vm.commentData.CarTypeDes)+"\n          ")])]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.commentData.CommentTime))])]),_vm._v(" "),_c('tuhu-rater',{attrs:{"point":_vm.commentData.CommentR1}})],1)]),_vm._v(" "),_c('div',{staticClass:"commentDetail"},[_c('div',{class:_vm.expanded ? 'commentTxt expanded' : 'commentTxt',domProps:{"textContent":_vm._s(_vm.commentData.CommentContent)}}),_vm._v(" "),(_vm.commentData.CommentContent.length>65)?_c('div',{staticClass:"open",on:{"click":_vm.changeState}},[_vm._v(_vm._s(_vm.expanded ? '收起' : '全文'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"commentImg"},_vm._l((_vm.commentData.CommentImages),function(item,index){return (index < 4)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item, width: 3.5, height:3.5, group: _vm.group1}),expression:"{src:item, width: 3.5, height:3.5, group: group1}"}],key:index,staticClass:"img"}):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"carInfo"},[_c('span',{staticClass:"carService"},[_vm._v(_vm._s(_vm.commentData.InstallShop && _vm.commentData.InstallShop))]),_vm._v(" "),_c('span',{staticClass:"bytime"},[_vm._v("购买时间："+_vm._s(_vm.commentData.OrderTime&&_vm.commentData.OrderTime))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7l/B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_car.c31dc1c.png";

/***/ }),

/***/ "7qK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_holidayConfirm_vue__ = __webpack_require__("3Y5V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c5834e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_holidayConfirm_vue__ = __webpack_require__("23Xj");
function injectStyle (ssrContext) {
  __webpack_require__("4f+T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20c5834e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_holidayConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c5834e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_holidayConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8+yF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc-icon-9.0da8413.png";

/***/ }),

/***/ "889I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v("小鲲车服合作商户结算流程说明")]),_vm._v(" "),_c('p',{staticClass:"name"},[_vm._v("    尊敬的小鲲车服合作商户：")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n          你们好！感谢大家一直以来对小鲲车服的支持。为让大家更清楚的知晓小鲲车服的结算流程，现做如下说明：\n      "),_c('br'),_vm._v("    1、商户工作人员在小鲲车服商户端（关注“小鲲车服”公众号，点击底部菜单“商户平台”\n      进入）点击【结算管理】进入自助申请出账结算，商户端会按照年度和月度对全部订单的出\n      账情况进行统计展示，方便商户自助查看出账及打款情况；\n      "),_c('br'),_vm._v("    2、可进行【结算管理】操作的商户工作人员，商户端账号需为“店长”或“老板”类型，“员\n      工”类型账号无法进行结算相关操作；\n      "),_c('br'),_vm._v("    3、每个商户每月可申请1次出账，建议在月末申请，每次可将未出账的订单按照月份\n      选择全部一次性申请出账结算。出账成功后会生成一笔结算账单，可点击页面【结算明细】\n      查看结算账单的状态，出账时请务必确认结算账户信息准确无误，否则将会影响打款进度；\n      "),_c('br'),_vm._v("    4、小鲲车服工作人员会在每月10日之前完成上月所有商户申请的全部对结算账单的\n      审核工作，如有出现审核不通过的情况，工作人员会与您联系进行核实；\n      "),_c('br'),_vm._v("    5、小鲲车服财务人员会在每月11日之前完成所有商户已审核通过结算账单的打款工\n      作，打款结果（成功或失败）将会通过微信消息、短信等方式通知到您。对于打款失败的，\n      工作人员会与您联系核实打款账户信息。\n      "),_c('br'),_vm._v("    再次感谢各位商户的配合与支持，祝您生意兴隆！\n    ")]),_vm._v(" "),_c('p',{staticClass:"end"},[_vm._v("小鲲科技商户管理部"),_c('br'),_vm._v("2023年04月18日")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8NIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Vhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"emptypage"},[_c('div',{staticClass:"contentwrap"},[_c('img',{attrs:{"src":_vm.imageUrl}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"btn",domProps:{"textContent":_vm._s(_vm.buttonName)},on:{"click":_vm.handleButtonClick}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8YRT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_platen_vue__ = __webpack_require__("Gqm0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4e6d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_platen_vue__ = __webpack_require__("WDKP");
function injectStyle (ssrContext) {
  __webpack_require__("+Ypz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc4e6d52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_platen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4e6d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_platen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8jTK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car.b115493.png";

/***/ }),

/***/ "8qPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_shops_wxc_png__ = __webpack_require__("NrIi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_shops_wxc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__imgs_shops_wxc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_shops_crd_png__ = __webpack_require__("Ry9+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_shops_crd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgs_shops_crd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imgs_shops_gcd_png__ = __webpack_require__("297+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imgs_shops_gcd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__imgs_shops_gcd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imgs_shops_kxd_png__ = __webpack_require__("w6an");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__imgs_shops_kxd_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__imgs_shops_kxd_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__imgs_shops_msz_png__ = __webpack_require__("yz1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__imgs_shops_msz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__imgs_shops_msz_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__imgs_shops_mfjc_png__ = __webpack_require__("jOFD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__imgs_shops_mfjc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__imgs_shops_mfjc_png__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shopData: false,
      locate: false, // 地理位置
      car: false, // 车型信息
      scrollId: tuhu.util.getScrollId(),
      selected: false, // 是否选择，选择后pageback
      areas: [],
      tabsSelectedType: '',
      ShopClassifications: [], // 门店所有种类
      selectedShopTypes: [], // 被选择的门店种类，暂时存放最终会放入 fetchParams 中
      shopList: [], // 门店列表
      TotalPage: 1,
      nodata: false,
      end: false,
      wxc: __WEBPACK_IMPORTED_MODULE_5__imgs_shops_wxc_png___default.a,
      crd: __WEBPACK_IMPORTED_MODULE_6__imgs_shops_crd_png___default.a,
      gcd: __WEBPACK_IMPORTED_MODULE_7__imgs_shops_gcd_png___default.a,
      kxd: __WEBPACK_IMPORTED_MODULE_8__imgs_shops_kxd_png___default.a,
      mfjc: __WEBPACK_IMPORTED_MODULE_10__imgs_shops_mfjc_png___default.a,
      msz: __WEBPACK_IMPORTED_MODULE_9__imgs_shops_msz_png___default.a,
      // hasDefalutShop: false,
      // activityId 保养定价
      // 612 & 512  === 512 为工厂店
      // options: {
      //   shopData: {'serviceType': 1, 'pids': 'FU-TUHU-LUTAI|1', 'activityId': '', callBack: () => {}}
      // },
      sort: [{
        text: '默认排序',
        sort: 'HuShi',
        select: true
      }, {
        text: '附近优先',
        sort: '',
        select: false
      }],
      fetchParams: {
        pageIndex: 1, // * 页数
        Ismatchregion: 0, // 当前定位地址 和 选择的地址是否一样
        shopClassification: [], // * 门店种类们
        city: '', // *
        province: '', // *
        district: '', // *
        latBegin: '', // *
        lngBegin: '', // *
        serviceType: 1, // 传入 门店类型
        pageSize: 10, // *
        pids: '', // 传入
        activityId: '', // 传入
        sort: 'HuShi', // 默认排序
        brands: '', // * 筛选品牌类型，暂时不写
        vehicleId: '', // * 车型信息
        shopId: '' // 传入 默认门店id
      },
      resolve: function resolve() {}
    };
  },

  watch: {
    fetchParams: {
      handler: function handler(value, oldValue) {
        var isRefersh = true;
        // // this.end = false
        if (value.pageIndex !== oldValue.pageIndex) {
          isRefersh = false;
        }
        if (value.pageIndex === 1) {
          isRefersh = true;
        }
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(value) !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(oldValue)) {
          this.getShopList(isRefersh);
        }
      },

      deep: true
    },
    sort: {
      handler: function handler(value, oldValue) {
        var _sort = value.filter(function (element, index) {
          return element.select;
        })[0];
        this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fetchParams, {
          sort: _sort.sort,
          pageIndex: 1
        });
      },

      deep: true
    },
    locationInfo: function locationInfo(val) {
      if (val) {
        this.fetchAll();
      }
    }
  },
  filters: {
    fliterLocateNull: function fliterLocateNull(value) {
      if (value.replace(/\s/g, '') === '') {
        return '定位中';
      } else {
        return value;
      }
    },
    filterDistance: function filterDistance(value) {
      if (value === undefined) {
        value = 0;
      }
      return value.toFixed(2) + 'km';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    cityTabTitle: function cityTabTitle() {
      if (this.fetchParams.district === '') {
        return this.fetchParams.city;
      } else {
        return this.fetchParams.district;
      }
    },
    locateName: function locateName() {
      if (this.fetchParams.province === this.fetchParams.city) {
        return this.fetchParams.city + ' ' + this.fetchParams.district;
      } else {
        return this.fetchParams.province + ' ' + this.fetchParams.city + ' ' + this.fetchParams.district;
      }
    },
    hasDefalutShop: function hasDefalutShop() {
      if (this.shopData) {
        return this.shopData.shopId ? this.shopData.shopId : false;
      } else {
        return false;
      }
    },

    // 显示市还是区
    sortTabTitle: function sortTabTitle() {
      return this.sort.filter(function (element, index) {
        return element.select;
      })[0].text;
    }
  }, Vuex.mapState({
    locationInfo: '_locationInfo'
  })),
  created: function created() {
    var shopData = this.options.shopData;
    this.shopData = shopData;
    this.fetchAll();
  },
  beforeDestroy: function beforeDestroy() {
    // 不选择直接返回，并不返回第一个门店信息
    // if (!this.selected) {
    //   this.options.callBack(this.shopList[0])
    // }
  },

  methods: {
    switchCity: function switchCity() {
      this.resetTabsSelectedType();

      tuhu.navigateTo({
        url: '/pages/home/chooseCity'
      });
    },
    handelClickCover: function handelClickCover(e) {
      if (e.target.classList.value.indexOf('Typelist') !== -1) {
        this.resetTabsSelectedType();
      }
    },
    autoNavigate: function autoNavigate(item) {
      if (tuhu.autoNavigate) {
        // 点击跳转至门店暂时隐藏
        // tuhu.autoNavigate(item)
      }
    },
    fetchAll: function fetchAll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.getSelectOptions();
                _context.next = 3;
                return _this.getLocate();

              case 3:
                _context.next = 5;
                return _this.getShopArea();

              case 5:
                _context.next = 7;
                return _this.getDefaultCar();

              case 7:
                // await this.getShopList(true)
                _this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.fetchParams, {
                  city: _this.locate.city || '',
                  province: _this.locate.province || '',
                  district: _this.locate.district || '',
                  latBegin: _this.locate.latitude || '',
                  lngBegin: _this.locate.longitude || '',
                  serviceType: _this.shopData ? _this.shopData.serviceType : 1,
                  products: _this.shopData ? _this.shopData.products : '',
                  pids: _this.shopData ? _this.shopData.pids : '',
                  activityId: _this.shopData ? _this.shopData.activityId : '',
                  shopId: _this.shopData ? _this.shopData.shopId : '',
                  vehicleId: _this.car ? _this.car.ProductID : ''
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getLocate: function getLocate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var locate;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                locate = {};

                if (!(tuhu.store === undefined)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return tuhu.getLocate();

              case 4:
                locate = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return tuhu.store.state._locationInfo;

              case 9:
                locate = _context2.sent;

              case 10:
                _this2.locate = locate;
                return _context2.abrupt('return', locate);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getDefaultCar: function getDefaultCar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', tuhu.getDefaultCar(2, false).then(function (res) {
                  _this3.car = res;
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    // 获取地理位置下拉
    getShopArea: function getShopArea() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', tuhu.fetch('https://api.tuhu.cn/Shops/SelectBookShopArea', {}, { query: { city: _this4.locate.city, province: _this4.locate.province } }).then(function (res) {
                  _this4.areas = res.Areas;
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },

    // 获取门店筛选信息
    getSelectOptions: function getSelectOptions() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tuhu.fetch('https://api.tuhu.cn/Shops/SelectShopCategories').then(function (res) {
                  _this5.ShopClassifications = res.Data.ShopClassifications;
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },

    // 获取店铺列表
    getShopList: function getShopList(isRefersh) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // if ((this.TotalPage >= this.fetchParams.pageIndex) && this.end === false) {
                tuhu.fetch('https://api.tuhu.cn/Shops/SelectBookShops', {
                  // method: 'POST',
                  // body: JSON.stringify({
                  //   ...this.fetchParams,
                  //   shopClassification: this.fetchParams.shopClassification.join(';')
                  // })
                }, {
                  query: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this6.fetchParams, {
                    shopClassification: _this6.fetchParams.shopClassification.join(';')
                  })
                }).then(function (res) {
                  _this6.TotalPage = res.TotalPage;
                  // 有默认门店
                  if (_this6.hasDefalutShop && _this6.fetchParams.pageIndex === 1) {
                    res.Shops.unshift(res.SelectShop);
                  }
                  // 是否刷新
                  if (isRefersh) {
                    _this6.shopList = res.Shops;
                  } else {
                    var _shopList;

                    (_shopList = _this6.shopList).push.apply(_shopList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.Shops));
                  }
                  // 是否第一次就结束
                  if (!(res.TotalPage > _this6.fetchParams.pageIndex)) {
                    _this6.end = true;
                  } else {
                    _this6.end = false;
                  }
                  _this6.resolve();
                });

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },

    // 点击选择更换门店
    changeShop: function changeShop(shop) {
      if (!shop.IsSuspend) {
        this.selected = true;
        this.options.callBack(shop);
        tuhu.navigateBack({
          delta: tuhu.getCurrentPages().reduce(function (sum, item) {
            return sum + (item.path.indexOf('/pages/_shops/selectShopList') > -1 ? 1 : 0);
          }, 0)
        });
      } else {
        tuhu.toast('本店暂停营业，暂不支持下单，敬请谅解');
      }
    },

    // 滚动
    oninfinite: function oninfinite(ev, resolve, reject) {
      if (this.TotalPage > this.fetchParams.pageIndex) {
        this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fetchParams, {
          pageIndex: this.fetchParams.pageIndex + 1
        });
      } else {
        this.end = true;
      }
      this.resolve = resolve;
    },
    resetTabsSelectedType: function resetTabsSelectedType() {
      this.tabsSelectedType = '';
    },
    resetTypeButton: function resetTypeButton() {
      this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fetchParams, {
        pageIndex: 1,
        shopClassification: []
      });
      this.selectedShopTypes = [];
      this.resetTabsSelectedType();
    },
    submitTypeButton: function submitTypeButton() {
      this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fetchParams, {
        pageIndex: 1,
        shopClassification: this.selectedShopTypes
      });
      this.resetTabsSelectedType();
    },
    isCitySelected: function isCitySelected(value) {
      if (this.fetchParams.district === '') {
        return this.fetchParams.city === value.Region;
      } else {
        return this.fetchParams.district === value.Region;
      }
    },
    handleClickTabsItem: function handleClickTabsItem(e) {
      if (this.tabsSelectedType === '') {
        this.tabsSelectedType = e;
      } else if (this.tabsSelectedType === e) {
        this.resetTabsSelectedType();
      } else {
        this.tabsSelectedType = e;
      }
    },
    handleClickType: function handleClickType(type) {
      var _types = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.selectedShopTypes));
      // 不存在
      if (_types.indexOf(type) === -1) {
        _types.push(type);
      } else {
        _types.splice(_types.indexOf(type), 1);
      }
      // this.$set(this.fetchParams, 'shopClassification', _types)
      this.selectedShopTypes = _types;
    },
    handleClickCity: function handleClickCity(city) {
      if (city === this.fetchParams.city) {
        // 点击城市
        this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fetchParams, {
          pageIndex: 1,
          district: ''
        });
      } else {
        // 点击区
        this.fetchParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.fetchParams, {
          pageIndex: 1,
          district: city
        });
      }
      this.resetTabsSelectedType();
    },
    handleClickSort: function handleClickSort(sort) {
      this.resetTabsSelectedType();
      var _index = 0;
      this.sort.forEach(function (element, index) {
        if (element.sort === sort) {
          _index = index;
        }
      });
      var _sort = this.sort.map(function (item, index) {
        var _item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, item);
        if (index === _index) {
          _item.select = true;
        } else {
          _item.select = false;
        }
        return _item;
      });
      this.sort = _sort;
    }
  }
});

/***/ }),

/***/ "8t5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sildePopup3_vue__ = __webpack_require__("DCSo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2afc5e7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sildePopup3_vue__ = __webpack_require__("VCDj");
function injectStyle (ssrContext) {
  __webpack_require__("gOjf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2afc5e7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sildePopup3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2afc5e7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sildePopup3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "96kh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configs_config__ = __webpack_require__("65XL");






//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '请选择城市'
    },
    column: {
      type: Number,
      default: 3
    },
    confirm: {
      type: Function
    },
    cancel: {
      type: Function
    },
    formatvalue: {
      type: Function
    }
  },
  data: function data() {
    return {
      columns: []
    };
  },
  mounted: function mounted() {
    var proviceList = tuhu.localStorage.getItem('proviceList');
    if (proviceList) {
      var proviceListAreaNo = JSON.parse(proviceList);
      if (proviceListAreaNo && proviceListAreaNo[0] && proviceListAreaNo[0].areaNo) {
        this.initCityPicker(JSON.parse(proviceList));
      } else {
        tuhu.localStorage.removeItem('proviceList');
        this.getCityList();
      }
    } else {
      this.getCityList();
    }
  },

  methods: {
    getCityList: function getCityList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, transformTree, r1, r2;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.PROVINCE);

              case 3:
                res = _context.sent;

                if (res && res.code === '200') {
                  transformTree = function transformTree(data) {
                    return data.map(function (item) {
                      return {
                        id: item.id,
                        name: item.areaName,
                        areaNo: item.areaNo,
                        children: item.children ? transformTree(item.children) : undefined
                      };
                    });
                  };

                  r1 = transformTree(res.data);
                  r2 = _this.replace(r1);

                  tuhu.localStorage.setItem('proviceList', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(r2));
                  _this.initCityPicker(r2);
                } else {
                  tuhu.toast(res.message || '城市列表获取错误');
                  console.log('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.PROVINCE, res);
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.log('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.PROVINCE, _context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },

    // 格式化数据
    initCityPicker: function initCityPicker(cityList) {
      this.columns = cityList;
      // 格式化格式化以后的数据
      // let pArr = []
      // // 格式化省市区信息
      // cityList.map(pItem => {
      //     // 添加省列表
      //     let pList = {
      //         text: pItem.ProviceName,
      //         pcNo: pItem.pcNo,
      //         children: []
      //     }
      //     pArr.push(pList)

      //     // 市
      //     pItem.CityList.map(cItem => {
      //         // 添加市列表
      //         let cList = {
      //             text: cItem.CityName,
      //             pcNo: cItem.pcNo,
      //             children: []
      //         }
      //         pList.children.push(cList)

      //         // 区
      //         if (cItem.AreaList) { // 没有县
      //             cItem.AreaList.map(aItem => {
      //                 // 添加区列表
      //                 let aList = {
      //                     pcNo: aItem.pcNo,
      //                     text: aItem.CityName
      //                 }
      //                 cList.children.push(aList)
      //             })
      //         }
      //     })
      // })
      // console.log('pArr', pArr)
      // this.columns = pArr
    },

    // 格式化城市信息
    groupby: function groupby(list, key) {
      var map = {};
      list.forEach(function (item) {
        var index = item[key];
        if (!map[index]) map[index] = [];

        map[index].push(item);
      });

      return map;
    },
    transfer: function transfer(groups, parentId) {
      var list = groups[parentId];
      var res = [];
      if (!list) return [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          var route = {
            id: item.id,
            name: item.pcName,
            areaNo: item.areaNo
          };

          var children = this.transfer(groups, item.id);
          if (children && children.length) {
            route.children = children;
          }

          res.push(route);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return res;
    },
    replace: function replace(menus) {
      var fields = [{
        name: 'text',
        id: 'RegionID',
        areaNo: 'areaNo',
        children: 'children'
      }, {
        name: 'text',
        id: 'RegionID',
        areaNo: 'areaNo',
        children: 'children'
      }, {
        name: 'text',
        id: 'RegionID',
        areaNo: 'areaNo',
        children: ''
      }];
      var r = function r(menus, index) {
        var field = fields[index];
        ++index;
        if (!field) return;
        var arr = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(menus), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item;

            var v = _step2.value;

            var item = (_item = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_item, field.id, v.id), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_item, field.name, v.name), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_item, field.areaNo, v.areaNo), _item);
            // 过滤
            // if (['上海市', '北京市', '天津市', '重庆市'].indexOf(v.name) > -1) { // 不用了
            if ([].indexOf(v.name) > -1) {
              (function () {
                var res = [];
                v.children.forEach(function (item) {
                  res.push({
                    RegionID: item.id,
                    CityName: item.name,
                    areaNo: item.areaNo
                  });
                });
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
                  CityList: [{
                    CityName: v.name,
                    RegionID: v.id,
                    areaNo: v.areaNo,
                    AreaList: res
                  }]
                });
              })();
            } else {
              if (v.children && v.children.length) {
                field.children && (item[field.children] = r(v.children, index));
              }
            }
            arr.push(item);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return arr;
      };
      return r(menus, 0);
    },

    // this.$refs.xxx.cityData(iArr)
    // 父组件confirm中调用 params：选中的indexList [0, 1, 1]
    cityData: function cityData(iArr) {
      var index = iArr;
      var pData = this.columns[index[0]];
      var cData = this.columns[index[0]].children[index[1]] || '';
      var dData = this.columns[index[0]].children[index[1]].children[index[2]] || '';
      var city = {
        provinceId: pData.areaNo,
        cityId: cData.areaNo,
        districtId: dData.areaNo
      };
      return city;
    }
  }
});

/***/ }),

/***/ "9Fhu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9J6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NyL+");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_826bf80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("8Vhm");
function injectStyle (ssrContext) {
  __webpack_require__("mws0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-826bf80c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_826bf80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9Jir":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9tv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/11/20
 * desc: 搜索主页面
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // isApp: false,
      // isWeixin: false
      userInfo: '',
      value: this.options ? this.options.keyword : '',
      hotSearchKeyWord: [],
      DefaultSearchKeyWord: {
        Keywords: '请输入您要查找的商品'
      },
      historys: [],
      HistorySearch: tuhu.localStorage.getItem('HistorySearch') ? JSON.parse(tuhu.localStorage.getItem('HistorySearch')) : []
    };
  },

  props: {},
  beforeCreate: function beforeCreate() {
    this.isApp = tuhu.device.isApp;
    this.isWeixin = tuhu.device.isWeixin;
    this.isAndroid = tuhu.device.android;
    this.isIos = tuhu.device.ios;
  },
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {
    this.bodyHeight = window.innerHeight + 'px';
  },

  watch: {
    userInfo: {
      handler: function handler(value, oldValue) {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value) !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(oldValue)) {
          if (value.islogin) {
            this.getSearchHistory();
          }
        }
      },

      deep: true
    }
  },
  methods: {
    tologin: function tologin() {
      var _this = this;

      tuhu.getUserInfo({
        force: true
      }).then(function (res) {
        _this.userInfo = res;
      });
    },

    // 初始化数据
    initData: function initData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.getHotWord();
                _context.next = 3;
                return _this2.getUserInfo();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    // 获取热搜词和input默认值
    getHotWord: function getHotWord() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tuhu.fetch('https://api.tuhu.cn/Search/SelectDefaultAndHotSearchKeyWord', {
                  method: 'GET'
                }, {
                  status: false
                }).then(function (res) {
                  _this3.hotSearchKeyWord = res.HotSearchKeyWord;
                  if (res.DefaultSearchKeyWord) {
                    _this3.DefaultSearchKeyWord = res.DefaultSearchKeyWord;
                  }
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },

    // 获取用户信息
    getUserInfo: function getUserInfo() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                user = {};

                if (!(tuhu.store === undefined)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 4;
                return tuhu.getUserInfo({ force: false }).then(function (res) {
                  user = res;
                });

              case 4:
                _context3.next = 9;
                break;

              case 6:
                _context3.next = 8;
                return tuhu.store.state._userInfo;

              case 8:
                user = _context3.sent;

              case 9:
                _this4.userInfo = user;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },

    // 获取用户历史记录
    getSearchHistory: function getSearchHistory() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                tuhu.fetch('https://api.tuhu.cn/Search/SelectSearchHistoryV2', {
                  method: 'GET'
                }, { status: false }).then(function (res) {
                  _this5.historys = res.SearchHistory;
                });

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    declectHistory: function declectHistory(value, index) {
      if (index !== undefined) {
        // 删除一个
        this.historys.splice(index, 1);
      } else {
        // 删除所有
        this.historys = [];
      }
      tuhu.fetch('https://api.tuhu.cn/Search/ClearSearchHistory', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
          word: value
        })
      }).then(function (res) {
        console.log('res: ', res);
      });
    },
    handleDelect: function handleDelect(item, index) {
      if (item === undefined) {
        this.declectHistory();
      } else {
        this.declectHistory(item.Word, index);
      }
    },
    hindleBack: function hindleBack() {
      tuhu.navigateBack();
    },
    toList: function toList(value) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!value && tuhu.autoNavigate !== undefined)) {
                  _context5.next = 4;
                  break;
                }

                _this6.$refs.search.blur();
                // 跳转到活动页
                tuhu.autoNavigate(_this6.DefaultSearchKeyWord);
                return _context5.abrupt('return');

              case 4:
                if (value) {
                  tuhu.redirectTo({
                    url: '/pages/_search/list',
                    query: { keyword: value }
                  });
                }

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },

    // 插入历史记录
    insertSearchHistory: function insertSearchHistory(value) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(value !== '')) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return tuhu.fetch('https://api.tuhu.cn/Search/InsertSearchHistory', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                    word: value
                  })
                }, { status: false }).then(function (res) {});

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },

    // 输入框点击回车
    submit: function submit(e) {
      this.hindleClickHistory(this.value);
    },

    // 点击搜索历史
    hindleClickHistory: function hindleClickHistory(word) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.insertSearchHistory(word);
                _this8.toList(word);

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },

    // 兼容ios微信内置浏览器键盘关闭后页面缺失问题
    iosCompatible: function iosCompatible() {
      var isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var ua = navigator.userAgent.toLowerCase();
      var isWX = /micromessenger/.test(ua);
      if (isIOS && isWX) {
        document.body.style.height = this.bodyHeight;
      }
    }
  }
});

/***/ }),

/***/ "9wfQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-3.8bbf277.png";

/***/ }),

/***/ "9xwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs_config__ = __webpack_require__("65XL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            billData: {},
            orderStatus: ''
        };
    },
    created: function created() {
        this.billDetail();
    },
    mounted: function mounted() {
        // let vConsole = new VConsole()
    },

    methods: {
        billDetail: function billDetail() {
            var _this = this;

            var orderId = tuhu.getParam('orderId');
            console.log(orderId);
            tuhu.fetch(__WEBPACK_IMPORTED_MODULE_0__configs_config__["a" /* default */].apis.GOODS_DETAIL + '/' + orderId).then(function (data) {
                if (data && data.code === '200') {
                    _this.billData = data.data;
                    if (data.data.orderStatus === 'ORDER_INIT') {
                        _this.orderStatus = '待接单';
                    } else if (data.data.orderStatus === 'ORDER_ACCEPT') {
                        _this.orderStatus = '已接单';
                    } else if (data.data.orderStatus === 'ORDER_CANCEL') {
                        _this.orderStatus = '订单取消';
                    } else if (data.data.orderStatus === 'ORDER_FINISH') {
                        _this.orderStatus = '订单完成';
                    } else if (data.data.orderStatus === 'ORDER_CLOSED') {
                        _this.orderStatus = '订单关闭';
                    } else if (data.data.orderStatus === 'ORDER_DISPATCH') {
                        _this.orderStatus = '已派单';
                    }
                } else {
                    tuhu.toast(data.message || '网络错误');
                }
            }).catch(function (error) {
                return console.error('Error:', error);
            });
        },
        newBack: function newBack() {
            var newBackUrl = JSON.parse(tuhu.sessionStorage.getItem('newBackUrl'));
            console.log(newBackUrl);
            tuhu.navigateTo({
                url: newBackUrl
            });
        }
    }

});

/***/ }),

/***/ "A5B4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tabs)?[_vm._l((_vm.tabs),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.tabIndex),expression:"index === tabIndex"}],key:index,staticClass:"page-group"})}),_vm._v(" "),_c('nav',{staticClass:"tuhu-tabbar",attrs:{"id":"tuhu-tabbar"}},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,class:'item' + (index === _vm.tabIndex ? ' current' : '') + (index === parseInt((_vm.tabs.length + 1) / 2) - 1 ? '' : ''),on:{"click":function($event){return _vm.switchTab(index)}}},[_c('img',{attrs:{"src":(index === _vm.tabIndex ? item.activeImg : item.img)}}),_vm._v(" "),_c('div',{staticClass:"txt",domProps:{"textContent":_vm._s(item.title)}})])}),0)]:[_c('div',{staticClass:"page-group"})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AJps":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/locked-cc.378e061.png";

/***/ }),

/***/ "AVGa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var getListUrl = 'https://api.tuhu.cn/Comment/GetProductComments';
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    group1: function group1() {
      return tuhu.util.getGroup();
    },
    allImages: function allImages() {
      var allImages = [];
      this.imageList.forEach(function (element) {
        allImages = allImages.concat(element.CommentImages);
      });
      return allImages;
    }
  },
  props: {
    tab2Data: {
      type: Object,
      defalut: true
    }
  },
  data: function data() {
    return {
      nodata: false,
      end: false,
      imageList: [],
      PageNumber: 1,
      MaxPageCount: 1,
      tabData: this.tab2Data,
      resolve: function resolve() {},
      reject: function reject() {}
    };
  },

  watch: {
    PageNumber: function PageNumber(value, oldValue) {
      // 第一次请求发送
      if (value === 1) {
        this.getList(true);
      } else if (value) {
        this.getList(false);
      }
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var isRefersh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      tuhu.fetch(getListUrl, {}, {
        query: {
          productId: this.tabData.productId,
          commentType: 1,
          PageNumber: this.PageNumber
        }
      }).then(function (res) {
        if (isRefersh) {
          _this.imageList = res.Data;
        } else {
          var _imageList;

          (_imageList = _this.imageList).push.apply(_imageList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.Data));
        }
        // 第一次请求就结束的两种情况
        if (res.MaxPageCount === 1) {
          _this.end = true;
        }
        if (res.MaxPageCount === 0) {
          _this.nodata = true;
        }
        _this.maxPageCount = res.MaxPageCount;
        _this.resolve();
      });
    },
    oninfinite: function oninfinite(ev, resolve, reject) {
      // 如果当前页数小于总页数，增加页数
      if (this.PageNumber < this.maxPageCount) {
        this.PageNumber = this.PageNumber + 1;
        this.resolve = resolve;
      } else {
        this.end = true;
      }
    }
  },
  updated: function updated() {
    this.tabData = this.tab2Data;
  },
  created: function created() {
    this.getList();
  }
});

/***/ }),

/***/ "AfIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_month_vue__ = __webpack_require__("jl1Z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0732105c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_month_vue__ = __webpack_require__("lb4E");
function injectStyle (ssrContext) {
  __webpack_require__("aU8J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0732105c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_month_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0732105c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_month_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Ax1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verifyUploadImg_vue__ = __webpack_require__("zoak");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fedceb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verifyUploadImg_vue__ = __webpack_require__("Duol");
function injectStyle (ssrContext) {
  __webpack_require__("Mp6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fedceb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verifyUploadImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fedceb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verifyUploadImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BKEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9tv5");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db06318_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("LJFy");
function injectStyle (ssrContext) {
  __webpack_require__("IKzx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5db06318"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db06318_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BN2I":
/***/ (function(module, exports) {

/**
 * author: 582196894@qq.com
 * date: 2017/11/13
 * desc: selectcar
 */

Vue.directive('selectcar', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, arg) {
    $(el).on('click', function () {
      var _arg$value = arg.value,
          level = _arg$value.level,
          force = _arg$value.force,
          onchange = _arg$value.onchange;


      if (onchange) {
        return tuhu.selectCar(level, force).then(onchange);
      }

      tuhu.selectCar(level, force);
    });
  }
});

/***/ }),

/***/ "BUgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sortTabs"},[_vm._l((_vm.tabsStatusType),function(item,index){return _c('div',{key:index,staticClass:"sortItem",class:_vm.tabsStatusArray[index],on:{"click":function($event){return _vm.handleClickTab(index)}}},[_c('span',{domProps:{"textContent":_vm._s(item.name)}})])}),_vm._v(" "),_c('div',{staticClass:"sortItem",class:_vm.shiftStatusObject,on:{"click":_vm.handleClickShift}},[_c('span',[_vm._v("筛选")])]),_vm._v(" "),_c('div',{class:_vm.showCover?'sort-cover show':'sort-cover',on:{"touchstart":_vm.close}}),_vm._v(" "),_c('tuhu-panel',{ref:"panel",staticClass:"sort-pannel",attrs:{"dir":"right","open-type":"cover"},on:{"closed":_vm.closePnnel}},[_c('div',{staticClass:"panel-page",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"infiniteBox"},[_c('div',{staticClass:"sorttasbs-infinite",attrs:{"end":true}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"panel-title"},[_vm._v("价格区间(元)")]),_vm._v(" "),_c('div',{staticClass:"panel-input"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.minMoney),expression:"minMoney",modifiers:{"number":true}}],ref:"min",attrs:{"type":"text","placeholder":"最低价"},domProps:{"value":(_vm.minMoney)},on:{"input":function($event){if($event.target.composing){ return; }_vm.minMoney=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v("—\n                "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.maxMoeny),expression:"maxMoeny",modifiers:{"number":true}}],ref:"max",attrs:{"type":"text","placeholder":"最高价"},domProps:{"value":(_vm.maxMoeny)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxMoeny=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),(_vm.filterList)?_c('div',{staticClass:"panel-brands"},_vm._l((_vm.filterList),function(item,index){return _c('div',{key:index,staticStyle:{"clear":"both"}},[_c('div',{staticClass:"brands-type"},[_c('div',[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('div',{class:{selected:item.filterItem.length>0,expanded:item.expanded},on:{"click":function($event){return _vm.expand(index)}}},[_c('span',[_vm._v(_vm._s(item.filterItem.length>0 ? item.filterItem.join('、') : '全部'))])])]),_vm._v(" "),_c('div',{class:{brandsList:true, expanded:item.expanded}},_vm._l((item.ItemList),function(item2,index2){return _c('div',{key:index2,class:{brandsName: true, selected: item2.selected},on:{"click":function($event){return _vm.handleClickBrand(item2.Name, index, index2)}}},[_vm._v("\n                      "+_vm._s(item2.Name)+"\n                    ")])}),0)])}),0):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"panel-buttons"},[_c('div',{staticClass:"panel-button",on:{"click":_vm.clear}},[_vm._v("重置")]),_vm._v(" "),_c('div',{staticClass:"panel-button",on:{"click":_vm.commit}},[_vm._v("确认")])])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bk4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rotateBase64Img; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


var rotateBase64Img = function rotateBase64Img(src, edg, callback) {
  try {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var imgW = 0; // 图片宽度
    var imgH = 0; // 图片高度
    var size = 0; // canvas初始大小

    if (edg % 90 !== 0) {
      throw new Error("旋转角度必须是90的倍数!");
    }

    edg < 0 && (edg = edg % 360 + 360);
    var quadrant = edg / 90 % 4; // 旋转象限
    var cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; // 裁剪坐标

    var image = new Image();
    image.src = src;
    image.crossOrigin = "anonymous";

    image.onload = function () {
      imgW = image.width;
      imgH = image.height;
      size = imgW > imgH ? imgW : imgH;

      canvas.width = size * 2;
      canvas.height = size * 2;
      switch (quadrant) {
        case 0:
          cutCoor.sx = size;
          cutCoor.sy = size;
          cutCoor.ex = size + imgW;
          cutCoor.ey = size + imgH;
          break;
        case 1:
          cutCoor.sx = size - imgH;
          cutCoor.sy = size;
          cutCoor.ex = size;
          cutCoor.ey = size + imgW;
          break;
        case 2:
          cutCoor.sx = size - imgW;
          cutCoor.sy = size - imgH;
          cutCoor.ex = size;
          cutCoor.ey = size;
          break;
        case 3:
          cutCoor.sx = size;
          cutCoor.sy = size - imgW;
          cutCoor.ex = size + imgH;
          cutCoor.ey = size + imgW;
          break;
      }

      ctx.translate(size, size);
      ctx.rotate(edg * Math.PI / 180);
      ctx.drawImage(image, 0, 0);

      var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
      if (quadrant % 2 === 0) {
        canvas.width = imgW;
        canvas.height = imgH;
      } else {
        canvas.width = imgH;
        canvas.height = imgW;
      }
      ctx.putImageData(imgData, 0, 0);

      if (typeof callback === "function") {
        callback(canvas.toDataURL("image/png", 0.7));
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        // 异步操作...
        resolve(canvas.toDataURL("image/png", 0.7));
      });
    };
  } catch (e) {
    console.log(e);
  }
};

/***/ }),

/***/ "BuU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platenum",attrs:{"id":"insert_Plate"}},[_c('div',{staticClass:"maskbg",class:{transparent:!this.myShowmask},style:({display:this.showPlate !== 3? 'block':'none'}),on:{"click":_vm.hidePlate}}),_vm._v(" "),_c('div',{staticClass:"cityPlate",style:({display:this.showPlate===1?'block':'none'})},[_c('div',{staticClass:"cancle-btn"},[_c('span',{staticClass:"text",on:{"click":_vm.hidePlate}},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"platenumCont"},_vm._l((this.cityList),function(citys,index){return _c('div',{key:index,staticClass:"lineList"},_vm._l((citys),function(item,idx){return _c('div',{key:idx,class:{'item': true, 'selected already': item === _vm.citySelected},on:{"touchend":function($event){return _vm.cityremove(item)},"touchstart":function($event){return _vm.citychooseHandler(item)}}},[_vm._v("\n          "+_vm._s(item)+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item !== ''),expression:"item !== ''"}],staticClass:"itemPop"},[_vm._v(_vm._s(item))])])}),0)}),0)]),_vm._v(" "),_c('div',{staticClass:"cityPlate EnglishPlate",style:({display:this.showPlate===2?'block':'none'})},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"cancleBtn",on:{"click":_vm.hidePlate}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"confirmBtn",on:{"click":_vm.hidePlate}},[_vm._v("确定")])]),_vm._v(" "),_c('div',{staticClass:"platenumCont"},_vm._l((this.EnglishList),function(english,index){return _c('div',{key:index,staticClass:"lineList"},_vm._l((english),function(item,idx){return _c('div',{key:idx,class:{'item': true, 'delete': item === 'delete' ? true :false, 'selected already': item === _vm.citySelected},on:{"touchend":function($event){$event.stopPropagation();return _vm.cityremove($event)},"touchstart":function($event){$event.stopPropagation();return _vm.citychooseHandler(item)}}},[_vm._v("\n          "+_vm._s(item === 'delete' ? '' : item)+"\n          "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(item !== 'delete'),expression:"item !== 'delete'"}],staticClass:"itemPop"},[_vm._v(_vm._s(item))]),_vm._v(" "),(item === 'delete')?_c('img',{attrs:{"src":__webpack_require__("gNyG")}}):_vm._e()])}),0)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CGQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CSlk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs_config__ = __webpack_require__("65XL");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    },
    slideId: {
      type: Boolean,
      default: true,
      require: true
    }
  },
  data: function data() {
    return {
      countdown: 0, //倒计时
      hasScrolled: false,
      timer: null //计时器
    };
  },

  watch: {},
  mounted: function mounted() {
    if (this.visible) {
      // 重置状态
      this.hasScrolled = false;
      if (!this.slideId) {
        this.countdown = 5;
      } else {
        this.countdown = 0;
      }
      clearInterval(this.timer);
    }
  },


  methods: {
    open: function open() {
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=https%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect';
    },

    // 处理滚动事件
    handleScroll: function handleScroll() {
      if (!this.hasScrolled) {
        this.hasScrolled = true;
        this.startCountdown();
      }
    },


    // 初始化倒计时
    startCountdown: function startCountdown() {
      var _this = this;

      if (!this.slideId) {
        this.timer = setInterval(function () {
          _this.countdown -= 1;
          if (_this.countdown <= 0) {
            clearInterval(_this.timer);
          }
        }, 1000);
      } else {
        this.countdown = 0;
      }
    },

    // 处理关闭操作
    handleClose: function handleClose() {
      if (this.countdown > 0) return;
      if (this.countdown <= 0 && !this.slideId) {
        this.addUserNotice(2);
      }
      this.$emit('close');
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, userInfoPromise;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_2__configs_config__["a" /* default */].apis.GET_USERINFO);

              case 2:
                res = _context.sent;

                if (res && res.code === '200') {
                  userInfoPromise = tuhu._setUserInfo(res.data); // 返回数据

                  if (_this2.options && _this2.options.resolve) {
                    _this2.options.resolve(userInfoPromise);
                  }
                } else {
                  tuhu.toast(res.message || '获取权限信息失败');
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    //用户看过某个公告
    addUserNotice: function addUserNotice(type) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formdata, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                formdata = new FormData();

                formdata.append('type', type);
                _context2.next = 5;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_2__configs_config__["a" /* default */].apis.ADD_USER_NOTICE, {
                  method: 'post',
                  body: new URLSearchParams({
                    type: type
                  }),
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                });

              case 5:
                data = _context2.sent;

                if (!(data.code === '200')) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this3.getUserInfo();

              case 9:
                _context2.next = 12;
                break;

              case 11:
                tuhu.toast(data.message);

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);

                console.log('err', _context2.t0);
                tuhu.toast(_context2.t0);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "Cntp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopInfo_vue__ = __webpack_require__("q4t3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c553118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopInfo_vue__ = __webpack_require__("3ph9");
function injectStyle (ssrContext) {
  __webpack_require__("hMyl")
  __webpack_require__("pG79")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c553118"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c553118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CrBw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cyej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            shopId: '',
            userRole: '',
            tabList1: [{
                name: '员工权限',
                url: '/pages/accountAccessPic/index'
            }, {
                name: '员工管理',
                url: '/pages/userManagement/index'
            }],
            addUser_val1: '',
            addUser_val2: '',
            addUser_val3: '',
            addUser_Picker1: false,
            addUser_columns1: [
            // 类型第一列
            {
                values: ['老板', '店长', '员工'],
                defaultIndex: 0
            }]
        };
    },
    created: function created() {
        this.getRoleData();
    },

    methods: {
        getRoleData: function getRoleData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                if (roleData && roleData.code === '200') {
                                    _this.userRole = roleData.data.role;
                                    _this.shopId = roleData.data.shopId;
                                    if (_this.userRole === '店长') {
                                        _this.addUser_columns1 = [{
                                            values: ['店长', '员工'],
                                            defaultIndex: 0
                                        }];
                                    } else if (_this.userRole === '员工') {
                                        tuhu.toast('员工权限不足');
                                    }
                                } else {
                                    tuhu.toast(roleData.message || '获取权限失败');
                                }

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleClick1: function handleClick1(item) {
            tuhu.navigateTo({
                url: item.url
            });
        },
        handleClick2: function handleClick2(item) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.ADD_USER_ACCOUNT, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                        phone: _this2.addUser_val3,
                                        role: _this2.addUser_val1,
                                        shopId: _this2.shopId,
                                        userAccount: _this2.addUser_val3, // 员工账号
                                        userName: _this2.addUser_val2
                                    })
                                });

                            case 2:
                                data = _context2.sent;

                                if (data && data.code === '200') {
                                    tuhu.toast(data.message || '操作成功');
                                    tuhu.navigateBack();
                                    // tuhu.navigateTo({
                                    //     url: item.url,
                                    //     query: {
                                    //         shopId: this.shopId
                                    //     }
                                    // })
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },

        // 选择框
        addUser_onConfirm1: function addUser_onConfirm1(value) {
            this.addUser_val1 = value.toString();
            this.addUser_Picker1 = false;
        },

        // 输入格式化
        formatter1: function formatter1(value) {
            // 过滤输入的数字
            return value.replace(/\d/g, '').replace(/\s/g, '');
        }
    }
});

/***/ }),

/***/ "D1fO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DCSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs_config__ = __webpack_require__("65XL");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    }
  },
  data: function data() {
    return {};
  },

  watch: {},
  mounted: function mounted() {},


  methods: {
    // 处理关闭操作
    handleClose: function handleClose() {
      this.addUserNotice(3);
      this.$emit('close');
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=http%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect';
    },
    getUserInfo: function getUserInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, userInfoPromise;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_2__configs_config__["a" /* default */].apis.GET_USERINFO);

              case 2:
                res = _context.sent;

                if (res && res.code === '200') {
                  userInfoPromise = tuhu._setUserInfo(res.data); // 返回数据

                  if (_this.options && _this.options.resolve) {
                    _this.options.resolve(userInfoPromise);
                  }
                } else {
                  tuhu.toast(res.message || '获取权限信息失败');
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    //用户看过某个公告
    addUserNotice: function addUserNotice(type) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formdata, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                formdata = new FormData();

                formdata.append('type', type); // 文件对象
                _context2.next = 5;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_2__configs_config__["a" /* default */].apis.ADD_USER_NOTICE, {
                  method: 'post',
                  body: new URLSearchParams({
                    type: type
                  }),
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                });

              case 5:
                data = _context2.sent;

                if (!(data.code === '200')) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this2.getUserInfo();

              case 9:
                _context2.next = 12;
                break;

              case 11:
                tuhu.toast(data.message);

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);

                console.log('err', _context2.t0);
                tuhu.toast(_context2.t0);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "Df5F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DhIS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_3.969681d.png";

/***/ }),

/***/ "DrzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Cyej");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c1b2e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("jTC0");
function injectStyle (ssrContext) {
  __webpack_require__("VOoA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00c1b2e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c1b2e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Duol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"item-box3"},[_vm._v("\n        "+_vm._s(_vm.uploadDetail.serviceDetailName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"_content1"},[(_vm.showAllProv)?_c('div',{ref:"provinces",staticClass:"provinces"},[_c('div',{staticClass:"prolist"},_vm._l((_vm.provinces),function(item,index){return _c('div',{key:index,class:_vm.province === item ? 'selected' : '',on:{"click":function($event){return _vm.chooseProvince(item)}}},[_vm._v(_vm._s(item))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-box2"},[_c('div',{staticClass:"box-cont"},[_c('div',{staticClass:"title bottom-line"},[_c('div',[_vm._v("图片资料")]),_vm._v(" "),_c('div',{staticClass:"title-right",on:{"click":function($event){_vm.showPupup = !_vm.showPupup}}},[_vm._v("\n                        查看范例\n                        "),_c('img',{attrs:{"src":__webpack_require__("OzHQ"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"cont"},_vm._l((_vm.filteredCarWashList),function(item,index){return _c('div',{key:index,staticClass:"li"},[(_vm.photoMap[item.isShow])?_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, vin: false, index: item.imgType, refresh: true }),expression:"{ onUpload: upload, vin: false, index: item.imgType, refresh: true }"}],staticClass:"upload-img"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photoList[item.imgType]),expression:"!photoList[item.imgType]"}],staticClass:"car",attrs:{"src":__webpack_require__("gKLg"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photoList[item.imgType]),expression:"!photoList[item.imgType]"}],staticClass:"camera",attrs:{"src":__webpack_require__("eAMs"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoList[item.imgType]),expression:"photoList[item.imgType]"}],staticClass:"upload-img",attrs:{"src":_vm.photoList[item.imgType],"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoList[item.imgType]),expression:"photoList[item.imgType]"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.photoList[item.imgType] = ''}}})]):_vm._e(),_vm._v(" "),(_vm.photoMap[item.isShow])?_c('div',{staticClass:"tips"},[_vm._v(_vm._s(item.text)),(item.required)?_c('span',{staticClass:"themeColor"},[_vm._v(" *")]):_vm._e()]):_vm._e()])}),0)]),_vm._v(" "),(_vm.photoMap.safeCheckReport)?_c('div',[_c('div',{staticClass:"box-cont2"},[_c('div',{staticClass:"title"},[_c('div',{staticStyle:{"font-size":"0.75rem","font-weight":"550"}},[_vm._v("安全检测结果建议")]),_vm._v(" "),_c('div',{staticClass:"title-right"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}],staticClass:"van-checkbox__icon van-checkbox__icon--square van-checkbox__icon--checked",staticStyle:{"font-size":"12px"},on:{"click":_vm.handleCheckAll}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}],staticClass:"van-checkbox__icon van-checkbox__icon--square",staticStyle:{"font-size":"12px"},on:{"click":_vm.handleCheckAll}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"3px"}},[_vm._v("全部已通过")])])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('van-cell-group',{attrs:{"inset":""}},[_c('van-field',{attrs:{"rows":"3","autosize":"","type":"textarea","maxlength":"300","placeholder":"请输入留言","show-word-limit":""},model:{value:(_vm.safeCheckResultAdvise),callback:function ($$v) {_vm.safeCheckResultAdvise=$$v},expression:"safeCheckResultAdvise"}})],1)],1)]),_vm._v(" "),_vm._l((_vm.filteredSafeCheckContent),function(item,index){return _c('div',{key:index,staticClass:"box-cont3"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-label"},[_vm._v(_vm._s(item.checkId)+" 、 "+_vm._s(item.checkName))]),_vm._v(" "),_c('div',{staticClass:"title-right"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.pass === 1),expression:"item.pass === 1"}],staticClass:"van-checkbox__icon van-checkbox__icon--square van-checkbox__icon--checked",staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.handleCheck(item)}}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.pass === 0),expression:"item.pass === 0"}],staticClass:"van-checkbox__icon van-checkbox__icon--square",staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.handleCheck(item)}}},[_c('i',{staticClass:"van-icon van-icon-success"})]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"3px"}},[_vm._v(_vm._s(item.pass === 1 ? '已通过' : '未通过'))])])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"li"},[_c('p',[_vm._v(_vm._s(item.checkContent))])])])])}),_vm._v(" "),_c('div',{staticClass:"box-cont4",on:{"click":function($event){_vm.showALL = !_vm.showALL}}},[_vm._v("\n                    "+_vm._s(_vm.showALL ? '收起' : '展开剩余7条')+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"box-cont"},[_c('div',{staticClass:"title bottom-line"},[_c('div',[_vm._v("客户签名")]),_vm._v(" "),_c('div',{staticClass:"title-right"},[_c('van-radio-group',{attrs:{"direction":"horizontal","icon-size":"12"},model:{value:(_vm.signatureType),callback:function ($$v) {_vm.signatureType=$$v},expression:"signatureType"}},[_c('van-radio',{attrs:{"name":1}},[_vm._v("在线签名")]),_vm._v(" "),_c('van-radio',{attrs:{"name":2}},[_vm._v("签名图片")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"li"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signatureType === 1),expression:"signatureType === 1"}],staticClass:"upload-img2",on:{"click":_vm.toOnlineSign}},[(_vm.signatureUrl)?_c('img',{staticClass:"upload-img",attrs:{"src":_vm.signatureUrl,"alt":""}}):_c('img',{staticClass:"camera",attrs:{"src":__webpack_require__("Iy2a"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.signatureType === 2),expression:"signatureType === 2"},{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.uploadSignature, vin: false, refresh: true }),expression:"{ onUpload: uploadSignature, vin: false, refresh: true }"}],staticClass:"upload-img2"},[(_vm.signatureUrl)?_c('img',{staticClass:"upload-img",attrs:{"src":_vm.signatureUrl,"alt":""}}):_c('img',{staticClass:"camera",attrs:{"src":__webpack_require__("QHWF"),"alt":""}})])])])])],2):_vm._e()]),_vm._v(" "),_c('van-popup',{staticClass:"popup-about",attrs:{"round":"","closeable":"","position":"bottom"},model:{value:(_vm.showPupup),callback:function ($$v) {_vm.showPupup=$$v},expression:"showPupup"}},[_c('div',{staticClass:"content-block"},[_c('p',{staticClass:"tt"},[_vm._v("图片资料范例")]),_vm._v(" "),_c('p',{staticClass:"tip marginTop fmarginBottom"},[_vm._v("请按照示例上传完整清晰图片")]),_vm._v(" "),(_vm.photoMap.isVehicleWorkingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("8jTK"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            能清晰显露车牌及车店的作业中照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.isWorkingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("DhIS"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            作业中照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.isVehicleOilPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("0q08"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            使用的机油与车辆合影照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.isWorkOrderPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("wOE/"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            工单照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.carLiftPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("USF0"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            车辆在起升架上的照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.hoodOpenPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("gB3B"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            引擎盖打开的照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.puttyingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2025/12/22/78bb17d304294a51a4d49cd660f428db.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            刮腻子照片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.photoMap.isVinPhoto || _vm.photoMap.isVehicleWorkingPhoto)?_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2026/01/13/db02a6572ec54e498122c9e66b473976.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n                            车架号图片\n                        ")]),_vm._v("\n                        示意图\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showPupup = false}}},[_c('tt-button',{attrs:{"text":"知道了"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"btn verify-btn",on:{"click":function($event){return _vm.sureToOff()}}},[_c('tt-button',{attrs:{"text":"立即核销"}})],1)],1),_vm._v(" "),_c('van-popup',{staticClass:" infocustorm",model:{value:(_vm.showOrcCarNoTip),callback:function ($$v) {_vm.showOrcCarNoTip=$$v},expression:"showOrcCarNoTip"}},[_c('p',{staticClass:"title"},[_vm._v("提示")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n            识别车牌为："),_c('span',{staticStyle:{"color":"#4078ff"}},[_vm._v(_vm._s(_vm.orcCarNo))]),_c('br'),_vm._v("\n            与限制可使用车牌不一致"),_c('br'),_vm._v("\n            请正面拍摄车牌照上传\n        ")]),_vm._v(" "),_c('p',{staticClass:"btn",on:{"click":function($event){_vm.showOrcCarNoTip = false}}},[_vm._v("重新上传")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E2wV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-container",on:{"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchEnd}},[_c('div',{staticClass:"carousel",style:({
      transform: ("translateY(" + _vm.offset + "px)"),
      transition: _vm.isTransitioning ? 'transform 0.8s ease' : 'none'
    })},_vm._l((_vm.visibleItems),function(item,index){return _c('div',{key:index,staticClass:"tips",on:{"click":function($event){return _vm.handleView(item.type)}}},[_c('p',{staticClass:"left"},[_c('img',{attrs:{"src":_vm.tips,"alt":""}}),_vm._v("\n        "+_vm._s(item.title)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"right"},[_vm._v("\n        查看\n        "),_c('img',{attrs:{"src":_vm.left,"alt":""}})])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E63A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(this.userRole === '老板' )?_c('div',[(!_vm.code)?_c('div',{staticClass:"accounts_add_bank"},[_c('div',{staticClass:"notice_bar"},[_c('van-notice-bar',{staticClass:"accounts_notice-bar",attrs:{"wrapable":"","scrollable":false,"background":"rgb(251,229,229)"}},[_c('img',{attrs:{"src":__webpack_require__("ti/l"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("请准确填写开户支行及联行号等账户信息（如不清楚可咨询银行客服或联系市场经理协助查询），否则由此造成收款失败等责任由商户自负。")])])],1),_vm._v(" "),_c('div',{staticClass:"accounts_add_bankcar"},[_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"开户银行","value":_vm.proceeds_val1,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.proceeds_Picker1 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.proceeds_Picker1),callback:function ($$v) {_vm.proceeds_Picker1=$$v},expression:"proceeds_Picker1"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"请选择银行名称","columns":_vm.proceeds_columns1},on:{"cancel":function($event){_vm.proceeds_Picker1 = false},"confirm":_vm.proceeds_onConfirm1}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","label":"开户支行","placeholder":"请输入"},model:{value:(_vm.proceeds_val2),callback:function ($$v) {_vm.proceeds_val2=$$v},expression:"proceeds_val2"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","label":"收款人姓名","placeholder":"请输入","maxlength":"50","formatter":_vm.formatterAccountName},model:{value:(_vm.proceeds_val3),callback:function ($$v) {_vm.proceeds_val3=$$v},expression:"proceeds_val3"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","label":"身份证号码","placeholder":"请输入"},model:{value:(_vm.proceeds_val6),callback:function ($$v) {_vm.proceeds_val6=$$v},expression:"proceeds_val6"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","label":"银行账号","placeholder":"请输入","maxlength":"19","formatter":_vm.formatter1},model:{value:(_vm.proceeds_val4),callback:function ($$v) {_vm.proceeds_val4=$$v},expression:"proceeds_val4"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{staticClass:"w100",attrs:{"input-align":"right","label":"收款人手机号码","placeholder":"请输入收款人实名认证手机号码","maxlength":"19","formatter":_vm.formatter1},model:{value:(_vm.proceeds_val7),callback:function ($$v) {_vm.proceeds_val7=$$v},expression:"proceeds_val7"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{class:['custom-placeholder',_vm.proceeds_val5?'':'custom-placeholder1'],attrs:{"input-align":"right","label":"联行号","placeholder":"请输入联行号（可咨询银行客服或联系市场经理协助查询）"},model:{value:(_vm.proceeds_val5),callback:function ($$v) {_vm.proceeds_val5=$$v},expression:"proceeds_val5"}})],1)],1),_vm._v(" "),_c('div',[_c('van-button',{staticClass:"add_bankcar_btn",attrs:{"size":"large","type":"info"},on:{"click":function($event){_vm.isDisabled ? _vm.handleClick(_vm.tabList1[0]) :''}}},[_vm._v("保存\n                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.code)?_c('div',{staticClass:"accounts_show_bank"},[_c('div',{staticClass:"notice_bar"},[_c('van-notice-bar',{staticClass:"accounts_notice-bar",attrs:{"wrapable":"","scrollable":false,"background":"rgb(251,229,229)"}},[_c('img',{attrs:{"src":__webpack_require__("ti/l"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("如需更改收款账户信息，请联系市场经理")])])],1),_vm._v(" "),_c('div',{staticClass:"proceeds_bank"},[_c('van-icon',{attrs:{"name":"credit-pay","color":"#fff","size":"3rem"}}),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.bankInfoData.bankName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bankInfoData.bankBranchName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bankInfoData.bankAccountName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bankInfoData.bankAccount))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bankInfoData.bankAccountNumber)+"（联行号）")])])],1),_vm._v(" "),_c('div',{staticClass:"proceeds_btn"},[_c('van-button',{directives:[{name:"call",rawName:"v-call",value:('400-176-8848'),expression:"'400-176-8848'"}],staticClass:"proceeds_phoneicon add_bankcar_btn",attrs:{"url":"","to":"","size":"large","type":"info"}},[_c('van-icon',{attrs:{"name":"phone","color":"#fff"}}),_vm._v(" "),_c('span',[_vm._v("联系市场经理")])],1)],1)]):_vm._e()]):(this.userRole === '店长' || this.userRole === '员工' || this.userRole === '' )?_c('van-empty',{attrs:{"image":"error","description":"权限不足或网络错误"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EOys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_signature_pad__ = __webpack_require__("kfhq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_signature_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_signature_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sign__ = __webpack_require__("zq5k");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 //这是使用的方法，当手机屏幕是竖屏的时候要旋转图片

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isShow: {
      type: Boolean,
      require: true
    }
  },
  data: function data() {
    return {
      canvasNode: null,
      signPic: '',
      flag: true,
      savedSignature: '',
      resizeTimer: null
    };
  },

  watch: {
    isShow: function isShow(newV) {
      var _this = this;

      if (newV) {
        tuhu.toast('请横屏签字');
        this.$nextTick(function () {
          _this.restoreSignature();
          window.addEventListener('resize', _this.handleResize);
        });
      } else {
        this.saveSignature();
        window.removeEventListener('resize', this.handleResize);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.saveSignature();
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
  },

  methods: {
    saveSignature: function saveSignature() {
      if (this.canvasNode && !this.canvasNode.isEmpty()) {
        this.savedSignature = this.canvasNode.toDataURL();
      }
    },
    restoreSignature: function restoreSignature() {
      var _this2 = this;

      if (this.savedSignature && this.$refs.canvasMapRef) {
        var ctx = this.$refs.canvasMapRef.getContext('2d');
        var img = new Image();

        img.onload = function () {
          var canvasBox = _this2.$refs.canvasRef;
          ctx.canvas.width = canvasBox.clientWidth;
          ctx.canvas.height = canvasBox.clientHeight;
          ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
          ctx.drawImage(img, 0, 0, ctx.canvas.width, ctx.canvas.height);
          _this2.initalHandle();
        };
        img.src = this.savedSignature;
      } else {
        this.initalHandle();
      }
    },
    handleResize: function handleResize() {
      var _this3 = this;

      if (this.isShow) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function () {
          _this3.restoreSignature();
        }, 200);
      }
    },
    initalHandle: function initalHandle() {
      var _canvasBox = this.$refs.canvasRef;
      var _canvas = this.$refs.canvasMapRef;
      if (!_canvasBox || !_canvas) return false;

      _canvas.width = _canvasBox.clientWidth;
      _canvas.height = _canvasBox.clientHeight;

      var computedOpt = {
        minWidth: 4,
        maxWidth: 4,
        penColor: 'rgb(0, 0, 0)',
        dotSize: function dotSize(radius) {
          return radius < 3 ? 1 : Math.ceil(radius / 8);
        }
      };

      this.canvasNode = new __WEBPACK_IMPORTED_MODULE_4_signature_pad___default.a(_canvas, computedOpt);
    },
    clearHandle: function clearHandle() {
      if (this.canvasNode) {
        this.canvasNode.clear();
        this.savedSignature = '';
      }
    },
    confirmHandle: function confirmHandle() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _boxWidth, _boxHeight, _signImg;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this4.canvasNode) _this4.initalHandle();

                if (!_this4.canvasNode.isEmpty()) {
                  _context.next = 4;
                  break;
                }

                tuhu.toast('您还没有签名');
                return _context.abrupt('return', false);

              case 4:
                _boxWidth = window.innerWidth;
                _boxHeight = window.innerHeight;
                _signImg = _this4.canvasNode.toDataURL('image/png', 0.6) || null; //不旋转就是手机横屏

                if (!(_boxWidth < _boxHeight)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_5__sign__["a" /* rotateBase64Img */])(_signImg, -90, function (imgUrlRes) {
                  //在这里修改逻辑，返回的是旋转后的database
                  _this4.imgBase64ToUrl(imgUrlRes);
                });

              case 10:
                _context.next = 13;
                break;

              case 12:
                _this4.imgBase64ToUrl(_signImg);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    imgBase64ToUrl: function imgBase64ToUrl(data) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.flag) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this5.flag = false;

                params = {
                  baseFile: data,
                  fileName: '签名.png'
                };
                _context2.prev = 4;
                _context2.next = 7;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.UploadBase64File, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
                });

              case 7:
                res = _context2.sent;


                if (res.code === '200') {
                  _this5.signPic = res.data;
                  _this5.$emit('close', _this5.signPic);
                } else {
                  tuhu.toast(res.message || '上传失败');
                }
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](4);

                console.error('上传错误', _context2.t0);
                tuhu.toast('请求异常');

              case 15:
                _context2.prev = 15;

                _this5.flag = true;
                return _context2.finish(15);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[4, 11, 15, 18]]);
      }))();
    }
  }
});

/***/ }),

/***/ "EhoZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__("xMCk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ase__ = __webpack_require__("sfZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_config__ = __webpack_require__("65XL");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase, eqeqeq, no-redeclare */

/**
 * VerifyPoints
 * @description 点选
 * */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VerifyPoints',
  props: {
    // 弹出式pop，固定fixed
    mode: {
      type: String,
      default: 'fixed'
    },
    captchaType: {
      type: String
    },
    // 间隔
    vSpace: {
      type: Number,
      default: 5
    },
    imgSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '155px'
        };
      }
    },
    barSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '40px'
        };
      }
    },
    defaultImg: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      secretKey: '', // 后端返回的ase加密秘钥
      checkNum: 3, // 默认需要点击的字数
      fontPos: [], // 选中的坐标信息
      checkPosArr: [], // 用户点击的坐标
      num: 1, // 点击的记数
      pointBackImgBase: '', // 后端获取到的背景图片
      poinTextList: [], // 后端返回的点击字体顺序
      backToken: '', // 后端返回的token值
      setSize: {
        imgHeight: 0,
        imgWidth: 0,
        barHeight: 0,
        barWidth: 0
      },
      tempPoints: [],
      text: '',
      barAreaColor: undefined,
      barAreaBorderColor: undefined,
      showRefresh: true,
      bindingClick: true
    };
  },

  computed: {
    resetSize: function resetSize() {
      return __WEBPACK_IMPORTED_MODULE_2__utils_util__["a" /* resetSize */];
    }
  },
  watch: {
    // type变化则全面刷新
    type: {
      immediate: true,
      handler: function handler() {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    console.log('verufypoint mounted', localStorage.getItem('slider'));

    // 禁止拖拽
    this.$el.onselectstart = function () {
      return false;
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      // 加载页面
      this.fontPos.splice(0, this.fontPos.length);
      this.checkPosArr.splice(0, this.checkPosArr.length);
      this.num = 1;
      this.getPictrue();
      this.$nextTick(function () {
        _this.setSize = _this.resetSize(_this); // 重新设置宽度高度
        _this.$parent.$emit('ready', _this);
      });
    },
    canvasClick: function canvasClick(e) {
      var _this2 = this;

      this.checkPosArr.push(this.getMousePos(this.$refs.canvas, e));
      if (this.num == this.checkNum) {
        this.num = this.createPoint(this.getMousePos(this.$refs.canvas, e));
        // 按比例转换坐标值
        this.checkPosArr = this.pointTransfrom(this.checkPosArr, this.setSize);
        // 等创建坐标执行完
        setTimeout(function () {
          // var flag = this.comparePos(this.fontPos, this.checkPosArr);
          // 发送后端请求
          var captchaVerification = _this2.secretKey ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_ase__["a" /* aesEncrypt */])(_this2.backToken + '---' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.checkPosArr), _this2.secretKey) : _this2.backToken + '---' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.checkPosArr);
          var data = {
            captchaType: _this2.captchaType,
            pointJson: _this2.secretKey ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_ase__["a" /* aesEncrypt */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.checkPosArr), _this2.secretKey) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.checkPosArr),
            token: _this2.backToken
          };
          tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.captchaCheck, {
            method: 'post',
            body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)
          }).then(function (data) {
            if (data && data.code === '200') {
              _this2.barAreaColor = '#4cae4c';
              _this2.barAreaBorderColor = '#5cb85c';
              _this2.text = '验证成功';
              _this2.bindingClick = false;
              if (_this2.mode == 'pop') {
                setTimeout(function () {
                  _this2.$parent.clickShow = false;
                  _this2.refresh();
                }, 1500);
              }
              _this2.$parent.$emit('success', { captchaVerification: captchaVerification });
            } else {
              tuhu.toast(data.message || '网络错误');
            }
          }).catch(function (e) {
            _this2.$parent.$emit('error', _this2);
            _this2.barAreaColor = '#d9534f';
            _this2.barAreaBorderColor = '#d9534f';
            _this2.text = '验证失败';
            setTimeout(function () {
              _this2.refresh();
            }, 700);
            tuhu.toast(e || '网络错误');
          });
        }, 400);
      }
      if (this.num < this.checkNum) {
        this.num = this.createPoint(this.getMousePos(this.$refs.canvas, e));
      }
    },


    // 获取坐标
    getMousePos: function getMousePos(obj, e) {
      var x = e.offsetX;
      var y = e.offsetY;
      return { x: x, y: y };
    },
    // 创建坐标点
    createPoint: function createPoint(pos) {
      this.tempPoints.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pos));
      return ++this.num;
    },
    refresh: function refresh() {
      this.tempPoints.splice(0, this.tempPoints.length);
      this.barAreaColor = '#000';
      this.barAreaBorderColor = '#ddd';
      this.bindingClick = true;
      this.fontPos.splice(0, this.fontPos.length);
      this.checkPosArr.splice(0, this.checkPosArr.length);
      this.num = 1;
      this.getPictrue();
      this.text = '验证失败';
      this.showRefresh = true;
    },

    // 请求背景图片和验证图片
    getPictrue: function getPictrue() {
      var _this3 = this;

      var data = {
        captchaType: this.captchaType,
        clientUid: localStorage.getItem('point'),
        ts: Date.now() // 现在的时间戳
      };
      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.captchaGet, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)
      }).then(function (data) {
        if (data && data.code === '200') {
          console.log(data);
          _this3.backImgBase = data.data.originalImageBase64;
          _this3.blockBackImgBase = data.data.jigsawImageBase64;
          _this3.backToken = data.data.token;
          _this3.secretKey = data.data.secretKey;
        } else {
          tuhu.toast(data.message || '网络错误');
        }
      }).catch(function (e) {
        // 判断接口请求次数是否失效
        if (e.code == '6201') {
          _this3.backImgBase = null;
          _this3.blockBackImgBase = null;
        }
        _this3.tipWords = e.message || '请求错误';
      });
    },

    // 坐标转换函数
    pointTransfrom: function pointTransfrom(pointArr, imgSize) {
      var newPointArr = pointArr.map(function (p) {
        var x = Math.round(310 * p.x / parseInt(imgSize.imgWidth));
        var y = Math.round(155 * p.y / parseInt(imgSize.imgHeight));
        return { x: x, y: y };
      });
      // console.log(newPointArr,"newPointArr");
      return newPointArr;
    }
  }
});

/***/ }),

/***/ "Ehs9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EmT4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Et+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("4trQ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e58ccf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Vn1U");
function injectStyle (ssrContext) {
  __webpack_require__("P2Ve")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e58ccf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e58ccf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EttA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            shopId: '',
            userRole: '',
            serveCode: 0,
            tabList1: [{
                name: '店铺服务',
                url: '/pages/shopService/index'
            }],
            shopServiceData: {},
            isDisabled: false
        };
    },

    computed: {
        currentShopInfo: function currentShopInfo() {
            return tuhu.store.state.currentShopInfo;
        }
    },
    created: function created() {
        this.getUserInfo();
        this.shopServiceData = this.options.ServeInfo;
    },

    methods: {
        getUserInfo: function getUserInfo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                console.log('roleData', roleData);
                                if (roleData && roleData.code === '200') {
                                    console.log('roleData', roleData);
                                    _this.userRole = roleData.data.role;
                                    _this.shopId = roleData.data.shopId;
                                } else {
                                    tuhu.toast(roleData.message || '获取权限信息失败');
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        handleClick: function handleClick(item) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.CLOSE_SERVICE, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                        secondClassId: _this2.shopServiceData.secondClassId, // 二级分类id
                                        shopId: _this2.shopId
                                    })
                                });

                            case 2:
                                data = _context2.sent;

                                if (data && data.code === '200') {
                                    _this2.isDisabled = true;
                                    // tuhu.navigateTo({url: item.url})
                                    tuhu.navigateBack();
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),

/***/ "EyY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"record-list"},[_c('div',{staticClass:"time"},[_vm._t("top")],2),_vm._v(" "),_c('div',{staticClass:"statistics"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,staticClass:"block"},[_c('img',{attrs:{"src":item.icon,"alt":""}}),_vm._v(" "),_c('div',[_c('p',{class:['count', index === 'orderAmountSum' ? 'count1' : '']},[_vm._v("\n          "+_vm._s(item.num)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"sub"},[_vm._v(_vm._s(item.text))])])])}),0),_vm._v(" "),(_vm.dataList.length)?_c('section',{staticClass:"list"},[(_vm.isDay)?_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"list-item list-item1"},[_c('section',{staticClass:"top top1"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"one"},[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"status",style:({'color':item.orderStatus==='ORDER_FINISH'?'#09090A':'#C6C6C6'})},[_vm._v(_vm._s(item.statusText))])])]),_vm._v(" "),_c('section',{staticClass:"top"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"two"},[_vm._v("核销时间："+_vm._s(item.date))])]),_vm._v(" "),_c('div',{staticClass:"right",style:({'display':item.orderStatus==='ORDER_FINISH'?'inline-flex':'none'})},[_c('img',{staticClass:"add-icon",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/ecd76c8196a542bc8b6af3207c3e5ed8.png","alt":""}}),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(item.price))])])]),_vm._v(" "),_vm._t("tips",null,{"obj":Object.assign({}, item,{index: index})})],2)}):_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"list-item"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"one"},[_vm._v(_vm._s(item.date))])]),_vm._v(" "),_c('div',{staticClass:"right",on:{"click":function($event){return _vm.goPage(item)}}},[_c('span',{staticClass:"num"},[_vm._v(_vm._s(item.count)+"笔")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(item.price))]),_vm._v(" "),_c('img',{staticClass:"right-arrow",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/096dd766f8974f66a751cf0664a9b04b.png","alt":""}})])])})],2):_vm._e(),_vm._v(" "),(_vm.dataList.length === 0 )?_c('van-empty',{attrs:{"description":"暂无数据"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FP3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XQ5R");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e7f9da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("6XpL");
function injectStyle (ssrContext) {
  __webpack_require__("x18j")
  __webpack_require__("mK3k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71e7f9da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e7f9da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FY18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G/kn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G1XJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"ban-con"},[_c('img',{attrs:{"src":_vm.configData.bannerPic}})]),_vm._v(" "),_c('p',[_c('van-icon',{staticStyle:{"float":"left","margin-right":"10px"},attrs:{"name":"shop","color":"#1677FF","size":"30px"}}),_vm._v(_vm._s(_vm.configData.shopName))],1)]),_vm._v(" "),_c('div',{staticClass:"shop-list"},[_c('van-tree-select',{attrs:{"height":"auto","items":_vm.items,"active-id":_vm.activeId,"main-active-index":_vm.activeIndex},on:{"click-nav":_vm.navClick,"update:activeId":function($event){_vm.activeId=$event},"update:active-id":function($event){_vm.activeId=$event},"update:mainActiveIndex":function($event){_vm.activeIndex=$event},"update:main-active-index":function($event){_vm.activeIndex=$event}},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"list"},[_c('h4',{staticStyle:{"font-weight":"bold","margin-top":"10px"}},[_vm._v(_vm._s(_vm.serName))]),_vm._v(" "),_c('ul',{staticStyle:{"padding-bottom":"20px"}},_vm._l((_vm.goodsListd),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":item.goodsPic}})]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('h3',[_vm._v(_vm._s(item.goodsName))]),_vm._v(" "),_c('div',{staticClass:"sn"},[_c('span',[_vm._v("￥ "+_vm._s(item.goodsPrice))]),_vm._v(" "),_c('van-stepper',{attrs:{"integer":"","min":"0"},model:{value:(item.buySum),callback:function ($$v) {_vm.$set(item, "buySum", $$v)},expression:"item.buySum"}})],1)])])}),0)])]},proxy:true}])})],1),_vm._v(" "),_c('div',{class:_vm.czlass},[_c('div',{staticClass:"cz-top",on:{"click":_vm.animh}},[_c('p',[_c('van-icon',{attrs:{"name":_vm.arrow}})],1),_vm._v(" "),_c('p',[_vm._v("查看操作流程")])]),_vm._v(" "),_c('div',{staticClass:"cz-con"},[_c('p',[_vm._v("1、请引导客户打开并登录杉德宝APP，出示付款码；")]),_vm._v(" "),_c('p',[_vm._v("2、用户需提前绑定杉德预付卡；")]),_vm._v(" "),_c('p',[_vm._v("3、如用户没有设置免密支付，则收到订单后需输入支付密码。")]),_vm._v(" "),_c('p',[_vm._v("4、如有问题请联系小鲲车服："),_c('i',{directives:[{name:"call",rawName:"v-call"}],staticStyle:{"color":"#016EEF"}},[_vm._v("400-176-8848")])])])]),_vm._v(" "),_c('div',{staticClass:"botSub"},[_c('h5',[_vm._v("合计："),_c('span',[_vm._v("￥ "+_vm._s(_vm.totalPrice))])]),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('van-button',{staticStyle:{"width":"5rem","margin":"0px","padding":"0px"},attrs:{"round":"","size":"normal","type":"info","disabled":_vm.disable},on:{"click":_vm.submit}},[_vm._v("去提交")])],1)]),_vm._v(" "),_c('van-popup',{staticClass:"pop",style:({ width: '80%' }),attrs:{"closeable":"","close-icon":"close","close-icon-position":"top-right"},model:{value:(_vm.showMob),callback:function ($$v) {_vm.showMob=$$v},expression:"showMob"}},[_c('div',{staticClass:"sub"},[_c('p',[_vm._v("请填写顾客手机号")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"inputs",attrs:{"type":"number","placeholder":"请输入手机号"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"button",attrs:{"type":"button","value":"确认提交","disabled":_vm.inputDis},on:{"click":_vm.submit}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G7pU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GE8P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GgT6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"main-bg"},[_c('div',{staticClass:"cont-box bgTop"},[_c('div',{staticClass:"phone row-item bottom-line"},[_c('img',{attrs:{"src":__webpack_require__("rBCm"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"phoneInput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],attrs:{"type":"number","placeholder":"请输入手机号","onkeyup":"value=value.replace(/[^\\d]/g,'')","onblur":"value=value.replace(/[^\\d]/g,'')","oninput":"if(value.length > 11) value = value.slice(0,11)"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.phone.length > 0)?_c('div',{staticClass:"clear",on:{"click":function($event){return _vm.clear('phone')}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"yzm row-item"},[_c('img',{attrs:{"src":__webpack_require__("AJps"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"yzmInput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],attrs:{"type":"number","placeholder":"请输入验证码","onkeyup":"value=value.replace(/[^\\d]/g,'')","onblur":"value=value.replace(/[^\\d]/g,'')","oninput":"if(value.length > 6) value = value.slice(0,6)"},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code.length > 0)?_c('div',{staticClass:"clear",on:{"click":function($event){return _vm.clear('code')}}}):_vm._e()]),_vm._v(" "),_c('span',{class:{'activeText':!_vm.yzmLock, 'text': _vm.yzmLock},on:{"click":_vm.getYzm}},[_vm._v(_vm._s(_vm.yzmText))])])])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"getBtn",on:{"click":_vm.clickBtn}},[_c('tt-button',{attrs:{"text":"立即加盟"}})],1),_vm._v(" "),_c('div',{staticClass:"kefuText"},[_vm._v("如有疑问请咨询小鲲车服"),_c('span',{directives:[{name:"call",rawName:"v-call"}]},[_vm._v("400-176-8848")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gh1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_newPlatenum_vue__ = __webpack_require__("asNC");

// type=type=2显示字母键盘,returnHandler返回键盘值的回调方法,showmask控制是否要黑色遮罩背景
// <div class="cityP" v-platenum="{type: 1, returnHandler: returnHandler,showmask: false}" v-text='cityp'></div>
// <div class="engP" v-platenum="{type: 2, returnHandler: returnHandler,showmask: false}"  v-text='carNo'></div>
Vue.directive('newPlatenum', {
  inserted: function inserted(el, binding) {
    var instance = null;
    $(el).on('click', function (e) {
      e.preventDefault();
      var $content = $('.page-current').eq(tuhu.getParam('_tab') || 0).children('._content');
      var replaceEl = $('<div></div>');
      $content.append(replaceEl);
      if (instance) {
        instance.$children[0].showPlate = binding.value.type;
        instance.$children[0].myShowmask = binding.value.showmask;
        if (binding.value.type === 1) {
          instance.$children[0].cityVal = $(e.target).text();
          instance.$children[0].carVal = $(e.target).siblings().text();
        } else if (binding.value.type === 2) {
          instance.$children[0].cityVal = $(e.target).siblings().text();
          instance.$children[0].carVal = $(e.target).text();
        }
      } else {
        var cityV = '';
        var carV = '';
        if (binding.value.type === 1) {
          cityV = $(e.target).text();
          carV = $(e.target).siblings().text();
        } else if (binding.value.type === 2) {
          cityV = $(e.target).siblings().text();
          carV = $(e.target).text();
        }
        instance = new Vue({
          el: replaceEl[0],
          render: function render(createElement) {
            return createElement(__WEBPACK_IMPORTED_MODULE_0__components_newPlatenum_vue__["a" /* default */], {
              props: {
                showmask: binding.value.showmask,
                showP: binding.value.type,
                returnHandler: binding.value.returnHandler,
                cityV: cityV,
                carV: carV
              }
            });
          }
        });
      }
    });
  }
});

/***/ }),

/***/ "GjXy":
/***/ (function(module, exports) {

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/11/21
 * desc: input自动聚焦
 * eg: <input v-focus>
 */

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function inserted(el) {
    // 聚焦元素
    el.focus();
  }
});

/***/ }),

/***/ "Gqm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      carNo: '',
      speChars: ['港', '澳', '学', '警', '领'],
      numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      chars: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    };
  },

  props: {
    showTitleBtn: {
      type: Boolean,
      default: false
    },
    showNoBoard: {
      type: Boolean
    },
    chooseCarNO: {
      type: Function
    },
    delect: {
      type: Function
    },
    province: {
      type: String
    },
    getCarNo: {
      type: Function
    }
  },
  mounted: function mounted() {
    var fwrap = this.$refs.keyboard.parentNode.parentNode.parentNode;
    fwrap.appendChild(this.$refs.keyboard);
  },

  methods: {
    close: function close() {
      this.$emit('closeCarNO');
    },
    confirm: function confirm() {
      if (!/^[A-Z][a-zA-Z0-9]{4,5}[a-zA-Z0-9挂学警港澳]$/.test(this.carNo)) {
        tuhu.toast('请输入正确的车牌号');
      } else {
        this.close();
      }
    },
    handleChoose: function handleChoose(ev, item) {
      $(ev['target']).addClass('transShadow');
      setTimeout(function () {
        $(ev['target']).removeClass('transShadow');
      }, 100);

      if (this.carNo.length > 6) {
        tuhu.toast('请输入正确的车牌号');
        return;
      }

      this.carNo = this.carNo + item;

      this.chooseCarNO(this.carNo);
      // this.getCarNo(this.province + this.carNo)
    },
    del: function del() {
      this.carNo = this.carNo.slice(0, -1);
      this.delect();
    }
  }
});

/***/ }),

/***/ "GxCR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/tq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_config__ = __webpack_require__("65XL");





/**
 * author: 582196894@qq.com
 * date: 2020/06/12
 * desc: 用户信息
 * demo:
 * User.getUserInfo({
 *  force: false
 * })
 * 返回，注意事项
 * 1 IOS,Android,H5返回的数据结构一致
 * 2 用户是否登录根据 islogin字段判断
 *
 * {
 *  islogin: true,
 *  userid: "115d52a7-cb3e-4070-811f-64c8d6aa135c",
 *  phone: "13921745521",
 *  name: "wahaha",
 *  usersession: "206eb5e212cd4136bb711fdc9b1c08df"
 * }
 */
/** 接口配置 */
// import Cookies from 'js-cookie'


var USER_INFO_URL = '' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.GET_USERINFO;

var LOGOUT = '' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.LOG_OUT;

var GET_OUT_URL = '' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.WX_SILENT;

var USER_STORAGE_KEY = '_xk_user_key';

var userInfoPromise = null;

function resetData(data) {
  if (!data || !data.userId) {
    return { islogin: false };
  }

  var userId = (data.userId || data.userid || data.userID || '').replace(/[{}]/g, '');
  if (!userId) {
    data.islogin = false;
  } else {
    data.islogin = true;
  }

  return data;
}

var uuid = function () {
  var key = '_login_uuid';
  var uuid = '';

  return function () {
    if (!uuid) {
      uuid = tuhu.localStorage.getItem(key);
    }

    if (uuid) {
      return uuid;
    }

    var d = new Date().getTime();
    uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });

    tuhu.localStorage.setItem(key, uuid);
    return uuid;
  };
}();

var User = function () {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(User, null, [{
    key: 'clearUserInfoPromise',
    value: function clearUserInfoPromise() {
      userInfoPromise = null;
    }
  }, {
    key: 'getUserInfo',
    value: function getUserInfo() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        direct: false,
        force: false,
        phone: ''
      }, options);
      return new User(options).getUserInfo();
    }
  }, {
    key: 'setUserInfo',
    value: function setUserInfo(data) {
      if (!data) {
        userInfoPromise = null;
        tuhu.localStorage.removeItem(USER_STORAGE_KEY);

        tuhu.store && tuhu.store.commit('setUserInfo', { islogin: false });

        tuhu.localStorage.clear();

        tuhu.fetch('' + LOGOUT);
        //   Cookies.set('x-auth-token', '')
        //   return tuhu.navigateTo({
        // 	  url: '/pages_login/index'
        //   })
      }

      var result = resetData(data);

      tuhu.store && tuhu.store.commit('setUserInfo', result);

      userInfoPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);

      try {
        tuhu.localStorage.setItem(USER_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
      } catch (e) {
        console.log(e);
      }

      return userInfoPromise;
    }
  }]);

  function User(options) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, User);

    this.options = options;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(User, [{
    key: '_getH5Promise',
    value: function _getH5Promise() {
      var _this = this;

      this.showLoading();

      return tuhu.fetch('' + USER_INFO_URL).catch(function (e) {
        _this.hideLoading();
        return {
          islogin: false
        };
      });
    }
  }, {
    key: 'showLoading',
    value: function showLoading() {
      tuhu.showIndicator();
    }
  }, {
    key: 'hideLoading',
    value: function hideLoading() {
      tuhu.hideIndicator();
    }
  }, {
    key: 'getUserInfo',
    value: function getUserInfo() {
      var _this2 = this;

      if (!userInfoPromise) {
        userInfoPromise = this._getH5Promise();

        userInfoPromise = userInfoPromise.then(function (data) {
          if (data && data.code === '200') {
            return resetData(data.data);
          } else {
            return resetData();
          }
        }).catch(function (e) {
          console.error(e);
          _this2.hideLoading();

          userInfoPromise = null;

          return {
            islogin: false
          };
        });
      }

      userInfoPromise = userInfoPromise.then(function (userInfo) {
        tuhu.store && tuhu.store.commit('setUserInfo', userInfo);
        return userInfo;
      }).then(function (result) {
        if (!result.islogin) {
          if (!tuhu.device.isApp && "production" !== 'development') {
            tuhu.localStorage.removeItem(USER_STORAGE_KEY);
          }
          if (_this2.options.force) {
            // openId 只有后端（无次用户）重定向登陆页有
            if (tuhu.device.isWeixin && !_this2.options.openId && location.href.indexOf('localhost') === -1) {
              location.href = GET_OUT_URL + '?url=' + encodeURIComponent(location.href) + '&source=3';
            } else {
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                tuhu.navigateTo({
                  url: '/pages/_login/index',
                  query: {
                    direct: _this2.options.direct ? 1 : '',
                    phone: _this2.options.phone || '',
                    openId: _this2.options.openId || ''
                  },
                  data: {
                    resolve: resolve
                  }
                });
              });
            }
          }
        }

        return result;
      });
      // .then(async (result) => {
      //   return result
      // })
      return userInfoPromise;
    }
  }]);

  return User;
}();

User.uuid = uuid;


/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ "H3ej":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H452":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HHv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk__);







var Payment = function () {
  function Payment() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Payment);

    this.sign = null; // 微信支付-验证数据

    this.payModelId = null; // 支付模式
    this.signUrl = null; // 统一支付接口
    this.openid = null; // 用户id
    this.payPlatformId = null; // 服务名
    this.payPriceTotal = null; // 金额
    this.orderId = null; // 订单id
    this.title = null; // 券号
    this.jumpUrl = null; // h5支付-成功后跳转地址
  }

  // 打开收银台 res所需数据 isWxNet是否微信


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Payment, [{
    key: 'h5pay',


    // h5支付 成功失败都返回jumpUrl
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sign;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.fetch('' + this.signUrl, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    orderId: this.orderId,
                    jumpUrl: '',
                    openid: '',
                    payModelId: this.payModelId,
                    payPlatformId: this.payPlatformId,
                    payPriceTotal: this.payPriceTotal,
                    title: this.title
                  })
                }).then(function (res) {
                  location.href = res.data.mwebUrl;
                });

              case 2:
                sign = _context.sent;
                return _context.abrupt('return', sign);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function h5pay() {
        return _ref.apply(this, arguments);
      }

      return h5pay;
    }()

    // 微信调起支付1

  }, {
    key: 'config',
    value: function config(orderId) {
      var _this2 = this;

      return this.getSign().then(function () {
        if (__WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default.a) {
          return _this2.wxConfig(orderId);
        }
      });
    }

    // 微信调起支付2

  }, {
    key: 'getSign',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var sign;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return tuhu.fetch('' + this.signUrl, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    orderId: this.orderId,
                    jumpUrl: '',
                    openid: '',
                    payModelId: this.payModelId,
                    payPlatformId: this.payPlatformId,
                    payPriceTotal: this.payPriceTotal,
                    title: this.title
                  })
                }).then(function (res) {
                  console.log('接口获取验证数据', res);

                  if (res && res.code === '200') {
                    // console.log('getSign成功', res)
                    _this3.sign = res.data;
                  } else {
                    tuhu.toast(res.message || '支付失败，200');
                    console.log('getSign失败', res.message || '网络错误');
                  }
                });

              case 2:
                sign = _context2.sent;
                return _context2.abrupt('return', sign);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSign() {
        return _ref2.apply(this, arguments);
      }

      return getSign;
    }()

    // 微信调起支付3

  }, {
    key: 'wxConfig',
    value: function wxConfig(orderId) {
      // console.log('验证sign', this.sign)
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default.a.chooseWXPay({
        timestamp: this.sign.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: this.sign.nonceStr, // 支付签名随机串，不长于 32 位
        package: this.sign.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: this.sign.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: this.sign.paySign, // 支付签名
        success: function success(res) {
          // 支付成功后的回调函数
          // console.log('支付成功后的回调函数', res)
          setTimeout(function () {
            // this.sign.outTradeNo: 支付流水号微信orderId 下午茶用到
            console.log('ress', _this.sign);
            //   Payment.toOrderSuccess(serviceTickitCode, orderId, _this.sign && _this.sign.orderId)
          }, 200);
        }
      });
    }

    // 跳转

  }], [{
    key: 'openBank',
    value: function openBank() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isWxNet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


      // 跳转自己平台的收银台
      // const BANK_ROUTER = isWxNet ? '/pages/cashier/index' : 'https://wx.tuhu.cn/vue/wx/pages/cashier/index'

      if (!res.payModelId) return tuhu.toast('无服务名称');

      if (!res.payPlatformId) return tuhu.toast('无服务金额');

      if (!res.payPriceTotal) return tuhu.toast('无券号');

      if (!res.signUrl) return tuhu.toast('无支付接口');

      if (!res.orderId) return tuhu.toast('无支付模式类型');

      if (!res.title) return tuhu.toast('无用户id');

      var pay = new Payment();
      pay.payModelId = res.payModelId;
      pay.payPlatformId = res.payPlatformId;
      pay.payPriceTotal = res.payPriceTotal;
      pay.signUrl = res.signUrl;
      pay.title = res.title;
      pay.orderId = res.orderId;

      // 先支付没有orderId
      // pay.orderId = res.orderId || null

      pay.jumpUrl = res.jumpUrl || null;

      isWxNet ? pay.config(pay.orderId) : pay.h5pay();
    }
  }]);

  return Payment;
}();

Payment.toOrderSuccess = function (serviceTickitCode, orderId, outTradeNo) {
  tuhu.redirectTo({
    url: '/pages/orderResult/index',
    query: {
      tCode: serviceTickitCode,
      oId: orderId,
      oNo: outTradeNo
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Payment);

/***/ }),

/***/ "HLcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HRUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ttButton__ = __webpack_require__("bPVk");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ttButton: __WEBPACK_IMPORTED_MODULE_4__components_ttButton__["a" /* default */]
    },
    data: function data() {
        return {
            merchantCode: '',
            merchantSignFlag: '',
            signFlag: '',
            source: 1,
            phone: '',
            code: '',
            yzmBtnLock: false, // 按钮
            yzmLock: false, // 倒计时
            joinLock: false, // 加盟
            time: 60,
            shopPhone: '',
            shopNo: ''
        };
    },

    computed: {
        yzmText: function yzmText() {
            if (!this.yzmLock) {
                return '获取验证码';
            } else {
                return this.time + '\u79D2\u540E\u91CD\u53D1';
            }
        }
    },
    created: function created() {
        this.init();
    },

    methods: {
        clear: function clear(val) {
            this[val] = '';
        },
        init: function init() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.shopPhone = tuhu.getParam('phone') || '';
                                _this.shopNo = tuhu.getParam('shopNo') || '';
                                _this.merchantCode = tuhu.getParam('merchantCode');
                                _this.merchantSignFlag = tuhu.getParam('merchantSignFlag');
                                _this.signFlag = tuhu.getParam('signFlag');
                                if (_this.shopPhone && _this.shopNo) _this.source = 1;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getYzm: function getYzm() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.phone.length !== 11)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请输入正确的手机号'));

                            case 2:
                                if (!_this2.yzmBtnLock) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return', false);

                            case 4:
                                _this2.yzmBtnLock = true;
                                _context2.prev = 5;
                                _context2.next = 8;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_CODE + ('/' + _this2.phone + '/' + _this2.source));

                            case 8:
                                res = _context2.sent;

                                if (res && res.code === '200' || res && res.code === 2000) {
                                    _this2.countDown();
                                } else {
                                    _this2.yzmBtnLock = false;
                                    tuhu.toast(res.message || '网络错误');
                                    console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_CODE, res.message);
                                }
                                _context2.next = 16;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2['catch'](5);

                                _this2.yzmBtnLock = false;
                                console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_CODE, _context2.t0);

                            case 16:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[5, 12]]);
            }))();
        },
        countDown: function countDown() {
            var _this3 = this;

            if (this.yzmLock) return;
            var timer = setInterval(function () {
                _this3.yzmLock = true;
                _this3.time--;
                if (_this3.time < 0) {
                    clearInterval(timer);
                    _this3.time = 10;
                    _this3.yzmLock = false;
                    _this3.yzmBtnLock = false;
                }
            }, 1000);
        },
        clickBtn: function clickBtn() {
            var _this4 = this;

            if (!this.phone || this.phone.length !== 11) return tuhu.toast('请输入正确的手机号');
            if (!this.code) return tuhu.toast('请输入正确的验证码');
            if (this.joinLock) return;
            this.joinLock = true;
            setTimeout(function () {
                _this4.joinLock = false;
            }, 2000);
            if (this.shopPhone && this.shopNo) {
                this.verifyLogin();
            } else {
                this.login();
            }
        },
        verifyLogin: function verifyLogin() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var params, data, phone, shopId;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                params = {
                                    phone: _this5.phone,
                                    desPhone: _this5.shopPhone,
                                    shopId: _this5.shopNo
                                };
                                _context3.next = 4;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_VERIFY_LOGIN, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
                                });

                            case 4:
                                data = _context3.sent;

                                if (data && data.code === '200') {
                                    phone = data.data.desPhone;
                                    shopId = data.data.shopId;

                                    _this5.login(phone, shopId, _this5.shopNo);
                                } else {
                                    tuhu.toast(data.message || '网络异常');
                                    console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_VERIFY_LOGIN, data);
                                }
                                _context3.next = 11;
                                break;

                            case 8:
                                _context3.prev = 8;
                                _context3.t0 = _context3['catch'](0);

                                console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SHOP_VERIFY_LOGIN, _context3.t0);

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5, [[0, 8]]);
            }))();
        },
        login: function login() {
            var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var _this6 = this;

            var shopId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var shopNo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var params, data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;
                                params = {
                                    phone: _this6.phone,
                                    verificationCode: _this6.code,
                                    source: _this6.source // 来源
                                };
                                _context4.next = 4;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.LOGIN, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
                                });

                            case 4:
                                data = _context4.sent;

                                if (data && data.code === '200') {
                                    tuhu.redirectTo({
                                        url: '/pages/cooperationShopInfo/index',
                                        query: {
                                            phone: phone,
                                            shopId: shopId,
                                            shopNo: shopNo,
                                            merchantCode: _this6.merchantCode,
                                            merchantSignFlag: _this6.merchantSignFlag,
                                            signFlag: _this6.signFlag
                                        }
                                    });
                                } else {
                                    tuhu.toast(data.message || '网络异常');
                                    console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.LOGIN, data);
                                }
                                _context4.next = 11;
                                break;

                            case 8:
                                _context4.prev = 8;
                                _context4.t0 = _context4['catch'](0);

                                console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.LOGIN, _context4.t0);

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6, [[0, 8]]);
            }))();
        }
    }
});

/***/ }),

/***/ "HaFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.type === '2')?_c('div',{staticClass:"verify-img-out",style:({ height: parseInt(_vm.setSize.imgHeight) + _vm.vSpace + 'px' })},[_c('div',{staticClass:"verify-img-panel",style:({ width: _vm.setSize.imgWidth, height: _vm.setSize.imgHeight })},[_c('van-image',{staticStyle:{"width":"100%","height":"100%","display":"block"},attrs:{"src":_vm.backImgBase ? 'data:image/png;base64,' + _vm.backImgBase : '',"alt":""},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('van-loading',{attrs:{"type":"spinner","size":"20"}})]},proxy:true},{key:"error",fn:function(){return [_c('van-loading',{attrs:{"type":"spinner","size":"20"}})]},proxy:true}],null,false,2122737239)}),_vm._v(" "),_c('van-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRefresh),expression:"showRefresh"}],staticClass:"icon-refresh",attrs:{"name":"replay"},on:{"click":_vm.refresh}}),_vm._v(" "),_c('transition',{attrs:{"name":"tips"}},[(_vm.tipWords)?_c('span',{staticClass:"verify-tips",class:_vm.passFlag ? 'suc-bg' : 'err-bg'},[_vm._v(_vm._s(_vm.tipWords))]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"verify-bar-area",style:({ width: _vm.setSize.imgWidth, height: _vm.barSize.height, 'line-height': _vm.barSize.height })},[_c('span',{staticClass:"verify-msg",domProps:{"textContent":_vm._s(_vm.text)}}),_vm._v(" "),_c('div',{staticClass:"verify-left-bar",style:({
        width: _vm.leftBarWidth !== undefined ? _vm.leftBarWidth : _vm.barSize.height,
        height: _vm.barSize.height,
        'border-color': _vm.leftBarBorderColor,
        transaction: _vm.transitionWidth
      })},[_c('span',{staticClass:"verify-msg",domProps:{"textContent":_vm._s(_vm.finishText)}}),_vm._v(" "),_c('div',{staticClass:"verify-move-block",style:({
          width: _vm.barSize.height,
          height: _vm.barSize.height,
          'background-color': _vm.moveBlockBackgroundColor,
          left: _vm.moveBlockLeft,
          transition: _vm.transitionLeft
        }),on:{"touchstart":_vm.start,"mousedown":_vm.start}},[_c('i',{class:['verify-icon iconfont', _vm.iconClass],style:({ color: _vm.iconColor })}),_vm._v(" "),(_vm.type === '2')?_c('div',{staticClass:"verify-sub-block",style:({
            width: Math.floor((parseInt(_vm.setSize.imgWidth) * 47) / 310) + 'px',
            height: _vm.setSize.imgHeight,
            top: '-' + (parseInt(_vm.setSize.imgHeight) + _vm.vSpace) + 'px',
            'background-size': _vm.setSize.imgWidth + ' ' + _vm.setSize.imgHeight
          })},[_c('van-image',{staticStyle:{"width":"100%","height":"100%","display":"block"},attrs:{"src":'data:image/png;base64,' + _vm.blockBackImgBase,"alt":""},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('van-loading',{attrs:{"type":"spinner","size":"20"}})]},proxy:true},{key:"error",fn:function(){return [_c('van-loading',{attrs:{"type":"spinner","size":"20"}})]},proxy:true}],null,false,2122737239)})],1):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HfTo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rx.7e50820.png";

/***/ }),

/***/ "Hh61":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HpBV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lazy_vue__ = __webpack_require__("Z52j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b79480b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lazy_vue__ = __webpack_require__("xQDi");
function injectStyle (ssrContext) {
  __webpack_require__("WC/x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b79480b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lazy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b79480b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lazy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I8BA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmInfo_vue__ = __webpack_require__("qtxv");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2197b588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmInfo_vue__ = __webpack_require__("/lqb");
function injectStyle (ssrContext) {
  __webpack_require__("vSyV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2197b588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2197b588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IA7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+Jgj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1fa2a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("KpUx");
function injectStyle (ssrContext) {
  __webpack_require__("RQXV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c1fa2a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c1fa2a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IKzx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ia83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_vue__ = __webpack_require__("ZpKA");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95235ff4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__ = __webpack_require__("Qu6i");
function injectStyle (ssrContext) {
  __webpack_require__("ZHLH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95235ff4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95235ff4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_agreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IjLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_camera_vue__ = __webpack_require__("QFb7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28fa6566_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_camera_vue__ = __webpack_require__("yyDs");
function injectStyle (ssrContext) {
  __webpack_require__("kk5Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28fa6566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_camera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28fa6566_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_camera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IuaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wxconfig__ = __webpack_require__("Z+yf");





var TwiceShare = function () {
  function TwiceShare(param) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TwiceShare);

    this.param = param;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TwiceShare, [{
    key: 'config',
    value: function config() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3__wxconfig__["a" /* default */].share(['onMenuShareTimeline', 'onMenuShareAppMessage']).then(function () {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var param = _this.getParam();
          var link = param.Link.replace(/\{/g, '%7B').replace(/\}/g, '%7D');

          window.wx.onMenuShareAppMessage({
            title: param.Title,
            desc: param.Description,
            link: link,
            imgUrl: param.ImageUrl,
            success: function success() {
              resolve();
            },
            cancel: function cancel() {}
          });

          window.wx.onMenuShareTimeline({
            title: param.Title,
            desc: param.Description,
            link: link,
            imgUrl: param.ImageUrl,
            success: function success() {
              resolve();
            },
            cancel: function cancel() {}
          });
        });
      });
    }
  }, {
    key: 'getParam',
    value: function getParam() {
      var param = {};

      param.Title = this.param.shareTitle;
      param.Description = this.param.shareDescrip;
      param.ImageUrl = this.param.shareImage;
      param.Link = this.param.shareUrl || location.href;

      return param;
    }
  }]);

  return TwiceShare;
}();

TwiceShare.share = function (param) {
  if (!tuhu.device.isWeixin) {
    return;
  }

  var share = new TwiceShare(param);
  return share.config();
};

/* harmony default export */ __webpack_exports__["a"] = (TwiceShare);

/***/ }),

/***/ "Iy2a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pen.cb78f74.png";

/***/ }),

/***/ "IzBW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J1i8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Nkzj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_979c3e36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("kGVr");
function injectStyle (ssrContext) {
  __webpack_require__("lA/M")
  __webpack_require__("Lk/r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-979c3e36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_979c3e36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JCFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ttButton__ = __webpack_require__("bPVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_platen__ = __webpack_require__("8YRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__configs_config__ = __webpack_require__("65XL");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var carParams = {
  province: '沪',
  provinces: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣', '闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂', '琼', '青', '新', '藏', '港', '澳'],
  carNO: '',
  showNoBoard: false,
  showAllProv: false,
  showCarNoFill: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ttButton: __WEBPACK_IMPORTED_MODULE_6__components_ttButton__["a" /* default */],
    platen: __WEBPACK_IMPORTED_MODULE_7__components_platen__["a" /* default */]
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
      isQuery: false,
      showSureOff: false,
      isCheckCarNo: null,
      orderId: 0,
      verifyConfig: {},
      code: '',
      lock: false
    }, carParams, {
      message: '',
      severName: '',
      inputShow: false,
      inputValue: '',
      show: true,
      hideKey: true
    });
  },
  created: function created() {
    this.autoVerifyCode();
  },
  mounted: function mounted() {
    // let that = this
    // $('#code-search-input').bind('search', function () {
    // 	this.checkCoupon()
    // })
  },

  watch: {
    inputValue: function inputValue(val, newVal) {
      if (val.length < 10) {
        this.isQuery = false;
      } else {
        this.isQuery = true;
      }
    }
  },
  computed: {
    verifyCarNo: function verifyCarNo() {
      var carNo = this.verifyConfig ? this.verifyConfig.carNo : '';
      var rightCarNo = carNo ? carNo.trim().replace(/[\s\.,\!@#%&*()~`]*/g, '') : '';
      var reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}(([A-HJ-NP-Z0-9]{5})|([0-9]{6}|[A-HJ-NP-Z]{1}[0-9]{5}|[0-9]{5}[A-HJ-NP-Z]{1}|[A-HJ-NP-Z]{2}[0-9]{4}))$/;
      if (!reg.test(rightCarNo)) {
        return '';
      } else {
        return rightCarNo;
      }
    },
    shopId: function shopId() {
      var shopInfo = tuhu.store.state.currentShopInfo;
      return shopInfo ? shopInfo.shopId : tuhu.getParam('shopId');
    }
  },
  methods: {
    getVerifactionConfig: function getVerifactionConfig() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.inputValue.length < 10)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                try {
                  tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_8__configs_config__["a" /* default */].apis.GET_VERIFICATION_CONFIG, {
                    method: 'post',
                    body: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                      verificationCode: _this.inputValue,
                      shopId: parseInt(_this.shopId)
                    })
                  }).then(function (data) {
                    if (data && data.code === '200') {
                      _this.verifyConfig = data.data ? data.data : {};
                      if (!_this.verifyConfig.serverName) return tuhu.toast('请核实券码是否正确');else _this.showSureOff = true;
                      var serviceAttributeInfo = data.data ? JSON.parse(data.data.serviceAttributeInfo) : null;
                      _this.isCheckCarNo = serviceAttributeInfo ? serviceAttributeInfo.isCheckCarNo : null;
                    } else {
                      _this.verifyConfig = {};
                      _this.showSureOff = false;
                      tuhu.toast(data.message || '请核实券码是否正确');
                    }
                  });
                } catch (e) {
                  console.log(e);
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    autoVerifyCode: function autoVerifyCode() {
      if (tuhu.getParam('success')) {
        this.inputValue = this.options && this.options.verifyCode || '';
        // this.onBlur()
      } else {}
    },
    checkCoupon: function checkCoupon() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var timeoutPromise, data, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.lock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', false);

              case 2:
                if (!(_this2.inputValue.length < 10)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', tuhu.toast('请输入正确的小鲲消费码'));

              case 4:

                _this2.lock = true;

                _this2.$kun.showLoading('正在核销，请不要关闭页面，耐心等待');
                setTimeout(function () {
                  _this2.lock = false;
                }, 2500);

                _context2.prev = 7;

                // 给接口添加 30秒 超时控制
                timeoutPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  setTimeout(function () {
                    reject(new Error('timeout'));
                  }, 30000); // 30秒超时
                });

                // 竞赛模式：接口请求 vs 超时，谁先完成执行谁

                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.race([tuhu.fetch(__WEBPACK_IMPORTED_MODULE_8__configs_config__["a" /* default */].apis.CHECK_CODE_COUPON + '?code=' + _this2.inputValue + '&shopId=' + _this2.shopId), timeoutPromise]);

              case 11:
                data = _context2.sent;

                if (!(data && data.code === '200')) {
                  _context2.next = 22;
                  break;
                }

                // this.severName = data.data

                res = data.data;

                _this2.$kun.hideLoading();

                if (!res.isUploadPhoto) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt('return', _this2.uploadImg(res));

              case 19:
                return _context2.abrupt('return', _this2.sureToOff(res));

              case 20:
                _context2.next = 25;
                break;

              case 22:
                _this2.$kun.hideLoading();

                tuhu.toast(data.message || '网络错误');

                console.log(data.message);

              case 25:
                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](7);

                // 判断是否是超时错误
                if (_context2.t0.message === 'timeout') {
                  _this2.$kun.hideLoading();
                  tuhu.toast('核销失败，请重试');
                } else {
                  _this2.$kun.hideLoading();
                  tuhu.toast('核销失败，请检查网络后重试');
                }
                console.log(_context2.t0);

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 27]]);
      }))();
    },
    chooseProvince: function chooseProvince(item) {
      this.province = item;
      this.showAllProv = false;
      this.showNoBoard = true;
    },
    chooseCarNO: function chooseCarNO(no) {
      this.carNO = no;
    },
    delect: function delect() {
      this.carNO = this.carNO.slice(0, -1);
    },

    // 不输入车牌核销
    sureToOff: function sureToOff(obj) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$kun.showLoading('正在核销，请不要关闭页面，耐心等待');

                _context3.prev = 1;
                _context3.next = 4;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_8__configs_config__["a" /* default */].apis.GET_CODE_COUPON, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this3.shopId,
                    carNo: '',
                    code: obj && obj.writeOffCode || _this3.inputValue
                  })
                });

              case 4:
                data = _context3.sent;


                _this3.showCarNoFill = false;

                _this3.showAllProv = false;

                if (data && data.code === '200') {
                  _this3.$kun.hideLoading();

                  tuhu.toast('核销成功');

                  setTimeout(function () {
                    _this3.showAllProv = false;

                    _this3.code = '';

                    var info = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data.data, {
                      Message: data.message
                    });

                    tuhu.sessionStorage.setItem('shopOrderDetail', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(info));

                    tuhu.navigateTo({
                      url: '/pages/orderDetail/index',

                      data: {
                        ListInfo: info
                      },

                      query: {
                        success: data.code === '200' ? 1 : ''
                      }
                    });
                  }, 300);
                } else {
                  _this3.$kun.hideLoading();

                  tuhu.toast(data.message || '网络错误');
                }
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](1);

                _this3.$kun.hideLoading();

                console.log(_context3.t0);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 10]]);
      }))();
    },
    uploadImg: function uploadImg(data) {
      tuhu.sessionStorage.setItem('upDetail', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
      tuhu.navigateTo({
        url: '/pages/verifyUploadImg/index',
        data: {
          uploadDetail: data
        },
        query: {
          isCheckCarNo: this.isCheckCarNo,
          carNo: this.verifyConfig.carNo,
          sId: this.shopId,
          vCode: data && data.writeOffCode || this.inputValue
        }
      });
    },
    onBlur: function onBlur() {
      this.show = false;
      this.checkCoupon();
    },
    onInput: function onInput() {},
    onDelete: function onDelete() {},
    onPageBack: function onPageBack(to, from) {
      if (from.path.indexOf('/pages/orderDetail') > -1) {
        this.inputValue = '';
      }
    }
  }
});

/***/ }),

/***/ "JKBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_picker__ = __webpack_require__("yTAH");




//
//
//
//
//
//

/**
 * author: caominjie@tuhu.cn
 * show: 控制citypicker显示隐藏
 * cityPicker: 默认值为3 三级地区选择 (2为两级地区选择)
 * cityValue: 默认选择地区 示例['上海市', '上海市', '闵行区']
 * formatvalue: 格式化数据， 每次数据变化时都会执行  picker实例下的$city为整理好的返回数据
 * onOpen: 自定义 picker 打开时的触发动作
 * onClose:  自定义 picker 关闭时的触发动作
 * el: <tuhu-citypicker :formatvalue='formatvalue' :show='true'>
    </tuhu-citypicker>
 */


(function ($) {
  // this = input
  $.fn.cityPicker = function (params, data, type) {
    var defaultParmas = __WEBPACK_IMPORTED_MODULE_5__commons_picker__["a" /* default */].initPicker(params, { 'data': data, 'type': 'city', level: type });
    return this.each(function () {
      $(this).picker($.extend(defaultParmas, params));
    });
  };
})($);

var confirmBtnClass = function () {
  var ID = 0;
  return function () {
    ID++;
    return '_cityPicker_confirmBtn' + ID;
  };
}();

var pickerConfirmClass = '';
var pickerConfirmButton = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    onopen: {
      type: Function
    },
    onclose: {
      type: Function
    },
    successBtn: {
      type: String,
      default: '确定'
    },
    cancelBtn: {
      type: String,
      default: '取消'
    },
    title: {
      type: String,
      default: ''
    },
    formatvalue: {
      type: Function,
      require: true
    },
    cityPicker: {
      type: Number,
      default: 3
    },
    cityValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    show: function show(n, o) {
      this._showAndHide(n);
    }
  },
  mounted: function mounted() {
    var proviceList = tuhu.localStorage.getItem('proviceList');
    if (proviceList) {
      try {
        this._cityPicker(JSON.parse(proviceList));
      } catch (error) {
        this._netWorkLoad();
      }
    } else {
      this._netWorkLoad();
    }
  },
  beforeDestroy: function beforeDestroy() {
    $(this.$el).picker('close');
  },

  methods: {
    _cityPicker: function _cityPicker(proviceList) {
      pickerConfirmClass = confirmBtnClass();

      $(this.$el).cityPicker({
        toolbarTemplate: '<header class="bar bar-nav">\n                            <button class="button button-link pull-right ' + pickerConfirmClass + ' close-picker">' + this.successBtn + '</button>\n                            <span class="subtitle">' + this.title + '</span>\n                            <h1 class="title close-picker">' + this.cancelBtn + '</h1>\n                          </header>',
        formatValue: this.formatvalue,
        cityValue: this.cityValue,
        onOpen: this._onopen,
        onClose: this._onclose
      }, proviceList, this.cityPicker);

      this._showAndHide(this.show);
    },
    _netWorkLoad: function _netWorkLoad() {
      var _this = this;

      var $this = this;
      // tuhu.fetch('https://www.xiaokunkeji.cn/api/queryProvinceCity').then((res) => {
      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.PROVINCE).then(function (res) {
        if (res.code === '200') {
          var transformTree = function transformTree(data) {
            return data.map(function (item) {
              return {
                id: item.id,
                name: item.areaName,
                children: item.children ? transformTree(item.children) : undefined
              };
            });
          };

          var r1 = transformTree(res.data);
          var r2 = _this.replace(r1);
          //   debugger
          tuhu.localStorage.setItem('proviceList', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(r2));
          try {
            $this._cityPicker(r2);
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    replace: function replace(menus) {
      var fields = [{ name: 'ProviceName', id: 'RegionID', children: 'CityList' }, { name: 'CityName', id: 'RegionID', children: 'AreaList' }, { name: 'CityName', id: 'RegionID', children: '' }];
      var r = function r(menus, index) {
        var field = fields[index];
        ++index;
        if (!field) return;
        var arr = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(menus), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _item;

            var v = _step.value;

            var item = (_item = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_item, field.id, v.id), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_item, field.name, v.name), _item);
            // if (['上海市', '北京市', '天津市', '重庆市'].indexOf(v.name) > -1) { // 不需要
            if ([].indexOf(v.name) > -1) {
              (function () {
                var res = [];
                v.children.forEach(function (item) {
                  res.push({
                    RegionID: item.id,
                    CityName: item.name
                  });
                });
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, { CityList: [{
                    CityName: v.name,
                    RegionID: v.id,
                    AreaList: res
                  }] });
              })();
            } else {
              if (v.children && v.children.length) {
                field.children && (item[field.children] = r(v.children, index));
              }
            }
            arr.push(item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return arr;
      };
      return r(menus, 0);
    },
    _showAndHide: function _showAndHide(n) {
      n ? $(this.$el).picker('open') : $(this.$el).picker('close');
    },
    _onclose: function _onclose(picker) {
      this.onclose && this.onclose(picker);
    },
    _onopen: function _onopen(picker) {
      var _this2 = this;

      // 确认按钮注册事件
      pickerConfirmButton = picker.container.find('.' + pickerConfirmClass + '.close-picker');
      pickerConfirmButton.on('click', function () {
        _this2.$emit('onconfirm', picker);
      });

      this.onopen && this.onopen(picker);
    }
  },
  destroyed: function destroyed() {
    // 确认按钮注销事件
    pickerConfirmButton && pickerConfirmButton.off('click');
  }
});

/***/ }),

/***/ "JKiR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JY8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JsOw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jytq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wm_vue__ = __webpack_require__("5FTe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f25ba95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wm_vue__ = __webpack_require__("TqMK");
function injectStyle (ssrContext) {
  __webpack_require__("a+R+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f25ba95"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f25ba95_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KCds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"search-page"},[_c('div',{staticClass:"search-input"},[_c('input',{attrs:{"placeholder":_vm.searchParmas.word},on:{"click":_vm.toIndex}}),_vm._v(" "),_c('div',{staticClass:"search-button",on:{"click":_vm.hindleBack}},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"search-content"},[_c('tuhu-infinite',{class:_vm.isPanelShow?'hidden':'',attrs:{"nodata":_vm.noProduct,"endmsg":"到底了哦","distance":100,"end":_vm.end,"id":_vm.scrollId},on:{"oninfinite":_vm.oninfinite}},[_c('div',{staticStyle:{"padding-top":"2.3rem"},attrs:{"slot":"content"},slot:"content"},[_c('tuhu-wm',{attrs:{"eventaction":"searchlist_download_click","nativeurl":_vm.appKeyword},on:{"update:nativeurl":function($event){_vm.appKeyword=$event}}}),_vm._v(" "),(_vm.ActivityBuildList)?_c('div',{staticClass:"acitivty",on:{"click":_vm.toActivity}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.ActivityBuildList.SelKeyImage,width:'100%'}),expression:"{src:ActivityBuildList.SelKeyImage,width:'100%'}"}]})]):_vm._e(),_vm._v(" "),(_vm.activityFirmList && _vm.activityFirmList.Link)?_c('div',{staticClass:"tomodule"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:_vm.activityFirmList.Image,width: 3}),expression:"{src:activityFirmList.Image,width: 3}"}]}),_vm._v(" "),_c('div',{staticClass:"module-name"},[_c('div',{},[_vm._v(_vm._s(_vm.activityFirmList.Name))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.activityFirmList.Description))])]),_vm._v(" "),_c('div',{staticClass:"module-button",on:{"click":_vm.toModule}},[_vm._v("进入")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-car",on:{"click":_vm.selectCar}},[_c('div',{staticClass:"box"},[_c('div',{class:{carInfo: _vm.carInfo.TID}},[_vm._v(_vm._s(_vm.carNamesShow))]),_vm._v(" "),(_vm.carInfo.ProductID && !_vm.carInfo.TID)?_c('div',[_vm._v("完善车型")]):_vm._e()])]),_vm._v(" "),_c('searchSortTabs',{staticClass:"search-list-sorttabs",attrs:{"tabsStatusType":_vm.tabsStatusType,"callbackClickTab":_vm.callbackClickTab,"keyword":_vm.searchParmas.word,"handlePanelHiden":_vm.handleSortPanelHidden}}),_vm._v(" "),_c('div',{staticClass:"product-list"},_vm._l((_vm.ProductList),function(item,index){return _c('div',{key:index,staticClass:"product-item",on:{"click":function($event){return _vm.autoNavigate(item)}}},[(item.StockOut === 1)?_c('div',{staticClass:"mask"}):_vm._e(),_vm._v(" "),_c('div',{class:{productimg: true, yuding: item.StockOut === 1}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item.Image,width: 6}),expression:"{src:item.Image,width: 6}"}]}),_vm._v(" "),(item.ProductBannerImage)?_c('img',{staticClass:"bannerimage",attrs:{"src":item.ProductBannerImage,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"product-content"},[_c('div',{staticClass:"product-name"},[_c('span',{domProps:{"textContent":_vm._s(item.DisplayName)}}),_vm._v(" "),_c('span',{style:({color:'#df3448'}),domProps:{"textContent":_vm._s(item.ShuXing5)}})]),_vm._v(" "),_c('div',{staticClass:"product-tabs"},_vm._l((item.Tabs),function(ite,ind){return (ite.ShortTab!='分期')?_c('span',{key:ind,style:({border:'1px solid #'+ite.BorderColor,backgroundColor: '#'+ite.Color,color: '#' + ite.FontColor,marginLeft:'0.1rem'}),domProps:{"textContent":_vm._s(ite.Tab)}}):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"product-price",domProps:{"textContent":_vm._s(item.Price)}})])])}),0)],1)])],1),_vm._v(" "),_c('tuhu-gotop',{attrs:{"scrollid":_vm.scrollId}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KEzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_upload__ = __webpack_require__("x3mS");

/**
 * desc: 图片上传
 * docs:
 * onLoadImgSuccess: 钩子函数( 加载完图片 上传图片之前 可以获取图片url )
 * onUpload: 上传图片完成回调函数
 * reset: 是否重置input 默认true
 * capture: 是否禁用相册,直接唤起拍照  默认false
 * readonly: 回显用 默认true
 * eg: <a href="#" v-upload="{onUpload: onUpload, imgIndex: 0,imgName: 'desc',imgDesc: 'aaaaa', readonly: false}" alt="">aaaaaa</a>
 */


Vue.directive('upload', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, arg) {
    var readonly = arg.value.readonly || true;

    // 随机id
    var randomName = '';
    var d = new Date().getTime();
    randomName = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
    // input:file实例
    var fileElem = null;

    !fileElem && $(el).parent().append('\n      <input type="file" id="_File' + randomName + '" accept="image/*" ' + (arg.capture ? 'capture' : '') + ' style="width: 0.001px;height: 0.001px;opacity: 0;overflow: hidden;position: absolute;z-index: -999;" >\n    ');
    fileElem = document.querySelector('#_File' + randomName);

    // 点击挂载元素
    $(el).on('click', function () {
      // 派发事件
      readonly && fileElem && fileElem.dispatchEvent(new MouseEvent('click'));
    });

    // 绑定change事件
    $(fileElem).on('change', function (e) {
      // 如果没选择
      if (e.currentTarget.files.length === 0) return;
      var _arg$value = arg.value,
          onUpload = _arg$value.onUpload,
          _arg$value$reset = _arg$value.reset,
          reset = _arg$value$reset === undefined ? true : _arg$value$reset;

      __WEBPACK_IMPORTED_MODULE_1__commons_upload__["a" /* default */].upload(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        file: e.currentTarget.files
      }, arg.value)).then(onUpload);
      // reset input:file
      if (reset) {
        $(this)[0].value = '';
      }
    });
  }
});

/***/ }),

/***/ "KPJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onlineSign_vue__ = __webpack_require__("g6X3");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c8761e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onlineSign_vue__ = __webpack_require__("cSXx");
function injectStyle (ssrContext) {
  __webpack_require__("VYOR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36c8761e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onlineSign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c8761e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onlineSign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KUrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_vue__ = __webpack_require__("egk8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3347bcda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__ = __webpack_require__("889I");
function injectStyle (ssrContext) {
  __webpack_require__("nLtl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3347bcda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3347bcda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KbyD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wxconfig__ = __webpack_require__("Z+yf");








/**
 * author: guiyuxuan@tuhu.cn
 * date: 2017/8/21
 * desc: 获取用户位置信息
 * 调用方式: Locate.getLocate({
 *  refresh: false //是否实时获取 默认为false
 * })
 * 正常返回 (ios,android,h5)保持一致
 *{
    city: "上海市"
    district: "闵行区"
    info: "上海市闵行区万源路18号-1"
    latitude: "31.1359024047852"
    longitude: "121.402229309082"
    province: "上海市"
 }
 *异常返回 null
 */
// import jsonp from 'fetch-jsonp'
// import WxConfig from './wxconfig'

// const MAP_URL = 'https://webapi.amap.com/maps?v=1.3&key=37e72836556ecf33165d4e958de699d9'
// const CALL_URL = 'https://wx.tuhu.cn/home/GetWxJsApiParams'
// const WX_URL = 'https://res.tuhu.org/react/lib/jweixin.1.2.0.min.js'
// const BAIDU_MAP = 'https://api.map.baidu.com/getscript?v=2.0&ak=w742K60CZ4fOaGEQ3n6HeB05'


var SELECT_MAP = 'https://wx.tuhu.cn/user/SelectMap';

var CONVER_BAIDU = '';

var BAIDU_PACKAGE = 'com.baidu.BaiduMap';
var BAIDU_SCHEME = 'baidumap://';
var GAODE_PACKAGE = 'com.autonavi.minimap';
var GAODE_SCHEME = 'iosamap://';

var lastOptions = {};

var allowed = false;

var SELECT_KEY = '_locate_user_selected';

var locatePromise = null;

var curLocatePromise = null;

function nativeMap(data) {
  if (tuhu.isLightApp) {
    return tuhu.toast('暂不支持');
  }
  var blat = data.lat;
  var blng = data.lng;
  // 是否是百度渠道
  var isBaiDu = tuhu.wxChannel === 'baidulbs';
  var buttons1 = [{
    text: '高德地图',
    bold: true,
    abled: !isBaiDu,
    onClick: function onClick() {
      transformLocate(blng, blat).then(function (data) {
        var lng = data.lng,
            lat = data.lat;


        if (tuhu.device.isApp) {
          if (tuhu.device.tuhuAndroid) {
            tuhu.actionWithNative('checkThirdApp', { package: GAODE_PACKAGE }).then(function (res) {
              if (res === '1') {
                location.href = 'androidamap://navi?sourceApplication=\u5C0F\u9CB2\u8F66\u670D&lat=' + lat + '&lon=' + lng + '&dev=0&style=2';
              } else if (res === '0') {
                tuhu.toast('您的手机未安装高德地图app');

                gaodeH5Jump(lng, lat);
              } else if (res === '2') {
                // tuhu.toast('高德地图未通过小鲲车服白名单～')
                gaodeH5Jump(lng, lat);
              } else {
                gaodeH5Jump(lng, lat);
              }
            });
          } else {
            tuhu.actionWithNative('checkThirdApp', { url: GAODE_SCHEME }).then(function (res) {
              if (res.result) {
                location.href = 'iosamap://navi?sourceApplication=\u5C0F\u9CB2\u8F66\u670D&lat=' + lat + '&lon=' + lng + '&dev=0&style=2';
              } else {
                // tuhu.toast('您的手机未安装高德地图app')

                gaodeH5Jump(lng, lat);
              }
            });
          }
        } else {
          var u = window.navigator.userAgent;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
          // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

          if (isAndroid) {
            location.href = 'androidamap://navi?sourceApplication=\u5C0F\u9CB2\u8F66\u670D&lat=' + lat + '&lon=' + lng + '&dev=0&style=2';
          } else {
            location.href = 'iosamap://navi?sourceApplication=\u5C0F\u9CB2\u8F66\u670D&lat=' + lat + '&lon=' + lng + '&dev=0&style=2';
          }
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }, {
    text: '百度地图',
    abled: true,
    onClick: function onClick() {
      if (tuhu.device.isApp) {
        if (tuhu.device.tuhuAndroid) {
          // android
          tuhu.actionWithNative('checkThirdApp', { package: BAIDU_PACKAGE }).then(function (res) {
            if (res === '0') {
              tuhu.getLocate().then(function (from) {
                var url = direction(data, from);
                location.href = url;
              });
            } else if (res === '1') {
              bdSchemeJump(data);
            } else if (res === '2') {
              // 未通过白名单
              tuhu.getLocate().then(function (from) {
                var url = direction(data, from);
                location.href = url;
              });
            } else {}
          });
        } else {
          // ios
          tuhu.actionWithNative('checkThirdApp', { url: BAIDU_SCHEME }).then(function (res) {
            if (res.result) {
              bdSchemeJump(data);
            } else {
              tuhu.getLocate().then(function (from) {
                var url = direction(data, from);
                location.href = url;
              });
            }
          });
        }
      } else {
        bdSchemeJump(data);
      }
    }
  }];
  var buttons2 = [{
    text: '取消'
  }];

  var groups = [buttons1.filter(function (item) {
    return item.abled;
  }), buttons2];
  tuhu.actions(groups);
}

function gaodeH5Jump(lng, lat) {
  // 高德web跳转
  tuhu.getLocate().then(function (from) {
    transformLocate(from.longitude, from.latitude).then(function (res) {
      var url = 'https://uri.amap.com/navigation?from=' + res.lng + ',' + res.lat + ',\u6211\u7684\u4F4D\u7F6E&to=' + lng + ',' + lat + ',\u95E8\u5E97&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0';
      location.href = url;
    });
  });
}

function bdSchemeJump(data) {
  // 百度地图scheme跳转
  tuhu.getLocate().then(function (from) {
    var u = window.navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;

    if (isAndroid) {
      // location.href = `bdapp://map/navi?location=${data.lat},${data.lng}&src=andr.baidu.tuhu`
      location.href = 'baidumap://map/direction?origin=' + from.latitude + ',' + from.longitude + '&destination=' + data.lat + ',' + data.lng + '&mode=driving&region=' + from.city;
    } else {
      location.href = 'baidumap://map/navi?location=' + data.lat + ',' + data.lng + '&type=BLK&src=ios.baidu.tuhu';
    }
  });
}

function transformLocate(blng, blat) {
  return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    return tuhu.fetchJsonp('https://restapi.amap.com/v3/assistant/coordinate/convert?locations=' + blng + ',' + blat + '&coordsys=baidu&output=JSON&key=e1a4e5f544003203fdb8ddb9f0f8062f').then(function (res) {
      return res.json();
    }).then(function (res) {
      var _res$locations$split = res.locations.split(','),
          _res$locations$split2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_res$locations$split, 2),
          lng = _res$locations$split2[0],
          lat = _res$locations$split2[1];

      lng = (lng - 0).toFixed(6);
      lat = (lat - 0).toFixed(6);

      resolve({ lng: lng, lat: lat });
    });
  });
}

function direction(data, from) {
  var urlParams = tuhu.util.query2Str({
    origin: 'latlng:' + from.latitude + ',' + from.longitude + '|name:我的位置',
    destination: 'latlng:' + data.lat + ',' + data.lng + '|name:' + data.name,
    mode: 'driving',
    region: from.province,
    output: 'html',
    src: '小鲲车服'
  });

  return 'https://api.map.baidu.com/direction' + urlParams;
}

function locateTo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (tuhu.device.isWeixin) {
    return __WEBPACK_IMPORTED_MODULE_8__wxconfig__["a" /* default */].share().then(function () {
      return tuhu.fetchJsonp('https://apis.map.qq.com/ws/coord/v1/translate?locations=' + data.lat + ',' + data.lng + '&type=3&output=jsonp&key=FQBBZ-RC5K4-E4CU3-XMZ43-4QEHZ-EZB5X').then(function (res) {
        return res.json();
      });
    }).then(function (res) {
      var coverData = res.locations[0];
      window.wx.openLocation({
        latitude: coverData.lat, // 纬度，浮点数，范围为90 ~ -90
        longitude: coverData.lng, // 经度，浮点数，范围为180 ~ -180。
        name: data.name, // 位置名
        address: data.address, // 地址详情说明
        scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    }).catch(function (e) {
      tuhu.navigateTo({
        url: '/pages/_locate/index',
        query: data
      });
    });
  }

  tuhu.navigateTo({
    url: '/pages/_locate/index',
    query: data
  });
}

function getSelectedCity() {
  var result = null;

  try {
    result = JSON.parse(tuhu.localStorage.getItem(SELECT_KEY));
  } catch (e) {}

  return result;
}

var Locate = function () {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Locate, null, [{
    key: 'getIpLocate',
    value: function getIpLocate(options) {
      var instance = new Locate(options);

      return instance.getH5Location();
    }
  }, {
    key: 'getCurLocate',
    value: function getCurLocate() {
      var instance = new Locate();

      return instance.getCurLocation();
    }
  }, {
    key: 'selectCity',
    value: function selectCity(selectedInfo) {
      tuhu.navigateBack();
      var city = selectedInfo.city || selectedInfo.City;
      var district = selectedInfo.district || selectedInfo.District || '';

      tuhu.getLocate().then(function (locationInfo) {
        var allSaveLocate = {
          latitude: locationInfo.latitude || '',
          longitude: locationInfo.longitude || '',
          currentProvince: locationInfo.currentProvince,
          currentCity: locationInfo.currentCity,
          currentDistrict: locationInfo.currentDistrict,
          province: selectedInfo.province || selectedInfo.Province,
          city: city,
          district: city === district ? '' : district,
          info: locationInfo.info || ''
        };

        tuhu.store && tuhu.store.commit('setLocationInfo', {
          locationInfo: allSaveLocate
        });

        tuhu.localStorage.setItem(SELECT_KEY, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
          province: allSaveLocate.province,
          city: allSaveLocate.city,
          district: allSaveLocate.district,
          latitude: locationInfo.latitude || '',
          longitude: locationInfo.longitude || ''
        }));
      });
    }
  }, {
    key: 'getLocate',
    value: function getLocate(options) {
      var instance = new Locate(options);

      return instance.getLocate();
    }
  }]);

  function Locate() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Locate);

    this.options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
      ipLocation: true,
      checkLocation: false,
      commit: true,
      refresh: false,
      updateStore: false
    }, options);

    if (!allowed && !options.ipLocation && lastOptions.ipLocation) {
      locatePromise = null;
    }

    if (options.refresh) {
      locatePromise = null;
    }
  }

  // _detailData(res, resolve) {
  //   const formData = new FormData()
  //   formData.append('longitude', res.longitude)
  //   formData.append('latitude', res.latitude)

  //   tuhu.fetch(CONVER_BAIDU, {
  //     method: 'POST',
  //     body: formData
  //   }, {
  //     status: false
  //   }).then((data) => {
  //     return data.result[0]
  //   }).then((data) => {
  //     return this._detailData(data).then((data) => {
  //       resolve(data)
  //     })
  //   })
  // }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Locate, [{
    key: '_detailInfo',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(lng, lat) {
        var formData, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();

                formData.append('longitude', lng);
                formData.append('latitude', lat);

                _context.next = 5;
                return tuhu.fetch(CONVER_BAIDU, {
                  method: 'POST',
                  body: formData
                }, {
                  status: false
                }).then(function (data) {
                  return data.result[0];
                });

              case 5:
                data = _context.sent;


                formData = new FormData();
                formData.append('longitude', data.x);
                formData.append('latitude', data.y);

                return _context.abrupt('return', tuhu.fetch(SELECT_MAP, {
                  method: 'POST',
                  body: formData
                }, {
                  status: false
                }).then(function (data) {
                  var ret = data.result;

                  return {
                    latitude: ret.location.lat,
                    longitude: ret.location.lng,
                    province: ret.address_component.province,
                    city: ret.address_component.city,
                    district: ret.address_component.district,
                    info: ret.formatted_addresses && ret.formatted_addresses.recommend || ret.formatted_addresses
                  };
                }));

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _detailInfo(_x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return _detailInfo;
    }()

    // _getWxLocation() {
    //   return WxConfig.share(['getLocation', 'openLocation']).then(() => {
    //     return new Promise((resolve, reject) => {
    //       window.wx.getLocation({
    //         type: 'wgs84',
    //         success: (res) => {
    //           this._detailData(res, resolve)
    //         },
    //         fail: function (e) {
    //           console.error('微信获取位置失败', e)
    //           resolve(null)
    //         },
    //         cancel: function (e) {
    //           console.error('微信获取位置取消', e)
    //           resolve(null)
    //         }
    //       })
    //     })
    //   }).catch((e) => {
    //     return Promise.resolve(null)
    //   })
    // }

    // _getGaode() {
    //   return new Promise((resolve, reject) => {
    //     const map = new window.AMap.Map('map')

    //     function onComplete(data) {
    //       try {
    //         const locationInfo = {}

    //         locationInfo.province = data.addressComponent.province
    //         locationInfo.city = data.addressComponent.city || data.addressComponent.province
    //         locationInfo.district = data.addressComponent.district
    //         locationInfo.info = data.formattedAddress
    //         locationInfo.latitude = data.position.lat
    //         locationInfo.longitude = data.position.lng

    //         resolve(locationInfo)
    //       } catch (e) {
    //         reject(e)
    //       }
    //     }

    //     function onError(data) {
    //       reject(data)
    //     }

    //     map.plugin('AMap.Geolocation', () => {
    //       const geolocation = new window.AMap.Geolocation({
    //         enableHighAccuracy: true,
    //         timeout: 10000,
    //         maximumAge: 0,
    //         convert: true,
    //         showButton: true,
    //         buttonPosition: 'LB',
    //         buttonOffset: new window.AMap.Pixel(10, 20),
    //         showMarker: true,
    //         showCircle: true,
    //         panToLocation: true,
    //         zoomToAccuracy: true
    //       })

    //       map.addControl(geolocation)
    //       window.AMap.event.addListener(geolocation, 'complete', onComplete)
    //       window.AMap.event.addListener(geolocation, 'error', onError)

    //       geolocation.getCurrentPosition()
    //     })
    //   })
    // }

    // _getH5Location() {
    //   return new Promise((resolve, reject) => {
    //     navigator.geolocation.getCurrentPosition((position) => {
    //       this._detailData(position.coords, resolve)
    //     }, (e) => {
    //       console.error('调用h5 navigator.geolocation 失败：', e)
    //       resolve(null)
    //     })
    //   })
    // }

  }, {
    key: 'getH5Location',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        var src, iframe;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                src = '/static/locate.html';

                if (location.host.indexOf('xiaokunkeji') > 0) {
                  src = location.origin + '/user/vue/locate.html';
                }

                iframe = $('<iframe\n\t\t\t\t\t\tstyle="width:100px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\tbackground:#fff;\n\t\t\t\t\t\tz-index:9999;\n\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\toverflow:hidden;\n\t\t\t\t\t\tborder-radius: 5px;"\n\t\t\t\t\t\tname="iframe"\n\t\t\t\t\t\tsrc="' + src + '"></iframe>');


                $(document.body).append(iframe);
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  tuhu.showIndicator();

                  window._locateIframePromise = {
                    resolve: resolve,
                    reject: reject
                  };
                }).then(function (ret) {
                  tuhu.hideIndicator();

                  iframe.remove();
                  if (!ret.addressComponent.district && !_this.options.ipLocation) {
                    return null;
                  }

                  allowed = !!ret.addressComponent.district;

                  var info = {
                    latitude: ret.position.lat,
                    longitude: ret.position.lng,
                    province: ret.addressComponent.province,
                    city: ret.addressComponent.city,
                    district: ret.addressComponent.district,
                    info: ret.formattedAddress
                  };

                  return info;
                }).catch(function (e) {
                  iframe.remove();
                  return null;
                }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getH5Location() {
        return _ref2.apply(this, arguments);
      }

      return getH5Location;
    }()
  }, {
    key: 'getAppLocation',
    value: function getAppLocation() {
      var locatePromise = null;

      if (locatePromise) {
        return locatePromise;
      } else {
        return this.getNativeLocation();
      }
    }
  }, {
    key: 'getNativeLocation',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var nativeLocPromise;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return tuhu.actionWithNative('locate');

              case 2:
                nativeLocPromise = _context3.sent;

                if (nativeLocPromise) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return', this.getH5Location());

              case 5:
                return _context3.abrupt('return', nativeLocPromise);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getNativeLocation() {
        return _ref3.apply(this, arguments);
      }

      return getNativeLocation;
    }()
  }, {
    key: 'getAppCurLocation',
    value: function getAppCurLocation() {
      if (tuhu.device.tuhuAndroid) {
        return tuhu.actionWithNative('getUserInfo');
      } else {
        return tuhu.actionWithNative('deviceDetail');
      }
    }
  }, {
    key: 'getH5CurLocation',
    value: function getH5CurLocation() {
      return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          resolve(JSON.parse(tuhu.localStorage.getItem(SELECT_KEY)));
        } catch (e) {
          resolve(null);
        }
      });
    }
  }, {
    key: 'getCurLocation',
    value: function getCurLocation() {
      if (!curLocatePromise) {
        if (tuhu.device.isApp) {
          var isTuhuAndroid = tuhu.device.tuhuAndroid;
          curLocatePromise = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.all([this.getAppCurLocation(), this.getAppLocation()]).then(function (data) {
            var curLocation = isTuhuAndroid ? data[0] : data[0].raw;
            var isSameCity = data[1] && (isTuhuAndroid ? curLocation.userCity : curLocation.city) === data[1].city;
            if (isSameCity) {
              return data[1];
            } else {
              if (isTuhuAndroid) {
                curLocation.city = curLocation.userCity;
                curLocation.province = curLocation.userProvince;
                curLocation.district = '';
                curLocation.latitude = curLocation.lat || '';
                curLocation.longitude = curLocation.lng || '';
              } else {
                var _curLocation$location = curLocation.location.split(','),
                    _curLocation$location2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_curLocation$location, 2),
                    latitude = _curLocation$location2[0],
                    longitude = _curLocation$location2[1];

                curLocation.latitude = latitude;
                curLocation.longitude = longitude;
              }
              return curLocation;
            }
          });
        } else {
          curLocatePromise = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.all([this.getH5CurLocation(), this.getH5Location()]).then(function (data) {
            if (data[0]) {
              if (data[0].city === data[1].city) {
                return data[1];
              } else {
                return data[0];
              }
            } else {
              return data[1];
            }
          });
        }
      }

      return curLocatePromise.catch(function (e) {
        console.error(e);
        curLocatePromise = null;
        return null;
      });
    }
  }, {
    key: 'getLocate',
    value: function getLocate() {
      var _this2 = this;

      if (!locatePromise) {
        var lng = tuhu.getParam('_longitude');

        var info = JSON.parse(sessionStorage.getItem('LOCATION_INFO') || null);
        if (info) {
          tuhu.store.commit('setLocationInfo', info);
          return info;
        }

        if (lng) {
          locatePromise = this._detailInfo(lng, tuhu.getParam('_latitude'));
        } else if (tuhu.device.isApp) {
          locatePromise = this.getAppLocation();
        } else {
          locatePromise = this.getH5Location();
        }
      }

      return locatePromise.then(function (locationInfo) {
        var promise = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a.resolve();
        var selectedInfo = getSelectedCity();

        var currentLocate = locationInfo && {
          currentProvince: locationInfo.province || '',
          currentCity: locationInfo.city || '',
          currentDistrict: locationInfo.district || ''
        };

        if (selectedInfo && _this2.options.commit) {
          if (_this2.options.checkLocation && locationInfo && locationInfo.district && locationInfo.city !== selectedInfo.city) {
            promise = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              tuhu.confirm('\u4F60\u5F53\u524D\u57CE\u5E02\u662F' + locationInfo.city + '\uFF0C\u662F\u5426\u5207\u6362\u5230\u5F53\u524D\u4F4D\u7F6E', '温馨提示', function () {
                tuhu.localStorage.removeItem(SELECT_KEY);

                resolve();
              }, function () {
                locationInfo = {
                  latitude: locationInfo && locationInfo.latitude || '',
                  longitude: locationInfo && locationInfo.longitude || '',
                  province: selectedInfo.province,
                  city: selectedInfo.city,
                  district: selectedInfo.city === selectedInfo.district ? '' : selectedInfo.district,
                  info: locationInfo.info
                };
                resolve();
              });
            });
          } else {
            locationInfo = {
              latitude: locationInfo && locationInfo.latitude || '',
              longitude: locationInfo && locationInfo.longitude || '',
              province: selectedInfo.province,
              city: selectedInfo.city,
              district: selectedInfo.city === selectedInfo.district ? '' : selectedInfo.district,
              info: locationInfo.info
            };
          }
        }

        return promise.then(function () {
          if (currentLocate) {
            locationInfo = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(locationInfo, currentLocate);
          }

          if (_this2.options.commit && tuhu.getCurrentPages().length < 1) {
            _this2.options.updateStore = true;
          }

          var info = {
            locationInfo: locationInfo,
            force: _this2.options.updateStore
          };

          tuhu.sessionStorage.setItem('LOCATION_INFO', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(info));

          _this2.options.commit && tuhu.store && tuhu.store.commit('setLocationInfo', info);
          return locationInfo;
        });
      }).catch(function (e) {
        console.error(e);
        locatePromise = null;
        return null;
      });
    }
  }]);

  return Locate;
}();

Locate.nativeMap = nativeMap;
Locate.locateTo = locateTo;

/* harmony default export */ __webpack_exports__["a"] = (Locate);

/***/ }),

/***/ "Kg3z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Khs+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kj3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-dialog',{staticClass:"custormTips4",attrs:{"showConfirmButton":false},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('p',{staticClass:"title"},[_vm._v("重要税务公告")]),_vm._v(" "),_c('div',{staticClass:"t-content"},[_c('p',{staticClass:"name"},[_vm._v("尊敬的平台用户:")]),_vm._v(" "),_c('div',{staticClass:"text-content",on:{"scroll":_vm.handleScroll}},[_vm._v("\n        根据"),_c('span',{staticStyle:{"color":"#006EEF"},on:{"click":_vm.open}},[_vm._v("国家税务总局2025年第16号公告")]),_vm._v("要求，自2025年10月1日起，您在小鲲车服取得的收入，将由平台合作方按规定进行个人所得税预扣预缴及增值税代办申报。"),_c('br'),_vm._v("\n        具体说明"),_c('br'),_vm._v("\n        Q1.从什么时候开始预扣个税?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:根据政策要求，从2025年10月1日起开始预扣并于次月进行申报和预缴。"),_c('br')]),_vm._v("\n        Q2.个税是怎么计算的?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:应纳税所得金额=年累计收入金额x80%-5000元x连续收入月数，根据应纳税所得额按3%-45%的税率预缴个税。"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("如每月收入都低于"),_c('strong',{staticStyle:{"font-size":"large"}},[_vm._v("6250")]),_vm._v("元，则不需要预扣个税。如月平均收入高于"),_c('strong',{staticStyle:{"font-size":"large"}},[_vm._v("6250")]),_vm._v("元，则按照以上方法预扣。")]),_vm._v("举例:服务人员6月收入7000元，7月收入7500元，那么每个月个税按照如下方法计算:6月:[7000x(1-20%)-5000]x3%=18元:7月:[(7000+7500)x(1-20%)-5000x2]x3%-18=30元;以此类推。注意:如果某个月未产生收入，再次获取收入时，重新累计全年收入总额和连续收入月数。"),_c('br')]),_vm._v("\n        Q3.在哪里可以看到缴税记录?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:手机端下载个人所得税APP，预扣税款后的次月下旬可以在APP上查询。"),_c('br')]),_vm._v("\n        Q4:我怎么查不到个税缴纳记录?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:预扣税款后的次月下旬可以在APP上查询。举例:10月预扣的个税，可以于11月下旬在个人所得税\n          APP上查询。"),_c('br')]),_vm._v("\n        Q5.如何获取个人所得税纳税记录(原完税证明)?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:手机端下载&登录个人所得税APP，首页底部【办&查】模块，点击【纳税记录开具】，即可生成纳税记录(原完税证明)。"),_c('br')]),_vm._v("\n        Q6.我在平台上取得的收入能不能不缴纳个税?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:不能。为响应国家税务政策要求，自10月1日起平台合作方将对个人获取的收入按劳务报酬进行累计预扣税。此举是为更合规地履行代扣代缴义务请您理解。"),_c('br')]),_vm._v("\n        Q7.我在其他平台也有收入，会合并计税吗?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:每月预扣时不会，每月各平台会根据从业人员收入分别计算和预扣预缴个税。次年3-6月需个人在个人所得税APP上对各平台所有收入做汇算清缴。"),_c('strong',[_vm._v("（每个月各个平台核算个税的时候不会合并计算，各个平台收入在月度是单独预扣交税，到第二年3-6月，由本人在个税APP上自行做年度汇算清缴，对所有平台收入做汇总核算，多退少补）")]),_c('br')]),_vm._v("\n        Q8.我的个税好像比以前扣的多了?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:当个人累计预扣预缴应纳所得额超过36000元后，预扣率会从3%变为10%。"),_c('br')]),_vm._v("\n        Q9.增值税如何处理?"),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-answer"},[_vm._v("\n          A:从业人员一个月度内一个或者多个平台合计收入少于小规模纳税人增值税免税标准(目前是10万元)的，免增值税。一个月度内自两个以上互联网平台企业取得服务收入合计超过小规模纳税人增值税免税标准(目前是10万元)的，于取得收入的次次月、按照约1.06%补缴增值税及附加。"),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"t-btns-box"},[_c('div',{staticClass:"t-btns",class:{ disabled: _vm.countdown > 0 },on:{"click":_vm.handleClose}},[_vm._v("\n        "+_vm._s(_vm.countdown > 0
            ? ("我已阅读税务公告(" + _vm.countdown + "s)")
            : "我已阅读税务公告")+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KpUx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content",attrs:{"id":"_content"}},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","src":_vm.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KuuQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hu.a2d301b.png";

/***/ }),

/***/ "L1w5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/5ab");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108bb751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("bL+R");
function injectStyle (ssrContext) {
  __webpack_require__("s5X+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-108bb751"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108bb751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "L5f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"content"},[_c('div',{ref:"agreementRef",staticClass:"agreement",attrs:{"id":"agreementId"}},[_c('img',{attrs:{"src":_vm.fileUrl1},on:{"click":function($event){return _vm.showImagePreview(0)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.fileUrl2},on:{"click":function($event){return _vm.showImagePreview(1)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.fileUrl3},on:{"click":function($event){return _vm.showImagePreview(2)}}}),_vm._v(" "),_c('img',{ref:"signImage",attrs:{"src":_vm.assignSignUrl},on:{"click":function($event){return _vm.showImagePreview(3)}}})]),_vm._v(" "),_c('div',{staticClass:"confirmBox"},[_c('div',{staticClass:"assignBox"},[_c('div',{staticClass:"assign-cont"},[(_vm.signatureUrl)?_c('div',{staticClass:"assign-tip"},[_c('div',{staticClass:"reWrite",on:{"click":function($event){_vm.isShowSignPad = true}}},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2025/11/24/6c46d1d2fa2f40f199b709185b80f9e7.png"}}),_vm._v("重绘\n            ")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.signatureUrl,"alt":""}})]):_c('div',{staticClass:"assign-text",on:{"click":function($event){_vm.isShowSignPad = true}}},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2025/11/24/6c46d1d2fa2f40f199b709185b80f9e7.png"}}),_vm._v("手绘签名\n          ")])]),_vm._v(" "),_c('p',{staticStyle:{"color":"#808080","text-align":"center","font-size":"0.6rem"}},[_vm._v("在手机屏幕上绘制本人真实姓名的个人签名")])]),_vm._v(" "),_c('div',{staticClass:"assign-btn",style:(_vm.btnStyle),on:{"click":_vm.submit}},[_vm._v("\n        提交申请\n      ")])])]),_vm._v(" "),_c('signPad',{attrs:{"isShow":_vm.isShowSignPad},on:{"close":_vm.close}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LHxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "LJFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"search-page"},[_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"},{name:"focus",rawName:"v-focus"}],ref:"search",attrs:{"placeholder":_vm.DefaultSearchKeyWord && _vm.DefaultSearchKeyWord.Keywords,"type":"search"},domProps:{"value":(_vm.value)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)},"blur":_vm.iosCompatible,"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}}),_vm._v(" "),(_vm.value)?_c('div',{staticClass:"search-button",on:{"click":_vm.submit}},[_vm._v("搜索")]):_c('div',{staticClass:"search-button",on:{"click":_vm.hindleBack}},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"search-content"},[_c('div',{staticClass:"search-hot"},[_c('div',{staticClass:"hot-title"},[_vm._v("热门搜索")]),_vm._v(" "),_vm._l((_vm.hotSearchKeyWord),function(item,index){return _c('div',{key:index,staticClass:"hot-word",on:{"click":function($event){return _vm.hindleClickHistory(item)}}},[_vm._v("\n          "+_vm._s(item)+"\n        ")])})],2),_vm._v(" "),(!_vm.userInfo.islogin)?_c('div',{staticClass:"search-history"},[_c('div',{staticClass:"history-title"},[_vm._v("历史搜索")]),_vm._v(" "),_c('div',{staticClass:"login-button",on:{"click":function($event){$event.stopPropagation();return _vm.tologin($event)}}},[_vm._v("点击登录 查看历史搜索记录")])]):_c('div',{staticClass:"search-history"},[_c('div',{staticClass:"history-title"},[_vm._v("历史搜索")]),_vm._v(" "),_vm._l((_vm.historys),function(item,index){return _c('tuhu-swipeout',{key:item.Word,on:{"onDelete":function($event){return _vm.handleDelect(item ,index)}}},[_c('div',{staticClass:"history-word",on:{"click":function($event){$event.stopPropagation();return _vm.hindleClickHistory(item.Word)}}},[_c('div',{staticClass:"word"},[_vm._v(_vm._s(item.Word))]),_vm._v(" "),_vm._l((item.KeyWordBrands),function(item2){return _c('div',{key:item2,staticClass:"brands",on:{"click":function($event){$event.stopPropagation();return _vm.hindleClickHistory(("" + item2 + (item.Word)))}}},[_vm._v("\n              "+_vm._s(item2)+"\n            ")])})],2)])}),_vm._v(" "),(_vm.historys && _vm.historys.length>0)?_c('div',{staticClass:"history-button",on:{"click":_vm.handleDelect}},[_vm._v("清空历史搜索记录")]):_c('div',{staticClass:"no-history"},[_vm._v("没有历史记录")])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LOZ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LP6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            bankName: '',
            bankList: [],
            cachBankList: [] // 缓存门店列表
        };
    },
    created: function created() {
        this.init();
    },
    mounted: function mounted() {
        var _this = this;

        this.$watch('bankName', tuhu.util.debounce(function (newVal, oldVal) {
            if (newVal.trim() === oldVal.trim()) return;
            if (!_this.cachBankList.length) return;

            _this.bankList = _this.cachBankList.filter(function (item) {
                return item.text.indexOf(newVal) > -1;
            });
        }, 200));
    },

    methods: {
        init: function init() {
            var bankList = tuhu.sessionStorage.getItem('bankList');
            if (bankList) {
                this.bankList = JSON.parse(bankList);
                this.cachBankList = JSON.parse(bankList);
            } else {
                this.getBankList();
            }
        },
        getBankList: function getBankList() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_BANK_LIST + '?level=1&type=3');

                            case 3:
                                data = _context.sent;

                                if (data && data.code === '200') {
                                    _this2.bankList = data.data;
                                    _this2.cachBankList = data.data;
                                    tuhu.sessionStorage.setItem('bankList', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.data));
                                } else {
                                    console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_BANK_LIST, data.message);
                                    tuhu.toast(data.message || '网络错误');
                                }
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context['catch'](0);

                                console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_BANK_LIST, _context.t0);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[0, 7]]);
            }))();
        },
        clickBank: function clickBank(item) {
            tuhu.store.commit('setBankInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item));
            setTimeout(function () {
                tuhu.navigateBack();
            }, 80);
        }
    }
});

/***/ }),

/***/ "LWIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_util__ = __webpack_require__("sEZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      copyContent: "",
      invoiceInfo: {
        invoiceTitle: {
          label: "发票抬头：",
          value: ""
        },
        invoiceTaxNumber: {
          label: "纳税识别号：",
          value: ""
        },
        invoiceType: {
          label: "开票类型：",
          value: ""
        },
        invoiceSubject: {
          label: "开票科目：",
          value: ""
        },
        invoicePoint: {
          label: "开票税点：",
          value: ""
        },
        invoiceBankAccount: {
          label: "银行账户：",
          value: ""
        },
        invoiceBankName: {
          label: "开户银行：",
          value: ""
        },
        invoiceAddress: {
          label: "联系地址：",
          value: ""
        },
        invoicePhone: {
          label: "联系方式：",
          value: ""
        }
      }
    };
  },
  created: function created() {
    this.init();
  },

  computed: {
    shopId: function shopId() {
      return tuhu.store.state.userInfo.shopId;
    }
  },
  methods: {
    onCopy: function onCopy(e) {
      tuhu.toast("复制成功");
    },
    onError: function onError() {
      tuhu.toast("复制失败");
    },
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formdata, res, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formdata = new FormData();

                formdata.append("shopId", parseInt(_this.shopId)); // 文件对象
                _context.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.INVOICE_INFO + "?shopId=" + parseInt(_this.shopId));

              case 4:
                res = _context.sent;

                if (res && res.code === "200") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.invoiceInfo).forEach(function (key) {
                    if (res.data.hasOwnProperty(key)) {
                      _this.invoiceInfo[key].value = res.data[key];
                    }
                  });
                  data = res.data;

                  console.log(data.invoiceTitle);
                  _this.copyContent = "\u53D1\u7968\u62AC\u5934\uFF1A" + data.invoiceTitle + "\n\u7EB3\u7A0E\u8BC6\u522B\u53F7\uFF1A" + data.invoiceTaxNumber + "\n\u5F00\u7968\u7C7B\u578B\uFF1A" + data.invoiceType + "\n\u5F00\u7968\u79D1\u76EE\uFF1A" + data.invoiceSubject + "\n\u5F00\u7968\u7A0E\u70B9\uFF1A" + data.invoicePoint + "\n\u94F6\u884C\u8D26\u6237\uFF1A" + data.invoiceBankAccount + "\n\u5F00\u6237\u94F6\u884C\uFF1A" + data.invoiceBankName + "\n\u8054\u7CFB\u5730\u5740\uFF1A" + data.invoiceAddress + "\n\u8054\u7CFB\u65B9\u5F0F\uFF1A" + data.invoicePhone;
                } else {
                  tuhu.toast(res.message || "网络错误");
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "Lk/r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LxrK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"inWrap"},[_c('div',{staticClass:"header"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"userInfo"},[_c('div',{staticClass:"name"},[_c('div',{staticClass:"nameinput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],attrs:{"type":"number","placeholder":"请输入手机号","maxlength":"11","readonly":_vm.phoneReadonly},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.phone.length > 0 && !_vm.phoneReadonly),expression:"phone.length > 0 && !phoneReadonly"}],staticClass:"clear",on:{"click":function($event){return _vm.clear('phone')}}})])]),_vm._v(" "),_c('div',{staticClass:"yanzhengma"},[_c('div',{staticClass:"yzminput"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],attrs:{"type":"number","placeholder":"请输入验证码","maxlength":"4","readonly":_vm.readonly},domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.code.length > 0),expression:"code.length > 0"}],staticClass:"clear",on:{"click":function($event){return _vm.clear('code')}}})]),_vm._v(" "),_c('div',{class:'getyzm ' + _vm.yzmClass,domProps:{"textContent":_vm._s(_vm.codeText)},on:{"click":_vm.getCode}})])]),_vm._v(" "),_c('div',{class:'loginBtn ' + _vm.codeClass,on:{"click":_vm.signIn}},[_vm._v("\n      登录\n    ")])]),_vm._v(" "),_c('div',{directives:[{name:"call",rawName:"v-call",value:('400-176-8848'),expression:"'400-176-8848'"}],staticClass:"bottom-content"},[_vm._v("没收到验证码？咨询客服"),_c('span',[_vm._v("400-176-8848")])]),_vm._v(" "),_c('Verify',{ref:"verify",attrs:{"captcha-type":'blockPuzzle',"img-size":{ width: '300px', height: '150px' },"vSpace":20,"phone":_vm.phone},on:{"success":_vm.getCodeSuccess}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("Ty83"),"width":"100%"}}),_vm._v(" "),_c('div',{staticClass:"logo-desc"},[_vm._v("欢迎使用商户管理平台")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M2dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","src":_vm.url}}),_vm._v(" "),_c('button',{staticClass:"close-btn",on:{"click":_vm.handleClose}},[_vm._v("×")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MQsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("iemT");









/**
 * author: 582196894@qq.com
 * desc: 小鲲路由
 * date: 2018/3/28 updated
 */



/** 常量 */
var EVENTS = {
  // pageLoadStart: 'pageLoadStart', // ajax 开始加载新页面前
  // pageLoadCancel: 'pageLoadCancel', // 取消前一个 ajax 加载动作后
  // pageLoadError: 'pageLoadError', // ajax 加载页面失败后
  // pageLoadComplete: 'pageLoadComplete', // ajax 加载页面完成后（不论成功与否）
  // pageAnimationStart: 'pageAnimationStart', // 动画切换 page 前
  pageAnimationEnd: 'pageAnimationEnd' // 动画切换 page 结束后
  // beforePageRemove: 'beforePageRemove', // 移除旧 document 前（适用于非内联 page 切换）
  // pageRemoved: 'pageRemoved' // 移除旧 document 后（适用于非内联 page 切换）
  // beforePageSwitch: 'beforePageSwitch' // page 切换前，在 pageAnimationStart 前，beforePageSwitch 之后会做一些额外的处理才触发 pageAnimationStart
  // pageInit: 'pageInitInternal' // 目前是定义为一个 page 加载完毕后（实际和 pageAnimationEnd 等同）


  /** 常量 */
};var ROUTER_CONFIG = {
  // sectionGroupClass: 'page-group',
  // 表示是当前 page 的 class
  curPageClass: 'page-current',
  // 用来辅助切换时表示 page 是 visible 的,
  // 之所以不用 curPageClass，是因为 page-current 已被赋予了「当前 page」这一含义而不仅仅是 display: block
  // 并且，别的地方已经使用了，所以不方便做变更，故新增一个
  // visiblePageClass: 'page-visible',
  // 表示是 page 的 class，注意，仅是标志 class，而不是所有的 class
  // pageClass: 'page',
  contentClass: '_content'

  /** 常量 */
};var SESSION_NAMES = {
  currentState: 'sm.router.currentState' + +new Date(),
  maxStateId: 'sm.router.maxStateId' + +new Date()

  /** 常量 */
};var DIRECTION = {
  leftToRight: 'from-left-to-right',
  rightToLeft: 'from-right-to-left'

  /** 生成唯一id */
};var _generateRandomId = function () {
  var ids = {};

  return function () {
    if (!ids[tabIndex]) {
      ids[tabIndex] = 0;
    }

    return ids[tabIndex]++;
  };
}();

/** 返回链 */
var backPromise = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a.resolve();

/** 后退锁 */
var lockBack = false;

/** 模块缓存 */
var tabLoaded = {};

/** 当前tab index */
var tabIndex = __WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].getParam('_tab', 'number') || 0;

/** 当前loadpage params */
var pageObj = null;

/** 当前loadpage config */
var pageOther = null;

/** 后退icon */
var backIcon = null;

/** 默认标题 */
var defaultTitle = '小鲲车服';

/** 一组路由跟随参数 */
var channel = __WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].getParam('_channel');

var uuid = __WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].getParam('_uuid');

var project = __WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].getParam('_project');

var longitude = __WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].getParam('_longitude');

var latitude = __WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].getParam('_latitude');

var myoptions = {};

var firstLoad = true;

var onPopState = function onPopState(event) {
  if (lockBack) {
    setTimeout(function () {
      lockBack = false;
    }, 300);
    return;
  }
  var state = event.state;
  // if not a valid state, do nothing todo
  if (!state || !state.pageId) {
    // ios 10系统前会自动调用onpopstate 暂时关闭
    // tuhu.actionWithNative('closeWebview')
    return;
  }

  var lastState = _getLastState();

  if (!lastState) {
    console.error && console.error('Missing last state when backward or forward');
    return;
  }

  if (state.id === lastState.id) {
    return;
  }

  if (state.pageId === lastState.pageId) {
    location.reload();
    return;
  }

  if (state.id < lastState.id) {
    back(state, lastState);
  }
};

/** state 操作方法开始 */
// const checkPageId = function (pageId) {
//   return tuhu.getCurrentPages().some((v) => {
//     return v.pageId === pageId
//   })
// }

var _getLastState = function _getLastState() {
  var currentState = tuhu.sessionStorage.getItem(SESSION_NAMES.currentState);
  try {
    currentState = JSON.parse(currentState);
  } catch (e) {
    currentState = null;
  }

  return currentState;
};

function _getNextStateId() {
  var maxStateId = tuhu.sessionStorage.getItem(SESSION_NAMES.maxStateId) || 1;

  return maxStateId - 0 + 1;
}

function _saveAsCurrentState(state) {
  tuhu.sessionStorage.setItem(SESSION_NAMES.currentState, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(state));
}

function _incMaxStateId() {
  tuhu.sessionStorage.setItem(SESSION_NAMES.maxStateId, _getNextStateId());
}
/** state 操作方法结束 */

/** 显示隐藏tab */
var tabBar = null;
function showTab(istab) {
  if (!tabBar) {
    tabBar = $('#tuhu-tabbar');
  }

  if (istab) {
    tabBar.addClass('show');
  } else {
    tabBar.removeClass('show');
  }
}

/** 设置标题 */
var titleDom = null;
function setTitle(instance) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTitle;

  if (!titleDom) {
    titleDom = $('#title .title');
  }

  if (instance && instance._setTitle) {
    instance._setTitle().then(function (pageTitle) {
      var realTitle = pageTitle && pageTitle !== 'undefined' ? pageTitle : title;
      document.title = realTitle;
      titleDom.html(realTitle);
    });
  } else {
    document.title = title;
    titleDom.html(title);
  }
}

/** 当前tab下页面 */
function getFilterPages() {
  return tuhu.getCurrentPages().filter(function (item) {
    return item.tab === tabIndex;
  });
}

/** 页面动画 */
function _animateElement($from, $to, direction) {
  if (typeof direction === 'undefined') {
    direction = DIRECTION.rightToLeft;
  }

  var animPageClasses = ['page-from-center-to-left', 'page-from-center-to-right', 'page-from-right-to-center', 'page-from-left-to-center'].join(' ');

  var classForFrom = void 0,
      classForTo = void 0;
  switch (direction) {
    case DIRECTION.rightToLeft:
      classForFrom = 'page-from-center-to-left';
      classForTo = 'page-from-right-to-center';
      break;
    case DIRECTION.leftToRight:
      classForFrom = 'page-from-center-to-right';
      classForTo = 'page-from-left-to-center';
      break;
    default:
      classForFrom = 'page-from-center-to-left';
      classForTo = 'page-from-right-to-center';
      break;
  }

  $from.removeClass(animPageClasses).addClass(classForFrom);
  $to.removeClass(animPageClasses).addClass(classForTo);

  $from.animationEnd(function () {
    $from.removeClass(animPageClasses);
  });
  $to.animationEnd(function () {
    $to.removeClass(animPageClasses);
  });
}

/** 启动页面动画 */
function _animateSection($from, $to, direction, resolve) {
  // var toId = $to.attr('id')
  // $from.trigger(EVENTS.beforePageSwitch, [$from.attr('id'), $from])
  $from.removeClass(ROUTER_CONFIG.curPageClass);
  $to.addClass(ROUTER_CONFIG.curPageClass);
  // $to.trigger(EVENTS.pageAnimationStart, [toId, $to])
  _animateElement($from, $to, direction);
  $to.animationEnd(function () {
    $to.trigger(EVENTS.pageAnimationEnd);
    // 外层（init.js）中会绑定 pageInitInternal 事件，然后对页面进行初始化
    // $to.trigger(EVENTS.pageInit, [toId, $to])
    resolve && resolve();
  });
}

/** 当前模块 当前页面 */
function _getCurrentSection() {
  return $('.page-group').eq(tabIndex).find('.' + ROUTER_CONFIG.curPageClass);
}

/** 当前模块 所有页面 */
function _getPages() {
  return $('.page-group').eq(tabIndex).find('.page[id^="_page_"]');
}

var touchStartTime = 0;
var touchEndTime = 0;

$(document.body).on('touchstart', function (ev) {
  touchStartTime = +new Date();
});

$(document.body).on('touchend', function (ev) {
  touchEndTime = +new Date();
});

function _back(state, fromState) {
  return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    setTimeout(resolve, 300);

    $.closeModal();

    var $newPage = $('#' + state.pageId);
    if ($newPage.length) {
      var $currentPage = $('#' + fromState.pageId);
      showTab(state.istab);

      if (!fromState.animation || touchEndTime - touchStartTime > 100) {
        setTimeout(function () {
          $currentPage.remove();
          $newPage.addClass(ROUTER_CONFIG.curPageClass);
          if (getFilterPages().length < 2) {
            backIcon.hide();
          }

          resolve();
        });
      } else {
        _animateSection($currentPage, $newPage, DIRECTION.leftToRight);
      }

      touchStartTime = 0;
      touchEndTime = 0;

      $newPage.on(EVENTS.pageAnimationEnd, function () {
        $currentPage.remove();
        if (getFilterPages().length < 2) {
          backIcon.hide();
        }

        resolve();
      });
      _saveAsCurrentState(state);

      var currentPages = tuhu.getCurrentPages();
      var lastItem = null;
      currentPages.some(function (citem, cindex) {
        if (citem.pageId === fromState.pageId) {
          citem.instance && citem.instance.$destroy();
          citem.instance = null;
          lastItem = citem;
          // currentPages.splice(cindex, 1)
          tuhu.delPage(cindex);
          return true;
        }

        return false;
      });

      currentPages.some(function (citem, cindex) {
        if (citem.pageId === state.pageId) {
          setTimeout(tuhu.hideIndicator);
          citem.instance.onPageBack && citem.instance.onPageBack(citem, lastItem);
          // setTitle(null, tuhu.config.pages[state.path].title)

          try {
            setTitle(null, tuhu.config.pages[state.path].title);
          } catch (e) {
            setTitle(null, state.title);
          }
          if (citem.instance.twiceShare) {
            citem.instance.twiceShare();
          }

          if (location.href.indexOf('.tuhu.') > -1) {
            Ta.ta('pv');
          }

          return true;
        }
      });
    } else {
      console.error('页面堆栈有误', '#' + state.pageId, tabLoaded);
    }
  });
}

function checkCar(carInfo, level) {
  if (!carInfo) {
    return false;
  }
  if (carInfo.noPailiang) {
    return true;
  }
  if (level <= 5) {
    if (carInfo.currentType < level) {
      return false;
    }
  } else if (level === 6) {
    if (!carInfo.TireSizeForSingle) {
      return false;
    }
  } else if (level === 8) {
    if (!carInfo.lunguType) {
      return false;
    }
  }

  return true;
}

function back(state, fromState) {
  backPromise = backPromise.then(function () {
    return _back(state, fromState);
  });
}

/** 载入页面锁 */
var loadLock = false;

/** 对比参数 */
var lastObj = {};

var promises = [];

var loadPromise = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a.resolve();

var beforeEachs = [];

var afterEachs = [];

// let lastVueInstance = null

var Router = function () {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Router, null, [{
    key: 'beforeEach',
    value: function beforeEach(callback) {
      beforeEachs.push(callback);
    }
  }, {
    key: 'afterEach',
    value: function afterEach(callback) {
      afterEachs.push(callback);
    }
  }, {
    key: 'switchTab',
    value: function switchTab(obj) {
      var other = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pagesDom = _getPages();

      if (other.tabIndex !== undefined) {
        tabIndex = other.tabIndex;
      }

      if (pagesDom.length > 1) {
        this.navigateBack({
          delta: pagesDom.length - 1
        });
      } else {
        if (tabLoaded[tabIndex]) {
          history.replaceState(tabLoaded[tabIndex].state, '', tabLoaded[tabIndex].url);
          setTitle(null, tabLoaded[tabIndex].state.title);

          if (tabLoaded[tabIndex].instance.twiceShare) {
            tabLoaded[tabIndex].instance.twiceShare();
          }
        } else {
          Router.loadPage(obj, {
            direct: true
          });
        }
      }
    }
  }, {
    key: 'realGoHome',
    value: function realGoHome() {
      tuhu.router.goHome(location.href.replace(/\/pages\/.+?([?&]|$)/, '/pages/home/index$1').replace(/_tab=\d/, ''));
    }
  }, {
    key: 'goHome',
    value: function goHome() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var delta = 0;

      tuhu.getCurrentPages().forEach(function (item, index) {
        if (!item.istab && item.tab === tabIndex) {
          delta++;
        }
      });

      window.removeEventListener('popstate', onPopState);

      if (tuhu.channel === 'xiaomi') {
        tuhu.sessionStorage.setItem('_tuhu_gohome', 1);

        history.go(-(history.length - 1));
      } else if (tuhu.device.isWeixin) {
        tuhu.sessionStorage.setItem('_tuhu_gohome', 1);

        history.go(-(history.length - 2));
      } else {
        history.go(-delta);

        setTimeout(function () {
          location.replace(url || tabLoaded[0].url);
        }, 100);
      }
    }
  }, {
    key: 'navigateBack',
    value: function navigateBack(obj) {
      obj = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        state: true,
        delta: 1,
        last: 1,
        params: {}
      }, obj);

      var filterPages = getFilterPages();
      var delta = obj.delta;

      if (delta >= 1) {
        var len = filterPages.length;
        var delId = 0;

        filterPages.forEach(function (item, index) {
          if (index >= len - delta && index < len - obj.last) {
            item.instance && item.instance.$destroy();
            item.instance = null;

            tuhu.delPage(item._id - delId++);
            if (index === len - obj.last - 1 && obj.last !== 1) {
              setTimeout(function () {
                $('#' + item.pageId).remove();
              }, 1000);
            } else {
              $('#' + item.pageId).remove();
            }
          }
        });

        lockBack = obj.last !== 1;
        if (!lockBack && filterPages.length > 1) {
          filterPages[filterPages.length - delta - 1].params = obj.params;
        }
        if (obj.state) {
          history.go(-delta);
        }
      }
    }
  }, {
    key: 'loadPage',
    value: function loadPage(obj, other) {
      if (obj.url.indexOf('http') === 0) {
        window.location.href = obj.url;
      }
      // if (tuhu.isLightApp) {
      //   // else if (obj.url === '/pages/personal/index') {
      //   //   system.go('/tuhupages/personal/home')
      //   // }
      //   // else if (obj.url.indexOf('/pages/chepin/detail') > -1) {
      //   //   system.postMessage(JSON.stringify({type: 'toProduct', data: other}))
      //   // }
      //   try {
      //     if (obj.url === '/pages/home/index' && (window.location.href.indexOf('https://wx.tuhu.cn/vue/wx') > -1 || window.location.href.indexOf('https://wx.tuhu.cn/vue/vueTest') > -1)) {
      //       system.go('/tuhupages/home/index?isH5=true')
      //     } else if (obj.url === '/pages/order/orderResult') {
      //       if (obj.query && obj.query.i) {
      //         system.go('tuhupages/order/orderResult?orderId=' + obj.query.i)
      //       }
      //     } else {
      //       pageObj = obj
      //       pageOther = other
      //       const instance = new Router(obj, other)
      //       instance.load()
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   }
      // } else {
      pageObj = obj;
      pageOther = other;
      var instance = new Router(obj, other);
      instance.load();
      // }
    }
  }, {
    key: 'loadFirstPage',
    value: function loadFirstPage() {
      if (pageObj) {
        Router.loadPage(pageObj, pageOther);
      } else {
        tuhu.redirectTo({
          url: tuhu.getPath(location.href),
          query: tuhu.getParams()
        });
      }
    }
  }, {
    key: 'loadModule',
    value: function loadModule(path) {
      tuhu.config.modules[path]();
    }
  }, {
    key: 'goPayRouter',
    value: function goPayRouter() {
      var sameOrigin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var delta = 0;
      var currentPages = tuhu.getCurrentPages();
      var hasTab = currentPages.some(function (item) {
        return item.istab;
      });
      if (hasTab) {
        currentPages.forEach(function (item, index) {
          if (!item.istab && item.tab === tabIndex) {
            delta++;
          }
        });
      } else {
        delta = currentPages.length - 1;
      }

      if (sameOrigin) {
        if (tuhu.device.isApp) {
          setTimeout(function () {
            history.go(-delta);

            setTimeout(function () {
              location.reload();
            }, 300);
          }, 50);
        } else {
          window.removeEventListener('popstate', onPopState);

          setTimeout(function () {
            history.go(-delta);
          }, 50);

          setTimeout(function () {
            tuhu.navigateBack({
              delta: delta + 1,
              state: false
            });
            window.addEventListener('popstate', onPopState);
          }, 100);
        }
      } else {
        window.removeEventListener('popstate', onPopState);
        history.go(-delta);
      }
    }
  }]);

  function Router() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var other = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Router);

    // this.redirected = false
    tuhu.util.clearObj(obj);
    tuhu.util.clearObj(other);

    this.obj = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
      data: {}
    }, obj);

    this.other = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, other);

    this.path = '';

    this.url = '';

    this.id = 0;

    this.pageId = '';

    this.vueInstance = null;

    this.options = null;

    this.query = {};

    this.error = false;

    this.direct = false;

    this.animation = true;

    this.istab = false;

    this.promise = null;

    this.resolve = null;

    try {
      this.init();
    } catch (e) {
      console.log('' + e.message);
      this.error = true;
    }
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Router, [{
    key: 'init',
    value: function init() {
      this.tooMore();

      this.setPath();

      this.setDirect();

      this.setIstab();

      this.setQuery();

      this.setOptions();

      this.setId();

      this.setPageId();

      this.setUrl();

      this.setAnimation();
    }
  }, {
    key: 'setDirect',
    value: function setDirect() {
      if (this.other.direct !== undefined) {
        this.direct = this.other.direct;
      }
    }
  }, {
    key: 'setAnimation',
    value: function setAnimation() {
      if (this.other.animation !== undefined) {
        this.animation = this.other.animation;
      }
    }
  }, {
    key: 'setIstab',
    value: function setIstab() {
      var _this = this;

      if (this.direct) {
        tuhu.config.tabs && tuhu.config.tabs.some(function (item, index) {
          if (_this.obj.url.indexOf(item.url) > -1) {
            _this.istab = true;

            if (tabIndex !== index) {
              tabIndex = index;

              $('.page-group').eq(tabIndex).show().siblings('.page-group').hide();
            }

            return true;
          }
        });
      }
    }
  }, {
    key: 'setQuery',
    value: function setQuery() {
      var query = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.obj.query, tuhu.getParams(this.obj.url));
      this.query = query;

      if (project) {
        query._project = project;
      }
      if (longitude) {
        query._longitude = longitude;
      }
      if (latitude) {
        query._latitude = latitude;
      }

      if (tuhu.config.tabs) {
        query._tab = tabIndex;
      }

      if (channel) {
        query._channel = channel;
      }

      if (uuid) {
        query._uuid = uuid;
      }

      this.cleanQuery();

      if (tuhu.config.mapParams) {
        query = tuhu.config.mapParams(query);
      }

      this.cleanQuery();
    }
  }, {
    key: 'cleanQuery',
    value: function cleanQuery() {
      var query = this.query;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(query).map(function (key) {
        if (query[key] === null || query[key] === undefined || query[key] === 'null' || query[key] === 'undefined') {
          delete query[key];
        }
      });
    }
  }, {
    key: 'resetVueInstance',
    value: function resetVueInstance() {
      var instance = this.options.vue.default;
      myoptions = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.query, this.obj.data);
      var myMixin = {
        beforeCreate: function beforeCreate() {
          this.options = myoptions;
        }
      };

      if (instance.mixins) {
        instance.mixins.unshift(myMixin);
      } else {
        instance.mixins = [myMixin];
      }

      this.vueInstance = instance;
    }
  }, {
    key: 'tooMore',
    value: function tooMore() {
      if (loadLock && this.obj.url === lastObj.url) {
        throw new Error('\u9875\u9762\u8FDE\u7EED\u8F7D\u5165');
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions() {
      this.options = tuhu.config.pages[this.path];

      if (!this.options) {
        Router.loadModule(this.path.split('/')[2]);
        throw new Error('\u52A0\u8F7D\u65B0\u6A21\u5757' + this.path);
      }
    }
  }, {
    key: 'setId',
    value: function setId() {
      this.id = _generateRandomId();
    }
  }, {
    key: 'setPageId',
    value: function setPageId() {
      this.pageId = '_page_' + tabIndex + '_' + this.id;
    }
  }, {
    key: 'setPath',
    value: function setPath() {
      var match = this.obj.url.match(/\/pages\/[\w-]+\/[\w-]+/);

      this.path = match ? match[0] : '/pages/home/index';
    }
  }, {
    key: 'setUrl',
    value: function setUrl() {
      var queryStr = tuhu.util.param(this.query);
      if (queryStr) {
        queryStr = '?' + queryStr;
      }
      this.url = location.pathname.replace(/pages\/.+/, '').replace(/\/$/, '') + this.path + queryStr;
    }
  }, {
    key: 'ta',
    value: function ta() {
      if (location.href.indexOf('.tuhu.') > -1) {
        Ta.ta('pv');
      }
    }
  }, {
    key: 'setPageLock',
    value: function setPageLock() {
      loadLock = true;
      setTimeout(function () {
        loadLock = false;
      }, 300);
    }
  }, {
    key: '_pushNewState',
    value: function _pushNewState() {
      var url = this.url;

      var state = {
        id: _getNextStateId(),
        istab: this.istab,
        pageId: this.pageId,
        title: this.options.title,
        animation: this.animation,
        path: this.path
      };

      if (this.istab && !tabLoaded[tabIndex]) {
        tabLoaded[tabIndex] = {
          state: state,
          url: url
        };
      }

      if (this.direct) {
        if (firstLoad) {
          firstLoad = false;
          history.replaceState(state, '', location.href);
        } else {
          history.replaceState(state, '', url);
        }
      } else {
        history.pushState(state, '', url);
      }

      _saveAsCurrentState(state);
      _incMaxStateId();
    }
  }, {
    key: 'pageDom',
    value: function pageDom() {
      var $curPage = _getCurrentSection();
      var $newPage = $('<div id="' + this.pageId + '" class="page ' + ROUTER_CONFIG.curPageClass + '"><div class="' + ROUTER_CONFIG.contentClass + '"></div></div>');

      if ($curPage.length < 1) {
        $('.page-group').eq(tabIndex).append($newPage);
      } else {
        $curPage.after($newPage);
      }

      return {
        newPage: $newPage,
        curPage: $curPage
      };
    }
  }, {
    key: 'vue',
    value: function vue(curPage, newPage) {
      var _this2 = this;

      var self = this;

      var vueConfig = {
        el: newPage.find('.' + ROUTER_CONFIG.contentClass)[0],
        mounted: function mounted() {
          if ($(this.$el).attr('class') !== ROUTER_CONFIG.contentClass) {
            throw Error('template\u7ED3\u6784\u9519\u8BEF \u8BF7\u6240\u6709\u7684\u6A21\u677F\u5185\u5BB9\u7528<div class="' + ROUTER_CONFIG.contentClass + '"></div>\u5305\u88F9');
          }
          if (self.direct) {
            !self.istab && tuhu._popPage();
            curPage.remove();

            self.resolve();
          } else {
            self.animation && _animateSection(curPage, newPage, DIRECTION.rightToLeft, self.resolve);
          }

          var instance = this.$children[0];

          // lastVueInstance = instance
          // if (self.options.vue.default.beforeRouteLeave) {
          //   lastVueInstance.beforeRouteLeave = self.options.vue.default.beforeRouteLeave.bind(lastVueInstance)
          // }

          setTitle(instance, self.options.title);
          tuhu._setCurrentPage(self.id, self.url, tabIndex, self.pageId, self.istab, instance, self.url);

          if (self.istab) {
            tabLoaded[tabIndex].instance = instance;
          }

          if (instance.twiceShare) {
            instance.twiceShare();
          }

          if (getFilterPages().length > 1) {
            backIcon.show();
          }
        },

        render: function render(h) {
          return h(_this2.vueInstance);
        }
      };

      if (tuhu.store) {
        vueConfig.store = tuhu.store;
      }

      new Vue(vueConfig);
    }
  }, {
    key: 'load',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.error) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                this.promise = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this3.resolve = function (data) {
                    afterEachs.forEach(function (callback) {
                      callback(_this3.obj, lastObj);
                    });

                    lastObj = _this3.obj;
                    resolve(data);
                  };
                });

                setTimeout(this.resolve, 300);

                promises.push(this.promise);

                return _context.abrupt('return', loadPromise.then(function () {
                  var promise = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a.resolve();
                  var routerConfig = _this3.options;
                  if (routerConfig.beforeEnter) {
                    promise = promise.then(function () {
                      return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        routerConfig.beforeEnter(_this3.obj, lastObj, resolve);
                      });
                    });
                  }

                  return promise;
                }).then(function (lastData) {
                  loadPromise = loadPromise.then(function () {
                    return _this3.promise;
                  });

                  if (promises[promises.length - 1] !== _this3.promise) {
                    _this3.resolve();
                    return;
                  }

                  var promise = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a.resolve(lastData);
                  beforeEachs.forEach(function (callback) {
                    promise = promise.then(function (data) {
                      if (data === false) {
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a.resolve(false);
                      }

                      return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                        callback(_this3.obj, lastObj, resolve);
                      });
                    });
                  });

                  return promise.then(function (data) {
                    if (data !== false) {
                      if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
                        return tuhu.navigateTo(data);
                      }
                      return _this3._load();
                    }
                  });
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _ref.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: '_load',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var startTime, userInfo, _userInfo, locationInfo, _startTime, carInfo, _forceCar, _carLevel, _carPage, _carInfo, _pageDom, curPage, newPage, iframe;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                $.closeModal();

                if (!this.options.forceLogin) {
                  _context2.next = 15;
                  break;
                }

                startTime = +new Date();
                _context2.next = 5;
                return tuhu.getUserInfo({
                  force: true,
                  direct: 1
                });

              case 5:
                userInfo = _context2.sent;

                if (!(+new Date() - startTime > 3000 && userInfo.islogin)) {
                  _context2.next = 10;
                  break;
                }

                tuhu.navigateBack({
                  delta: 1,
                  last: 0
                });

                _context2.next = 10;
                return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  setTimeout(function () {
                    resolve();
                  }, 300);
                });

              case 10:
                if (userInfo.islogin) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt('return');

              case 12:

                this.obj.data && (this.obj.data._userInfo = userInfo);
                _context2.next = 20;
                break;

              case 15:
                if (!this.options.notForceLogin) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 18;
                return tuhu.getUserInfo({
                  force: false
                });

              case 18:
                _userInfo = _context2.sent;


                this.obj.data && (this.obj.data._userInfo = _userInfo);

              case 20:
                if (!this.options.forceLocate) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 23;
                return tuhu.getLocate();

              case 23:
                locationInfo = _context2.sent;

                if (locationInfo) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 27;
                return tuhu.locate.getIpLocate();

              case 27:
                locationInfo = _context2.sent;

              case 28:

                this.obj.data._locationInfo = locationInfo;

              case 29:
                if (!this.options.forceCar) {
                  _context2.next = 76;
                  break;
                }

                _startTime = +new Date();
                carInfo = null;
                // 新版车型库

                if (!this.options.isNewCar) {
                  _context2.next = 50;
                  break;
                }

                _forceCar = this.options.forceCar;

                if (!((typeof _forceCar === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_forceCar)) === 'object')) {
                  _context2.next = 47;
                  break;
                }

                _carLevel = _forceCar[0];
                _carPage = _forceCar[1];

                if (!(_carPage === 10)) {
                  _context2.next = 41;
                  break;
                }

                _context2.next = 40;
                return tuhu.tCar.getDefaultCar(_carLevel, true, {
                  isSpecific: true
                });

              case 40:
                carInfo = _context2.sent;

              case 41:
                if (!(_carPage === 8)) {
                  _context2.next = 45;
                  break;
                }

                _context2.next = 44;
                return tuhu.tCar.getDefaultCar(_carLevel, true, {
                  isLungu: true
                });

              case 44:
                carInfo = _context2.sent;

              case 45:
                _context2.next = 50;
                break;

              case 47:
                _context2.next = 49;
                return tuhu.tCar.getDefaultCar(_forceCar, true);

              case 49:
                carInfo = _context2.sent;

              case 50:
                if (carInfo) {
                  _context2.next = 73;
                  break;
                }

                if (!(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.options.forceCar) === 'object')) {
                  _context2.next = 64;
                  break;
                }

                _context2.next = 54;
                return tuhu.getDefaultCar(this.options.forceCar[0], true, {
                  pageCar: true
                });

              case 54:
                carInfo = _context2.sent;

                if (checkCar(carInfo, this.options.forceCar[0])) {
                  _context2.next = 57;
                  break;
                }

                return _context2.abrupt('return');

              case 57:
                _context2.next = 59;
                return tuhu.getDefaultCar(this.options.forceCar[1], true, {
                  pageCar: true
                });

              case 59:
                carInfo = _context2.sent;

                if (checkCar(carInfo, this.options.forceCar[1])) {
                  _context2.next = 62;
                  break;
                }

                return _context2.abrupt('return');

              case 62:
                _context2.next = 70;
                break;

              case 64:
                _context2.next = 66;
                return tuhu.getDefaultCar(this.options.forceCar, true, {
                  pageCar: true
                });

              case 66:
                carInfo = _context2.sent;

                if (checkCar(carInfo, this.options.forceCar)) {
                  _context2.next = 70;
                  break;
                }

                if (this.istab && tuhu._tabInstance) {
                  tuhu._tabInstance.tabIndex = tuhu._tabInstance.lastTabIndex;
                }
                return _context2.abrupt('return');

              case 70:
                if (!(+new Date() - _startTime > 3000)) {
                  _context2.next = 73;
                  break;
                }

                _context2.next = 73;
                return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  setTimeout(function () {
                    resolve();
                  }, 300);
                });

              case 73:
                this.obj.data._carInfo = carInfo;
                _context2.next = 88;
                break;

              case 76:
                if (!this.options.notForceCar) {
                  _context2.next = 88;
                  break;
                }

                _carInfo = null;

                if (!this.options.isNewCar) {
                  _context2.next = 84;
                  break;
                }

                _context2.next = 81;
                return tuhu.tCar.getDefaultCar(5, false);

              case 81:
                _carInfo = _context2.sent;
                _context2.next = 87;
                break;

              case 84:
                _context2.next = 86;
                return tuhu.getDefaultCar(5, false);

              case 86:
                _carInfo = _context2.sent;

              case 87:
                this.obj.data._carInfo = _carInfo;

              case 88:

                this.setPageLock();

                this.ta();

                showTab(this.istab);

                this._pushNewState();
                _pageDom = this.pageDom(), curPage = _pageDom.curPage, newPage = _pageDom.newPage;

                if (this.options.vue && this.options.vue.default) {
                  this.resetVueInstance(this.options.vue.default);
                  this.vue(curPage, newPage);
                } else {
                  iframe = $('<iframe width="100%" height="100%" frameborder="0" src="' + this.query.url.replace(/(\/[^&?/.]+)$/, '$1/') + '"></iframe>');

                  iframe.on('load', function () {
                    var _this4 = this;

                    document.title = this.contentDocument.title || defaultTitle;
                    setTimeout(function () {
                      document.title = _this4.contentDocument.title || defaultTitle;
                    }, 1000);
                  });
                  newPage.find('.' + ROUTER_CONFIG.contentClass).append(iframe);

                  if (this.direct) {
                    !this.istab && tuhu._popPage();
                    curPage.remove();

                    this.resolve();
                  } else {
                    this.animation && _animateSection(curPage, newPage, DIRECTION.rightToLeft, this.resolve);
                  }

                  tuhu._setCurrentPage(this.id, this.url, tabIndex, this.pageId, this.istab, null, this.url);
                }

              case 94:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _load() {
        return _ref2.apply(this, arguments);
      }

      return _load;
    }()
  }]);

  return Router;
}();

/** 关闭默认路由 */


$.smConfig.router = false;
/** 注入router */
$(document).on('click', 'a', function (e) {
  if (tuhu.config.preventALabel === undefined || tuhu.config.preventALabel) {
    e.preventDefault();
  }
});

window.addEventListener('popstate', onPopState);

/** 后退键处理 */
$(function () {
  backIcon = $('#myback');
  setTimeout(function () {
    if (getFilterPages().length < 2) {
      backIcon.hide();
    }
  });

  backIcon.on('click', function () {
    tuhu.navigateBack();
  });
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),

/***/ "MZKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bankList_vue__ = __webpack_require__("LP6e");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3933d492_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bankList_vue__ = __webpack_require__("fon5");
function injectStyle (ssrContext) {
  __webpack_require__("3OQM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3933d492"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bankList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3933d492_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bankList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MjFd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "MnV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platenum"},[_c('div',{class:_vm.showModal?'modal modal-coupons modal-in': 'modal modal-coupons modal-out',staticStyle:{"display":"block","margin-top":"-167px"}},[_c('div',{staticClass:"modal-inner"},[_c('div',{staticClass:"modal-title"},[_vm._v("领取优惠券")]),_vm._v(" "),_c('div',{staticClass:"modal-text"},[_c('div',{staticClass:"promotions"},[_c('div',{staticClass:"promotionBox"},[_c('div',{staticClass:"list"},_vm._l((_vm.couponsList),function(item,index){return _c('div',{key:index,class:item.IsGet || item.AlreadyHave? 'item getted':'item'},[_c('div',{staticClass:"itemLeft"},[_c('div',{staticClass:"number"},[_c('span',{staticClass:"label"},[_vm._v("¥")]),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v(_vm._s(item.Discount))])]),_vm._v(" "),_c('div',{staticClass:"condition"},[_vm._v(_vm._s(item.Rule || '满' + item.MinMoney + '元可用'))])]),_vm._v(" "),_c('div',{staticClass:"itemRight"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.PromtionName || item.PromotionName))]),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(item.Time || item.ValidStartTime + '-' + item.ValidEndTime))]),_vm._v(" "),_c('div',{staticClass:"useNow",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(item,index)}}},[_vm._v("领取优惠券")]),_vm._v(" "),_c('div',{staticClass:"quanDetail"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.Description))])])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"modal-buttons ",on:{"click":function($event){$event.stopPropagation();return _vm.closeCoupons($event)}}},[_vm._m(0)])]),_vm._v(" "),(_vm.showmask && _vm.showModal)?_c('div',{staticClass:"modal-overlay modal-overlay-visible"}):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"modal-button"},[_c('span',{staticClass:"closeBtn"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mp5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_swiperModify_css__ = __webpack_require__("iuq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_swiperModify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__css_swiperModify_css__);

/*
author: zhangping
调用方式：v-choose可以为1，2，3有三种选中和未选中的样式
选中样式右边的内容可以任意添加，选中图标会自动居中
<div v-choose="3">
    <img width="75px" height="75px" src="https://img3.tuhu.org/comment/40c0/03be/576b8ef70a0480ec558db859_w600_h800.jpg@100w_100h_100Q.jpg" />
</div>
<div v-choose="2">测试选中</div>
<div v-choose="1">
  <div>任意内容</div>
</div>
*/
Vue.directive('choose', {
  inserted: function inserted(el, binding) {
    var type = binding.value;
    if (type === 1) {
      $(el).append('<i class="choose-icon type1"></i>');
    } else if (type === 2) {
      $(el).append('<i class="choose-icon type2"></i>');
    } else if (type === 3) {
      $(el).append('<i class="choose-icon type3"></i>');
    }
    $(el).addClass('choose-unselect');
    $(el).find('.choose-icon').on('click', function () {
      if ($(el).hasClass('choose-selected')) {
        $(el).removeClass('choose-selected');
      } else {
        $(el).addClass('choose-selected');
      }
    });
  }
});

/***/ }),

/***/ "Mp6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N4ji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_toast_style__ = __webpack_require__("eqfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__ = __webpack_require__("/QYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);




__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  toast: function toast() {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '加载中...';
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    Object(__WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */])({
      message: msg,
      duration: duration,
      forbidClick: true
    });
  },


  /**
   * loading显示
   * @param msg
   */
  showLoading: function showLoading() {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '加载中...';
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */].loading({
      message: msg,
      duration: duration,
      forbidClick: true
    });
  },


  /**
   * Loading隐藏
   */
  hideLoading: function hideLoading() {
    __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */].loading().clear();
  }
});

/***/ }),

/***/ "N6PM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compressImage; });
/* unused harmony export compressBase64Image */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return drawCompressedCanvas; });
/* unused harmony export formatSize */
/* unused harmony export base64Bytes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);






var _this = this;

/**
 * 公共图片压缩工具（先压缩、再上传）
 * 默认策略：不修改原图尺寸，仅按指定质量重新编码（JPEG）降低体积
 * 提供 File/Blob 压缩（输出 File，供 FormData 上传）
 * 与 base64(dataURL) 压缩（输出 dataURL，供 base64 流上传）两种入口
 *
 * options:
 *   maxEdge  可选最大边长，传入数值时长边超出才等比缩小；默认 null 不缩放、保持原尺寸
 *   quality  重新编码质量 0~1，默认 0.8
 *   mimeType 输出格式，默认 'image/jpeg'（需保留透明的场景可传 'image/png'）
 *   maxSize  压缩触发阈值（字节），仅当文件超过该体积才压缩，默认 8MB
 *   timeout  处理超时时间（毫秒），超过则报错"处理失败"并返回 null，默认 15000
 */

// 默认压缩配置
var DEFAULT_OPTIONS = {
  maxEdge: null, // 默认不修改尺寸，仅重新编码降体积
  quality: 0.8,
  mimeType: 'image/jpeg',
  maxSize: 1024 * 1024 * 8, // 超过 8MB 才压缩，不超过直接返回原文件
  timeout: 15000 // 处理超过 15s 视为失败


  // 合并配置（过滤 undefined，避免覆盖默认值）
};var mergeOptions = function mergeOptions(options) {
  var opts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, DEFAULT_OPTIONS);
  if (options) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(options).forEach(function (key) {
      if (options[key] !== undefined) {
        opts[key] = options[key];
      }
    });
  }
  return opts;
};

// 加载 Image 对象（支持 File/Blob 的 objectURL 或 dataURL）
var loadImage = function loadImage(src) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      return resolve(img);
    };
    img.onerror = function () {
      return reject(new Error('图片加载失败'));
    };
    img.src = src;
  });
};

// 计算输出尺寸：默认保持原尺寸；传入 maxEdge 时长边超出才等比缩小
var calculateSize = function calculateSize(img, maxEdge) {
  var width = img.width;
  var height = img.height;
  if (maxEdge) {
    var longerEdge = Math.max(width, height);
    if (longerEdge > maxEdge) {
      var scale = maxEdge / longerEdge;
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }
  }
  return { width: width, height: height };
};

// 按指定尺寸绘制到 canvas（JPEG 铺白底避免透明区域变黑）
var drawToCanvas = function drawToCanvas(img, width, height, mimeType) {
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, width, height);
  if (mimeType === 'image/jpeg') {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
  }
  ctx.drawImage(img, 0, 0, width, height);
  return canvas;
};

// 通过 canvas 按输出尺寸绘制并重新编码（默认原尺寸，仅降质量）
var drawCompressedCanvas = function drawCompressedCanvas(img, options) {
  var opts = mergeOptions(options);

  var _calculateSize = calculateSize(img, opts.maxEdge),
      width = _calculateSize.width,
      height = _calculateSize.height;

  return drawToCanvas(img, width, height, opts.mimeType);
};

// 页面提示（框架全局 tuhu 可用时才提示，避免工具层硬依赖）
var toast = function toast(message) {
  try {
    if (typeof tuhu !== 'undefined' && tuhu.toast) {
      tuhu.toast(message);
    }
  } catch (e) {}
};

// 持续提示：处理完成前不会消失（Preloader 需手动关闭）
var showProcessing = function showProcessing() {
  try {
    if (typeof tuhu !== 'undefined' && tuhu.showPreloader) {
      tuhu.showPreloader('图片较大，正在处理…');
    }
  } catch (e) {}
};

// 关闭持续提示
var hideProcessing = function hideProcessing() {
  try {
    if (typeof tuhu !== 'undefined' && tuhu.hidePreloader) {
      tuhu.hidePreloader();
    }
  } catch (e) {}
};

// canvas 转 blob
var canvasToBlob = function canvasToBlob(canvas, mimeType, quality) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    try {
      canvas.toBlob(function (blob) {
        blob ? resolve(blob) : reject(new Error('canvas 转换 blob 失败'));
      }, mimeType, quality);
    } catch (e) {
      reject(e);
    }
  });
};

// 根据输出格式替换文件名后缀
var renameExt = function renameExt(name, mimeType) {
  var ext = (mimeType.split('/')[1] || 'jpg').toLowerCase();
  return name ? name.replace(/\.\w+$/, '') + '.' + ext : 'file.' + ext;
};

// 体积格式化（字节 -> 可读字符串）
var formatSize = function formatSize(bytes) {
  if (bytes === null || bytes === undefined) return '未知';
  return bytes >= 1024 * 1024 ? (bytes / 1024 / 1024).toFixed(2) + 'MB' : (bytes / 1024).toFixed(1) + 'KB';
};

// base64(dataURL) 近似字节数
var base64Bytes = function base64Bytes(dataUrl) {
  var idx = dataUrl.indexOf(',');
  var base64 = idx > -1 ? dataUrl.substring(idx + 1) : dataUrl;
  return Math.round(base64.length * 3 / 4);
};

/**
 * 实际压缩流程：返回压缩后的 File，失败或体积未变小时返回原文件
 */
var doCompressFile = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file, opts) {
    var objectURL, img, _calculateSize2, width, height, quality, blob, _arr, _i, q, retry, i, scale, _retry, compressed;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            objectURL = null;
            _context.prev = 1;

            objectURL = URL.createObjectURL(file);
            _context.next = 5;
            return loadImage(objectURL);

          case 5:
            img = _context.sent;


            // 第一轮：保持原尺寸，按指定质量编码
            _calculateSize2 = calculateSize(img, opts.maxEdge), width = _calculateSize2.width, height = _calculateSize2.height;
            quality = opts.quality;
            _context.next = 10;
            return canvasToBlob(drawToCanvas(img, width, height, opts.mimeType), opts.mimeType, quality);

          case 10:
            blob = _context.sent;

            if (!(blob && blob.size > opts.maxSize)) {
              _context.next = 27;
              break;
            }

            _arr = [0.6, 0.4, 0.3];
            _i = 0;

          case 14:
            if (!(_i < _arr.length)) {
              _context.next = 27;
              break;
            }

            q = _arr[_i];

            if (!(q >= quality)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt('continue', 24);

          case 18:
            _context.next = 20;
            return canvasToBlob(drawToCanvas(img, width, height, opts.mimeType), opts.mimeType, q);

          case 20:
            retry = _context.sent;

            if (retry && retry.size < blob.size) {
              blob = retry;
              quality = q;
            }

            if (!(blob.size <= opts.maxSize)) {
              _context.next = 24;
              break;
            }

            return _context.abrupt('break', 27);

          case 24:
            _i++;
            _context.next = 14;
            break;

          case 27:
            if (!(blob && blob.size > opts.maxSize)) {
              _context.next = 41;
              break;
            }

            i = 0;

          case 29:
            if (!(i < 3 && blob.size > opts.maxSize)) {
              _context.next = 40;
              break;
            }

            scale = Math.max(0.1, Math.sqrt(opts.maxSize * 0.9 / blob.size));

            width = Math.max(1, Math.round(width * scale));
            height = Math.max(1, Math.round(height * scale));
            _context.next = 35;
            return canvasToBlob(drawToCanvas(img, width, height, opts.mimeType), opts.mimeType, quality);

          case 35:
            _retry = _context.sent;

            if (_retry) blob = _retry;

          case 37:
            i++;
            _context.next = 29;
            break;

          case 40:
            console.log('[\u56FE\u7247\u538B\u7F29] ' + file.name + ': \u539F\u5C3A\u5BF8\u65E0\u6CD5\u538B\u5230 ' + formatSize(opts.maxSize) + ' \u4EE5\u4E0B\uFF0C\u5DF2\u7B49\u6BD4\u7F29\u5C0F\u5C3A\u5BF8\u515C\u5E95');

          case 41:
            if (!(blob && blob.size < file.size)) {
              _context.next = 46;
              break;
            }

            compressed = new File([blob], renameExt(file.name, opts.mimeType), {
              type: opts.mimeType
            });

            console.log('[\u56FE\u7247\u538B\u7F29] ' + file.name + ': ' + formatSize(file.size) + ' -> ' + formatSize(compressed.size) + '\uFF08' + img.width + 'x' + img.height + ' -> ' + width + 'x' + height + '\uFF0C' + opts.mimeType + '\uFF0Cquality=' + quality + '\uFF09');
            if (compressed.size > opts.maxSize) {
              toast('\u56FE\u7247\u8FC7\u5927\uFF0C\u538B\u7F29\u540E\u4ECD\u8D85\u8FC7 ' + formatSize(opts.maxSize) + '\uFF0C\u5EFA\u8BAE\u66F4\u6362\u8F83\u5C0F\u7684\u56FE\u7247');
            }
            return _context.abrupt('return', compressed);

          case 46:
            console.log('[\u56FE\u7247\u538B\u7F29] ' + file.name + ': ' + formatSize(file.size) + ' -> ' + formatSize(blob && blob.size) + ' \u4F53\u79EF\u672A\u53D8\u5C0F\uFF0C\u4F7F\u7528\u539F\u6587\u4EF6');
            return _context.abrupt('return', file);

          case 50:
            _context.prev = 50;
            _context.t0 = _context['catch'](1);

            console.error('图片压缩失败，使用原文件上传', _context.t0);
            return _context.abrupt('return', file);

          case 54:
            _context.prev = 54;

            objectURL && URL.revokeObjectURL(objectURL);
            return _context.finish(54);

          case 57:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 50, 54, 57]]);
  }));

  return function doCompressFile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 压缩 File/Blob，输出压缩后的 File，保证结果不超过 maxSize（默认 8MB）
 * 仅当文件超过 maxSize 才压缩；策略：优先保持原尺寸逐级降质量，
 * 仍超标时才按体积估算等比缩小尺寸兜底（仅极端大图会走到这一步）
 * 处理期间页面持续提示"图片较大，正在处理…"，完成/失败后关闭；
 * 超过 timeout（默认 15s）提示"处理失败"并返回 null，调用方应终止上传
 */
var compressImage = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var opts, timer, timeoutPromise;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            opts = mergeOptions(options);

            // 未超过阈值不压缩，直接返回原文件（无耗时处理，不弹提示）

            if (!(file.size && file.size <= opts.maxSize)) {
              _context2.next = 4;
              break;
            }

            console.log('[\u56FE\u7247\u538B\u7F29] ' + file.name + ': ' + formatSize(file.size) + ' \u672A\u8D85\u8FC7 ' + formatSize(opts.maxSize) + '\uFF0C\u65E0\u9700\u538B\u7F29');
            return _context2.abrupt('return', file);

          case 4:

            // 持续提示：处理完成/失败前不消失
            showProcessing();

            // 超时控制：超过 timeout 视为处理失败
            timer = null;
            timeoutPromise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              timer = setTimeout(function () {
                return reject(new Error('timeout'));
              }, opts.timeout);
            });
            _context2.prev = 7;
            _context2.next = 10;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.race([doCompressFile(file, opts), timeoutPromise]);

          case 10:
            return _context2.abrupt('return', _context2.sent);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2['catch'](7);

            if (!(_context2.t0 && _context2.t0.message === 'timeout')) {
              _context2.next = 19;
              break;
            }

            console.error('[\u56FE\u7247\u538B\u7F29] ' + file.name + ': \u5904\u7406\u8D85\u8FC7 ' + Math.round(opts.timeout / 1000) + 's\uFF0C\u5DF2\u7EC8\u6B62');
            toast('图片处理失败，请重试');
            return _context2.abrupt('return', null);

          case 19:
            console.error('图片压缩失败，使用原文件上传', _context2.t0);
            return _context2.abrupt('return', file);

          case 21:
            _context2.prev = 21;

            timer && clearTimeout(timer);
            hideProcessing();
            return _context2.finish(21);

          case 25:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[7, 13, 21, 25]]);
  }));

  return function compressImage(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 压缩 base64(dataURL)，输出压缩后的 dataURL
 * 压缩失败时返回原 dataURL
 */
var compressBase64Image = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dataUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var opts, img, canvas, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            opts = mergeOptions(options);
            _context3.prev = 1;
            _context3.next = 4;
            return loadImage(dataUrl);

          case 4:
            img = _context3.sent;
            canvas = drawCompressedCanvas(img, opts);
            result = canvas.toDataURL(opts.mimeType, opts.quality);

            console.log('[\u56FE\u7247\u538B\u7F29] base64\u56FE\u7247: ' + formatSize(base64Bytes(dataUrl)) + ' -> ' + formatSize(base64Bytes(result)) + '\uFF08' + img.width + 'x' + img.height + ' -> ' + canvas.width + 'x' + canvas.height + '\uFF0C' + opts.mimeType + '\uFF09');
            return _context3.abrupt('return', result);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3['catch'](1);

            console.error('图片压缩失败，使用原图片上传', _context3.t0);
            return _context3.abrupt('return', dataUrl);

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[1, 11]]);
  }));

  return function compressBase64Image(_x5) {
    return _ref3.apply(this, arguments);
  };
}();



/* unused harmony default export */ var _unused_webpack_default_export = ({
  compressImage: compressImage,
  compressBase64Image: compressBase64Image,
  drawCompressedCanvas: drawCompressedCanvas
});

/***/ }),

/***/ "N9fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_list_vue__ = __webpack_require__("z+E+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RecordList: __WEBPACK_IMPORTED_MODULE_2__components_list_vue__["a" /* default */] },
  data: function data() {
    return {
      dataList: [],
      tabList: {
        verifyOrderSum: {
          num: 0,
          text: "核销订单数",
          icon: "https://res.xiaokunkeji.cn/image/2023/12/14/50fa1f29610e4cfaa9074e811fcd18e9.png"
        },
        orderAmountSum: {
          num: 0,
          text: "核销订单总收入",
          icon: "https://res.xiaokunkeji.cn/image/2023/12/14/4360a3f7855d4483bcd3d25d3e4060e2.png"
        }
      },
      queryYear: "", //查询的年份
      isOpen: false, //年份选择
      yearList: [] //年份选择列表
    };
  },
  mounted: function mounted() {
    this.handleYear();
    this.shopId = tuhu.getParam("shopId") || JSON.parse(localStorage.getItem("_xk_user_key"))['shopId'];
    this.queryDataList();
  },

  methods: {
    //前往月记录
    goPage: function goPage(row) {
      tuhu.navigateTo({
        url: '/pages/monthRecord/index?date=' + row.month + '&shopId=' + this.shopId
      });
      // localStorage.setItem('monthList',JSON.stringify(row))
    },

    //展开收起年份选择
    change: function change() {
      this.isOpen = !this.isOpen;
    },

    //选择年份查询
    oncheck: function oncheck(row) {
      this.queryYear = row;
      this.queryDataList();
      this.isOpen = false;
    },

    //处理可选年份数据
    handleYear: function handleYear() {
      this.yearList = [];
      this.queryYear = new Date().getFullYear(); //"2025-12-13"
      //2023年起始，当年与2023年相差几年
      var subtractNum = this.queryYear - 2023;
      if (subtractNum === 0) return;
      for (var i = 0; i <= subtractNum; i++) {
        var temp = 2023 + i;
        this.yearList.push(temp);
      }
    },

    //获取列表数据
    queryDataList: function queryDataList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tuhu.showIndicator();
                _this.dataList = [];
                _context.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_TIKTOK_ORDER_YEAR_RECORD + '?shopId=' + _this.shopId + '&year=' + _this.queryYear);

              case 4:
                res = _context.sent;

                tuhu.hideIndicator();
                if (res && res.code === '200') {
                  _this.tabList['verifyOrderSum']['num'] = res['data'] && res['data']['verifyOrderSum'] || 0;
                  _this.tabList['orderAmountSum']['num'] = res['data'] && res['data']['orderAmountSum'] || 0;
                  _this.dataList = res && res.data && res.data.monthList.length ? res.data.monthList.map(function (item) {
                    item.count = item.verifyOrderSum;
                    item.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.month).format("YYYY年MM月");
                    item.price = item.orderAmountSum;
                    return item;
                  }) : [];
                } else {
                  tuhu.toast(res.message || "网络错误");
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_button_style__ = __webpack_require__("3Lne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_button__ = __webpack_require__("SSsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_switch_style__ = __webpack_require__("3gWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_switch__ = __webpack_require__("ZxCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_cell_style__ = __webpack_require__("OWWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_cell__ = __webpack_require__("1fWZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_cell_group_style__ = __webpack_require__("i0mo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_cell_group__ = __webpack_require__("Hkar");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_field_style__ = __webpack_require__("MY4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_es_field__ = __webpack_require__("0zAV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vant_es_popup_style__ = __webpack_require__("mMXg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_es_popup__ = __webpack_require__("qYlo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vant_es_picker_style__ = __webpack_require__("nI2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vant_es_picker__ = __webpack_require__("qWG/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vant_es_tab_style__ = __webpack_require__("yIEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant_es_tab__ = __webpack_require__("OIh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vant_es_tabs_style__ = __webpack_require__("jAcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vant_es_tabs__ = __webpack_require__("86U2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vant_es_notice_bar_style__ = __webpack_require__("OLZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vant_es_notice_bar__ = __webpack_require__("4j1Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vant_es_toast_style__ = __webpack_require__("eqfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vant_es_toast__ = __webpack_require__("/QYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vant_es_checkbox_style__ = __webpack_require__("cZ0s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vant_es_checkbox__ = __webpack_require__("fIxc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vant_es_checkbox_group_style__ = __webpack_require__("RIEG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vant_es_checkbox_group__ = __webpack_require__("zjGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vant_es_radio_group_style__ = __webpack_require__("HZGa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vant_es_radio_group__ = __webpack_require__("pykS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vant_es_radio_style__ = __webpack_require__("le1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vant_es_radio__ = __webpack_require__("hZxG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vant_es_uploader_style__ = __webpack_require__("jti4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vant_es_uploader__ = __webpack_require__("uk7J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vant_es_icon_style__ = __webpack_require__("k3b4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vant_es_icon__ = __webpack_require__("+2ln");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vant_es_dialog_style__ = __webpack_require__("XmAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vant_es_dialog__ = __webpack_require__("il3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vant_es_pagination_style__ = __webpack_require__("MVd3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vant_es_pagination__ = __webpack_require__("XXPT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vant_es_collapse_style__ = __webpack_require__("NjV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vant_es_collapse__ = __webpack_require__("dq/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vant_es_collapse_item_style__ = __webpack_require__("1O2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vant_es_collapse_item__ = __webpack_require__("sXqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vant_es_action_sheet_style__ = __webpack_require__("PEgo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vant_es_action_sheet__ = __webpack_require__("HNZ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vant_es_dropdown_menu_style__ = __webpack_require__("iQ6B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_vant_es_dropdown_menu__ = __webpack_require__("H6W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vant_es_dropdown_item_style__ = __webpack_require__("n90r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_vant_es_dropdown_item__ = __webpack_require__("dJne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_vant_es_datetime_picker_style__ = __webpack_require__("dKK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_vant_es_datetime_picker__ = __webpack_require__("balU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_vant_es_tag_style__ = __webpack_require__("3ab0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_vant_es_tag__ = __webpack_require__("bHMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_vant_es_empty_style__ = __webpack_require__("g+tI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_vant_es_empty__ = __webpack_require__("NLod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_vant_es_number_keyboard_style__ = __webpack_require__("0FYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_vant_es_number_keyboard__ = __webpack_require__("XmXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_vant_es_search_style__ = __webpack_require__("4yKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_vant_es_search__ = __webpack_require__("wolx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_vant_es_tree_select_style__ = __webpack_require__("z+oF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_vant_es_tree_select__ = __webpack_require__("zcgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_vant_es_stepper_style__ = __webpack_require__("10Qn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_vant_es_stepper__ = __webpack_require__("UQoe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_vant_es_image_style__ = __webpack_require__("LlGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_vant_es_image__ = __webpack_require__("Wtz3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__static_css_sm_css__ = __webpack_require__("TTHc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__static_css_sm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__static_css_sm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__static_js_sm_js__ = __webpack_require__("/FvA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__static_js_sm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__static_js_sm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__css_reset_css__ = __webpack_require__("xsZ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__css_common_css__ = __webpack_require__("0lA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__css_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_quill_dist_quill_core_css__ = __webpack_require__("3f40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_quill_dist_quill_snow_css__ = __webpack_require__("4qOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_quill_dist_quill_bubble_css__ = __webpack_require__("+cgv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__lib_commons_tuhu__ = __webpack_require__("eIHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__pages_layout_vue__ = __webpack_require__("m/fZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__commons_util__ = __webpack_require__("sEZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__lib_components_citypicker_vue__ = __webpack_require__("zlD5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__commons_kun__ = __webpack_require__("N4ji");
































































/** 基础样式 勿删 */

/** sm.js 勿删 */









/** 基础API 勿删 */

/** 获取第三方渠道 */
// import '../lib/commons/channel'





// vantUI Toast可以直接this.$toast()调用'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole



Vue.use(__WEBPACK_IMPORTED_MODULE_76_vue_clipboard2___default.a);

Vue.use(__WEBPACK_IMPORTED_MODULE_1_vant_es_button__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_3_vant_es_switch__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_5_vant_es_cell__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_7_vant_es_cell_group__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_9_vant_es_field__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_11_vant_es_popup__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_13_vant_es_picker__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_15_vant_es_tab__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_17_vant_es_tabs__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_19_vant_es_notice_bar__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_21_vant_es_toast__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_23_vant_es_checkbox__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_25_vant_es_checkbox_group__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_27_vant_es_radio_group__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_29_vant_es_radio__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_31_vant_es_uploader__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_33_vant_es_icon__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_35_vant_es_dialog__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_37_vant_es_pagination__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_39_vant_es_collapse__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_41_vant_es_collapse_item__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_43_vant_es_action_sheet__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_45_vant_es_dropdown_menu__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_47_vant_es_dropdown_item__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_49_vant_es_datetime_picker__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_51_vant_es_tag__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_53_vant_es_empty__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_55_vant_es_number_keyboard__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_57_vant_es_search__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_59_vant_es_tree_select__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_61_vant_es_stepper__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_63_vant_es_image__["a" /* default */]);
Vue.component('tuhu-citypicker', __WEBPACK_IMPORTED_MODULE_75__lib_components_citypicker_vue__["a" /* default */]);

// loading加载

Vue.prototype.$kun = __WEBPACK_IMPORTED_MODULE_77__commons_kun__["a" /* default */];
/** 加载layout */
new Vue({
  el: $('#root')[0],
  mounted: function mounted() {},

  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_72__pages_layout_vue__["a" /* default */]);
  }
});
// let vConsole = new VConsole()
Vue.prototype.util = __WEBPACK_IMPORTED_MODULE_74__commons_util__["a" /* default */];
/** 自己控制初始化路由 */
var url = tuhu.getFullPath(location.href);
var params = tuhu.getParams() || {};
var token = params['x-auth-token'];
if (token) tuhu.localStorage.setItem('shop-token', token);
tuhu.redirectTo({
  url: url,
  query: tuhu.getParams()
});
tuhu.store = __WEBPACK_IMPORTED_MODULE_73__store_store__["a" /* default */];
/** 页面加载完成删除index.html中的loading动画 */
$('#tuhuloadmore').hide();

/***/ }),

/***/ "NLbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      _channel: ''
    };
  },

  props: ['mlink'],
  created: function created() {
    this._channel = tuhu.device.android ? '去应用市场下载' : '去App Store下载';
  },

  methods: {
    closePopup: function closePopup() {
      this.$emit('cancelChange', {});
    },
    downloadApp: function downloadApp() {
      Ta.ta('event', 'mw_download_btn_click', {
        channel: tuhu.orderChannel || 'kH5'
      });
      if (tuhu.device.isWeixin) {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.TuHu.android';
      } else if (tuhu.device.ios) {
        window.location.href = 'https://itunes.apple.com/cn/app/tu-hu-yang-che-5fen-qian-xi-che/id943708006?mt=8';
      } else {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.TuHu.android';
      }
      this.$emit('cancelChange', {});
    },
    openApp: function openApp() {
      Ta.ta('event', 'mw_openapp_btn_click', {
        channel: tuhu.orderChannel || 'kH5'
      });
      if (this.mlink && !tuhu.device.isWeixin) {
        window.location.href = this.mlink;
      }
      this.$emit('cancelChange', {});
    }
  }
});

/***/ }),

/***/ "Nkzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_image_preview_style__ = __webpack_require__("WJbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_image_preview__ = __webpack_require__("OhwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configs_config__ = __webpack_require__("65XL");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            todayListInfo: {},
            success: '', // 订单列表来的1
            scsShow: '', // 核销来的1
            isEdit: '',
            fromVerify: false, // true订单来的 false核销来的
            hidePrice: false,
            Message: '', // 失败信息
            imgList: []
        };
    },
    created: function created() {
        this.init();
    },

    methods: {
        showImagePreview: function showImagePreview(val) {
            Object(__WEBPACK_IMPORTED_MODULE_5_vant_es_image_preview__["a" /* default */])({
                images: [val], // 要预览的图片数组（支持多张）
                closeable: true, // 显示关闭按钮
                closeOnPopstate: true // 浏览器后退时关闭预览
            });
        },
        init: function init() {
            var _this = this;

            this.todayListInfo = this.options && this.options.ListInfo ? this.options.ListInfo : JSON.parse(tuhu.sessionStorage.getItem('shopOrderDetail') || null) || {};

            this.Message = this.todayListInfo.Message || '';

            this.scsShow = tuhu.getParam('scsShow') || '';

            this.success = tuhu.getParam('success') || '';

            var result = location.href.indexOf('success') === -1;

            this.fromVerify = result;

            var imgList = [{
                type: 'vehicleWorkingPhoto',
                title: '显露车牌及车店一体的作业中照片',
                val: ''
            }, {
                type: 'vehicleOilPhoto',
                title: '使用的机油与车辆合影照片',
                val: ''
            }, {
                type: 'beforeWorkPhoto',
                title: '作业前漆面照片',
                val: ''
            }, {
                type: 'workingPhoto',
                title: '作业中照片',
                val: ''
            }, {
                type: 'afterWorkPhoto',
                title: '作业后漆面照片',
                val: ''
            }, {
                type: 'workOrderPhoto',
                title: '工单照片',
                val: ''
            }, {
                type: 'elseWorkPhoto',
                title: '其他照片',
                val: ''
            }, {
                type: 'carLiftPhoto',
                title: '车辆在起升架上的照片',
                val: ''
            }, {
                type: 'hoodOpenPhoto',
                title: '引擎盖打开的照片',
                val: ''
            }, {
                type: 'electronicCheckReport',
                title: '安全检测电子检测报告',
                val: ''
            }, {
                type: 'signature',
                title: '签名图片',
                val: ''
            }, {
                type: 'puttyingPhoto',
                title: '刮腻子照片',
                val: ''
            }, {
                type: 'vinPhoto',
                title: '车架号图片',
                val: ''
            }];
            this.isEdit = tuhu.getParam('isEdit') || '';
            // 核销界面
            if (!this.fromVerify || this.isEdit) {
                var checkPhoto = this.todayListInfo.checkPhoto;
                imgList.forEach(function (item) {
                    if (checkPhoto[item.type]) {
                        item.val = checkPhoto[item.type];
                    }
                });
            } else {
                //订单详情界面
                imgList.forEach(function (item) {
                    if (_this.todayListInfo[item.type]) {
                        item.val = _this.todayListInfo[item.type];
                    }
                });
            }
            this.imgList = imgList.filter(function (item) {
                return item.val;
            });
        },
        upload: function upload(val) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var index, type, params, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                index = val.index.split('-')[0];
                                type = val.index.split('-')[1];


                                _this2.$set(_this2.imgList[index], 'val', val.data);

                                params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({

                                    shopBillId: _this2.todayListInfo.billId

                                }, type, val.data);
                                _context.next = 6;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.UPDATAE_WRITEOFF_PIC, {

                                    method: 'post',

                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params)

                                });

                            case 6:
                                res = _context.sent;


                                if (res && res.code === '200') {

                                    tuhu.toast(res.message || '更换成功');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },

        //跳转修改核销信息
        toVerifyUpload: function toVerifyUpload() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var shopInfo, shopId, code, res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                shopInfo = tuhu.store.state.currentShopInfo;
                                shopId = shopInfo ? shopInfo.shopId : JSON.parse(localStorage.getItem("_xk_user_key"))['shopId'];
                                code = _this3.todayListInfo.verificationCode;
                                //获取回显 

                                _context2.next = 5;
                                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_6__configs_config__["a" /* default */].apis.GET_SAFE_MESSAGE + '?writeOffCode=' + code);

                            case 5:
                                res = _context2.sent;

                                if (res && res.code === '200') {
                                    tuhu.sessionStorage.setItem('upDetail', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.data));
                                    tuhu.navigateTo({
                                        url: '/pages/editVerifyImg/index',
                                        data: {
                                            uploadDetail: res.data
                                        },
                                        query: {
                                            sId: shopId,
                                            vCode: code
                                        }
                                    });
                                } else {
                                    tuhu.toast(res.message || '网络错误');
                                }

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        }
    }
});

/***/ }),

/***/ "Nq27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',[_c('div',{staticClass:"main"},[_c('div',{staticClass:"row-cell"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.tiktokData.goodsImg,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"cell-flex"},[_c('p',{staticClass:"one-limit cell-name"},[_vm._v(_vm._s(_vm.tiktokData.goodsName))]),_vm._v(" "),_c('p',{staticClass:"cell-price"},[_vm._v("结算单价"),_c('span',[_vm._v("￥"+_vm._s(_vm.tiktokData.settlementPrice))])])])]),_vm._v(" "),_c('div',{staticClass:"coupon"},[_c('div',{staticClass:"num-time"},[_c('p',{staticClass:"num"},[_vm._v("当前共"),_c('span',[_vm._v(_vm._s(_vm.num)+"张")]),_vm._v("可用")]),_vm._v(" "),_c('p',{staticClass:"time"},[_vm._v("有效期至"+_vm._s(_vm.tiktokData.exireTime))])]),_vm._v(" "),_c('div',{staticClass:"edit-num"},[_c('img',{attrs:{"src":_vm.count <= 1 ? _vm.no_minus : _vm.minus,"alt":""},on:{"click":function($event){_vm.count--}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.count),expression:"count"}],attrs:{"type":"tel","max":_vm.count,"maxlength":"2"},domProps:{"value":(_vm.count)},on:{"input":function($event){if($event.target.composing){ return; }_vm.count=$event.target.value}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.count >= _vm.num ? _vm.no_add : _vm.add,"alt":""},on:{"click":function($event){_vm.count >= _vm.num ? _vm.count = _vm.num : _vm.count++}}})])])]),_vm._v(" "),_c('div',{staticClass:"cell-phone"},[_c('span',{staticClass:"name"},[_vm._v("手机号码")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],staticClass:"tel-int",attrs:{"type":"tel","maxlength":"11","placeholder":"请输入消费者手机号码(非必填)"},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('p',{staticClass:"desc"},[_vm._v("共选择"),_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("张券，核销前请与顾客确认核销券数")]),_vm._v(" "),_c('p',{staticClass:"btn-btn",on:{"click":function($event){return _vm.handlePreverify()}}},[_vm._v("确定核销")])]),_vm._v(" "),_c('van-popup',{staticClass:"confirm-write-off",attrs:{"round":"","close-on-popstate":true,"close-on-click-overlay":false},model:{value:(_vm.visibleConfirm),callback:function ($$v) {_vm.visibleConfirm=$$v},expression:"visibleConfirm"}},[_c('p',{staticClass:"name"},[_vm._v("确认核销")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("请再次确认核销门店与核销券数")]),_vm._v(" "),_c('div',{staticClass:"cell-store"},[_c('div',{staticClass:"store-info"},[_c('span',[_vm._v("核销门店：")]),_vm._v(" "),_c('p',{staticClass:"one-limit"},[_vm._v(_vm._s(_vm.shopName))])]),_vm._v(" "),_c('div',{staticClass:"store-info"},[_c('span',[_vm._v("核销券数：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.count)+"张")])])]),_vm._v(" "),_c('div',{staticClass:"confirm-btn"},[_c('p',{staticClass:"cancel",on:{"click":function($event){_vm.visibleConfirm = false}}},[_vm._v("取消核销")]),_vm._v(" "),_c('p',{staticClass:"confirm-button",on:{"click":function($event){return _vm.handleConfirmWriteOff()}}},[_vm._v("确认核销")])])]),_vm._v(" "),_c('van-popup',{staticClass:"tiktoTips",attrs:{"round":"","close-on-popstate":true,"close-on-click-overlay":false},model:{value:(_vm.tiktoStorekVisible),callback:function ($$v) {_vm.tiktoStorekVisible=$$v},expression:"tiktoStorekVisible"}},[_c('p',{staticClass:"name"},[_vm._v("门店提示")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.tiktokText))]),_vm._v(" "),_c('p',{staticClass:"tit-btn",on:{"click":function($event){return _vm.toBack()}}},[_vm._v("我知道了")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NrIi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wxc.d031a3e.png";

/***/ }),

/***/ "NyL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

var src = __webpack_require__("7RoH");
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: this.options.title || '空页面',
      imageUrl: this.options.imageUrl || src,
      buttonName: this.options.buttonName || '返回上一页',
      buttonCallBack: this.options.buttonCallBack
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {},

  methods: {
    handleButtonClick: function handleButtonClick(e) {
      if (this.buttonCallBack) {
        this.buttonCallBack(e);
      } else {
        tuhu.navigateBack();
      }
    }
  }
});

/***/ }),

/***/ "OzHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow-right-grey2.9c69707.png";

/***/ }),

/***/ "P2Ve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P3LE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1How");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7519952c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("us5i");
function injectStyle (ssrContext) {
  __webpack_require__("2ify")
  __webpack_require__("Pdze")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7519952c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7519952c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PKmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchSortTabs_vue__ = __webpack_require__("Qe5M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4f5ad96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchSortTabs_vue__ = __webpack_require__("BUgN");
function injectStyle (ssrContext) {
  __webpack_require__("HLcn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4f5ad96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchSortTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4f5ad96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchSortTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pdze":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Py7c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close.ba510d9.png";

/***/ }),

/***/ "Q/Tj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q0im":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QFb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_imageCompress__ = __webpack_require__("N6PM");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showCamera: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {
    triggerFileInput: function triggerFileInput(type) {
      if (type === 'image') this.$refs.imageInput.click();else if (type === 'file') this.$refs.fileInput.click();
    },
    handleImageUpload: function handleImageUpload(event) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, imgFile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = event.target.files[0];

                if (!file) {
                  _context.next = 9;
                  break;
                }

                // 先关闭选择弹窗，避免压缩耗时期间界面停留
                _this.closeModal();
                // 上传前先压缩：等比缩放到最大边长后重新编码（压缩失败时内部返回原文件）
                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__commons_imageCompress__["a" /* compressImage */])(file);

              case 5:
                imgFile = _context.sent;

                if (imgFile) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:
                // 处理超时已提示"处理失败"，终止本次上传
                _this.$emit("fileUploaded", imgFile, 'image');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleFileUpload: function handleFileUpload(event) {
      var file = event.target.files[0];
      if (file) {
        this.$emit("fileUploaded", file, 'file');
        this.closeModal();
      }
    },
    closeModal: function closeModal() {
      this.$emit("close");
    }
  }
});

/***/ }),

/***/ "QHWF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grayCamera.45d6c6c.png";

/***/ }),

/***/ "QHvU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs_config__ = __webpack_require__("65XL");
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    window._locateToData = this.options;
    var src = '/static/locateline.html';
    if (location.host.indexOf('xiaokunkeji') > -1) {
      // src = 'https://www.xiaokunkeji.cn/user/vue/locateline.html'
      src = '' + __WEBPACK_IMPORTED_MODULE_0__configs_config__["a" /* default */].apis.XK_MAP;
    }
    // else if (location.host === 'wxdev.tuhu.work') {
    //   src = 'https://wxdev.tuhu.work/vue/locateline.html'
    // }
    var iframe = $('<iframe width="100%" height="100%" frameborder="0" src="' + src + '"></iframe>');
    $(this.$el).append(iframe);
  },

  methods: {}
});

/***/ }),

/***/ "Qe5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/11/23
 * desc: 排序筛选tab
 * eg:<tuhu-sortTabs
          :tabsStatusType='tabsStatusType'
          :callbackClickTab='callbackClickTab'
        >
        </tuhu-sortTabs>
    tabsStatusType: [
          { // 没有上下按钮的筛选
            name: '综合',
            type: 0, // 筛选id
            choosed: true // 是否默认选中
          }, {
            name: '销量',
            up: 2,
            down: 1,
            default: 'up', // 默认展示的是啥样的
            choosed: false
          }, {
            name: '价格',
            up: 5,
            down: 6,
            default: 'down',
            choosed: false
          }
        ]
callbackClickTab(type) {
      }
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tabsStatusType: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    callbackClickTab: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    handlePanelHiden: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    keyword: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      tabsStatusArray: [],
      shiftStatusObject: {
        choosed: false,
        shift: true
      },
      test: false,
      showCover: false,
      filterList: null,
      reg: /^([^-]+?)-(.+?)$/,
      brandSelected: [],
      recommendSelected: '',
      minMoney: '',
      maxMoeny: '',
      noFilter: false,
      reject: function reject() {},
      Easing: {
        easeBoth: function easeBoth(t) {
          return (t *= 2) < 1 ? 0.5 * t * t : 0.5 * (1 - --t * (t - 2));
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    if (this.keyword !== '') {
      tuhu.fetch('https://api.tuhu.cn/Search/SelectFilterValues?key=' + this.keyword).then(function (res) {
        if (res.Code === 1) {
          if (res.FilterList.length === 0) {
            _this.noFilter = true;
          } else if (res.FilterList) {
            _this.initFilterList(res.FilterList);
          }
        }
      });
    }
    var tabsStatusArray = [];
    this.tabsStatusType.forEach(function (element) {
      var tabStatus = {};
      // 如果是没有排序的筛选
      if (element.type !== undefined) {
        // 默认选中
        if (element.choosed) {
          tabStatus.choosed = true;
        } else {
          // 默认不是选中
          tabStatus.choosed = false;
        }
        tabStatus.up = false;
        tabStatus.down = false;
      } else {
        // 有排序的筛选
        if (element.default === 'up') {
          tabStatus.up = true;
          tabStatus.down = false;
        } else if (element.default === 'down') {
          tabStatus.up = false;
          tabStatus.down = true;
        }
        tabStatus.choosed = element.choosed;
      }
      tabsStatusArray.push(tabStatus);
    });
    this.tabsStatusArray = tabsStatusArray;
  },

  watch: {
    tabsStatusArray: function tabsStatusArray(val, oldVal) {
      var _index = 0;
      var tab = this.tabsStatusArray.find(function (element, index) {
        _index = index;
        return element.choosed;
      });
      var typeKey = void 0;
      if (tab.down) {
        typeKey = 'down';
      } else if (tab.up) {
        typeKey = 'up';
      } else {
        typeKey = 'type';
      }
      this.callbackClickTab('sequence', this.tabsStatusType[_index][typeKey]);
    },
    shiftStatusObject: function shiftStatusObject(val, oldVal) {},
    reject: function reject(_reject) {
      _reject();
    },
    brandSelected: function brandSelected(value) {
      if (this.minMoney === '' && this.maxMoeny === '' && this.brandSelected.length === 0) {
        this.shiftStatusObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shiftStatusObject, { choosed: false });
      } else {
        this.shiftStatusObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shiftStatusObject, { choosed: true });
      }
      // this.callbackClickTab('brand', value)
    },
    minMoney: function minMoney() {
      if (this.minMoney === '' && this.maxMoeny === '' && this.brandSelected.length === 0) {
        this.shiftStatusObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shiftStatusObject, { choosed: false });
      } else {
        this.shiftStatusObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shiftStatusObject, { choosed: true });
      }
    },
    maxMoeny: function maxMoeny() {
      if (this.minMoney === '' && this.maxMoeny === '' && this.brandSelected.length === 0) {
        this.shiftStatusObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shiftStatusObject, { choosed: false });
      } else {
        this.shiftStatusObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.shiftStatusObject, { choosed: true });
      }
    }
  },
  methods: {
    closePnnel: function closePnnel() {
      this.showCover = false;
      this.$refs.min.blur();
      this.$refs.max.blur();
    },
    getElementTop: function getElementTop(elem) {
      var elemTop = elem.offsetTop;
      elem = elem.offsetParent;
      while (elem != null) {
        elemTop += elem.offsetTop;
        elem = elem.offsetParent;
      }
      return elemTop;
    },
    scrollToElement: function scrollToElement(dom) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$duration = _ref.duration,
          duration = _ref$duration === undefined ? 240 : _ref$duration,
          _ref$easing = _ref.easing,
          easing = _ref$easing === undefined ? this.Easing.easeBoth : _ref$easing,
          _ref$interval = _ref.interval,
          interval = _ref$interval === undefined ? 15 : _ref$interval,
          _ref$padding = _ref.padding,
          padding = _ref$padding === undefined ? 0 : _ref$padding;

      if (!dom || !(dom instanceof HTMLElement)) {
        throw new Error('scrollToElement need a dom element');
      }
      var screenHeight = container.clientHeight || document.documentElement.clientHeight;
      var pageScrollHeight = container.scrollHeight || document.body.scrollHeight;
      var maxScrollHeight = pageScrollHeight - screenHeight;
      var domToPageTop = this.getElementTop(dom) - padding; // 要滑到的位置
      if (domToPageTop > maxScrollHeight) {
        domToPageTop = maxScrollHeight;
      }
      var curScrollTop = container.scrollTop || document.body.scrollTop || window.scrollY || document.documentElement.scrollTop; // 当前所在的位置
      var distance = domToPageTop - curScrollTop; // 滑动的距离
      var k = distance / easing(1);
      var duringTime = 0; // 运动经过的时间
      var timer = setInterval(function () {
        duringTime += interval;
        var percent = duringTime / duration;
        var scrollNum = k * easing(percent);
        if (duration - duringTime > interval) {
          container.scrollTo(0, scrollNum + curScrollTop);
        } else {
          clearInterval(timer);
          container.scrollTo(0, domToPageTop);
        }
      }, interval);
    },
    handleSelectLetter: function handleSelectLetter(e) {
      // debugger
      var letter = e.currentTarget.outerText;
      // # 是非法的class类名，所以#改为0
      var classname = '.brands-type-' + (letter === '#' ? '0' : letter);
      this.scrollToElement($(classname)[0], $('.sorttasbs-infinite')[0]);
    },
    initFilterList: function initFilterList(data) {
      var filterList = data;
      filterList.map(function (item) {
        item.filterItem = [];
        item.expanded = false;
        return item.ItemList.map(function (x) {
          x.Name = x.Name.indexOf('-') > -1 ? x.Name.split('-')[1] : x.Name;
          x.selected = false;
          return x;
        });
      });
      this.filterList = filterList;
    },
    clear: function clear() {
      this.brandSelected = [];
      this.minMoney = '';
      this.maxMoeny = '';
      this.recommendSelected = '';
      this.initFilterList(this.filterList);
    },
    commit: function commit() {
      this.handlePanelHiden(false);
      this.callbackClickTab('brand', this.brandSelected);
      this.callbackClickTab('money', [this.minMoney, this.maxMoeny]);
      this.callbackClickTab('recommend', this.recommendSelected);
      this.$refs.panel.close();
      this.showCover = false;
    },
    close: function close() {
      this.handlePanelHiden(false);
      this.callbackClickTab('brand', this.brandSelected);
      this.callbackClickTab('money', [this.minMoney, this.maxMoeny]);
      this.callbackClickTab('recommend', this.recommendSelected);
      this.$refs.panel.close();
      this.showCover = false;
    },
    handleClickBrand: function handleClickBrand(value, index, index2) {
      var _this2 = this;

      var filterList = this.filterList;
      filterList[index].ItemList.map(function (x) {
        var name = filterList[index].Name;
        if (x.Name === value) {
          if (!x.selected) {
            if (name === '品牌') {
              if (_this2.brandSelected.length >= 5) {
                tuhu.toast('最多能选择5项');
                return;
              }
              _this2.brandSelected.push(x.Name);
              filterList[index].filterItem.push(x.Name);
            } else {
              filterList[index].filterItem = [x.Name];
              _this2.recommendSelected = x.Name;
            }
            x.selected = !x.selected;
          } else {
            if (name === '品牌') {
              var delIndex = _this2.brandSelected.indexOf(value);
              _this2.brandSelected.splice(delIndex, 1);
              filterList[index].filterItem.splice(delIndex, 1);
            } else {
              filterList[index].filterItem = [];
              _this2.recommendSelected = '';
            }
            x.selected = !x.selected;
          }
        } else {
          if (name === '推荐') {
            x.selected = false;
          }
        }
        return x;
      });
      this.$set(this.filterList, index, filterList[index]);
    },
    handleClickTab: function handleClickTab(index) {
      // 如果可以排序，切换排序
      if (this.tabsStatusArray[index].choosed && (this.tabsStatusArray[index].up || this.tabsStatusArray[index].down)) {
        this.tabsStatusArray[index].up = !this.tabsStatusArray[index].up;
        this.tabsStatusArray[index].down = !this.tabsStatusArray[index].down;
      }
      // 选中当前，取消其他选中
      this.tabsStatusArray.forEach(function (element) {
        element.choosed = false;
      });
      this.tabsStatusArray[index].choosed = true;
      // 触发watch
      this.tabsStatusArray.splice(1, 0);
    },
    handleClickShift: function handleClickShift(e) {
      if (!this.noFilter) {
        // 显示
        this.handlePanelHiden(true);
        this.showCover = true;
        this.$refs.panel.open();
      }
    },
    expand: function expand(index) {
      // const filterList = this.filterList
      this.filterList[index].expanded = !this.filterList[index].expanded;
      // this.$set(this.filterList, index, this.filterList[index])
    }
  }
});

/***/ }),

/***/ "QpxN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qu6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(!_vm.shopNo)?_c('div',[_c('h2',{staticClass:"fontWeight"},[_vm._v("小鲲车服指定服务网点合作协议")]),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("协议适用主体范围")]),_vm._v(" "),_c('div',{staticClass:"text indent2"},[_vm._v("\n      本协议是商户（以下可称为“您”）与小鲲车服（以下简称“我司”）之间关于汽车维修保养、汽车美容服务之相关合作所定立的协议，依据《中华人民共和国合同法》等有关法律、法规的规定，经友好、平等协商，双方现达成如下内容，以资遵行：\n    ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("合作期限")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("合作内容")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("服务流程")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("服务标准与要求")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("客户投诉与处理")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("费用结算")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("禁止恶意刷单与舞弊")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("保密条款")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("反贪污、反商业贿赂")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("适用法律与争议解决")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("其他约定")]),_vm._v(" "),_vm._m(10)]):_c('div',[_c('h2',{staticClass:"fontWeight"},[_vm._v("小鲲车服指定服务网点合作协议")]),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("协议适用主体范围")]),_vm._v(" "),_c('div',{staticClass:"text indent2"},[_vm._v("\n      本协议是商户（以下可称为“您”）"),_c('span',{staticClass:"fontWeight"},[_vm._v(_vm._s(_vm.shopInfo.name))]),_vm._v("与"),_c('span',{staticClass:"fontWeight"},[_vm._v("杭州小鲲科技有限公司（小鲲车服）")]),_vm._v("（以下简称“我司”）之间关于汽车维修保养、汽车美容服务之相关合作所定立的协议，依据《中华人民共和国合同法》等有关法律、法规的规定，经友好、平等协商，双方现达成如下内容，以资遵行：\n    ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("合作期限")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("合作内容")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("服务流程")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("服务标准与要求")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("客户投诉与处理")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("费用结算")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("服务费")]),_vm._v(" "),_c('p',[_vm._v("\n        服务费系指您为我司客户提供符合本协议约定的标准、要求的汽车配件、设备安装及美容服务后，我司应支付给您的服务费。\n      ")]),_vm._v(" "),_c('table',{staticStyle:{"border-collapse":"collapse","width":"100%"},attrs:{"border":"1","cellspacing":"1px","bordercolor":"#254389","cellpadding":"0"}},[_vm._m(16),_vm._v(" "),_vm._l((_vm.shopSignServviceList),function(item,index){return _c('tr',{key:index,attrs:{"align":"center","height":"30"}},[_c('td',[_vm._v(_vm._s(index * 1 + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.signService))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.signPrice))])])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("对账与结算")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('p',[_vm._v("您指定银行账户为：")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("开户银行："+_vm._s(_vm.shopBankCardInfos.bankName))]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("\n        支行信息："+_vm._s(_vm.shopBankCardInfos.bankBranchName)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("账户名称："+_vm._s(_vm.shopBankCardInfos.bankAccount))]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("\n        银行账号："+_vm._s(_vm.shopBankCardInfos.bankAccountName)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("\n        联行号："+_vm._s(_vm.shopBankCardInfos.bankAccountNumber)+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("禁止恶意刷单与舞弊")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("保密条款")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("反贪污、反商业贿赂")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("适用法律与争议解决")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("其他约定")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方在此认可，双方均为独立履行本协议的法人主体，自担风险和费用履行本协议；双方之间不因本协议的存在、履行而存在或产生任何合伙、合营、代理或雇佣关系。在任何涉及第三方的活动中，除本协议有明确规定外，本协议的任何一方均无权代表另一方行事，亦不得以本协议另一方之名义与其他第三方签署任何协议，除非事先有书面授权。\n      ")]),_vm._v(" "),_c('p',[_vm._v("本协议自您同意之日起生效。")]),_vm._v(" "),_c('div',{staticClass:"shop-flex"},[_c('div',{staticClass:"flex-row"},[_c('p',[_c('span',{staticClass:"span1"},[_vm._v("商户：")]),_c('span',{staticClass:"span2"},[_vm._v(_vm._s(_vm.shopInfo.name))])]),_vm._v(" "),_vm._m(22)]),_vm._v(" "),_c('div',{staticClass:"flex-row"},[_c('p',[_c('span',{staticClass:"span1"},[_vm._v("商户签字：")]),_c('img',{staticClass:"sing",attrs:{"src":_vm.sing,"alt":""}})]),_vm._v(" "),_c('p',[_c('span',{staticClass:"span1"},[_vm._v("平台盖章：")]),_c('img',{staticClass:"chapter",attrs:{"src":_vm.chapter,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"flex-row"},[_c('p',[_c('span',{staticClass:"span1"},[_vm._v("日期：")]),_c('span',{staticClass:"span2"},[_vm._v(_vm._s(_vm.shopInfo.createdTime))])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"span1"},[_vm._v("日期：")]),_c('span',{staticClass:"span2"},[_vm._v(_vm._s(_vm.shopInfo.createdTime))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方的合作期限为两（2）年，从首次同意该协议时间开始计算（“首次合作期”）。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        首次合作期届满前三十（30）日，若双方均未提出本协议不再续期，则双方合作期限自动续展一（1）年（“合作展期”）；\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        合作展期届满前三十（30）日，若双方均选择继续合作，则应另行签订书面协议；除非双方另有约定，本协议所有条款在合作展期内继续有效。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        合作期限（包括首次合作期、合作展期）届满前，我司有权视市场、您履约情况及其他各方面因素，单方决定是否续约。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("双方合作的服务项目有：")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"fontWeight"},[_vm._v("汽车保养维修")]),_vm._v("包括但不限于：机油更换、滤清器更换、喷漆等。\n      ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"fontWeight"},[_vm._v("汽车美容服务项目")]),_vm._v("包括但不限于：普通洗车、精细洗车、打蜡等。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        双方合作内容均不包含汽车配件产品销售，您须接受我司客户自带汽车配产品由您提供服务。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您为我司客户提供服务所必需的设备、工具、耗材等由您自行准备、提供，该等设备、工具、耗材等应符合我司要求和相应国家标注或行业标准的要求。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        经我司客户同意，您可以向我司客户推销、提供其自行采购第三方产品（该等产品须不会替代我司客户已从我司购买的产品），及提供安装服务，与我司无关，由您自行承担所有责任。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("系统使用")]),_vm._v(" "),_c('p',[_vm._v("小鲲门店商户系统")]),_vm._v(" "),_c('p',[_vm._v("\n        我司在“小鲲车服”公众号中为您开放接口及登录授权，并为您提供系统使用培训服务。您应安排专人熟练使用该系统，并使用该业务系统接受我司派单。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("营业时间")]),_vm._v(" "),_c('p',[_vm._v("\n        您须应保证在可以接受我司系统派单的时间内正常营业。如您实在无法在法定节假日进行营业，您需明确提前告知我司停止向您派单。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("营销与推广")]),_vm._v(" "),_c('p',[_vm._v("\n        我司可以对您店铺提供营销支持，您可以选择在我司平台通过展示、系统推荐、营销活动策划、广告、市场推广等各类营销方法宣传您店铺及相关活动。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("汽车美容服务流程")]),_vm._v(" "),_c('p',[_vm._v("\n        客户在我司平台及我司授权的第三方合作平台获得汽车美容服务产品或者进行预约后，我司将向客户发出服务权凭证或服务验证码，并将预约信息通知您。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您根据我司的通知、客户所持的服务权凭证或者服务验证码，为客户安排经验丰富的工作人员提供汽车美容服务。您为客户提供安汽车美容服务完毕后，根据客户提供的服务权凭证或者服务验证码，在我司“小鲲车服公众号”中结算服务费。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("服务重点要求：")]),_vm._v(" "),_c('p',[_vm._v("\n        您应熟练、准确使用我司业务系统以保证服务质量。我司将不定期对您进行业务系统使用熟练度抽查。您连续三（3）次不合格，我司有权终止合作。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您根据我司的检测/安装单为我司客户提供安装服务，不得替换其它任何产品；在我司未知情且未授权的情况下，您替代其它任何产品导致的损失由您全部承担。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您如经我司客户同意，向我司客户推销、提供其自行采购的第三方产品（该等产品须不会替代我司客户已从我司购买的产品），必须确保产品质量，并且对所提供的产品质量承担全部责任。我司不承担因安装非我司货品所导致的任何风险和责任。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        在协议有效期内，您无正当理由不得拒绝为我司客户提供相应服务。如因您无正当理由拒绝提供服务而产生的一切损失由您全部承担，且我司有权因您拒绝为我司客户提供服务而终止与您的合作关系。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        您有义务竭力为客户提供优质满意的服务体验，不得因为推销店里产品及其他服务造成客户不满及投诉。确实因您问题导致的服务的投诉累计≥3次，我司有权终止与其的合作关系。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        上述情况下，若客户在向我司投诉的过程中索赔或要求我司给予解决方案，我司因此先行给予客户的任何赔付、赔偿、补偿、赠与等，均应由您承担。我司有权在您的保证金或结算款项中进行扣除。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("服务费")]),_vm._v(" "),_c('p',[_vm._v("\n        服务费系指您为我司客户提供符合本协议约定的标准、要求的汽车配件、设备安装及美容服务后，我司应支付给您的服务费。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("对账与结算")]),_vm._v(" "),_c('p',[_vm._v("\n        我司和您约定每月的一个固定日作为对帐日（“约定对账日”，若遇到周末、法定节假日予以相应顺延），用以核对您上个月的服务费，并在对帐日当天完成当期对帐。对账完成后"),_c('span',{staticClass:"decoration"},[_vm._v("\n          7 ")]),_vm._v("个工作日内，您应向我司提供合法的、相应金额的增值税发票，我司在收到该等增值税发票后"),_c('span',{staticClass:"decoration"},[_vm._v("\n          7 ")]),_vm._v("个工作日内将相应服务费支付到您指定账户。\n      ")]),_vm._v(" "),_c('p',[_vm._v("您指定银行账户为：")]),_vm._v(" "),_c('p',[_vm._v("以双方协定的账户为准。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        对于我司推出的优惠券或其他优惠产品和/或服务，目的是为回馈车主，扩大用户群，您不得直接参与购买该等产品和/或服务。如您存在或参与恶意刷单、作弊等行为，一经我司查实、认定，我司有权立即终止本协议，\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("恶意刷单、舞弊行为包括但不限于：")]),_vm._v(" "),_c('p',[_vm._v("\n        我司随机抽取涉嫌恶意刷单、舞弊的注册手机号码在不同时段进行拨打，同一号码在不同时段拨打总计三（3）次后仍无法与手机号码所有人取得联系的，包括但不限于：手机通话显示“已停机”、“已关机”、“无人接听”、“无法接通”、“拨打号码不存在”等；\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        尽管与涉嫌恶意刷单、舞弊的注册手机号码所有人取得了联系，但我司发现该手机号码所有人并未在我司平台及我司授权的第三方合作平台使用该手机号码注册为我司用户/客户，亦未授权其他人使用该手机号码注册为我司用户/客户；\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        其他证明涉嫌恶意刷单、舞弊的注册手机号码所有人并未注册或授权注册成为我司用户/客户的情形。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        如出现上述涉嫌恶意刷单、舞弊行为的比例达到我司抽取号码比例的百分之十（10%），我司有权认定您存在或参与恶意刷单、舞弊行为。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方的交易或合作关系亦视为保密信息。双方应对本协议的存在、协议协商过程中的报价和最终成交价，以及双方之间已有、正在进行或者未来的交易或者合作关系承担保密义务。非经对方书面同意，双方不得向任何第三方（不包括因工作需要而接触保密信息的员工、财务审计机构、顾问、律师、服务地点物业管理部门之必要登记、公安部门之必要登记）披露。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        一方在本协议有效期内违反上述规定，另一方有权立即无条件终止本协议，并享有追究违约方的违约责任的权利。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方均申明并同意，过去、现在和将来在与对方品牌有关的业务和合作的过程中，严守中国有关反贪污腐败、反商业贿赂方面法律、法规的规定，杜绝提供、承诺给予、给予、同意接受或接受任何非法贿赂、回扣、回报、影响付款、返利或其他非法支付金钱、有价物品、卡券或任何利益（包括疏通费）等任何违反这些法律、法规的行为。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        如果一方或其分公司、集团公司、分包商、代理或代表违反本条规定，和/或因涉及或从事任何可能构成反贿赂法下犯罪的行为被指控或被调查，守约方有权单方面立即终止本协议而不承担任何违约或赔偿责任。如前述任何行为给守约方造成任何损失的，守约方保留追究法律责任和要求赔偿损失的权利。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        本协议的成立、生效、解释及履行等各方面均适用中华人民共和国现行及未来生效的法律，并依之解释。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        任何因本协议或者本协议的履行而引发的争议，双方应首先采取友好协商的方式解决该争议；如协商不成，双方同意向我司住所地的有管辖权的人民法院提起诉讼。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        当因一方违反本协议规定而起争议时，除须承担违约或者侵权责任外，违约方/侵权方还需承担守约方就该等争议主张权利的相关费用，包括但不限于诉讼费用、律师费用、调查取证费用、差旅费用。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方在此认可，双方均为独立履行本协议的法人主体，自担风险和费用履行本协议；双方之间不因本协议的存在、履行而存在或产生任何合伙、合营、代理或雇佣关系。在任何涉及第三方的活动中，除本协议有明确规定外，本协议的任何一方均无权代表另一方行事，亦不得以本协议另一方之名义与其他第三方签署任何协议，除非事先有书面授权。\n      ")]),_vm._v(" "),_c('p',[_vm._v("本协议自您同意之日起生效。")]),_vm._v(" "),_c('p',{staticClass:"fontWeight margin"},[_vm._v("\n        汽车美容服务内容和服务费以最终您和本司协商的项目和价格为准。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方的合作期限为两（2）年，从首次同意该协议时间开始计算（“首次合作期”）。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        首次合作期届满前三十（30）日，若双方均未提出本协议不再续期，则双方合作期限自动续展一（1）年（“合作展期”）；\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        合作展期届满前三十（30）日，若双方均选择继续合作，则应另行签订书面协议；除非双方另有约定，本协议所有条款在合作展期内继续有效。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        合作期限（包括首次合作期、合作展期）届满前，我司有权视市场、您履约情况及其他各方面因素，单方决定是否续约。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("双方合作的服务项目有：")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"fontWeight"},[_vm._v("汽车保养维修")]),_vm._v("包括但不限于：机油更换、滤清器更换、喷漆等。\n      ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"fontWeight"},[_vm._v("汽车美容服务项目")]),_vm._v("包括但不限于：普通洗车、精细洗车、打蜡等。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        双方合作内容均不包含汽车配件产品销售，您须接受我司客户自带汽车配产品由您提供服务。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您为我司客户提供服务所必需的设备、工具、耗材等由您自行准备、提供，该等设备、工具、耗材等应符合我司要求和相应国家标注或行业标准的要求。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        经我司客户同意，您可以向我司客户推销、提供其自行采购第三方产品（该等产品须不会替代我司客户已从我司购买的产品），及提供安装服务，与我司无关，由您自行承担所有责任。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("系统使用")]),_vm._v(" "),_c('p',[_vm._v("小鲲门店商户系统")]),_vm._v(" "),_c('p',[_vm._v("\n        我司在“小鲲车服”公众号中为您开放接口及登录授权，并为您提供系统使用培训服务。您应安排专人熟练使用该系统，并使用该业务系统接受我司派单。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("营业时间")]),_vm._v(" "),_c('p',[_vm._v("\n        您须应保证在可以接受我司系统派单的时间内正常营业。如您实在无法在法定节假日进行营业，您需明确提前告知我司停止向您派单。\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("营销与推广")]),_vm._v(" "),_c('p',[_vm._v("\n        我司可以对您店铺提供营销支持，您可以选择在我司平台通过展示、系统推荐、营销活动策划、广告、市场推广等各类营销方法宣传您店铺及相关活动。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("汽车美容服务流程")]),_vm._v(" "),_c('p',[_vm._v("\n        客户在我司平台及我司授权的第三方合作平台获得汽车美容服务产品或者进行预约后，我司将向客户发出服务权凭证或服务验证码，并将预约信息通知您。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您根据我司的通知、客户所持的服务权凭证或者服务验证码，为客户安排经验丰富的工作人员提供汽车美容服务。您为客户提供安汽车美容服务完毕后，根据客户提供的服务权凭证或者服务验证码，在我司“小鲲车服公众号”中结算服务费。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',{staticClass:"fontWeight"},[_vm._v("服务重点要求：")]),_vm._v(" "),_c('p',[_vm._v("\n        您应熟练、准确使用我司业务系统以保证服务质量。我司将不定期对您进行业务系统使用熟练度抽查。您连续三（3）次不合格，我司有权终止合作。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您根据我司的检测/安装单为我司客户提供安装服务，不得替换其它任何产品；在我司未知情且未授权的情况下，您替代其它任何产品导致的损失由您全部承担。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        您如经我司客户同意，向我司客户推销、提供其自行采购的第三方产品（该等产品须不会替代我司客户已从我司购买的产品），必须确保产品质量，并且对所提供的产品质量承担全部责任。我司不承担因安装非我司货品所导致的任何风险和责任。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        在协议有效期内，您无正当理由不得拒绝为我司客户提供相应服务。如因您无正当理由拒绝提供服务而产生的一切损失由您全部承担，且我司有权因您拒绝为我司客户提供服务而终止与您的合作关系。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        您有义务竭力为客户提供优质满意的服务体验，不得因为推销店里产品及其他服务造成客户不满及投诉。确实因您问题导致的服务的投诉累计≥3次，我司有权终止与其的合作关系。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        上述情况下，若客户在向我司投诉的过程中索赔或要求我司给予解决方案，我司因此先行给予客户的任何赔付、赔偿、补偿、赠与等，均应由您承担。我司有权在您的保证金或结算款项中进行扣除。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{attrs:{"align":"center","height":"30"}},[_c('th',{staticStyle:{"width":"10.33%"}},[_vm._v("序号")]),_vm._v(" "),_c('th',{staticStyle:{"width":"53.33%"}},[_vm._v("签约服务")]),_vm._v(" "),_c('th',{staticStyle:{"width":"33.33%"}},[_vm._v("签约价格")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        我司和您约定每月的一个固定日作为对帐日（“约定对账日”，若遇到周末、法定节假日予以相应顺延），用以核对您上个月的服务费，并在对帐日当天完成当期对帐。对账完成后"),_c('span',{staticClass:"decoration"},[_vm._v("\n          7 ")]),_vm._v("个工作日内，您应向我司提供合法的、相应金额的增值税发票，我司在收到该等增值税发票后"),_c('span',{staticClass:"decoration"},[_vm._v("\n          7 ")]),_vm._v("个工作日内将相应服务费支付到您指定账户。\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        对于我司推出的优惠券或其他优惠产品和/或服务，目的是为回馈车主，扩大用户群，您不得直接参与购买该等产品和/或服务。如您存在或参与恶意刷单、作弊等行为，一经我司查实、认定，我司有权立即终止本协议，\n      ")]),_vm._v(" "),_c('p',{staticClass:"fontWeight"},[_vm._v("恶意刷单、舞弊行为包括但不限于：")]),_vm._v(" "),_c('p',[_vm._v("\n        我司随机抽取涉嫌恶意刷单、舞弊的注册手机号码在不同时段进行拨打，同一号码在不同时段拨打总计三（3）次后仍无法与手机号码所有人取得联系的，包括但不限于：手机通话显示“已停机”、“已关机”、“无人接听”、“无法接通”、“拨打号码不存在”等；\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        尽管与涉嫌恶意刷单、舞弊的注册手机号码所有人取得了联系，但我司发现该手机号码所有人并未在我司平台及我司授权的第三方合作平台使用该手机号码注册为我司用户/客户，亦未授权其他人使用该手机号码注册为我司用户/客户；\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        其他证明涉嫌恶意刷单、舞弊的注册手机号码所有人并未注册或授权注册成为我司用户/客户的情形。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        如出现上述涉嫌恶意刷单、舞弊行为的比例达到我司抽取号码比例的百分之十（10%），我司有权认定您存在或参与恶意刷单、舞弊行为。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方的交易或合作关系亦视为保密信息。双方应对本协议的存在、协议协商过程中的报价和最终成交价，以及双方之间已有、正在进行或者未来的交易或者合作关系承担保密义务。非经对方书面同意，双方不得向任何第三方（不包括因工作需要而接触保密信息的员工、财务审计机构、顾问、律师、服务地点物业管理部门之必要登记、公安部门之必要登记）披露。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        一方在本协议有效期内违反上述规定，另一方有权立即无条件终止本协议，并享有追究违约方的违约责任的权利。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        双方均申明并同意，过去、现在和将来在与对方品牌有关的业务和合作的过程中，严守中国有关反贪污腐败、反商业贿赂方面法律、法规的规定，杜绝提供、承诺给予、给予、同意接受或接受任何非法贿赂、回扣、回报、影响付款、返利或其他非法支付金钱、有价物品、卡券或任何利益（包括疏通费）等任何违反这些法律、法规的行为。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        如果一方或其分公司、集团公司、分包商、代理或代表违反本条规定，和/或因涉及或从事任何可能构成反贿赂法下犯罪的行为被指控或被调查，守约方有权单方面立即终止本协议而不承担任何违约或赔偿责任。如前述任何行为给守约方造成任何损失的，守约方保留追究法律责任和要求赔偿损失的权利。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("\n        本协议的成立、生效、解释及履行等各方面均适用中华人民共和国现行及未来生效的法律，并依之解释。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        任何因本协议或者本协议的履行而引发的争议，双方应首先采取友好协商的方式解决该争议；如协商不成，双方同意向我司住所地的有管辖权的人民法院提起诉讼。\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        当因一方违反本协议规定而起争议时，除须承担违约或者侵权责任外，违约方/侵权方还需承担守约方就该等争议主张权利的相关费用，包括但不限于诉讼费用、律师费用、调查取证费用、差旅费用。\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"span1"},[_vm._v("平台名称：")]),_c('span',{staticClass:"span2"},[_vm._v("杭州小鲲科技有限公司（小鲲车服）")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qzko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"shopWrap"},[_c('div',{staticClass:"tabsList"},[_c('div',{class:'tabsItem area' + (_vm.tabIndex === 0 ? ' selected' : '')},[_c('div',{staticClass:"tabTitle",on:{"click":function($event){return _vm.selectShop(0)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.selectArea)}}),_c('i')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shows[0]),expression:"shows[0]"}],staticClass:"arealist",on:{"click":_vm.hideTabs}},[_c('div',{staticClass:"areaExpanded"},[_c('ul',[_vm._l((_vm.areaList),function(item,index){return [(index === 0)?_c('li',{key:index,staticClass:"myArea",on:{"click":function($event){return _vm.handleSelectArea(item)}}},[_c('i',{domProps:{"textContent":_vm._s(item.Region)}}),_c('span',[_c('em',[_vm._v("我的位置")]),_vm._v(_vm._s(item.Count))])]):_c('li',{key:index,on:{"click":function($event){return _vm.handleSelectArea(item)}}},[_c('i',{domProps:{"textContent":_vm._s(item.Region)}}),_c('span',{domProps:{"textContent":_vm._s(item.Count)}})])]})],2)])])]),_vm._v(" "),_c('div',{class:'tabsItem arealist' + (_vm.tabIndex === 1 ? ' selected' : '')},[_c('div',{staticClass:"tabTitle",on:{"click":function($event){return _vm.selectShop(1)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.serviceName)}}),_c('i')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shows[1]),expression:"shows[1]"}],staticClass:"shoplist"},[_c('div',{staticClass:"leftcategory"},[_c('ul',_vm._l((_vm.shopsName),function(item,index){return _c('li',{key:index,class:(item.serviceType - 0 === 4 || item.serviceType - 0 === 7) ? 'meirong selected' : '',on:{"click":function($event){return _vm.handleSelectCate(item)}}},[_c('span'),_vm._v(_vm._s(item.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"rightproject"},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.serviceType === 4 || _vm.serviceType === 7),expression:"serviceType === 4 || serviceType === 7"}]},_vm._l(((_vm.serviceType === 7 ? _vm.beauty : _vm.services)),function(item,index){return _c('li',{key:index,domProps:{"textContent":_vm._s(item.ServersName)},on:{"click":function($event){return _vm.handleCateChild(item)}}})}),0)])])]),_vm._v(" "),_c('div',{class:'tabsItem sort' + (_vm.tabIndex === 2 ? ' selected' : '')},[_c('div',{staticClass:"tabTitle",on:{"click":function($event){return _vm.selectShop(2)}}},[_c('span',{domProps:{"textContent":_vm._s(this.sorts[this.sortIndex].name)}}),_c('i')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shows[2]),expression:"shows[2]"}],staticClass:"shopsortlist"},[_c('div',{staticClass:"shopsortExpanded"},[_c('ul',_vm._l((_vm.sorts),function(item,index){return _c('li',{key:index,class:_vm.sortIndex === index ? 'selected' : '',on:{"click":function($event){return _vm.handleSort(index)}}},[_c('i',{domProps:{"textContent":_vm._s(item.name)}})])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"scrollContent"},[_c('tuhu-infinite',{attrs:{"nodata":_vm.noData,"end":_vm.end,"distance":100},on:{"oninfinite":_vm.oninfinite}},[_c('div',{staticClass:"shopList",attrs:{"slot":"content"},slot:"content"},[_c('ul',{staticClass:"list-container"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"shopItem"},[_c('div',{staticClass:"leftImg"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item.Images[0], width: 3.2}),expression:"{src:item.Images[0], width: 3.2}"}],attrs:{"width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"rightText"},[_c('div',{staticClass:"shopTitle"},[_c('span',{staticClass:"name",domProps:{"textContent":_vm._s(item.CarparName)}}),_vm._v(" "),_c('div',{staticClass:"marks"},[_c('span',{staticClass:"xing"}),_vm._v(" "),_c('span',{staticClass:"hu"}),_vm._v(" "),_c('span',{staticClass:"zhi"})])]),_vm._v(" "),_c('div',{staticClass:"itemInfo"},[_c('div',{staticClass:"rank"},[_c('span',{staticClass:"yi"})]),_vm._v(" "),_c('div',{staticClass:"allPingjia"},[_vm._v("评价"),_c('span',{domProps:{"textContent":_vm._s(item.CommentRate)}})]),_vm._v(" "),_c('div',{staticClass:"allOrder"},[_vm._v(_vm._s(item.InstallQuantity)),_c('span',[_vm._v("单")])])]),_vm._v(" "),_c('div',{staticClass:"address"},[_c('span',{staticClass:"addInfo",domProps:{"textContent":_vm._s(item.Address)}}),_vm._v(" "),_c('span',{staticClass:"distance",domProps:{"textContent":_vm._s(item.Distance.toFixed(2) + 'KM')}})]),_vm._v(" "),_c('div',{staticClass:"activity"},[_c('div',{staticClass:"group"},[_c('i'),_c('em',[_vm._v("9.9团购洗车")])])])])])])}),0)])]),_vm._v(" "),_vm._m(0)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locateAdd"},[_c('div',{staticClass:"locate"},[_vm._v("当前地址：闵行区沪闵路7866号")]),_vm._v(" "),_c('div',{staticClass:"refresh"},[_c('i'),_vm._v("刷新地址")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RQXV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RZh8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RmqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"invoice-info"},[_vm._l((_vm.invoiceInfo),function(item){return _c('van-field',{key:item,attrs:{"readonly":"","clickable":"","label":item.label,"value":item.value,"placeholder":item.value}})}),_vm._v(" "),_c('div',{staticClass:"invoice-call"},[_c('div',[_c('span',[_vm._v("如有疑问，")]),_c('span',{directives:[{name:"call",rawName:"v-call",value:({tel:'15561531212'}),expression:"{tel:'15561531212'}"}],staticClass:"invoice-call-blue"},[_vm._v("联系市场经理")])])])],2),_vm._v(" "),_c('div',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.copyContent),expression:"copyContent",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"invoice-copy-btn"},[_c('span',[_vm._v("一键复制开票信息")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ry9+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crd.e1b8733.png";

/***/ }),

/***/ "RyDP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.hideKey = true))?_c('div',{staticClass:"_content"},[_c('div',[_c('div',{staticClass:"input-t"},[_c('van-field',{staticClass:"input-text",attrs:{"clickable":"","placeholder":"请输入小鲲车服消费码","clearable":true},nativeOn:{"touchstart":function($event){$event.stopPropagation();_vm.show = true}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_vm._v(" "),_c('div',{class:_vm.isQuery ? 'input-btn' : 'input-btn-gray',on:{"click":_vm.getVerifactionConfig}},[_vm._v("查询")])],1),_vm._v(" "),(_vm.showSureOff && _vm.verifyConfig && _vm.verifyConfig.serverName)?_c('div',{staticClass:"veri-box"},[_c('p',{staticClass:"service-text"},[_vm._v("服务名称："+_vm._s(_vm.verifyConfig.serverName))]),_vm._v(" "),(_vm.verifyCarNo && _vm.isCheckCarNo === '1')?_c('p',{staticClass:"car-text"},[_vm._v("车牌号："+_vm._s(_vm.verifyCarNo))]):_vm._e(),_vm._v(" "),(_vm.verifyConfig.vinNo && _vm.isCheckCarNo === '1')?_c('p',{staticClass:"car-text"},[_vm._v("\n          车架号："+_vm._s(_vm.verifyConfig.vinNo)+"\n          "),_c('span',{staticStyle:{"font-size":"0.5rem"}},[_vm._v(_vm._s(_vm.verifyCarNo ? '（两者不一致优先以车架号为准）' : '（请按照车架号核销）'))])]):_vm._e(),_vm._v(" "),(_vm.verifyConfig.verificationDesc)?_c('div',{staticClass:"veri-text"},[_c('span',[_vm._v("注意事项：")]),_vm._v(" "),_c('p',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.verifyConfig.verificationDesc)}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.showSureOff && _vm.verifyConfig && _vm.verifyConfig.serverName)?_c('div',{staticClass:"btn",on:{"click":_vm.checkCoupon}},[_c('tt-button',{attrs:{"text":"确认核销"}})],1):_vm._e()]),_vm._v(" "),(_vm.showAllProv)?_c('div',{ref:"provinces",staticClass:"provinces"},[_c('div',{staticClass:"prolist"},_vm._l((_vm.provinces),function(item,index){return _c('div',{key:index,class:_vm.province === item ? 'selected' : '',on:{"click":function($event){return _vm.chooseProvince(item)}}},[_vm._v("\n          "+_vm._s(item)+"\n        ")])}),0)]):_vm._e(),_vm._v(" "),_c('platen',{attrs:{"showNoBoard":_vm.showNoBoard,"chooseCarNO":_vm.chooseCarNO,"delect":_vm.delect,"province":_vm.province,"selectCarNo":_vm.carNO},on:{"closeCarNO":function($event){_vm.showNoBoard = false}}}),_vm._v(" "),(_vm.showCarNoFill)?_c('div',{staticClass:"car-no-fill"},[_c('div',{staticClass:"check-title"},[_vm._v("核销服务："+_vm._s(this.severName))]),_vm._v(" "),_c('div',{staticClass:"car-no-cont"},[_c('div',{staticClass:"col-province",on:{"click":function($event){_vm.showAllProv = true
            _vm.showNoBoard = false}}},[_vm._v("\n          "+_vm._s(_vm.province)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-carNoFill",on:{"click":function($event){_vm.showNoBoard = true
            _vm.showAllProv = false}}},[(_vm.carNO)?_c('span',{staticClass:"carno"},[_vm._v(_vm._s(_vm.carNO))]):_c('span',{staticClass:"carno"},[_vm._v("请输入车牌号")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showAllProv && _vm.showNoBoard),expression:"!showAllProv && showNoBoard"}],staticClass:"cursor"})])]),_vm._v(" "),_c('div',{staticClass:"sure-btn",on:{"click":_vm.sureToOff}},[_vm._v("确认核销")])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S/7D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sd.f40649e.png";

/***/ }),

/***/ "S6Ip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SJI6":
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ "SOHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"top_bar"},[_c('i',{on:{"click":function($event){return _vm.handleClick(_vm.tabList1[0])}}},[_vm._v("查看店长和员工的区别>")])]),_vm._v(" "),(this.userRole === '老板' || this.userRole === '店长' )?_c('div',{staticClass:"management_content"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),(this.userRole === '老板')?_c('div',{key:"1",staticClass:"cont"},_vm._l((_vm.UserManagementData || ''),function(item,index){return _c('van-cell',{key:index,staticClass:"management_list"},[(item.userName)?_c('i',[(item.role === '老板')?_c('span',{staticClass:"tip_boss"},[_vm._v("\n                            "+_vm._s(item.role)+"\n                        ")]):(item.role === '店长')?_c('span',{staticClass:"tip_manager"},[_vm._v("\n                            "+_vm._s(item.role)+"\n                        ")]):_c('span',{staticClass:"tip_staff"},[_vm._v("\n                            "+_vm._s(item.role)+"\n                        ")]),_vm._v("\n                        "+_vm._s(item.userName)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('i',{staticClass:"user_management_alter"},[_c('img',{attrs:{"src":__webpack_require__("x3WB"),"alt":""},on:{"click":function($event){return _vm.alterUser($event,index)}}})])])}),1):(this.userRole === '店长')?_c('div',{key:"2",staticClass:"cont"},_vm._l((_vm.UserManagementData),function(item,index){return _c('van-cell',{key:index,staticClass:"management_list"},[_c('i',[(item.role === '老板')?_c('span',{staticClass:"tip_boss"},[_vm._v("\n                            "+_vm._s(item.role)+"\n                        ")]):(item.role === '店长')?_c('span',{staticClass:"tip_manager"},[_vm._v("\n                            "+_vm._s(item.role)+"\n                        ")]):_c('span',{staticClass:"tip_staff"},[_vm._v("\n                            "+_vm._s(item.role)+"\n                        ")]),_vm._v("\n                        "+_vm._s(item.userName)+"\n                    ")]),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('i',[_vm._v(_vm._s(item.status))]),_vm._v(" "),(item.role === '老板')?_c('i',[_vm._v("——")]):_c('i',{staticClass:"user_management_alter"},[_c('img',{attrs:{"src":__webpack_require__("x3WB"),"alt":""},on:{"click":function($event){return _vm.alterUser($event,index)}}})])])}),1):(this.userRole === '员工' )?_c('van-empty',{key:"3",attrs:{"image":"error","description":"员工权限不足"}}):_vm._e()],1),_vm._v(" "),(this.UserManagementData[this.alterUserIndex])?_c('van-action-sheet',{attrs:{"title":this.alterUserIndex !== null ? '编辑账号-' + this.UserManagementData[this.alterUserIndex].userName : '编辑账号',"round":false,"cancel-text":"取消编辑"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.userStatus==='禁用' )?_c('div',{staticClass:"alter_select",on:{"click":function($event){_vm.userStatus==='禁用' ? _vm.onSelect1(_vm.tabList3[0], $event) : ''}}},[_vm._v("\n                启用\n            ")]):_vm._e(),_vm._v(" "),(_vm.userStatus==='启用')?_c('div',{staticClass:"alter_select",on:{"click":function($event){_vm.userStatus==='启用' ? _vm.onSelect2(_vm.tabList3[0], $event) : ''}}},[_vm._v("\n                禁用\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"alter_select",on:{"click":function($event){return _vm.onSelect3(_vm.tabList3[0])}}},[_vm._v("删除")])]):_vm._e(),_vm._v(" "),(this.userRole === '老板' || this.userRole === '店长' )?_c('van-button',{staticClass:"user_management_btn",attrs:{"color":"rgb(25,137,250)","size":"large","type":"info"},on:{"click":function($event){return _vm.handleClick(_vm.tabList2[0])}}},[_vm._v("+新增账号\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(this.userRole === '店员' || this.userRole === '' )?_c('van-empty',{attrs:{"image":"error","description":"权限不够或网络错误"}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("姓名")]),_vm._v(" "),_c('span',[_vm._v("账号")]),_vm._v(" "),_c('span',[_vm._v("状态")]),_vm._v(" "),_c('span',[_vm._v("操作")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SdEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("立即打开")]),_vm._v(" "),_c('div',{staticClass:"bold downloadapp",on:{"click":_vm.downloadApp}},[_vm._v(_vm._s(_vm._channel))]),_vm._v(" "),_c('div',{staticClass:"bold openapp",on:{"click":_vm.openApp}},[_vm._v("打开小鲲车服")]),_vm._v(" "),_c('div',{staticClass:"bold cancelBtn",on:{"click":_vm.closePopup}},[_vm._v("取消")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T2s0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TK4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_vue__ = __webpack_require__("ihhn");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a72386_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_vue__ = __webpack_require__("M2dw");
function injectStyle (ssrContext) {
  __webpack_require__("zr4H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54a72386"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a72386_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TMiK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_64__ = __webpack_require__("RYeZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base_64__);

/**
 * author: 582196894@qq.com
 * date: 2017/11/13
 * desc: mlink
 */

var MLINK_URL = 'https://res.tuhu.org/react/lib/mlink.min.js';

Vue.directive('mlink', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, arg) {
    if (tuhu.device.isApp) {
      return $(el).hide();
    }

    var results = [];

    var url = arg.value;
    var data = __WEBPACK_IMPORTED_MODULE_1_base_64___default.a.encode(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
      url: /^https?:/.test(url) ? '/webView?url=' + encodeURIComponent(url) : url
    }));

    results.push({
      mlink: 'https://a.mlinks.cc/AakR',
      button: el,
      params: {
        data: data
      }
    });

    if (window.Mlink) {
      new window.Mlink(results);
    } else {
      tuhu.script(MLINK_URL).then(function () {
        new window.Mlink(results);
      });
    }
  }
});

/***/ }),

/***/ "TSLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(this.userRole === '老板' || this.userRole === '店长')?_c('div',{staticClass:"main-cont"},[_c('div',{staticClass:"pay-tabs"},[_c('div',{class:{ 'active-tab': _vm.tabIndex === 0 },on:{"click":function($event){return _vm.handleTabIndex(0)}}},[_vm._v("\n        出账管理\n      ")]),_vm._v(" "),_c('div',{class:{ 'active-tab': _vm.tabIndex === 1 },on:{"click":function($event){return _vm.handleTabIndex(1)}}},[_vm._v("\n        结算明细\n      ")])]),_vm._v(" "),((_vm.tabIndex === 0 || _vm.tabIndex === 1) && _vm.childIndex != 1)?_c('div',{staticClass:"header-bg"},[_c('div',{staticClass:"img-bg"}),_vm._v(" "),_c('div',{staticClass:"con-bg"},[_c('div',{staticClass:"select-year"},[((_vm.tabIndex === 0 || _vm.tabIndex === 1) && _vm.childIndex != 1)?_c('div',{staticClass:"select"},[_c('p',{staticClass:"yearClass",domProps:{"innerHTML":_vm._s(_vm.yearValue)},on:{"click":function($event){_vm.yearVisible = !_vm.yearVisible}}}),_vm._v(" "),_c('img',{staticClass:"up",attrs:{"src":_vm.icon4,"alt":""}}),_vm._v(" "),(_vm.yearVisible)?_c('ul',{staticClass:"yearUl"},_vm._l((_vm.year),function(item,index){return _c('li',{key:index,staticClass:"yearLi",class:_vm.yearValue == item.value ? 'acbg' : '',on:{"click":function($event){return _vm.changeYearValue(item.value)}}},[_vm._v("\n                "+_vm._s(item.value)+"\n              ")])}),0):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.tabIndex === 0 && _vm.childIndex != 1)?_c('div',{staticClass:"order-num"},[_c('div',{staticClass:"order"},[_c('p',{staticClass:"text"},[_vm._v("核销订单数")]),_vm._v(" "),_c('p',{staticClass:"num"},[_vm._v(_vm._s(_vm.countOrderNum))])]),_vm._v(" "),_c('div',{staticClass:"order"},[_c('p',{staticClass:"text"},[_vm._v("核销订单总金额（元）")]),_vm._v(" "),_c('p',{staticClass:"num"},[_vm._v(_vm._s(_vm.countOrderPrice))])])]):_vm._e(),_vm._v(" "),(_vm.tabIndex == 1)?_c('div',{staticClass:"order-num"},[_c('div',{staticClass:"order"},[_c('p',{staticClass:"text"},[_vm._v("已结款订单数")]),_vm._v(" "),_c('p',{staticClass:"num"},[_vm._v(_vm._s(_vm.countOrderNum2))])]),_vm._v(" "),_c('div',{staticClass:"order"},[_c('p',{staticClass:"text"},[_vm._v("核销总金额（元）")]),_vm._v(" "),_c('p',{staticClass:"num"},[_vm._v(_vm._s(_vm.countOrderPrice2))])])]):_vm._e(),_vm._v(" "),(_vm.tabIndex === 0 && _vm.childIndex != 1)?_c('div',{staticClass:"header-tips"},[_vm._v("\n          每月10号之前小鲲车服会完成上月已出账订单的审核，每月11号会对审核通过的账单进行打款\n        ")]):_vm._e(),_vm._v(" "),(_vm.tabIndex === 1)?_c('div',{staticClass:"header-tips",staticStyle:{"text-align":"center"}},[_vm._v("\n          每月11号会对审核通过的账单进行打款\n        ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.tabIndex === 0)?_c('div',{staticClass:"orderCard"},[(_vm.childIndex == 0)?_c('div',{staticClass:"child1"},_vm._l((_vm.orderList),function(item,idx){return _c('van-collapse',{key:idx,staticClass:"collapse-bill",attrs:{"accordion":""},on:{"change":function($event){return _vm.handleItem(item, idx)}},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('van-collapse-item',{staticClass:"collapse-position",attrs:{"name":idx},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"position"}),_vm._v(" "),_c('div',{staticClass:"bill-title"},[_c('p',{staticClass:"title"},[_vm._v("\n                  "+_vm._s(item.year)+"年"+_vm._s(item.month)+"月 "),_c('span',{staticClass:"title-num"},[_vm._v(_vm._s(item.shopBillQuantity || 0)+"笔")])]),_vm._v(" "),_c('p',{staticClass:"num"},[_vm._v("￥"+_vm._s(item.totalAmount || 0))])])]},proxy:true}],null,true)},[_vm._v(" "),_vm._l((_vm.childrenOrder),function(item1,index1){return _c('div',{key:index1,staticClass:"bill-info"},[(item1.shopBillQuantity)?_c('div',{staticClass:"bill-info2"},[_c('p',{staticClass:"bill-num"},[_vm._v(_vm._s(item1.shopBillQuantity || 0)+"笔")]),_vm._v(" "),_c('p',{staticClass:"bill-info2-status"},[_vm._v("\n                  ￥"+_vm._s(item1.totalAmount || 0)+" \n                  "),_c('span',{staticClass:"setClass",style:({ background: _vm.remitStatusColor[item1.status] })},[_vm._v("\n                    "+_vm._s(_vm.shopStatus[item1.status]))])])]):_vm._e()])})],2)],1)}),1):_vm._e(),_vm._v(" "),(_vm.childIndex == 1)?_c('div',{staticClass:"child2"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"conten"},_vm._l((_vm.orderList),function(item,index){return _c('div',{key:index,staticClass:"content-text"},[_c('van-checkbox',{on:{"change":_vm.handleRadio},model:{value:(item.select),callback:function ($$v) {_vm.$set(item, "select", $$v)},expression:"item.select"}}),_vm._v(" "),_c('div',{staticClass:"right"},[_c('p',{staticClass:"year"},[_vm._v(_vm._s(item.year)+"年"+_vm._s(item.month)+"月")]),_vm._v(" "),_c('div',{staticClass:"num"},[_c('p',{staticClass:"left"},[_vm._v("\n                    "+_vm._s(item.shopBillQuantity || 0)+"笔"),_c('span',{staticClass:"solid"}),_vm._v("￥"+_vm._s(item.totalAmount || 0)+"\n                  ")]),_vm._v(" "),_c('span',{staticClass:"span"},[_vm._v("未出账")])])])],1)}),0)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.childIndex == 1)?_c('div',{staticClass:"btn2"},[_c('van-checkbox',{on:{"click":function($event){_vm.checkedAll ? _vm.handleCheckAll() : _vm.handleCheckAllFlase()}},model:{value:(_vm.checkedAll),callback:function ($$v) {_vm.checkedAll=$$v},expression:"checkedAll"}},[_vm._v("全选")]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('div',{staticClass:"center-count"},[_c('p',{staticClass:"count"},[_vm._v("\n            合计："),_c('img',{attrs:{"src":_vm.icon3,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.sumPrice))])]),_vm._v(" "),_c('p',{staticClass:"count-name"},[_vm._v("\n            本次合计出账："),_c('span',[_vm._v(_vm._s(_vm.sumOrder)+"笔")])])]),_vm._v(" "),_c('p',{staticClass:"a-apply",on:{"click":_vm.checkBillSatus}},[_vm._v("立即申请")])])],1):_vm._e(),_vm._v(" "),(_vm.tabIndex === 1)?_c('div',{staticClass:"recordsCard"},[_c('van-checkbox-group',{model:{value:(_vm.chosedBill),callback:function ($$v) {_vm.chosedBill=$$v},expression:"chosedBill"}},_vm._l((_vm.recordsData && _vm.recordsData.list),function(item,index){return _c('div',{key:index,staticClass:"recordsCard-box marginTop"},[_c('div',{staticClass:"box-item paddingBottom bottom-line"},[_c('span',{staticClass:"solid"}),_vm._v(" "),_c('div',{staticClass:"title"},[(_vm.billFlag === 1 && !_vm.isInvoiceCanALLChosed)?_c('van-checkbox',{staticStyle:{"margin-right":"0.25rem"},attrs:{"disabled":item.status !== 7,"name":item.id},on:{"click":function($event){return _vm.handleCheckInvoice()}}}):_vm._e(),_vm._v("\n              出账编号："+_vm._s(item.settlementBillNo)+"\n            ")],1),_vm._v(" "),_c('div',{staticClass:"val"},[_c('p',{staticClass:"setClass",style:({ background: _vm.remitStatusColor[item.status] })},[_vm._v("\n                "+_vm._s(_vm.shopStatus[item.status])+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-item paddingTop"},[_c('div',{staticClass:"title"},[_vm._v("出账时间")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v("\n              "+_vm._s(item.createdTime)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"box-item paddingTop"},[_c('div',{staticClass:"title"},[_vm._v("收款账户")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v("\n              "+_vm._s(item.bankName)+"-"+_vm._s(item.bankBranchName)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"box-item marginTop paddingTop"},[_c('div',{staticClass:"title"},[_vm._v("收款账号")]),_vm._v(" "),_c('div',{staticClass:"val"},[_vm._v("\n              "+_vm._s(item.bankAccountName)+"\n            ")])]),_vm._v(" "),(item.paymentExplain)?_c('div',{staticClass:"box-item marginTop paddingTop"},[_c('div',{staticClass:"title"},[_vm._v("异常提醒")]),_vm._v(" "),_c('div',{staticClass:"val val2"},[_vm._v("\n              "+_vm._s(item.paymentExplain)+"\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"orderNum"},[_c('p',{staticClass:"orderName"},[_vm._v("\n              订单数："),_c('span',[_vm._v(_vm._s(item.billCount))])]),_vm._v("\n               \n            "),_c('p',{staticClass:"orderName"},[_vm._v("\n              订单总金额：￥"),_c('span',[_vm._v(_vm._s(item.settlementPrice))]),_vm._v("元\n            ")])]),_vm._v(" "),(_vm.billFlag === 1 && item.invoiceUrl)?_c('div',{staticClass:"box-item marginTop paddingTop"},[_c('div',{staticClass:"title"},[_vm._v("发票")]),_vm._v(" "),_c('div',{staticClass:"val"},[_c('p',{staticStyle:{"color":"#1890ff"},on:{"click":function($event){return _vm.handleReviewInvoice(item.invoiceUrl)}}},[_vm._v(" 点击查看 ")])])]):_vm._e()])}),0),_vm._v(" "),(this.recordsData.total === 0)?_c('van-empty',{attrs:{"description":"无结款记录"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.tabIndex === 1 && _vm.billFlag === 1 && !_vm.isInvoiceCanALLChosed)?_c('div',{staticClass:"upload-invoice"},[_c('div',{staticClass:"upload-invoice-btn-left"},[_c('van-checkbox',{attrs:{"disabled":_vm.isInvoiceCanALLChosed},on:{"click":function($event){_vm.checkedInvoiceAll
              ? _vm.handleCheckInvoiceAll()
              : _vm.handleCheckInvoiceAllFlase()}},model:{value:(_vm.checkedInvoiceAll),callback:function ($$v) {_vm.checkedInvoiceAll=$$v},expression:"checkedInvoiceAll"}},[_vm._v("全选")])],1),_vm._v(" "),_c('div',{staticClass:"upload-invoice-btn-right",on:{"click":_vm.openDrawer}},[_c('span',[_vm._v("上传发票")])])]):_vm._e(),_vm._v(" "),(this.recordsData.total > 3 && _vm.tabIndex === 1)?_c('van-pagination',{attrs:{"total-items":this.recordsData.total,"items-per-page":"50","force-ellipses":"","show-page-size":50},on:{"change":function($event){return _vm.changePage($event)}},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.tabIndex === 0 && _vm.childIndex != 1)?_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.handleApplyBill()}}},[_c('tt-button',{attrs:{"text":"一键申请出账","type":_vm.applyNum > 1 ? 'disabled' : 'primary'}})],1):(this.userRole === '员工' || this.userRole === '')?_c('van-empty',{attrs:{"image":"error","description":"权限不足或网络错误"}}):_vm._e(),_vm._v(" "),_c('van-popup',{staticClass:"custormRemit",attrs:{"round":"","position":"bottom","close-on-click-overlay":false},model:{value:(_vm.remitVisible),callback:function ($$v) {_vm.remitVisible=$$v},expression:"remitVisible"}},[_c('p',{staticClass:"title"},[_vm._v("确认结账信息")]),_vm._v(" "),_c('div',{staticClass:"custormRemit-content"},[_c('div',{staticClass:"account first"},[_c('p',[_vm._v("收款账户")]),_vm._v(" "),_c('p',[_vm._v("\n        "+_vm._s(_vm.shopBankCardInfo.bankAccount)+"("+_vm._s(_vm.shopBankCardInfo.bankName)+"-"+_vm._s(_vm.shopBankCardInfo.bankBranchName)+")\n      ")])]),_vm._v(" "),_c('div',{staticClass:"account"},[_c('p',[_vm._v("身份证号码")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.shopBankCardInfo.bankAccountIdCard))])]),_vm._v(" "),_c('div',{staticClass:"account"},[_c('p',[_vm._v("收款账号")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.shopBankCardInfo.bankAccountName))])]),_vm._v(" "),_c('div',{staticClass:"account"},[_c('p',[_vm._v("收款人手机号")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.shopBankCardInfo.bankAccountPhone))])]),_vm._v(" "),_c('div',{staticClass:"account"},[_c('p',[_vm._v("联行号")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.shopBankCardInfo.bankAccountNumber))])]),_vm._v(" "),_c('div',{staticClass:"explain"},[_c('p',{staticClass:"explain-title"},[_vm._v("结账说明")]),_vm._v(" "),_c('p',{staticClass:"explain-info"},[_vm._v("\n        1、每月可提交1次结账申请"),_c('br'),_vm._v("\n        2、提交申请后，工作人员会在次月5号之前完成账单审核"),_c('br'),_vm._v("\n        3、审核成功后，财务人员会在11号之前完成打款"),_c('br'),_vm._v("\n        4、请在申请结账后务必确保打款银行账户信息已录入且正常无误，否则可能影响打款\n        ")]),(_vm.billFlag === 1)?_c('p',{staticStyle:{"color":"red"}},[_vm._v("5、提交出账申请，审核通过后，成功上传发票即可在规定时间收到打款")]):_vm._e(),_vm._v(" "),_c('p')]),_vm._v(" "),(_vm.shopBankCardInfo.isCheck)?_c('div',{staticClass:"classChecked"},[_c('van-checkbox',{attrs:{"checked-color":"#4078ff"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("我已确认收款信息无误且知晓结账说明")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btn-2"},[_c('p',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("暂不结账")]),_vm._v(" "),(_vm.billFlag===1 && _vm.shopBankCardInfo.isCheck)?_c('p',{staticClass:"confim",on:{"click":_vm.handleInvoiceApply}},[_vm._v("\n        确认申请结账\n      ")]):_vm._e(),_vm._v(" "),(_vm.billFlag!==1 && _vm.shopBankCardInfo.isCheck)?_c('p',{staticClass:"confim",on:{"click":_vm.handleApply}},[_vm._v("\n        确认申请结账\n      ")]):_vm._e(),_vm._v(" "),(!_vm.shopBankCardInfo.isCheck)?_c('p',{staticClass:"confim",on:{"click":_vm.goUdate}},[_vm._v("去完善收款信息")]):_vm._e()])]),_vm._v(" "),_c('van-popup',{staticClass:"applycustorm",model:{value:(_vm.noApplyVisible),callback:function ($$v) {_vm.noApplyVisible=$$v},expression:"noApplyVisible"}},[_c('p',{staticClass:"title"},[_vm._v("您本月已申请过1次结账了，不可再次申请！")]),_vm._v(" "),_c('p',{staticClass:"explan"},[_vm._v("结账说明")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      1、每月仅可提交1次结账申请"),_c('br'),_vm._v("\n      2、提交申请后，工作人员会在次月5号之前完成账单审核"),_c('br'),_vm._v("\n      3、审核成功后，财务人员会在11号之前完成打款"),_c('br'),_vm._v("\n      4、请在申请结账后务必确保打款银行账户信息已录入且正常无误，否则可能影响打款\n    ")]),_vm._v(" "),_c('p',{staticClass:"btn",on:{"click":function($event){_vm.noApplyVisible = false}}},[_vm._v("我已知晓")])]),_vm._v(" "),_c('van-popup',{staticClass:"infocustorm",model:{value:(_vm.infoVisible),callback:function ($$v) {_vm.infoVisible=$$v},expression:"infoVisible"}},[_c('p',{staticClass:"title"},[_vm._v("补全信息提示")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      您的收款账户信息不全，请联系您的商户专员进行补全后再来申请！\n    ")]),_vm._v(" "),_c('p',{staticClass:"btn",on:{"click":function($event){_vm.infoVisible = false}}},[_vm._v("我知道了")])]),_vm._v(" "),_c('van-popup',{staticClass:"infocustorm",model:{value:(_vm.isShowTips),callback:function ($$v) {_vm.isShowTips=$$v},expression:"isShowTips"}},[_c('p',{staticClass:"title"},[_vm._v("温馨提示")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      提交完出账申请，审核通过后需在"),_c('span',{staticStyle:{"font-weight":"bolder"}},[_vm._v("结算明细")]),_vm._v("上传发票，即可在规定期限内收到打款\n    ")]),_vm._v(" "),_c('p',{staticClass:"btn",on:{"click":_vm.handleApply}},[_vm._v("确认")])]),_vm._v(" "),_c('van-dialog',{staticClass:"tips-dialog",attrs:{"title":"订单出账状态提示","show-cancel-button":"","confirm-button-text":"立即申请","cancel-button-text":"暂不申请"},on:{"cancel":function($event){_vm.isShow = false},"confirm":_vm.submitApply},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('p',{staticClass:"text"},[_vm._v("\n      您提交的订单中有"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.djNum)+"笔")]),_vm._v("目前处于冻结状态，暂时无法直接进行出账，请联系市场经理为您处理。\n    ")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      另外"),_c('span',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.kczNum)+"笔")]),_vm._v("订单现处于可出账状态，是否申请出账?\n    ")])]),_vm._v(" "),(_vm.drawerShow)?_c('div',{staticClass:"upload-invoice-confirm",on:{"click":function($event){_vm.drawerShow = false}}},[_c('div',{staticClass:"popup-content",style:({ height: _vm.invoiceFileUrl ? '16.1rem' : '11.48rem' }),on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"popup-cont-pic"},[_c('div',{staticClass:"popup-cont-piccont-left",on:{"click":function($event){_vm.showCamera = true}}}),_vm._v(" "),_c('div',{staticClass:"popup-cont-piccont-right"},[_c('div',{staticClass:"img-div"},[_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2025/09/18/00798cf42b634dcc90f0bfb6fd127cc3.jpg"},on:{"click":function($event){return _vm.handleReviewInvoice('https://res.xiaokunkeji.cn/image/2025/09/18/00798cf42b634dcc90f0bfb6fd127cc3.jpg')}}})]),_vm._v(" "),_c('p',[_vm._v("发票示例")])])]),_vm._v(" "),(_vm.invoiceFileUrl)?_c('div',{staticClass:"popup-cont-pic2"},[(_vm.invoiceFileType === 'image')?_c('div',{staticClass:"popup-cont-piccont-left"},[_c('div',{staticClass:"delete-btn",on:{"click":_vm.deleteInvoiceUrl}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.invoiceFileUrl}})]):_vm._e(),_vm._v(" "),(_vm.invoiceFileType === 'file')?_c('div',{staticClass:"popup-cont-piccont-left"},[_c('div',{staticClass:"delete-btn",on:{"click":_vm.deleteInvoiceUrl}}),_vm._v(" "),_c('img',{attrs:{"src":"https://res.xiaokunkeji.cn/image/2025/09/16/fc7054f3f5564a238259f7d3e957d7bf.png"}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-bth"},[_c('div',{staticClass:"popup-bth-left",on:{"click":_vm.closeUploadInvoice}},[_vm._v("\n          取消\n        ")]),_vm._v(" "),_c('div',{staticClass:"popup-bth-right",on:{"click":_vm.uploadInvoice}},[_vm._v("\n          确认上传\n        ")])])])]):_vm._e(),_vm._v(" "),_c('van-dialog',{staticClass:"custormTips4",attrs:{"showConfirmButton":true,"showCancelButton":true,"confirmButtonText":"去签署","title":"提示"},on:{"confirm":_vm.toAssignMent},model:{value:(_vm.visibleAssign),callback:function ($$v) {_vm.visibleAssign=$$v},expression:"visibleAssign"}},[_c('p',{staticClass:"t-content4"},[_vm._v("您好,合作协议已更新需重新签署")])]),_vm._v(" "),_c('camera',{attrs:{"showCamera":_vm.showCamera},on:{"fileUploaded":_vm.fileUploaded,"close":_vm.closeCamera}}),_vm._v(" "),_c('review',{attrs:{"isShow":_vm.isReviewInvioce,"url":_vm.reviewInvioceUrl},on:{"close":_vm.closeRewiveInvoice}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TTHc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TgOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("WfYq");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e45c720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("LxrK");
function injectStyle (ssrContext) {
  __webpack_require__("H3ej")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e45c720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e45c720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Th+8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-4.dce0415.png";

/***/ }),

/***/ "TqMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDownloadBtnStatus),expression:"showDownloadBtnStatus"}],staticClass:"downloadbtn"},[_c('a',{ref:"mlinkref",attrs:{"href":"","id":_vm.mlinkid}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.downloadAppImg,"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.openApp($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ty83":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shopLogo.7b9cf49.png";

/***/ }),

/***/ "UEfU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UII/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allImages.length>0)?_c('tuhu-infinite',{attrs:{"endmsg":"没有更多晒图","distance":100,"nodata":_vm.nodata,"end":_vm.end},on:{"oninfinite":_vm.oninfinite}},[_c('div',{staticClass:"commentPicture",attrs:{"slot":"content"},slot:"content"},[_c('ul',_vm._l((_vm.allImages),function(item,index){return _c('li',{key:index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({src:item,width:'5.4', height:'5.4', group: _vm.group1}),expression:"{src:item,width:'5.4', height:'5.4', group: group1}"}]})])}),0)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "USF0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_5.d2a4c67.png";

/***/ }),

/***/ "UeWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ttButton__ = __webpack_require__("bPVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import VConsole from "vconsole/dist/vconsole.min.js"; // import vconsole
var statusType = {
  '0': '初始状态',
  '1': '已核销',
  '2': '已确认',
  '3': '已取消'
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ttButton: __WEBPACK_IMPORTED_MODULE_3__components_ttButton__["a" /* default */]
  },
  data: function data() {
    return {
      statusType: statusType,
      lock: false,
      codeInfo: {},
      showPupup: false,
      img1: __webpack_require__("gKLg"),
      img2: __webpack_require__("eAMs"),
      orderType: 'MAINTAIN_ORDER',
      carWashList: {
        MAINTAIN_ORDER: [{
          imgType: 'vehicleWorkingPhoto',
          text: '需显露车牌及车店一体的照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '人车合影',
          required: true,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'workingPhoto',
          text: '显露车牌及车店一体的作业中照片',
          required: true,
          isShow: 'isWorkingPhoto'
        }]
      },
      photoMap: {
        isVehicleWorkingPhoto: false, //车辆与门店合照
        isVehicleOilPhoto: false, //机油和车辆合照
        isBeforeWorkPhoto: false, //  作业前照片
        isAfterWorkPhoto: false, //  作业后照片
        isWorkingPhoto: false, // 作业中照片
        isWorkOrderPhoto: false, // 工单照片
        isElseWorkPhoto: false //其他照片 人车合影
      },
      photoList: {
        vehicleWorkingPhoto: '', // 显露车牌及车店一体的作业中照片
        vehicleOilPhoto: '', // 使用的机油与车辆合影照片
        beforeWorkPhoto: '', // 作业前照片
        afterWorkPhoto: '', // 作业后照片
        workingPhoto: '', // 作业中照片
        workOrderPhoto: '', // 工单照片
        elseWorkPhoto: '' // 其他照片
      }
    };
  },

  computed: {
    shopId: function shopId() {
      var shopInfo = tuhu.store.state.userInfo;
      return shopInfo ? shopInfo.shopId : '';
    },
    verifyCode: function verifyCode() {
      return this.options ? this.options.verifyCode : tuhu.getParam('verifyCode');
    }
  },
  mounted: function mounted() {
    // let vConsole = new VConsole();
    this.viewCode();
  },

  methods: {
    upload: function upload(val) {
      if (val && val.code === '200') {
        this.photoList[val.index] = val.data;
      } else {
        tuhu.toast(val.message || '网络错误');
      }
    },
    viewCode: function viewCode() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.GET_VERUFUCATION_CODE, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    id: _this.verifyCode
                  })
                });

              case 2:
                data = _context.sent;

                if (data.code === '200') {
                  _this.codeInfo = data.data;
                  if (data.data.photoMap) {
                    _this.photoMap = data.data.photoMap && JSON.parse(data.data.photoMap);
                  }
                } else {
                  tuhu.toast(data.message);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 立即核销
    sureToOff: function sureToOff() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res, _photoList, vehicleWorkingPhoto, elseWorkPhoto, workingPhoto, data, info;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.codeInfo || _this2.codeInfo.verificationStatus == 2)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', false);

              case 2:
                res = _this2.ckeckImg();

                if (res) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                if (!_this2.lock) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:
                _this2.lock = true;
                _photoList = _this2.photoList, vehicleWorkingPhoto = _photoList.vehicleWorkingPhoto, elseWorkPhoto = _photoList.elseWorkPhoto, workingPhoto = _photoList.workingPhoto;

                tuhu.showIndicator();
                _context2.next = 12;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.TO_VALIDATE, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    id: _this2.verifyCode,
                    shopId: _this2.shopId,
                    isVehicleWorkingPhoto: vehicleWorkingPhoto,
                    isWorkingPhoto: workingPhoto,
                    isElseWorkPhoto: elseWorkPhoto
                  })
                });

              case 12:
                data = _context2.sent;


                if (data.code === '200') {
                  tuhu.hideIndicator();
                  _this2.lock = false;
                  tuhu.toast('核销成功');
                  info = {
                    secondClassName: data.data.serviceProviderName,
                    verificationCode: data.data.providerVerificationCode,
                    orderPrice: data.data.orderPrice,
                    goodsOrderId: data.data.goodsOrderId,
                    id: data.data.id,
                    shopId: data.data.shopId,
                    vehicleWorkingPhoto: data.data.isVehicleWorkingPhoto,
                    workingPhoto: data.data.isWorkingPhoto,
                    elseWorkPhoto: data.data.isElseWorkPhoto
                  };

                  tuhu.sessionStorage.setItem('shopOrderDetail', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info));
                  setTimeout(function () {
                    tuhu.redirectTo({
                      url: '/pages/orderDetail/index',
                      data: {
                        ListInfo: info
                      },
                      query: {
                        success: data.code === '200' ? 1 : ''
                      }
                    });
                  }, 300);
                } else {
                  tuhu.hideIndicator();
                  _this2.lock = false;
                  tuhu.toast(data.message);
                }

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    ckeckImg: function ckeckImg() {
      if (!this.photoList.vehicleWorkingPhoto && this.photoMap.isVehicleWorkingPhoto) return tuhu.toast('请上传显露车牌及车店一体的照片');
      if (!this.photoList.elseWorkPhoto && this.photoMap.isElseWorkPhoto) return tuhu.toast('请上传人车合影照片');
      if (!this.photoList.workingPhoto && this.photoMap.isWorkingPhoto) return tuhu.toast('请上传显露车牌及车店一体的作业中照片');
      return true;
    }
  }
});

/***/ }),

/***/ "UywY":
/***/ (function(module, exports) {

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/12/4
 * desc: commentsall
 */

Vue.directive('commentsall', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, options) {
    $(el).on('click', function () {
      // 只传入一个String参数时跳转不传参数
      if (Object.prototype.toString.call(options.value) === '[object Object]') {
        tuhu.navigateTo({
          url: '/pages/_comments/all',
          query: options.value
        });
      }
    });
  }
});

/***/ }),

/***/ "V0e4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V51g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VBkv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tabs: tuhu.config.tabs,
      tabIndex: tuhu.getParam('_tab', 'number') || 0
    };
  },

  methods: {
    switchTab: function switchTab(index) {
      this.tabIndex = index;
      tuhu.switchTab({
        url: tuhu.config.tabs[index].url
      });
    }
  }
});

/***/ }),

/***/ "VCDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-dialog',{staticClass:"custormTips4",attrs:{"showConfirmButton":false},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('p',{staticClass:"title"},[_vm._v("温馨提示")]),_vm._v(" "),_c('div',{staticClass:"t-content"},[_vm._v("\n      自即日起，通过平台结算，需完成人脸识别认证，未完成则无法完成账户收款，请立即完成认证\n    ")]),_vm._v(" "),_c('div',{staticClass:"t-btns-box"},[_c('div',{on:{"click":_vm.handleClose}},[_vm._v("\n        去认证\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VOoA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VYOR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vn1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"con"},[_c('p',[_vm._v("应付金额")]),_vm._v(" "),_c('h1',[_vm._v("￥"),_c('span',[_vm._v(_vm._s(_vm.totalPrice))])]),_vm._v(" "),_c('div',{staticClass:"pay-type"},[_c('h5',[_vm._v("请选择支付方式")]),_vm._v(" "),_c('div',{staticClass:"type-pay"},[_c('ul',_vm._l((_vm.shopBill.payModels),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.payLogo}}),_c('span',{class:item.payPlatformId},[_vm._v(_vm._s(item.payPlatform))]),_vm._v(" "),_c('van-radio-group',{staticClass:"vradio",model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_c('van-radio',{attrs:{"name":item.payModelId},on:{"click":function($event){return _vm.radioChange(item.payPlatformId)}}})],1)],1)}),0)])])]),_vm._v(" "),_c('van-button',{staticClass:"coll",attrs:{"round":"","type":"info"},on:{"click":_vm.nowPay}},[_vm._v(_vm._s(_vm.payTitle))]),_vm._v(" "),_c('p',{staticClass:"kf"},[_vm._v("支付遇到问题？"),_c('i',{directives:[{name:"call",rawName:"v-call",value:('400-176-8848'),expression:"'400-176-8848'"}],staticStyle:{"color":"#1989fa"}},[_vm._v("联系客服")])]),_vm._v(" "),_c('van-popup',{staticClass:"wait",style:({width: '80%', height: '20%'}),attrs:{"close-on-click-overlay":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-icon',{attrs:{"name":"passed","color":"#999"}}),_vm._v(" "),_c('p',[_vm._v("正在等待顾客支付（"),_c('span',[_vm._v(_vm._s(_vm.sec)+"s")]),_vm._v("）...")])],1),_vm._v(" "),_c('van-popup',{staticClass:"wait",style:({width: '90%', height: '16%'}),attrs:{"close-on-click-overlay":false},model:{value:(_vm.serd),callback:function ($$v) {_vm.serd=$$v},expression:"serd"}},[_c('div',{staticClass:"serd"},[_c('ul',[_c('li',[_c('p',[_c('van-icon',{staticStyle:{"margin-bottom":"10px"},attrs:{"name":"passed","color":"#1989fa"}})],1),_vm._v(" "),_c('span',{staticStyle:{"color":"#1989fa"}},[_vm._v("客户支付成功")])]),_vm._v(" "),_c('li',{staticStyle:{"color":"#eee"}},[_vm._v(".....")]),_vm._v(" "),_c('li',[(_vm.now)?_c('div',[_c('p',{staticStyle:{"margin":"-10px 0px 10px"}},[_c('van-loading',{staticStyle:{"display":"inline-block"},attrs:{"type":"spinner","size":"38px","color":"#1989fa"}})],1),_vm._v(" "),_c('span',[_vm._v("正在创建服务单")])]):_c('div',[_c('p',[_c('van-icon',{staticStyle:{"margin-bottom":"10px"},attrs:{"name":"passed","color":"#1989fa"}})],1),_vm._v(" "),_c('span',[_vm._v("服务单创建成功")])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W/LA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"item-box1"},[_c('div',[_vm._v("太平券码")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.codeInfo.orderId))])]),_vm._v(" "),_c('div',{staticClass:"item-box1"},[_c('div',[_vm._v("券码状态")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.codeInfo.orderType == 1 ? '预约' : '非预约')+"-"+_vm._s(_vm.statusType[_vm.codeInfo.status]))])]),_vm._v(" "),_c('div',{staticClass:"item-box1"},[_c('div',[_vm._v("车牌号码")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.codeInfo.carNumber))])]),_vm._v(" "),_c('div',{staticClass:"item-box1"},[_c('div',[_vm._v("服务名称")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm.codeInfo.companyCode)),_c('br'),_vm._v(_vm._s(_vm.codeInfo.serviceDetailName))])]),_vm._v(" "),_c('div',{staticClass:"item-box2"},[_c('div',{staticClass:"box"},[_c('p',[_vm._v("上传服务照片")]),_vm._v(" "),_c('p',{staticClass:"img",on:{"click":function($event){_vm.showPupup = true}}},[_vm._v("\n          查看范例\n          "),_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("OzHQ"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"cont"},_vm._l((_vm.carWashList[_vm.orderType]),function(item,index){return _c('div',{key:index,staticClass:"li"},[(_vm.photoMap[item.isShow])?_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({
              onUpload: _vm.upload,
              vin: false,
              index: item.imgType,
              refresh: true
            }),expression:"{\n              onUpload: upload,\n              vin: false,\n              index: item.imgType,\n              refresh: true\n            }"}],staticClass:"upload-img"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photoList[item.imgType]),expression:"!photoList[item.imgType]"}],staticClass:"car",attrs:{"src":__webpack_require__("gKLg"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.photoList[item.imgType]),expression:"!photoList[item.imgType]"}],staticClass:"camera",attrs:{"src":__webpack_require__("eAMs"),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoList[item.imgType]),expression:"photoList[item.imgType]"}],staticClass:"upload-img",attrs:{"src":_vm.photoList[item.imgType],"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.photoList[item.imgType]),expression:"photoList[item.imgType]"}],staticClass:"uploadClose",attrs:{"src":__webpack_require__("Py7c"),"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.photoList[item.imgType] = ''}}})]):_vm._e(),_vm._v(" "),(_vm.photoMap[item.isShow])?_c('div',{staticClass:"tips"},[_vm._v("\n            "+_vm._s(item.text)),(item.required)?_c('span',{staticClass:"themeColor"},[_vm._v(" *")]):_vm._e()]):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.sureToOff()}}},[_c('tt-button',{attrs:{"text":_vm.codeInfo.verificationStatus == 1 ? '立即核销' : '不可核销（请客户出示可用的券码）',"type":_vm.codeInfo.verificationStatus == 2 ? 'active' : ''}})],1),_vm._v(" "),_c('van-popup',{staticClass:"popup-about",attrs:{"round":"","closeable":"","position":"bottom"},model:{value:(_vm.showPupup),callback:function ($$v) {_vm.showPupup=$$v},expression:"showPupup"}},[_c('div',{staticClass:"content-block"},[_c('p',{staticClass:"tt"},[_vm._v("图片资料范例")]),_vm._v(" "),_c('p',{staticClass:"tip marginTop marginBottom"},[_vm._v("请按照示例上传完整清晰图片")]),_vm._v(" "),_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("8jTK"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n            需显露车牌及车店一体的照片\n          ")]),_vm._v("\n          示意图\n        ")])]),_vm._v(" "),_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("DhIS"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n            人车合影\n          ")]),_vm._v("\n          示意图\n        ")])]),_vm._v(" "),_c('div',{staticClass:"img2"},[_c('img',{attrs:{"src":__webpack_require__("8jTK"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"marginTop marginBottom textAlignCenter"},[_c('span',{staticStyle:{"color":"#0081F3"}},[_vm._v("\n            显露车牌及车店一体的作业中照片\n          ")]),_vm._v("\n          示意图\n        ")])]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.showPupup = false}}},[_c('tt-button',{attrs:{"text":"知道了"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W0KU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WC/x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WDKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNoBoard),expression:"showNoBoard"}],ref:"keyboard",staticClass:"keys",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.close($event)}}},[_vm._t("default"),_vm._v(" "),_c('div',{class:_vm.showNoBoard ? 'prolist show' : 'prolist'},[(_vm.showTitleBtn)?_c('div',{staticClass:"buttons"},[_c('div',{on:{"click":_vm.close}},[_vm._v("取消")]),_vm._v(" "),_c('div',{on:{"click":_vm.confirm}},[_vm._v("确认")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"specChars"},_vm._l((_vm.speChars),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.handleChoose($event, item)}}},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('div',{staticClass:"numbers"},_vm._l((_vm.numbers),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.handleChoose($event, item)}}},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('div',{staticClass:"chars"},[_vm._l((_vm.chars),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.handleChoose($event, item)}}},[_vm._v(_vm._s(item))])}),_vm._v(" "),_c('div',{staticClass:"delete",on:{"click":_vm.del}},[_vm._v("删除")])],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WO5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WcOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","src":_vm.src + '?type=' + _vm.type}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "We2S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uploadimg.79bc6c3.png";

/***/ }),

/***/ "WfYq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__verifition_Verify_vue__ = __webpack_require__("vMYD");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole


var UUID = tuhu.util.uuid();
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Verify: __WEBPACK_IMPORTED_MODULE_4__verifition_Verify_vue__["a" /* default */]
  },
  data: function data() {
    return {
      options: null,
      locked: false,
      phone: '',
      _loginSuccess: false,
      _blackBox: null,
      readonly: false,
      phoneReadonly: false,
      code: '',
      yzmClass: '',
      codeClass: '',
      codeText: '获取验证码'
    };
  },
  mounted: function mounted() {
    var _this = this;

    // let vConsole = new VConsole()
    // tuhu.localStorage.clear()

    // 保存需要保留的值 这里是滑动验证需要的2个值 需要兼容原来逻辑清楚所有，但本次滑动验证需要保留这两个值
    var sliderValue = localStorage.getItem('slider');
    var pointValue = localStorage.getItem('point');

    // 清空所有
    localStorage.clear();

    // 恢复需要保留的值
    if (sliderValue) localStorage.setItem('slider', sliderValue);
    if (pointValue) localStorage.setItem('point', pointValue);
    if (!this.options) return;
    var phone = this.options.phone;

    if (phone) {
      this.phone = phone + '';
      this.phoneReadonly = true;
      Vue.nextTick(function () {
        _this.getCode();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this._loginSuccess) {
      this.options.resolve({
        islogin: false
      });
    }
  },

  watch: {
    phone: function phone(val) {
      if (val.length > 11) {
        this.phone = val.substr(0, 11);
        return;
      }

      if (val.length === 11 && /\d{11}/.test(val)) {
        this.yzmClass = 'active';
      } else {
        this.yzmClass = '';
      }
    },
    code: function code(val) {
      if (val.length === 4 && /\d{4}/.test(val)) {
        this.codeClass = 'active';
      } else {
        this.codeClass = '';
      }
    },
    yzmClass: function yzmClass(val) {
      var _this2 = this;

      if (val === 'djs') {
        var times = 60;
        this.codeText = times-- + '秒后重发';
        var interval = setInterval(function () {
          _this2.codeText = times-- + '秒后重发';

          if (times < 0) {
            _this2.locked = false;
            _this2.yzmClass = 'active';
            _this2.codeText = '获取验证码';
            clearInterval(interval);
          }
        }, 1000);
      }
    }
  },
  methods: {
    getCodeSuccess: function getCodeSuccess() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.locked = true;
                _this3.yzmClass = 'djs';
                _this3.readonly = false;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    clear: function clear(val) {
      this[val] = '';
    },

    // back() {
    //   return tuhu.navigateBack()
    // },
    signIn: function signIn() {
      var _this4 = this;

      if (!this.phone || this.phone.length !== 11) return tuhu.toast('请填写手机号');
      if (!this.code) return tuhu.toast('请填写验证码');
      var params = {
        phone: this.phone,
        verificationCode: this.code,
        source: 3, // 来源，商户端3
        openId: tuhu.getParam('openId')
      };

      tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.LOGIN, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
      }).then(function (data) {
        console.log(data, data.code === '200');
        if (data && data.code === '200') {
          tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO).then(function (res) {
            // get用户信息
            if (res && res.code === '200') {
              _this4._loginSuccess = true;

              var userInfoPromise = tuhu._setUserInfo(res.data); // 返回数据

              if (_this4.options && _this4.options.resolve) {
                _this4.options.resolve(userInfoPromise);
              }
              // tuhu.navigateTo({
              //   url: '/pages/home/index'
              // })
              if (location.host.indexOf('localhost') > -1) {
                setTimeout(function () {
                  location.replace(location.origin + '/pages/home/index');
                }, 200);
              } else {
                setTimeout(function () {
                  location.replace(location.origin + '/shop/index.html');
                }, 200);
              }

              // location.replace(`${location.origin}/shop/index.html`)

              // // openId为微信环境 后端返回
              // if ((this.options && !this.options.direct && !this.options.redirectUrl) || tuhu.getParam('openId')) {
              //   if (location.host.indexOf('localhost') > -1) {
              //     setTimeout(() => {
              //       location.replace(`${location.origin}/pages/home/index`)
              //     }, 200)
              //   } else {
              //     setTimeout(() => {
              //       location.replace(`${location.origin}/shop/index.html`)
              //     }, 200)
              //   }
              // }
            } else {
              tuhu.toast(data.message || '网络异常');
              console.log('未获取到用户信息');
            }
          });
        } else {
          tuhu.toast(data.message || '网络错误');
        }
      }).catch(function () {
        return {
          islogin: false
        };
      });
    },
    getCode: function getCode() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this5.locked) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (_this5.yzmClass) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _this5.$refs.verify.show();

                /*  this.locked = true
                setTimeout(() => {
                  tuhu
                    .fetch(`${config.apis.GET_CODE}` + `/${this.phone}/3`)
                    .then(data => {
                      if (data.code === '200') {
                        this.yzmClass = 'djs'
                        this.readonly = false
                      } else {
                        this.locked = false
                        tuhu.toast(data.message || '网络异常')
                      }
                    })
                    .catch(() => {
                      this.locked = false
                    })
                }, 1000) */

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  }
});

/***/ }),

/***/ "WpgC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X0T2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imgs_hu_png__ = __webpack_require__("KuuQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imgs_hu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__imgs_hu_png__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loaded: {},
      back: false,
      index: this.options.other.index || 0,
      pb: null
    };
  },

  methods: {
    getPhotos: function getPhotos() {
      var photos = [];
      this.options.photos.forEach(function (item, index) {
        photos.push(__WEBPACK_IMPORTED_MODULE_0__imgs_hu_png___default.a);
      });

      return photos;
    },
    setPb: function setPb() {
      var _this = this;

      var pagination = $.Swiper.prototype.defaults.pagination;
      $.Swiper.prototype.defaults.pagination = '';

      var photos = this.getPhotos();

      var template = '<div class="photo-browser-closeIcon"></div>';

      if (this.options.other.showPage) {
        template += '<div class="showpage">\n                        <div class="photo-browser-current"></div>\n                        /<div class="photo-browser-total"></div>\n                      </div>';
      }

      var param = {
        photos: photos,
        onClose: function onClose() {
          $.Swiper.prototype.defaults.pagination = pagination;

          if (!_this.back) {
            history.go(-1);
          }
        },
        navbarTemplate: template
      };
      var pb = $.photoBrowser(param);

      pb.open(this.index);
      // $(pb.container).find('.photo-browser-closeIcon').on('click', () => {
      //   pb.close()
      // })

      var count = 0;
      $(pb.container).on('click', function (ev) {
        count++;

        setTimeout(function () {
          if (count === 1) {
            pb.close();
          }

          count = 0;
        }, 300);
        // if (ev.target.nodeName !== 'IMG') {
        //   close(ev)
        // } else {
        //   setTimeout(() => {
        //     if (ev.target.larged) {
        //       close(ev)
        //     } else if ($(ev.target).css('transform') === 'none') {
        //       close(ev)
        //     } else {
        //       setTimeout(() => {
        //         ev.target.larged = true
        //       }, 300)
        //     }
        //   }, 300)
        // }
      });

      pb.onSliderTransitionEnd = function () {
        if (pb.activeIndex !== _this.index) {
          _this.index = pb.activeIndex;

          _this.loadImg();
        }
      };

      this.pb = pb;
    },
    loadImg: function loadImg() {
      var img = $(this.pb.container).find('.photo-browser-zoom-container').eq(this.index).find('img');
      if (!this.loaded[this.index]) {
        img.attr('src', this.options.photos[this.index]);
        this.loaded[this.index] = true;
      }
    }
  },
  created: function created() {
    this.setPb();
    this.loadImg(this.index);
  },
  beforeDestroy: function beforeDestroy() {
    this.back = true;
    this.pb.close();
  }
});

/***/ }),

/***/ "XLZH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XQ5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sildePopup_vue__ = __webpack_require__("+2ZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sildePopup2_vue__ = __webpack_require__("sL9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sildePopup3_vue__ = __webpack_require__("8t5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_slideTip_vue__ = __webpack_require__("+T4a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_holidayConfirm_vue__ = __webpack_require__("7qK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vconsole_dist_vconsole_min_js__ = __webpack_require__("Lw6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vconsole_dist_vconsole_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vconsole_dist_vconsole_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__imgs_image_home_car_png__ = __webpack_require__("7l/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__imgs_image_home_car_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__imgs_image_home_car_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__imgs_image_home_order_png__ = __webpack_require__("1SyJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__imgs_image_home_order_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__imgs_image_home_order_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_kefu__ = __webpack_require__("lamQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_locale_zh_cn__ = __webpack_require__("Vz2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment_locale_zh_cn__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






 // import vconsole
// import defaultImg from "@/imgs/image/defaultHead.png";

// import homeOwner from "@/imgs/image/home_owner.png";

// import homeSettlementRecords from "@/imgs/image/home_settlementRecords.png";
// import homeAccounts from "@/imgs/image/home_accounts.png";
// import washcar from "@/imgs/image/washcar.png";



// import WxConfig from "../../../lib/commons/wxconfig";
// import compareTime from "@/commons/secret";


__WEBPACK_IMPORTED_MODULE_16_moment___default.a.locale('zh-cn');

var enterList = [{
  name: '门店信息',
  key: 'shopInfo',
  icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/3ffc29b178ef4e5f9ec8ed04ddda1559.png',
  url: '/pages/shopInfo/index',
  badge: null
}, {
  name: '门店服务',
  key: 'shopService',
  icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/ffe206fb74244d10929c842acc0c36cf.png',
  url: '/pages/shopService/index',
  badge: null
}, {
  name: '员工管理',
  key: 'userManagement',
  icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/cfa35095c70443d9a997db104e880583.png',
  url: '/pages/userManagement/index',
  badge: null
}, {
  name: '结算管理',
  key: 'settlementRecords',
  icon: 'https://res.xiaokunkeji.cn/image/2023/12/07/4faffd44f77849dfb28adf0b376b08d2.png',
  url: '/pages/settlementRecords/index',
  badge: null
}, {
  name: '收款账户',
  key: 'accounts',
  icon: 'https://res.xiaokunkeji.cn/image/2026/10/22/26677c2b0a8d455e925f4752f4aabb8b.png',
  url: '/pages/accounts/index',
  badge: null
}, {
  name: '发票信息',
  key: 'invoice',
  icon: 'https://res.xiaokunkeji.cn/image/2025/09/12/e9bf6cb7cdae4582bdd4408cf888c26b.png',
  url: '/pages/invoice/index',
  badge: null
}, {
  name: '服务协议',
  key: 'assignMent',
  icon: 'https://res.xiaokunkeji.cn/image/2026/10/22/a7a5e4ef7abb4790bac539588a0a3802.png',
  url: '/pages/assignMent/index',
  badge: null
}, {
  name: '人脸认证',
  key: 'faceAuthen',
  icon: 'https://res.xiaokunkeji.cn/image/2026/10/22/fa4ba79e0c544ab4b3a756cac8e74e77.png',
  url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=https%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect',
  // 处理滚动事件',
  badge: null
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    kefu: __WEBPACK_IMPORTED_MODULE_13__components_kefu__["a" /* default */],
    slideTip: __WEBPACK_IMPORTED_MODULE_8__components_slideTip_vue__["a" /* default */],
    sildePopup: __WEBPACK_IMPORTED_MODULE_5__components_sildePopup_vue__["a" /* default */],
    sildePopup2: __WEBPACK_IMPORTED_MODULE_6__components_sildePopup2_vue__["a" /* default */],
    sildePopup3: __WEBPACK_IMPORTED_MODULE_7__components_sildePopup3_vue__["a" /* default */],
    holidayConfirm: __WEBPACK_IMPORTED_MODULE_9__components_holidayConfirm_vue__["a" /* default */]
  },
  computed: {
    userInfo: function userInfo() {
      return tuhu.store.state.userInfo;
    },
    locationInfo: function locationInfo() {
      return tuhu.store.state.location;
    },
    userAuthList: function userAuthList() {
      return this.userInfo.authList || [];
    },
    allOrder: function allOrder() {
      var list = this.userAuthList;
      return list.findIndex(function (key) {
        return key === 'allOrder';
      }) >= 0;
    },
    todayOrder: function todayOrder() {
      var list = this.userAuthList;
      return list.findIndex(function (key) {
        return key === 'todayOrder';
      }) >= 0;
    },
    marketManage: function marketManage() {
      var list = this.userAuthList;
      return list.findIndex(function (key) {
        return key === 'marketingManagement';
      }) >= 0;
    },
    veryCoupon: function veryCoupon() {
      var list = this.userAuthList;
      return list.findIndex(function (key) {
        return key === 'veryCoupon';
      }) >= 0;
    },
    tabList: function tabList() {
      var _this = this;

      var assignment = this.currentShopData.assignment;
      var signFlag = this.currentShopData.signFlag;
      var billFlag = this.userInfo.billFlag;
      var arr = enterList.filter(function (item) {
        return item.key !== 'invoice' || billFlag === 1;
      }).filter(function (item) {
        return signFlag !== 0 || signFlag === 0 && item.key !== 'assignMent';
      }).map(function (item) {
        return item.key === 'invoice' ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, { hasAuth: billFlag === 1 }) : item;
      });
      arr.forEach(function (item) {
        var cItem = _this.userAuthList.find(function (v) {
          return v === item.key;
        });
        if (cItem) {
          item['hasAuth'] = true;
        } else {
          item['hasAuth'] = false;
        }
        if (item.key === 'invoice') item['hasAuth'] = true;
        if (!assignment && item.key === 'assignMent') item.badge = '!';else item.badge = null;
      });
      return arr;
    },
    currentShopInfo: function currentShopInfo() {
      return tuhu.store.state.currentShopInfo;
    }
  },
  data: function data() {
    window.pagesHomeVUe = this;
    return {
      currentIndex: 0,
      noticeDialogs: [{ id: 4, show: false, containSlideId: true }, //中秋国庆营业确认（最高优先级）
      { id: 1, show: false, containSlideId: true }, //重点税务公告
      { id: 2, show: false, containSlideId: true }, //重要打款公告
      { id: 3, show: false, containSlideId: true //老板去认证
      }],
      noticeIds: null,
      shopSignUrl: '',
      visibleAssign: false, //是否显示合作协议重新签署弹窗
      pendingAssign: false, //合作协议弹窗延迟标记（等营业确认弹窗关闭后再弹出）
      commonText: '',
      visibleSlidePop: false, //15秒滚动弹窗
      visiblePopup: false,
      tipsVisible: false,
      btn: __webpack_require__("vEpc"),
      tips: __webpack_require__("um+J"),
      left: __webpack_require__("qm4d"),
      icon1: __webpack_require__("pzd1"),
      tpVisible: false, // 太平核销券
      CollectionAccount: [],
      userName: '',
      showAllShop: false,
      shopOpen: false,
      shopId: '',
      shopList: [],
      currentShopData: {},
      activeId: 0,
      tabList1: [{
        name: '所有订单',
        key: 'allOrder',
        icon: __WEBPACK_IMPORTED_MODULE_11__imgs_image_home_car_png___default.a,
        url: '/pages/orderAll/index'
      }],
      tabList2: [{
        name: '今日订单',
        key: 'todayOrder',
        icon: __WEBPACK_IMPORTED_MODULE_11__imgs_image_home_car_png___default.a,
        url: '/pages/orderToday/index'
      }],
      marketManageList: [{
        name: '市场经理',
        key: 'marketingManagement',
        icon: __WEBPACK_IMPORTED_MODULE_12__imgs_image_home_order_png___default.a,
        url: '/pages/marketingManagement/index'
      }],
      shopStatus: '',
      radio: 0,
      vConsolePhone: ['15068788141', '18379008896', '18056928085', '16608671350', '15257122457', '17752526745', '19956900629'],
      tiktokVisible: false, //抖音结算说明
      tiktokOrder: {}
    };
  },
  mounted: function mounted() {
    if (this.vConsolePhone.indexOf(this.userInfo.phone) > -1) {
      var vConsole = new __WEBPACK_IMPORTED_MODULE_10_vconsole_dist_vconsole_min_js___default.a();
    }
  },
  created: function created() {
    this.init();
    this.processNext();
  },

  methods: {
    // 去签订新的协议
    toAssignMent: function toAssignMent() {
      tuhu.navigateTo({
        url: '/pages/assignMent/index',
        query: {
          shopId: this.currentShopData.shopId,
          cryptoId: this.currentShopData.cryptoId
        }
      });
    },
    handleClose: function handleClose(id) {
      var _this2 = this;

      var index = this.noticeDialogs.findIndex(function (d) {
        return d.id === id;
      });
      this.$set(this.noticeDialogs, index, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.noticeDialogs[index], {
        containSlideId: true,
        show: false
      }));
      // 放假弹窗（id=4）未提交接口，需手动移动 currentIndex 避免重复弹出；其他弹窗走正常 processNext 逻辑
      if (id === 4) {
        this.currentIndex = index + 1;
        // 未提交时临时将 4 加入 noticeIds，防止 processNext 再次弹出营业确认
        if (!this.noticeIds.includes(4)) {
          this.noticeIds.push(4);
        }
        // 营业确认关闭后，展示待弹出的合作协议弹窗
        if (this.pendingAssign) {
          this.pendingAssign = false;
          this.visibleAssign = true;
        }
      }
      setTimeout(function () {
        return _this2.processNext();
      }, 300);
    },

    // 处理下一个弹窗
    processNext: function processNext() {
      this.noticeIds = this.userInfo.noticeIds || [];
      if (this.currentIndex >= this.noticeDialogs.length) return;
      var currentDialog = this.noticeDialogs[this.currentIndex];
      var v1 = tuhu.localStorage.getItem('visibleSlidePop') || null;
      // 营业确认弹窗（id=4）超过截止时间 2026-09-30 23:59:59 后不再展示，直接跳过
      if (currentDialog.id === 4 && Date.now() > new Date('2026-09-30T23:59:59').getTime()) {
        // 超过截止时间仍需弹出待处理的协议弹窗
        if (this.pendingAssign) {
          this.pendingAssign = false;
          this.visibleAssign = true;
        }
        this.currentIndex++;
        this.processNext();
        return;
      }
      // 检查是否存在当前弹窗
      if (!this.noticeIds.includes(currentDialog.id)) {
        console.log('不存在当前弹窗', currentDialog.id);
        this.$set(this.noticeDialogs, this.currentIndex, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentDialog, {
          containSlideId: false,
          show: true
        }));
        return;
      } else {
        console.log('存在当前弹窗', currentDialog.id);
        if (currentDialog.id === 1) {
          this.$set(this.noticeDialogs, 0, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentDialog, {
            containSlideId: true,
            show: v1 == 1 ? true : false
          }));
        } else {
          this.$set(this.noticeDialogs, this.currentIndex, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentDialog, {
            containSlideId: true,
            show: false
          }));
        }
        // 营业确认弹窗已提交被跳过时，展示待弹出的合作协议弹窗
        if (currentDialog.id === 4 && this.pendingAssign) {
          this.pendingAssign = false;
          this.visibleAssign = true;
        }
      }
      this.noticeIds = this.userInfo.noticeIds || [];
      // 存在则继续下一个
      this.currentIndex++;
      this.processNext();
    },

    // 展示条里点进去
    handleShowSlide: function handleShowSlide(typeIndex) {
      var currentDialog = this.noticeDialogs[typeIndex];
      this.currentIndex = typeIndex;
      console.log();
      // 检查是否存在当前弹窗
      this.$set(this.noticeDialogs, typeIndex, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, currentDialog, {
        containSlideId: true,
        show: true
      }));
    },


    // 抖音核销
    handleDyZone: function handleDyZone(url) {
      tuhu.navigateTo({
        url: url,
        query: {
          shopId: this.currentShopData.shopId,
          date: __WEBPACK_IMPORTED_MODULE_16_moment___default()().format('YYYY-MM-DD')
        }
      });
    },

    // 抖音扫码
    handleDySRcode: function handleDySRcode() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.wxsdk.scanDY();

              case 2:
                res = _context.sent;


                if (res.resultStr.indexOf('tiktok') > -1) {
                  _this3.getTiktokPreverify(res);
                } else {
                  tuhu.navigateTo({
                    url: '/pages/tiktok/verify',
                    query: {
                      path: res.resultStr,
                      shopId: _this3.currentShopData.shopId,

                      shopName: _this3.currentShopData.shopName
                    }
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },


    // 抖音保养新核销接口
    getTiktokPreverify: function getTiktokPreverify(res) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                tuhu.showIndicator();
                _context2.next = 4;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_TIKTOK_MAINTAIM_MERCHANT_PERPARE, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    code: res.resultStr,
                    shopId: _this4.currentShopData.shopId
                  })
                });

              case 4:
                _data = _context2.sent;

                if (_data.code === '200') {
                  tuhu.hideIndicator();
                  tuhu.toast('核销成功');
                } else {
                  tuhu.hideIndicator();
                  tuhu.toast(_data.message);
                }
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                tuhu.hideIndicator();
                console.log('err', _context2.t0);
                tuhu.toast(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 8]]);
      }))();
    },


    //抖音今天订单数量
    queryDataList: function queryDataList() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tuhu.showIndicator();
                _context3.next = 3;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_TIKTOK_ORDER_DAY_RECORD + '?shopId=' + _this5.currentShopData.shopId + '&date=' + __WEBPACK_IMPORTED_MODULE_16_moment___default()().format('YYYY-MM-DD'));

              case 3:
                res = _context3.sent;

                if (res && res.code === '200') {
                  _this5.tiktokOrder = res.data;
                  tuhu.hideIndicator();
                } else {
                  tuhu.hideIndicator();
                  tuhu.toast(data.message || '网络错误');
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    handleView: function handleView() {
      if (this.userInfo.billFlag === 0) {
        tuhu.navigateTo({
          url: '/pages/home/text'
        });
      } else if (this.userInfo.billFlag === 1) {
        tuhu.navigateTo({
          url: '/pages/home/textInvoice'
        });
      }
    },
    handleGoToSD: function handleGoToSD() {
      tuhu.navigateTo({
        url: 'http://m.hzqmtech.com/distribution/channel/SDSYT_XK/' + this.userInfo.shopId
      });
    },
    handleGoToRX: function handleGoToRX() {
      tuhu.navigateTo({
        url: 'http://m.hzqmtech.com/distribution/channel/RXSYT_XK/' + this.userInfo.shopId
      });
    },
    handleGoToTP: function handleGoToTP() {
      tuhu.wxsdk.scanTP();
    },
    init: function init() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.getShopList();

              case 2:
                _context4.next = 4;
                return _this6.getHomeData();

              case 4:
                _context4.next = 6;
                return _this6.getTPcode();

              case 6:
                //暂时用不到
                _this6.time();
                tuhu.wxsdk.hideBtn(); // 禁止分享 复制链接

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    time: function time() {
      var nowDate = new Date();
      var startDate = new Date('2025/01/21 00:00:00');
      var endDate = new Date('2025/03/26 23:59:59');
      if (nowDate > startDate && nowDate < endDate) {
        this.commonText = '\u60A8\u597D\uFF01\u4E3A\u4E86\u7ED9\u60A8\u63D0\u4F9B\u66F4\u52A0\u4FBF\u6377\u7684\u670D\u52A1\uFF0C\u6211\u4EEC\u5C06\u628A\u5C0F\u9CB2\u6838\u9500\u7684\u4F7F\u7528\u5E73\u53F0\u7531\u539F\u6765\u7684\u201C\u5C0F\u9CB2\u8F66\u670D\u201D\u516C\u4F17\u53F7\u8FC1\u79FB\u81F3\u201C\u5C0F\u9CB2\u8F66\u670D\u5546\u6237\u7AEF\u201D\u516C\u4F17\u53F7\u3002\u8BF7\u60A8\u5C3D\u5FEB\u5173\u6CE8 \u201C\u5C0F\u9CB2\u8F66\u670D\u5546\u6237\u7AEF\u201D \u516C\u4F17\u53F7\uFF0C\u5E76\u70B9\u51FB\u5DE6\u4E0B\u89D2\u7684 \u201C\u5546\u6237\u5E73\u53F0\u201D \u8FDB\u884C\u767B\u5F55\u3002<br>\u6211\u4EEC\u8877\u5FC3\u611F\u8C22\u60A8\u4E00\u76F4\u4EE5\u6765\u5BF9\u5C0F\u9CB2\u7684\u652F\u6301\u4E0E\u4FE1\u4EFB\uFF0C\u82E5\u6B64\u6B21\u8FC1\u79FB\u7ED9\u60A8\u5E26\u6765\u4E0D\u4FBF\uFF0C\u656C\u8BF7\u8C05\u89E3\u3002';
        this.visiblePopup = true;
      }
      // tuhu
      //   .fetch(`${config.apis.GET_MERCHANT_VERIFY_FIRST_TIME}`, {
      //     method: "post",
      //     body: JSON.stringify({ shopId: this.userInfo.shopId })
      //   })
      //   .then(data => {
      //     if (data.code === '200') {
      //       let nowDate = new Date();
      //       if (data.data) {
      //         this.commonText = `感谢您对我们的支持！我们更新了系统功能：<br>申请出账时需补充收款人实名认证的手机号码，请如实填写，避免影响出账。如果您在申请出账时遇到无法提交的情况，请尝试刷新页面或清理微信缓存。具体操作为：微信-我-设置-通用-存储空间-缓存-去清理（此操作不会影响历史聊天记录）。如需进一步的帮助，请致电客服热线400-176-8848。对此带来的不便，我们深表歉意，感谢您的理解与支持。 祝好！`;
      //         this.visiblePopup = true;
      //       } else {
      //         let startDate = new Date("2025/01/21 00:00:00");
      //         let endDate = new Date("2025/02/13 23:59:59");
      //         if (nowDate > startDate && nowDate < endDate) {
      //           this.commonText =
      //             "您好！2025年春节将近，我司洗美类线下服务将在2025年1月08日至2025年02月13日(农历正月十六)期间暂停下单或使用，商户端也将在此期间关闭核销功能。 感谢您在过去一年对小鲲科技的支持与信任，小鲲科技全体员工提早祝您春节愉快，万事如意!";
      //           this.visiblePopup = true;
      //         }
      //       }
      //     } else {
      //       tuhu.toast(data.message || "网络错误");
      //     }
      //   });
    },
    closeTipsVisible: function closeTipsVisible() {
      localStorage.setItem('isShow', null);
      this.tipsVisible = false;
      this.handleView();
    },
    closeTipsVisible2: function closeTipsVisible2() {
      localStorage.setItem('isShow', null);
      this.tipsVisible = false;
    },
    geDataList: function geDataList() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tuhu.fetch(__WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_SHOP_URL_PROVIDE + '/' + _this7.userInfo.shopId + '/1').then(function (data) {
                  if (data.code === '200') {
                    _this7.CollectionAccount = data.data;
                  } else {
                    _this7.CollectionAccount = [];
                  }
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },

    // 太平核销展示
    getTPcode: function getTPcode() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                tuhu.fetch(__WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_QUERY_TP + '?shopId=' + _this8.userInfo.shopId).then(function (data) {
                  if (data.code === '200') {
                    if (data.data) _this8.tpVisible = true;else _this8.tpVisible = false;
                  } else {
                    _this8.tpVisible = false;
                  }
                });

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    getHomeData: function getHomeData() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _data2, noticeIds, res, status;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                tuhu.showIndicator();
                _context7.prev = 1;
                _context7.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SWITCH_SHOP + '?shopId=' + _this9.userInfo.shopId);

              case 4:
                _data2 = _context7.sent;

                if (!(_data2 && _data2.code === '200')) {
                  _context7.next = 18;
                  break;
                }

                _this9.currentShopData = _data2.data;
                tuhu.sessionStorage.setItem('assignment', !_data2.data.assignment ? '0' : '1');
                tuhu.sessionStorage.setItem('signFlag', _data2.data.signFlag);
                _this9.shopSignUrl = _data2.data.shopSignUrl;
                // 营业确认弹窗优先：noticeIds 含 4 说明已提交不需要弹，直接展示合作协议；否则延迟到营业确认关闭后再弹
                if (!_data2.data.assignment && _data2.data.signFlag !== 0) {
                  noticeIds = _this9.userInfo.noticeIds || [];

                  if (noticeIds.includes(4)) {
                    _this9.visibleAssign = true;
                  } else {
                    _this9.pendingAssign = true;
                  }
                }
                if (_data2.data.tiktokShop) {
                  _this9.queryDataList();
                }
                _context7.next = 14;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SHOP_OPEN_INFO, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _data2.data.shopId
                  })
                });

              case 14:
                res = _context7.sent;

                if (res && res.code === '200') {
                  tuhu.hideIndicator();
                  status = res.data.shopStatus;

                  _this9.shopStatus = status;
                  tuhu.store.commit('setCurrentShopInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_data2.data, { shopStatus: status }));
                  // 单选按钮 高亮
                  _this9.shopList.forEach(function (val, index, arr) {
                    if (val.id === _data2.data.shopId) {
                      _this9.radio = index;
                    }
                  });
                } else {
                  tuhu.hideIndicator();
                  tuhu.toast(res.message || '网络错误');
                  console.log('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SHOP_OPEN_INFO, res);
                }
                _context7.next = 21;
                break;

              case 18:
                tuhu.hideIndicator();
                tuhu.toast(_data2.message || '网络错误');
                console.log('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SWITCH_SHOP, _data2);

              case 21:
                _context7.next = 27;
                break;

              case 23:
                _context7.prev = 23;
                _context7.t0 = _context7['catch'](1);

                tuhu.hideIndicator();
                console.log('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SWITCH_SHOP, _context7.t0);

              case 27:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[1, 23]]);
      }))();
    },
    getShopList: function getShopList() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _data3;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                tuhu.showIndicator();
                _context8.prev = 1;
                _context8.next = 4;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_SHOPLIST_BYID, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ traderId: _this10.userInfo.userId })
                });

              case 4:
                _data3 = _context8.sent;

                if (_data3 && _data3.code === '200') {
                  tuhu.hideIndicator();
                  _this10.shopList = _data3.data || [];
                } else {
                  tuhu.hideIndicator();
                  tuhu.toast(_data3.message || '网络错误');
                  console.log('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_SHOPLIST_BYID, _data3);
                }
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8['catch'](1);

                tuhu.hideIndicator();
                console.log('' + __WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.GET_SHOPLIST_BYID, _context8.t0);

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[1, 8]]);
      }))();
    },
    handleVerify: function handleVerify() {
      tuhu.navigateTo({
        url: '/pages/verifyCode/index',
        query: {
          shopId: this.currentShopData.shopId
        }
      });
    },
    handleClick: function handleClick(item) {
      if (!item.hasAuth) return tuhu.toast('您无查看权限');
      if (item.url.indexOf('https://') === 0) {
        location.href = item.url;
        return;
      }

      if (item.key === 'assignMent' && this.currentShopData.assignment) {
        window.open(this.shopSignUrl);
        //  tuhu.navigateTo({
        //   url: '/pages/common/review',
        //   query: {
        //     url: this.shopSignUrl
        //   }
        //   });
        return;
      }
      tuhu.navigateTo({
        url: item.url,
        query: {
          shopId: this.currentShopData.shopId,
          cryptoId: this.currentShopData.cryptoId
        }
      });
    },
    handleClick2: function handleClick2(item) {
      if (item.key === 'allOrder') {
        if (this.allOrder) {
          tuhu.navigateTo({
            url: item.url
          });
        } else {
          tuhu.toast('您无查看权限');
        }
      } else if (item.key === 'todayOrder') {
        if (this.todayOrder) {
          tuhu.navigateTo({
            url: item.url
          });
        } else {
          tuhu.toast('您无查看权限');
        }
      } else {}
    },

    // 切换门店
    handleSelect: function handleSelect(item) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var _data4, res;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SWITCH_SHOP + '?shopId=' + item.id);

              case 3:
                _data4 = _context9.sent;

                if (!(_data4 && _data4.code === '200')) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 7;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_14__configs_config__["a" /* default */].apis.SWITCH_USER_COUNT + '/' + item.id);

              case 7:
                res = _context9.sent;

                if (res && res.code === '200') {
                  tuhu.toast('切换成功');
                  setTimeout(function () {
                    location.reload();
                    // this.getShopList();
                    // this.getHomeData();
                    // this.geDataList();
                    _this11.getTPcode();
                  }, 300);
                } else {
                  tuhu.toast(res.message || '切换账号出错');
                }
                _context9.next = 12;
                break;

              case 11:
                tuhu.toast(_data4.message || '网络错误');

              case 12:
                _context9.next = 17;
                break;

              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9['catch'](0);

                console.log(_context9.t0);

              case 17:
                _this11.showAllShop = false;

              case 18:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[0, 14]]);
      }))();
    },
    upload: function upload(val) {
      if (val && val.code === '200' && val.data) {
        this.shopHeadImg = val.data;
        this.changeShopDoorImg(val.data);
      }
    },
    handleOpenTips: function handleOpenTips() {
      tuhu.alert('门店营业状态为已关闭，无法核销，请至【门店信息】开启营业');
    },
    scanQrcode: function scanQrcode() {
      tuhu.wxsdk.scanQR();
    },

    // 返回到home刷新数据
    onPageBack: function onPageBack(to, from) {
      if (to.path.indexOf('/pages/home/index') > -1) {
        this.init();
      }
    }
  }
});

/***/ }),

/***/ "XRQx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XTwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var API_SELECT_AREA = 'https://api.tuhu.cn/Shops/SelectShopListArea';

var API_SELECT_CATEGORIES = 'https://api.tuhu.cn/Shops/SelectShopCategories';

var API_SELECT_LIST = 'https://api.tuhu.cn/Shops/SelectShopList';

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeCreate: function beforeCreate() {
    var _this = this;

    tuhu.showIndicator();

    this.allPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([tuhu.getDefaultCar(2, true), tuhu.getLocate()]);
    tuhu.fetch(API_SELECT_CATEGORIES).then(function (data) {
      _this.services = data.Data.Services;
      _this.beauty = data.Data.Beauty;
    });
  },
  created: function created() {
    var _this2 = this;

    this.getArea().then(function () {
      return _this2.getList();
    });
  },
  data: function data() {
    return {
      car: null,
      locate: null,
      noData: false,
      end: false,
      serviceName: '标准洗车',
      pageIndex: 1,
      list: [],
      pids: 4,
      sortIndex: 3,
      tabIndex: -1,
      serviceType: 7,
      shows: {},
      selectArea: '',
      areaList: [],
      cateGories: [],
      beauty: [],
      services: [],
      sorts: [{
        name: '默认排序',
        sort: 'HuShi'
      }, {
        name: '附近优先',
        sort: ''
      }, {
        name: '累计安装',
        sort: 'Install'
      }, {
        name: '评分最高',
        sort: 'Grade'
      }],
      shopsName: [{
        name: '全部门店',
        serviceType: 0
      }, {
        name: '美容门店',
        serviceType: 7
      }, {
        name: '轮胎门店',
        serviceType: 1
      }, {
        name: '保养门店',
        serviceType: 2
      }, {
        name: '安装门店',
        serviceType: 4
      }, {
        name: '改装门店',
        serviceType: 6
      }]
    };
  },

  methods: {
    init: function init() {
      this.shows = {};
      this.list = [];
      this.pageIndex = 1;
      this.noData = false;
      this.end = false;
    },
    hideTabs: function hideTabs() {
      this.shows = {};
    },
    oninfinite: function oninfinite(ev, resolve, reject) {
      var _this3 = this;

      this.getList().then(function (data) {
        _this3.end = _this3.pageIndex > data.TotalPage;

        resolve();
      });
    },
    getList: function getList() {
      var _this4 = this;

      var locate = this.locate;
      var car = this.car;

      var query = {
        LatBegin: locate.latitude,
        LngBegin: locate.longitude,
        Province: locate.province,
        city: locate.city,
        district: this.selectArea,
        pageIndex: this.pageIndex++,
        serviceType: this.serviceType,
        shopClassification: '',
        sort: this.sorts[this.sortIndex].sort,
        vehicleId: car.ProductID,
        isMatchRegion: 1
      };

      if (this.pids !== null) {
        query.pids = this.pids;
      }

      return tuhu.fetch(API_SELECT_LIST, {}, {
        status: false,
        query: query
      }).then(function (data) {
        _this4.list = _this4.list.concat(data.Shops);
        _this4.noData = _this4.list.length < 1;
        return data;
      });
    },
    handleSort: function handleSort(index) {
      this.init();
      this.sortIndex = index;
      this.getList();
    },
    handleSelectCate: function handleSelectCate(item) {
      this.serviceType = item.serviceType - 0;

      if (this.serviceType !== 4 && this.serviceType !== 7) {
        this.pids = null;
        this.serviceName = item.name;
        this.init();
        this.getList();
      }
    },
    handleCateChild: function handleCateChild(item) {
      this.pids = item.ServiceId - 0;
      this.serviceName = item.ServersName;
      this.init();
      this.getList();
    },
    handleSelectArea: function handleSelectArea(item) {
      this.init();
      this.selectArea = item.Region;

      this.getList();
    },
    getArea: function getArea() {
      var _this5 = this;

      return this.allPromise.then(function (data) {
        var _data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(data, 2),
            car = _data[0],
            locate = _data[1];
        // for test


        locate.district = '闵行区';
        locate.latitude = 31.13670374204165;
        locate.longitude = 121.40186784995873;

        _this5.car = car;
        _this5.locate = locate;
        tuhu.hideIndicator();

        var query = {
          city: locate.city,
          province: locate.province,
          serviceType: 7,
          pids: 4,
          vehicleId: car.ProductID
        };
        return tuhu.fetch(API_SELECT_AREA, {}, {
          query: query,
          status: false
        }).then(function (data) {
          var findIndex = -1;
          data.Areas.some(function (item, index) {
            if (item.Region === locate.district) {
              findIndex = index;
              return true;
            }
          });

          if (findIndex > -1) {
            _this5.areaList = data.Areas.splice(findIndex, 1).concat(data.Areas);
          } else {
            _this5.areaList = data.Areas;
          }
          _this5.selectArea = _this5.areaList[0].Region;
        });
      }).catch(function (e) {
        tuhu.hideIndicator();
      });
    },
    selectShop: function selectShop(index) {
      this.tabIndex = index;

      var shows = {};
      if (this.shows[index]) {
        shows[index] = false;
      } else {
        shows[index] = true;
      }

      this.shows = shows;
    }
  }
});

/***/ }),

/***/ "XYcx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"service_tabs"},[_c('van-tabs',{on:{"click":_vm.onClickTabs},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{attrs:{"title":"全部服务"}},_vm._l((_vm.shopServiceData),function(item,index){return _c('van-cell',{key:item.secondClassId,attrs:{"value":item.signStatus ? '已开启' : '已关闭',"value-class":item.signStatus ? 'service_tabs_list_color' : '',"index":item.secondClassId,"title-class":"pic_title","title":item.secondClassName,"label":("结算价￥" + (item.signPrice) + " 合计销量 " + (item.salesNum) + " "),"is-link":""},on:{"click":function($event){return _vm.handleClick1(_vm.tabList1[0],index)}}})}),1),_vm._v(" "),_c('van-tab',{attrs:{"title":"已上线"}},_vm._l((_vm.serveUplineData),function(item,index){return _c('van-cell',{key:item.secondClassId,attrs:{"value":item.signStatus ? '已开启' : '已关闭',"value-class":item.signStatus ? 'service_tabs_list_color' : '',"index":item.secondClassId,"title-class":"pic_title","title":item.secondClassName,"label":("结算价￥" + (item.signPrice) + " 合计销量 " + (item.salesNum) + " "),"is-link":""},on:{"click":function($event){return _vm.handleClick2(_vm.tabList1[0],index)}}})}),1),_vm._v(" "),_c('van-tab',{attrs:{"title":"已下线"}},_vm._l((_vm.serveDownlineData),function(item,index){return _c('van-cell',{key:item.secondClassId,attrs:{"value":item.signStatus ? '已开启' : '已关闭',"value-class":item.signStatus ? 'service_tabs_list_color' : '',"index":item.secondClassId,"title-class":"pic_title","title":item.secondClassName,"label":("结算价￥" + (item.signPrice) + " 合计销量 " + (item.salesNum) + " "),"is-link":""},on:{"click":function($event){return _vm.handleClick3(_vm.tabList1[0],index)}}})}),1)],1),_vm._v(" "),_c('van-button',{directives:[{name:"call",rawName:"v-call",value:({tel: (_vm.currentShopInfo.managerPhone ? _vm.currentShopInfo.managerPhone : '400-176-8848')}),expression:"{tel: (currentShopInfo.managerPhone ? currentShopInfo.managerPhone : '400-176-8848')}"}],staticClass:"shop_service_btn",attrs:{"color":"rgb(25,137,250)","size":"large","type":"info"}},[_c('van-icon',{attrs:{"name":"phone","color":"#fff"}}),_vm._v(" "),_c('span',[_vm._v("新增服务请联系市场经理")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xarx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content",staticStyle:{"margin-top":"0px"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xegr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XhlL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"coWrap comments-all"},[_c('div',{staticClass:"scrollContent"},[_c('tuhu-tabsnew',{staticClass:"tabsnew",attrs:{"titles":_vm.titles,"active-index":0}},[_c('tuhu-swiper',{attrs:{"slot":"content","haspagination":false},slot:"content"},[_c('div',{key:1,staticClass:"swiper-slide",attrs:{"slot":"content"},slot:"content"},[_c('tab1',{attrs:{"tab1Data":_vm.tabData}})],1),_vm._v(" "),_c('div',{key:2,staticClass:"swiper-slide",attrs:{"slot":"content"},slot:"content"},[_c('tab2',{attrs:{"tab2Data":_vm.tabData}})],1)])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xj3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_image_preview_style__ = __webpack_require__("WJbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_image_preview__ = __webpack_require__("OhwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_review__ = __webpack_require__("kY29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ttButton__ = __webpack_require__("bPVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_camera__ = __webpack_require__("IjLn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commons_enmu__ = __webpack_require__("pNIc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_locale_zh_cn__ = __webpack_require__("Vz2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment_locale_zh_cn__);





 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_10_moment___default.a.locale("zh-cn");
// import VConsole from "vconsole/dist/vconsole.min.js"; // import vconsole

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ttButton: __WEBPACK_IMPORTED_MODULE_8__components_ttButton__["a" /* default */],
    camera: __WEBPACK_IMPORTED_MODULE_9__components_camera__["a" /* default */],
    review: __WEBPACK_IMPORTED_MODULE_6__components_review__["a" /* default */]
  },
  data: function data() {
    return {
      currentShopData: {},
      visibleAssign: false,
      isShowTips: false, //出账提示，有发票才需要
      isReviewInvioce: false,
      reviewInvioceUrl: null,
      invoiceFile: "",
      invoiceFileUrl: null, //上传图片链接，展示用，不用传
      invoiceFileType: null, //上传图片类型，展示用，不用传
      showCamera: false, // 上传图片
      drawerShow: false, //上传发票图片抽屉
      chosedBill: [],
      year: [],
      remitStatusColor: __WEBPACK_IMPORTED_MODULE_11__commons_enmu__["a" /* remitStatusColor */],
      shopStatus: __WEBPACK_IMPORTED_MODULE_11__commons_enmu__["b" /* shopStatus */],
      yearValue: 2023,
      checked: false,
      checkedAll: false,
      checkedInvoiceAll: false,
      remitVisible: false,
      noApplyVisible: false,
      orderList: [],
      childrenOrder: [],
      recordsData: {},
      currentPage: 1,
      userRole: "",
      shopId: "",
      tabIndex: 0,
      childIndex: 0,
      countOrderNum: 0,
      countOrderPrice: 0,
      countOrderNum2: 0,
      countOrderPrice2: 0,
      applyNum: "",
      infoVisible: false,
      shopBankCardInfo: {},
      sucessNum: "",
      monthList: [],
      activeNames: 0,
      icon9: __webpack_require__("8+yF"),
      icon3: __webpack_require__("9wfQ"),
      icon4: __webpack_require__("Th+8"),

      sumOrder: 0,
      sumPrice: 0,
      yearVisible: false,
      vConsolePhone: ["17534753224", "19956900629"],
      isShow: false,
      djNum: 0, //冻结
      kczNum: 0 //可出账
    };
  },


  computed: {
    user: function user() {
      return tuhu.store.state.userInfo;
    },
    assignment: function assignment() {
      return tuhu.sessionStorage.getItem('assignment');
    },
    signFlag: function signFlag() {
      return tuhu.sessionStorage.getItem('signFlag') || null;
    },
    billFlag: function billFlag() {
      return tuhu.store.state.userInfo.billFlag;
    },
    isInvoiceCanALLChosed: function isInvoiceCanALLChosed() {
      var list = [];
      if (!this.recordsData.list) return;
      this.recordsData.list.forEach(function (item) {
        if (item.status === 7) {
          list.push(item.id); // 将每个billNo添加到数组中
        }
      });
      return list.length < 1;
    }
  },

  created: function created() {
    this.init();
    //开启监听页面返回
    window.addEventListener("popstate", this.handleBackButton);
    //处理可选年份数据
    var yearList = [];
    this.yearValue = new Date().getFullYear(); //"2025-12-13"
    var subtractNum = this.yearValue - 2020;
    if (subtractNum === 0) return;
    for (var i = 0; i <= subtractNum; i++) {
      var temp = 2020 + i;
      yearList.push({
        value: temp,
        text: temp + "\u5E74"
      });
    }
    this.year = yearList;
    console.log("yearList", this.year);
  },
  mounted: function mounted() {
    // if (this.vConsolePhone.indexOf(tuhu.store.state.userInfo.phone) != -1) {
    //   let vConsole = new VConsole(); // init vconsole
    // }
  },
  destroyed: function destroyed() {
    //移除监听页面返回
    window.removeEventListener("popstate", this.handleBackButton);
  },

  methods: {
    getShopData: function getShopData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tuhu.showIndicator();
                _context.prev = 1;
                _context.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SWITCH_SHOP + "?shopId=" + _this.shopId);

              case 4:
                data = _context.sent;

                if (data && data.code === "200") {
                  _this.currentShopData = data.data;
                  tuhu.sessionStorage.setItem('assignment', !data.data.assignment ? '0' : '1');
                  tuhu.sessionStorage.setItem('signFlag', data.data.signFlag);
                } else {
                  tuhu.hideIndicator();
                  tuhu.toast(data.message || "网络错误");
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                tuhu.hideIndicator();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },

    // 去签订新的协议
    toAssignMent: function toAssignMent() {
      tuhu.navigateTo({
        url: '/pages/assignMent/index',
        query: {
          shopId: this.shopId,
          cryptoId: this.currentShopData.cryptoId
        }
      });
    },
    showImagePreview: function showImagePreview(val) {
      Object(__WEBPACK_IMPORTED_MODULE_3_vant_es_image_preview__["a" /* default */])({
        images: [val], // 要预览的图片数组（支持多张）
        closeable: true, // 显示关闭按钮
        closeOnPopstate: true // 浏览器后退时关闭预览
      });
    },
    deleteInvoiceUrl: function deleteInvoiceUrl() {
      this.invoiceFile = null;
      this.invoiceFileType = null;
      this.invoiceFileUrl = null;
    },
    openDrawer: function openDrawer() {
      var _this2 = this;

      if (this.chosedBill.length === 0) return tuhu.toast("请选择需要上传发票的账单");
      var filteredItems = this.recordsData.list.filter(function (item) {
        return _this2.chosedBill.includes(item.id);
      });
      // 如果没有筛选到任何项，返回false（或根据业务需求调整）
      // 提取所有bankName并去重
      var bankNames = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(filteredItems.map(function (item) {
        return item.bankName;
      }));
      console.log(bankNames, filteredItems);
      if (bankNames.size > 1) {
        return tuhu.toast("收款信息主体不一致，无法一起上传。");
      }
      this.drawerShow = true;
    },
    closeRewiveInvoice: function closeRewiveInvoice() {
      this.isReviewInvioce = false;
      this.reviewInvioceUrl = null;
    },
    handleReviewInvoice: function handleReviewInvoice(val) {
      if (val.includes('pdf')) {
        this.reviewInvioceUrl = val;
        this.isReviewInvioce = true;
      } else {
        this.showImagePreview(val);
      }
    },
    closeUploadInvoice: function closeUploadInvoice() {
      this.invoiceFile = null;
      this.invoiceFileType = null;
      this.invoiceFileUrl = null;
      this.drawerShow = false;
    },

    // 上传发票
    uploadInvoice: function uploadInvoice() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formdata, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.invoiceFile) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", tuhu.toast("请上传发票图片"));

              case 4:
                tuhu.showIndicator();
                _context2.prev = 5;
                formdata = new FormData();

                formdata.append("file", _this3.invoiceFile); // 文件对象
                formdata.append("shopId", _this3.shopId); // 文件对象
                formdata.append("settlementIds", _this3.chosedBill); // 文件对象
                formdata.append("url", _this3.invoiceFileUrl); // 文件对象
                _context2.next = 13;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.UPLOAD_INVOICE, {
                  method: "post",
                  body: formdata
                });

              case 13:
                data = _context2.sent;

                if (!(data && data.code === "200")) {
                  _context2.next = 26;
                  break;
                }

                _this3.drawerShow = false;
                _this3.chosedBill = [];
                _this3.checkedInvoiceAll = false;
                _this3.invoiceFile = null;
                _this3.invoiceFileType = null;
                _this3.invoiceFileUrl = null;
                tuhu.toast(data.message || "上传成功");
                _context2.next = 24;
                return _this3.getRecordsInfo();

              case 24:
                _context2.next = 28;
                break;

              case 26:
                tuhu.hideIndicator();

                tuhu.toast(data.message || "网络错误");

              case 28:
                _context2.next = 33;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t0 = _context2["catch"](5);

                tuhu.hideIndicator();

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 30]]);
      }))();
    },
    closeCamera: function closeCamera() {
      this.showCamera = false;
    },
    fileUploaded: function fileUploaded(val, type) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isLt8M, mess;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tuhu.showIndicator();
                _this4.invoiceFileType = type;
                _this4.invoiceFile = val;
                console.log(val.size);
                isLt8M = val.size / 1024 / 1024 < 8;

                if (isLt8M) {
                  _context3.next = 9;
                  break;
                }

                _this4.submitLoading = false;
                tuhu.toast('只能上传8MB（含）内大小的文件');
                return _context3.abrupt("return", tuhu.hideIndicator());

              case 9:
                mess = new FormData();

                mess.append("multipartFile", _this4.invoiceFile);
                _context3.next = 13;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.UPLOAD_URL, {
                  method: "post",
                  body: mess
                }).then(function (res) {
                  console.log("res", res);
                  if (res.code === "200") {
                    _this4.invoiceFileUrl = res.data;
                  } else {
                    tuhu.toast(res.message || "网络错误");
                  }
                });

              case 13:
                tuhu.hideIndicator();

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    changeYearValue: function changeYearValue(value) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.activeNames = 0;
                _this5.yearValue = value;
                _this5.yearVisible = false;
                if (_this5.tabIndex == 0) {
                  _this5.getOrderList();
                } else {
                  _this5.getRecordsInfo();
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    changeLiYear: function changeLiYear() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },

    // tab切换
    handleTabIndex: function handleTabIndex(index) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.tabIndex = index;
                _this7.childIndex = 0;
                _this7.yearVisible = false;
                if (index == 0) {
                  _this7.getOrderList();
                  _this7.GetRemitNum();
                } else if (index == 1) {
                  _this7.getRecordsInfo();
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    init: function init() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this8.userInfo();

              case 2:

                _this8.getOrderList();

                _this8.GetRemitNum();
                _this8.getShopData();

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },

    // 全选
    handleCheckAll: function handleCheckAll() {
      var list = [];
      this.orderList.forEach(function (item) {
        item.select = true;
      });
      this.checkedAll = true;
      this.monthList = list;
    },
    handleCheckAllFlase: function handleCheckAllFlase() {
      this.orderList.forEach(function (item) {
        item.select = false;
      });
      this.checkedAll = false;
      this.monthList = [];
    },

    //单选上传发票监听
    handleCheckInvoice: function handleCheckInvoice() {
      var list = [];
      this.recordsData.list.forEach(function (item) {
        if (item.status === 7) {
          list.push(item.id); // 将每个billNo添加到数组中
        }
      });
      this.checkedInvoiceAll = this.chosedBill.length === list.length;
    },

    // 结算发票全选
    handleCheckInvoiceAll: function handleCheckInvoiceAll() {
      var list = [];
      this.recordsData.list.forEach(function (item) {
        if (item.status === 7) {
          list.push(item.id); // 将每个billNo添加到数组中
        }
      });
      if (list.length < 1) {
        this.checkedInvoiceAll = false;
        this.chosedBill = [];
        return;
      }

      this.checkedInvoiceAll = true;
      this.chosedBill = list;
    },
    handleCheckInvoiceAllFlase: function handleCheckInvoiceAllFlase() {
      this.checkedInvoiceAll = false;
      this.chosedBill = [];
    },

    //单选
    handleRadio: function handleRadio() {
      var _this9 = this;

      var sumPrice = 0,
          sumOrder = 0;
      this.orderList.forEach(function (item) {
        if (item.select) {
          _this9.checkedAll = true;
        }
        if (!item.select) {
          _this9.checkedAll = false;
        }
        if (item.select) {
          sumPrice += item.totalAmount;
          sumOrder += item.shopBillQuantity;
        }
      });
      this.sumPrice = sumPrice;
      this.sumOrder = sumOrder;
    },

    // 一键申请
    handleApplyBill: function handleApplyBill() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this10.signFlag !== 0 && _this10.signFlag !== '0' && (!_this10.assignment || _this10.assignment === '0'))) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", _this10.visibleAssign = true);

              case 2:
                if (!(_this10.applyNum >= 1)) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt("return", _this10.noApplyVisible = true);

              case 6:
                if (!(_this10.applyNum < 1)) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt("return", _this10.remitVisible = true);

              case 10:
                if (!(!_this10.shopBankCardInfo.bankAccountName || !_this10.shopBankCardInfo.bankName)) {
                  _context8.next = 12;
                  break;
                }

                return _context8.abrupt("return", _this10.infoVisible = true);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },

    // 查询商户结款次数
    GetRemitNum: function GetRemitNum() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_MERCHANT_NUM, {
                  method: "post",

                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this11.shopId
                  })
                });

              case 2:
                data = _context9.sent;

                if (data.code === "200") {
                  _this11.applyNum = data.data.chargeCount;
                  _this11.sucessNum = 1 - (data.data.chargeCount || 0);
                  _this11.shopBankCardInfo = data.data.shopBankCardInfo || {};
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },

    // handleItem
    handleItem: function handleItem(item, index) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this12.getOrderListMonth(item.month);

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },

    // 关闭申请
    close: function close() {
      this.remitVisible = false;
      this.checked = false;
      this.childIndex = 0;
    },

    // 暂不申请
    handleNoApply: function handleNoApply() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                //   location.reload();
                _this13.tabIndex = 0;
                _this13.childIndex = 0;
                _this13.monthList = [];
                _this13.init();
                _this13.close();

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },

    //发票必传时候提示
    handleInvoiceApply: function handleInvoiceApply() {
      if (!this.shopBankCardInfo.bankAccountName) return tuhu.toast("请先添加收款账户");
      if (!this.checked) return tuhu.toast("请确认收款信息");
      this.isShowTips = true;
    },

    // 立即申请
    handleApply: function handleApply() {
      if (!this.shopBankCardInfo.bankAccountName) return tuhu.toast("请先添加收款账户");
      if (!this.checked) return tuhu.toast("请确认收款信息");
      this.childIndex = 1;
      this.remitVisible = false;
      this.isShowTips = false;
      this.checked = false;
      this.getOrderList(5);
    },

    // handleApply1
    handleApply1: function handleApply1(status) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var list, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // this.monthList
                list = [];

                _this14.orderList.forEach(function (item) {
                  if (item.select) {
                    list.push(item.month);
                  }
                });

                if (!(_this14.orderList.length <= 0)) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt("return", tuhu.toast("暂无账单"));

              case 4:
                if (list.length) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt("return", tuhu.toast("请先选择一笔订单"));

              case 6:
                _context12.next = 8;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.TO_SHOP_ACCOUNT, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    monthList: list,
                    shopId: Number(_this14.shopId),
                    status: status,
                    year: _this14.yearValue
                  })
                });

              case 8:
                data = _context12.sent;

                if (data && data.code === "200") {
                  tuhu.toast(data.message);
                  _this14.sumOrder = 0;
                  _this14.sumPrice = 0;
                  _this14.checkedAll = false;
                  _this14.handleNoApply();
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this14);
      }))();
    },

    // 身份信息
    userInfo: function userInfo() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_USERINFO);

              case 3:
                res = _context13.sent;

                if (res && res.code === "200") {
                  _this15.userRole = res.data.role;
                  _this15.shopId = res.data.shopId;
                } else {
                  tuhu.toast(res.message || "网络错误或权限不足");
                  console.log("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_USERINFO, res);
                }
                _context13.next = 10;
                break;

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13["catch"](0);

                console.log("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_USERINFO, _context13.t0);

              case 10:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this15, [[0, 7]]);
      }))();
    },

    // 出账订单
    getOrderList: function getOrderList() {
      var _this16 = this;

      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var data, num, price;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                tuhu.showIndicator();

                _context14.prev = 1;
                _context14.next = 4;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_MERCHANT_YEAR, {
                  method: "post",

                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    year: _this16.yearValue,
                    month: "",
                    status: status,
                    shopId: _this16.shopId
                  })
                });

              case 4:
                data = _context14.sent;


                if (data && data.code === "200") {
                  tuhu.hideIndicator();
                  if (data.data && data.data.length > 0) {
                    _this16.orderList = data.data;

                    num = 0, price = 0;

                    data.data.forEach(function (item) {
                      num += item.shopBillQuantity;
                      price += item.totalAmount;
                    });
                    _this16.countOrderNum = num;
                    _this16.countOrderPrice = parseFloat(price.toFixed(2));
                    if (data.data[0].month) {
                      _this16.getOrderListMonth(data.data[0].month);
                    }
                  } else {
                    _this16.countOrderNum = 0;
                    _this16.countOrderPrice = 0;
                    _this16.orderList = [];
                  }
                } else {
                  tuhu.hideIndicator();

                  tuhu.toast(data.message || "网络错误");
                }
                _context14.next = 12;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](1);

                tuhu.hideIndicator();

                console.log("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SETTLEMENT_LIST, _context14.t0);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this16, [[1, 8]]);
      }))();
    },
    getOrderListMonth: function getOrderListMonth(month) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                tuhu.showIndicator();

                _context15.prev = 1;
                _context15.next = 4;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_MERCHANT_MONTH, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    year: _this17.yearValue,
                    // month: month,
                    monthList: [month],
                    status: "",
                    shopId: _this17.shopId
                  })
                });

              case 4:
                data = _context15.sent;


                if (data && data.code === "200") {
                  tuhu.hideIndicator();
                  _this17.childrenOrder = data.data;
                } else {
                  tuhu.hideIndicator();

                  tuhu.toast(data.message || "网络错误");
                }
                _context15.next = 12;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](1);

                tuhu.hideIndicator();

                console.log("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SETTLEMENT_LIST, _context15.t0);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this17, [[1, 8]]);
      }))();
    },

    // 结款数据
    getRecordsInfo: function getRecordsInfo() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var data, num, price;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SETTLEMENT_LIST, {
                  method: "post",

                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    pageNum: 1,

                    pageSize: 50,

                    shopId: Number(_this18.shopId),

                    year: _this18.yearValue
                  })
                });

              case 3:
                data = _context16.sent;


                if (data && data.code === "200") {
                  _this18.recordsData = data.data;

                  num = 0, price = 0;

                  data.data.list.forEach(function (item) {
                    num += item.billCount;
                    price += item.settlementPrice;
                  });
                  _this18.countOrderNum2 = num;
                  _this18.countOrderPrice2 = parseFloat(price.toFixed(2));
                } else {
                  console.log("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SETTLEMENT_LIST, data);

                  tuhu.toast(data.message || "网络错误");
                }
                _context16.next = 10;
                break;

              case 7:
                _context16.prev = 7;
                _context16.t0 = _context16["catch"](0);

                console.log("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SETTLEMENT_LIST, _context16.t0);

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this18, [[0, 7]]);
      }))();
    },

    // 分页事件
    changePage: function changePage(index) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var pageNum, data, num, price;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                pageNum = index;
                _context17.next = 3;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.SETTLEMENT_LIST, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    pageNum: pageNum,
                    pageSize: 50,
                    shopId: _this19.shopId,
                    year: _this19.yearValue
                  })
                });

              case 3:
                data = _context17.sent;

                if (data && data.code === "200") {
                  _this19.recordsData = data.data;
                  num = 0, price = 0;

                  data.data.list.forEach(function (item) {
                    num += item.billCount;
                    price += item.settlementPrice;
                  });
                  _this19.countOrderNum2 = num;
                  _this19.countOrderPrice2 = price;
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this19);
      }))();
    },
    submit: function submit() {
      //   this.remitVisible = true;
      //   if (!this.orderList) return false;
      //   tuhu.navigateTo({
      //     url: "/pages/confirmInfo/index",
      //     query: {
      //       sId: this.shopId,
      //       seId: this.orderList && this.orderList.id,
      //     },
      //   });

      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this20);
      }))();
    },
    onPageBack: function onPageBack(to, from) {
      if (from.path.indexOf("pages/confirmInfo/index") > -1) {
        this.init();

        this.tabIndex = 1;
      }
    },

    //去完善信息
    goUdate: function goUdate() {
      tuhu.navigateTo({ url: "/pages/accounts/index?" + this.userInfo.shopId });
    },

    //刷新银行卡信息
    handleBackButton: function handleBackButton() {
      this.GetRemitNum();
    },

    // 检验账单信息
    checkBillSatus: function checkBillSatus() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var list, data, allData, djArr, wczArr;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                list = [];

                _this21.orderList.forEach(function (item) {
                  if (item.select) {
                    list.push(item.month);
                  }
                });

                if (!(_this21.orderList.length <= 0)) {
                  _context19.next = 4;
                  break;
                }

                return _context19.abrupt("return", tuhu.toast("暂无账单"));

              case 4:
                if (list.length) {
                  _context19.next = 6;
                  break;
                }

                return _context19.abrupt("return", tuhu.toast("请先选择一笔订单"));

              case 6:
                _context19.next = 8;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_MERCHANT_MONTH, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    year: _this21.yearValue,
                    // month: month,
                    monthList: list,
                    status: "",
                    shopId: _this21.shopId
                  })
                });

              case 8:
                data = _context19.sent;

                if (data && data.code === "200") {
                  allData = data.data;

                  if (allData && allData.length) {
                    djArr = allData.filter(function (item) {
                      return item.status == 6;
                    }); // 冻结数据

                    if (djArr.length && djArr[0]["shopBillQuantity"] > 0) {
                      wczArr = allData.filter(function (item) {
                        return item.status == 5;
                      }); //未出账数据

                      _this21.djNum = djArr[0]["shopBillQuantity"];
                      _this21.kczNum = wczArr[0]["shopBillQuantity"] - djArr[0]["shopBillQuantity"];
                      if (_this21.kczNum >= 0) {
                        _this21.isShow = true;
                      } else {
                        _this21.handleApply1(5);
                      }
                    } else {
                      _this21.handleApply1(5);
                    }
                  } else {
                    _this21.handleApply1(5);
                  }
                } else {
                  tuhu.hideIndicator();
                  tuhu.toast(data.message || "网络错误");
                }

              case 10:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this21);
      }))();
    },

    // 确认立即申请
    submitApply: function submitApply() {
      if (this.kczNum > 0) {
        this.handleApply1(7);
      } else {
        this.isShow = false;
        tuhu.toast("暂无可出账订单");
      }
    }
  }
});

/***/ }),

/***/ "XxjT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yc9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textInvoice_vue__ = __webpack_require__("q9iw");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16047364_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textInvoice_vue__ = __webpack_require__("b+6a");
function injectStyle (ssrContext) {
  __webpack_require__("ccG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16047364"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16047364_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_textInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Yoto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_platenum_vue__ = __webpack_require__("t+JU");

// type=type=2显示字母键盘,returnHandler返回键盘值的回调方法,showmask控制是否要黑色遮罩背景
// <div class="cityP" v-platenum="{type: 1, returnHandler: returnHandler,showmask: false}" v-text='cityp'></div>
// <div class="engP" v-platenum="{type: 2, returnHandler: returnHandler,showmask: false}"  v-text='carNo'></div>

Vue.directive('platenum', {
  inserted: function inserted(el, binding) {
    var instance = null;
    $(el).on('click', function (e) {
      e.preventDefault();
      var $content = $('.page-current').eq(tuhu.getParam('_tab') || 0).children('._content');
      var replaceEl = $('<div></div>');
      $content.append(replaceEl);
      if (instance) {
        instance.$children[0].showPlate = binding.value.type;
      } else {
        var cityV = '';
        var carV = '';
        if (binding.value.type === 1) {
          cityV = $(e.target).text();
          carV = $(e.target).siblings().text();
        } else if (binding.value.type === 2) {
          carV = $(e.target).text();
          cityV = $(e.target).siblings().text();
        }
        instance = new Vue({
          el: replaceEl[0],
          render: function render(createElement) {
            return createElement(__WEBPACK_IMPORTED_MODULE_0__components_platenum_vue__["a" /* default */], {
              props: {
                showmask: binding.value.showmask,
                showP: binding.value.type,
                returnHandler: binding.value.returnHandler,
                cityV: cityV,
                carV: carV
              }
            });
          }
        });
      }
    });
  }
});

/***/ }),

/***/ "Z+yf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk__);




/**
 * updateBy: duwei
 * updateTime: 2017-9-11
 * updateDesc: 支持传入调用方法
 *
 * WxConfig().share().then((status)=>{
 *   // status为true则配置成功
 * })
 *
 */
 // 本来未引入插件 本来是window.wx 引入插件改为 wx
var CALL_URL = 'https://api.hzqmtech.com/shop/wechat/getJsTicket';
var WX_URL = 'https://www.xiaokunkeji.cn/user/vue/js/jweixin.1.2.0.min.js';

var WxConfig = function () {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WxConfig, null, [{
    key: 'share',
    value: function share() {
      if (!tuhu.device.isWeixin) {
        return;
      }

      var share = new WxConfig();
      return share.config();
    }
  }]);

  function WxConfig() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WxConfig);

    this.param = ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice', 'hideMenuItems'];
    this.sign = null;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WxConfig, [{
    key: 'config',
    value: function config() {
      var _this = this;

      return this.getSign().then(function () {
        if (__WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a) {
          return _this.wxConfig();
        }
        return tuhu.script(WX_URL).then(function () {
          return _this.wxConfig();
        });
      });
    }
  }, {
    key: 'wxConfig',
    value: function wxConfig() {
      __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.sign.appId, // 必填，公众号的唯一标识
        timestamp: this.sign.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.sign.nonceStr, // 必填，生成签名的随机串
        signature: this.sign.signature, // 必填，签名，见附录1
        jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.error(function (err) {
        return console.log('配置出错了22：' + err.errMsg);
      });
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.ready(function () {
          __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.checkJsApi({
            jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation', 'openLocation', 'scanQRCode', 'translateVoice', 'hideMenuItems'],
            success: function success(res) {
              resolve(true);
            }
          });
        });
      });
    }
  }, {
    key: 'getSign',
    value: function getSign() {
      var _this2 = this;

      return tuhu.fetch(CALL_URL, {
        method: 'post',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          path: location.href.split('#')[0]
          // path: encodeURIComponent('https://www.xiaokunkeji.cn/shop/index.html')
        })
      }).then(function (res) {
        if (res && res.code === '200') {
          // console.log('签名数据', res)
          _this2.sign = res.data;
        } else {
          tuhu.toast(res.message || '网络错误');
        }
      });
    }
  }]);

  return WxConfig;
}();

/* harmony default export */ __webpack_exports__["a"] = (WxConfig);

/***/ }),

/***/ "Z52j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

var FONSTSIZE = parseInt($('html').css('font-size')) || 20;

var PRELOAD = 1;

var LIMIT = 2;

var RATIO = 2;

var photos = [];

tuhu.getDeviceDetail().then(function (data) {
  if (data && data.netWork !== 'wifi') {
    RATIO = 1.5;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loadCount: 0,
      loaded: false,
      timeout: null,
      scrollDom: null,
      height: 0,
      cutHeight: 0
    };
  },

  props: {
    el: {
      type: HTMLImageElement
    },
    src: {
      type: String,
      required: true
    },
    width: {
      type: [String, Number],
      required: false
    },
    forceHeight: {
      type: [String, Number],
      required: false
    },
    group: {
      type: String,
      required: false,
      validator: function validator(value) {
        return (value + '').indexOf('group_') > -1;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // this.el.__instance__ = this

    this.setPhotos();

    var height = this.getHeight();
    this.scrollDom = this.getScrollDom();
    if (height) {
      this.cutHeight = height[0];
      this.height = height[1];
    }
    setTimeout(function () {
      _this.scrollDom.on('scroll', _this.scrollHandle);
      _this.loadImg();
    });
  },

  watch: {},
  computed: {
    // 计算后的真实宽度
    realWidth: function realWidth() {
      return this.getWidth();
    },
    style: function style() {
      return {
        width: this.realWidth + 'px',
        height: this.height + 'px'
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.scrollDom.off('scroll', this.scrollHandle);
  },

  methods: {
    getWidth: function getWidth() {
      var width = this.width;
      var match = (width + '').match(/(\d+)%$/);
      if (match) {
        return parseInt(match[1] * window.innerWidth / 100);
      }
      if (width && typeof width === 'string') {
        width = width.replace('rem', '');
      }
      return parseInt(width * FONSTSIZE);
    },
    scrollHandle: function scrollHandle() {
      var _this2 = this;

      clearTimeout(this.timeout);

      this.timeout = setTimeout(function () {
        // console.log('scroll')

        _this2.loadImg();
      }, 100);
    },

    // 图片浏览器
    setPhotos: function setPhotos() {
      var group = this.group;
      var imageIndex = 0;

      if (group !== undefined) {
        if ((group + '').indexOf('group_') < 0) {
          throw new Error('group\u5C5E\u6027\u975E\u6CD5\uFF0C\u8BF7\u8C03\u7528tuhu.util.getGroup()\u751F\u6210');
        }

        if (!photos[group]) {
          photos[group] = [];
        }
        imageIndex = photos[group].length;
        if (this.src.indexOf('@') < 0) {
          var type = this.src.match(/\.([^.]+)$/)[1];
          photos[group].push(this.src + '@' + innerWidth + 'w_100Q.' + type);
        } else {
          photos[group].push(this.src);
        }

        $(this.el).on('click', function (e) {
          if (photos[group]) {
            tuhu.photoBrowser({
              photos: photos[group]
            }, {
              index: imageIndex
            });
          }
        });
      }
    },
    loadImg: function loadImg() {
      if (this.loaded) {
        return;
      }

      var isLoad = this.isLoad();
      if (!isLoad) {
        return;
      }

      this.loaded = true;
      this.scrollDom.off('scroll', this.scrollHandle);

      this._loadImg();
    },
    _loadImg: function _loadImg() {
      var _this3 = this;

      this.loadCount++;
      this.el.src = this.getSrc();
      this.el.onload = function () {
        if (_this3.height) {
          $(_this3.el).css({
            width: _this3.realWidth + 'px',
            height: _this3.height + 'px'
          });
        }

        $(_this3.$el).replaceWith($(_this3.el));
        _this3.$el.__vue__.$el = _this3.el;
        _this3.el.__vue__ = _this3.$el.__vue__;
      };

      this.el.onerror = function () {
        if (_this3.loadCount < LIMIT) {
          _this3._loadImg();
        }
      };
    },
    getSrc: function getSrc() {
      // if (!this.height) {
      //   return this.src
      // }
      if (!/img\d\.tuhu\.org/.test(this.src)) {
        return this.src;
      }

      var src = this.src.replace(/@.+/, '');
      var type = src.match(/\.([^.]+)$/)[1];
      // debugger
      if (!this.cutHeight) {
        var wid = this.getWidth();
        if (type === 'gif') {
          src += '?@' + wid + 'w_99q.src';
        } else {
          src += '@' + wid + 'w_99q.' + type;
        }
      } else {
        if (type === 'gif') {
          src += '?@' + this.cutHeight + 'h_99q.src';
        } else {
          src += '@' + this.cutHeight + 'h_99q.' + type;
        }
      }
      return src.replace('image.tuhu.cn', 'img1.tuhu.org').replace(/https?/, 'https').replace(/img\d\./, 'img1.').replace(/\.(?:webp|png)$/, '.jpg');
    },
    isLoad: function isLoad() {
      var scrollOffset = this.scrollDom.offset();
      if (!scrollOffset) {
        return true;
      }

      var scrollTop = scrollOffset.top;
      var scrollHeight = scrollOffset.height;

      var offset = $(this.$el).offset();
      if (!offset.height) {
        return true;
      }

      var checkTop = offset.top - scrollTop + offset.height / 2;
      if (checkTop >= -(PRELOAD * scrollHeight) && checkTop <= (PRELOAD + 1) * scrollHeight) {
        return true;
      }

      return false;
    },
    getScrollDom: function getScrollDom() {
      var parentNode = this.$el;
      do {
        var style = window.getComputedStyle(parentNode);
        if (!style) {
          break;
        }

        var overflow = style['overflow-y'];

        if (overflow === 'auto' || overflow === 'scroll') {
          break;
        }

        parentNode = parentNode.parentNode;
      } while (parentNode);

      return $(parentNode);
    },

    // 获取 获取高度
    getHeight: function getHeight() {
      var height = this._getHeight(this.src.replace(/@.+/, ''));
      if (!height) {
        height = this._getHeight(this.src);
      }

      return height;
    },
    _getHeight: function _getHeight(src) {
      var match = src.match(/(\d+)w_(\d+)h/);
      if (!match) {
        match = src.match(/w(\d+)_h(\d+)/);
      }

      if (match) {
        if (!this.width) {
          throw new Error('必须传入width剪裁图片');
        }
        // (match[2] / match[1] 高宽比 ratioHeight 真实高度
        var ratioHeight = 0;
        ratioHeight = this.realWidth * (match[2] / match[1]);
        // RATIO放大倍数
        return [Math.ceil(ratioHeight / 10) * 10 * RATIO, parseInt(ratioHeight)];
      } else {
        return [0, this.getWidth()];
      }
    }
  }
});

/***/ }),

/***/ "ZG7+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZGyv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab1_vue__ = __webpack_require__("vJFf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a81ad63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab1_vue__ = __webpack_require__("7HPE");
function injectStyle (ssrContext) {
  __webpack_require__("Kg3z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a81ad63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a81ad63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZHLH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLWk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopInfo_vue__ = __webpack_require__("6xC8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0f6bf9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopInfo_vue__ = __webpack_require__("75xz");
function injectStyle (ssrContext) {
  __webpack_require__("Khs+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c0f6bf9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shopInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0f6bf9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shopInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZPEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifySlide_vue__ = __webpack_require__("/Lae");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7267d825_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifySlide_vue__ = __webpack_require__("HaFi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifySlide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7267d825_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifySlide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZVHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("LHxb");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64234876_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/ThF");
function injectStyle (ssrContext) {
  __webpack_require__("aC2k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64234876"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64234876_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Zdwm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accountAccessPic.344f263.png";

/***/ }),

/***/ "ZfdV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zmio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signPad_vue__ = __webpack_require__("EOys");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718e56c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signPad_vue__ = __webpack_require__("1j7e");
function injectStyle (ssrContext) {
  __webpack_require__("5uA8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-718e56c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signPad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718e56c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signPad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZpKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      shopNo: tuhu.getParam("shopNo") || null,
      sing: __webpack_require__("aaAN"),
      chapter: __webpack_require__("pgmo"),
      shopBankCardInfos: {},
      shopInfo: {},
      shopSignServviceList: []
    };
  },
  mounted: function mounted() {
    if (this.shopNo) {
      this.getAgreementInfo();
    }
  },

  methods: {
    getAgreementInfo: function getAgreementInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  shopId: _this.shopNo
                };
                _context.next = 3;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_AGREEMERT_INFO, {
                  method: "post",
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params || "")
                });

              case 3:
                res = _context.sent;

                if (res.code === '200') {
                  _this.shopBankCardInfos = res.data.shopBankCardInfos;
                  _this.shopInfo = res.data.shopInfo;
                  _this.shopSignServviceList = res.data.shopSignServviceList;
                } else {
                  tuhu.toast(res.message || "网络错误");
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "ZtQm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ztm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wxconfig__ = __webpack_require__("Z+yf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk__);


var _this = this;




var WxSdks = function WxSdks() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WxSdks);
};

WxSdks.scanQR = function () {
  _this.show = true;
  // Toast.loading({
  //   message: '正在发起收款...',
  //   forbidClick: true,
  //   duration: 0
  // })
  if (tuhu.device.isWeixin) {
    __WEBPACK_IMPORTED_MODULE_1__wxconfig__["a" /* default */].share(['scanQRCode']).then(function (status) {
      // console.log('配置是否成功', status)
      __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function success(res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          // tuhu.navigateTo({
          //   url: '/pages/verifyCode/index',
          //   data: {
          //     verifyCode: result
          //   },
          //   query: {
          //     success: 1
          //   }
          // })
        },
        fail: function fail(err) {
          tuhu.toast(err || '网络错误');
        }
      });
    });
  } else {
    // tuhu.toast('请在微信客户端打开')
  }
};

WxSdks.hideBtn = function () {
  if (tuhu.device.isWeixin) {
    __WEBPACK_IMPORTED_MODULE_1__wxconfig__["a" /* default */].share(['hideMenuItems']).then(function (status) {
      console.log('配置是否', status);
      __WEBPACK_IMPORTED_MODULE_2_weixin_js_sdk___default.a.hideMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
      });
    });
  } else {
    tuhu.toast('请在微信客户端打开');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (WxSdks);

/***/ }),

/***/ "a+R+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aC2k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aINi":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ommR").polyfill();

/***/ }),

/***/ "aU8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aaAN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sing.df0784c.png";

/***/ }),

/***/ "aieO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_coupons_vue__ = __webpack_require__("4uTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timers__ = __webpack_require__("162o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_timers__);


/**
  * author: lijingwen@tuhu.cn
  * date: 2017/12/6
  * desc: 领取优惠券的弹窗
  * demo: v-coupons:1 轮胎列表领取优惠券
<a href="#" v-coupons='couponsData' >弹出商品优惠券</a>
data {
  couponsData: {
    couponsList: [{'GetRuleID': 8810, 'GetRuleGUID': '52a7d77a-d279-48af-b197-e4a7e61de661', 'Minmoney': 999, 'ValiStartDate': '2017-11-21', 'DeadLineDate': null, 'ValiEndDate': '2017-12-31', 'Description': '1114详情页100元轮胎券-到店且在线支付，部分产品不可用', 'PromtionName': '全网轮胎优惠券', 'Discount': 100, 'IsGet': true, 'Term': 0, 'Time': '2017.11.21 - 2017.12.31', 'Rule': '满￥999可用', 'LabelName': '满999减100'}, {'GetRuleID': 8811, 'GetRuleGUID': 'c2df607e-c8ac-48dc-a678-2b8da1457afe', 'Minmoney': 1999, 'ValiStartDate': '2017-11-21', 'DeadLineDate': null, 'ValiEndDate': '2017-12-31', 'Description': '1114详情页200元轮胎券-到店且在线支付，部分产品不可用', 'PromtionName': '全网轮胎优惠券', 'Discount': 200, 'IsGet': false, 'Term': 0, 'Time': '2017.11.21 - 2017.12.31', 'Rule': '满￥1999可用', 'LabelName': '满1999减200'}],
    couponsCallBack: this.couponsCallBack
  }
}
methods: {
  couponsCallBack(value) {
    console.log('couponsCallBack', value)
  }
}
*/
Vue.directive('coupons', {
  inserted: function inserted(el, couponsData) {
    var instance = null;
    var replaceEl = $('<div></div>');
    // $(el).after(replaceEl)
    var $content = $('.page-group').eq(tuhu.getParam('_tab') || 0).find('.page-current').last();
    $content.append(replaceEl);
    // let $content = $('.page-current').eq(tuhu.getParam('_tab') || 0).children('._content')
    // let replaceEl = $('<div></div>')
    // $content.append(replaceEl)

    $(el).on('click', function (e) {
      e.stopPropagation();
      if (instance) {
        instance.$children[0].showModal = true;
        return;
      }
      tuhu.getUserInfo({ force: true }).then(function (res) {
        if (res.islogin) {
          // console.log('地址与车型', couponsData.value.locationData, couponsData.value.carInfo)

          Object(__WEBPACK_IMPORTED_MODULE_1_timers__["setTimeout"])(function () {
            instance = new Vue({
              el: replaceEl[0],
              render: function render(createElement) {
                return createElement(__WEBPACK_IMPORTED_MODULE_0__components_coupons_vue__["a" /* default */], {
                  props: {
                    showmask: couponsData.value.showmask,
                    couponsCallBack: couponsData.value.couponsCallBack,
                    productId: couponsData.value.productId,
                    type: couponsData.value.type,
                    sort: couponsData.value.sort,
                    locationData: couponsData.value.locationData,
                    carInfo: couponsData.value.carInfo
                  }
                });
              }
            });
          }, 300);
        }
      });
    });
  }
});

/***/ }),

/***/ "aj2C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "asNC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newPlatenum_vue__ = __webpack_require__("nJfr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee23f56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newPlatenum_vue__ = __webpack_require__("BuU7");
function injectStyle (ssrContext) {
  __webpack_require__("4idc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ee23f56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newPlatenum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee23f56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newPlatenum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v("小鲲车服合作商户结算流程说明")]),_vm._v(" "),_c('p',{staticClass:"name"},[_vm._v("    尊敬的小鲲车服合作商户：")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n          你们好！感谢大家一直以来对小鲲车服的支持。为让大家更清楚的知晓小鲲车服的结算流程，现做如下说明：\n      "),_c('br'),_vm._v("    1、商户工作人员在小鲲车服商户端（关注“小鲲车服”公众号，点击底部菜单“商户平台”\n      进入）点击【结算管理】进入自助申请出账结算，商户端会按照年度和月度对全部订单的出\n      账情况进行统计展示，方便商户自助查看出账及打款情况；\n      "),_c('br'),_vm._v("    2、可进行【结算管理】操作的商户工作人员，商户端账号需为“店长”或“老板”类型，“员\n      工”类型账号无法进行结算相关操作；\n      "),_c('br'),_vm._v("    3、每个商户每月可申请1次出账，建议在月末申请，每次可将未出账的订单按照月份\n      选择全部一次性申请出账结算。出账成功后会生成一笔结算账单，可点击页面【结算明细】\n      查看结算账单的状态，出账时请务必确认结算账户信息准确无误，否则将会影响打款进度；\n      "),_c('br'),_vm._v("    4、针对需要上传发票的门店，在出账审核完成后，需要及时上传对应账单的发票，如不及时上传发票，将会影响打款进度。\n      "),_c('br'),_vm._v("    5、小鲲车服工作人员会在每月10日之前完成上月所有商户申请的全部对结算账单的\n      审核工作，如有出现审核不通过的情况，工作人员会与您联系进行核实；\n      "),_c('br'),_vm._v("    6、小鲲车服财务人员会在每月11日之前完成所有商户已审核通过结算账单的打款工\n      作，打款结果（成功或失败）将会通过微信消息、短信等方式通知到您。对于打款失败的，\n      工作人员会与您联系核实打款账户信息。\n      "),_c('br'),_vm._v("    再次感谢各位商户的配合与支持，祝您生意兴隆！\n    ")]),_vm._v(" "),_c('p',{staticClass:"end"},[_vm._v("小鲲科技商户管理部"),_c('br'),_vm._v("2023年04月18日")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b9Th":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("LWIP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_432434ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("RmqU");
function injectStyle (ssrContext) {
  __webpack_require__("dliB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-432434ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_432434ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bFPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bL+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"tabs"},[_c('van-tabs',{attrs:{"color":"rgb(25,137,250)"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('van-tab',{staticClass:"change_shopinfo_tab",attrs:{"title":"基本信息"}},[_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"店招名称","placeholder":"请输入"},model:{value:(_vm.StoreInfo_val1),callback:function ($$v) {_vm.StoreInfo_val1=$$v},expression:"StoreInfo_val1"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"门店负责人","placeholder":"请输入"},model:{value:(_vm.StoreInfo_val2),callback:function ($$v) {_vm.StoreInfo_val2=$$v},expression:"StoreInfo_val2"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"负责人类型","value":_vm.StoreInfo_val3,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.StoreInfo_Picker1 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.StoreInfo_Picker1),callback:function ($$v) {_vm.StoreInfo_Picker1=$$v},expression:"StoreInfo_Picker1"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择负责人类型","columns":_vm.StoreInfo_columns1},on:{"cancel":function($event){_vm.StoreInfo_Picker1 = false},"confirm":_vm.StoreInfo_onConfirm1}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"负责人电话","placeholder":"请输入"},model:{value:(_vm.StoreInfo_val4),callback:function ($$v) {_vm.StoreInfo_val4=$$v},expression:"StoreInfo_val4"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"门店电话","placeholder":"请输入"},model:{value:(_vm.StoreInfo_val5),callback:function ($$v) {_vm.StoreInfo_val5=$$v},expression:"StoreInfo_val5"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"店铺区域","value":_vm.StoreInfo_val6,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.StoreInfo_Picker2 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.StoreInfo_Picker2),callback:function ($$v) {_vm.StoreInfo_Picker2=$$v},expression:"StoreInfo_Picker2"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择地址","columns":_vm.StoreInfo_columns2},on:{"cancel":function($event){_vm.StoreInfo_Picker = false},"confirm":_vm.StoreInfo_onConfirm2}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"门店地址","placeholder":"请输入"},model:{value:(_vm.StoreInfo_val7),callback:function ($$v) {_vm.StoreInfo_val7=$$v},expression:"StoreInfo_val7"}})],1),_vm._v(" "),_c('van-button',{staticClass:"shop_info_btn",attrs:{"size":"large","color":"rgb(25,137,250)","type":"info"},on:{"click":function($event){return _vm.handleClick1(_vm.tabList1[0])}}},[_vm._v("保存")])],1),_vm._v(" "),_c('van-tab',{staticClass:"change_shopinfo_tab",attrs:{"title":"店铺信息"}},[_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"门店类型","value":_vm.Shopinfo_val1,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker1 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker1),callback:function ($$v) {_vm.Shopinfo_Picker1=$$v},expression:"Shopinfo_Picker1"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择门店类型","columns":_vm.Shopinfo_columns1},on:{"cancel":function($event){_vm.Shopinfo_1 = false},"confirm":_vm.Shopinfo_onConfirm1}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"主营服务","value":_vm.Shopinfo_val2,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker2 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker2),callback:function ($$v) {_vm.Shopinfo_Picker2=$$v},expression:"Shopinfo_Picker2"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择主营服务","columns":_vm.Shopinfo_columns2},on:{"cancel":function($event){_vm.Shopinfo_2 = false},"confirm":_vm.Shopinfo_onConfirm2}})],1)],1),_vm._v(" "),_c('van-cell-group',{staticClass:"shop_checkbox_group"},[_c('span',[_vm._v("营业项目")]),_vm._v(" "),_c('van-checkbox-group',{ref:"checkboxGroup",staticClass:"checkbox_group",attrs:{"direction":"horizontal"},model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}},[_c('van-checkbox',{attrs:{"name":"全选","shape":"square"},on:{"click":function($event){return _vm.checkAll()}},model:{value:(_vm.Shopinfo_checked1),callback:function ($$v) {_vm.Shopinfo_checked1=$$v},expression:"Shopinfo_checked1"}},[_vm._v("全选")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"洗车","shape":"square"}},[_vm._v("洗车")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"美容","shape":"square"}},[_vm._v("美容")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"装潢","shape":"square"}},[_vm._v("装潢")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"保养","shape":"square"}},[_vm._v("保养")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"油漆","shape":"square"}},[_vm._v("油漆")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"维修","shape":"square"}},[_vm._v("维修")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"救援","shape":"square"}},[_vm._v("救援")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"年检","shape":"square"}},[_vm._v("年检")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"保险","shape":"square"}},[_vm._v("保险")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"理赔","shape":"square"}},[_vm._v("理赔")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"轮胎","shape":"square"}},[_vm._v("轮胎")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"安全检测","shape":"square"}},[_vm._v("安全检测")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"四轮定位","shape":"square"}},[_vm._v("四轮定位")]),_vm._v(" "),_c('van-checkbox',{attrs:{"name":"动平衡","shape":"square"}},[_vm._v("动平衡")])],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"营业面积","value":_vm.Shopinfo_val3,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker3 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker3),callback:function ($$v) {_vm.Shopinfo_Picker3=$$v},expression:"Shopinfo_Picker3"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择营业面积","columns":_vm.Shopinfo_columns3},on:{"cancel":function($event){_vm.Shopinfo_3 = false},"confirm":_vm.Shopinfo_onConfirm3}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"洗车工位","value":_vm.Shopinfo_val4,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker4 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker4),callback:function ($$v) {_vm.Shopinfo_Picker4=$$v},expression:"Shopinfo_Picker4"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择洗车工位","columns":_vm.Shopinfo_columns4},on:{"cancel":function($event){_vm.Shopinfo_4 = false},"confirm":_vm.Shopinfo_onConfirm4}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"美容工位","value":_vm.Shopinfo_val5,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker5 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker5),callback:function ($$v) {_vm.Shopinfo_Picker5=$$v},expression:"Shopinfo_Picker5"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择美容工位","columns":_vm.Shopinfo_columns5},on:{"cancel":function($event){_vm.Shopinfo_5 = false},"confirm":_vm.Shopinfo_onConfirm5}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"维保工位","value":_vm.Shopinfo_val6,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker6 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker6),callback:function ($$v) {_vm.Shopinfo_Picker6=$$v},expression:"Shopinfo_Picker6"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择维保工位","columns":_vm.Shopinfo_columns6},on:{"cancel":function($event){_vm.Shopinfo_6 = false},"confirm":_vm.Shopinfo_onConfirm6}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"烤漆房数","value":_vm.Shopinfo_val7,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.Shopinfo_Picker7 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.Shopinfo_Picker7),callback:function ($$v) {_vm.Shopinfo_Picker7=$$v},expression:"Shopinfo_Picker7"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择烤漆房数","columns":_vm.Shopinfo_columns7},on:{"cancel":function($event){_vm.Shopinfo_7 = false},"confirm":_vm.Shopinfo_onConfirm7}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"name":"radio","label":"独立休息区","input-align":"right"},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('van-radio-group',{attrs:{"direction":"horizontal"},model:{value:(_vm.Shopinfo_radio),callback:function ($$v) {_vm.Shopinfo_radio=$$v},expression:"Shopinfo_radio"}},[_c('van-radio',{attrs:{"name":"0"}},[_vm._v("有")]),_vm._v(" "),_c('van-radio',{attrs:{"name":"1"}},[_vm._v("无")])],1)]},proxy:true}])})],1),_vm._v(" "),_c('van-button',{staticClass:"shop_info_btn",attrs:{"size":"large","color":"rgb(25,137,250)","type":"info"},on:{"click":function($event){return _vm.handleClick2(_vm.tabList1[0])}}},[_vm._v("保存")])],1),_vm._v(" "),_c('van-tab',{staticClass:"change_shopinfo_tab",attrs:{"title":"企业信息"}},[_c('van-field',{attrs:{"name":"radio","label":"营业执照","input-align":"right"},scopedSlots:_vm._u([{key:"input",fn:function(){return [_c('van-radio-group',{attrs:{"direction":"horizontal"},model:{value:(_vm.CompanyInfo_radio),callback:function ($$v) {_vm.CompanyInfo_radio=$$v},expression:"CompanyInfo_radio"}},[_c('van-radio',{attrs:{"name":"0"}},[_vm._v("有")]),_vm._v(" "),_c('van-radio',{attrs:{"name":"1"}},[_vm._v("无")])],1)]},proxy:true}])}),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"企业法人","placeholder":"请输入姓名"},model:{value:(_vm.CompanyInfo_val1),callback:function ($$v) {_vm.CompanyInfo_val1=$$v},expression:"CompanyInfo_val1"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","type":"digit","label":"法人手机","placeholder":"请输入"},model:{value:(_vm.CompanyInfo_val2),callback:function ($$v) {_vm.CompanyInfo_val2=$$v},expression:"CompanyInfo_val2"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","type":"digit","label":"员工人数","placeholder":"请输入"},model:{value:(_vm.CompanyInfo_val3),callback:function ($$v) {_vm.CompanyInfo_val3=$$v},expression:"CompanyInfo_val3"}})],1),_vm._v(" "),_c('van-button',{staticClass:"shop_info_btn",attrs:{"size":"large","color":"rgb(25,137,250)","type":"info"},on:{"click":function($event){return _vm.handleClick3(_vm.tabList1[0])}}},[_vm._v("保存")])],1),_vm._v(" "),_c('van-tab',{staticClass:"change_shopinfo_tab",attrs:{"title":"证照店照"}},[_c('div',{staticClass:"shop_img"},[_c('div',{staticClass:"shop_certificate"},[_c('van-uploader',{attrs:{"upload-text":"营业执照","after-read":_vm.afterRead1,"max-count":1,"multiple":""},model:{value:(_vm.StoreImg_fileList1),callback:function ($$v) {_vm.StoreImg_fileList1=$$v},expression:"StoreImg_fileList1"}},[_c('img',{staticClass:"shop_uploadimg",attrs:{"src":__webpack_require__("We2S"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("营业执照")])],1),_vm._v(" "),_c('div',{staticClass:"shop_certificate"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead2,"max-count":1,"multiple":""},model:{value:(_vm.StoreImg_fileList2),callback:function ($$v) {_vm.StoreImg_fileList2=$$v},expression:"StoreImg_fileList2"}},[_c('img',{staticClass:"shop_uploadimg",attrs:{"src":__webpack_require__("We2S"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("工位图")])],1),_vm._v(" "),_c('div',{staticClass:"shop_certificate"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead3,"max-count":1,"multiple":""},model:{value:(_vm.StoreImg_fileList3),callback:function ($$v) {_vm.StoreImg_fileList3=$$v},expression:"StoreImg_fileList3"}},[_c('img',{staticClass:"shop_uploadimg",attrs:{"src":__webpack_require__("We2S"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("工位图")])],1),_vm._v(" "),_c('div',{staticClass:"shop_certificate"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead4,"max-count":1,"multiple":""},model:{value:(_vm.StoreImg_fileList4),callback:function ($$v) {_vm.StoreImg_fileList4=$$v},expression:"StoreImg_fileList4"}},[_c('img',{staticClass:"shop_uploadimg",attrs:{"src":__webpack_require__("We2S"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("工位图")])],1),_vm._v(" "),_c('div',{staticClass:"shop_certificate"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead5,"max-count":1,"multiple":""},model:{value:(_vm.StoreImg_fileList5),callback:function ($$v) {_vm.StoreImg_fileList5=$$v},expression:"StoreImg_fileList5"}},[_c('img',{staticClass:"shop_uploadimg",attrs:{"src":__webpack_require__("We2S"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("休息区")])],1),_vm._v(" "),_c('div',{staticClass:"shop_certificate"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead6,"multiple":""},model:{value:(_vm.StoreImg_fileList6),callback:function ($$v) {_vm.StoreImg_fileList6=$$v},expression:"StoreImg_fileList6"}},[_c('img',{staticClass:"shop_uploadimg",attrs:{"src":__webpack_require__("We2S"),"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("其他形象")])],1)]),_vm._v(" "),_c('van-button',{staticClass:"shop_info_btn",attrs:{"size":"large","color":"rgb(25,137,250)","type":"info"},on:{"click":function($event){return _vm.handleClick4(_vm.tabList1[0])}}},[_vm._v("保存")])],1)],1)],1),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bPVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ttButton_vue__ = __webpack_require__("tB3a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07170a06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ttButton_vue__ = __webpack_require__("/voH");
function injectStyle (ssrContext) {
  __webpack_require__("RZh8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07170a06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ttButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07170a06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ttButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bdat":
/***/ (function(module, exports) {

/**
 * author: 582196894@qq.com
 * date: 2017/12/11
 * desc: 视频播放
 * eg:<a href="#" v-video="src">视频播放</a>
 */

// import src from '../imgs/hu.png'

Vue.directive('video', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, arg) {
    var video = null;
    if (!tuhu.isLightApp) {
      video = document.createElement('video');
      video.src = arg.value;
      video.controls = true;
      video.preload = 'auto';
      video.style.display = 'none';
      $(el).after(video);
    }
    // const video = $(`<video
    //     src="${arg.value}"
    //     controls = "true"
    //     poster="images.jpg" /*视频封面*/
    //     preload="auto"
    //     webkit-playsinline="true" /*这个属性是ios 10中设置可以
    //                       让视频在小窗内播放，也就是不是全屏播放*/
    //     playsinline="true"  /*IOS微信浏览器支持小窗内播放*/
    //     x-webkit-airplay="allow"
    //     x5-video-player-type="h5"  /*启用H5播放器,是wechat安卓版特性*/
    //     x5-video-player-fullscreen="true" /*全屏设置，
    //                       设置为 true 是防止横屏*/
    //     x5-video-orientation="portraint" //播放器支付的方向， landscape横屏，portraint竖屏，默认值为竖屏
    //     style="object-fit:fill">
    //   </video>`).hide()[0]

    // video.height = 0
    // video.width = 0
    // video.style.position = 'fixed'
    // video.style.top = '-9999px'

    $(el).on('click', function () {
      if (tuhu.isLightApp) {
        system.go('/Component_Video?video=' + encodeURIComponent(arg.value));
        // if (tuhu.util.isMiApp()) {
        //   system.go('/Component_Video?video=' + encodeURIComponent(arg.value))
        // } else {
        //   system.go(`/component_video?video=${arg.value}`)
        // }
      } else {
        video.play();
        video.style.display = 'block';

        setTimeout(function () {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullScreen();
          }
        }, 200);
      }

      // tuhu.photoBrowser({
      //   photos: [
      //     src
      //   ]
      // }, {
      //   showPage: false
      // })
      // const pb = tuhu.getCurrentPage().instance.pb
      // window.pb = pb
      // $(pb.container).find('.photo-browser-zoom-container img').replaceWith(video)
      // video.play()
      // const pagination = $.Swiper.prototype.defaults.pagination

      // $.Swiper.prototype.defaults.pagination = ''

      // const pb = $.photoBrowser({
      //   photos: [{
      //     html: '<div style="position:fixed;top:15px;right:15px;color:#fff;font-size:14px;">关闭</div><iframe src="' + arg.value + '" frameborder="0" allowfullscreen></iframe>'
      //   }],
      //   theme: 'dark',
      //   type: 'standalone'
      // })
      // pb.open()

      // $(pb.container).on('click', function(ev) {
      //   $.Swiper.prototype.defaults.pagination = pagination

      //   pb.close()
      // })
    }, video.addEventListener('webkitfullscreenchange', function (e) {
      if (!document.webkitIsFullScreen) {
        // 退出全屏关闭视频
        video.style.display = 'none';
        video.pause();
      };
    }), video.addEventListener('webkitendfullscreen', function (e) {
      if (!document.webkitIsFullScreen) {
        // 退出全屏关闭视频
        video.style.display = 'none';
        video.pause();
      };
    }));
  }
});

/***/ }),

/***/ "cAUL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showPlate: this.showP,
      cityList: [['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫'], ['川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣'], ['闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂'], ['琼', '青', '新', '藏', '港', '澳', '', '', '']],
      EnglishList: [['港', '澳', '学', '警', '领'], ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'], ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O'], ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'P'], ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'L', 'delete']],
      citySelected: ' ',
      cityVal: this.cityV,
      carVal: this.carV
    };
  },

  props: {
    showmask: {
      type: Boolean
    },
    showP: {
      type: Number,
      default: 3
    },
    returnHandler: {
      type: Function
    },
    cityV: {
      type: String
    },
    carV: {
      type: String
    }
  },
  mounted: function mounted() {
    // window.test = this
  },

  watch: {
    showPlate: function showPlate(val) {
      if (val === 1) {
        $(this.$el).find('.cityPlate').eq(0).show();
        $(this.$el).find('.EnglishPlate').hide();
      } else if (val === 2) {
        $(this.$el).find('.cityPlate').eq(0).hide();
        $(this.$el).find('.EnglishPlate').show();
      }
    }
  },
  methods: {
    hidePlate: function hidePlate(e) {
      this.showPlate = 3;
    },
    citychooseHandler: function citychooseHandler(item) {
      if ($(event.currentTarget).hasClass('delete')) {
        this.ondelete();
      }
      if (item === '' || item === 'delete') return;
      this.citySelected = item;
      this.onchange(item);
    },
    cityremove: function cityremove(item) {
      if (item === '') return;
      if (this.showPlate === 1) {
        this.showPlate = 3;
      }
      this.citySelected = ' ';
    },

    onchange: function onchange(val) {
      // debugger
      if (this.showPlate === 1) {
        this.cityVal = val;
      } else if (this.showPlate === 2) {
        if (this.carVal === '请填写车牌号') {
          this.carVal = val;
        } else if (this.carVal.length < 7) {
          this.carVal = this.carVal + val;
        }
      }
      this.returnHandler(this.cityVal, this.carVal);
    },
    ondelete: function ondelete() {
      if (this.showPlate === 2) {
        if (this.carVal === '请填写车牌号') return;
        if (this.carVal.length <= 1) {
          this.carVal = '请填写车牌号';
          this.returnHandler(this.cityVal, this.carVal);
          return;
        }
        this.carVal = this.carVal.substring(0, this.carVal.length - 1);
        this.returnHandler(this.cityVal, this.carVal);
      }
    }
  }
});

/***/ }),

/***/ "cSKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

// const GET_CUSTOMER_SERVERICE_PARAM = 'https://wx.tuhu.cn/Home/Get_NTKF_PARAM'

// 客服脚本地址
// const CUSTOMER_SCRIPT_URL = 'https://dl.ntalker.com/js/xn6/ntkfstat.js?siteid=kf_9739'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // fetched: false,
      type: this.options.type,
      src:  true ? '/vue/customer.html' : '/static/customer.html'
    };
  },
  mounted: function mounted() {
    // tuhu.fetch(GET_CUSTOMER_SERVERICE_PARAM, {
    //   credentials: 'include' // 支持cookie
    // }).then(() => {
    //   const iframe = $(`<iframe>
    //       <html>
    //         <head>
    //         </head>
    //         <body></body>
    //       </html>
    //     </iframe>`)
    //   $(this.$el).append(iframe)
    //   const iframeDocument = iframe[0].contentDocument

    //   if (window.NTKF) {
    //     window.NTKF.im_openOutPageChat('kf_9739_1468912096836')
    //   } else {
    //     debugger
    //     tuhu.script(CUSTOMER_SCRIPT_URL, iframeDocument).then(() => {
    //       debugger
    //       // const script = iframeDocument.createElement('script')
    //       // script.innerHTML = `window.NTKF.im_openOutPageChat('kf_9739_1468912096836')`
    //       // $(iframeDocument.head).append(script)
    //       // window.NTKF.im_openOutPageChat('kf_9739_1468912096836')
    //     })
    //   }
    // })
  }
});

/***/ }),

/***/ "cSXx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"recruit-canvas"},[_c('div',{staticClass:"text-box"},[_c('div',{staticClass:"back",on:{"click":_vm.goBack}},[_vm._v("返回")]),_vm._v(" "),_c('span',{staticClass:"middle"},[_vm._v("请签名")])]),_vm._v(" "),_c('div',{staticClass:"canvas-out-box"},[_c('div',{ref:"canvasRef",staticClass:"canvas-box"},[_c('canvas',{ref:"canvasMapRef",attrs:{"id":"canvas-map","width":"100","height":"100"}})])]),_vm._v(" "),_c('div',{staticClass:"btn-box flex-row"},[_c('div',{staticClass:"btn-text"},[_c('van-icon',{attrs:{"name":"info","color":"#1989fa"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("本人确认已完成检测")])],1),_vm._v(" "),_c('div',{staticClass:"btn-boxs"},[_c('van-button',{staticClass:"no-use",attrs:{"size":"small"},on:{"click":_vm.clearHandle}},[_vm._v("一键清除")]),_vm._v(" "),_c('van-button',{attrs:{"size":"small","type":"info"},on:{"click":_vm.confirmHandle}},[_vm._v("确认签名")])],1)]),_vm._v(" "),_vm._t("default",null,{"signatrue":_vm.canvasNode})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ccG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "clQL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("iemT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__configs_config__ = __webpack_require__("65XL");






/**
 * author: 582196894@qq.com
 * date: 2017/11/29 rebuild
 * desc: fetch
 */




var GET_OUT_URL = '' + __WEBPACK_IMPORTED_MODULE_8__configs_config__["a" /* default */].apis.WX_SILENT;

// const API_URLS = ['api.tuhu.cn', 'api.tuhu.work', 'apidev.tuhu.work', 'by.tuhu.cn', 'activity-api.tuhu.cn']

// const NEED_PROXYS = ['item.tuhu.cn']

var counts = {};

var lastPageId = '';

var loginPromise = null;

var tokenLoaded = false;

function getCookie(key) {
  var reg = new RegExp(key + '=(.+?)(?:;|$)');
  var match = document.cookie.match(reg);

  return match && match[1] || '';
}

var Fetch = function () {
  function Fetch(url) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var other = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Fetch);

    var cookie = localStorage.getItem('shop-token') ? localStorage.getItem('shop-token') : __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get('x-auth-token');

    this.url = url;

    opts.credentials = 'include';

    this.opts = opts;
    this.opts.headers = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
      'Accept': '*/*',
      'Access-Control-Allow-Credentials': true,
      'x-auth-token': cookie
    }, url.indexOf('upload') > -1 || url.indexOf('vin/image/ocr') > -1 || url.indexOf('vin/ocr') > -1 || url.indexOf('imageListToPdf') > -1 ? {} : { 'Content-Type': 'application/json' },
    // 上传接口不需要设置content-type
    opts.headers);

    this.other = other;

    this.count = 0;

    this.timeout = false;

    this.timeoutId = null;

    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Fetch, [{
    key: 'init',
    value: function init() {
      this.other = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
        session: false,
        json: true,
        timeout: 30,
        limit: 2,
        status: true,
        force: true,
        query: {},
        phone: '' // 401跳转登陆->自动填写手机号并发送验证码
      }, this.other);

      // this.autoSession()
      // if (this.opts.method === 'post') {
      this.setProxy();
      // }
      this.setQuery();
      this.url = tuhu.config.apiFilter(this.url);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this = this;

      var other = this.other;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.race([new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.timeoutId = setTimeout(function () {
          _this.timeout = true;

          _this.endCount();

          _this.hideLoading();

          _this.showError('网络超时');

          reject({
            url: _this.url,
            code: -2,
            message: '网络超时'
          });
        }, other.timeout * 1000);
      }), this._fetch()]);
    }
  }, {
    key: '_fetch',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var url, opts, other;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = this.url;
                opts = this.opts;
                other = this.other;


                this.count++;
                this.pageCount();

                return _context2.abrupt('return', fetch(url, opts).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            clearTimeout(_this2.timeoutId);

                            if (!_this2.timeout) {
                              _context.next = 3;
                              break;
                            }

                            return _context.abrupt('return');

                          case 3:

                            _this2.endCount();
                            if (res.headers.get('x-auth-token')) {
                              localStorage.setItem('shop-token', res.headers.get('x-auth-token'));
                            }

                            if (!(res.code === '401' && !other.force)) {
                              _context.next = 10;
                              break;
                            }

                            localStorage.setItem('shop-token', '');
                            __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.remove('x-auth-token');
                            _this2.hideLoading();

                            return _context.abrupt('return', res);

                          case 10:
                            if (!(res.code === '401')) {
                              _context.next = 24;
                              break;
                            }

                            localStorage.setItem('shop-token', '');
                            __WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.remove('x-auth-token');

                            if (loginPromise) {
                              _context.next = 23;
                              break;
                            }

                            _this2.hideLoading();
                            // openId 只有后端（无次用户）重定向登陆页有

                            if (!(tuhu.device.isWeixin && !tuhu.getParam('openId') && !(location.href.indexOf('localhost') > -1))) {
                              _context.next = 20;
                              break;
                            }

                            location.href = GET_OUT_URL + '?url=' + encodeURIComponent(location.href) + '&source=3';

                            loginPromise = null;
                            _context.next = 23;
                            break;

                          case 20:
                            _context.next = 22;
                            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                              tuhu.navigateTo({
                                url: '/pages/_login/index',
                                query: {
                                  openId: tuhu.device.isWeixin ? tuhu.getParam('openId') : ''
                                },
                                data: {
                                  resolve: resolve
                                }
                              });
                            });

                          case 22:
                            loginPromise = _context.sent;

                          case 23:
                            return _context.abrupt('return', loginPromise.then(function (data) {
                              loginPromise = null;

                              if (!data.islogin) {
                                _this2.showError('用户信息缺失');

                                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject({
                                  url: _this2.url,
                                  code: -4,
                                  message: '用户信息缺失'
                                });
                              }

                              //   this.insertSession()
                              return _this2._fetch();
                            }));

                          case 24:
                            if (!res.ok) {
                              _context.next = 29;
                              break;
                            }

                            _this2.hideLoading();

                            if (!other.json) {
                              _context.next = 28;
                              break;
                            }

                            return _context.abrupt('return', res.json().then(function (data) {
                              if (data.code !== undefined) {
                                data.Code -= 0;
                              }

                              return data;
                            }).catch(function (e) {
                              _this2.showError( false ? e.message : '程序异常');

                              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject({
                                url: _this2.url,
                                code: -1,
                                message: e.message
                              });
                            }));

                          case 28:
                            return _context.abrupt('return', res);

                          case 29:
                            if (!(_this2.count < other.limit)) {
                              _context.next = 31;
                              break;
                            }

                            return _context.abrupt('return', _this2._fetch());

                          case 31:

                            _this2.hideLoading();

                            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject({
                              url: _this2.url,
                              code: -3,
                              message: '接口异常 状态码:' + res.code
                            }));

                          case 33:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()).then(function (data) {
                  return data;
                }));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _fetch() {
        return _ref.apply(this, arguments);
      }

      return _fetch;
    }()
  }, {
    key: 'showError',
    value: function showError(msg) {
      if (!this.other.status) {
        return;
      }

      tuhu.toast(msg || '网络异常,请稍候再试', 1000);
    }
  }, {
    key: 'endCount',
    value: function endCount() {
      if (!this.other.status) {
        return;
      }

      counts[lastPageId].end++;
    }
  }, {
    key: 'pageCount',
    value: function pageCount() {
      if (!this.other.status) {
        return;
      }

      var currentPageId = location.pathname;
      if (counts[lastPageId] && lastPageId !== currentPageId) {
        delete counts[lastPageId];
      }

      if (!counts[currentPageId]) {
        counts[currentPageId] = {
          begin: 0,
          end: 0
        };
      }

      if (counts[currentPageId].begin < 1) {
        tuhu.showIndicator();
      }

      counts[currentPageId].begin++;

      lastPageId = currentPageId;
    }
  }, {
    key: 'hideLoading',
    value: function hideLoading() {
      var other = this.other;

      if (!other.status) {
        return;
      }

      setTimeout(function () {
        if (counts[lastPageId].end >= counts[lastPageId].begin) {
          tuhu.hideIndicator();
        }
      }, 300);
    }
  }, {
    key: 'setProxy',
    value: function setProxy() {
      var url = this.url;

      if (false) {
        url = url.replace(/.*?\/\/.+?\//, '/');
      }

      this.url = url;
    }
  }, {
    key: 'setQuery',
    value: function setQuery() {
      var url = this.url;
      var str = $.param(this.other.query);
      // const query = this.other.query

      // const strArr = []
      // for (let i in query) {
      //   if (query.hasOwnProperty(i)) {
      //     strArr.push(`${i}=` + encodeURIComponent(query[i]))
      //   }
      // }
      if (str) {
        url += url.indexOf('?') > 0 ? '&' + str : '?' + str;
      }

      this.url = url;
    }
  }]);

  return Fetch;
}();

Fetch.fetch = function (url, opts, other) {
  var instance = new Fetch(url, opts, other);
  return instance.fetch();
};

/* harmony default export */ __webpack_exports__["a"] = (Fetch);

/***/ }),

/***/ "d7XO":
/***/ (function(module, exports) {

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/11/7
 * desc: navigateto
 * 不带参数的简便写法：
 * <div v-navigateto='item.pages'  >string to {{item.name}}</div>
 * 带参数的写法
 * <div v-navigateto="{url:'/pages/alert/alert', query:{a:1, b:2}, data:{user: {name: 'lijingwen'}}}">to {{item.name}}</div>
 */

Vue.directive('navigateto', {
  // 当绑定元素插入到 DOM 中。
  inserted: function inserted(el, options) {
    $(el).on('click', function () {
      // 只传入一个String参数时跳转不传参数
      if (Object.prototype.toString.call(options.value) === '[object String]') {
        tuhu.navigateTo({ url: options.value });
      } else {
        var _options$value = options.value,
            url = _options$value.url,
            query = _options$value.query,
            data = _options$value.data;

        tuhu.navigateTo({ url: url, query: query, data: data });
      }
    });
  }
});

/***/ }),

/***/ "dQAN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_year_vue__ = __webpack_require__("N9fb");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0a23d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_year_vue__ = __webpack_require__("0jmB");
function injectStyle (ssrContext) {
  __webpack_require__("Xegr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0a23d36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_year_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0a23d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_year_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dSEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imgs_v0_png__ = __webpack_require__("7AV6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__imgs_v0_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__imgs_v0_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imgs_v1_png__ = __webpack_require__("xgxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imgs_v1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__imgs_v1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imgs_v2_png__ = __webpack_require__("3R1Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imgs_v2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__imgs_v2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imgs_v3_png__ = __webpack_require__("sv6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imgs_v3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__imgs_v3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_v4_png__ = __webpack_require__("rHuL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_v4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__imgs_v4_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    group1: function group1() {
      return tuhu.util.getGroup();
    }
  },
  props: {
    commentData: {
      require: true,
      type: Object
    }
  },
  data: function data() {
    return {
      expanded: false, // 是否展开
      level: {
        V0: __WEBPACK_IMPORTED_MODULE_0__imgs_v0_png___default.a,
        V1: __WEBPACK_IMPORTED_MODULE_1__imgs_v1_png___default.a,
        V2: __WEBPACK_IMPORTED_MODULE_2__imgs_v2_png___default.a,
        V3: __WEBPACK_IMPORTED_MODULE_3__imgs_v3_png___default.a,
        V4: __WEBPACK_IMPORTED_MODULE_4__imgs_v4_png___default.a
      }
    };
  },

  methods: {
    changeState: function changeState() {
      this.expanded = !this.expanded;
    }
  }
});

/***/ }),

/***/ "dliB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dpq6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fail.bd8adc9.png";

/***/ }),

/***/ "dqcT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XTwm");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e197659_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Qzko");
function injectStyle (ssrContext) {
  __webpack_require__("WO5t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e197659"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e197659_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eAMs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/camera.97d296a.png";

/***/ }),

/***/ "eApe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("xx2W");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbbdc24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SOHT");
function injectStyle (ssrContext) {
  __webpack_require__("QpxN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cbbdc24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbbdc24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eIHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfills__ = __webpack_require__("aINi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user__ = __webpack_require__("H/tq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locate2__ = __webpack_require__("KbyD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__share__ = __webpack_require__("hjNn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fetch__ = __webpack_require__("clQL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__("iemT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page__ = __webpack_require__("2LI0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__phone__ = __webpack_require__("0KwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__twiceshare__ = __webpack_require__("IuaC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__("MQsz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__storage__ = __webpack_require__("qb/n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__script__ = __webpack_require__("mKeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__wxsdk__ = __webpack_require__("vlgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shopWxsdk__ = __webpack_require__("Ztm6");


/**
 * author: 582196894@qq.com
 * date: 2017/10/9
 * desc: 核心方法
 * 注意：
 * 1 query: {} 参数不用encodeURIComponent 已经统一处理过了
 * 2 getParam 新增参数 指定返回类型
 * 3 config 注入全局命名空间
 * 4 新增页面堆栈相关
 */
/** 项目核心配置 根据项目配置 */






















// import fetchJsonp from 'fetch-jsonp'









window.tuhu = {
    config: __WEBPACK_IMPORTED_MODULE_3__src_configs_config__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
    User: __WEBPACK_IMPORTED_MODULE_4__user__["a" /* default */],
    wxsdk: __WEBPACK_IMPORTED_MODULE_15__wxsdk__["a" /* default */],
    wxsdks: __WEBPACK_IMPORTED_MODULE_16__shopWxsdk__["a" /* default */],
    /**
     * 正常跳转
     * params {
     *  url: '',
     *  query: {}
     * }
     */
    navigateTo: function navigateTo(obj, other) {
        if (obj.webview && tuhu.device.isApp) {
            location.href = tuhu.util.getWebviewUrl(obj);
        } else {
            return __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].loadPage(obj, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
                direct: false
            }, other));
        }
    },


    /**
     * replace跳转
     * params {
     *  url: '',
     *  query: {}
     * }
     */

    redirectTo: function redirectTo(obj, other) {
        return __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].loadPage(obj, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
            direct: true
        }, other));
    },
    replaceTo: function replaceTo(obj, other) {
        return __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].loadPage(obj, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
            direct: false
        }, other));
    },


    /**
     * 后退
     * params {
     *  delta: 1 //返回的页面数目
     * }
     */
    navigateBack: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].navigateBack,

    loadModule: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].loadModule,

    loadFirstPage: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].loadFirstPage,

    /**
     * 回到指定的tab页
     * parmas: {
     *  url: '/pages/step2/step2'
     *}
     */
    switchTab: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].switchTab,

    device: __WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */].device,

    getDeviceDetail: __WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */].getDeviceDetail.bind(__WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */]),
    /**
     * // arg1 > arg2, return 1; arg1 == arg2, return 0; arg1 < arg2, return -1
        tuhu.compareVersion('8.0', '7.1.1')
        // return 1
        tuhu.compareVersion('4.2', $.device.osVersion)
        // return -1
        tuhu.compareVersion('5.0', '5.0')
        // return 0
     */
    compareVersion: $.compareVersion,

    /**
     * 我们需要调用以下任一一种App方法来打开Alert modal ：
     * tuhu.alert(text, [title, callbackOk])
        或者
        tuhu.alert(text, [callbackOk])
         text - string. Alert文本
        title - string. Optional. Alert modal 标题
        callbackOk - function. Optional.在Alert modal下，当用户点击“Ok”按钮时，回调函数将被执行。
      * tuhu.alert('Here goes alert text')
     * tuhu.alert('Here goes alert text', 'Custom Title!')
     * tuhu.alert('Here goes alert text', 'Custom Title!', function () {
            $.alert('Button clicked!')
        })
     * tuhu.alert('Here goes alert text', function () {
            $.alert('Button clicked!')
        })
     */
    alert: $.alert,
    /**
    * author: 李婧雯@tuhu.cn
    * date: 2017/11/8
    * desc: showdialog
    * tuhu.showDialog({
        text: `<div class='mycontent'>opendialog1</div>`,
        onClose: function(e) {
        }
      })
    */
    showDialog: function showDialog(args) {
        args = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
            'text': '',
            'onClose': function onClose() {}
        }, args);
        tuhu.modal({
            'text': args.text,
            'extraClass': 'dialogwrap',
            'buttons': [{
                text: '<div>关闭</div>',
                onClose: false,
                onClick: function onClick(e) {
                    args.onClose(e);
                    tuhu.closeModal(e.selector[0]);
                }
            }]
        });
    },

    /**
     * Confirm modal 经常在需要确认一些行为时被使用. 打开Alert modal同样也需要调用以下任一一种App方法：$.confirm(text, [title, callbackOk, callbackCancel])
        或者
        $.confirm(text, [callbackOk, callbackCancel])
         text - string. Confirm 文本
        title - string. Optional. Confirm modal 标题
        callbackOk - function. Optional. 在 Confirm modal下，当用户点击“Ok”按钮时，回调函数将被执行。(当用户确认操作）
        callbackCancel - function. Optional. 在 Confirm modal下，当用户点击“Cancel”按钮时，回调函数将被执行。(当用户不想进行操作)
         tuhu.confirm('Are you sure?', function () {
            tuhu.alert('You clicked Ok button')
        })
         tuhu.confirm('Are you sure?',
                function () {
                    tuhu.alert('You clicked Ok button')
                },
                function () {
                    tuhu.alert('You clicked Cancel button')
                }
        )
         tuhu.confirm('Are you sure?', 'Custom Title', function () {
            tuhu.alert('You clicked Ok button')
        })
         $.confirm('Are you sure?', 'Custom Title',
            function () {
                tuhu.alert('You clicked Ok button')
            },
            function () {
                tuhu.alert('You clicked Cancel button')
            }
        )
     */
    confirm: $.confirm,

    /**
     * Prompt modal 经常在需要从用户那里得到一些数据/答案时使用。打开 Prompt modal同样也需要调用以下任一一种App方法：$.prompt(text, [title, callbackOk, callbackCancel])
        或者
        $.prompt(text, [callbackOk, callbackCancel])
         text - string. Prompt 文本/问题
        title - string. Optional. Prompt modal 标题
        callbackOk - function. Optional. 在 Prompt modal下，当用户点击“Ok”按钮时，回调函数将被执行。回调函数的参数是输入框的值
        callbackCancel - function. Optional. 在 Prompt modal下，当用户点击“Cancel”按钮时，回调函数将被执行。回调函数的参数是输入框的值
         tuhu.prompt('What is your name?', function (value) {
            tuhu.alert('Your name is "' + value + '". You clicked Ok button')
        })
         tuhu.prompt('What is your name?',
            function (value) {
                tuhu.alert('Your name is "' + value + '". You clicked Ok button')
            },
            function (value) {
                tuhu.alert('Your name is "' + value + '". You clicked Cancel button')
            }
        )
         tuhu.prompt('What is your name?', 'Custom Title', function (value) {
          tuhu.alert('Your name is "' + value + '". You clicked Ok button')
        })
         tuhu.prompt('What is your name?', 'Custom Title',
            function (value) {
                tuhu.alert('Your name is "' + value + '". You clicked Ok button')
            },
            function (value) {
                tuhu.alert('Your name is "' + value + '". You clicked Cancel button')
            }
        )
     */
    prompt: $.prompt,

    /**
     * 自定义Modals
        Ok, 所有的预定义modals都只是一些适用于特定的场景的方法. 让我们看看如何创建自定义的 modals:
         $.modal(parameters) - 显示 custom modal
         parameters - object. Modal 的 parameters/options对象
        该方法返回动态创建的modal的HTML元素。
         这里有 Modal 的参数列表:
         参数  类型  默认值 描述
        title 字符串 可选. Modal 标题 (可以是html字符串)
        text  字符串 可选. Modal 文本 (可以是html字符串)
        afterText 字符串 可选. 将被放在"text"后的文本 (可以是html字符串)
        buttons 数组  可选. 按钮数组. 每个按钮应该被表示为带按钮参数的对象 (看下面)
        extraClass  字符串 可选. 给modal的根节点.modal附加1或多个自定义class(如'bg-red','bg-blue share-type')，方便按需定制不同的modal样式。
        verticalButtons boolean  false Optional. Set to true to enable vertical buttons layout
        onClick 函数  可选. 回调函数将在用户点击任何Modal按钮后被触发执行. 它接收 modal (Modal的 HTML元素) 和 index作为参数 (被点击按钮的索引号)
        让我们一起来看看按钮参数:
         参数  类型  默认值 描述
        text  字符串 按钮文本 (可以是 HTML 字符串)
        bold  布尔值 false  可选. 设置为true会加粗按钮文本
        close 布尔值  true  可选. 如果是“true”，点击这个按钮后modal会被关闭
        onClick 函数  可选. 用户点击这个按钮后，回调函数会被执行
          tuhu.modal({
            title:  'Modal with 3 buttons',
            text: 'Vivamus feugiat diam velit. Maecenas aliquet egestas lacus, eget pretium massa mattis non. Donec volutpat euismod nisl in posuere. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
            buttons: [
                {
                    text: 'B1',
                    onClick() {
                        tuhu.alert('You clicked first button!')
                    }
                },
                {
                    text: 'B2',
                    onClick() {
                        tuhu.alert('You clicked second button!')
                    }
                },
                {
                    text: 'B3',
                    bold: true,
                    onClick() {
                        tuhu.alert('You clicked third button!')
                    }
                },
            ]
        })
         tuhu.modal({
            title: 'Awesome Photos?',
            text: 'What do you think about my photos?',
            afterText:  '<div class="swiper-container" style="width: auto; margin:5px -15px -15px">'+
                            '<div class="swiper-pagination"></div>'+
                            '<div class="swiper-wrapper">'+
                            '<div class="swiper-slide"><img src="..." height="150" style="display:block"></div>' +
                            '<div class="swiper-slide"><img src="..." height="150" style="display:block"></div>'+
                            '</div>'+
                        '</div>',
            buttons: [
                {
                    text: 'Bad :('
                },
                {
                    text: 'Awesome!',
                    bold: true,
                    onClick () {
                        tuhu.alert('Thanks! I know you like it!')
                    }
                },
            ]
        })
         tuhu.modal({
            title:  '<div class="buttons-row">'+
                        '<a href="#tab1" class="button active tab-link">Tab 1</a>'+
                        '<a href="#tab2" class="button tab-link">Tab 2</a>'+
                    '</div>',
            text: '<div class="tabs">'+
                    '<div class="tab active" id="tab1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam convallis nunc non dolor euismod feugiat. Sed at sapien nisl. Ut et tincidunt metus. Suspendisse nec risus vel sapien placerat tincidunt. Nunc pulvinar urna tortor.</div>'+
                    '<div class="tab" id="tab2">Vivamus feugiat diam velit. Maecenas aliquet egestas lacus, eget pretium massa mattis non. Donec volutpat euismod nisl in posuere. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae</div>'+
                    '</div>',
            buttons: [
                {
                    text: 'Ok, got it',
                    bold: true
                },
            ]
        })
         tuhu.modal({
            title:  'Vertical Buttons Layout',
            text: 'Vivamus feugiat diam velit. Maecenas aliquet egestas lacus, eget pretium massa mattis non. Donec volutpat euismod nisl in posuere. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae',
            verticalButtons: true,
            buttons: [
                {
                    text: 'Button 1',
                    onClick() {
                        tuhu.alert('You clicked first button!')
                    }
                },
                {
                    text: 'Button 2',
                    onClick() {
                        tuhu.alert('You clicked second button!')
                    }
                },
                {
                    text: 'Button 3',
                    onClick() {
                        tuhu.alert('You clicked third button!')
                    }
                },
            ]
        })
     */
    modal: $.modal,

    /**
     *  - 关闭任意 modal
     *  updated by wanglin @2017-10-18
        modal - HTMLElement or string ( CSS 选择器). 可选，关闭指定的modal. 除了指定的modal，任何被打开modal都将被关闭。不传或者没有找到则关闭所有modal
     */
    closeModal: $.closeModal,

    /**
     * 预加载 Modal 用来提示一些后台活动（像Ajax请求）和阻止在这个活动期间的任何用户操作。 打开预加载 modal 我们也需要调用适当的App方法: $.show预加载([title])- 显示 预加载 modal
        title - string. Optional. 预加载 modal 标题. 默认（没有指定）的时候，它等同于 "Loading...". 你可以在App初始化时通过 modal预加载Title 参数改变默认的 预加载 标题
     */
    showPreloader: $.showPreloader,

    /** 关闭加载器 */
    hidePreloader: $.hidePreloader,

    /** 如果你不需要用像预加载Modal这样如此大的modal 窗口去指示活动, 你可以使用简单并且小的指示器modal */
    showIndicator: $.showIndicator,

    /** 隐藏/关闭指示器 modal. 因为指示器modal没有任何按钮, 它需要用JavaScript来关闭 */
    hideIndicator: $.hideIndicator,

    /**
     * toast是一种轻量的提示，在页面中间显示，并且会在2秒(默认值，可修改)之后自动消失。
        可以用来显示一些不会打断用户操作的提示。
        * msg{string}: toast内容
        * duration{number}：toast显示时间,默认2000
        * extraclass{string}：给toast根节点附加class，高度自定义属性，方便用户自行控制不同场景的样式。
        * 如果使用了第三个参数，请自行在业务css里添加extraclass对应的样式
         $.toast("操作失败")
        $.toast('操作成功，正在跳转...', 2345, 'success top')
     */
    toast: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].toast.bind(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */]),

    /**
     * 操作表可以让用户从多个可选的操作中选择一个
        $.actions(buttons) - 创建并弹出一个操作表
        buttons - 显示的几个按钮，你也可以把按钮分组
        你可以通过 color: "danger" 来指定按钮的文案为红色
        或者通过 bg: "danger" 来指定按钮的背景为红色
         eg:const buttons1 = [
            {
                text: '请选择',
                label: true
            },
            {
                text: '卖出',
                bold: true,
                color: 'danger',
                onClick() {
                    $.alert("你选择了“卖出“")
                }
            },
            {
                text: '买入',
                onClick() {
                    $.alert("你选择了“买入“")
                }
            }
        ]
        const buttons2 = [
            {
                text: '取消',
                bg: 'danger'
            }
        ]
        const groups = [buttons1, buttons2]
        tuhu.actions(groups)
     */
    actions: $.actions,

    /** 动态加载脚本 */
    script: __WEBPACK_IMPORTED_MODULE_14__script__["a" /* default */].load,

    /** 获取地理位置 */
    locate: __WEBPACK_IMPORTED_MODULE_5__locate2__["a" /* default */],
    getLocate: __WEBPACK_IMPORTED_MODULE_5__locate2__["a" /* default */].getLocate,

    /** 获取用户信息 */
    getUserInfo: __WEBPACK_IMPORTED_MODULE_4__user__["a" /* default */].getUserInfo,

    /** 设置用户信息 内部调用 */
    _setUserInfo: __WEBPACK_IMPORTED_MODULE_4__user__["a" /* default */].setUserInfo,

    /** 唤起 app头部分享 */
    appShare: __WEBPACK_IMPORTED_MODULE_6__share__["a" /* default */].share,

    /** 获取路由path */
    getPath: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getPath,

    getFullPath: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getFullPath,

    /** 获取所有参数 */
    getParams: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getParams,

    /** 获取指定参数 */
    getParam: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */].getParam,

    /** 兼容无痕模式下sessionStorage */
    sessionStorage: __WEBPACK_IMPORTED_MODULE_13__storage__["a" /* default */].sessionStorage,

    /** 兼容无痕模式下localStorage */
    localStorage: __WEBPACK_IMPORTED_MODULE_13__storage__["a" /* default */].localStorage,

    /** 工具方法 */
    util: __WEBPACK_IMPORTED_MODULE_8__util__["a" /* default */],

    //   car: Car,

    /** 选车 */
    //   selectCar: Car.selectCar,

    /** 获取默认车型 */
    //   getDefaultCar: Car.getDefaultCar,

    /**
     * 更新车型信息
     * tuhu.updateCar({
     *  CarNumber: '',
     *  Registrationtime: ''
     * })
     * */
    //   updateCar: Car.updateCar,

    /** 新增页面堆栈 内部调用 */
    _setCurrentPage: __WEBPACK_IMPORTED_MODULE_9__page__["a" /* default */]._setCurrentPage,

    /** 新增页面堆栈 内部调用 */
    _popPage: __WEBPACK_IMPORTED_MODULE_9__page__["a" /* default */]._popPage,

    /** 获取所有页面堆栈 */
    getCurrentPages: __WEBPACK_IMPORTED_MODULE_9__page__["a" /* default */].getCurrentPages,

    /** 获取当前页面堆栈 */
    getCurrentPage: __WEBPACK_IMPORTED_MODULE_9__page__["a" /* default */].getCurrentPage,

    delPage: __WEBPACK_IMPORTED_MODULE_9__page__["a" /* default */].delPage,

    fetch: __WEBPACK_IMPORTED_MODULE_7__fetch__["a" /* default */].fetch,

    /**
     * 原生交互
     */
    actionWithNative: __WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */].actionWithNative,

    actionWithAll: __WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */].actionWithAll,

    /**
     * 查违章
     */
    toWeiZhang: function toWeiZhang() {
        return this.actionWithNative('toWeiZhang');
    },


    /**
     * 唤起收银台 参看首页使用
     * channel在内部判断
     */
    //   openBank: Pay.openBank,
    validatelogin: function validatelogin() {
        return this.actionWithNative('validatelogin', {
            presentLogin: false
        });
    },

    /**
     * params type standalone|popup 默认 standalone
    tuhu.photoBrowser({
        photos : [
            '//img.alicdn.com/tps/i3/TB1kt4wHVXXXXb_XVXX0HY8HXXX-1024-1024.jpeg',
            '//img.alicdn.com/tps/i1/TB1SKhUHVXXXXb7XXXX0HY8HXXX-1024-1024.jpeg',
            '//img.alicdn.com/tps/i4/TB1AdxNHVXXXXasXpXX0HY8HXXX-1024-1024.jpeg',
        ]
    })
    * 有标题
    tuhu.photoBrowser({
        photos : [
            {
                url: '//img.alicdn.com/tps/i3/TB1kt4wHVXXXXb_XVXX0HY8HXXX-1024-1024.jpeg',
                caption: 'Caption 1 Text'
            },
            {
                url: '//img.alicdn.com/tps/i1/TB1SKhUHVXXXXb7XXXX0HY8HXXX-1024-1024.jpeg',
                caption: 'Second Caption Text'
            },
            // 这个没有标题
            {
                url: '//img.alicdn.com/tps/i4/TB1AdxNHVXXXXasXpXX0HY8HXXX-1024-1024.jpeg',
            },
        ],
        type: 'popup'
    })
    * 有视频
    tuhu.photoBrowser({
        photos : [
            {
                html: '<iframe src="//www.youtube.com/embed/lmc21V-zBq0?list=PLpj0FBQgLGEr3mtZ5BTwtmSwF1dkPrPRM" frameborder="0" allowfullscreen></iframe>',
                caption: 'Woodkid - Run Boy Run (Official HD Video)'
            },
            {
                url: 'http://lorempixel.com/1024/1024/sports/2/',
                caption: 'Second Caption Text'
            },
            {
                url: 'http://lorempixel.com/1024/1024/sports/3/',
            },
        ],
        type: 'standalone'
    })
     */
    photoBrowser: function photoBrowser() {
        var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var other = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        other = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
            index: 0,
            showPage: true
        }, other);

        this.navigateTo({
            url: '/pages/_photo/index',
            data: {
                photos: args.photos,
                other: other
            }
        }, {
            animation: false
        });
    },


    /** 二次分享 */
    twiceShare: __WEBPACK_IMPORTED_MODULE_11__twiceshare__["a" /* default */].share,

    /** 弹出分享面板 */
    //   sharePanel: SharePanel.share,

    detachInfiniteScroll: $.detachInfiniteScroll,

    /**
     * @param {*} data {
        lat: 31.1364283468,
        lng: 121.3640087132,
        name: "养车工场店（罗秀路店）",
        address: "上海市徐汇区罗秀路105号（近平福路路口）"
        }
     */
    locateTo: __WEBPACK_IMPORTED_MODULE_5__locate2__["a" /* default */].locateTo,

    /**
     * 新开webview
     * @param String {*} url
     */
    newWebView: __WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */].newWebView.bind(__WEBPACK_IMPORTED_MODULE_10__phone__["a" /* default */]),

    /** jsonp请求 */
    //   fetchJsonp: fetchJsonp,

    /**
     * 唤起原生高德百度地图
     * @param {*} data {
        lat: 31.1364283468,
        lng: 121.3640087132
        }
     */
    nativeMap: __WEBPACK_IMPORTED_MODULE_5__locate2__["a" /* default */].nativeMap,

    /**
     * 调整门店列表
     */
    selectShop: function selectShop() {
        this.navigateTo({
            url: '/pages/_shops/index'
        });
    },

    /**
     * 更改选择的默认门店
     * author :lijignwen@tuhu.cn
     * date: 2017.12.5 pids 必须
     * tuhu.changeShop({
          serviceType: 2, // 门店类型 1 轮胎 2 保养 4 服务
          pids: '', // pids
          activityId: '', // 活动id
          shopId: 60, // 默认门店id
        })
          .then((shopDetail)=>{
          })
     */
    changeShop: function changeShop(data) {
        var sResolve = void 0;
        var shopPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            sResolve = resolve;
        }).catch(function (e) {});
        this.navigateTo({
            url: '/pages/_shops/selectShopList',
            data: {
                callBack: function callBack(shopDetal) {
                    sResolve(shopDetal);
                },

                shopData: data
            }
        });
        return shopPromise;
    }
    // 支付
    //   Pay: (params, type) => {
    //     return Pay.toPay(params, type)
    //   }

};

window.xk = window.tuhu;

__webpack_require__("y+7s");
__webpack_require__("GjXy");
__webpack_require__("TMiK");
__webpack_require__("BN2I");
__webpack_require__("d7XO");
__webpack_require__("KEzI");
__webpack_require__("1bfi");
__webpack_require__("slVp");
__webpack_require__("0EE9");
__webpack_require__("/Hz0");
__webpack_require__("UywY");
__webpack_require__("aieO");
__webpack_require__("Mp5C");
__webpack_require__("Yoto");
__webpack_require__("Gh1x");
__webpack_require__("bdat");
__webpack_require__("0/Pl");
__webpack_require__("oaFS");

__webpack_require__("hux5");

/** 系统页面 */

tuhu.config.pages['/pages/_login/index'] = {
    title: '登录',
    vue: __webpack_require__("TgOU")
};

tuhu.config.pages['/pages/_emptypage/index'] = {
    title: '404',
    vue: __webpack_require__("9J6N")
};

tuhu.config.pages['/pages/_search/index'] = {
    title: '搜索',
    vue: __webpack_require__("BKEK"),
    notForceLogin: true
};

tuhu.config.pages['/pages/_search/list'] = {
    title: '搜索列表',
    vue: __webpack_require__("frIA"),
    notForceCar: true,
    forceLocate: true
};

tuhu.config.pages['/pages/_comments/product'] = {
    title: '商品评价',
    vue: __webpack_require__("7Cty")
};

tuhu.config.pages['/pages/_comments/shop'] = {
    title: '店铺评价',
    vue: __webpack_require__("+bc7")
};

tuhu.config.pages['/pages/_shops/selectShopList'] = {
    title: '门店列表',
    vue: __webpack_require__("gMpH"),
    forceLocate: true, // 是否需要强制获取地理位置
    forceLogin: false // 是否需要强制登录
};

tuhu.config.pages['/pages/_customer/index'] = {
    title: '客服',
    vue: __webpack_require__("23rr")
};

tuhu.config.pages['/pages/_newcustomer/index'] = {
    title: '客服',
    vue: __webpack_require__("IA7G")
};

tuhu.config.pages['/pages/_locate/index'] = {
    title: '导航',
    vue: __webpack_require__("6seA")
};

tuhu.config.pages['/pages/_shops/index'] = {
    title: '门店',
    vue: __webpack_require__("dqcT")
};

tuhu.config.pages['/pages/_photo/index'] = {
    title: '图片浏览',
    vue: __webpack_require__("gdej")
};

/***/ }),

/***/ "eLXq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/add.397f9f1.png";

/***/ }),

/***/ "egk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs_config__ = __webpack_require__("65XL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});

/***/ }),

/***/ "eh36":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "emv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__ = __webpack_require__("Vz2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_zh_cn__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale("zh-cn");
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            icon1: 'https://res.xiaokunkeji.cn/image/2023/12/13/5f83129518f9435f8e1164fc214e9ee4.png',
            icon2: 'https://res.xiaokunkeji.cn/image/2023/12/13/8f44c0445f0549418588fdd8154acd72.png',
            dataInfo: {},
            verifyNum: tuhu.getParam('verifyNum') || '',
            verifyIncome: tuhu.getParam('verifyIncome') || '',
            isSucess: tuhu.getParam('isSucess') || '',
            shopId: tuhu.getParam('shopId') || '',
            goodsOrderId: tuhu.getParam('goodsOrderId') || '',
            tips: tuhu.getParam('tips') || '',
            isShow: false,
            currentItem: {}
        };
    },
    created: function created() {
        if (this.isSucess) {
            this.getResultList();
        }
    },


    methods: {
        getResultList: function getResultList() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                tuhu.showIndicator();
                                tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_TIKTOK_MERCHANT_LIST + '/' + _this.goodsOrderId).then(function (data) {
                                    if (data.code === '200') {
                                        tuhu.hideIndicator();
                                        _this.dataInfo = data.data;
                                    } else {
                                        tuhu.hideIndicator();
                                        tuhu.toast(data.message);
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },


        //撤销核销接口
        sureRevoke: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var res;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.QUERY_TIKTOK_CANCEL, {
                                method: "post",
                                body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                    providerOrderId: this.currentItem.providerOrderId
                                })
                            });

                        case 2:
                            res = _context2.sent;

                            if (res && res.code === '200') {
                                this.getResultList();
                            } else {
                                tuhu.toast(res.message || "网络错误");
                            }

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        })), 500),

        toView: function toView() {
            tuhu.navigateTo({
                url: '/pages/dayRecord/index',
                query: {
                    date: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY-MM-DD"),
                    shopId: this.shopId
                }
            });
        },
        toHome: function toHome() {
            tuhu.navigateTo({
                url: '/pages/home/index'
            });
        }
    }
});

/***/ }),

/***/ "f/Ek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs_config__ = __webpack_require__("65XL");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    },
    slideId: {
      type: Boolean,
      default: true,
      require: true
    }
  },
  data: function data() {
    return {
      countdown: 0, //倒计时
      hasScrolled: false,
      timer: null //计时器
    };
  },

  watch: {
    // visible(val) {
    //   if (val) {
    //     // 重置状态
    //     this.hasScrolled = false;
    //     if (!this.slideId) {
    //       this.countdown = 15;
    //     }else{
    //        this.countdown = 0
    //     }
    //     clearInterval(this.timer);
    //   }
    // }
  },
  mounted: function mounted() {
    if (this.visible) {
      // 重置状态
      this.hasScrolled = false;
      if (!this.slideId) {
        this.countdown = 15;
      } else {
        this.countdown = 0;
      }
      clearInterval(this.timer);
    }
  },


  methods: {
    open: function open() {
      location.href = "https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241472/content.html";
      tuhu.localStorage.setItem("visibleSlidePop", 1);
    },

    // 处理滚动事件
    handleScroll: function handleScroll() {
      if (!this.hasScrolled) {
        this.hasScrolled = true;
        this.startCountdown();
      }
    },


    // 初始化倒计时
    startCountdown: function startCountdown() {
      var _this = this;

      if (!this.slideId) {
        this.timer = setInterval(function () {
          _this.countdown -= 1;
          if (_this.countdown <= 0) {
            clearInterval(_this.timer);
          }
        }, 1000);
      } else {
        this.countdown = 0;
      }
    },

    // 处理关闭操作
    handleClose: function handleClose() {
      if (this.countdown > 0) return;
      if (this.countdown <= 0 && !this.slideId) {
        this.addUserNotice(1);
      }
      tuhu.localStorage.setItem("visibleSlidePop", 2);
      this.$emit("close");
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, userInfoPromise;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_2__configs_config__["a" /* default */].apis.GET_USERINFO);

              case 2:
                res = _context.sent;

                if (res && res.code === "200") {
                  userInfoPromise = tuhu._setUserInfo(res.data); // 返回数据

                  if (_this2.options && _this2.options.resolve) {
                    _this2.options.resolve(userInfoPromise);
                  }
                } else {
                  tuhu.toast(res.message || "获取权限信息失败");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    //用户看过某个公告
    addUserNotice: function addUserNotice(type) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formdata, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                formdata = new FormData();

                formdata.append("type", type); // 文件对象
                _context2.next = 5;
                return tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_2__configs_config__["a" /* default */].apis.ADD_USER_NOTICE, {
                  method: "post",
                  body: new URLSearchParams({
                    type: type
                  }),
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  }
                });

              case 5:
                data = _context2.sent;

                if (!(data.code === "200")) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this3.getUserInfo();

              case 9:
                _context2.next = 12;
                break;

              case 11:
                tuhu.toast(data.message);

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);

                console.log("err", _context2.t0);
                tuhu.toast(_context2.t0);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ "f93R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"_content"},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","src":_vm.url}}),_vm._v(" "),_c('button',{staticClass:"close-btn",on:{"click":_vm.handleClose}},[_vm._v("×")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fKu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fWlp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticStyle:{"width":"100%","text-align":"center","margin-top":"1rem"}},[_c('van-icon',{attrs:{"name":"passed","color":"#1677FF","size":"70"}}),_vm._v(" "),_c('p',{staticStyle:{"color":"#1677FF","font-size":"1rem","margin-top":"10px"}},[_vm._v("客户"+_vm._s(_vm.orderStatus))])],1),_vm._v(" "),_c('div',{staticClass:"det-info"},[_c('p',[_c('span',[_vm._v("合计收款")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#FF3B30"}},[_vm._v("￥ "+_vm._s(_vm.billData.totalPayPrice))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("商品订单")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.billData.orderId))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("下单时间")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.billData.placeTheOrderOfTime))])])]),_vm._v(" "),_c('div',{staticClass:"ser-info"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ser-main"},_vm._l((_vm.billData.childGoodsDetaiDtos),function(item,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(item.goodsName))]),_vm._v(" "),_c('span',[_vm._v("￥"+_vm._s(item.goodsPrice))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.buyCount))])])}),0)]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_c('van-button',{staticStyle:{"width":"8rem","margin":"0px","padding":"0px"},attrs:{"round":"","size":"normal","type":"info"},on:{"click":_vm.newBack}},[_vm._v("重新下新单")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","color":"#BEBEBE","margin-top":"10px"}},[_vm._v("咨询客服 "),_c('i',{directives:[{name:"call",rawName:"v-call"}],staticStyle:{"color":"#006EEF"}},[_vm._v("400-176-8848")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"tit-con"},[_c('span',[_vm._v("服务")]),_vm._v(" "),_c('span',[_vm._v("金额")]),_vm._v(" "),_c('span',[_vm._v("数量")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "faWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"verify-img-out"},[_c('div',{staticClass:"verify-img-panel",style:({
        width: _vm.setSize.imgWidth,
        height: _vm.setSize.imgHeight,
        'background-size': _vm.setSize.imgWidth + ' ' + _vm.setSize.imgHeight,
        'margin-bottom': _vm.vSpace + 'px'
      })},[_c('van-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRefresh),expression:"showRefresh"}],staticClass:"icon-refresh",staticStyle:{"z-index":"3"},attrs:{"name":"replay"},on:{"click":_vm.refresh}}),_vm._v(" "),_c('img',{ref:"canvas",staticStyle:{"width":"100%","height":"100%","display":"block"},attrs:{"src":_vm.pointBackImgBase ? 'data:image/png;base64,' + _vm.pointBackImgBase : _vm.defaultImg,"alt":""},on:{"click":function($event){_vm.bindingClick ? _vm.canvasClick($event) : undefined}}}),_vm._v(" "),_vm._l((_vm.tempPoints),function(tempPoint,index){return _c('div',{key:index,staticClass:"point-area",style:({
          'background-color': '#1abd6c',
          color: '#fff',
          'z-index': 9999,
          width: '20px',
          height: '20px',
          'text-align': 'center',
          'line-height': '20px',
          'border-radius': '50%',
          position: 'absolute',
          top: parseInt(tempPoint.y - 10) + 'px',
          left: parseInt(tempPoint.x - 10) + 'px'
        })},[_vm._v("\n        "+_vm._s(index + 1)+"\n      ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"verify-bar-area",style:({
      width: _vm.setSize.imgWidth,
      color: this.barAreaColor,
      'border-color': this.barAreaBorderColor,
      'line-height': this.barSize.height
    })},[_c('span',{staticClass:"verify-msg"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fon5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"search"},[_c('van-search',{attrs:{"shape":"round","placeholder":"请输入搜索关键词"},model:{value:(_vm.bankName),callback:function ($$v) {_vm.bankName=$$v},expression:"bankName"}})],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"list"},_vm._l((_vm.bankList),function(item,index){return _c('div',{key:item.code,staticClass:"li bottom-line",on:{"click":function($event){return _vm.clickBank(item)}}},[_vm._v(_vm._s(item.text))])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "frIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("w2vY");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca02af8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("KCds");
function injectStyle (ssrContext) {
  __webpack_require__("XRQx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ca02af8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca02af8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "g4ZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_list_vue__ = __webpack_require__("z+E+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RecordList: __WEBPACK_IMPORTED_MODULE_3__components_list_vue__["a" /* default */] },
  data: function data() {
    return {
      dataList: [],
      tabList: {
        verifyOrderSum: {
          num: 0,
          text: "核销订单数",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/50fa1f29610e4cfaa9074e811fcd18e9.png'
        },
        orderAmountSum: {
          num: 0,
          text: "核销订单总收入",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/4360a3f7855d4483bcd3d25d3e4060e2.png'
        }
      },
      queryDate: "", //查询天
      isShow: false, //撤销弹窗
      time: null, //定时器
      revokeInfo: {}, //撤销数据
      flag: true, //撤销按钮锁
      queryDateText: ''
    };
  },
  mounted: function mounted() {
    this.queryDate = tuhu.getParam("date");
    this.queryDateText = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.queryDate).format("YYYY年MM月DD日");
    this.shopId = tuhu.getParam("shopId") || JSON.parse(localStorage.getItem("_xk_user_key"))['shopId'];
    this.queryDataList();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.time);
  },

  methods: {
    revoke: function revoke(row) {
      this.isShow = true;
      this.revokeInfo = row;
    },

    //核销后59分钟内展示撤销按钮
    handleRevokeShow: function handleRevokeShow() {
      var _this = this;
      this.time = setInterval(function () {
        var nowTime = Math.floor(new Date().getTime() / (1000 * 60));
        _this.dataList = _this.dataList.map(function (item) {
          var writeOffTime = Math.floor(new Date(item.date).getTime() / (1000 * 60));
          if (item.orderStatus === 'CANCEL') {
            item.noRevoke = false;
          } else {
            item.noRevoke = Math.floor(nowTime - writeOffTime) >= 60 ? false : true; //发测试调整60
          }
          return item;
        });
      });
    },

    //获取列表数据
    queryDataList: function queryDataList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tuhu.showIndicator();
                _this2.dataList = [];
                _context.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.GET_TIKTOK_ORDER_DAY_RECORD + '?shopId=' + _this2.shopId + '&date=' + _this2.queryDate);

              case 4:
                res = _context.sent;

                tuhu.hideIndicator();
                if (res && res.code === '200') {
                  _this2.tabList['verifyOrderSum']['num'] = res['data'] && res['data']['verifyOrderSum'] || 0;
                  _this2.tabList['orderAmountSum']['num'] = res['data'] && res['data']['orderAmountSum'] || 0;
                  _this2.dataList = res && res.data && res.data.orders.length ? res.data.orders.map(function (item) {
                    item.date = item.createTime;
                    item.price = item.orderAmount;
                    item.title = item.orderTitle;
                    item.statusText = '';
                    if (item.orderStatus === 'ORDER_FINISH') {
                      item.statusText = '核销成功';
                    }
                    if (item.orderStatus === 'CANCEL') {
                      item.statusText = '已撤销核销';
                    }
                    return item;
                  }) : [];
                  if (_this2.dataList.length) _this2.handleRevokeShow();
                } else {
                  tuhu.toast(data.message || "网络错误");
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    //撤销核销接口
    sureRevoke: function sureRevoke() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _revokeInfo, providerOrderId, index, res;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.flag) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this3.flag = false;
                _revokeInfo = _this3.revokeInfo, providerOrderId = _revokeInfo.providerOrderId, index = _revokeInfo.index;
                _context2.next = 6;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.QUERY_TIKTOK_CANCEL, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ providerOrderId: providerOrderId })
                });

              case 6:
                res = _context2.sent;

                _this3.flag = true;
                if (res && res.code === '200') {
                  // this.dataList[index]['orderStatus']='CANCEL'
                  // this.dataList[index]['statusText']='已撤销核销'
                  _this3.queryDataList();
                  _this3.isShow = false;
                } else {
                  tuhu.toast(res.message || "网络错误");
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ "g6X3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_signature_pad__ = __webpack_require__("kfhq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_signature_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_signature_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sign__ = __webpack_require__("Bk4K");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 //这是使用的方法，当手机屏幕是竖屏的时候要旋转图片

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      canvasNode: "",
      signPic: "",
      flag: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.initalHandle();
      window.addEventListener("resize", _this.initalHandle, false);
    });
  },

  methods: {
    goBack: function goBack() {
      tuhu.navigateBack();
    },
    initalHandle: function initalHandle() {
      var _canvasBox = this.$refs.canvasRef;
      var _canvas = this.$refs.canvasMapRef;
      if (!_canvasBox || !_canvas) {
        console.warn("DOM节点初始化失败");
        return false;
      }

      _canvas.width = _canvasBox.clientWidth;
      _canvas.height = _canvasBox.clientHeight;
      var computedOpt = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        minWidth: 1, //因为有笔锋的效果的，鼠标压力不同显示粗细不同
        maxWidth: 1,
        penColor: "rgb(0, 0, 0)"
      });

      this.clearHandle();
      this.canvasNode = new __WEBPACK_IMPORTED_MODULE_5_signature_pad___default.a(_canvas, computedOpt); //这里设置笔的宽度和颜色的样式
    },
    clearHandle: function clearHandle() {
      var hasNode = this.canvasNode;
      if (hasNode) {
        hasNode.clear();
      }
    },
    confirmHandle: function confirmHandle() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var canvasNode, _boxWidth, _boxHeight, _signImg;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 重新初始化画布
                canvasNode = _this2.canvasNode;

                if (!canvasNode) {
                  _this2.initalHandle();
                }
                // 是否签字

                if (!canvasNode.isEmpty()) {
                  _context.next = 5;
                  break;
                }

                tuhu.toast("您还没有签名");
                return _context.abrupt("return", false);

              case 5:
                // 图像旋转二次处理
                _boxWidth = window.innerWidth;
                _boxHeight = window.innerHeight;
                _signImg = canvasNode.toDataURL("image/png", 0.6) || null; //不旋转就是手机横屏

                if (!(_boxWidth < _boxHeight)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_6__sign__["a" /* rotateBase64Img */])(_signImg, -90, function (imgUrlRes) {
                  //在这里修改逻辑，返回的是旋转后的database
                  _this2.imgBase64ToUrl(imgUrlRes);
                });

              case 11:
                _context.next = 14;
                break;

              case 13:
                _this2.imgBase64ToUrl(_signImg);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    imgBase64ToUrl: function imgBase64ToUrl(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.flag) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this3.flag = false;
                params = {
                  baseFile: data,
                  fileName: "签名.png"
                };

                tuhu.fetch("" + __WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.UploadBase64File, {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
                }).then(function (res) {
                  console.log('点击确认', res);
                  if (res.code === '200') {
                    _this3.signPic = res.data;
                    _this3.combineText();
                  } else {
                    _this3.flag = true;
                    tuhu.toast(res.message);
                  }
                }).catch(function (err) {
                  _this3.flag = true;
                  console.log('点击确认', err);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },

    // 需要正文
    combineText: function combineText() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_4__configs_config__["a" /* default */].apis.GetSignature + "?signature=" + _this4.signPic).then(function (res) {
                  _this4.flag = true;
                  if (res.code === '200') {
                    //向跳转的上一页传参
                    window.parent.postMessage(res.data);
                    console.log(res, 're3s', res.data);
                    tuhu.navigateBack();
                  } else {
                    tuhu.toast(res.message);
                  }
                }).catch(function (err) {
                  _this4.flag = true;
                  tuhu.toast(err.message);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },
  beforeUnmount: function beforeUnmount() {
    window.removeEventListener("resize", this.initalHandle, false);
  }
});

/***/ }),

/***/ "g7gQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_platen__ = __webpack_require__("8YRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ttButton__ = __webpack_require__("bPVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configs_config__ = __webpack_require__("65XL");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var carParams = {
  province: '沪',
  provinces: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣', '闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂', '琼', '青', '新', '藏', '港', '澳'],
  carNo: '',
  showAllProv: false,
  showNoBoard: false
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ttButton: __WEBPACK_IMPORTED_MODULE_6__components_ttButton__["a" /* default */],
    platen: __WEBPACK_IMPORTED_MODULE_5__components_platen__["a" /* default */]
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      safeCheckResultAdvise: '',
      lock: false,
      isOnlineSign: true, //客户签名是否选择在线签名
      isCheck: false, //全部通过
      uploadDetail: {},
      sId: '',
      vCode: ''
    }, carParams, {
      showPupup: false,
      imgType: '',
      orderType: '',
      showALL: false,
      signatureType: 1,
      signatureUrl: '',
      safeCheckContent: [{
        checkId: 1,
        checkName: '发动机检测',
        checkContent: '机油量、防冻液、空气格、水箱、火花塞等',
        pass: 0
      }, {
        checkId: 2,
        checkName: '变速器检测',
        checkContent: '变速箱油量；变速箱换挡平顺性；档位性能',
        pass: 0
      }, {
        checkId: 3,
        checkName: '转向系统检测',
        checkContent: '四轮定位、助力油、平衡杆球头及衬套、方向机及防尘套等',
        pass: 0
      }, {
        checkId: 4,
        checkName: '底盘检测',
        checkContent: '减震器及顶胶、方向机、拉杆球头等',
        pass: 0
      }, {
        checkId: 5,
        checkName: '汽车玻璃检测',
        checkContent: '划痕、破损、检查天窗等',
        pass: 0
      }, {
        checkId: 6,
        checkName: '汽车电子系统检测',
        checkContent: '仪表灯、灯光、喇叭、雨刷等',
        pass: 0
      }, {
        checkId: 7,
        checkName: '车内环境检测',
        checkContent: '备箱灯、遮阳板灯光、阅读灯、安全带等',
        pass: 0
      }, {
        checkId: 8,
        checkName: '轮胎检测',
        checkContent: '轮胎裂纹、钉子、轮盖等',
        pass: 0
      }, {
        checkId: 9,
        checkName: '蓄电池检测',
        checkContent: '电池线路老化检测、蓄电池电压检测',
        pass: 0
      }, {
        checkId: 10,
        checkName: '车辆综合安全检测',
        checkContent: '驾驶室及车身部分、发动机部分、底盘部分',
        pass: 0
      }],
      carWashList: {
        'NO_APPOINTMENT_SHOP_ORDER': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }],
        'SHOP_ORDER': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'beforeWorkPhoto',
          text: '作业前漆面照片',
          required: true,
          isShow: 'isBeforeWorkPhoto'
        }, {
          imgType: 'workingPhoto',
          text: '作业中照片',
          required: true,
          isShow: 'isWorkingPhoto'
        }, {
          imgType: 'afterWorkPhoto',
          text: '作业后漆面照片',
          required: true,
          isShow: 'isAfterWorkPhoto'
        }, {
          imgType: 'workOrderPhoto',
          text: '工单照片',
          required: true,
          isShow: 'isWorkOrderPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }],
        'LACQURE_SHOP_ORDER': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'beforeWorkPhoto',
          text: '作业前漆面照片',
          required: true,
          isShow: 'isBeforeWorkPhoto'
        }, {
          imgType: 'workingPhoto',
          text: '作业中照片',
          required: true,
          isShow: 'isWorkingPhoto'
        }, {
          imgType: 'afterWorkPhoto',
          text: '作业后漆面照片',
          required: true,
          isShow: 'isAfterWorkPhoto'
        }, {
          imgType: 'workOrderPhoto',
          text: '工单照片',
          required: true,
          isShow: 'isWorkOrderPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'puttyingPhoto',
          text: '刮腻子照片',
          required: true,
          isShow: 'puttyingPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }],
        'MAINTAIN_ORDER': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'vehicleOilPhoto',
          text: '使用的机油与车辆合影照片',
          required: true,
          isShow: 'isVehicleOilPhoto'
        }, {
          imgType: 'workingPhoto',
          text: '作业中照片',
          required: true,
          isShow: 'isWorkingPhoto'
        }, {
          imgType: 'workOrderPhoto',
          text: '工单照片',
          required: true,
          isShow: 'isWorkOrderPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }],

        'MICRO_REPAIR_ORDER': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'beforeWorkPhoto',
          text: '作业前漆面照片',
          required: true,
          isShow: 'isBeforeWorkPhoto'
        }, {
          imgType: 'workingPhoto',
          text: '作业中照片',
          required: true,
          isShow: 'isWorkingPhoto'
        }, {
          imgType: 'afterWorkPhoto',
          text: '作业后漆面照片',
          required: true,
          isShow: 'isAfterWorkPhoto'
        }, {
          imgType: 'workOrderPhoto',
          text: '工单照片',
          required: true,
          isShow: 'isWorkOrderPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'puttyingPhoto',
          text: '刮腻子照片',
          required: false,
          isShow: 'puttyingPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }],
        'RESERVE_SHOP': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'beforeWorkPhoto',
          text: '作业前漆面照片',
          required: true,
          isShow: 'isBeforeWorkPhoto'
        }, {
          imgType: 'workingPhoto',
          text: '作业中照片',
          required: true,
          isShow: 'isWorkingPhoto'
        }, {
          imgType: 'afterWorkPhoto',
          text: '作业后漆面照片',
          required: true,
          isShow: 'isAfterWorkPhoto'
        }, {
          imgType: 'workOrderPhoto',
          text: '工单照片',
          required: true,
          isShow: 'isWorkOrderPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }],
        'NO_RESERVE_SHOP_SERVICE': [{
          imgType: 'vehicleWorkingPhoto',
          text: '能清晰显露车牌及车店的作业中照片',
          required: true,
          isShow: 'isVehicleWorkingPhoto'
        }, {
          imgType: 'workOrderPhoto',
          text: '工单照片',
          required: true,
          isShow: 'isWorkOrderPhoto'
        }, {
          imgType: 'elseWorkPhoto',
          text: '其他图片',
          required: false,
          isShow: 'isElseWorkPhoto'
        }, {
          imgType: 'carLiftPhoto',
          text: '车辆在起升架上的照片',
          required: true,
          isShow: 'carLiftPhoto'
        }, {
          imgType: 'hoodOpenPhoto',
          text: '引擎盖打开的照片',
          required: true,
          isShow: 'hoodOpenPhoto'
        }, {
          imgType: 'vinPhoto',
          text: '车架号图片',
          required: true,
          isShow: 'isVinPhoto'
        }]
      },
      photoMap: {
        isVinPhoto: false, //车架号图片
        isVehicleWorkingPhoto: false, //车辆与门店合照
        isVehicleOilPhoto: false, //机油和车辆合照
        isBeforeWorkPhoto: false, //  作业前照片
        isAfterWorkPhoto: false, //  作业后照片
        isWorkingPhoto: false, // 作业中照片
        isWorkOrderPhoto: false, // 工单照片
        isElseWorkPhoto: false, //其他照片
        carLiftPhoto: false, //车辆在起升架上的照片
        hoodOpenPhoto: false, //引擎盖打开的照片
        puttyingPhoto: false, //刮腻子照片
        safeCheckReport: false // 是否需要安全检测报告
      },
      photoList: {
        vinPhoto: '', //车架号图片
        vehicleWorkingPhoto: '', // 显露车牌及车店一体的作业中照片
        vehicleOilPhoto: '', // 使用的机油与车辆合影照片
        beforeWorkPhoto: '', // 作业前照片
        afterWorkPhoto: '', // 作业后照片
        workingPhoto: '', // 作业中照片
        workOrderPhoto: '', // 工单照片
        elseWorkPhoto: '', // 其他照片
        carLiftPhoto: '', //车辆在起升架上的照片
        hoodOpenPhoto: '', //引擎盖打开的照片
        puttyingPhoto: '' //刮腻子照片
      }
    });
  },
  created: function created() {
    this.uploadDetail = this.options && this.options.uploadDetail ? this.options.uploadDetail : JSON.parse(tuhu.sessionStorage.getItem('upDetail') || null);
    console.log(this.uploadDetail);

    this.photoMap = JSON.parse(this.uploadDetail.photoMap);

    this.photoList = this.uploadDetail.photoList || this.photoList;

    this.safeCheckResultAdvise = this.uploadDetail.safeCheckResultAdvise || '';
    this.safeCheckContent = this.uploadDetail.safeCheckContent || this.safeCheckContent;
    // 全选状态获取
    var passedItems = this.safeCheckContent.filter(function (item) {
      return item.pass === 1;
    });
    if (passedItems.length === 10) this.isCheck = true;
    //签名
    var signature = this.uploadDetail.signature || '';
    this.signatureType = signature.signatureType || '';
    this.signatureUrl = signature.signatureUrl || '';

    var serviceGroupId = this.uploadDetail.serviceGroupId;
    var checkType = this.uploadDetail.checkType;
    //10项对应的分组ID=86标准安全检测，第3项的描述说明有：四轮定位,18项对应的分组ID=73快捷安全检测，第3项的描述说明没有：四轮定位
    if (serviceGroupId === 73 && checkType === 2) {
      var foundItem = this.safeCheckContent.find(function (item) {
        return item.checkId === 3;
      });
      if (foundItem) {
        foundItem.checkContent = '助力油、平衡杆球头及衬套、方向机及防尘套等';
      }
    }
    this.sId = tuhu.getParam('sId');
    this.vCode = tuhu.getParam('vCode');
    this.orderType = this.uploadDetail.orderType;
  },
  mounted: function mounted() {
    var _this = this;

    //获取在线签名返回url
    window.addEventListener('message', function (event) {
      if (event.data) {
        _this.$set(_this, 'signatureUrl', event.data);
      }
    });
  },

  computed: {
    filteredSafeCheckContent: function filteredSafeCheckContent() {
      return this.showALL ? this.safeCheckContent : this.safeCheckContent.slice(0, 3);
    },
    filteredCarWashList: function filteredCarWashList() {
      var _this2 = this;

      var photoList = this.carWashList[this.orderType].map(function (item) {
        if (item.imgType === 'vinPhoto' && _this2.photoMap['isVehicleWorkingPhoto']) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, {
            required: _this2.photoMap['isVinPhoto'] ? true : false,
            isShow: 'isVehicleWorkingPhoto'
          });
        }
        return item; // 其他项保持不变
      });

      return this.orderType && this.photoMap ? photoList.filter(function (item) {
        return _this2.photoMap[item.isShow];
      }) : [];
    }
  },
  methods: {
    handleCheckAll: function handleCheckAll() {
      this.isCheck = !this.isCheck;
      if (this.isCheck) {
        this.safeCheckContent.forEach(function (item) {
          item.pass = 1;
        });
      } else {
        this.safeCheckContent.forEach(function (item) {
          item.pass = 0;
        });
      }
    },
    handleCheck: function handleCheck(item) {
      item.pass === 1 ? item.pass = 0 : item.pass = 1;
      var passedItems = this.safeCheckContent.filter(function (item) {
        return item.pass === 1;
      });
      if (passedItems.length === 10) this.isCheck = true;else this.isCheck = false;
    },
    chooseProvince: function chooseProvince(item) {
      this.province = item;
      this.showAllProv = false;
      this.showNoBoard = true;
    },
    chooseCarNo: function chooseCarNo(val) {
      this.carNo = val;
    },
    delect: function delect() {
      this.carNo = this.carNo.slice(0, -1);
    },

    // 跳转在线签名
    toOnlineSign: function toOnlineSign() {
      tuhu.navigateTo({
        url: "/pages/orderDetail/onlineSign"
      });
    },
    upload: function upload(val) {
      if (val && val.code === '200') {
        this.photoList[val.index] = val.data;
      } else {
        tuhu.toast(val.message || '网络错误');
      }
    },
    uploadSignature: function uploadSignature(val) {
      if (val && val.code === '200') {
        this.signatureUrl = val.data;
      } else {
        tuhu.toast(val.message || '网络错误');
      }
    },
    sureToOff: function sureToOff() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, baseParams, params, data, info;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                res = _this3.ckeckImg();

                if (res) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                if (!_this3.lock) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:

                _this3.lock = true;

                tuhu.showIndicator();
                _context.prev = 7;

                //必传项
                baseParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this3.photoList, {
                  shopId: parseInt(_this3.sId),
                  code: _this3.vCode
                });
                params = _this3.photoMap.safeCheckReport ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseParams, {
                  //根据photoMap.safeCheckReport判断后边的值需不需要传
                  safeCheckContent: _this3.safeCheckContent,
                  safeCheckResultAdvise: _this3.safeCheckResultAdvise,
                  signature: {
                    signatureType: _this3.signatureType,
                    signatureUrl: _this3.signatureUrl
                  }
                }) : baseParams;
                _context.next = 12;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.UPDATE_SAFE_MESSAGE, {

                  method: 'post',

                  body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params)

                });

              case 12:
                data = _context.sent;


                if (data && data.code === '200') {

                  tuhu.hideIndicator();

                  _this3.lock = false;

                  tuhu.toast('修改成功');

                  info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data.data, {
                    Message: data.message
                  });


                  tuhu.sessionStorage.setItem('shopOrderDetail', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(info));

                  setTimeout(function () {

                    tuhu.redirectTo({

                      url: '/pages/orderDetail/index',

                      data: {

                        ListInfo: info

                      },

                      query: {

                        isEdit: 1

                      }

                    });
                  }, 300);
                } else {

                  tuhu.hideIndicator();

                  _this3.lock = false;

                  tuhu.toast(data.message || '网络错误');
                }

                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](7);

                tuhu.hideIndicator();

                _this3.lock = false;

                console.log(_context.t0);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[7, 16]]);
      }))();
    },
    ckeckImg: function ckeckImg() {
      if (!this.photoList.vinPhoto && this.photoMap.isVinPhoto) return tuhu.toast('请上传车架号图片');

      if (!this.photoList.vehicleWorkingPhoto && this.photoMap.isVehicleWorkingPhoto) return tuhu.toast('请上传显露车牌及车店一体的作业中照片');

      if (!this.photoList.vehicleOilPhoto && this.photoMap.isVehicleOilPhoto) return tuhu.toast('请上传使用的机油与车辆合影照片');

      if (!this.photoList.beforeWorkPhoto && this.photoMap.isBeforeWorkPhoto) return tuhu.toast('请上传作业前照片');

      if (!this.photoList.afterWorkPhoto && this.photoMap.isAfterWorkPhoto) return tuhu.toast('请上传作业后照片');

      if (!this.photoList.workingPhoto && this.photoMap.isWorkingPhoto) return tuhu.toast('请上传作业中照片');

      if (!this.photoList.workOrderPhoto && this.photoMap.isWorkOrderPhoto) return tuhu.toast('请上传工单照片');

      if (!this.photoList.carLiftPhoto && this.photoMap.carLiftPhoto) return tuhu.toast('请上传车辆在起升架上的照片');

      if (!this.photoList.hoodOpenPhoto && this.photoMap.hoodOpenPhoto) return tuhu.toast('请上传引擎盖打开的照片');

      if (!this.safeCheckResultAdvise && this.photoMap.safeCheckReport) return tuhu.toast('请输入安全检测结果建议');

      if (!this.signatureType && this.photoMap.safeCheckReport) return tuhu.toast('请选择签名方式');

      if (!this.signatureUrl && this.photoMap.safeCheckReport) return tuhu.toast('请上传签名');

      if (this.orderType == 'LACQURE_SHOP_ORDER' && this.photoMap.puttyingPhoto && !this.photoList.puttyingPhoto) return tuhu.toast('请上传刮腻子照片');
      return true;
    }
  }
});

/***/ }),

/***/ "gB3B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_6.09b8a81.png";

/***/ }),

/***/ "gKLg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car.42e2784.png";

/***/ }),

/***/ "gMpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectShopList_vue__ = __webpack_require__("8qPQ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e0c071_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectShopList_vue__ = __webpack_require__("1g47");
function injectStyle (ssrContext) {
  __webpack_require__("stXk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77e0c071"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectShopList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e0c071_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectShopList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gNyG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/delete_copy.8f38194.png";

/***/ }),

/***/ "gOjf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gSgL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gXbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("qAGI");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4f5946e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("mx0I");
function injectStyle (ssrContext) {
  __webpack_require__("ra/D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4f5946e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4f5946e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gdej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("X0T2");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c79334ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Xarx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c79334ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gq/Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gwO7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h1gB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h731":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dataList: {
      type: Array,
      default: []
    },
    tabList: {
      type: Object,
      default: {}
    },
    isDay: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    goPage: function goPage(row) {
      console.log(row, "nnnnn");
      this.$emit("goPage", row);
    }
  }
});

/***/ }),

/***/ "hMyl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hW8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hjNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





/**
 * author: lishufen
 * fixTime: 2017-3-13
 * desc:  调用app头部分享按钮
 * 调用方法: CommonShare3.doshare({
    shareUrl: '',     //分享地址
    shareImage: '',   //分享图片
    shareTitle: '',   //分享标题
    shareDescrip: '', //分享描述
    shareProject: '', //项目名称 2019-01-07 (默认为 wx)
  })
 */

var Share = function () {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Share, null, [{
    key: 'share',
    value: function share(params, opts) {
      var share = new Share(params, opts);
      share.doShare();
    }
  }]);

  function Share() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Share);

    this.params = params;

    this.opts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
      isClip: true
    }, opts);

    // this.params.shareUrl = this.params.shareUrl + '&' + tuhu.util.query2Str(this.params, '_twiceshare_')
    // console.log(888, this.params.shareUrl)
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Share, [{
    key: 'getUrl',
    value: function getUrl() {
      var url = decodeURIComponent(location.href);

      return url.indexOf('?') > -1 ? url + '&utm_source=1' : url + '?utm_source=1';
    }
  }, {
    key: 'shareAndroid',
    value: function shareAndroid() {
      var params = {};
      var data = this.params;

      params.Description = data.shareDescrip;
      params.Title = data.shareTitle;
      params.Picture = data.shareImage;
      params.Url = data.shareUrl;
      params.MiniProgramPath = data.wxAppPath || '';
      params.MiniProgramId = data.wxAppId || '';
      params.HdImageData = data.wxAppImg || '';

      tuhu.actionWithNative('share', params);
    }
  }, {
    key: 'shareIos',
    value: function shareIos() {
      var data = this.params;
      var params = {};
      var iosParam = [];
      var types = [1, 2, 4, 8, 16, 32];
      var param = {
        channel: 1,
        type: 0,
        url: data.shareUrl,
        content: data.shareDescrip,
        title: data.shareTitle,
        imageURL: data.shareImage,
        image: ''
      };

      types.forEach(function (type) {
        if (type === 1) {
          iosParam.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, param, {
            type: data.shareType || 0,
            MiniProgramPath: data.wxAppPath || '',
            MiniProgramID: data.wxAppId || '',
            HdImageData: data.wxAppImg || ''
          }));
        } else {
          iosParam.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, param, {
            channel: type
          }));
        }
      });

      params.descrip = data.shareDescrip;
      params.title = data.shareTitle;
      params.image = data.shareImage;
      params.url = data.shareUrl;
      params.share = iosParam;

      // window.webkit.messageHandlers.setShare.postMessage(params)
      tuhu.actionWithNative('share', params);
    }

    // 快应用分享设置

  }, {
    key: 'shareLightApp',
    value: function shareLightApp() {
      var _params = this.params,
          title = _params.shareTitle,
          imgUrl = _params.shareImage,
          desc = _params.shareDescrip,
          link = _params.shareUrl,
          project = _params.shareProject;

      var sharParams = {
        type: 'toShareWeb',
        project: project || 'wx',
        data: {
          title: title,
          imgUrl: imgUrl,
          desc: desc,
          link: link
        }
        // console.log('快应用分享参数 -> ', sharParams);
      };system.postMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sharParams));
      // system.onmessage = (data) => {}
    }
  }, {
    key: 'doShare',
    value: function doShare() {
      if (/img\d\.tuhu\.org/.test(this.params.shareImage)) {
        this.params.shareImage = this.params.shareImage.replace(/@.+/, '') + '@200h_99q.jpg';
      }

      if (tuhu.device.tuhuAndroid) {
        this.shareAndroid();
      } else if (tuhu.device.tuhuIos) {
        this.shareIos();
      }

      // 快应用分享
      if (navigator.userAgent.indexOf('com.tuhu.lightapp') >= 0) {
        this.shareLightApp();
      }
    }
  }]);

  return Share;
}();

/* harmony default export */ __webpack_exports__["a"] = (Share);

/***/ }),

/***/ "hpHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kefu-com"},[_c('div',{staticClass:"kefu-ask"},[_vm._v("咨询客服")]),_vm._v(" "),_c('span',[_vm._v("服务由小鲲车服提供")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hux5":
/***/ (function(module, exports) {

Vue.filter('toMoney', function (number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var decimalSep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  var thousandSep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ',';

  return parseFloat(number).toFixed(decimals) || '';
});

/***/ }),

/***/ "iemT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user__ = __webpack_require__("H/tq");








var _id = 0;

var _group = 0;

var toast = function () {
  var lock = false;
  var lastToastArgs = null;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log(lock, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(lastToastArgs) === __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(args));
    if (lock && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(lastToastArgs) === __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(args)) {
      return;
    }

    setTimeout(function () {
      lock = false;
    }, 1000);

    $.toast.apply($, args);

    lastToastArgs = args;
    lock = true;
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  query2Str: function query2Str(obj) {
    var pre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var strArr = [];

    for (var i in obj) {
      strArr.push('' + pre + i + '=' + encodeURIComponent(obj[i]));
    }
    /** 判断 ? & */
    return strArr.length > 0 ? '?' + strArr.join('&') : '';
  },

  uuid: __WEBPACK_IMPORTED_MODULE_6__user__["a" /* default */].uuid,
  setBlackBox: __WEBPACK_IMPORTED_MODULE_6__user__["a" /* default */].setBlackBox,
  getBlackBox: function getBlackBox() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__user__["a" /* default */].setBlackBox().catch(function (e) {
                throw e;
              });

            case 2:
              return _context.abrupt('return', _this.getCookie('_fmdata'));

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getCookie: function getCookie(key) {
    var reg = new RegExp(key + '=(.+?)(?:;|$)');
    var match = document.cookie.match(reg);

    return match && match[1] || '';
  },
  isIphoneX: function isIphoneX() {
    return (/iphone/i.test(navigator.userAgent) && screen.height === 812 && screen.width === 375
    );
  },
  lockFn: function lockFn() {
    var locked = false;

    return function (fn) {
      if (locked) {
        return;
      }

      locked = true;

      fn();

      setTimeout(function () {
        locked = false;
      }, 300);
    };
  },
  getPath: function getPath() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;

    var match = url.match(/\/pages\/[\w-]+\/[\w-]+/);

    return match ? match[0] : '/pages/home/index';
  },
  getFullPath: function getFullPath(url) {
    var match = location.pathname.match(/\/pages.+?(?:\?|&|$)/);

    return match ? match[0] : '/pages/home/index';
  },


  /** 获取所有参数 */
  getParams: function getParams() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search;

    var result = {};
    var decodeUrl = decodeURIComponent(url);
    var urlArr = decodeUrl.split('&');

    urlArr.forEach(function (item) {
      var match = item.match(/([\w-]+)=(.*?)(?:&|\?|$)/);
      if (match) {
        result[match[1]] = match[2];
      }
    });

    return result;
  },


  /** 获取指定参数 */
  getParam: function getParam(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
    var src = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : location.search;

    var reg = new RegExp('(?:^|\\?|&)' + key + '=(.*?)(?:&|\\?|$)');
    var match = decodeURIComponent(src).match(reg);
    if (match) {
      return type === 'number' ? match[1] - 0 : match[1];
    }

    return type === 'number' ? 0 : '';
  },
  getScrollId: function getScrollId() {
    var pre = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'goTop';

    return pre + '_' + _id++;
  },
  getGroup: function getGroup() {
    return 'group_' + _group++;
  },
  getDistance: function getDistance(lat1, lng1, lat2, lng2) {
    var radLat1 = lat1 * Math.PI / 180;
    var radLat2 = lat2 * Math.PI / 180;
    var a = radLat1 - radLat2;
    var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;

    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    return s.toFixed(2);
  },
  objectEqual: function objectEqual(obj1, obj2) {
    var _this2 = this;

    if (!obj1 || !obj2) {
      return false;
    }

    var arr1 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj1);
    var arr2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj2);
    if (arr1.length !== arr2.length) {
      return false;
    }

    return arr1.every(function (key) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj1[key]) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj2[key]) === 'object') {
        return _this2.objectEqual(obj1[key], obj2[key]);
      }

      if (obj1[key] === obj2[key]) {
        return true;
      }

      return false;
    });
  },


  toast: toast,
  // 获取跳转至 webview 的url
  getWebviewUrl: function getWebviewUrl(obj) {
    var url = null;
    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(tuhu.util.getParams(obj.url), obj.query); // 所有 query
    var navHidden = params.navHidden;
    delete params.navHidden;
    if (/^https?:\/\/.+/.test(obj.url)) {
      url = obj.url;
    } else {
      // 相对路径
      url = '' + (location.origin + location.pathname.replace(/\/pages.+$/, '')) + obj.url;
    }

    var paramStr = tuhu.util.param(params);
    url = '' + url.match(/^(.+?)(\?.+)?$/)[1] + ('?newwebview=1' + (paramStr ? '&' + paramStr : ''));
    if (navHidden) {
      url = url + '&navHidden=' + navHidden;
    }

    if (tuhu.device.tuhuIos) {
      url = 'tuhu:/webView?url=' + encodeURIComponent(url);
    } else if (tuhu.device.tuhuAndroid) {
      url = 'tuhu:/webView?url=' + encodeURIComponent(encodeURIComponent(url));
    }
    return url;
  },

  /** zepto static function */
  param: $.param,

  type: $.type,

  isEmptyObject: $.isEmptyObject,
  isLightApp: typeof system !== 'undefined',
  channel: function channel() {
    if (this.isLightApp) {
      return this.isMiApp() ? 'xiaomi' : 'huawei';
    } else {
      return 'wx';
    }
  },
  isMiApp: function isMiApp() {
    return this.getParam('_channel') === 'xiaomi';
  },
  getLightChannel: function getLightChannel() {
    var _channel = this.isLightApp ? tuhu.localStorage.getItem('_channel') : '';
    return _channel;
  },
  getLightChannel_system: function getLightChannel_system() {
    tuhu.localStorage.setItem('_channel', '');
    if (this.isLightApp) {
      system.postMessage('getOrderChannel');
      system.onmessage = function (data) {
        var dataJson = JSON.parse(data);
        tuhu.localStorage.setItem('_channel', dataJson && dataJson.getOrderChannel);
      };
    }
  },
  clearObj: function clearObj(obj) {
    for (var i in obj) {
      if (obj.hasOwnProperty(i) && obj[i] === undefined) {
        delete obj[i];
      }
    }
  },
  checkPhone: function checkPhone(phone) {
    return (/^1\d{10}$/.test(phone)
    );
  },
  trim: function trim(str) {
    if (typeof str === 'string') return str.replace(/\s/g, '');else return str;
  },


  // 防抖
  debounce: function debounce(func, delay) {
    var timer = void 0;
    return function () {
      var _this3 = this;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(_this3, args);
      }, delay);
    };
  }
});

/***/ }),

/***/ "ihhn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: tuhu.getParam('url')
    };
  },

  methods: {
    handleClose: function handleClose() {
      tuhu.navigateBack();
    }
  }
});

/***/ }),

/***/ "iuq6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jOFD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mfjc.36177dd.png";

/***/ }),

/***/ "jTC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(this.userRole === '老板' || this.userRole === '店长' )?_c('div',{staticClass:"top_bar"},[_c('i',{on:{"click":function($event){return _vm.handleClick1(_vm.tabList1[0])}}},[_vm._v("查看店长和员工的区别>")])]):_vm._e(),_vm._v(" "),(this.userRole === '老板' || this.userRole === '店长' )?_c('div',{staticClass:"user_type"},[_c('van-cell-group',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"账号类型","value":_vm.addUser_val1,"placeholder":"请选择","input-align":"right","is-link":""},on:{"click":function($event){_vm.addUser_Picker1 = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.addUser_Picker1),callback:function ($$v) {_vm.addUser_Picker1=$$v},expression:"addUser_Picker1"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"选择账号类型","columns":_vm.addUser_columns1},on:{"cancel":function($event){_vm.addUser_Picker1 = false},"confirm":_vm.addUser_onConfirm1}})],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","formatter":_vm.formatter1,"label":"员工姓名","maxlength":"4","placeholder":"请输入","is-link":""},model:{value:(_vm.addUser_val2),callback:function ($$v) {_vm.addUser_val2=$$v},expression:"addUser_val2"}})],1),_vm._v(" "),_c('van-cell-group',[_c('van-field',{attrs:{"input-align":"right","is-link":"","label":"手机号码","maxlength":"11","placeholder":"请输入"},model:{value:(_vm.addUser_val3),callback:function ($$v) {_vm.addUser_val3=$$v},expression:"addUser_val3"}})],1)],1):_vm._e(),_vm._v(" "),(this.userRole === '老板' || this.userRole === '店长' )?_c('div',[_c('van-button',{staticClass:"add_management_btn",attrs:{"size":"large","color":"rgb(25,137,250)","type":"info"},on:{"click":function($event){return _vm.handleClick2(_vm.tabList1[1])}}},[_vm._v("保存")])],1):_vm._e(),_vm._v(" "),(this.userRole === '员工')?_c('van-empty',{attrs:{"image":"error","description":"员工权限不足"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jl1Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_list_vue__ = __webpack_require__("z+E+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RecordList: __WEBPACK_IMPORTED_MODULE_3__components_list_vue__["a" /* default */] },
  data: function data() {
    return {
      dataList: [],
      tabList: {
        verifyOrderSum: {
          num: 0,
          text: "核销订单数",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/50fa1f29610e4cfaa9074e811fcd18e9.png'
        },
        orderAmountSum: {
          num: 0,
          text: "核销订单总收入",
          icon: 'https://res.xiaokunkeji.cn/image/2023/12/14/4360a3f7855d4483bcd3d25d3e4060e2.png'
        }
      },
      queryMonth: "", //查询月
      shopId: ''
    };
  },
  mounted: function mounted() {
    this.queryMonth = __WEBPACK_IMPORTED_MODULE_4_moment___default()(tuhu.getParam("date")).format("YYYY年MM月");
    this.shopId = tuhu.getParam("shopId") || JSON.parse(localStorage.getItem("_xk_user_key"))['shopId'];
    this.queryDataList();
  },

  methods: {
    goPage: function goPage(row) {
      tuhu.navigateTo({
        url: '/pages/dayRecord/index?date=' + row.countTime + '&shopId=' + this.shopId
      });
    },
    queryDataList: function queryDataList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var year, res, yearData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tuhu.showIndicator();
                year = __WEBPACK_IMPORTED_MODULE_4_moment___default()(tuhu.getParam("date")).format("YYYY");
                _context.next = 4;
                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.GET_TIKTOK_ORDER_YEAR_RECORD + '?shopId=' + _this.shopId + '&year=' + year);

              case 4:
                res = _context.sent;

                tuhu.hideIndicator();
                if (res && res.code === '200') {
                  yearData = res && res.data && res.data.monthList.length ? res.data.monthList.filter(function (item) {
                    if (item.month === tuhu.getParam("date")) return item;
                  }) : [];

                  _this.handleData(yearData[0]);
                } else {
                  tuhu.toast(res.message || "网络错误");
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    //获取列表数据
    handleData: function handleData(obj) {
      // const data = JSON.parse(localStorage.getItem('monthList'))
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
      for (var key in this.tabList) {
        this.tabList[key]['num'] = data[key] || 0;
      }
      console.log(data.dayOrders, "lllll");
      this.dataList = data && data.dayOrders.map(function (item) {
        item.count = item.verifyOrderSum;
        item.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.countTime).format("YYYY年MM月DD日");
        item.price = item.orderAmountSum;
        return item;
      });
    }
  }
});

/***/ }),

/***/ "k1KU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
    * author: lijingwen@tuhu.cn
    * date: 2017/12/6
    * desc: 领取优惠券的弹窗
   */
  data: function data() {
    return {
      showModal: true,
      couponsList: []
    };
  },

  props: {
    showmask: {
      type: Boolean,
      require: false,
      default: true
    },
    type: {
      type: String | Number
    },
    locationData: {
      type: Object
    },
    carInfo: {
      type: Object
    },
    couponsCallBack: {
      type: Function,
      require: false,
      default: function _default() {}
    },
    productId: {
      type: String,
      require: false
    },
    sort: {
      type: String | Number,
      require: false,
      default: 'xby'
    }
  },
  computed: {},
  watch: {
    showModal: {
      handler: function handler() {
        this.getCoupons().then(function (res) {});
      }
    }
  },
  created: function created() {
    this.getCoupons();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.getUserInfo();

              case 2:
                userInfo = _context.sent;

                if (!(_this.type + '' === '1')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', {
                  url: 'https://api.tuhu.cn/Action/SelectProductPromotionGetRules',
                  query: {
                    UserID: userInfo.userid,
                    pids: _this.productId,
                    type: 1
                  }
                });

              case 5:
                if (!(_this.type + '' === '2')) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', {
                  url: 'https://by.tuhu.cn/apinew/GetPromotionRulesByPackageType.html',
                  query: {
                    userId: userInfo.userid,
                    packagetype: _this.sort
                  }
                });

              case 7:
                if (!(_this.type + '' === '3')) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', {
                  url: 'https://api.tuhu.cn/Baoyang/GetBatteryPromotion',
                  postData: {
                    method: 'POST',
                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                      // UserID: data.userid,
                      pids: _this.pids,
                      type: 1,
                      city: _this.locationData.city,
                      district: _this.locationData.currentDistrict || _this.locationData.district,
                      province: _this.locationData.province,
                      vehicle: {
                        Nian: _this.carInfo.Nian,
                        PaiLiang: _this.carInfo.Pailiang,
                        Tid: _this.carInfo.TID || '',
                        VehicleId: _this.carInfo.ProductID,
                        Properties: _this.carInfo.PropertyList
                      }
                    }),
                    headers: {
                      'Content-Type': 'application/json',
                      'cache-control': 'no-cache'
                    }
                  }
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    receiveCoupon: function receiveCoupon(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userInfo, receiveData, receiveRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return tuhu.getUserInfo();

              case 2:
                userInfo = _context2.sent;
                receiveData = {};

                if (_this2.type + '' === '1') {
                  // 轮胎优惠券领取
                  // {"getRuleGuid":"c2df607e-c8ac-48dc-a678-2b8da1457afe","userId":"2c17639a-a05b-46ac-966b-123b15b644cb"}
                  receiveData = {
                    url: 'https://api.tuhu.cn/Action/CreateProductPromotion',
                    query: {
                      getRuleGuid: item.GetRuleGUID,
                      userId: userInfo.userid
                    }
                  };
                } else if (_this2.type + '' === '2') {
                  // 保养
                  // {"channel":"WXAPP","getRuleId":"3d29b26f-3ed6-42d7-bc5d-cbfd468b4ba3","userId":"2c17639a-a05b-46ac-966b-123b15b644cb"}
                  // {"Code": "1","Message": "领取成功"}
                  receiveData = {
                    url: 'https://by.tuhu.cn/apinew/CreatePromotionCode.html',
                    query: {
                      channel: 'WXAPP',
                      getRuleId: item.Id,
                      userId: userInfo.userid
                    }
                  };
                } else if (_this2.type + '' === '3') {
                  receiveData = {
                    url: 'https://api.tuhu.cn/action/CreateProductPromotion',
                    postData: {
                      method: 'POST',
                      body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                        GetRuleGUID: item.GetRuleGUID
                      }),
                      headers: {
                        'content-type': 'application/json'
                      }
                    }
                  };
                }

                // const receiveRes = await tuhu.fetch(receiveData.url, {}, {
                //   query: receiveData.query
                // })
                receiveRes = void 0;

                if (!(receiveData && receiveData.postData)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return tuhu.fetch(receiveData.url, receiveData.postData);

              case 9:
                receiveRes = _context2.sent;
                _context2.next = 15;
                break;

              case 12:
                _context2.next = 14;
                return tuhu.fetch(receiveData.url, {}, {
                  query: receiveData.query
                });

              case 14:
                receiveRes = _context2.sent;

              case 15:
                return _context2.abrupt('return', receiveRes);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleClick: function handleClick(item, index) {
      var _this3 = this;

      this.receiveCoupon(item).then(function (res) {
        _this3.couponsCallBack(res);
        tuhu.toast(res.Message);
        if (_this3.couponsList[index].IsGet !== undefined) {
          _this3.couponsList[index].IsGet = true;
        }
        if (_this3.couponsList[index].AlreadyHave !== undefined) {
          _this3.couponsList[index].AlreadyHave = true;
        }
        _this3.couponsList.slice(0, 0);
        // this.closeCoupons()
      });
    },
    closeCoupons: function closeCoupons() {
      this.showModal = false;
    },
    getCoupons: function getCoupons() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res, fetchData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                res = void 0;
                _context3.next = 3;
                return _this4.fetchData();

              case 3:
                fetchData = _context3.sent;

                if (!fetchData.postData) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 7;
                return tuhu.fetch(fetchData.url, fetchData.postData);

              case 7:
                res = _context3.sent;
                _context3.next = 13;
                break;

              case 10:
                _context3.next = 12;
                return tuhu.fetch(fetchData.url, {}, {
                  query: fetchData.query,
                  state: false
                });

              case 12:
                res = _context3.sent;

              case 13:

                if (_this4.type + '' === '1') {
                  // 轮胎车品
                  _this4.couponsList = res.Data.GetRules;
                } else if (_this4.type + '' === '2') {
                  // 保养 优惠券 小保养
                  _this4.couponsList = res.Data;
                } else if (_this4.type + '' === '3') {
                  _this4.couponsList = res.Code === 1 && res.Coupons; // 蓄电池新接口
                }
                return _context3.abrupt('return', res);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ "kGVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(!_vm.fromVerify)?[(_vm.success)?_c('div',{staticClass:"success-status"},[_c('img',{attrs:{"src":__webpack_require__("kfX6"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"verify_title"},[_vm._v("核销成功")])]):(!_vm.success)?_c('div',{staticClass:"success-status"},[_c('img',{attrs:{"src":__webpack_require__("dpq6"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"verify_title"},[_vm._v("核销失败")]),_vm._v(" "),_c('span',{staticClass:"Verify_message"},[_vm._v(_vm._s(this.Message))])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"detail_cont"},[_c('div',{staticClass:"order_car"},[(_vm.fromVerify)?_c('div',{staticClass:"title"},[_c('span',{staticClass:"order_title"},[_vm._v(" "+_vm._s(_vm.isEdit? _vm.todayListInfo.serviceProviderName:_vm.todayListInfo.secondClassName))]),_vm._v(" "),_c('span',{staticClass:"order_name"},[_vm._v("服务名称")])]):_vm._e(),_vm._v(" "),_c('van-cell-group',[(!_vm.fromVerify)?_c('van-cell',{attrs:{"title":"服务名称","value":this.todayListInfo.secondClassName||_vm.todayListInfo.serviceProviderName}}):_vm._e(),_vm._v(" "),_c('van-cell',{attrs:{"title":"消费码","value":this.todayListInfo.verificationCode}}),_vm._v(" "),(_vm.scsShow || !_vm.success  )?_c('van-cell',{attrs:{"title":"订单编号","value":this.todayListInfo.orderNo}}):_vm._e(),_vm._v(" "),(_vm.success)?[(!_vm.hidePrice)?_c('van-cell',{attrs:{"title":"订单收入"},on:{"click":function($event){_vm.hidePrice=true}},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('span',{staticStyle:{"color":"#006EEF"}},[_vm._v("点击查看")])]},proxy:true}],null,false,1158189228)}):_c('van-cell',{attrs:{"title":"订单收入","value":this.todayListInfo.orderPrice}})]:_vm._e(),_vm._v(" "),(_vm.scsShow || !_vm.success)?_c('van-cell',{attrs:{"title":"完成时间","value":this.todayListInfo.createdTime}}):_vm._e(),_vm._v(" "),(_vm.fromVerify && !_vm.isEdit)?_c('van-cell',{attrs:{"title":"手机号码","value":this.todayListInfo.userPhone}}):(_vm.isEdit)?_c('van-cell',{attrs:{"title":"手机号码","value":this.todayListInfo.mobile}}):_vm._e(),_vm._v(" "),(this.todayListInfo.userCar)?_c('van-cell',{attrs:{"title":"车牌号码","value":this.todayListInfo.userCar}}):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"verify-img"},[_c('div',{staticClass:"img-title bottom-line"},[_c('span',[_vm._v("核销图片")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#2875FF"},on:{"click":_vm.toVerifyUpload}},[_vm._v("修改")])]),_vm._v(" "),_c('div',{staticClass:"uploadImg-box"},_vm._l((_vm.imgList),function(item,index){return _c('div',{key:index,staticClass:"upload"},[_c('img',{staticClass:"uploadImg",attrs:{"src":item.val,"alt":""},on:{"click":function($event){return _vm.showImagePreview(item.val)}}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"tips"},[_c('span',[_vm._v("如有疑问")]),_vm._v(" "),_c('span',[_vm._v("请咨询客服  "),_c('i',{directives:[{name:"call",rawName:"v-call",value:('400-176-8848'),expression:"'400-176-8848'"}]},[_vm._v("400-176-8848")])])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kQ4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cityPicker_vue__ = __webpack_require__("96kh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68ce17e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cityPicker_vue__ = __webpack_require__("000B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cityPicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68ce17e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cityPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kXkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kY29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_vue__ = __webpack_require__("/DoW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e03a58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_vue__ = __webpack_require__("f93R");
function injectStyle (ssrContext) {
  __webpack_require__("Q0im")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57e03a58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e03a58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kcRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-dialog',{staticClass:"custormTips4",attrs:{"showConfirmButton":false},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('p',{staticClass:"title"},[_vm._v("重要打款公告")]),_vm._v(" "),_c('div',{staticClass:"t-content"},[_c('p',{staticClass:"name"},[_vm._v("尊敬的平台用户:")]),_vm._v(" "),_c('div',{staticClass:"text-content",on:{"scroll":_vm.handleScroll}},[_c('p',[_vm._v("\n          您好，为严格贯彻落实国务院第 810\n          号令及税务总局配套公告相关要求，依据实施细则规定，自即日起，通过平台结算，需完成人脸识别认证，操作链接如下，点击即可完成认证流程：\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#006EEF"},on:{"click":_vm.open}},[_vm._v("\n          https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73576c3cf6b396f8&redirect_uri=https%3A%2F%2Fconfirm.serviceshare.com%2Fpages%2FYoufuSupport.html%23%2Funified-login?appKey=wx73576c3cf6b396f8&response_type=code&scope=snsapi_base&state=1767496543936305#wechat_redirect\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          若在个人认证过程中遇到任何问题，随时联系我们，我们将提供协助完成认证。此次调整给您带来的不便，我们深表歉意，衷心感谢您的理解与支持\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"t-btns-box"},[_c('div',{staticClass:"t-btns",class:{ disabled: _vm.countdown > 0 },on:{"click":_vm.handleClose}},[_vm._v("\n        "+_vm._s(_vm.countdown > 0 ? ("我已阅读重要打款公告(" + _vm.countdown + "s)") : '我已阅读重要打款公告')+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kfX6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success.47d81f9.png";

/***/ }),

/***/ "kk5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lA/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lRwf":
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "lamQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kefu_vue__ = __webpack_require__("MjFd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd43d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kefu_vue__ = __webpack_require__("hpHG");
function injectStyle (ssrContext) {
  __webpack_require__("3wdF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bd43d3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kefu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd43d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kefu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lb4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('section',{staticClass:"month-record"},[_c('img',{staticClass:"bg",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/e41a13db2d4b41f181bff1e5aa73a44e.png","alt":"","srcset":""}}),_vm._v(" "),_c('section',{staticClass:"page-content"},[_c('RecordList',{attrs:{"dataList":_vm.dataList,"tabList":_vm.tabList},on:{"goPage":_vm.goPage},scopedSlots:_vm._u([{key:"top",fn:function(){return [_vm._v("\n          "+_vm._s(_vm.queryMonth)+"\n        ")]},proxy:true}])})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localStorage; });
/* unused harmony export sessionStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* eslint-disable */
var cookie = {
  // 读取cookie
  get: function get(key) {
    var cookieName = encodeURIComponent(key) + '=';
    var cookieStart = document.cookie.indexOf(cookieName);
    var cookieValue = '';
    if (cookieStart > -1) {
      var cookieEnd = document.cookie.indexOf(';', cookieStart);
      if (cookieEnd == -1) {
        cookieEnd = document.cookie.length;
      }
      cookieValue = decodeURIComponent(document.cookie.substring('' + cookieStart + cookieName.length, cookieEnd));
    }
    return cookieValue;
  },
  // 创建cookie
  set: function set(key, value, expires, path, domain, secure) {
    var cookieText = '';
    expires = expires * 1000 * 60 * 60 * 24;
    var expires_date = new Date(new Date().getTime() + expires);
    cookieText = '' + cookieText + encodeURIComponent(key) + '=' + encodeURIComponent(value);

    if (expires) {
      cookieText = cookieText + '; expires=' + expires_date.toGMTString();
    }
    if (path) {
      cookieText = cookieText + '; path=' + path;
    }
    if (domain) {
      cookieText = cookieText + '; domain=' + domain;
    }
    if (secure) {
      cookieText = cookieText + '; secure';
    }
    document.cookie = cookieText;
  },
  // 删除cookie
  clear: function clear(key) {
    cookie.set(key, '', -1);
  },
  // 检查cookie
  check: function check(key) {
    var value = cookie.get(key);
    if (value == '' || value == null) {
      return false;
    } else {
      return true;
    }
  }
};
var localStorage = {
  // 读取localStorage
  get: function get(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key));
    } catch (err) {
      return window.localStorage.getItem(key);
    }
  },
  // 创建localStorage
  set: function set(key, value) {
    window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
  },
  // 移除指定localStorage
  remove: function remove(key) {
    window.localStorage.removeItem(key);
  },
  // 清空所有localStorage
  clear: function clear() {
    window.localStorage.clear();
  }
};
var sessionStorage = {
  // 读取sessionStorage
  get: function get(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key));
    } catch (err) {
      return window.sessionStorage.getItem(key);
    }
  },
  // 创建sessionStorage
  set: function set(key, value) {
    window.sessionStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
  },
  // 移除指定sessionStorage
  remove: function remove(key) {
    window.sessionStorage.removeItem(key);
  },
  // 清空所有sessionStorage
  clear: function clear() {
    window.sessionStorage.clear();
  }
};



/***/ }),

/***/ "m/fZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("VBkv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ba3b90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("A5B4");
function injectStyle (ssrContext) {
  __webpack_require__("Df5F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ba3b90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mK3k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mKIo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mKeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var loadScriptPromises = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  load: function load(src) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'js';

    /** 防止二次加载 */
    if (loadScriptPromises[src]) {
      return loadScriptPromises[src];
    }

    /** try again */
    var count = 0;
    var load = function load(resolve, reject) {
      var script = null;
      if (type === 'js') {
        script = document.createElement('script');
        script.src = src;
      } else {
        script = document.createElement('link');
        script.rel = 'stylesheet';
        script.href = src;
      }

      script.onload = function (ev) {
        setTimeout(resolve);
      };
      script.onerror = function (ev) {
        $(script).remove();

        if (count > 0) {
          return reject(ev);
        }
        count++;

        load(resolve, reject);
      };
      if (type === 'js') {
        document.body.appendChild(script);
      } else {
        document.head.appendChild(script);
      }
    };

    loadScriptPromises[src] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      load(resolve, reject);
    });

    return loadScriptPromises[src];
  }
});

/***/ }),

/***/ "mnUN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow-right-grey.2bbef04.png";

/***/ }),

/***/ "mws0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mx0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"today_order"},[_c('span',[_vm._v(_vm._s(this.todayListData.total || '0')+"单")]),_vm._v(" "),_c('span',[_vm._v("今日订单")])]),_vm._v(" "),_c('van-cell-group',[_c('van-cell',{attrs:{"title":"今日订单列表","value":""}}),_vm._v(" "),_vm._l((_vm.todayListData.list),function(item,index){return _c('van-cell',{key:index,staticClass:"today_order_list",attrs:{"title":item.secondClassName,"label":item.createdTime,"center":""},on:{"click":function($event){return _vm.handleClick(_vm.tabList[0],index)}},scopedSlots:_vm._u([{key:"right-icon",fn:function(){return [_c('van-icon',{staticStyle:{"line-height":"inherit"},attrs:{"name":"arrow"}})]},proxy:true}],null,true)})})],2),_vm._v(" "),(this.todayListData.total > 6)?_c('van-pagination',{staticClass:"today_pagination",attrs:{"total-items":this.todayListData.total,"items-per-page":"6","force-ellipses":"","show-page-size":"3"},on:{"change":function($event){return _vm.changePage($event)}},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n/tq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nJfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showPlate: this.showP,
      cityList: [['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫'], ['川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣'], ['闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂'], ['琼', '青', '新', '藏', '港', '澳', '', '', '']],
      EnglishList: [['港', '澳', '学', '警', '领'], ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'], ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O'], ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'P'], ['Z', 'X', 'C', 'V', 'B', 'N', 'M', 'L', 'delete']],
      citySelected: ' ',
      myShowmask: this.showmask,
      cityVal: this.cityV,
      carVal: this.carV
    };
  },

  props: {
    showmask: {
      type: Boolean
    },
    showP: {
      type: Number,
      default: 3
    },
    returnHandler: {
      type: Function
    },
    cityV: {
      type: String
    },
    carV: {
      type: String
    }
  },
  mounted: function mounted() {
    // window.test = this
  },

  watch: {
    showPlate: function showPlate(val) {
      if (val === 1) {
        $(this.$el).find('.cityPlate').eq(0).show();
        $(this.$el).find('.EnglishPlate').hide();
      } else if (val === 2) {
        $(this.$el).find('.cityPlate').eq(0).hide();
        $(this.$el).find('.EnglishPlate').show();
      }
    }
  },
  methods: {
    hidePlate: function hidePlate(e) {
      this.showPlate = 3;
    },
    citychooseHandler: function citychooseHandler(item) {
      if ($(event.currentTarget).hasClass('delete')) {
        this.ondelete();
      }
      if (item === '' || item === 'delete') return;
      this.citySelected = item;
      this.onchange(item);
    },
    cityremove: function cityremove(item) {
      if (item === '') return;
      if (this.showPlate === 1) {
        this.showPlate = 3;
      }
      this.citySelected = ' ';
    },

    onchange: function onchange(val) {
      // debugger
      if (this.showPlate === 1) {
        this.cityVal = val;
      } else if (this.showPlate === 2) {
        if (this.carVal === '请填写车牌号') {
          this.carVal = val;
        } else if (this.carVal.length < 7) {
          this.carVal = this.carVal + val;
        }
      }
      this.returnHandler(this.cityVal, this.carVal);
    },
    ondelete: function ondelete() {
      if (this.showPlate === 2) {
        if (this.carVal === '请填写车牌号') return;
        if (this.carVal.length <= 1) {
          this.carVal = '请填写车牌号';
          this.returnHandler(this.cityVal, this.carVal);
          return;
        }
        this.carVal = this.carVal.substring(0, this.carVal.length - 1);
        this.returnHandler(this.cityVal, this.carVal);
      }
    }
  }
});

/***/ }),

/***/ "nLtl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nOtf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nYer":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(this.userRole === '老板' || this.userRole === '店长' || this.userRole === '员工' )?_c('div',[(_vm.shopServiceData.signStatus == 1 )?_c('div',{staticClass:"serve_open"},[_c('div',{staticClass:"shopserve_list"},[_c('div',[_c('span',[_vm._v("服务名称")]),_c('span',[_vm._v(_vm._s(_vm.shopServiceData.secondClassName))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('span',[_vm._v("结算价格")]),_c('span',[_vm._v("￥ "+_vm._s(_vm.shopServiceData.signPrice))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("合计销量")]),_c('span',[_vm._v(_vm._s(_vm.shopServiceData.salesNum))])])]),_vm._v(" "),_c('van-button',{staticClass:"closeserve_btn",attrs:{"type":"danger","size":"large","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.handleClick(_vm.tabList1[0])}}},[_vm._v("关闭服务")])],1):_c('div',{staticClass:"serve_close"},[_c('div',{staticClass:"shopserve_list"},[_c('div',[_c('span',[_vm._v("服务名称")]),_c('span',[_vm._v(_vm._s(_vm.shopServiceData.secondClassName))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',[_c('span',[_vm._v("结算价格")]),_c('span',[_vm._v("￥ "+_vm._s(_vm.shopServiceData.signPrice))])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("合计销量")]),_c('span',[_vm._v(_vm._s(_vm.shopServiceData.salesNum))])])]),_vm._v(" "),_c('van-button',{directives:[{name:"call",rawName:"v-call",value:({tel: (_vm.currentShopInfo.managerPhone ? _vm.currentShopInfo.managerPhone : '400-176-8848')}),expression:"{tel: (currentShopInfo.managerPhone ? currentShopInfo.managerPhone : '400-176-8848')}"}],staticClass:"closeserve_btn",attrs:{"type":"info","size":"large"}},[_vm._v("开启联系市场经理")])],1)]):(this.userRole === '' )?_c('van-empty',{attrs:{"image":"error","description":"网络错误"}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("服务状态")]),_c('span',{staticClass:"shopserve_list_open"},[_vm._v("已开启")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("服务状态")]),_c('span',[_vm._v("已关闭")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nhri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oaFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_citypicker_vue__ = __webpack_require__("zlD5");
/**
 * author: caominjie@tuhu.cn
 * date: 2017/11/21
 * desc: citypicker指令
 * eg: <div v-citypicker='{formatvalue: bbb}'>test</div>
 */


var bindVue = function bindVue(el, arg, isShow) {
  var $content = $('.page-current').eq(tuhu.getParam('_tab') || 0).children('._content');
  var replaceEl = $('<div></div>');
  $content.append(replaceEl);

  new Vue({
    el: replaceEl[0],
    render: function render(createElement) {
      return createElement(__WEBPACK_IMPORTED_MODULE_0__components_citypicker_vue__["a" /* default */], {
        props: {
          el: el,
          formatvalue: arg.value.formatvalue,
          cityPicker: arg.value.cityPicker || 3,
          cityValue: arg.value.cityValue || [],
          onclose: arg.value.onclose && arg.value.onclose
        }
      });
    }
  });
};

Vue.directive('citypicker', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function inserted(el, arg) {
    bindVue(el, arg);
  }
});

/***/ }),

/***/ "pG79":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pNIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return remitStatusColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shopStatus; });
/* unused harmony export year */
// 门店结款状态
var remitStatusColor = {
  "1": "rgba(128, 128, 255, 1)",
  "2": "rgba(217, 0, 27, 1)",
  "3": "rgba(129, 211, 248, 1)",
  "4": "rgba(250, 205, 145, 1)",
  "5": "rgba(196, 198, 77, 1)",
  "6": "rgba(170, 170, 170, 1)",
  "7": "rgba(255, 109, 109, 1)"
};

var shopStatus = {
  "1": "打款成功",
  "2": "打款失败",
  "3": "待打款",
  "4": "审核中",
  "5": "未出账",
  "6": "已冻结",
  "7": "待上传发票"
};

var year = [{
  value: 2020,
  text: "2020年"
}, {
  value: 2021,
  text: "2021年"
}, {
  value: 2022,
  text: "2022年"
}, {
  value: 2023,
  text: "2023年"
}, {
  value: 2024,
  text: "2024年"
}];

/***/ }),

/***/ "pgmo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chapter.cbe8c60.png";

/***/ }),

/***/ "pjao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editVerifyImg_vue__ = __webpack_require__("g7gQ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3555026c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editVerifyImg_vue__ = __webpack_require__("2g6j");
function injectStyle (ssrContext) {
  __webpack_require__("EmT4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3555026c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editVerifyImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3555026c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editVerifyImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "px3J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pzd1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon1.86fdb01.png";

/***/ }),

/***/ "q4t3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cityPicker_vue__ = __webpack_require__("kQ4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_image_add_png__ = __webpack_require__("eLXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_image_add_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgs_image_add_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commons_storage__ = __webpack_require__("lqPF");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var showParams = {
  shopBossPickerFlag: false, // 门店负责人
  showCityTypePicker: false,
  shopTypePickerFlag: false, // 门店类型
  showMainPickerFlag: false, // 门店主营类型
  showAreaPickerFlag: false // 营业面积
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { cityPicker: __WEBPACK_IMPORTED_MODULE_5__components_cityPicker_vue__["a" /* default */] },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    _shopBasicData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    _shopMerchantData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    _shopCompanyData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    _CertificatePhotoData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    _showTab: {
      type: Number,
      default: function _default() {
        return 0;
      }
    }
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      active: 0
    }, showParams, {
      shopBasicData: {},
      shopMerchantData: {},
      shopCompanyData: {},
      CertificatePhotoData: {},
      defaultCityValue: ['', '', ''],
      activeNames: ['1'],
      allServices: ['洗车', '装潢', '保养', '救援', '年检', '保险', '油漆', '轮胎', '安全检测', '四轮定位', '动平衡', '理赔'],
      businessItemsSelected: [], // 营业项目
      restArea: 1, // 有休息区
      businessLicense: 1, // 有营业执照
      washCount1: 0, // 洗车工位
      beautyCount1: 0, // 美容工位
      repairCount1: 0, // 维护工位
      copyCount1: 0, // 烤漆工位
      addIcon: __WEBPACK_IMPORTED_MODULE_6__imgs_image_add_png___default.a,
      title: '',
      tabList1: [{
        name: '员工权限',
        url: '/pages/changeShopInfo/index'
      }],
      startImgNum: '',
      endImgNum: '',
      tabIndex: 0,
      businessLicenseFlag: true,
      map: null
    });
  },

  watch: {
    _shopBasicData: function _shopBasicData(val) {
      val.city = val.provinceName + '-' + val.cityName + '-' + val.districtName;
      this.shopBasicData = val;
    },
    _shopMerchantData: function _shopMerchantData(val) {
      this.businessItemsSelected = val.businessItems.split(','); // 已选项目
      // console.log('this.businessItemsSelected', val.businessItems.split(',').splice(1), this.businessItemsSelected)
      this.restArea = val.haveRestArea || 0;
      // 初始赋值 undefined
      this.washCount1 = val.washCount;
      this.beautyCount1 = val.beautyCount;
      this.repairCount1 = val.repairCount;
      this.copyCount1 = val.copyCount;
      var arr = val.stationCondition.split(';');
      var obj = {};
      arr.forEach(function (item) {
        if (item.indexOf('洗车') > -1) {
          obj['washCount'] = item.split('_')[1] || 0;
        } else if (item.indexOf('美容') > -1) {
          obj['beautyCount'] = item.split('_')[1] || 0;
        } else if (item.indexOf('维护') > -1) {
          obj['repairCount'] = item.split('_')[1] || 0;
        } else if (item.indexOf('烤漆') > -1) {
          obj['copyCount'] = item.split('_')[1] || 0;
        } else {}
      });
      this.shopMerchantData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(val, obj);
      // console.log(this.shopMerchantData, '格式化后的店铺信息')
    },
    _shopCompanyData: function _shopCompanyData(val) {
      this.businessLicense = val.businessLicense || 0;
      this.shopCompanyData = val;
      // val.businessLicense === 0 ? this.businessLicenseFlag = false : this.businessLicenseFlag = true
    },
    _CertificatePhotoData: function _CertificatePhotoData(val) {
      this.CertificatePhotoData = val;
      this.startImgNum = this.CertificatePhotoData.length;
      this.endImgNum = this.CertificatePhotoData.length;
      // console.log('CertificatePhotoData', this.CertificatePhotoData[4].imgUrl === null)
      // console.log(this.CertificatePhotoData, '格式化后的店铺信息')
    },
    _showTab: function _showTab(val) {
      this.tabIndex = val;
      this.active = val;
    }
  },
  created: function created() {
    this.active = this.tabIndex;
    this.ShowTab();
  },

  computed: {
    shopId: function shopId() {
      var shopInfo = tuhu.store.state.currentShopInfo;
      return shopInfo ? shopInfo.shopId : tuhu.getParam('shopId');
    }
  },
  methods: {
    cityConfirm: function cityConfirm(val, i) {
      var res = this.$refs.cPicker.cityData(i);
      console.log(res, '2222222222222222');
      this.$set(this.shopBasicData, 'city', val.join().replace(/,/g, '-'));
      this.$set(this.shopBasicData, 'cityId', res.cityId);
      this.$set(this.shopBasicData, 'cityName', val[1]);
      this.$set(this.shopBasicData, 'provinceId', res.provinceId);
      this.$set(this.shopBasicData, 'provinceName', val[0]);
      this.$set(this.shopBasicData, 'districtId', res.districtId);
      this.$set(this.shopBasicData, 'districtName', val[2]);
      this.showCityTypePicker = false;
    },
    initMap: function initMap(data) {
      var _this = this;

      this.map = null;
      this.shopMapData = data;
      this.$nextTick(function () {
        document.getElementById('shop-title').innerText = data.name;
        document.getElementById('shop-subtitle').innerText = data.address;
        _this.map = new AMap.Map('shop-map', {
          zoom: 11,
          viewMode: '2D',
          center: [data.lng, data.lat],
          resizeEnable: true
        });
        // var icon = new AMap.Icon({
        //   image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        //   size: new AMap.Size(25, 34), // 图标尺寸
        //   imageSize: new AMap.Size(25, 34) // 图片实际尺寸
        // });
        // var marker = new AMap.Marker({
        //   content: content,
        //   position: new AMap.LngLat(data.lng, data.lat)
        //   // 将 html 传给 content
        //   // icon: icon
        //   // content: markerContent,
        // });
        // this.map.add(marker);
      });
    },
    washCountInput: function washCountInput(val) {
      this.washCount1 = val;
    },
    beautyCountInput: function beautyCountInput(val) {
      this.beautyCount1 = val;
    },
    repairCountInput: function repairCountInput(val) {
      this.repairCount1 = val;
    },
    copyCountInput: function copyCountInput(val) {
      this.copyCount1 = val;
    },
    TabsIndex: function TabsIndex() {
      this.$emit('changeTabInfo', this.active);
      // console.log('changeTabInfo', this.active)
    },
    ShowTab: function ShowTab() {
      if (__WEBPACK_IMPORTED_MODULE_8__commons_storage__["a" /* localStorage */].get('shopinfo_showtab')) {
        this.active = __WEBPACK_IMPORTED_MODULE_8__commons_storage__["a" /* localStorage */].get('shopinfo_showtab');
        __WEBPACK_IMPORTED_MODULE_8__commons_storage__["a" /* localStorage */].remove('shopinfo_showtab');
      }
    },
    upload2: function upload2(val) {
      if (val && val.code === '200') {
        var index = val.index,
            data = val.data;

        var item = this.CertificatePhotoData[index];
        item.imgUrl = data || '';
        this.startImgNum = this.CertificatePhotoData.length;
        console.log(index, 'index');
        this.$set(this.CertificatePhotoData, index, item);
        if (item.name === '其他形象图' && index + 1 === this.CertificatePhotoData.length) {
          this.CertificatePhotoData.push({
            urlType: 'other',
            imgUrl: '',
            name: '其他形象图'
          });
          console.log('yesyes');
        } else {
          console.log('no');
        }
        this.endImgNum = this.CertificatePhotoData.length;
        console.log(this.endImgNum, 'end');
      } else {
        tuhu.toast(val.message || '网络错误');
      }
    },
    onShopBossConfirm: function onShopBossConfirm(value) {
      this.$set(this.shopBasicData, 'shopPrincipalType', value === '店长' ? 2 : value === '老板' ? 1 : 0);
      this.shopBossPickerFlag = false;
    },

    // '加盟连锁店', '品牌自营连锁店', '私营门店'
    onShopTypeConfirm: function onShopTypeConfirm(value) {
      this.$set(this.shopMerchantData, 'shopType', value);
      this.shopTypePickerFlag = false;
    },

    // 主营业务 ['洗车', '美容装潢', '维修保养', '综合服务', '轮胎']
    onShowMainConfirm: function onShowMainConfirm(value) {
      this.$set(this.shopMerchantData, 'mainService', value);
      this.showMainPickerFlag = false;
    },

    // 营业面积
    onShowAreaConfirm: function onShowAreaConfirm(value) {
      this.$set(this.shopMerchantData, 'merchantArea', value);
      this.showAreaPickerFlag = false;
    },

    // 保存门店基本信息
    saveShopBaseInfo: function saveShopBaseInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _shopBasicData2, cityId, cityName, districtId, districtName, provinceId, provinceName, shopAddress, shopLatitude, shopLongitude, shopName, shopPhone, shopPrincipal, shopPrincipalPhone, shopPrincipalType, params, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _shopBasicData2 = _this2.shopBasicData, cityId = _shopBasicData2.cityId, cityName = _shopBasicData2.cityName, districtId = _shopBasicData2.districtId, districtName = _shopBasicData2.districtName, provinceId = _shopBasicData2.provinceId, provinceName = _shopBasicData2.provinceName, shopAddress = _shopBasicData2.shopAddress, shopLatitude = _shopBasicData2.shopLatitude, shopLongitude = _shopBasicData2.shopLongitude, shopName = _shopBasicData2.shopName, shopPhone = _shopBasicData2.shopPhone, shopPrincipal = _shopBasicData2.shopPrincipal, shopPrincipalPhone = _shopBasicData2.shopPrincipalPhone, shopPrincipalType = _shopBasicData2.shopPrincipalType;
                _context.prev = 1;
                params = {
                  cityId: cityId,
                  cityName: cityName,
                  districtId: districtId,
                  districtName: districtName,
                  provinceId: provinceId,
                  provinceName: provinceName,
                  shopAddress: shopAddress,
                  shopLatitude: 0,
                  shopLongitude: 0,
                  shopName: shopName,
                  shopPhone: shopPhone,
                  shopPrincipal: shopPrincipal,
                  shopPrincipalPhone: shopPrincipalPhone,
                  shopPrincipalType: shopPrincipalType
                };
                _context.next = 5;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.CHANGE_SHOP_DETAIL, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    merchantShopDetailInfo: params,
                    shopId: _this2.shopId
                  })
                });

              case 5:
                data = _context.sent;

                if (data && data.code === '200') {
                  tuhu.toast('保存成功');
                  // location.reload()
                  _this2.$parent.ShowTab();
                  _this2.$parent.getShopInfo();
                  _this2.$parent.getShopBasicInfo();
                } else {
                  tuhu.toast(data.message || '网络错误');
                }
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                tuhu.toast(_context.t0.message || '网络错误');

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 9]]);
      }))();
    },

    // 保存店铺信息
    saveShopMerInfo: function saveShopMerInfo() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var businessItemsSelected, _shopMerchantData2, mainService, merchantArea, shopBank, shopType, stationCondition, businessItems, haveRestArea, shopStoreInfo, params, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                businessItemsSelected = _this3.businessItemsSelected;
                _shopMerchantData2 = _this3.shopMerchantData, mainService = _shopMerchantData2.mainService, merchantArea = _shopMerchantData2.merchantArea, shopBank = _shopMerchantData2.shopBank, shopType = _shopMerchantData2.shopType;
                stationCondition = '\u6D17\u8F66_' + _this3.washCount1 + ';\u7F8E\u5BB9_' + _this3.beautyCount1 + ';\u7EF4\u62A4_' + _this3.repairCount1 + ';\u70E4\u6F06_' + _this3.copyCount1;
                // const businessItems = businessItemsSelected.join(',')
                // 所有和选择的项目
                // let businessItems = businessItemsSelected.slice(1).join(',')

                businessItems = businessItemsSelected.join(',');
                // console.log('11qqq1', businessItemsSelected.join(',')) // 发送的数据
                // 有无休息区

                haveRestArea = parseInt(_this3.restArea);
                shopStoreInfo = {
                  businessItems: businessItems,
                  haveRestArea: haveRestArea,
                  mainService: mainService,
                  merchantArea: merchantArea,
                  shopBank: shopBank,
                  shopType: shopType,
                  stationCondition: stationCondition
                };
                params = {
                  shopId: _this3.shopId,
                  shopStoreInfo: shopStoreInfo
                };
                _context2.next = 10;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.CHANGE_SHOP_STOREINFO, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params)
                });

              case 10:
                data = _context2.sent;

                if (data && data.code === '200') {
                  tuhu.toast('保存成功');
                  // location.reload()
                  _this3.$parent.ShowTab();
                  _this3.$parent.getMerchantInfo();
                } else {
                  tuhu.toast(data.message || '网络错误');
                }
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);

                tuhu.toast(_context2.t0.message || '网络错误');

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 14]]);
      }))();
    },

    // 保存企业信息
    saveCompanyInfo: function saveCompanyInfo() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _shopCompanyData2, enterprisePrincipal, enterprisePrincipalPhone, staffNum, shopCreditCode, businessEntity, businessLicense, params, reg, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _shopCompanyData2 = _this4.shopCompanyData, enterprisePrincipal = _shopCompanyData2.enterprisePrincipal, enterprisePrincipalPhone = _shopCompanyData2.enterprisePrincipalPhone, staffNum = _shopCompanyData2.staffNum, shopCreditCode = _shopCompanyData2.shopCreditCode, businessEntity = _shopCompanyData2.businessEntity;
                businessLicense = _this4.businessLicense;
                // const enterprisePrincipal = this.businessLicenseFlag ? this.shopCompanyData.enterprisePrincipal : ''
                // const enterprisePrincipalPhone = this.businessLicenseFlag ? this.shopCompanyData.enterprisePrincipalPhone : ''

                params = {
                  businessLicense: businessLicense,
                  enterprisePrincipal: enterprisePrincipal,
                  enterprisePrincipalPhone: enterprisePrincipalPhone,
                  staffNum: staffNum,
                  shopCreditCode: shopCreditCode,
                  businessEntity: businessEntity
                };

                if (!(businessLicense == 1)) {
                  _context3.next = 8;
                  break;
                }

                reg = /^[A-Za-z0-9]{18,18}$/;

                if (reg.test(_this4.shopCompanyData.shopCreditCode)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt('return', tuhu.toast('请输入正确的企业信用代码'));

              case 8:
                _context3.next = 10;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.CHANGE_SHOP_COMPANYINFO, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopCompanyInfo: params,
                    shopId: _this4.shopId
                  })
                });

              case 10:
                data = _context3.sent;

                if (data && data.code === '200') {
                  tuhu.toast('保存成功');
                  _this4.$emit('hide');
                  // location.reload()
                  _this4.$parent.ShowTab();
                  _this4.$parent.getCompanyInfo();
                } else {
                  tuhu.toast(data.message || '网络错误');
                }
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](0);

                tuhu.toast(_context3.t0.message || '网络错误');

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 14]]);
      }))();
    },

    // 保存店照证照
    saveShopImgs: function saveShopImgs() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var list, urlInfoList, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                list = _this5.CertificatePhotoData;
                urlInfoList = [];

                list.forEach(function (item) {
                  if (item.imgUrl) {
                    urlInfoList.push({
                      imgUrl: item.imgUrl,
                      urlType: item.urlType
                    });
                  }
                });
                _context4.next = 6;
                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.CHANGE_SHOP_URLINFO, {
                  method: 'post',
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                    shopId: _this5.shopId,
                    urlInfoList: urlInfoList
                  })
                });

              case 6:
                data = _context4.sent;

                if (data && data.code === '200') {
                  tuhu.toast('保存成功');
                  // location.reload()
                  _this5.$parent.ShowTab();
                  _this5.$parent.getCertificatePhoto();
                } else {
                  tuhu.toast(data.message || '网络错误');
                }
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

                tuhu.toast(_context4.t0.message || '网络错误');

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 10]]);
      }))();
    },
    handleSave: function handleSave() {
      console.log('this.active', this.active);
      __WEBPACK_IMPORTED_MODULE_8__commons_storage__["a" /* localStorage */].set('shopinfo_showtab', this.active);
      switch (this.active) {
        case 0:
          {
            this.$emit('hide');
            this.saveShopBaseInfo();
            break;
          }
        case 1:
          {
            this.$emit('hide');
            // console.log('ac', this.active)
            this.saveShopMerInfo();
            break;
          }
        case 2:
          {
            this.saveCompanyInfo();
            break;
          }
        case 3:
          {
            this.$emit('hide');
            this.saveShopImgs();
            break;
          }
      }
    }
  }
});

/***/ }),

/***/ "q9iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs_config__ = __webpack_require__("65XL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});

/***/ }),

/***/ "qAGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            shopId: '',
            currentPage: 1,
            todayListData: {},
            tabList: [{
                name: '今日订单列表详情',
                url: '/pages/orderDetail/index'
            }],
            dataCode: null
        };
    },
    created: function created() {
        this.getTodayList();
    },

    methods: {
        getTodayList: function getTodayList() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                if (roleData && roleData.code === '200') {
                                    _this.shopId = roleData.data.shopId;
                                } else {
                                    tuhu.toast(roleData.message || '获取权限信息失败');
                                }
                                // 今日订单列表
                                _context.next = 6;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_TODAYORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        'pageNum': 1,
                                        'pageSize': 6,
                                        'shopId': _this.shopId
                                    })
                                });

                            case 6:
                                data = _context.sent;

                                if (data && data.code === '200') {
                                    _this.todayListData = data.data;
                                    _this.dataCode = 200;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 分页事件
        changePage: function changePage(index) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var pageNum, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                pageNum = index;
                                _context2.next = 3;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_TODAYORDER_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        pageNum: pageNum,
                                        pageSize: 6,
                                        shopId: _this2.shopId
                                    })
                                });

                            case 3:
                                data = _context2.sent;

                                if (data && data.code === '200') {
                                    _this2.todayListData = data.data;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleClick: function handleClick(item, index) {
            tuhu.sessionStorage.setItem('shopOrderDetail', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.todayListData.list[index]));
            var i = index;
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ListInfo: this.todayListData.list[i] || {}
                },
                query: {
                    scsShow: 1
                }
            });
        }
    }
});

/***/ }),

/***/ "qb/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * author: 582196894@qq.com
 * desc: 兼容模式storage
 */

var tuhuSessionStorage = {};

var tuhuLocalStorage = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  /** 兼容无痕模式下sessionStorage */
  sessionStorage: {
    setItem: function setItem(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {
        tuhuSessionStorage[key] = value;
      }
    },
    getItem: function getItem(key) {
      try {
        var storageVal = sessionStorage.getItem(key) || tuhuSessionStorage[key];
        return storageVal === undefined ? null : storageVal;
      } catch (e) {
        return tuhuSessionStorage[key];
      }
    },
    removeItem: function removeItem(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (e) {
        delete tuhuSessionStorage[key];
      }
    },
    clear: function clear() {
      try {
        sessionStorage.clear();
      } catch (e) {
        tuhuSessionStorage = {};
      }
    }
  },

  /** 兼容无痕模式下localStorage */
  localStorage: {
    setItem: function setItem(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        tuhuLocalStorage[key] = value;
      }
    },
    getItem: function getItem(key) {
      try {
        var localStorageVal = localStorage.getItem(key) || tuhuLocalStorage[key];
        return localStorageVal === undefined ? null : localStorageVal;
      } catch (e) {
        return tuhuLocalStorage[key];
      }
    },
    removeItem: function removeItem(key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        delete tuhuLocalStorage[key];
      }
    },
    clear: function clear() {
      try {
        localStorage.clear();
      } catch (e) {
        tuhuLocalStorage = {};
      }
    }
  }
});

/***/ }),

/***/ "qm4d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/left.398aa46.png";

/***/ }),

/***/ "qpP9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ttButton__ = __webpack_require__("bPVk");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ttButton: __WEBPACK_IMPORTED_MODULE_4__components_ttButton__["a" /* default */]
    },
    data: function data() {
        return {
            shopId: '',
            settlementId: '',
            invoiceImg: '',
            orderInfo: {}
        };
    },
    created: function created() {
        this.init();
    },

    methods: {
        init: function init() {

            this.shopId = tuhu.getParam('sId');

            this.settlementId = tuhu.getParam('seId');

            this.getInfo();
        },
        getInfo: function getInfo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                tuhu.showIndicator();

                                _context.prev = 1;
                                _context.next = 4;
                                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SETTLEMENT_ORDER_INFO + '?shopId=' + _this.shopId + '&settlementId=' + _this.settlementId);

                            case 4:
                                data = _context.sent;


                                if (data && data.code === '200') {

                                    tuhu.hideIndicator();

                                    _this.orderInfo = data.data;
                                } else {

                                    tuhu.hideIndicator();

                                    console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SETTLEMENT_ORDER_INFO, data);

                                    tuhu.toast(data.message || '网络错误');
                                }

                                _context.next = 12;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](1);


                                tuhu.hideIndicator();

                                console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SETTLEMENT_ORDER_INFO, _context.t0);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[1, 8]]);
            }))();
        },
        upload: function upload(val) {

            if (val && val.code === '200' && val.data) {

                this.invoiceImg = val.data;
            } else {

                tuhu.toast(val.message || '网络错误');
            }
        },
        submit: function submit() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!_this2.invoiceImg && _this2.orderInfo.billFlag)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return', tuhu.toast('请上传发票图片'));

                            case 2:

                                tuhu.showIndicator();

                                _context2.prev = 3;
                                _context2.next = 6;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SETTLEMENT_ORDER_SUBMIT, {

                                    method: 'post',

                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({

                                        shopId: _this2.shopId,

                                        bankAccount: _this2.orderInfo.bankAccountName,

                                        settlementPrice: _this2.orderInfo.settlementPrice,

                                        shopSettlementBill: _this2.orderInfo.shopSettlementBill,

                                        settlementId: _this2.orderInfo.id,

                                        billImage: _this2.invoiceImg

                                    })

                                });

                            case 6:
                                data = _context2.sent;


                                if (data && data.code === '200') {

                                    tuhu.hideIndicator();

                                    tuhu.toast(data.message || '提交成功');

                                    setTimeout(function () {

                                        tuhu.navigateBack();
                                    }, 1000);
                                } else {

                                    tuhu.hideIndicator();

                                    console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SETTLEMENT_ORDER_SUBMIT, data);

                                    tuhu.toast(data.message || '网络错误');
                                }

                                _context2.next = 14;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](3);


                                tuhu.hideIndicator();

                                console.log('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SETTLEMENT_ORDER_SUBMIT, _context2.t0);

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[3, 10]]);
            }))();
        }
    }
});

/***/ }),

/***/ "rBCm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phone-cc.46016ff.png";

/***/ }),

/***/ "rHuL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/v4.890822a.png";

/***/ }),

/***/ "ra/D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s2wQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mwtemplate_vue__ = __webpack_require__("NLbh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae0cac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mwtemplate_vue__ = __webpack_require__("SdEA");
function injectStyle (ssrContext) {
  __webpack_require__("h1gB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mwtemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae0cac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mwtemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s5X+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sEZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imageCompress__ = __webpack_require__("N6PM");




// import config from '../configs/config'


var Util = function () {
  function Util(context, props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Util);

    this.html = "";
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Util, [{
    key: "limitArea",
    value: function limitArea() {
      var data = this.getData("MAIN_DATA");

      if (data) {
        if (data.LimitArea && data.LimitArea.length) {
          var str = "";
          data.LimitArea.forEach(function (item, i) {
            str += item + " ";
          });

          return str;
        } else {
          return null;
        }
      }
    }

    // 防抖

  }, {
    key: "debounce",
    value: function debounce(func, delay) {
      var timer = void 0;
      return function () {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          func.apply(_this, args);
        }, delay);
      };
    }

    // 验证手机号

  }, {
    key: "isPhone",
    value: function isPhone() {
      var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (/^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(phone)) {
        return true;
      } else {
        return false;
      }
    }

    // options: 压缩配置，同 imageCompress（quality/mimeType；默认保持原尺寸仅重编码）

  }, {
    key: "getFile",
    value: function getFile(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var opts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        quality: 0.8,
        mimeType: 'image/jpeg'
      }, options);

      var base64ImgtoFile = function base64ImgtoFile(dataurl) {
        var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';

        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var suffix = mime.split('/')[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename + "." + suffix, {
          type: mime
        });
      };
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var image = new Image();
        image.crossOrigin = 'Anonymous';
        image.src = url;

        image.onload = function () {
          // 保持原尺寸，仅重新编码控制体积（修复原先非法 MIME 导致回退 PNG 变大的 bug）
          var canvas = Object(__WEBPACK_IMPORTED_MODULE_4__imageCompress__["b" /* drawCompressedCanvas */])(image, opts);
          var base64 = canvas.toDataURL(opts.mimeType, opts.quality);
          var file = base64ImgtoFile(base64);
          resolve(file); // 加载完成后解析结果
        };

        image.onerror = function (error) {
          reject(null);
        };
      });
    }
  }]);

  return Util;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Util());

/***/ }),

/***/ "sL9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sildePopup2_vue__ = __webpack_require__("CSlk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114119f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sildePopup2_vue__ = __webpack_require__("kcRN");
function injectStyle (ssrContext) {
  __webpack_require__("Hh61")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114119f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sildePopup2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114119f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sildePopup2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sONz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_billDetail_vue__ = __webpack_require__("9xwj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f406a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_billDetail_vue__ = __webpack_require__("fWlp");
function injectStyle (ssrContext) {
  __webpack_require__("UEfU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62f406a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_billDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f406a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_billDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sfZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = aesEncrypt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
function aesEncrypt(word) {
  var keyWord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'XwKsGlMcdPMEhR1B';

  var key = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(keyWord);
  var srcs = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(word);
  var encrypted = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.AES.encrypt(srcs, key, { mode: __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.mode.ECB, padding: __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.pad.Pkcs7 });
  return encrypted.toString();
}

/***/ }),

/***/ "slVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);





/**
 * author: caominjie@tuhu.cn
 * date: 2017/11/20
 * docs:
 * eg:
    <a href="#" v-customer-care>唤出客服</a>
 */
// 客服参数接口
// const GET_CUSTOMER_SERVERICE_PARAM = 'https://wx.tuhu.cn/Home/Get_NTKF_PARAM'

// // 客服脚本地址
// const CUSTOMER_SCRIPT_URL = 'https://dl.ntalker.com/js/xn6/ntkfstat.js?siteid=kf_9739'

// const customerCare = () => {
//   // tuhu.fetch(GET_CUSTOMER_SERVERICE_PARAM, {
//   //   credentials: 'include' // 支持cookie
//   // }).then(() => {
//   //   if (window.NTKF) {
//   //     window.NTKF.im_openInPageChat('kf_9739_1468912096836')
//   //   } else {
//   //     tuhu.script(CUSTOMER_SCRIPT_URL).then(() => {
//   //       window.NTKF.im_openInPageChat('kf_9739_1468912096836')
//   //     })
//   //   }
//   // })

//   tuhu.navigateTo({url: '/pages/_customer/index'})
// }

// const lockFn = tuhu.util.lockFn()
var dictory = {
  /** 轮胎 */
  0: {
    h5: 'kf_9739_1449821124813',
    ios: 'kf_9739_1427361102492',
    android: 'kf_9739_1427361102492'
  },
  /** 保养 */
  1: {
    h5: 'kf_9739_1468912096836',
    ios: 'kf_9739_1468912258275',
    android: 'kf_9739_1468912258275'
  },
  /** 车品 */
  2: {
    h5: 'kf_9739_1469519005478',
    ios: 'kf_9739_1469518978190',
    android: 'kf_9739_1469518978190'
  },
  /** 蓄电池 */
  3: {
    h5: 'kf_9739_1483689907449',
    ios: 'kf_9739_1482974194375',
    android: 'kf_9739_1482974194375'
  },
  /** 镭射眼 */
  4: {
    h5: 'kf_9739_1468912096836',
    ios: 'kf_9739_1468913556620',
    android: 'kf_9739_1468913556620'
  },
  /** 轮毂 */
  5: {
    h5: 'kf_9739_1468914778973',
    ios: 'kf_9739_1468914714722',
    android: 'kf_9739_1468914714722'
  },
  /** 汽车改装 */
  6: {
    h5: 'kf_9739_1483690103056',
    ios: 'kf_9739_1483690103056',
    android: 'kf_9739_1483690103056'
  },
  /** 钣金喷漆 */
  7: {
    h5: 'kf_9739_1483690389556',
    ios: 'kf_9739_1483690389556',
    android: 'kf_9739_1483690389556'
  },
  /** 保险 */
  8: {
    h5: 'kf_9739_1479883503802',
    ios: 'kf_9739_1479883503802',
    android: 'kf_9739_1479883503802'
  },
  /** 找客服 轮胎 */
  9: {
    h5: 'kf_9739_1427361102492',
    ios: 'kf_9739_1427361102492',
    android: 'kf_9739_1427361102492'
  },
  /** 找客服 保养 */
  10: {
    h5: 'kf_9739_1468912258275',
    ios: 'kf_9739_1468912258275',
    android: 'kf_9739_1468912258275'
  },
  /** 找客服 车品 */
  11: {
    h5: 'kf_9739_1469518978190',
    ios: 'kf_9739_1469518978190',
    android: 'kf_9739_1469518978190'
  },
  /** 找客服 轮毂 */
  12: {
    h5: 'kf_9739_1468914714722',
    ios: 'kf_9739_1468914714722',
    android: 'kf_9739_1468914714722'
  },
  /** 找客服 喷漆 */
  13: {
    h5: 'kf_9739_1482974397518',
    ios: 'kf_9739_1482974397518',
    android: 'kf_9739_1482974397518'
  },
  /** 找客服 车险 */
  14: {
    h5: 'kf_9739_1479883433142',
    ios: 'kf_9739_1479883433142',
    android: 'kf_9739_1479883433142'
  },
  /** 汽车美容 */
  15: {
    APP_IOS: 'kf_9739_1482974342334',
    APP_Android: 'kf_9739_1482974342334',
    PC: 'kf_9739_1483690183879'
  }

  // 配置api地址
};var GET_CUSTOMER_SERVERICE_PARAM = 'https://api.tuhu.cn/User/SelectKeFuGroupId';

var CustomerCare = function () {
  function CustomerCare(config) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CustomerCare);

    if (typeof config === 'number') {
      return this.ByDictory(config);
    }

    return tuhu.getDefaultCar(2, false).then(function (res) {
      var vehicleId = res ? res.ProductID : '';

      _this.config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        source: 0,
        businessSource: 0,
        channel: _this.channel(),
        Pid: '',
        vehicleId: vehicleId,
        orderId: ''
      }, config);
      return _this.init();
    });
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CustomerCare, [{
    key: 'channel',
    value: function channel() {
      if (tuhu.device.tuhuAndroid) {
        return 'Android';
      } else if (tuhu.device.tuhuIos) {
        return 'Ios';
      } else {
        return 'H5';
      }
    }
  }, {
    key: 'init',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tuhu.fetch(GET_CUSTOMER_SERVERICE_PARAM, {}, {
                  query: this.config
                });

              case 2:
                res = _context.sent;
                return _context.abrupt('return', res.Id);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _ref.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'ByDictory',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(config) {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = dictory[config];

                if (!tuhu.device.tuhuAndroid) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', res.android);

              case 3:
                if (!tuhu.device.tuhuIos) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', res.ios);

              case 5:
                return _context2.abrupt('return', res.h5);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ByDictory(_x) {
        return _ref2.apply(this, arguments);
      }

      return ByDictory;
    }()
  }]);

  return CustomerCare;
}();

Vue.directive('customer-care', {
  inserted: function inserted(el, arg) {
    $(el).on('click', function () {
      var config = arg.value || 0;

      new CustomerCare(config).then(function (res) {
        tuhu.navigateTo({
          url: '/pages/_customer/index',
          query: {
            type: res
          }
        });
      });
    });
  }
});

/***/ }),

/***/ "stXk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sv6X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/v3.fa077a4.png";

/***/ }),

/***/ "t+JU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_platenum_vue__ = __webpack_require__("cAUL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e2cd70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_platenum_vue__ = __webpack_require__("4XSc");
function injectStyle (ssrContext) {
  __webpack_require__("mKIo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4e2cd70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_platenum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4e2cd70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_platenum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tB3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		text: {
			type: String,
			default: '保存'
		},
		type: {
			type: String,
			default: 'primary'
		}
	},
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "ti/l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/warning.878c886.png";

/***/ }),

/***/ "tqxU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("HRUa");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_541f46ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GgT6");
function injectStyle (ssrContext) {
  __webpack_require__("GxCR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-541f46ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_541f46ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uAu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBox)?_c('div',{class:_vm.mode == 'pop' ? 'verify-mask' : '',on:{"touchmove":function($event){$event.preventDefault();},"mousedown":function($event){$event.preventDefault();}}},[_c('div',{class:_vm.mode == 'pop' ? 'verifybox' : '',style:({ 'max-width': parseInt(_vm.imgSize.width) + 30 + 'px' })},[(_vm.mode == 'pop')?_c('div',{staticClass:"verifybox-top"},[_vm._v("\n      请完成安全验证\n      "),_c('van-icon',{attrs:{"name":"cross"},on:{"click":_vm.closeBox}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"verifybox-bottom",style:({ padding: _vm.mode == 'pop' ? '15px' : '0' })},[(_vm.componentType)?_c(_vm.componentType,{ref:"instance",tag:"components",attrs:{"captcha-type":_vm.captchaType,"type":_vm.verifyType,"figure":_vm.figure,"arith":_vm.arith,"mode":_vm.mode,"v-space":_vm.vSpace,"explain":_vm.explain,"img-size":_vm.imgSize,"block-size":_vm.blockSize,"bar-size":_vm.barSize,"default-img":_vm.defaultImg,"phone":_vm.phone}}):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uY7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verify_vue__ = __webpack_require__("uu74");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea2b72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verify_vue__ = __webpack_require__("Nq27");
function injectStyle (ssrContext) {
  __webpack_require__("G7pU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39ea2b72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea2b72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uhP7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ujE5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "um+J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tips.6522d3f.png";

/***/ }),

/***/ "us5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('div',{staticClass:"head-img"},[_c('img',{staticClass:"shop_door_img",attrs:{"src":_vm.shopHeadImg,"alt":"店铺门头照"}}),_vm._v(" "),_c('div',{staticClass:"switch-img"},[_c('div',{directives:[{name:"upload",rawName:"v-upload",value:({ onUpload: _vm.upload, index: 999, refresh: true }),expression:"{ onUpload: upload, index: 999, refresh: true }"}],staticClass:"switch"},[_vm._v("\n        更换\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"shop_bar"},[_c('div',[_c('van-cell',{attrs:{"center":"","title":"营业状态"}},[_c('van-switch',{attrs:{"value":_vm.checked,"active-color":"#33cc33","inactive-color":"#ccc"},on:{"click":_vm.onInput1}})],1)],1),_vm._v(" "),_c('div',[_c('van-field',{attrs:{"readonly":"","clickable":"","label":"营业时间","value":_vm.workTime,"placeholder":((_vm.shopStatusData.openingTime) + "-" + (_vm.shopStatusData.closingTime) + " "),"input-align":"right","is-link":""},on:{"click":function($event){_vm.showPicker = true}}}),_vm._v(" "),_c('van-popup',{attrs:{"round":"","position":"bottom"},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v},expression:"showPicker"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":"营业时间","columns":_vm.columns},on:{"cancel":function($event){_vm.showPicker = false},"confirm":_vm.onConfirm}})],1)],1),_vm._v(" "),_c('shop-info',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showEdit),expression:"!showEdit"}],attrs:{"_shopBasicData":_vm.shopBasicData,"_shopMerchantData":_vm.shopMerchantData,"_shopCompanyData":_vm.shopCompanyData,"_CertificatePhotoData":_vm.CertificatePhotoData,"_showTab":_vm.active},on:{"changeTabInfo":_vm.changeTabInfo}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEdit),expression:"showEdit"}],staticClass:"edit-shop-info"},[_c('shop-info',{ref:"shopInfoRef",attrs:{"isEdit":_vm.showEdit,"_shopBasicData":_vm.shopBasicData,"_shopMerchantData":_vm.shopMerchantData,"_shopCompanyData":_vm.shopCompanyData,"_CertificatePhotoData":_vm.CertificatePhotoData,"_showTab":_vm.active},on:{"hide":function($event){_vm.showEdit = false}}})],1),_vm._v(" "),_c('div',[_c('van-button',{staticClass:"shop_info_btn",attrs:{"size":"large","color":"rgb(25,137,250)","plain":"","type":"info","hairline":true},on:{"click":_vm.showTabs}},[_vm._v("修改")])],1)],1),_vm._v(" "),_c('van-dialog',{staticClass:"shopCustoremClass",attrs:{"showConfirmButton":false},model:{value:(_vm.visibleShop),callback:function ($$v) {_vm.visibleShop=$$v},expression:"visibleShop"}},[_c('p',{staticClass:"title"},[_vm._v("门店营业状态变更")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("如需更改门店营业状态，请联系市场经理或致电客服")]),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('p',{on:{"click":function($event){_vm.visibleShop = false}}},[_vm._v("取消变更")]),_vm._v(" "),_c('p',{directives:[{name:"call",rawName:"v-call"}]},[_vm._v("联系客服")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uu74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_util__ = __webpack_require__("sEZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    watch: {
        count: function count(val) {
            if (!val) return this.count = 1;
            if (val > this.num) return this.count = this.num;
        }
    },
    data: function data() {
        return {
            tiktoStorekVisible: false,
            tiktokText: '',
            visibleConfirm: false,
            count: 1,
            mobile: '',
            shopId: tuhu.getParam('shopId') || '',
            shopName: tuhu.getParam('shopName') || '',
            path: tuhu.getParam('path') || '',
            num: 1,
            tiktokData: {},
            minus: 'https://res.xiaokunkeji.cn/image/2023/12/13/4aaaca8b6a7549e9be69f356e4c7a3b2.png',
            no_minus: 'https://res.xiaokunkeji.cn/image/2023/12/13/e67c874239f84bf3b1102e9226aeb0dd.png',
            add: 'https://res.xiaokunkeji.cn/image/2023/12/13/75fb9b8d2d824802a03027ef10683b0f.png',
            no_add: 'https://res.xiaokunkeji.cn/image/2023/12/13/1bc24facb5ec4d7a8f38e681707a22fa.png'
        };
    },
    mounted: function mounted() {
        this.getTiktokInfo();
    },


    methods: {
        getTiktokInfo: function getTiktokInfo() {
            var _this = this;

            try {
                tuhu.showIndicator();
                tuhu.fetch(__WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.GET_TIKTOY_MERCHANT_PREPARE + '?path=' + encodeURIComponent(this.path) + '&shop=' + this.shopId).then(function (data) {
                    if (data.code === '200') {
                        tuhu.hideIndicator();

                        _this.tiktokData = data.data;
                        _this.num = data.data.num;
                    } else {
                        tuhu.hideIndicator();

                        if (data.code == 4003) {
                            _this.tiktoStorekVisible = true;
                            _this.tiktokText = '您的门店暂未暂未上架该服务，请联系您的商户专员或小鲲车服客服开通！';
                        } else if (data.code == 4004) {
                            _this.tiktoStorekVisible = true;
                            _this.tiktokText = '您的门店已下架该服务无法核销，请联系您的商户专员或小鲲车服客服重新上架！';
                        } else {
                            tuhu.toast(data.message);
                        }
                    }
                });
            } catch (error) {
                tuhu.hideIndicator();
                console.log('err', error);
                tuhu.toast(error);
            }
        },
        handlePreverify: function handlePreverify() {
            if (this.mobile) {
                if (!__WEBPACK_IMPORTED_MODULE_3__commons_util__["a" /* default */].isPhone(this.mobile)) return tuhu.toast('请输入正确的手机号');
            }
            this.visibleConfirm = true;
        },


        handleConfirmWriteOff: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _tiktokData, poiId, ttokorderId, res;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _tiktokData = this.tiktokData, poiId = _tiktokData.poiId, ttokorderId = _tiktokData.ttokorderId;

                            tuhu.showIndicator();
                            _context.next = 4;
                            return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.GET_TIKTOK_VERIFY, {
                                method: "post",
                                body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                    mobile: this.mobile || '400-176-8848',
                                    shopId: this.shopId,
                                    poiId: poiId,
                                    orderId: ttokorderId,
                                    num: this.count
                                })
                            });

                        case 4:
                            res = _context.sent;

                            if (res.code === '200') {
                                this.mobile = '';
                                tuhu.hideIndicator();
                                tuhu.navigateTo({
                                    url: '/pages/tiktok/result',
                                    query: {
                                        isSucess: 1,
                                        shopId: this.shopId,
                                        goodsOrderId: res.data.goodsOrderId
                                    }
                                });
                            } else {
                                this.mobile = '';
                                tuhu.hideIndicator();
                                tuhu.navigateTo({
                                    url: '/pages/tiktok/result',
                                    query: {
                                        tips: res.code == '5017' ? res.message : ''
                                    }

                                });
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        })), 500),

        toBack: function toBack() {
            tuhu.navigateTo({
                url: '/pages/home/index'
            });
        }
    }
});

/***/ }),

/***/ "vEpc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/t-btn.764190e.png";

/***/ }),

/***/ "vJFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commentCard__ = __webpack_require__("/iEN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 评论card

var getListUrl = 'https://api.tuhu.cn/Comment/GetProductComments';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    comment: __WEBPACK_IMPORTED_MODULE_1__commentCard__["a" /* default */]
  },
  props: {
    tab1Data: {
      type: Object,
      defalut: true
    }
  },
  data: function data() {
    return {
      nodata: false,
      end: false,
      commentsList: [],
      PageNumber: 1,
      maxPageCount: 1,
      tabData: this.tab1Data,
      resolve: function resolve() {},
      reject: function reject() {}
    };
  },

  watch: {
    PageNumber: function PageNumber(value, oldValue) {
      // 第一次请求发送
      if (value === 1) {
        this.getList(true);
      } else if (value) {
        this.getList(false);
      }
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var isRefersh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      tuhu.fetch(getListUrl, {}, {
        query: {
          productId: this.tabData.productId,
          commentType: 0,
          PageNumber: this.PageNumber
        }
      }).then(function (res) {
        if (isRefersh) {
          _this.commentsList = res.Data;
        } else {
          var _commentsList;

          (_commentsList = _this.commentsList).push.apply(_commentsList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.Data));
        }
        // 第一次请求就结束的两种情况
        if (res.MaxPageCount === 1) {
          _this.end = true;
        }
        if (res.MaxPageCount === 0) {
          _this.nodata = true;
        }
        _this.maxPageCount = res.MaxPageCount;
        _this.resolve();
      });
    },

    oninfinite: function oninfinite(ev, resolve, reject) {
      // 如果当前页数小于总页数，增加页数
      if (this.PageNumber < this.maxPageCount) {
        this.PageNumber = this.PageNumber + 1;
        this.resolve = resolve;
      } else {
        this.end = true;
      }
    }
  },
  updated: function updated() {
    this.tabData = this.tab1Data;
  },
  created: function created() {
    this.getList();
  }
});

/***/ }),

/***/ "vMYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Verify_vue__ = __webpack_require__("xBAO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0daac9f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Verify_vue__ = __webpack_require__("uAu4");
function injectStyle (ssrContext) {
  __webpack_require__("gq/Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Verify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0daac9f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Verify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vSyV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vlgO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wxconfig__ = __webpack_require__("Z+yf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk__);





var WxSdk = function WxSdk() {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WxSdk);
};

WxSdk.ready = function () {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__wxconfig__["a" /* default */].share().then(function (res) {
      if (res) {
        console.log('微信初始化验证成功, readytrue', res);
        resolve('微信初始化验证成功, true');
      } else {
        console.log('微信初始化验证失败, readyfalse');
        reject('微信初始化验证失败, false');
      }
    });
  });
};

WxSdk.scanQR = function () {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (tuhu.device.isWeixin) {
    console.log('调用扫一扫');
    __WEBPACK_IMPORTED_MODULE_2__wxconfig__["a" /* default */].share(['scanQRCode']).then(function (status) {
      console.log('配置是否成功1', status);
      __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function success(res) {
          console.log('qrCode', res);
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          tuhu.navigateTo({
            url: '/pages/verifyCode/index',
            data: {
              verifyCode: result
            },
            query: {
              success: 1
            }
          });
        },
        fail: function fail(err) {
          console.log('scanQR-err', err);
          tuhu.toast('网络错误,请刷新后重试' || '网络错误');
        }
      });
    });
  } else {
    tuhu.toast('请在微信客户端打开');
  }
};

WxSdk.scanTP = function () {
  if (tuhu.device.isWeixin) {
    __WEBPACK_IMPORTED_MODULE_2__wxconfig__["a" /* default */].share(['scanQRCode']).then(function (status) {
      // console.log('配置是否成功', status)
      __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function success(res) {
          console.log('resssss', res);
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          tuhu.navigateTo({
            url: '/pages/verify/code',
            data: {
              verifyCode: result
            },
            query: {
              success: 1,
              verifyCode: result
            }
          });
        },
        fail: function fail(err) {
          tuhu.toast(err || '网络错误');
        }
      });
    });
  } else {
    tuhu.toast('请在微信客户端打开');
  }
};

WxSdk.scanDY = function () {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (tuhu.device.isWeixin) {
    console.log('调用扫一扫');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__wxconfig__["a" /* default */].share(['scanQRCode']).then(function (status) {
        console.log('配置是否成功1', status);
        __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.scanQRCode({
          desc: 'scanQRCode desc',
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
          success: function success(res) {
            console.log('抖音扫一扫', res);
            resolve(res);
          },
          fail: function fail(err) {
            console.log('scanQR-err', err);
            tuhu.toast('网络错误,请刷新后重试' || '网络错误');
          }
        });
      });
    });
  } else {
    tuhu.toast('请在微信客户端打开');
  }
};

WxSdk.hideBtn = function () {
  if (tuhu.device.isWeixin) {
    __WEBPACK_IMPORTED_MODULE_2__wxconfig__["a" /* default */].share(['hideMenuItems']).then(function (status) {
      console.log('配置是否', status);
      __WEBPACK_IMPORTED_MODULE_3_weixin_js_sdk___default.a.hideMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
      });
    });
  } else {
    // tuhu.toast('请在微信客户端打开')
  }
};

/* harmony default export */ __webpack_exports__["a"] = (WxSdk);

/***/ }),

/***/ "w2vY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__searchSortTabs__ = __webpack_require__("PKmj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wm__ = __webpack_require__("Jytq");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * author: lijingwen@tuhu.cn
 * date: 2017/11/20
 * desc: 搜索列表页
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      value: '',
      // options: {
      //   searchword: '轮胎'
      // },
      resolve: function resolve() {},
      scrollId: tuhu.util.getScrollId(),
      noProduct: false,
      end: false,
      oldPageNumber: 1,
      ProductList: [],
      carNamesShow: '请选择车型信息',
      tabsStatusType: [{
        name: '综合',
        type: 0, // 少选id
        choosed: true // 是否默认选中
      }, {
        name: '销量',
        up: 2,
        down: 1,
        default: 'down', // 默认展示的是啥样的
        choosed: false
      }, {
        name: '价格',
        up: 6,
        down: 5,
        default: 'down',
        choosed: false
      }],
      TotalPage: 1,
      BrandType: '',
      CarName: '',
      car: {},
      appKeyword: '/search',
      searchParmas: {
        word: '', // 搜索关键字
        pageNumber: 1, // 页数
        orderType: 0, // 排序
        MinPrice: '', // 价格最低
        MaxPrice: '', // 价格最高
        BrandName: '', // 侧滑品牌筛选
        cityName: '',
        provinceName: '',
        cityId: '', // 空
        provinceId: '', // 空
        Width: '', // 空
        AspectRatio: '', // 空
        Rim: '', // 空
        // SalesName: '', // SalesName
        tid: '', // TID
        vehicleId: '', // ProductID
        TireSize: '',
        saleRuleId: this.options.ruleId || '' // 优惠券id
      },
      isPanelShow: false, // 侧边栏是否滑出
      location: {},
      carInfo: {},
      ActivityBuildList: null,
      activityFirmList: null
    };
  },

  components: {
    searchSortTabs: __WEBPACK_IMPORTED_MODULE_5__searchSortTabs__["a" /* default */],
    'tuhu-wm': __WEBPACK_IMPORTED_MODULE_6__wm__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {},

  watch: {
    searchParmas: {
      handler: function handler(value, oldValue) {
        var isRefersh = true;
        this.end = false;
        this.noProduct = false;
        if (value.pageNumber !== oldValue.pageNumber) {
          isRefersh = false;
        }
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(value) !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(oldValue)) {
          // if ((this.TotalPage === 1 ? 2 : this.TotalPage) > value.pageNumber) {
          this.fetchProductList(isRefersh);
          // }
        }
      },

      deep: true
    }
  },
  created: function created() {
    // 不会触发fetch，等到地理信息和车型信息到位后再触发
    var keyword = this.options === undefined ? '' : this.options.keyword;
    this.appKeyword = '/searchResult?keyword=' + encodeURIComponent(encodeURIComponent(keyword));
    // const saleRuleId = this.options === undefined ? '' : this.options.ruleId
    this.$set(this.searchParmas, 'word', keyword);
    // this.$set(this.searchParmas, 'saleRuleId', saleRuleId)
    this.firstSetParmas();
  },

  methods: {
    toActivity: function toActivity() {
      if (tuhu.autoNavigate) {
        tuhu.autoNavigate(this.ActivityBuildList);
      }
    },
    toModule: function toModule() {
      if (tuhu.autoNavigate) {
        tuhu.autoNavigate(this.activityFirmList);
      }
    },
    getCarInfo: function getCarInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var car;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                car = {};

                if (!(tuhu.store === undefined)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return tuhu.getDefaultCar(5, false);

              case 4:
                car = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.next = 9;
                return tuhu.store.state._carInfo;

              case 9:
                car = _context.sent;

              case 10:
                if (car !== undefined && !tuhu.util.isEmptyObject(car)) {
                  if (car.SalesName !== '') {
                    _this.carNamesShow = '\u8F66\u578B\uFF1A' + car.SalesName;
                  }
                  _this.carNamesShow = '\u8F66\u578B\uFF1A' + (car.BrandType || '') + ' - ' + (car.CarName || '') + ' ' + (car.SalesName || '');
                }
                _this.carInfo = car;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getLocation: function getLocation() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var location;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                location = void 0;

                if (!(tuhu.store === undefined)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return tuhu.getLocate();

              case 4:
                location = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return tuhu.store.state._locationInfo;

              case 9:
                location = _context2.sent;

              case 10:
                _this2.location = location;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    autoNavigate: function autoNavigate(item) {
      if (tuhu.autoNavigate) {
        tuhu.autoNavigate(item);
      }
    },
    handleSortPanelHidden: function handleSortPanelHidden(isshow) {
      this.isPanelShow = isshow;
    },
    firstSetParmas: function firstSetParmas() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var carInfo, location;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getCarInfo();

              case 2:
                _context3.next = 4;
                return _this3.getLocation();

              case 4:
                carInfo = _this3.carInfo;
                location = _this3.location;

                if (carInfo && location) {
                  console.log(carInfo);
                  _this3.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.searchParmas, {
                    // SalesName: carInfo.SalesName,
                    tid: carInfo.TID,
                    vehicleId: carInfo.ProductID,
                    TireSize: carInfo.TireSizeForSingle,
                    // BrandType: carInfo.BrandType,
                    // CarName: carInfo.CarName,
                    cityName: location.city,
                    provinceName: location.province
                  });
                } else if (!carInfo) {
                  _this3.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.searchParmas, {
                    cityName: location.city,
                    provinceName: location.province
                  });
                } else if (!location) {
                  _this3.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.searchParmas, {
                    // SalesName: carInfo.SalesName,
                    tid: carInfo.TID,
                    vehicleId: carInfo.ProductID
                    // BrandType: carInfo.BrandType,
                    // CarName: carInfo.CarName
                  });
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    selectCar: function selectCar() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.carInfo.TID === '' || _this4.carInfo.TID === undefined) {
                  // 二级车型继续补全 、没有车型选车
                  tuhu.getDefaultCar(5, true).then(function (car) {
                    _this4.getCarInfo();
                  }).catch(function (e) {
                    // alert(333, e)
                  });
                } else {
                  // 五级车型跳转选车页面
                  tuhu.selectCar(5, true).then(function (car) {
                    _this4.getCarInfo();
                    _this4.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.searchParmas, {
                      SalesName: car.SalesName,
                      tid: car.TID,
                      vehicleId: car.ProductID,
                      BrandType: car.BrandType,
                      CarName: car.CarName
                    });
                  }).catch(function (e) {
                    // alert(333, e)
                  });
                }

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    toIndex: function toIndex() {
      tuhu.redirectTo({
        // tuhu.navigateBack({
        url: '/pages/_search/index',
        data: {
          keyword: this.options === undefined ? '' : this.options.keyword
        }
      });
    },
    oninfinite: function oninfinite(ev, resolve, reject) {
      // 因为vue watch deep 监听对象时，handler 两个参数指向相同，所以要重新赋值，这样既可以监听到，又可以取到旧的值
      this.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.searchParmas, { pageNumber: this.searchParmas.pageNumber + 1 });
      this.resolve = resolve;
    },

    // 点击取消
    hindleBack: function hindleBack() {
      tuhu.navigateBack();
    },

    // 请求列表
    fetchProductList: function fetchProductList(isRefersh) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var searchParmas, res, _ProductList;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                searchParmas = _this5.searchParmas;

                if (!(_this5.end === false && _this5.searchParmas.word !== '')) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 4;
                return tuhu.fetch('https://api.tuhu.cn/Search/SearchList', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'version': 'iOS 5.3.7' // 活动价格
                  },
                  body: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(searchParmas)
                }, {
                  status: isRefersh
                });

              case 4:
                res = _context5.sent;


                _this5.ActivityBuildList = res.ActivityBuildList;
                _this5.activityFirmList = res.activityFirmList;
                if (isRefersh) {
                  _this5.ProductList = res.ProductList;
                } else {
                  (_ProductList = _this5.ProductList).push.apply(_ProductList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.ProductList));
                }
                if (res.ProductList.length === 0 || res.TotalPage === 1) {
                  _this5.noProduct = true;
                }
                if (res.TotalPage === _this5.searchParmas.pageNumber) {
                  _this5.end = true;
                }
                _this5.TotalPage = res.TotalPage;
                _this5.resolve();
                _context5.next = 15;
                break;

              case 14:
                _this5.end = true;

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    callbackClickTab: function callbackClickTab(style, typeKey) {
      // 排序
      if (style === 'sequence') {
        this.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.searchParmas, { orderType: typeKey, pageNumber: 1 });
      } else if (style === 'money') {
        // 价格范围
        // typeKey.sort()
        this.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.searchParmas, { MinPrice: typeKey[0], pageNumber: 1 });
        this.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.searchParmas, { MaxPrice: typeKey[1], pageNumber: 1 });
      } else if (style === 'brand') {
        // 品牌
        // this.searchParmas = {...this.searchParmas, BrandName: typeKey.join('、')}
        this.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.searchParmas, { BrandName: typeKey.join(','), pageNumber: 1 });
      } else if (style === 'recommend') {
        this.searchParmas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.searchParmas, { IsProductRefer: typeKey });
      }
    }
  }
});

/***/ }),

/***/ "w6an":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kxd.1e68ecc.png";

/***/ }),

/***/ "wOE/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car_4.48e83d5.png";

/***/ }),

/***/ "wPkz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yy/K");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c0f232e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("G1XJ");
function injectStyle (ssrContext) {
  __webpack_require__("ZG7+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c0f232e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c0f232e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wet0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[_c('section',{staticClass:"day-record"},[_c('img',{staticClass:"bg",attrs:{"src":"https://res.xiaokunkeji.cn/image/2023/12/14/e41a13db2d4b41f181bff1e5aa73a44e.png","alt":"","srcset":""}}),_vm._v(" "),_c('section',{staticClass:"page-content"},[_c('RecordList',{attrs:{"dataList":_vm.dataList,"tabList":_vm.tabList,"isDay":true},scopedSlots:_vm._u([{key:"top",fn:function(){return [_vm._v(" "+_vm._s(_vm.queryDateText)+" ")]},proxy:true},{key:"tips",fn:function(ref){
var obj = ref.obj;
return [(obj.noRevoke)?_c('section',{staticClass:"bottom"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"tip"},[_vm._v("备注：核销1小时内可以撤销核销")])]),_vm._v(" "),_c('div',{staticClass:"right",on:{"click":function($event){return _vm.revoke(obj)}}},[_c('div',{staticClass:"return"},[_vm._v("撤销核销")])])]):_vm._e()]}}])})],1),_vm._v(" "),_c('van-dialog',{staticClass:"dialog",attrs:{"title":"撤销当前核销？","showCancelButton":"","confirmButtonText":"确认撤销","cancelButtonText":"暂不撤销","get-container":".day-record"},on:{"confirm":_vm.sureRevoke},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"text"},[_vm._v("\n        请和消费者确认后再进行撤销操作，撤销后该订单将不计入核销订单和核销收入。\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("SJI6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);

var state = {
  location: null,
  userInfo: null,
  currentShopInfo: null,
  bankInfo: null
};

var mutations = {
  setLocationInfo: function setLocationInfo(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.location = payload;
  },
  setUserInfo: function setUserInfo(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.userInfo = payload;
  },
  setCurrentShopInfo: function setCurrentShopInfo(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.currentShopInfo = payload;
  },
  setBankInfo: function setBankInfo(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    state.bankInfo = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
  state: state,
  mutations: mutations
}));

/***/ }),

/***/ "x18j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x3WB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/operation.1f22f54.png";

/***/ }),

/***/ "x3mS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_commons_imageCompress__ = __webpack_require__("N6PM");






/**
 * 图片上传指令
 * opt: {
  *   maxEdge 压缩后最大边长 默认1280（长边超出时等比缩小）
  *   quality 重新编码质量 默认0.8（JPEG）
  *   notCompress 是否跳过压缩（如需 OCR 识别的清晰照片）默认false
  *   fileFormat 图片格式过滤
 * }
 */
// 公共图片压缩工具（先压缩、再上传）

// 图片上传接口（与 src/configs/config.js 的 apiFilter 保持一致：通过页面 origin 区分生产/测试环境）
var UPLOAD_URL = {
  prod: 'https://api.hzqmtech.com/admin/common/upload', // 生产
  test: 'https://test-api.hzqmtech.com/admin/common/upload' // 测试

  // 生产环境：正式站点（用 hostname 判断，兼容 http/https）
};var isProdEnv = location.hostname === 'm.hzqmtech.com';
var uploadUrl = isProdEnv ? UPLOAD_URL.prod : UPLOAD_URL.test;
var vinGetPic = 'https://www.xiaokunkeji.cn/api/vin/image/ocr'; // 本项目没用到，所以没修改
// 类实例
var instance = null;
// FileReader
var fileReader = null;

var ImgUpload = function () {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ImgUpload, null, [{
    key: 'upload',
    value: function upload() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object;

      opts = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
        // fileFormat: ['png', 'jpg', 'jpeg']
        quality: 0.8,
        maxSize: 1024 * 1024 * 8 // 超过 8MB 才压缩，不超过直接上传原文件（不修改尺寸）
      }, opts);

      this.opts = opts;

      if (!instance) {
        instance = new ImgUpload();
      }
      return instance.uploadImg(opts);
    }
  }]);

  function ImgUpload() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ImgUpload);

    this.onLoadImgSuccess = null;
    this.opts = null;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ImgUpload, [{
    key: 'uploadImg',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(opts) {
        var file, fileResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 实例上同步保存配置（static upload 里的 this 是类本身，实例读不到）
                this.opts = opts;

                // 过滤错误调用
                if (opts.file.length === 0) {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
                    _code: -1,
                    _message: '未选择图片或者取消选择图片'
                  });
                }

                // img
                file = opts.file[0];

                // 过滤文件格式

                if (opts.fileFormat && !opts.fileFormat.includes(file.name.match(/\.(\w+)$/)[1])) {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
                    _code: -2,
                    _message: '文件格式不正确'
                  });
                }

                // 回调(兼容1.0)
                this.onLoadImgSuccess = opts.onLoadImgSuccess || opts.onImgSuccess;

                // 未压缩分支单独触发回调（保持原有钩子行为）

                if (!(opts.notCompress && this.onLoadImgSuccess)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return instance._fileReader(file);

              case 8:
                fileResult = _context.sent;


                // 触发回调
                this.onLoadImgSuccess({
                  img: fileResult
                });

              case 10:
                if (opts.notCompress) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return instance._imgCompress(file);

              case 13:
                file = _context.sent;

                if (file) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt('return', {
                  code: '500',
                  message: '图片处理失败，请重试'
                });

              case 16:
                return _context.abrupt('return', instance._upload(file, opts));

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadImg(_x2) {
        return _ref.apply(this, arguments);
      }

      return uploadImg;
    }()
  }, {
    key: '_imgCompress',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
        var fileResult, opts;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return instance._fileReader(file);

              case 2:
                fileResult = _context2.sent;


                // 触发回调
                this.onLoadImgSuccess && this.onLoadImgSuccess({

                  img: fileResult

                });

                // 图片压缩（保持原尺寸，仅降低质量重新编码），失败或体积未变小时返回原文件
                opts = this.opts || {};
                return _context2.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_6__src_commons_imageCompress__["a" /* compressImage */])(file, {
                  quality: opts.quality,
                  maxSize: opts.maxSize
                }));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _imgCompress(_x3) {
        return _ref2.apply(this, arguments);
      }

      return _imgCompress;
    }()
  }, {
    key: '_fileReader',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(file) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                  if (!fileReader) {
                    fileReader = new FileReader();
                  }

                  fileReader.onloadend = function () {
                    resolve(fileReader.result);
                  };

                  fileReader.onerror = function () {

                    reject({
                      _code: -3,
                      _message: '文件load失败'
                    });
                  };

                  fileReader.readAsDataURL(file);
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _fileReader(_x4) {
        return _ref3.apply(this, arguments);
      }

      return _fileReader;
    }()
  }, {
    key: '_upload',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(img, opts) {
        var data, res, _res;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = new FormData();


                data.append('multipartFile', img);

                tuhu.showIndicator();

                if (!opts.vin) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 6;
                return tuhu.fetch(vinGetPic, {
                  method: 'post',
                  body: data
                }, {
                  timeout: 20
                }).catch(function () {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
                    _code: -6,
                    _message: '接口异常'
                  });
                });

              case 6:
                res = _context4.sent;
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ index: opts.index }, res || {}));

              case 10:
                _context4.next = 12;
                return tuhu.fetch(uploadUrl, {
                  method: 'POST',
                  body: data
                }, {
                  timeout: 2000
                }).catch(function () {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
                    _code: -6,
                    _message: '接口异常'
                  });
                });

              case 12:
                _res = _context4.sent;


                tuhu.hideIndicator();
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ index: opts.index }, _res || {}));

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _upload(_x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return _upload;
    }()
  }]);

  return ImgUpload;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImgUpload);

/***/ }),

/***/ "xBAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Verify_VerifySlide__ = __webpack_require__("ZPEK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Verify_VerifyPoints__ = __webpack_require__("zA4t");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase, eqeqeq, no-redeclare */
/**
 * Verify 验证码组件
 * @description 分发验证码使用
 * */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Vue2Verify',
  components: {
    VerifySlide: __WEBPACK_IMPORTED_MODULE_2__Verify_VerifySlide__["a" /* default */],
    VerifyPoints: __WEBPACK_IMPORTED_MODULE_3__Verify_VerifyPoints__["a" /* default */]
  },
  props: {
    // 双语化
    locale: {
      require: false,
      type: String,
      default: function _default() {
        // 默认语言不输入为浏览器语言
        if (navigator.language) {
          var language = navigator.language;
        } else {
          var language = navigator.browserLanguage;
        }
        return language;
      }
    },
    captchaType: {
      type: String,
      default: 'blockPuzzle'
    },
    figure: {
      type: Number
    },
    arith: {
      type: Number
    },
    mode: {
      type: String,
      default: 'pop'
    },
    vSpace: {
      type: Number,
      default: 20
    },
    explain: {
      type: String
    },
    imgSize: {
      type: Object,
      default: function _default() {
        return {
          width: '300px',
          height: '150px'
        };
      }
    },
    blockSize: {
      type: Object
    },
    barSize: {
      type: Object
    },
    phone: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      // showBox:true,
      clickShow: false,
      // 内部类型
      verifyType: undefined,
      // 所用组件类型
      componentType: undefined,
      // 默认图片
      defaultImg: 'https://res.xiaokunkeji.cn/image/2026/03/20/48bd8095eb024ad28ec81c309bf7989e.jpg'
    };
  },

  computed: {
    instance: function instance() {
      return this.$refs.instance || {};
    },
    showBox: function showBox() {
      if (this.mode == 'pop') {
        return this.clickShow;
      } else {
        return true;
      }
    }
  },
  watch: {
    captchaType: {
      immediate: true,
      handler: function handler(captchaType) {
        switch (captchaType.toString()) {
          case 'blockPuzzle':
            this.verifyType = '2';
            this.componentType = 'VerifySlide';
            break;
          case 'clickWord':
            this.verifyType = '';
            this.componentType = 'VerifyPoints';
            break;
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.uuid();

            case 2:
              console.log('verify mounted', localStorage.getItem('slider'), localStorage.getItem('point'));
              console.log(localStorage.getItem('slider'), localStorage.getItem('point'), 'uuid mounted');

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    // 生成 uuid
    uuid: function uuid() {
      var s = [];
      var hexDigits = '0123456789abcdef';
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-';

      var slider = 'slider' + '-' + s.join('');
      var point = 'point' + '-' + s.join('');
      // 判断下是否存在 slider
      console.log(localStorage.getItem('slider'));
      if (!localStorage.getItem('slider')) {
        localStorage.setItem('slider', slider);
      }
      if (!localStorage.getItem('point')) {
        localStorage.setItem('point', point);
      }
      console.log(localStorage.getItem('slider'), localStorage.getItem('point'), 'uuid');
    },

    /**
     * i18n
     * @description 兼容vue-i18n 调用$t来转换ok
     * @param {String} text-被转换的目标
     * @return {String} i18n的结果
     * */
    i18n: function i18n(text) {
      if (this.$t) {
        return this.$t(text);
      } else {
        // 兼容不存在的语言
        var i18n = this.$options.i18n.messages[this.locale] || this.$options.i18n.messages['en-US'];
        return i18n[text];
      }
    },

    /**
     * refresh
     * @description 刷新
     * */
    refresh: function refresh() {
      if (this.instance.refresh) {
        this.instance.refresh();
      }
    },
    closeBox: function closeBox() {
      this.clickShow = false;
      this.refresh();
    },
    show: function show() {
      if (this.mode == 'pop') {
        this.clickShow = true;
      }
    }
  }
});

/***/ }),

/***/ "xF0d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xMCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resetSize;
/* unused harmony export _code_chars */
/* unused harmony export _code_color1 */
/* unused harmony export _code_color2 */
/* eslint-disable camelcase, eqeqeq, no-redeclare */
function resetSize(vm) {
  var img_width, img_height, bar_width, bar_height; // 图片的宽度、高度，移动条的宽度、高度

  var parentWidth = vm.$el.parentNode.offsetWidth || window.offsetWidth;
  var parentHeight = vm.$el.parentNode.offsetHeight || window.offsetHeight;

  if (vm.imgSize.width.indexOf('%') != -1) {
    img_width = parseInt(this.imgSize.width) / 100 * parentWidth + 'px';
  } else {
    img_width = this.imgSize.width;
  }

  if (vm.imgSize.height.indexOf('%') != -1) {
    img_height = parseInt(this.imgSize.height) / 100 * parentHeight + 'px';
  } else {
    img_height = this.imgSize.height;
  }

  if (vm.barSize.width.indexOf('%') != -1) {
    bar_width = parseInt(this.barSize.width) / 100 * parentWidth + 'px';
  } else {
    bar_width = this.barSize.width;
  }

  if (vm.barSize.height.indexOf('%') != -1) {
    bar_height = parseInt(this.barSize.height) / 100 * parentHeight + 'px';
  } else {
    bar_height = this.barSize.height;
  }

  return { imgWidth: img_width, imgHeight: img_height, barWidth: bar_width, barHeight: bar_height };
}

var _code_chars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
var _code_color1 = ['#fffff0', '#f0ffff', '#f0fff0', '#fff0f0'];
var _code_color2 = ['#FF0033', '#006699', '#993366', '#FF9900', '#66CC66', '#FF33CC'];

/***/ }),

/***/ "xQDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.height)?_c('div',{staticClass:"wrap",style:(_vm.style)},[_c('img',{staticClass:"placeholder",attrs:{"src":__webpack_require__("KuuQ")}})]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xT4F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xW3h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab2_vue__ = __webpack_require__("AVGa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53124e1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab2_vue__ = __webpack_require__("UII/");
function injectStyle (ssrContext) {
  __webpack_require__("XxjT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53124e1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53124e1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xgxP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/v1.5484ef2.png";

/***/ }),

/***/ "xsZ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xx2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_dialog_style__ = __webpack_require__("XmAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_dialog__ = __webpack_require__("il3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_config__ = __webpack_require__("65XL");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            UserManagementData: {},
            show: false, // 选择框显示隐藏
            alterUserIndex: null, // 当前修改用户的下标 点击改变
            tabList1: [{
                name: '员工权限',
                url: '/pages/accountAccessPic/index'
            }],
            tabList2: [{
                name: '新增账户',
                url: '/pages/addAccessUser/index'
            }],
            tabList3: [{
                name: '员工管理',
                url: '/pages/userManagement/index'
            }],
            userPhone: '',
            shopId: '',
            userId: '',
            userName: '默认',
            userRole: '',
            userStatus: ''
        };
    },
    created: function created() {
        this.getUserManagementInfo();
    },

    // mounted() {
    //     if (window.history && window.history.pushState) {
    //     // 向历史记录中插入了当前页
    //     // history.pushState(null, null, document.URL)
    //     window.addEventListener('popstate', this.userManagementGoBack, false)
    // 	}
    // },
    // destroyed() {
    // 	window.removeEventListener('popstate', this.userManagementGoBack, false)
    // },
    methods: {
        // userManagementGoBack () {
        //     console.log('点击了浏览器的返回按钮')
        //     window.location.href = '/pages/home/index'
        // },
        getUserManagementInfo: function getUserManagementInfo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData, data;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                if (roleData && roleData.code === '200') {
                                    _this.userRole = roleData.data.role;
                                    _this.shopId = roleData.data.shopId;
                                } else {
                                    tuhu.toast(roleData.message || '获取权限失败');
                                }
                                // 员工列表
                                _context.next = 6;
                                return tuhu.fetch(__WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.SELECT_USER_INFO + '/' + _this.shopId);

                            case 6:
                                data = _context.sent;

                                if (data && data.code === '200') {
                                    _this.UserManagementData = data.data;
                                    _this.userStatus = data.data.status;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // 当前操作的用户数据
        alterUser: function alterUser(e, index) {
            // 点击的元素下标 对标第几条数据
            this.alterUserIndex = index;
            this.show = true;
            // 点击修改操作后需要发送的数据
            this.userPhone = this.UserManagementData[index].phone;
            this.userId = this.UserManagementData[index].userId;
            this.userName = this.UserManagementData[index].userName;
            this.userStatus = this.UserManagementData[index].status;
        },

        // 三个操作按钮的点击事件
        // 启用
        onSelect1: function onSelect1(item, e) {
            var _this2 = this;

            // 确认框
            __WEBPACK_IMPORTED_MODULE_2_vant_es_dialog__["a" /* default */].confirm({
                title: '启用账号确认',
                message: '\u786E\u8BA4\u542F\u7528\u8D26\u53F7-' + this.userName + '-' + this.userPhone + '\u5417\uFF1F'
            })
            // 点击确认
            .then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.SHOP_USER_UPDATE, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                        'phone': _this2.userPhone,
                                        'shopId': _this2.shopId,
                                        'status': 1,
                                        'userId': _this2.userId,
                                        'userName': _this2.userName
                                    })
                                });

                            case 2:
                                data = _context2.sent;

                                if (data && data.code === '200') {
                                    _this2.show = false;
                                    tuhu.toast(data.message || '操作成功');
                                    _this2.getUserManagementInfo();
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            })))
            // 点击取消
            .catch(function () {});
        },

        // 禁用
        onSelect2: function onSelect2(item) {
            var _this3 = this;

            // 确认框
            __WEBPACK_IMPORTED_MODULE_2_vant_es_dialog__["a" /* default */].confirm({
                title: '禁用账号确认',
                message: '\u786E\u8BA4\u7981\u7528\u8D26\u53F7-' + this.userName + '-' + this.userPhone + '\u5417\uFF1F'
            }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.SHOP_USER_UPDATE, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                        'phone': _this3.userPhone,
                                        'shopId': _this3.shopId,
                                        'status': 0,
                                        'userId': _this3.userId,
                                        'userName': _this3.userName
                                    })
                                });

                            case 2:
                                data = _context3.sent;

                                if (data && data.code === '200') {
                                    _this3.show = false;
                                    tuhu.toast(data.message || '操作成功');
                                    _this3.getUserManagementInfo();
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))).catch(function () {});
        },

        // 删除
        onSelect3: function onSelect3(item) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                // 确认框
                                __WEBPACK_IMPORTED_MODULE_2_vant_es_dialog__["a" /* default */].confirm({
                                    title: '删除账号确认',
                                    message: '\u786E\u8BA4\u5220\u9664\u8D26\u53F7-' + _this4.userName + '-' + _this4.userPhone + '\u5417\uFF1F'
                                }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
                                    var data;
                                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _context4.next = 2;
                                                    return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_5__configs_config__["a" /* default */].apis.SHOP_USER_UPDATE, {
                                                        method: 'post',
                                                        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                                                            'phone': _this4.userPhone,
                                                            'shopId': _this4.shopId,
                                                            'status': 2,
                                                            'userId': _this4.userId,
                                                            'userName': _this4.userName
                                                        })
                                                    });

                                                case 2:
                                                    data = _context4.sent;

                                                    if (data && data.code === '200') {
                                                        _this4.show = false;
                                                        tuhu.toast(data.message || '操作成功');
                                                        _this4.getUserManagementInfo();
                                                    } else {
                                                        tuhu.toast(data.message || '网络错误');
                                                    }

                                                case 4:
                                                case 'end':
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this4);
                                }))).catch(function () {});

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this4);
            }))();
        },
        handleClick: function handleClick(item) {
            tuhu.navigateTo({
                url: item.url
            });
        },
        onPageBack: function onPageBack() {
            this.getUserManagementInfo();
        }
    }
});

/***/ }),

/***/ "y+7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lazy_vue__ = __webpack_require__("HpBV");
// /**
//  * author: 582196894@qq.com
//  * date: 2017/10/17
//  * desc: 图片懒加载
//  * docs: https://github.com/hilongjw/vue-lazyload
//  * eg: <img :show-width="300" v-lazy="imgUrl"/>
//  */
// // import VueLazyload from 'vue-lazyload'

// import loadImg from '../imgs/hu.png'

// const photos = []

// let ratio = 2

// let preload = 1

// let fontSize = 20

// $(function() {
//   fontSize = parseInt($('html').css('font-size')) || 20
// })

// tuhu.getDeviceDetail().then((data) => {
//   if (data && data.netWork !== 'wifi') {
//     ratio = 1.5
//   }
// })

// function getHeight(fromSrc, width) {
//   const src = fromSrc.replace(/@.+/, '')
//   let match = src.match(/(\d+)w_(\d+)h/)
//   if (!match) {
//     match = src.match(/w(\d+)_h(\d+)/)
//   }

//   if (match) {
//     const ratioHeight = width * (match[2] / match[1])
//     return [Math.ceil(ratioHeight / 10) * 10 * ratio, parseInt(ratioHeight)]
//   }

//   match = fromSrc.match(/(\d+)w_(\d+)h/)
//   if (!match) {
//     match = fromSrc.match(/w(\d+)_h(\d+)/)
//   }

//   if (match) {
//     const ratioHeight = width * (match[2] / match[1])
//     return [Math.ceil(ratioHeight / 10) * 10 * ratio, parseInt(ratioHeight)]
//   }

//   return false
// }

// function getSrc(src, height) {
//   src = src.replace(/@.+/, '')
//   const type = src.match(/\.([^.]+)$/)[1]

//   if (type === 'gif') {
//     src += '?@' + height + 'h_99q.src'
//   } else {
//     src += '@' + height + 'h_99q.' + type
//   }

//   return src.replace('image.tuhu.cn', 'img1.tuhu.org').replace(/https?/, 'https').replace(/img\d\./, 'img1.').replace(/\.(?:webp|png)$/, '.jpg')
// }

// function onScroll(scrollDom, wrap, attrs, scrollHandle) {
//   const {top: scrollTop, height: scrollHeight} = scrollDom.offset()

//   const offset = wrap.offset()
//   const checkTop = offset.top - scrollTop + (offset.height / 2)

//   if (checkTop >= -(preload * scrollHeight) && checkTop <= (preload + 1) * scrollHeight) {
//     imgLoad(wrap, attrs, scrollHandle, scrollDom)
//   }
// }

// function imgLoad(wrap, attrs, scrollHandle, scrollDom) {
//   console.log(134214327777)
//   let obj = wrap.find('img')
//   let hasWrap = true
//   if (obj.length < 1) {
//     obj = wrap
//     hasWrap = false
//   }

//   obj.attr('src', attrs.realsrc)

//   obj.on('load', function() {
//     scrollDom.off(scrollHandle)
//     $(this).removeAttr('width')

//     Object.keys(attrs).forEach((item, index) => {
//       if (['realsrc', 'src'].indexOf(item) < 0) {
//         $(this).attr(item, attrs[item])
//       }
//     })

//     if (hasWrap) {
//       if (wrap === null) {
//         debugger
//       }

//       const width = wrap.width()
//       width && $(this).width(width).height(wrap.height())

//       wrap.after($(this)).remove()
//       wrap = null
//     }
//   })

//   obj.on('error', function() {
//     if (!obj._count) {
//       obj._count = 1
//       imgLoad(wrap, attrs)
//     }
//   })
// }

// function getScrollDom(el) {
//   let parentNode = el

//   do {
//     let style = window.getComputedStyle(parentNode)

//     const overflow = style['overflow-y']

//     if ((overflow === 'auto' || overflow === 'scroll')) {
//       break
//     }

//     style = window.getComputedStyle(parentNode.parentNode)
//     if (!style) {
//       break
//     }

//     parentNode = parentNode.parentNode
//   } while (parentNode)

//   return parentNode
// }

// function lozyLoad(el, arg) {
//   let {src, width} = arg.value
//   if (!src) {
//     return
//   }
//   let wrap = null
//   let height = 0

//   let timeout = null
//   let scrollDom = $(getScrollDom(el))
//   const attrs = {}

//   const match = (width + '').match(/(\d+)%$/)
//   if (match) {
//     width = parseInt(match[1] * window.innerWidth / 100)
//   } else if (width) {
//     width = parseInt(width * fontSize)
//   }

//   Array.prototype.slice.call(el.attributes).forEach((item) => {
//     attrs[item] = el.getAttribute(item)
//   })
//   const scrollHandle = function() {
//     clearTimeout(timeout)

//     timeout = setTimeout(() => {
//       onScroll($(this), wrap, attrs, scrollHandle)
//     }, 100)
//   }

//   scrollDom.on('scroll', scrollHandle)

//   if (width) {
//     // throw new Error(`${src} 没有指定显示区域的宽度, 请添加width属性`)
//     height = getHeight(src, width)
//     if (height) {
//       // throw new Error(`${src} 没有指定图片的原始宽高`)
//       attrs.realsrc = getSrc(src, height[0])

//       $(el)
//       .css('width', '1.3rem')
//       .css('height', '1.3rem')
//       .attr('src', loadImg)

//       $(el).wrap(`<div style="width: ${width}px; height: ${height[1]}px; display:-webkit-flex; display:flex; -webkit-justify-content: center; justify-content: center; -webkit-align-items: center; align-items: center;"></div>`)
//       wrap = $(el).parent()

//       return onScroll(scrollDom, wrap, attrs, scrollHandle)
//     }
//   }

//   if (!height) {
//     attrs.realsrc = src
//     $(el)
//     .attr('src', loadImg)

//     wrap = $(el)
//     return onScroll(scrollDom, wrap, attrs, scrollHandle)
//   }
// }

// Vue.directive('lazy', {
//   update(el, arg) {
//     if (arg.value.src !== arg.oldValue.src) {
//       lozyLoad(el, arg)
//     }
//   },
//   inserted(el, arg) {
//     lozyLoad(el, arg)
//     const group = arg.value.group
//     const fromSrc = arg.value.src
//     let imageIndex = 0

//     $(el).on('click', () => {
//       if (photos[group]) {
//         tuhu.photoBrowser({
//           photos: photos[group]
//         }, {
//           index: imageIndex
//         })
//       }
//     })

//     if (group !== undefined) {
//       if ((group + '').indexOf('group_') < 0) {
//         throw new Error(`group属性非法，请调用tuhu.util.getGroup()生成`)
//       }
//       if (!photos[group]) {
//         photos[group] = []
//       }
//       imageIndex = photos[group].length

//       let src = fromSrc
//       const height = getHeight(src, window.innerWidth)
//       if (height) {
//         src = getSrc(src, height[0])
//       }

//       photos[group].push(src)
//     }
//   }
// })


function bindVue(el, arg) {
  var replaceEl = el;

  if (el.__vue__) {
    replaceEl = el.__vue__.$el;
    el.__vue__.$destroy();
  }

  arg.value.src && new Vue({
    el: replaceEl,
    render: function render(createElement) {
      return createElement(__WEBPACK_IMPORTED_MODULE_0__components_lazy_vue__["a" /* default */], {
        props: {
          el: el,
          src: arg.value.src,
          width: arg.value.width,
          forceHeight: arg.value.height, // 强制高度
          group: arg.value.group
        }
      });
    }
  });
}

Vue.directive('lazy', {
  update: function update(el, arg) {
    if (arg.value.src && arg.value.src.replace(/\/\/img\d/, '') !== arg.oldValue.src.replace(/\/\/img\d/, '')) {
      bindVue(el, arg);
    }
  },
  inserted: function inserted(el, arg) {
    arg.value.src && bindVue(el, arg);
  }
});

/***/ }),

/***/ "yTAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * params
 * other: {
 *    data: data
 *    type: city date
 *    level: 2 3
 * }
 */
// let instance = null

var Picker = function () {
	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Picker, null, [{
		key: 'initPicker',
		value: function initPicker() {
			var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object;
			var other = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object;

			// default params
			other = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
				level: 3
			}, other);

			return new Picker()._pickerRouter(params, other);
		}
	}]);

	function Picker() {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Picker);

		// util
		this.util = {};
		// 省
		this.provinces = [];
		this.currentProvince = '';
		this.cpId = 0;
		// 市
		this.initCities = [];
		this.currentCity = '';
		this.ccId = 0;
		// 区
		this.initDistricts = [];
		this.currentDistrict = '';
		this.cdId = '';
		// timer
		this.t = null;
		this.t2 = null;
		// filterCity
		this.filterCity = ['请选择', '上海市', '北京市', '天津市', '重庆市'];
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Picker, [{
		key: '_pickerRouter',
		value: function _pickerRouter(params, other) {
			if (other.type === 'city') {
				this._cityPickerUtil(params, other.data, other.level);
				return this._cityPicker(params, other.data, other.level);
			} else if (other.type === 'date') {
				this._datePicker();
			}
		}
	}, {
		key: '_cityPicker',
		value: function _cityPicker(params, data, level) {
			var res = null;
			var $this = this;
			// 默认值
			var initValue = params.cityValue || [];
			if (level === 3) {
				this.provinces = data && data.map(function (v) {
					return v.ProviceName;
				});
				this.currentProvince = initValue[0] || this.provinces[0];
				this.initCities = this.currentProvince && this.util._getCities(this.currentProvince);
				this.currentCity = initValue[1] || this.initCities[0];
				this.initDistricts = this.currentCity && this.util._getDistricts(this.currentProvince, this.currentCity) || ['请选择'];
				this.currentDistrict = initValue[2] || this.initDistricts[0];
				res = {
					cssClass: 'city-picker',
					rotateEffect: false,
					cols: [{
						textAlign: 'center',
						values: this.provinces,
						cssClass: 'col-province'
					}, {
						textAlign: 'center',
						values: this.initCities,
						cssClass: 'col-city'
					}, {
						textAlign: 'center',
						values: this.initDistricts,
						cssClass: 'col-district'
					}],
					onChange: function onChange(picker) {
						// 选中的市
						var newProvince = picker.value[0];
						// 选中的省
						var newCity = picker.value[1];
						// 选中的区
						var newDistrict = picker.value[2];
						picker.$city = $this.util._getRegionId(newProvince, newCity, newDistrict);
						if (newProvince !== $this.currentProvince) {
							clearTimeout($this.t);

							$this.t = setTimeout(function () {
								$this.currentProvince = newProvince;
								var newCities = $this.util._getCities(newProvince);
								newCity = newCities[0];
								$this.currentCity = newCity;
								var newDistricts = $this.util._getDistricts(newProvince, newCity);
								$this.currentDistrict = newDistrict;
								picker.cols[1].replaceValues(newCities);
								picker.cols[2].replaceValues(newDistricts);
								picker.updateValue();
							}, 200);
						} else {
							newCity = picker.cols[1].value;
							if ($this.currentCity !== newCity) {
								picker.cols[2].replaceValues($this.util._getDistricts(newProvince, newCity));
								$this.currentDistrict = newDistrict;
								$this.currentCity = newCity;
								picker.updateValue();
							} else {
								if ($this.currentDistrict !== newDistrict) {
									// 所有change都会进入这里
									clearTimeout($this.t2);

									$this.t2 = setTimeout(function () {
										picker.$city = $this.util._getRegionId(newProvince, newCity, newDistrict);
									}, 200);
								}
							}
						}
					}
				};
			} else if (level === 2) {
				this.provinces = data && data.map(function (v) {
					return v.ProviceName;
				});
				this.currentProvince = initValue[0] || this.provinces[0];
				this.initCities = this.currentProvince && this.util._getCities(this.currentProvince);
				this.currentCity = initValue[1] || this.initCities[0];
				res = {
					cssClass: 'city-picker',
					rotateEffect: false,
					cols: [{
						textAlign: 'center',
						values: this.provinces,
						cssClass: 'col-province'
					}, {
						textAlign: 'center',
						values: this.initCities,
						cssClass: 'col-city'
					}],
					onChange: function onChange(picker) {
						// 选中的市
						var newProvince = picker.value[0];
						// 选中的省
						var newCity = picker.value[1];
						picker.$city = $this.util._getRegionId(newProvince, newCity);
						if (newProvince !== $this.currentProvince) {
							clearTimeout($this.t);

							$this.t = setTimeout(function () {
								$this.currentProvince = newProvince;
								var newCities = $this.util._getCities(newProvince);
								newCity = newCities[0];
								// currentCity = newCity
								picker.cols[1].replaceValues(newCities);
								picker.updateValue();
							}, 200);
						} else {
							newCity = picker.cols[1].value;
							if ($this.currentCity !== newCity) {
								$this.currentCity = newCity;
								// 所有change都会进入这里
								clearTimeout($this.t);

								$this.t = setTimeout(function () {
									picker.$city = $this.util._getRegionId(newProvince, newCity);
								}, 200);
							}
						}
					}
				};
			}
			if (initValue.length > 0) {
				res['value'] = [this.currentProvince, this.currentCity, this.currentDistrict];
			}
			return res;
		}
	}, {
		key: '_datePicker',
		value: function _datePicker() {
			// TODO
		}
	}, {
		key: '_cityPickerUtil',
		value: function _cityPickerUtil(params, data, level) {
			var _this = this;

			this.util._loopArr = function (arr) {
				return arr.map(function (v) {
					return v.CityName;
				});
			};
			this.util._getRegionId = function (newProvince, newCity, newDistrict) {
				data.some(function (v) {
					if (v.ProviceName === newProvince) {
						_this.cpId = v.RegionID;
						v.CityList.some(function (v) {
							if (v.CityName === newCity) {
								_this.ccId = v.RegionID;
								newDistrict && v.AreaList.some(function (v) {
									if (v.CityName === newDistrict) {
										_this.cdId = v.RegionID;
										return true;
									}
								});
								return true;
							}
						});
						return true;
					}
				});
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ 'province': newProvince, 'provinceRegionId': _this.cpId }, { 'city': newCity, 'cityRegionId': _this.ccId }, newDistrict ? { 'district': newDistrict, 'districtRegionId': _this.cdId } : {});
			};
			this.util._getCities = this._initUtilCity(data, level);
			this.util._getDistricts = this._initUtilDistricts(data, level);
		}
	}, {
		key: '_initUtilCity',
		value: function _initUtilCity(data, level) {
			var _this2 = this;

			if (level === 3) {
				return function (newProvince) {
					var result = [];
					data.some(function (v) {
						if (v.ProviceName === newProvince) {
							// cpId = v.RegionID
							result = _this2.util._loopArr(v.CityList);
							return true;
						}
					});
					return result;
				};
			} else if (level === 2) {
				return function (newProvince) {
					var result = [];
					data.some(function (v, i) {
						if (v.ProviceName === newProvince) {
							// includes 在微信pc客户端下 不兼容 导致2级城市列表面板调不起来
							if (v.CityList.length === 1 && _this2.filterCity.includes(newProvince)) {
								result = _this2.util._loopArr(v.CityList[0].AreaList);
							} else {
								result = _this2.util._loopArr(v.CityList);
							}
							return true;
						}
					});
					return result;
				};
			}
		}
	}, {
		key: '_initUtilDistricts',
		value: function _initUtilDistricts(data, level) {
			var _this3 = this;

			if (level === 3) {
				return function (newProvince, newCity) {
					var result = [];
					data.some(function (v) {
						if (v.ProviceName === newProvince) {
							// cpId = v.RegionID
							v.CityList.some(function (v) {
								if (v.CityName === newCity) {
									// ccId = v.RegionID
									result = _this3.util._loopArr(v.AreaList);
									return true;
								}
							});
							return true;
						}
					});
					return result;
				};
			}
		}
	}]);

	return Picker;
}();

/* harmony default export */ __webpack_exports__["a"] = (Picker);

/***/ }),

/***/ "yU4Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yXvx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ylj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            shopId: '',
            shopServiceData: {},
            serveUplineData: {},
            serveDownlineData: {},
            active: 0,
            tabList1: [{
                name: '关闭服务',
                url: '/pages/shopServeClose/index'
            }],
            clickTabTitle: '',
            clickTabIndex: 0
            // isDisabled: true
        };
    },

    computed: {
        currentShopInfo: function currentShopInfo() {
            return tuhu.store.state.currentShopInfo;
        }
    },
    created: function created() {
        this.getServeInfo();
    },

    methods: {
        getServeInfo: function getServeInfo() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roleData, data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GET_USERINFO);

                            case 2:
                                roleData = _context.sent;

                                if (roleData && roleData.code === '200') {
                                    _this.shopId = roleData.data.shopId;
                                } else {
                                    tuhu.toast(roleData.message || '获取权限信息失败');
                                }
                                // 服务列表
                                _context.next = 6;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SERVICE_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        shopId: _this.shopId,
                                        signStatus: null
                                    })
                                });

                            case 6:
                                data = _context.sent;

                                if (data && data.code === '200') {
                                    _this.shopServiceData = data.data;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        // tab切换请求
        onClickTabs: function onClickTabs(i, title) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data, _data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.clickTabTitle = title;
                                console.log(i, title);
                                // if (JSON.stringify(this.serveUplineData) === '{}' && this.clickTabTitle === '已上线' && this.clickTabIndex !== 1) {

                                if (!(_this2.clickTabTitle === '已上线' && _this2.clickTabIndex !== 1)) {
                                    _context2.next = 9;
                                    break;
                                }

                                _context2.next = 5;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SERVICE_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        shopId: _this2.shopId,
                                        signStatus: 1
                                    })
                                });

                            case 5:
                                data = _context2.sent;

                                if (data && data.code === '200') {
                                    _this2.serveUplineData = data.data;
                                } else {
                                    tuhu.toast(data.message || '网络错误');
                                }
                                // } else if (JSON.stringify(this.serveDownlineData) === '{}' && this.clickTabTitle === '已下线' && this.clickTabIndex !== 2) {
                                _context2.next = 14;
                                break;

                            case 9:
                                if (!(_this2.clickTabTitle === '已下线' && _this2.clickTabIndex !== 2)) {
                                    _context2.next = 14;
                                    break;
                                }

                                _context2.next = 12;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.SERVICE_LIST, {
                                    method: 'post',
                                    body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                                        shopId: _this2.shopId,
                                        signStatus: 0
                                    })
                                });

                            case 12:
                                _data = _context2.sent;

                                if (_data && _data.code === '200') {
                                    _this2.serveDownlineData = _data.data;
                                } else {
                                    tuhu.toast(_data.message || '网络错误');
                                }

                            case 14:
                                _this2.clickTabIndex = i;

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleClick1: function handleClick1(item, index) {
            var i = index;
            // this.isDisabled = false
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ServeInfo: this.shopServiceData[i] || {}
                }
            });
        },
        handleClick2: function handleClick2(item, index) {
            var i = index;
            // this.isDisabled = false
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ServeInfo: this.serveUplineData[i] || {}
                }
            });
        },
        handleClick3: function handleClick3(item, index) {
            var i = index;
            // this.isDisabled = false
            tuhu.navigateTo({
                url: item.url,
                data: {
                    ServeInfo: this.serveDownlineData[i] || {}
                }
            });
        },
        onPageBack: function onPageBack() {
            this.getServeInfo();
        }
    }
});

/***/ }),

/***/ "ypDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yy/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_dialog_style__ = __webpack_require__("XmAh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_dialog__ = __webpack_require__("il3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_config__ = __webpack_require__("65XL");


 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            active: 0,
            activeId: 0,
            activeIndex: 0,
            items: [],
            value: 0,
            configData: {},
            // disable: true,
            czlass: 'cz',
            arrow: 'arrow-up',
            goodsListd: [],
            goodsLists: [],
            serName: '',
            amount: 0,
            amounts: 0,
            showMob: false,
            phone: '',
            channelcode: '',
            shopid: '',
            inputDis: false
        };
    },
    mounted: function mounted() {
        // let vConsole = new VConsole()
        // alert(location.pathname)
    },

    //       beforeRouteEnter(to, from, next) {
    //     if (to.path !== location.pathname) {
    //          location.assign(to.fullPath) 
    //          console.log(to.path, location.pathname)
    //     } else {
    //         next()
    //     }
    // },
    methods: {
        init: function init() {
            this.channelcode = tuhu.getParam('channelcode');
            this.shopid = tuhu.getParam('shopid');
        },

        //   首页商品配置
        indexConfig: function indexConfig() {
            var _this = this;

            var channelcode = tuhu.getParam('channelcode');
            var shopid = tuhu.getParam('shopid');
            tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.INDEX_CONFIG + '/' + channelcode + '/' + shopid).then(function (data) {
                if (data && data.code === '200') {
                    _this.configData = data.data;
                    if (data.data.pageTitle && data.data.pageTitle !== null) {
                        document.title = data.data.pageTitle;
                    } else {
                        document.title = '\u200E'; // 根据后台返回字段修改页面title
                    }
                    console.log(document.title, 'sdsds');
                } else {
                    tuhu.toast(data.message || '网络错误');
                }
            }).catch(
            //   () => {
            // tuhu.toast('查询商品时出错')
            function (error) {
                return console.error('Error:', error);
            }
            //   }
            );
        },

        //   商品列表
        goodsList: function goodsList() {
            var _this2 = this;

            var channelcode = tuhu.getParam('channelcode');
            var shopid = tuhu.getParam('shopid');
            tuhu.fetch(__WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GOOD_LISTS + '/' + channelcode + '/' + shopid).then(function (data) {
                if (data && data.code === '200') {
                    data.data.map(function (item, index) {
                        _this2.items.push({
                            text: item.goodsClassification,
                            activeId: index
                        });
                        _this2.goodsLists.push({
                            list: item.goodsDtos,
                            id: index,
                            name: item.goodsClassification
                        });
                        _this2.goodsListd = _this2.goodsLists[0].list;
                        _this2.serName = _this2.goodsLists[0].name;
                    });
                } else {
                    tuhu.toast(data.message || '网络错误');
                }
            }).catch(
            //   () => {
            // tuhu.toast('查询商品时出错')
            function (error) {
                return console.error('Error:', error);
            }
            //   }
            );
        },

        //   左侧点击
        navClick: function navClick(index) {
            var _this3 = this;

            var activeId = this.items[index].activeId;
            this.goodsLists.map(function (item, index) {
                if (item.id === activeId) {
                    _this3.goodsListd = item.list;
                    _this3.serName = item.name;
                }
            });
            console.log(this.goodsListd);
        },

        //   操作手册控制
        animh: function animh() {
            if (this.czlass === 'cz') {
                this.czlass = 'cz1';
                this.arrow = 'arrow-down';
            } else {
                this.czlass = 'cz';
                this.arrow = 'arrow-up';
            }
        },
        dialog: function dialog() {
            __WEBPACK_IMPORTED_MODULE_2_vant_es_dialog__["a" /* default */].alert({
                title: '提示',
                allowHtml: true,
                // 修复：原代码 v-call 在字符串中不生效（Vue指令不会编译动态HTML），点击无法拨号
                // 改用原生 onclick 实现拨号功能
                message: '您暂未开通此服务，\n如需开通请联系：' + '<i onclick="window.location.href=\'tel:400-176-8848\'" style="color: #016EEF">400-176-8848</i>'
            }).then(function () {
                // on close
            });
        },

        //   提交显示输入手机号
        showMobs: function showMobs() {
            this.showMob = true;
            this.inputDis = false;
        },

        //   提交订单
        submit: function submit() {
            var _this4 = this;

            this.inputDis = true;
            var newBackUrl = window.location.href;
            tuhu.sessionStorage.setItem('newBackUrl', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newBackUrl));
            //   let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
            //   if (!reg.test(this.phone)) {
            //       tuhu.toast('请输入正确的手机号', 500)
            //       this.inputDis = false
            //   } else {
            //     this.inputDis = true  // 重复点击限制
            var params = {
                channelCode: this.channelcode,
                goodsDto: [],
                goodsPriceTotal: this.totalPrice,
                mobile: '13000000000',
                orderNote: '',
                shopName: this.configData.shopName,
                vehicleName: '',
                verifyCode: '',
                submitShopId: this.shopid,
                projectDetailId: this.configData.projectDetailId,
                pageType: '1' // 页面类型
            };
            JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.goodsLists)).forEach(function (good) {
                // 深拷贝一下 不改变计算价格值
                good.list.forEach(function (item) {
                    if (item.buySum > 0) {
                        // item.goodsPrice = item.buySum * item.goodsPrice
                        params.goodsDto.push(item);
                    }
                });
            });
            // 传参里商品价格为总计
            params.goodsDto.forEach(function (item) {
                if (item.buySum > 0) {
                    item.goodsPrice = (item.buySum * item.goodsPrice).toFixed(2);
                }
            });
            tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_3__configs_config__["a" /* default */].apis.GOOD_SUBMIT, {
                method: 'post',
                body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
            }).then(function (data) {
                if (data.code === '200') {
                    // this.showMob = false
                    tuhu.sessionStorage.setItem('shopBill', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.data));
                    var queryList = {
                        goodsOrderId: data.data.goodsOrderId,
                        goodsPriceTotal: _this4.totalPrice,
                        channelCode: _this4.channelcode,
                        shopName: _this4.configData.shopName
                    };
                    tuhu.sessionStorage.setItem('queryList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(queryList));
                    //    tuhu.navigateTo({
                    //         url: '/pages/cashiers/index'
                    //     })
                    // IOS下微信扫一扫需要刷新地址
                    window.location.href = 'http://m.hzqmtech.com/shop/pages/cashiers/index';
                    // window.location.href = 'http://www.xiaokunkeji.com/shop/pages/cashiers/index'
                } else {
                    tuhu.toast(data.message || '网络错误');
                    _this4.inputDis = false;
                }
            }).catch(function (error) {
                return console.error('Error:', error);
            });

            console.log(params);
        }
        //   }

    },
    computed: {
        //   价格计算
        totalPrice: function totalPrice() {
            var total = 0;
            this.goodsLists.forEach(function (good) {
                good.list.forEach(function (item) {
                    total += item.goodsPrice * item.buySum;
                });
            });
            return total.toFixed(2);
        },
        disable: function disable() {
            if (this.totalPrice > 0) {
                return false;
            } else {
                return true;
            }
        }
    },
    created: function created() {
        var md = navigator.userAgent;
        // 品牌
        // this.brand = md.mobile()
        console.log(md, '2323');
        this.indexConfig();
        this.goodsList();
        this.init();
    }
});

/***/ }),

/***/ "yyDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCamera)?_c('div',{staticClass:"upload-content"},[_c('div',{staticClass:"upload-cont"},[_c('div',{staticClass:"upload-cont-title"},[_vm._v("\n      请选择您上传资料的方式\n      "),_c('div',{staticClass:"close-btn",on:{"click":function($event){return _vm.closeModal()}}})]),_vm._v(" "),_c('div',{staticClass:"upload-cont-btn-top",on:{"click":function($event){return _vm.triggerFileInput('image')}}},[_c('div',{staticClass:"upload-icon"}),_vm._v(" "),_c('label',{staticClass:"upload-text"},[_vm._v("扫描（拍照或照片）")]),_vm._v(" "),_c('input',{ref:"imageInput",attrs:{"id":"imageInput","type":"file","accept":"image/*"},on:{"change":_vm.handleImageUpload}})]),_vm._v(" "),_c('div',{staticClass:"upload-cont-btn-bottom",on:{"click":function($event){return _vm.triggerFileInput('file')}}},[_c('div',{staticClass:"upload-icon"}),_vm._v(" "),_c('label',{staticClass:"upload-text"},[_vm._v("文件（PDF文件）")]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"id":"fileInput","type":"file","accept":".pdf"},on:{"change":_vm.handleFileUpload}})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yz1R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/msz.48ff21b.png";

/***/ }),

/***/ "z+E+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("h731");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03880a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("EyY9");
function injectStyle (ssrContext) {
  __webpack_require__("D1fO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03880a42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03880a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z4ei":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zA4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyPoints_vue__ = __webpack_require__("EhoZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7db5dae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyPoints_vue__ = __webpack_require__("faWO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerifyPoints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7db5dae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerifyPoints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zEXB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zG/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2QzO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a11062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("zxoh");
function injectStyle (ssrContext) {
  __webpack_require__("ujE5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26a11062"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a11062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zS2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_day_vue__ = __webpack_require__("g4ZZ");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007be978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_day_vue__ = __webpack_require__("wet0");
function injectStyle (ssrContext) {
  __webpack_require__("0+DV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-007be978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_day_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007be978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_day_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zlD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_citypicker_vue__ = __webpack_require__("JKBa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d173cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_citypicker_vue__ = __webpack_require__("fKu8");
function injectStyle (ssrContext) {
  __webpack_require__("XYcx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84d173cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_citypicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84d173cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_citypicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zoak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_platen__ = __webpack_require__("8YRT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ttButton__ = __webpack_require__("bPVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__configs_config__ = __webpack_require__("65XL");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var carParams = {
    province: '沪',
    provinces: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣', '闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂', '琼', '青', '新', '藏', '港', '澳'],
    carNo: '',
    showAllProv: false,
    showNoBoard: false
};
/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ttButton: __WEBPACK_IMPORTED_MODULE_6__components_ttButton__["a" /* default */],
        platen: __WEBPACK_IMPORTED_MODULE_5__components_platen__["a" /* default */]
    },
    data: function data() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
            safeCheckResultAdvise: '',
            lock: false,
            isOnlineSign: true, //客户签名是否选择在线签名
            isCheck: true, //全部通过
            validateCarNo: null, //需要验证的车牌号码
            orcCarNo: null, // OCR识别到的车牌号码
            showOrcCarNoTip: false,
            uploadDetail: {},
            sId: '',
            vCode: ''
        }, carParams, {
            showPupup: false,
            imgType: '',
            orderType: '',
            showALL: false,
            signatureType: 1, // 签名类型 1在线 2图片
            signatureUrl: '', //签名图片url
            safeCheckContent: [{
                checkId: 1,
                checkName: "发动机检测",
                checkContent: "机油量、防冻液、空气格、水箱、火花塞等",
                pass: 1
            }, {
                checkId: 2,
                checkName: "变速器检测",
                checkContent: "变速箱油量；变速箱换挡平顺性；档位性能",
                pass: 1
            }, {
                checkId: 3,
                checkName: "转向系统检测",
                checkContent: "四轮定位、助力油、平衡杆球头及衬套、方向机及防尘套等",
                pass: 1
            }, {
                checkId: 4,
                checkName: "底盘检测",
                checkContent: "减震器及顶胶、方向机、拉杆球头等",
                pass: 1
            }, {
                checkId: 5,
                checkName: "汽车玻璃检测",
                checkContent: "划痕、破损、检查天窗等",
                pass: 1
            }, {
                checkId: 6,
                checkName: "汽车电子系统检测",
                checkContent: "仪表灯、灯光、喇叭、雨刷等",
                pass: 1
            }, {
                checkId: 7,
                checkName: "车内环境检测",
                checkContent: "备箱灯、遮阳板灯光、阅读灯、安全带等",
                pass: 1
            }, {
                checkId: 8,
                checkName: "轮胎检测",
                checkContent: "轮胎裂纹、钉子、轮盖等",
                pass: 1
            }, {
                checkId: 9,
                checkName: "蓄电池检测",
                checkContent: "电池线路老化检测、蓄电池电压检测",
                pass: 1
            }, {
                checkId: 10,
                checkName: "车辆综合安全检测",
                checkContent: "驾驶室及车身部分、发动机部分、底盘部分",
                pass: 1
            }],
            carWashList: {
                'NO_APPOINTMENT_SHOP_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'SHOP_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'LACQURE_SHOP_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'puttyingPhoto',
                    text: '刮腻子照片',
                    required: true,
                    isShow: 'puttyingPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'MAINTAIN_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'vehicleOilPhoto',
                    text: '使用的机油与车辆合影照片',
                    required: true,
                    isShow: 'isVehicleOilPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'MICRO_REPAIR_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'puttyingPhoto',
                    text: '刮腻子照片',
                    required: false,
                    isShow: 'puttyingPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'RESERVE_SHOP': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'NO_RESERVE_SHOP_SERVICE': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }]
            },
            photoMap: {
                isVinPhoto: false, //车架号图片
                isVehicleWorkingPhoto: false, //车辆与门店合照
                isVehicleOilPhoto: false, //机油和车辆合照
                isBeforeWorkPhoto: false, //  作业前照片
                isAfterWorkPhoto: false, //  作业后照片
                isWorkingPhoto: false, // 作业中照片
                isWorkOrderPhoto: false, // 工单照片
                isElseWorkPhoto: false, //其他照片
                carLiftPhoto: false, //车辆在起升架上的照片
                hoodOpenPhoto: false, //引擎盖打开的照片
                puttyingPhoto: false, //刮腻子照片
                safeCheckReport: false //安全检测电子检测报告
            },
            photoList: {
                vinPhoto: '', //车架号图片
                vehicleWorkingPhoto: '', // 显露车牌及车店一体的作业中照片  
                vehicleOilPhoto: '', // 使用的机油与车辆合影照片
                beforeWorkPhoto: '', // 作业前照片
                afterWorkPhoto: '', // 作业后照片
                workingPhoto: '', // 作业中照片
                workOrderPhoto: '', // 工单照片
                elseWorkPhoto: '', // 其他照片
                carLiftPhoto: '', //车辆在起升架上的照片
                hoodOpenPhoto: '', //引擎盖打开的照片
                puttyingPhoto: '' //刮腻子照片
            }
        });
    },
    created: function created() {
        this.uploadDetail = this.options && this.options.uploadDetail ? this.options.uploadDetail : JSON.parse(tuhu.sessionStorage.getItem('upDetail') || null);
        this.photoMap = JSON.parse(this.uploadDetail.photoMap);
        var serviceGroupId = this.uploadDetail.serviceGroupId;
        var checkType = this.uploadDetail.checkType;
        //10项对应的分组ID=86标准安全检测，第3项的描述说明有：四轮定位,18项对应的分组ID=73快捷安全检测，第3项的描述说明没有：四轮定位
        if (serviceGroupId === 73 && checkType === 2) {
            var foundItem = this.safeCheckContent.find(function (item) {
                return item.checkId === 3;
            });
            if (foundItem) {
                foundItem.checkContent = '助力油、平衡杆球头及衬套、方向机及防尘套等';
            }
        }
        this.sId = tuhu.getParam('sId');
        this.vCode = tuhu.getParam('vCode');
        this.validateCarNo = tuhu.getParam('carNo');
        this.isCheckCarNo = tuhu.getParam('isCheckCarNo') === '1';
        this.orderType = this.uploadDetail.orderType;
    },
    mounted: function mounted() {
        var _this = this;

        // 监听在线签名的图片URL
        window.addEventListener('message', function (event) {
            if (event.data) {
                _this.$set(_this, 'signatureUrl', event.data);
            }
        });
    },

    computed: {
        filteredSafeCheckContent: function filteredSafeCheckContent() {
            return this.showALL ? this.safeCheckContent : this.safeCheckContent.slice(0, 3);
        },

        //防止盒子多余渲染影响页面布局
        filteredCarWashList: function filteredCarWashList() {
            var _this2 = this;

            var photoList = this.carWashList[this.orderType].map(function (item) {
                if (item.imgType === 'vinPhoto' && _this2.photoMap['isVehicleWorkingPhoto']) {
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, item, {
                        required: _this2.photoMap['isVinPhoto'] ? true : false,
                        isShow: 'isVehicleWorkingPhoto'
                    });
                }
                return item; // 其他项保持不变
            });

            return this.orderType && this.photoMap ? photoList.filter(function (item) {
                return _this2.photoMap[item.isShow];
            }) : [];
        }
    },
    methods: {
        //全选通过
        handleCheckAll: function handleCheckAll() {
            this.isCheck = !this.isCheck;
            if (this.isCheck) {
                this.safeCheckContent.forEach(function (item) {
                    item.pass = 1;
                });
            } else {
                this.safeCheckContent.forEach(function (item) {
                    item.pass = 0;
                });
            }
        },

        //单选通过
        handleCheck: function handleCheck(item) {
            item.pass === 1 ? item.pass = 0 : item.pass = 1;
            // 判断是否全选
            var passedItems = this.safeCheckContent.filter(function (item) {
                return item.pass === 1;
            });
            if (passedItems.length === 10) this.isCheck = true;else this.isCheck = false;
        },
        chooseProvince: function chooseProvince(item) {
            this.province = item;
            this.showAllProv = false;
            this.showNoBoard = true;
        },
        chooseCarNo: function chooseCarNo(val) {
            this.carNo = val;
        },
        delect: function delect() {
            this.carNo = this.carNo.slice(0, -1);
        },

        // 跳转在线签名
        toOnlineSign: function toOnlineSign() {
            tuhu.navigateTo({
                url: "/pages/orderDetail/onlineSign"
            });
        },
        upload: function upload(val) {
            if (val && val.code === '200') {
                this.photoList[val.index] = val.data;
            } else {
                tuhu.toast(val.message || '网络错误');
            }
        },

        // 保存签名图片url
        uploadSignature: function uploadSignature(val) {
            if (val && val.code === '200') {
                this.signatureUrl = val.data;
            } else {
                tuhu.toast(val.message || '网络错误');
            }
        },
        sureToOff: function sureToOff() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res, baseParams, params, data, info;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                res = _this3.ckeckImg();

                                if (res) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:
                                if (!_this3.lock) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:

                                _this3.lock = true;

                                _this3.orcCarNo = null;

                                tuhu.showIndicator();
                                _context.prev = 8;


                                //必传项
                                baseParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this3.photoList, {
                                    shopId: _this3.sId,
                                    code: _this3.vCode,
                                    carNo: _this3.validateCarNo,
                                    isOcr: _this3.isCheckCarNo && _this3.photoMap.isVehicleWorkingPhoto ? '1' : '0' //是否需要ocr识别，车店合照需要ocr识别获取车牌号 
                                });
                                params = _this3.photoMap.safeCheckReport ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseParams, {
                                    //根据photoMap.safeCheckReport判断后边的值需不需要传
                                    safeCheckContent: _this3.safeCheckContent,
                                    safeCheckResultAdvise: _this3.safeCheckResultAdvise,
                                    signature: {
                                        signatureType: _this3.signatureType,
                                        signatureUrl: _this3.signatureUrl
                                    }
                                }) : baseParams;
                                _context.next = 13;
                                return tuhu.fetch('' + __WEBPACK_IMPORTED_MODULE_7__configs_config__["a" /* default */].apis.GET_CODE_COUPON, {

                                    method: 'post',

                                    body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params)

                                });

                            case 13:
                                data = _context.sent;

                                if (!(_this3.isCheckCarNo && _this3.photoMap['isVehicleWorkingPhoto'] && data && data.code === '10003')) {
                                    _context.next = 23;
                                    break;
                                }

                                tuhu.hideIndicator();
                                _this3.lock = false;
                                _this3.orcCarNo = data.data.orcCarNo;

                                if (_this3.orcCarNo) {
                                    _context.next = 20;
                                    break;
                                }

                                return _context.abrupt('return', tuhu.toast('车牌识别校验失败，请重新上传能清晰显露车牌及车店的作业中照片' || '网络错误'));

                            case 20:
                                _this3.showOrcCarNoTip = true;
                                _context.next = 24;
                                break;

                            case 23:
                                if (data && data.code === '200') {

                                    tuhu.hideIndicator();

                                    _this3.lock = false;

                                    tuhu.toast('核销成功');

                                    info = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data.data, {
                                        Message: data.message
                                    });


                                    tuhu.sessionStorage.setItem('shopOrderDetail', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(info));

                                    setTimeout(function () {

                                        tuhu.redirectTo({

                                            url: '/pages/orderDetail/index',

                                            data: {

                                                ListInfo: info

                                            },

                                            query: {

                                                success: data.code === '200' ? 1 : ''

                                            }

                                        });
                                    }, 300);
                                } else {

                                    tuhu.hideIndicator();

                                    _this3.lock = false;

                                    tuhu.toast(data.message || '网络错误');
                                }

                            case 24:
                                _context.next = 31;
                                break;

                            case 26:
                                _context.prev = 26;
                                _context.t0 = _context['catch'](8);

                                tuhu.hideIndicator();

                                _this3.lock = false;

                                console.log(_context.t0);

                            case 31:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3, [[8, 26]]);
            }))();
        },
        ckeckImg: function ckeckImg() {

            if (!this.photoList.vinPhoto && this.photoMap.isVinPhoto) return tuhu.toast('请上传车架号图片');

            if (!this.photoList.vehicleWorkingPhoto && this.photoMap.isVehicleWorkingPhoto) return tuhu.toast('请上传显露车牌及车店一体的作业中照片');

            if (!this.photoList.vehicleOilPhoto && this.photoMap.isVehicleOilPhoto) return tuhu.toast('请上传使用的机油与车辆合影照片');

            if (!this.photoList.beforeWorkPhoto && this.photoMap.isBeforeWorkPhoto) return tuhu.toast('请上传作业前照片');

            if (!this.photoList.afterWorkPhoto && this.photoMap.isAfterWorkPhoto) return tuhu.toast('请上传作业后照片');

            if (!this.photoList.workingPhoto && this.photoMap.isWorkingPhoto) return tuhu.toast('请上传作业中照片');

            if (!this.photoList.workOrderPhoto && this.photoMap.isWorkOrderPhoto) return tuhu.toast('请上传工单照片');

            if (!this.photoList.carLiftPhoto && this.photoMap.carLiftPhoto) return tuhu.toast('请上传车辆在起升架上的照片');

            if (!this.photoList.hoodOpenPhoto && this.photoMap.hoodOpenPhoto) return tuhu.toast('请上传引擎盖打开的照片');

            if (!this.safeCheckResultAdvise && this.photoMap.safeCheckReport) return tuhu.toast('请输入安全检测结果建议');

            if (!this.signatureType && this.photoMap.safeCheckReport) return tuhu.toast('请选择签名方式');

            if (!this.signatureUrl && this.photoMap.safeCheckReport) return tuhu.toast('请上传签名');

            if (this.orderType == 'LACQURE_SHOP_ORDER' && this.photoMap.puttyingPhoto && !this.photoList.puttyingPhoto) return tuhu.toast('请上传刮腻子照片');
            return true;
        }
    }
});

/***/ }),

/***/ "zq5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rotateBase64Img; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


var rotateBase64Img = function rotateBase64Img(src, edg, callback) {
  try {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var imgW = 0; // 图片宽度
    var imgH = 0; // 图片高度
    var size = 0; // canvas初始大小

    if (edg % 90 !== 0) {
      throw new Error("旋转角度必须是90的倍数!");
    }

    edg < 0 && (edg = edg % 360 + 360);
    var quadrant = edg / 90 % 4; // 旋转象限
    var cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; // 裁剪坐标

    var image = new Image();
    image.src = src;
    image.crossOrigin = "anonymous";

    image.onload = function () {
      imgW = image.width;
      imgH = image.height;
      size = imgW > imgH ? imgW : imgH;

      canvas.width = size * 2;
      canvas.height = size * 2;
      switch (quadrant) {
        case 0:
          cutCoor.sx = size;
          cutCoor.sy = size;
          cutCoor.ex = size + imgW;
          cutCoor.ey = size + imgH;
          break;
        case 1:
          cutCoor.sx = size - imgH;
          cutCoor.sy = size;
          cutCoor.ex = size;
          cutCoor.ey = size + imgW;
          break;
        case 2:
          cutCoor.sx = size - imgW;
          cutCoor.sy = size - imgH;
          cutCoor.ex = size;
          cutCoor.ey = size;
          break;
        case 3:
          cutCoor.sx = size;
          cutCoor.sy = size - imgW;
          cutCoor.ex = size + imgH;
          cutCoor.ey = size + imgW;
          break;
      }

      ctx.translate(size, size);
      ctx.rotate(edg * Math.PI / 180);
      ctx.drawImage(image, 0, 0);

      var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
      if (quadrant % 2 === 0) {
        canvas.width = imgW;
        canvas.height = imgH;
      } else {
        canvas.width = imgH;
        canvas.height = imgW;
      }
      ctx.putImageData(imgData, 0, 0);

      if (typeof callback === "function") {
        callback(canvas.toDataURL("image/png", 0.7));
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        // 异步操作...
        resolve(canvas.toDataURL("image/png", 0.7));
      });
    };
  } catch (e) {
    console.log(e);
  }
};

/***/ }),

/***/ "zr4H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zxoh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_content"},[(this.userRole === '老板' || this.userRole === '店长' )?_c('div',[_c('van-dropdown-menu',[_c('van-dropdown-item',{ref:"item1",attrs:{"title-class":this.activeMonth ? 'title_active_color active_blue' : '',"title":"按月查询"}},[_c('div',{staticClass:"month_time"},[_c('van-field',{class:_vm.startTimePicker === true ? 'time_color' : '',attrs:{"readonly":"","clickable":"","value":this.monthStartTime || '开始时间',"input-align":"center"},on:{"click":_vm.clickStartTime}}),_vm._v(" "),_c('span',[_vm._v("至")]),_vm._v(" "),_c('van-field',{class:_vm.endTimePicker === true ? 'time_color' : '',attrs:{"readonly":"","clickable":"","input-align":"center","value":this.monthEndTime || '结束时间',"placeholder":"结束日期"},on:{"click":_vm.clickEndTime}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.startTimePicker),expression:"this.startTimePicker"}],staticClass:"month_time_picker"},[_c('van-datetime-picker',{attrs:{"currentDate":this.currentStartTime || '',"type":"year-month","title":"选择年月","show-toolbar":false,"min-date":_vm.minDate,"max-date":_vm.maxDate,"formatter":_vm.formatter1,"visible-item-count":"3","swipe-duration":"150"}}),_vm._v(" "),_c('div',{staticClass:"month_time_picker_btn"},[_c('div',{on:{"click":_vm.cancelStartPicker}},[_vm._v("取消")]),_vm._v(" "),_c('div',{on:{"click":_vm.confirmStartPicker}},[_vm._v("确认")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.endTimePicker),expression:"this.endTimePicker"}],staticClass:"month_time_picker"},[_c('van-datetime-picker',{attrs:{"currentDate":this.currentEndTime || '',"type":"year-month","title":"选择年月","min-date":_vm.minDate,"max-date":_vm.maxDate,"show-toolbar":false,"formatter":_vm.formatter2,"visible-item-count":"3","swipe-duration":"150"}}),_vm._v(" "),_c('div',{staticClass:"month_time_picker_btn"},[_c('div',{on:{"click":_vm.cancelEndPicker}},[_vm._v("取消")]),_vm._v(" "),_c('div',{on:{"click":_vm.confirmEndPicker}},[_vm._v("确认")])])],1)]),_vm._v(" "),_c('van-dropdown-item',{ref:"item2",attrs:{"title-class":this.activeDay ? 'title_active_color active_blue' : '',"title":"按日查询"}},[_c('div',{staticClass:"day_time"},[_c('van-field',{class:_vm.dayStartTimePicker === true ? 'time_color' : '',attrs:{"readonly":"","clickable":"","value":this.dayStartTime || '开始时间',"input-align":"center"},on:{"click":_vm.dayClickStartTime}}),_vm._v(" "),_c('span',[_vm._v("至")]),_vm._v(" "),_c('van-field',{class:_vm.dayEndTimePicker === true ? 'time_color' : '',attrs:{"readonly":"","clickable":"","input-align":"center","value":this.dayEndTime || '结束时间',"placeholder":"结束日期"},on:{"click":_vm.dayClickEndTime}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.dayStartTimePicker),expression:"this.dayStartTimePicker"}],staticClass:"month_time_picker"},[_c('van-datetime-picker',{attrs:{"currentDate":this.dayCurrentStartTime || '',"type":"date","title":"选择年月日","show-toolbar":false,"min-date":_vm.minDate,"max-date":_vm.maxDate,"formatter":_vm.formatter3,"visible-item-count":"3","swipe-duration":"150"}}),_vm._v(" "),_c('div',{staticClass:"month_time_picker_btn"},[_c('div',{on:{"click":_vm.dayCancelStartPicker}},[_vm._v("取消")]),_vm._v(" "),_c('div',{on:{"click":_vm.dayConfirmStartPicker}},[_vm._v("确认")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.dayEndTimePicker),expression:"this.dayEndTimePicker"}],staticClass:"month_time_picker"},[_c('van-datetime-picker',{attrs:{"currentDate":this.dayCurrentEndTime || '',"type":"date","title":"选择年月日","min-date":_vm.minDate,"max-date":_vm.maxDate,"show-toolbar":false,"formatter":_vm.formatter4,"visible-item-count":"3","swipe-duration":"150"}}),_vm._v(" "),_c('div',{staticClass:"month_time_picker_btn"},[_c('div',{on:{"click":_vm.dayCancelEndPicker}},[_vm._v("取消")]),_vm._v(" "),_c('div',{on:{"click":_vm.dayConfirmEndPicker}},[_vm._v("确认")])])],1)]),_vm._v(" "),_c('van-dropdown-item',{ref:"item3",attrs:{"title-class":this.activeServe ? 'title_active_color active_blue' : '',"title":"服务查询"}},[_c('div',{staticClass:"service_list"},[_c('div',{class:this.tagFlagAll ? 'service_tag service_tag_blue' : 'service_tag',on:{"click":_vm.clickServiceAll}},[_vm._v("全部服务")]),_vm._v(" "),_vm._l((_vm.SndServiceData),function(item,index){return _c('div',{key:index,ref:"serviceTagList",refInFor:true,class:_vm.serviceFlag(index) ? 'service_tag service_tag_blue' : 'service_tag',attrs:{"secondClassId":item.id},on:{"click":function($event){return _vm.clickService(index)}}},[_vm._v("\n                        "+_vm._s(item.text)+"\n                    ")])})],2),_vm._v(" "),_c('div',{staticClass:"month_time_picker_btn"},[_c('div',{on:{"click":_vm.cancelSndService}},[_vm._v("清空")]),_vm._v(" "),_c('div',{on:{"click":_vm.confirmSndService}},[_vm._v("确认")])])])],1),_vm._v(" "),_c('van-cell-group',[_c('div',{staticClass:"order_total"},[(this.selectStartTime === null && this.selectEndTime === null)?_c('span',[_vm._v("订单合计")]):(this.selectStartTime !== null && this.selectEndTime !== null)?_c('span',[_vm._v(_vm._s(this.selectStartTime)+" 至 "+_vm._s(this.selectEndTime))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.AllOrderListPage.total)+"笔  | ￥"+_vm._s(this.AllOrderData.allPrice))])]),_vm._v(" "),_c('van-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.AllOrderListPageRecords),function(item,index){return _c('div',{key:index,attrs:{"collapse_list":"","flag":"true"},on:{"click":function($event){return _vm.getOrderDetailList($event, index)}}},[_c('van-collapse-item',{attrs:{"name":index,"value":((item.total) + "笔 | " + (item.price) + "￥"),"value-class":"order_pic","title-class":"order_time"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',[_vm._v(_vm._s(item.billDate)+"\n                                            "),_c('span')])]},proxy:true}],null,true)},[_vm._v(" "),_vm._l((_vm.orderDetailList),function(li,index){return _c('div',{key:index,staticClass:"order_detail bottom-line",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(_vm.tabList[0],index)}}},[_c('div',[_c('span',[_vm._v(_vm._s(li.secondClassName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(li.createdTime)+"\n                                        "),_vm._v(" "),(li.chargeStatus===1 && li.settlementStatus===1)?_c('van-tag',{attrs:{"type":"primary"}},[_vm._v("未出账")]):_vm._e(),_vm._v(" "),(li.chargeStatus===2 && li.settlementStatus===1)?_c('van-tag',{attrs:{"type":"primary"}},[_vm._v("待结款")]):(li.chargeStatus===2 && (li.settlementStatus===2 || li.paymentStatus===3 || li.paymentStatus===4 || li.paymentStatus===6))?_c('van-tag',{attrs:{"type":"primary"}},[_vm._v("待结款")]):(li.chargeStatus===2 && (li.paymentStatus===4 || li.paymentStatus===6))?_c('van-tag',{attrs:{"type":"primary"}},[_vm._v("待结款")]):_vm._e(),_vm._v(" "),(li.chargeStatus===2 && li.paymentStatus===5)?_c('van-tag',{attrs:{"type":"success"}},[_vm._v("已结款")]):_vm._e(),_vm._v(" "),(li.chargeStatus===3 && (li.settlementStatus===2 || li.settlementStatus===3 || li.paymentStatus===4 || li.paymentStatus===6))?_c('van-tag',{attrs:{"type":"danger"}},[_vm._v("已稽核")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"no_settlement"},[_vm._v(_vm._s(li.orderPrice)+"￥"),_c('van-icon',{attrs:{"name":"arrow"}})],1)])})],2)],1)}),0)],1),_vm._v(" "),(_vm.AllOrderListPageRecords&&_vm.AllOrderListPageRecords.length === 0 )?_c('van-empty',{attrs:{"image":"search","description":"查询订单无结果"}}):_vm._e(),_vm._v(" "),(this.AllOrderListPage.total > 6 )?_c('van-pagination',{staticClass:"today_pagination",attrs:{"total-items":this.AllOrderListPage.total,"items-per-page":"6","force-ellipses":"","show-page-size":"3"},on:{"change":function($event){return _vm.changePage($event)}},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1):( this.userRole === '员工' || this.userRole === '' )?_c('van-empty',{attrs:{"image":"error","description":"权限不足或网络错误"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1792669296695.js